/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date; output: Date; }
  /** The `Decimal` scalar type represents signed unlimited-precision fractional values. */
  Decimal: { input: string; output: string; }
  /** The `Int64` scalar type represents non-fractional signed whole numeric values. Int can represent values between -2^63 and 2^63 - 1. */
  Int64: { input: number; output: number; }
  /** The `JSON` scalar type represents arbitrary JSON values. */
  JSON: { input: string; output: string; }
  /** A timezone-less calendar date in YYYY-MM-DD form (e.g. a date of birth). */
  LocalDate: { input: string; output: string; }
};

export type AcceptBillPayInput = {
  alternativePaymentOptions: Array<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  minimumDiscountPercent: Scalars['Int']['input'];
  savingsPreference: Scalars['String']['input'];
  successFeePercent: Scalars['Int']['input'];
};

export type AcceptTaskDraftInput = {
  suggestionId: Scalars['ID']['input'];
  /** The task the advocate actually filed. */
  taskId: Scalars['ID']['input'];
  /** True when they filed it without changing a field. */
  unchanged: Scalars['Boolean']['input'];
};

export type AcceptTermsInput = {
  /**
   * Version identifier of the Terms/Privacy the user accepted (a FE constant).
   * Persisted for compliance; the server stamps the time.
   */
  termsVersion: Scalars['String']['input'];
};

export enum AccountDeletionError {
  ALREADY_REQUESTED = 'ALREADY_REQUESTED',
  MANAGED_MFA = 'MANAGED_MFA',
  USER_NOT_FOUND = 'USER_NOT_FOUND'
}

export type AccountDeletionFailure = {
  __typename: 'AccountDeletionFailure';
  error: AccountDeletionError;
};

export type AccountDeletionResponse = AccountDeletionFailure | AccountDeletionSuccess;

export type AccountDeletionSuccess = {
  __typename: 'AccountDeletionSuccess';
  userId: Scalars['String']['output'];
};

export type AcknowledgePaymentFeeInput = {
  eventId: Scalars['ID']['input'];
};

export type ActivePromoForIssue = {
  __typename: 'ActivePromoForIssue';
  code: Scalars['String']['output'];
  /**
   * Null when the Stripe lookup is unavailable — the discount shape is unknown,
   * never a waive. Charging re-verifies against Stripe.
   */
  stripeDiscountPreview?: Maybe<StripePromoDiscountPreview>;
};

export type AddUserQuitFeedbackInput = {
  executionId?: InputMaybe<Scalars['String']['input']>;
  feedback: Scalars['String']['input'];
};

export type AdditionalSection = {
  __typename: 'AdditionalSection';
  fields: Array<FieldAttributes>;
  name: Scalars['String']['output'];
};

export type AddressAutocompleteInput = {
  /** Country/region filter (e.g., country:us) */
  components?: InputMaybe<Scalars['String']['input']>;
  /** Search term (minimum 2 characters) */
  input: Scalars['String']['input'];
  /** Language code (default: en) */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Optional lat/lng to bias results geographically */
  location?: InputMaybe<LocationInput>;
  /** Search radius in meters (default: 50000) */
  radius?: InputMaybe<Scalars['Int']['input']>;
  /** Optional UUID for billing optimization when paired with addressDetails */
  sessionToken?: InputMaybe<Scalars['String']['input']>;
  /** Result types (default: address) */
  types?: InputMaybe<Scalars['String']['input']>;
};

export type AddressAutocompleteResponse = {
  __typename: 'AddressAutocompleteResponse';
  /** Number of predictions returned (0-5) */
  count: Scalars['Int']['output'];
  /** Maximum 5 results (Google's limit) */
  predictions: Array<AddressPrediction>;
};

export type AddressDetails = {
  __typename: 'AddressDetails';
  city?: Maybe<Scalars['String']['output']>;
  /** Country code */
  country?: Maybe<Scalars['String']['output']>;
  /** County / parish / borough (Google administrative_area_level_2) */
  county?: Maybe<Scalars['String']['output']>;
  /** Full formatted address */
  formattedAddress: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  placeId: Scalars['String']['output'];
  /** State/province code */
  state?: Maybe<Scalars['String']['output']>;
  /** Street address (number and name) */
  street?: Maybe<Scalars['String']['output']>;
  /** Postal/zip code */
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressDetailsInput = {
  /** Specific fields to retrieve (affects pricing) */
  fields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Language code (default: en) */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Place ID from autocomplete results */
  placeId: Scalars['String']['input'];
  /** Optional UUID matching the one used in autocomplete */
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};

export type AddressPrediction = {
  __typename: 'AddressPrediction';
  /** Full address description */
  description: Scalars['String']['output'];
  /** Primary text (usually street address) */
  mainText: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  /** Secondary text (usually city, state, country) */
  secondaryText: Scalars['String']['output'];
  /** Place types from Google Places API */
  types: Array<Scalars['String']['output']>;
};

export type AnswerStaffTailgateInput = {
  answer: StaffTailgateAnswer;
  askId: Scalars['String']['input'];
  executionId: Scalars['String']['input'];
};

export type ApplyEpicEndpointChangesInput = {
  epicJsonData: Scalars['String']['input'];
};

export type ApplyEpicEndpointChangesResponse = {
  __typename: 'ApplyEpicEndpointChangesResponse';
  success: Scalars['Boolean']['output'];
};

export type ApplyPromoCodeUsageInput = {
  code: Scalars['String']['input'];
  issueId: Scalars['ID']['input'];
};

export type ApplyPromoCodeUsageResponse = ApplyPromoCodeUsageSuccess | FormError;

export type ApplyPromoCodeUsageSuccess = {
  __typename: 'ApplyPromoCodeUsageSuccess';
  promoCodeUsage: PromoCodeUsageInfo;
  /**
   * Stripe PromotionCode discount preview for intake UI. Null only when the
   * Stripe lookup is unavailable (a code Stripe affirmatively doesn't match is
   * rejected as invalid — every promo code is Stripe-backed).
   */
  stripeDiscountPreview?: Maybe<StripePromoDiscountPreview>;
};

export type ApproveSuggestedActionInput = {
  actionId: Scalars['ID']['input'];
};

export type ApproveSuggestedActionResult = {
  __typename: 'ApproveSuggestedActionResult';
  actionId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type ArchiveConsentReleaseInput = {
  templateReleaseId: Scalars['String']['input'];
};

export type ArchiveConsentReleaseResult = ArchiveConsentReleaseSuccess | FormError;

export type ArchiveConsentReleaseSuccess = {
  __typename: 'ArchiveConsentReleaseSuccess';
  templateReleaseId: Scalars['String']['output'];
};

export type ArchiveTemplateError = {
  __typename: 'ArchiveTemplateError';
  errors: Array<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
};

export type ArchiveTemplateInput = {
  templateId: Scalars['String']['input'];
};

export type ArchiveTemplateResult = ArchiveTemplateError | ArchiveTemplateSuccess;

export type ArchiveTemplateSuccess = {
  __typename: 'ArchiveTemplateSuccess';
  templateId: Scalars['String']['output'];
};

export type AssignPersonToPersonalInput = {
  personId: Scalars['ID']['input'];
  personalId: Scalars['ID']['input'];
};

export type AssignUserSegmentInput = {
  assignments: Array<UserSegmentAssignment>;
};

export type AssignUserSegmentResult = {
  __typename: 'AssignUserSegmentResult';
  assignedCount: Scalars['Int']['output'];
};

export type AttemptStatus = {
  __typename: 'AttemptStatus';
  dataTypes: DataTypesStatus;
  executionId: Scalars['ID']['output'];
};

export type AuthUser = {
  __typename: 'AuthUser';
  adminUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isShadow: Scalars['Boolean']['output'];
};

export type AuthUserResult = AuthUser | FormError;

export type AuthenticateError = {
  __typename: 'AuthenticateError';
  errorType: AuthenticateResultErrorType;
  success: Scalars['Boolean']['output'];
};

export type AuthenticateInput = {
  /**
   * Anonymous session ID (JWT) from a prior pre-auth session.
   * When provided, the anonymous user record is converted to a full user on login.
   */
  anonymousSessionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Ad attribution captured in this browser, as a JSON-encoded object of the
   * keys `attributionSchema` in `@medbillai/schemas` allows. Kept on a first
   * authentication; the newer capture wins over attribution a send left pending.
   */
  attribution?: InputMaybe<Scalars['JSON']['input']>;
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  /** The email address the OTP was sent to. Required when method is EMAIL_OTP. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Method of authentication (e.g., magic link, oauth, email OTP). */
  method: AuthenticateMethod;
  /** Natera intake answers carried by an OAuth login. Ignored for other methods. */
  nateraIntake?: InputMaybe<NateraIntakePacketInput>;
  /** Source of the registration (e.g., ios, android, web). */
  sourcePlatform?: InputMaybe<Scalars['String']['input']>;
  /**
   * The credential for the chosen method: magic-link token, OAuth session JWT,
   * or the 6-digit email OTP code.
   */
  token: Scalars['String']['input'];
  /** User segmentation data for the onboarding flow. */
  userSegmentationData?: InputMaybe<UserSegmentationData>;
};

export type AuthenticateMagicLinkInput = {
  codeVerifier?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type AuthenticateMagicLinkResult = {
  __typename: 'AuthenticateMagicLinkResult';
  errorType?: Maybe<AuthenticateMagicLinkResultErrorType>;
  firstAuthentication?: Maybe<Scalars['Boolean']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<AuthUser>;
};

export enum AuthenticateMagicLinkResultErrorType {
  INVALID_PKCE_CODE_CHALLENGE = 'INVALID_PKCE_CODE_CHALLENGE',
  UNABLE_TO_AUTH_MAGIC_LINK = 'UNABLE_TO_AUTH_MAGIC_LINK',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export enum AuthenticateMethod {
  EMAIL_OTP = 'EMAIL_OTP',
  MAGIC_LINK = 'MAGIC_LINK',
  OAUTH = 'OAUTH'
}

export type AuthenticateResult = AuthenticateError | AuthenticateSuccess;

export enum AuthenticateResultErrorType {
  INVALID_AUTH_OAUTH = 'INVALID_AUTH_OAUTH',
  INVALID_EMAIL_OTP = 'INVALID_EMAIL_OTP',
  INVALID_PKCE_CODE_CHALLENGE = 'INVALID_PKCE_CODE_CHALLENGE',
  UNABLE_TO_AUTH_MAGIC_LINK = 'UNABLE_TO_AUTH_MAGIC_LINK',
  UNABLE_TO_AUTH_OAUTH = 'UNABLE_TO_AUTH_OAUTH',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR'
}

export type AuthenticateSuccess = {
  __typename: 'AuthenticateSuccess';
  email?: Maybe<Scalars['String']['output']>;
  firstAuthentication: Scalars['Boolean']['output'];
  /**
   * Whether a funnel-created case is still unescalated. The auth callback diverts
   * to the activation route on it, which resumes that case rather than opening a
   * second one.
   */
  hasNateraCaseAwaitingActivation: Scalars['Boolean']['output'];
  /**
   * Whether natera-intake answers are stored server-side awaiting a case. The auth
   * callback routes on this, so a member who opens their magic link in a different
   * browser than the one they answered in still lands on their activation route
   * rather than in regular onboarding.
   */
  hasPendingNateraIntake: Scalars['Boolean']['output'];
  /**
   * The partner bound by an invite that was pending against this address, in the
   * same shape authenticateWithInvite returns — the client routes partner users
   * off it. Null whenever nothing was pending, the invite did not redeem, or the
   * caller passed its own token and used authenticateWithInvite instead.
   */
  partner?: Maybe<InviteTokenPartner>;
  success: Scalars['Boolean']['output'];
  user: AuthUser;
};

export type AuthenticateWithInviteResult = AuthenticateError | AuthenticateWithInviteSuccess;

export type AuthenticateWithInviteSuccess = {
  __typename: 'AuthenticateWithInviteSuccess';
  email?: Maybe<Scalars['String']['output']>;
  firstAuthentication: Scalars['Boolean']['output'];
  /**
   * As on AuthenticateSuccess. Carried here too because this mutation also
   * succeeds for returning accounts, which can still be owed the hub.
   */
  hasNateraCaseAwaitingActivation: Scalars['Boolean']['output'];
  /**
   * The partner the invite bound this user to — the client renders branding and
   * routes into onboarding from it. Always present: if the invite cannot be
   * redeemed or resolved, the mutation returns AuthenticateError instead.
   */
  partner: InviteTokenPartner;
  success: Scalars['Boolean']['output'];
  user: AuthUser;
};

/** An invite that has not been redeemed yet — partner only. */
export type AvailableInviteToken = {
  __typename: 'AvailableInviteToken';
  partner: InviteTokenPartner;
};

/** Root object type. */
export type BaseObject = {
  id: Scalars['ID']['output'];
};

export type BaseUpdatesPrompt = {
  count: Scalars['Int']['output'];
  type: UpdatesPromptType;
};

export type BasicSuccessResponse = {
  __typename: 'BasicSuccessResponse';
  success: Scalars['Boolean']['output'];
};

export type BatchGenerateBenefitsSummaryInput = {
  entities: Array<BenefitsSummaryEntity>;
};

/**
 * A person sourced from a partner, before they become a Granted user. PHI —
 * held in the isolated restricted Gel instance, never the shared store.
 */
export type Beneficiary = {
  __typename: 'Beneficiary';
  createdAt: Scalars['DateTime']['output'];
  /** The delivery the beneficiary was ingested from. Every beneficiary maps to one. */
  deliveryId: Scalars['ID']['output'];
  /** The beneficiary id (the event-sourced aggregate id). */
  id: Scalars['ID']['output'];
  /**
   * The verbatim 834 member segments as a JSON array of { tag, elements } objects.
   * Omitted (null) on the list query to bound the response; populated when a single
   * beneficiary is fetched.
   */
  memberSegments?: Maybe<Scalars['JSON']['output']>;
  /** Slug of the source the beneficiary came through. Set once at add time. */
  sourceSlug: Scalars['String']['output'];
  /**
   * Lifecycle stage, derived in Gel (read-only). Reflects the beneficiary's
   * termination and onboarding state.
   */
  stage: BeneficiaryStage;
  /**
   * When an 834 terminated the beneficiary's coverage (INS03=024). Null unless
   * terminated.
   */
  terminatedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The 834 transaction set (ST/SE) the beneficiary was enrolled in. Set once at
   * add time; carries the sponsor/payer lineage. Null on legacy rows predating the
   * transaction-set grain.
   */
  transactionSetId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** The onboarding user, set once the beneficiary is onboarded. Null before then. */
  userId?: Maybe<Scalars['ID']['output']>;
};

/**
 * A delivery: one raw 834 file landing. Retained as the replay source and the
 * lineage a beneficiary traces back to. PHI-adjacent — held in the isolated
 * restricted Gel instance.
 */
export type BeneficiaryDelivery = {
  __typename: 'BeneficiaryDelivery';
  /**
   * When an operator released the delivery to ingestion. Null while the delivery
   * awaits approval, and for deliveries recorded before the approval gate.
   */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * True while the delivery is staged and not yet approved — nothing about its
   * members has been ingested.
   */
  awaitingApproval: Scalars['Boolean']['output'];
  /** File content hash; the (source, fileHash) idempotency key for re-ingest. */
  checksum: Scalars['String']['output'];
  /** The delivery id (the DeliveryReceived event id; Beneficiary.deliveryId). */
  id: Scalars['ID']['output'];
  receivedAt: Scalars['DateTime']['output'];
  /** Number of member rows parsed from the file. */
  rowCount: Scalars['Int']['output'];
  /** S3 key of the raw 834 file retained as the replay source. */
  s3Key: Scalars['String']['output'];
  /**
   * S3 object version the delivery was staged from; approval ingests exactly this
   * version. Null for deliveries recorded before the approval gate.
   */
  s3VersionId?: Maybe<Scalars['String']['output']>;
  /** Slug of the source the delivery came through. */
  sourceSlug: Scalars['String']['output'];
  /**
   * When the file landed and was staged for review. Null for deliveries recorded
   * before the approval gate, which were ingested on receipt.
   */
  stagedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Non-PHI ingest summary recorded at delivery time: member and maintenance
   * counts, per-set sponsor/payer facts, aggregated validation issues, and
   * skipped-member records. Null for deliveries ingested before summaries were
   * recorded.
   */
  summary?: Maybe<Scalars['JSON']['output']>;
};

/**
 * Lifecycle stage of a beneficiary, derived in Gel: TERMINATED once coverage
 * ends, ONBOARDED once a user is bound, otherwise RECEIVED.
 */
export enum BeneficiaryStage {
  ONBOARDED = 'ONBOARDED',
  RECEIVED = 'RECEIVED',
  TERMINATED = 'TERMINATED'
}

/**
 * An 834 transaction set (ST/SE): one header within a delivery, carrying the
 * sponsor (1000A) and payer (1000B). A single file may carry several. PHI-adjacent
 * — held in the isolated restricted Gel instance.
 */
export type BeneficiaryTransactionSet = {
  __typename: 'BeneficiaryTransactionSet';
  /** The delivery (file) the transaction set arrived in. */
  deliveryId: Scalars['ID']['output'];
  /** The verbatim 834 header segments as a JSON array of { tag, elements } objects. */
  headerSegments: Scalars['JSON']['output'];
  /**
   * The transaction-set id (the TransactionSetReceived event id;
   * Beneficiary.transactionSetId).
   */
  id: Scalars['ID']['output'];
  /**
   * Payer (carrier) name, read from the verbatim 1000B header. Null when the header
   * omits it.
   */
  payerName?: Maybe<Scalars['String']['output']>;
  receivedAt: Scalars['DateTime']['output'];
  /** Slug of the source the transaction set came through. */
  sourceSlug: Scalars['String']['output'];
  /**
   * Sponsor organization (employer/school district) name, read from the verbatim
   * 1000A header. Null when the header omits it.
   */
  sponsorName?: Maybe<Scalars['String']['output']>;
};

export type BenefitSummaryCreated = {
  __typename: 'BenefitSummaryCreated';
  caseId: Scalars['String']['output'];
  executionId: Scalars['ID']['output'];
  status: DataTypeStatus;
};

export type BenefitsSummaryEntity = {
  documentId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type BillingSubscription = {
  __typename: 'BillingSubscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  currentPeriodStart?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: SubscriptionStatusGql;
  stripePriceId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type BillsToReviewUpdatesPrompt = BaseUpdatesPrompt & {
  __typename: 'BillsToReviewUpdatesPrompt';
  count: Scalars['Int']['output'];
  type: UpdatesPromptType;
};

export type BrowserbaseBrowserSettings = {
  advancedStealth?: InputMaybe<Scalars['Boolean']['input']>;
  blockAds?: InputMaybe<Scalars['Boolean']['input']>;
  fingerprint?: InputMaybe<BrowserbaseFingerprint>;
  os?: InputMaybe<Scalars['String']['input']>;
  viewport?: InputMaybe<BrowserbaseViewport>;
};

export type BrowserbaseConfig = {
  sessionOverrides?: InputMaybe<BrowserbaseSessionOverrides>;
};

export type BrowserbaseFingerprint = {
  browsers?: InputMaybe<Array<Scalars['String']['input']>>;
  devices?: InputMaybe<Array<Scalars['String']['input']>>;
  locales?: InputMaybe<Array<Scalars['String']['input']>>;
  operatingSystems?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BrowserbaseProxyConfig = {
  geolocation?: InputMaybe<BrowserbaseProxyGeolocation>;
  type: Scalars['String']['input'];
};

export type BrowserbaseProxyGeolocation = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};

export type BrowserbaseSessionOverrides = {
  browserSettings?: InputMaybe<BrowserbaseBrowserSettings>;
  proxies?: InputMaybe<Array<BrowserbaseProxyConfig>>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type BrowserbaseViewport = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type BulkUpdateEndpointSupportLevelsInput = {
  endpointIds: Array<Scalars['ID']['input']>;
  supportLevel: webAgent__EndpointSupportLevel;
};

export type CalibrateProviderFormInput = {
  /**
   * Doc kinds the operator explicitly confirmed removing, when this template
   * drops requiredDocs entries the stored calibration carries. Every removed
   * kind must appear here or the write is rejected: the server-side twin of
   * the preflight's removal acknowledgment, so a caller that skipped the
   * preflight can't silently strip the wizard's upload slots.
   */
  acknowledgedRemovedDocTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The form's revision as the caller read it at load. When present it joins
   * the update filter, so the optimistic-concurrency check and the write are
   * atomic: a write whose baseline moved (another approval, a PDF re-upload)
   * misses cleanly instead of reacquiring the newer template as its CAS
   * baseline and overwriting it. Absent = legacy behavior (content guards
   * only).
   */
  acquiredRevision?: InputMaybe<Scalars['Int']['input']>;
  /**
   * sha256 of the PDF bytes the operator calibrated against, as stored in
   * ProviderForm.contentHash. The write is rejected on mismatch: a calibration
   * is only valid against the exact bytes it was made from.
   */
  contentHash: Scalars['String']['input'];
  formType: provider__FormType;
  /**
   * The reviewed calibration template, JSON-encoded (the Gel JSON scalar
   * convention). Stamps calibratedAt and calibratedBy; revision is untouched,
   * since it tracks PDF byte revisions, not calibration passes.
   */
  internalTemplate: Scalars['JSON']['input'];
  providerId: Scalars['ID']['input'];
};

export type CalibrationDeltaAck = {
  __typename: 'CalibrationDeltaAck';
  accepted: Scalars['Int']['output'];
};

export type CalibrationDeltaInput = {
  action: Scalars['String']['input'];
  auditFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  clusterChange?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fieldTypeOverride?: InputMaybe<Scalars['String']['input']>;
  finalKey?: InputMaybe<Scalars['String']['input']>;
  formId: Scalars['String']['input'];
  originalFieldType?: InputMaybe<Scalars['String']['input']>;
  originalKey?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
  recalibration?: InputMaybe<Scalars['Boolean']['input']>;
  submissionId?: InputMaybe<Scalars['String']['input']>;
};

export type CalibrationPreview = {
  __typename: 'CalibrationPreview';
  formSpec: Scalars['String']['output'];
  report: Scalars['String']['output'];
};

export type CalibrationPreviewInput = {
  internalTemplate: Scalars['String']['input'];
};

export type CalibrationPreviewResult = CalibrationPreview | FormError;

export type CancelEligibilityEnrollmentInput = {
  /**
   * Free-form admin annotation captured on the
   * `EligibilityEnrollmentEnded` event for audit. Optional.
   */
  reason?: InputMaybe<Scalars['String']['input']>;
  /** User to remove from the eligibility program. */
  userId: Scalars['ID']['input'];
};

export type CancelEligibilityEnrollmentResult = {
  __typename: 'CancelEligibilityEnrollmentResult';
  /**
   * True when the dispatch succeeded. The aggregate's decide is
   * idempotent, so this is true regardless of whether the user was
   * enrolled or already-not-enrolled at dispatch time. Failures
   * surface as GraphQL errors rather than `ok: false`.
   */
  ok: Scalars['Boolean']['output'];
  /** User the cancellation was dispatched against. */
  userId: Scalars['ID']['output'];
};

export type CancelSubscriptionInput = {
  atPeriodEnd?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancelSubscriptionResponse = {
  __typename: 'CancelSubscriptionResponse';
  subscription: BillingSubscription;
};

export type CancelTailgateInput = {
  sessionId: Scalars['String']['input'];
};

/**
 * setupIntentId is required to place the hold. It is omitted only when finishing
 * a request that already succeeded but whose card save or task completion failed.
 */
export type CaptureCardCollectionInput = {
  eventId: Scalars['ID']['input'];
  setupIntentId?: InputMaybe<Scalars['String']['input']>;
};

export type CardDetails = {
  __typename: 'CardDetails';
  brand: Scalars['String']['output'];
  last4: Scalars['String']['output'];
  walletType?: Maybe<Scalars['String']['output']>;
};

export type CaseAdvisorChatInput = {
  caseId: Scalars['ID']['input'];
  messages: Array<CaseAdvisorMessageInput>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type CaseAdvisorChatResult = {
  __typename: 'CaseAdvisorChatResult';
  content: Scalars['String']['output'];
  inputTokens: Scalars['Int']['output'];
  outputTokens: Scalars['Int']['output'];
  toolCalls: Array<CaseAdvisorToolCall>;
};

export type CaseAdvisorMessageInput = {
  content: Scalars['String']['input'];
  role: CaseAdvisorMessageRole;
};

export enum CaseAdvisorMessageRole {
  assistant = 'assistant',
  user = 'user'
}

export type CaseAdvisorToolCall = {
  __typename: 'CaseAdvisorToolCall';
  label: Scalars['String']['output'];
  toolName: Scalars['String']['output'];
  uri: Scalars['String']['output'];
};

export type CaseCardOnFile = {
  __typename: 'CaseCardOnFile';
  brand?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
  ready: Scalars['Boolean']['output'];
};

export type CaseConversationVerdict = {
  __typename: 'CaseConversationVerdict';
  kind: CaseConversationVerdictKind;
  /**
   * The review task the suggestion was bound to server-side. The task panel binds
   * the band on exactly this, never on a guessed "first open task" — otherwise a
   * suggestion whose task closed unresolved migrates onto an unrelated later one.
   */
  reviewTaskId?: Maybe<Scalars['ID']['output']>;
  /** The pending SuggestedAction backing this verdict, for approve/reject. */
  suggestionId?: Maybe<Scalars['ID']['output']>;
  /** The suggested reply body. Only set for SUGGESTED_REPLY. */
  text?: Maybe<Scalars['String']['output']>;
  /** The member event the verdict was formed against. */
  triggerEventId?: Maybe<Scalars['ID']['output']>;
  /**
   * Set when a member message arrived after `triggerEventId`, i.e. the verdict was
   * formed against older state. Advisory only — the HA is looking at the
   * conversation and can still act. Blocking belongs to the unattended rung.
   */
  writtenBeforeEventId?: Maybe<Scalars['ID']['output']>;
};

/**
 * What the case currently thinks should happen with the conversation. Both HA
 * surfaces — the review-task band and the compose bar — read this one object, so
 * they cannot show conflicting advice about the same member message.
 */
export enum CaseConversationVerdictKind {
  /** No pending conversation suggestion. */
  NONE = 'NONE',
  /** The newest member message does not need a reply. */
  NO_REPLY_NEEDED = 'NO_REPLY_NEEDED',
  /** A reply is suggested; `text` carries the draft. */
  SUGGESTED_REPLY = 'SUGGESTED_REPLY'
}

/** Coverage is per kind, so a kind nobody has assessed cannot read as settled. */
export type CaseKindCoverage = {
  __typename: 'CaseKindCoverage';
  coverage: CaseRequirementCoverage;
  kind: CaseRequirementKind;
};

export type CaseRecommendation = {
  __typename: 'CaseRecommendation';
  evidence: Array<CaseRecommendationEvidence>;
  fallback?: Maybe<Scalars['String']['output']>;
  generatedAt?: Maybe<Scalars['DateTime']['output']>;
  providerSummary?: Maybe<Scalars['String']['output']>;
  stepGroups: Array<CaseRecommendationStepGroup>;
  /** One-sentence HA-facing summary of the case state + recommended path. */
  summary: Scalars['String']['output'];
  tactic: CaseRecommendationTactic;
};

export type CaseRecommendationEvidence = {
  __typename: 'CaseRecommendationEvidence';
  kind: CaseRecommendationEvidenceKind;
  signal: Scalars['String']['output'];
};

export enum CaseRecommendationEvidenceKind {
  CONFIRMED = 'CONFIRMED',
  GAP = 'GAP'
}

export type CaseRecommendationPhoneCallDetails = {
  __typename: 'CaseRecommendationPhoneCallDetails';
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CaseRecommendationSendFormDetails = {
  __typename: 'CaseRecommendationSendFormDetails';
  formSender: Scalars['String']['output'];
  formType: Scalars['String']['output'];
  recipient?: Maybe<Scalars['String']['output']>;
  sendingMethod: Scalars['String']['output'];
};

export type CaseRecommendationStep = {
  __typename: 'CaseRecommendationStep';
  dependsOn?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  phoneCall?: Maybe<CaseRecommendationPhoneCallDetails>;
  /** Surfaced in the HA panel for prioritization. */
  priority: CaseRecommendationStepPriority;
  sendForm?: Maybe<CaseRecommendationSendFormDetails>;
  taskType: CaseRecommendationStepTaskType;
  title: Scalars['String']['output'];
};

export type CaseRecommendationStepGroup = {
  __typename: 'CaseRecommendationStepGroup';
  category: Scalars['String']['output'];
  label: Scalars['String']['output'];
  steps: Array<CaseRecommendationStep>;
};

export enum CaseRecommendationStepPriority {
  LATER = 'LATER',
  NEXT = 'NEXT',
  NOW = 'NOW'
}

export enum CaseRecommendationStepTaskType {
  FOLLOW_UP_USER_UNRESPONSIVE = 'FOLLOW_UP_USER_UNRESPONSIVE',
  GENERAL = 'GENERAL',
  ISSUE_USER_MESSAGING = 'ISSUE_USER_MESSAGING',
  PHONE_CALL = 'PHONE_CALL',
  SEND_FORM = 'SEND_FORM'
}

export type CaseRecommendationTactic = {
  __typename: 'CaseRecommendationTactic';
  confidence: CaseRecommendationTacticConfidence;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reasoning: Scalars['String']['output'];
};

/**
 * Enums mirror the Zod source of truth in
 * `ts/apps/api/src/case-resolution/schemas.ts`. Keep these in lockstep —
 * adding a Zod enum value without adding it here means the resolver will
 * return a string the gateway rejects at response time.
 */
export enum CaseRecommendationTacticConfidence {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type CaseReplyDraftResult = {
  __typename: 'CaseReplyDraftResult';
  confidence?: Maybe<Scalars['Float']['output']>;
  draft: Scalars['String']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  rationale?: Maybe<Scalars['String']['output']>;
  sourcesUsed?: Maybe<Array<Scalars['String']['output']>>;
};

export enum CaseReplyMessageType {
  DRAFT = 'DRAFT',
  POLISH = 'POLISH',
  STATUS_UPDATE = 'STATUS_UPDATE'
}

/**
 * A requirement as a reader sees it. A union rather than one type with nullable
 * fields, so a consumer cannot treat an unplaced satisfaction as a satisfied
 * target by ignoring a null.
 */
export type CaseRequirement = OpenCaseRequirement | SatisfiedCaseRequirement | UnattestedCaseRequirement;

/**
 * Whether a kind has anything to say about this case. An ask is the only
 * evidence; its absence proves nothing either way, because no policy decides
 * whether a case needs one.
 */
export enum CaseRequirementCoverage {
  EVALUATED = 'EVALUATED',
  UNKNOWN = 'UNKNOWN'
}

/**
 * The requirement kinds published to case-state clients. Domain kinds join this
 * enum only after deployed readers tolerate them; adding an enum member reaches
 * every case through `coverage` immediately.
 */
export enum CaseRequirementKind {
  /**
   * We know the member's coverage: an insurance card has landed, or the member
   * has told us there is none to give.
   */
  COVERAGE_INFORMATION = 'COVERAGE_INFORMATION',
  HIPAA_AUTHORIZATION = 'HIPAA_AUTHORIZATION',
  PAYMENT_PREFERENCES = 'PAYMENT_PREFERENCES'
}

/**
 * The party a requirement names, and the second half of its identity: two
 * providers each needing an authorization are two requirements.
 */
export type CaseRequirementTarget = {
  __typename: 'CaseRequirementTarget';
  /**
   * Null when the ask named no organization. An unidentified counterparty is its
   * own target rather than one that joins a named organization's.
   */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /**
   * The organization's display name. Null when the ask named no organization, and
   * also when it named one that no longer resolves — a target type alone cannot
   * tell two counterparties apart, so a reader must show the difference.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  type: CaseRequirementTargetType;
};

/** The party a requirement is directed at. */
export enum CaseRequirementTargetType {
  GRANTED_HEALTH = 'GRANTED_HEALTH',
  INSURER = 'INSURER',
  PROVIDER = 'PROVIDER',
  /**
   * Absence keyed as itself: the ask carries no counterparty because the template
   * predates the categorization backfill. Not a fourth party — a reader must not
   * present it as one, and it must not read as satisfied by another target's
   * evidence.
   */
  UNSPECIFIED = 'UNSPECIFIED'
}

/** The party expected to move while a requirement is open. */
export enum CaseRequirementWaitingOn {
  COUNTERPARTY = 'COUNTERPARTY',
  GRANTED_HEALTH = 'GRANTED_HEALTH',
  USER = 'USER'
}

/**
 * A room's metadata. No case text: the advocate's messages and the agent's
 * answers live in S3 and reach the browser over the event stream, never here.
 */
export type CaseRoom = {
  __typename: 'CaseRoom';
  artifacts: Array<CaseRoomArtifact>;
  /** The cap the proxy refuses past. Null if unreadable. */
  budgetUsd?: Maybe<Scalars['Float']['output']>;
  /**
   * What each turn reported spending, summed. Undercounts on purpose-built
   * failure: a turn that failed reports zero, so this is NOT what the budget is
   * measured against. Read `spentUsd` for that.
   */
  costUsd: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  issueId: Scalars['ID']['output'];
  /** Every path in the bundle manifest. A citation not in this list is not a citation. */
  manifestPaths: Array<Scalars['String']['output']>;
  /** The model the room runs against, fixed when it opens. Null for a room opened before this was recorded. */
  model?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['DateTime']['output'];
  /**
   * This room's proposals that are no longer open, with what became of each. A
   * reload replays every proposal event; without this, one already dismissed or
   * turned into a task came back actionable.
   */
  settledProposals: Array<CaseRoomSettledProposal>;
  /** The moment the bundle was built. A live case moves while the room is open. */
  snapshotAt: Scalars['DateTime']['output'];
  /** What the model proxy has actually metered for this room. Null if unreadable. */
  spentUsd?: Maybe<Scalars['Float']['output']>;
  status: CaseRoomStatus;
  turns: Array<CaseRoomTurn>;
};

export type CaseRoomArtifact = {
  __typename: 'CaseRoomArtifact';
  bytes: Scalars['Int']['output'];
  path: Scalars['String']['output'];
};

/** The CaseRoomEvent contract, serialized. A string rather than a JSON scalar so the schema adds no scalar. */
export type CaseRoomEvent = {
  __typename: 'CaseRoomEvent';
  /** The event's kind, so a consumer can filter without parsing the payload. */
  kind: Scalars['String']['output'];
  /** JSON.stringify of the whole event, `kind` included. The decoder cross-checks the two. */
  payload: Scalars['String']['output'];
};

export enum CaseRoomPreset {
  CASE_BRIEF = 'CASE_BRIEF',
  CASE_OPTIONS = 'CASE_OPTIONS',
  CHECK_DOCUMENTS = 'CHECK_DOCUMENTS',
  COMPARE_PLANS = 'COMPARE_PLANS',
  DRAFT_STATUS_UPDATE = 'DRAFT_STATUS_UPDATE',
  LOOK_UP = 'LOOK_UP',
  PREPARE_PROVIDER_INTERACTION = 'PREPARE_PROVIDER_INTERACTION'
}

/** A Case Room proposal that is no longer open. */
export type CaseRoomSettledProposal = {
  __typename: 'CaseRoomSettledProposal';
  /** The suggestion's status: ACCEPTED, MODIFIED, REJECTED or SUPERSEDED. */
  status: Scalars['String']['output'];
  suggestionId: Scalars['ID']['output'];
};

export enum CaseRoomStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export type CaseRoomTurn = {
  __typename: 'CaseRoomTurn';
  costUsd?: Maybe<Scalars['Float']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  index: Scalars['Int']['output'];
  startedAt: Scalars['DateTime']['output'];
  /** A TurnStatus value from the locked contract. */
  status: Scalars['String']['output'];
};

/**
 * Requirements and the collapsed answer for one case, derived from the captured
 * lifecycle facts rather than stored.
 *
 * This covers the kinds listed in `coverage` and nothing else, so it is additive
 * detail beside the case's conversational status, not a replacement for it.
 */
export type CaseState = {
  __typename: 'CaseState';
  coverage: Array<CaseKindCoverage>;
  issueId: Scalars['ID']['output'];
  /** Ordered by requirement key, so the order is stable across reads. */
  requirements: Array<CaseRequirement>;
  summary: CaseStateSummary;
  /** Non-null exactly when `summary` is `WAITING`. */
  waitingOn?: Maybe<CaseRequirementWaitingOn>;
};

/**
 * The case-level answer, collapsed from the requirements by a stated rule: closed,
 * else the first party in `USER, COUNTERPARTY, GRANTED_HEALTH` with an open
 * requirement, else ready.
 *
 * The user comes first so a case that owes us work and the user work reports the
 * user, rather than reading as ours to move and suppressing the outreach the
 * user's own requirement is waiting for.
 */
export enum CaseStateSummary {
  /** Something is outstanding and it is ours to move. */
  ACTIVE = 'ACTIVE',
  /** An HA recorded the terminal resolution. */
  CLOSED = 'CLOSED',
  /**
   * Open, with nothing outstanding — so nothing says what to do next. Either no
   * kind applies, or the applicable ones are satisfied and nobody has closed the
   * case. Both want a human, which is why this is its own answer rather than a
   * quiet ACTIVE.
   */
  READY = 'READY',
  /** Something is outstanding and another party owes the next move. */
  WAITING = 'WAITING'
}

/**
 * The pending task draft for a case, or NONE. Asking for it is also what triggers
 * generation, so a surface that never reads this never pays for a draft.
 */
export type CaseTaskDraft = {
  __typename: 'CaseTaskDraft';
  draft?: Maybe<CaseTaskDraftFields>;
  kind: CaseTaskDraftKind;
  /** The pending SuggestedAction backing this draft, for accept/dismiss. */
  suggestionId?: Maybe<Scalars['ID']['output']>;
};

/**
 * The drafted task itself, field for field as the Create Task form takes them.
 * Priority and assignee are deliberately absent: proposing who does the work is a
 * different thing from proposing the work.
 */
export type CaseTaskDraftFields = {
  __typename: 'CaseTaskDraftFields';
  /** A calendar date, `YYYY-MM-DD`. */
  dueDate: Scalars['String']['output'];
  /** Set only when `taskType` is SEND_FORM. */
  formSender?: Maybe<Scalars['String']['output']>;
  /** Set only when `taskType` is SEND_FORM. */
  formType?: Maybe<Scalars['String']['output']>;
  notes: Scalars['String']['output'];
  /** One line naming the fact that made this task due. No reason, no offer. */
  reason: Scalars['String']['output'];
  /** Set only when `taskType` is SEND_FORM. */
  sendingMethod?: Maybe<Scalars['String']['output']>;
  taskType: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/**
 * Whether this case has a task draft to offer. One object, read by every surface,
 * so the v2 panel and the classic form cannot disagree about what is being
 * suggested.
 */
export enum CaseTaskDraftKind {
  /** No pending draft, or the mode is not live. */
  NONE = 'NONE',
  /** A draft is available; `draft` carries it. */
  SUGGESTED_TASK = 'SUGGESTED_TASK'
}

/**
 * Domain of a case. Mirrors the CaseTypeSchema zod enum (single source of truth);
 * a parity test keeps the two in lockstep.
 */
export enum CaseType {
  APP_ISSUE = 'APP_ISSUE',
  BENEFITS_QUESTION = 'BENEFITS_QUESTION',
  BILL_ISSUE = 'BILL_ISSUE',
  CARE_NAVIGATION = 'CARE_NAVIGATION',
  FIND_PROVIDER = 'FIND_PROVIDER',
  OPEN_ENROLLMENT = 'OPEN_ENROLLMENT',
  OTHER = 'OTHER',
  OUT_OF_BOUNDS = 'OUT_OF_BOUNDS',
  OUT_OF_NETWORK_CLAIM = 'OUT_OF_NETWORK_CLAIM',
  PRIOR_AUTHORIZATION_DENIAL = 'PRIOR_AUTHORIZATION_DENIAL'
}

export enum CaseWorklistAssignee {
  ANY = 'ANY',
  /** Cases assigned to the session user. */
  MINE = 'MINE',
  /** Cases with an open REVIEW_ISSUE_CHAT task. */
  NEEDS_REPLY = 'NEEDS_REPLY',
  UNASSIGNED = 'UNASSIGNED',
  /** Cases assigned to `assigneeId`. */
  USER = 'USER'
}

export type CaseWorklistAssigneeSla = {
  __typename: 'CaseWorklistAssigneeSla';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  /** Null for unassigned cases. */
  assigneeId?: Maybe<Scalars['ID']['output']>;
  noTask: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  unanswered: Scalars['Int']['output'];
};

/** The GrantCentral case worklist's filters, applied before a page is selected. */
export type CaseWorklistFilter = {
  assignee: CaseWorklistAssignee;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  caseManagementType?: InputMaybe<Scalars['String']['input']>;
  /** Drop cases whose owner is staff. GrantCentral sets it in prod only. */
  excludeInternalOwners: Scalars['Boolean']['input'];
  hideClosed: Scalars['Boolean']['input'];
  hideTestCases: Scalars['Boolean']['input'];
  highPriorityOnly: Scalars['Boolean']['input'];
  includeNonEscalated: Scalars['Boolean']['input'];
  /** Cases carrying any of these labels. Empty means no label filter. */
  labelsAny: Array<Scalars['String']['input']>;
  /** True shows only cases parked with marketing; false hides them. */
  marketingReengagement: Scalars['Boolean']['input'];
  nextSteps: CaseWorklistNextSteps;
  /** Cases whose owner has this active segment. */
  ownerSegmentKey?: InputMaybe<Scalars['String']['input']>;
  /** Matched case-insensitively against the row's searchable text. */
  search?: InputMaybe<Scalars['String']['input']>;
  sla?: InputMaybe<CaseWorklistSla>;
  slaBand?: InputMaybe<CaseWorklistSlaBand>;
  status?: InputMaybe<CaseWorklistStatus>;
};

export enum CaseWorklistNextSteps {
  ANY = 'ANY',
  HAS = 'HAS',
  NONE = 'NONE'
}

export type CaseWorklistPage = {
  __typename: 'CaseWorklistPage';
  hasMore: Scalars['Boolean']['output'];
  /** Pass as `after` for the next page. Null when there is none. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  rows: Array<CaseWorklistRow>;
  /** Cases matching this filter, for the pager's N of M. */
  totalCount: Scalars['Int']['output'];
};

export type CaseWorklistRow = {
  __typename: 'CaseWorklistRow';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  assigneeId?: Maybe<Scalars['ID']['output']>;
  autoPayAuthorized: Scalars['Boolean']['output'];
  caseManagementType?: Maybe<Scalars['String']['output']>;
  caseRef?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  /** The earliest due date among open tasks, undated ones last. */
  earliestOpenTaskDueDate?: Maybe<Scalars['String']['output']>;
  hasOpenReviewChatTask: Scalars['Boolean']['output'];
  hasOpenTask: Scalars['Boolean']['output'];
  hasStaffMessage: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isEscalated: Scalars['Boolean']['output'];
  labels: Array<Scalars['String']['output']>;
  lastEventParticipant?: Maybe<Scalars['String']['output']>;
  lastEventSentAt?: Maybe<Scalars['String']['output']>;
  lastMemberActivityAt?: Maybe<Scalars['String']['output']>;
  lastMemberMessageAwaitingReplyAt?: Maybe<Scalars['String']['output']>;
  lastStaffTouchAt?: Maybe<Scalars['String']['output']>;
  nextTaskDueDate?: Maybe<Scalars['String']['output']>;
  /** The most recent open task: the Next steps and Follow-up columns. */
  nextTaskTitle?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['String']['output']>;
  ownerEmail?: Maybe<Scalars['String']['output']>;
  ownerId?: Maybe<Scalars['ID']['output']>;
  ownerSegments: Array<CaseWorklistSegment>;
  priorityOverride?: Maybe<Scalars['String']['output']>;
  priorityOverrideSetAt?: Maybe<Scalars['String']['output']>;
  priorityOverrideSetByEmail?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalBillDollarAmount?: Maybe<Scalars['Float']['output']>;
};

export type CaseWorklistSegment = {
  __typename: 'CaseWorklistSegment';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
};

export enum CaseWorklistSla {
  NO_TASK = 'NO_TASK',
  OVERDUE = 'OVERDUE',
  UNANSWERED = 'UNANSWERED'
}

export enum CaseWorklistSlaBand {
  BREACHING = 'BREACHING',
  WITHIN = 'WITHIN'
}

export type CaseWorklistSort = {
  /** Breached cases first (unanswered, then overdue), then `key`. */
  breachFirst: Scalars['Boolean']['input'];
  direction: CaseWorklistSortDirection;
  key: CaseWorklistSortKey;
};

export enum CaseWorklistSortDirection {
  ASC = 'ASC',
  DESC = 'DESC'
}

export enum CaseWorklistSortKey {
  ASSIGNEE = 'ASSIGNEE',
  CASE_MANAGEMENT_TYPE = 'CASE_MANAGEMENT_TYPE',
  CASE_REF = 'CASE_REF',
  FOLLOW_UP = 'FOLLOW_UP',
  ID_SHORT = 'ID_SHORT',
  IS_ESCALATED = 'IS_ESCALATED',
  LABELS = 'LABELS',
  LAST_EVENT = 'LAST_EVENT',
  NEXT_STEPS = 'NEXT_STEPS',
  OPENED_AT = 'OPENED_AT',
  OWNER = 'OWNER',
  PRIORITY = 'PRIORITY',
  PROVIDER = 'PROVIDER',
  STATUS = 'STATUS',
  TITLE = 'TITLE',
  TOTAL_BILL_DOLLAR_AMOUNT = 'TOTAL_BILL_DOLLAR_AMOUNT',
  USER_LABELS = 'USER_LABELS'
}

export enum CaseWorklistStatus {
  DONE = 'DONE',
  FOLLOW_UP_NEEDED = 'FOLLOW_UP_NEEDED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  WAITING_ON_USER = 'WAITING_ON_USER'
}

export type CaseWorklistSummary = {
  __typename: 'CaseWorklistSummary';
  byAssignee: Array<CaseWorklistAssigneeSla>;
  /** Distinct case types in the queue: the filter's tab and toggles, no facets. */
  caseManagementTypes: Array<Scalars['String']['output']>;
  noTask: Scalars['Int']['output'];
  overdue: Scalars['Int']['output'];
  /** SLA signals over the queue's high-priority cases. */
  unanswered: Scalars['Int']['output'];
};

export type ChargeNegotiatedBillInput = {
  issueId: Scalars['ID']['input'];
  negotiatedBillAmount: Scalars['Decimal']['input'];
  /**
   * HA-asserted override: the user agreed (e.g. in chat) to exceed the ceilings
   * stored on their payment preferences, so skip the maxSettle/maxSingleCharge
   * checks for this charge. Set only after a NEEDS_APPROVAL rejection.
   */
  overrideMaxApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When true, charge only the success fee (skip the negotiated bill payment line item).
   * Use when the provider won't accept payment from us, or the user opted out of having
   * us pay the bill, but we still negotiated savings.
   */
  successFeeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChargeNegotiatedBillResponse = {
  __typename: 'ChargeNegotiatedBillResponse';
  billAmount: Scalars['Decimal']['output'];
  invoiceId?: Maybe<Scalars['String']['output']>;
  invoiceUrl?: Maybe<Scalars['String']['output']>;
  successFeeAmount: Scalars['Decimal']['output'];
  totalCharged: Scalars['Decimal']['output'];
};

export type ChargePaymentProfileInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  issueId?: InputMaybe<Scalars['ID']['input']>;
};

export type ChargePaymentProfileResponse = {
  __typename: 'ChargePaymentProfileResponse';
  paymentIntentId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChargeRetryReadyInput = {
  issueId: Scalars['ID']['input'];
};

export type CheckClientVersionInput = {
  /**
   * Expected to take the value of Platform.OS from React Native.
   * One of "web", "ios", "android".
   * Currently, we only expect "ios".
   */
  os: Scalars['String']['input'];
  /** EAS Update ID for the JS bundle, if applicable. */
  updateId?: InputMaybe<Scalars['String']['input']>;
  /** Native application version. */
  version: Scalars['String']['input'];
};

export type CheckClientVersionResponse = {
  __typename: 'CheckClientVersionResponse';
  /**
   * Indicates whether the application binary is supported by the API service.
   * If false, the user needs to update the application from the app store or similar.
   */
  isSupportedBinary: Scalars['Boolean']['output'];
  /**
   * Indicates whether the JS bundle is supported by the API service.
   * If false, the user needs to close and reopen the application.
   */
  isSupportedBundle: Scalars['Boolean']['output'];
};

export type CheckFaEligibilityInput = {
  householdSize: Scalars['Int']['input'];
  /**
   * Annual household income in whole USD. Provide exactly one non-null value:
   * income or incomeBand.
   */
  income?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Household income as a poverty-line band. Provide exactly one non-null value:
   * income or incomeBand.
   */
  incomeBand?: InputMaybe<FfgaIncomeBand>;
};

export type CheckPersonMatchInput = {
  dob: Scalars['String']['input'];
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClientSupportedVersionResponse = {
  __typename: 'ClientSupportedVersionResponse';
  /**
   * The most recent version of the application to ensure the EAS update block
   * only executes on the latest version of the application.
   */
  latestClientVersion: Scalars['String']['output'];
  /**
   * Current EAS Update ID for the JS bundle, if applicable. Will be empty if new
   * version was published and there is not a current update.
   */
  supportedClientUpdateId?: Maybe<Scalars['String']['output']>;
  /** Indicates the version of the client that is supported by the API service. */
  supportedClientVersion: Scalars['String']['output'];
};

export type CloseCaseInput = {
  issueId: Scalars['ID']['input'];
  reason: issue__UserClosureReason;
};

export type CloseIssueInput = {
  caseManagementClosureReason: Scalars['String']['input'];
  issueId: Scalars['ID']['input'];
};

export type CompleteNateraIntakeActivationInput = {
  issueId: Scalars['ID']['input'];
  /**
   * True only when the member presses Submit. Without it the call is a pure
   * state read — the hub refreshes after every sub-flow and upload, and a read
   * that escalated would end activation the moment the last item landed, while
   * the member still had more to add.
   */
  submit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeFaApplicationInput = {
  /** Extracted candidates; gated by confidence before they pre-fill. */
  extractions?: InputMaybe<Array<FaExtractionValueInput>>;
  formType?: InputMaybe<provider__FormType>;
  issueId: Scalars['ID']['input'];
  /** Pin the form to fill (paired with formType). */
  providerId?: InputMaybe<Scalars['ID']['input']>;
  /** Direct entries (highest trust); overwrite any lower-trust value on the draft. */
  structured?: InputMaybe<Array<FaStructuredValueInput>>;
};

/** Input type for generating a snapshot of a FHIR resource */
export type ComputeResourceSnapshotInput = {
  resourceId: Scalars['ID']['input'];
  resourceType: fhirext__ResourceType;
};

/**
 * Money fields are integer cents. maxSettle is the bill-only settlement ceiling
 * (excludes the success fee); maxSingleCharge is the fee-inclusive card
 * authorization. resolvedFeeCap / successFeePercent come from the event creation
 * snapshot — not user input.
 *
 * Two mutually exclusive modes: acceptAny true means no ceiling at all and both
 * maxes must be omitted; otherwise both are required and must be positive.
 * acceptAny is optional because bundles shipped before it exists send only the
 * maxes, which is the ceiling mode.
 */
export type ConfirmPaymentPreferencesInput = {
  acceptAny?: InputMaybe<Scalars['Boolean']['input']>;
  autoPayAuthorized: Scalars['Boolean']['input'];
  eventId: Scalars['ID']['input'];
  maxSettle?: InputMaybe<Scalars['Int']['input']>;
  maxSingleCharge?: InputMaybe<Scalars['Int']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  paymentPlanMaxMonthly?: InputMaybe<Scalars['Int']['input']>;
  paymentPlanRequested: Scalars['Boolean']['input'];
  providerRelationship?: InputMaybe<issue__ProviderRelationship>;
};

/**
 * The simplified general-payment agreement. providerRelationship is required for
 * a non-intake negotiation and forbidden for FA; note is forbidden for FA. An
 * intake-keyed request (the funnel's fee-ack) asks neither, so it must send no
 * relationship and no note. The server rejects a request whose stored contract is
 * FULL.
 */
export type ConfirmSimplifiedPaymentAgreementInput = {
  eventId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  providerRelationship?: InputMaybe<issue__ProviderRelationship>;
};

export enum ConversationEventType {
  DOCUMENT_STAGE = 'DOCUMENT_STAGE',
  ROW_PERSISTED = 'ROW_PERSISTED',
  STREAM_END = 'STREAM_END',
  TEXT_RECLASSIFIED = 'TEXT_RECLASSIFIED',
  TIMELINE_UPDATED = 'TIMELINE_UPDATED',
  TOKEN = 'TOKEN',
  TOOL_CALL_START = 'TOOL_CALL_START',
  TURN_COMPLETED = 'TURN_COMPLETED',
  TURN_FAILED = 'TURN_FAILED',
  TURN_STARTED = 'TURN_STARTED',
  WAIT_ENDED = 'WAIT_ENDED',
  WAIT_STARTED = 'WAIT_STARTED'
}

export type ConversationSubscriptionEvent = {
  __typename: 'ConversationSubscriptionEvent';
  at?: Maybe<Scalars['String']['output']>;
  /**
   * The pipeline attempt, on DOCUMENT_STAGE, WAIT_STARTED and WAIT_ENDED. A wait's
   * identity is its reason, document and attempt, so a close from a stale attempt
   * never ends a newer attempt's wait.
   */
  attemptId?: Maybe<Scalars['String']['output']>;
  attemptStartedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The streamed block an event belongs to, stable from the block's first event.
   * A reply block's TOKEN events share one key for the turn; a card's
   * TOOL_CALL_START carries the tool call id. ROW_PERSISTED repeats the key of
   * the block its row replaces, so a client can swap that block in place. A row
   * no block drew, such as a flow's first question, carries none.
   */
  blockId?: Maybe<Scalars['String']['output']>;
  /**
   * Set on ROW_PERSISTED with blockId. The row's position among the rows its
   * block saved, from 0, because one block can save several rows (a flow's intro
   * line, then its first question). The row at 0 takes the drawn block's place;
   * each later row goes directly after the one before it.
   */
  blockRow?: Maybe<Scalars['Int']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  /**
   * The document associated with a TIMELINE_UPDATED, DOCUMENT_STAGE, WAIT_STARTED
   * or WAIT_ENDED event.
   */
  documentId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  /**
   * Set on ROW_PERSISTED only. One `issue::Event` row the turn just wrote.
   * Arrives before TURN_COMPLETED, so a client can swap a streamed bubble or
   * card for its row without waiting for the turn to end. A client that
   * ignores it uses `eventIds` at the end instead.
   */
  eventId?: Maybe<Scalars['String']['output']>;
  /**
   * Set on TURN_COMPLETED and TURN_FAILED. The `issue::Event` rows the turn inserted
   * through the executor, in write order. This server always sends it, as an empty
   * list when the turn inserted none. Null means an older server. The list omits
   * rows the turn did not insert (an identical message it reused, a case reopen), so
   * an empty list does not prove the timeline is unchanged. A client that ignores it
   * refetches the transcript instead.
   *
   * Also set on TIMELINE_UPDATED: the rows the write outside a turn inserted or
   * changed, in write order, and an empty list when it named none.
   */
  eventIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Set on TEXT_RECLASSIFIED only. The TOKEN events with seq in [fromSeq, toSeq]
   * were the model's preamble to a tool call, not the reply. Show them as a
   * status label and remove them from the bubble. A client that ignores it shows
   * the preamble inline.
   */
  fromSeq?: Maybe<Scalars['Int']['output']>;
  /**
   * Set on ROW_PERSISTED. The saved row's Gel type, such as `issue::ChatEvent`
   * or `issue::UserSelectionRequestedEvent`, so a client can render it without a
   * fetch when it already holds the fields.
   */
  rowKind?: Maybe<Scalars['String']['output']>;
  /** Sender named on READ: the biller for a bill or the insurer for an EOB. */
  sender?: Maybe<Scalars['String']['output']>;
  /**
   * Per-turn ordinal, 0 at TURN_STARTED and increasing with each later event of
   * the same turn. A client that ignores it keeps Redis delivery order and cannot
   * tell a dropped event from a slow one.
   */
  seq?: Maybe<Scalars['Int']['output']>;
  /**
   * Set on DOCUMENT_STAGE only: where the document has reached, when it reached
   * it, and the cause for the stages that carry one.
   */
  stage?: Maybe<DocumentStage>;
  /** The inclusive upper bound of the range `fromSeq` describes. */
  toSeq?: Maybe<Scalars['Int']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  toolName?: Maybe<Scalars['String']['output']>;
  turnId: Scalars['String']['output'];
  type: ConversationEventType;
  /**
   * Set on WAIT_STARTED and WAIT_ENDED only, with `documentId` naming the document
   * when the wait has one. A client that ignores it shows no labelled wait.
   * A WAIT_ENDED only follows a WAIT_STARTED this server published for the same
   * reason, document and attempt. With the rollout flag off, neither is sent.
   */
  waitReason?: Maybe<WaitReason>;
  /**
   * Set on TURN_COMPLETED only. The turn ended with the intake flow holding for
   * the document pipeline rather than done: `document-read` or `extraction`. A
   * client that does not know the value ignores it.
   */
  waitingOn?: Maybe<Scalars['String']['output']>;
  /** The document `waitingOn` is waiting for, when the turn named one. */
  waitingOnDocumentId?: Maybe<Scalars['String']['output']>;
  /**
   * Set on TURN_COMPLETED only. The same hold as `waitingOn`, as an enum. A client
   * that ignores it can still read the string.
   */
  waitingOnKind?: Maybe<WaitReason>;
};

/** Input fields for editing a Coverage resource */
export type CoverageEditInput = {
  coverageType?: InputMaybe<fhir__CoverageType>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  insuranceName?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<fhirEdit__CoverageRelationship>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  terminationDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** How a closed `sign_in@1` workflow ended, from its status. */
export enum CrawlClosedAs {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  TERMINATED = 'TERMINATED',
  TIMED_OUT = 'TIMED_OUT'
}

/** What a saved document is, for the user, mapped from the crawler's data type. */
export enum CrawlDocumentCategory {
  CLAIM = 'CLAIM',
  EOB = 'EOB',
  MEMBER_CARD = 'MEMBER_CARD',
  MEMBER_INFO = 'MEMBER_INFO',
  PLAN_DOCUMENT = 'PLAN_DOCUMENT'
}

/** Documents of one category the product has stored, not yet processed. */
export type CrawlDocumentCount = {
  __typename: 'CrawlDocumentCount';
  category: CrawlDocumentCategory;
  firstSavedAt: Scalars['DateTime']['output'];
  lastSavedAt: Scalars['DateTime']['output'];
  saved: Scalars['Int']['output'];
};

/** A goal the robot crawl works. OTHER is a goal this API doesn't know yet. */
export enum CrawlGoal {
  CLAIMS = 'CLAIMS',
  COVERAGE = 'COVERAGE',
  EXPLANATION_OF_BENEFITS = 'EXPLANATION_OF_BENEFITS',
  MEMBER_INFO = 'MEMBER_INFO',
  OTHER = 'OTHER'
}

export type CrawlGoalProgress = {
  __typename: 'CrawlGoalProgress';
  goal: CrawlGoal;
  state: CrawlGoalState;
};

/** PENDING until the robot reports starting the goal, which it may never do. */
export enum CrawlGoalState {
  DONE = 'DONE',
  NOT_FOUND = 'NOT_FOUND',
  PENDING = 'PENDING',
  WORKING = 'WORKING'
}

/**
 * Where a `sign_in@1` attempt's robot crawl is. FINISHED covers a crawl that
 * completed, whether or not it kept any document.
 */
export enum CrawlPhase {
  FAILED = 'FAILED',
  FINISHED = 'FINISHED',
  RUNNING = 'RUNNING'
}

/**
 * Once the workflow has closed, `phase` and `startedAt` are null, `closedAs`
 * says how it ended, and `goals` and `documents` are empty.
 */
export type CrawlProgress = {
  __typename: 'CrawlProgress';
  closedAs?: Maybe<CrawlClosedAs>;
  documents: Array<CrawlDocumentCount>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  goals: Array<CrawlGoalProgress>;
  phase?: Maybe<CrawlPhase>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CreateApplePayIntentResponse = {
  __typename: 'CreateApplePayIntentResponse';
  clientSecret: Scalars['String']['output'];
};

export type CreateDataQualityFlagTaskInput = {
  description: Scalars['String']['input'];
  dueDate: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  resourceId: Scalars['ID']['input'];
  sourceName: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type CreateDocumentInput = {
  caseIntake?: InputMaybe<Scalars['Boolean']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Optional document type (e.g. bill, EOB, member ID) to skip ingestion classification. */
  dataType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional isInternal flag for uploading internal documents that are initially
   * hidden by the user.
   */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /**
   * Optional owner for the new document. If not specified, the owner is assumed to
   * be the user who uploaded the document. Only admin users may specify an owner
   * other than themselves. If the document is finalized with an issue, the issue's
   * owner will be overridden as the document's owner no matter what.
   */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to USER if not specified. */
  participant?: InputMaybe<Participant>;
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDocumentResult = {
  __typename: 'CreateDocumentResult';
  document: document__Document;
  s3Key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateFeedbackResult = {
  __typename: 'CreateFeedbackResult';
  success: Scalars['Boolean']['output'];
};

export type CreateFileInput = {
  contentType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  sizeBytes?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFileResult = {
  __typename: 'CreateFileResult';
  name: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CreateGeneralFeedbackInput = {
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  selectedOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateIssueChatEventInput = {
  actionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  chatBody: Scalars['String']['input'];
  issueId: Scalars['ID']['input'];
  /**
   * The SuggestedAction whose draft this reply came from, when a staff sender
   * accepted one. The server cannot infer it — an advocate who edits a draft
   * heavily and one who ignores it and types their own produce the same body — so
   * the composer volunteers the one fact only it knows. Omitting it on a staff
   * reply is meaningful, not neutral: it resolves the open verdict as rejected.
   * Ignored for member and automated sends.
   */
  usedSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  userVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateIssueCommentEventInput = {
  comment: Scalars['String']['input'];
  issueId: Scalars['ID']['input'];
};

export type CreateIssueConnectAccountRequestedEventInput = {
  buttonText?: InputMaybe<Scalars['String']['input']>;
  chatBody?: InputMaybe<Scalars['String']['input']>;
  endpointType: webAgent__EndpointType;
  issueId: Scalars['ID']['input'];
  showSkipButton?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateIssueFeedbackInput = {
  issueId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  selectedOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateIssueTaskInput = {
  additionalDetailsRequested?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate: Scalars['String']['input'];
  formSender?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  hasAllInformation?: InputMaybe<Scalars['Boolean']['input']>;
  issueId: Scalars['ID']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  /**
   * When source === CRI_RECOMMENDATION, the id of the recommendation step
   * the HA clicked Create Task on. Logged only — not persisted.
   */
  recommendationStepId?: InputMaybe<Scalars['String']['input']>;
  sendingMethod?: InputMaybe<Scalars['String']['input']>;
  /**
   * Where this task creation originated. Logged for analytics; not persisted
   * on the Task. When set to CRI_RECOMMENDATION, recommendationStepId should
   * also be provided so we can correlate per-step engagement.
   */
  source?: InputMaybe<TaskCreationSource>;
  taskType?: InputMaybe<taskManagement__TaskType>;
  title: Scalars['String']['input'];
};

export type CreateIssueTemplateReleaseRequestedEventInput = {
  issueId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};

export type CreateMultiFileDocumentInput = {
  /** Optional document type (e.g. bill, EOB, member ID) to skip ingestion classification. */
  dataType?: InputMaybe<Scalars['String']['input']>;
  files: Array<CreateFileInput>;
  /** Name of the entire document. */
  name: Scalars['String']['input'];
  /**
   * Optional owner for the new document. If not specified, the owner is assumed to
   * be the user who uploaded the document. Only admin users may specify an owner
   * other than themselves. If the document is finalized with an issue, the issue's
   * owner will be overridden as the document's owner no matter what.
   */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /** Defaults to USER if not specified. */
  participant?: InputMaybe<Participant>;
  uploadEntryPoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * Upload provenance, known at selection time: which method picked the files
   * (SCANNER, GALLERY, FILE, WEB_PREAUTH), which product surface the upload sheet
   * was opened from, and the device class. The server owns the allowlists, so an
   * unrecognised value from a stale or future client is dropped rather than
   * failing the upload.
   */
  uploadMethod?: InputMaybe<Scalars['String']['input']>;
  uploadPlatform?: InputMaybe<Scalars['String']['input']>;
  /**
   * Which product checklist requirement this upload satisfies (e.g. the Natera
   * intake hub's proof-of-income slot, or a post-escalation checklist row).
   * Orthogonal to `dataType` — the classifier still decides what the file is.
   */
  uploadPurpose?: InputMaybe<Scalars['String']['input']>;
  /**
   * The client upload-funnel session id, so the document row joins exactly to the
   * event stream that produced it. Dropped unless it is a well-formed UUID.
   */
  uploadSessionId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateMultiFileDocumentResult = {
  __typename: 'CreateMultiFileDocumentResult';
  document: document__Document;
  files: Array<CreateFileResult>;
};

export type CreateNateraIntakeCaseInput = {
  /**
   * Which route to open the case on, and the server's only way to tell a client
   * that understands chat mode from one that predates it. Absent means HUB *and*
   * an old client, which is answered a payment request whatever route the case is
   * on. The server may still answer HUB for a requested CHAT when the member is
   * not in the cohorts the chat flow needs.
   */
  mode?: InputMaybe<NateraIntakeMode>;
};

/** Input for creating a navigator specialist instruction */
export type CreateNavigatorSpecialistInstructionsInput = {
  /** The endpoint ID this instruction belongs to */
  endpointId: Scalars['ID']['input'];
  /** The instruction content */
  instructions: Scalars['String']['input'];
  /** Optional slug for the instruction. If not provided, will be auto-generated */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartnerGroupInput = {
  /**
   * The partner's own identifier for the group in their system. Optional when
   * the id is not known at registration time.
   */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Group name, unique within the partner. */
  name: Scalars['String']['input'];
};

export type CreatePartnerInput = {
  /**
   * Groups to create alongside the partner. Optional — groups can also be added
   * later.
   */
  groups?: InputMaybe<Array<CreatePartnerGroupInput>>;
  /** Partner display name. Unique across all partners. */
  name: Scalars['String']['input'];
  /**
   * Stable, human-readable handle. Unique, supplied explicitly (not derived from
   * the name). Lowercase kebab-case: a-z, 0-9, and hyphens.
   */
  slug: Scalars['String']['input'];
};

/**
 * requestKey is minted per send by the caller. Re-sending it returns the event
 * the first attempt created instead of opening a second live request, so a
 * transport-level replay of the same POST cannot duplicate the intake.
 */
export type CreatePaymentPreferencesRequestedEventInput = {
  caseType: issue__PaymentCaseType;
  issueId: Scalars['ID']['input'];
  requestKey?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentProfileResponse = {
  __typename: 'CreatePaymentProfileResponse';
  clientSecret: Scalars['String']['output'];
};

export type CreatePersonInput = {
  address?: InputMaybe<PersonAddress>;
  dob: Scalars['String']['input'];
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenNames?: InputMaybe<Array<Scalars['String']['input']>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePhoneCallInput = {
  aircallId: Scalars['String']['input'];
  aircallSessionId?: InputMaybe<Scalars['String']['input']>;
  callDate: Scalars['String']['input'];
  callType?: InputMaybe<Scalars['String']['input']>;
  duration: Scalars['Float']['input'];
  hasVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  isInbound?: InputMaybe<Scalars['Boolean']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
};

export type CreatePromoCodeInput = {
  code: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreatePromoCodeResponse = {
  __typename: 'CreatePromoCodeResponse';
  promoCode: payment__PromoCode_Type;
};

export type CreateProviderInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  contacts?: InputMaybe<Array<ProviderContactPointInput>>;
  county?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  faPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<provider__ProviderKind>;
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  npi?: InputMaybe<Scalars['String']['input']>;
  partOfId?: InputMaybe<Scalars['ID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Machine syncs only: stamps lastSyncedAt at creation so later sync updates
   * pass the machine-owned latch check. Leave unset for HA-created providers.
   */
  stampLastSynced?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  systemName?: InputMaybe<Scalars['String']['input']>;
};

/** Base input type for creating resource edits */
export type CreateResourceEditInput = {
  coverageEdit?: InputMaybe<CoverageEditInput>;
  explanationOfBenefitEdit?: InputMaybe<ExplanationOfBenefitEditInput>;
  rationale: Scalars['String']['input'];
  resourceId: Scalars['ID']['input'];
  resourceType: fhirext__ResourceType;
};

export type CreateRetoolNotificationInput = {
  description: Scalars['String']['input'];
  issueId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateReviewPaymentAcceptanceIssueTaskInput = {
  issueId: Scalars['ID']['input'];
};

export type CreateSegmentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  key: Scalars['String']['input'];
  owningTeam: Scalars['String']['input'];
};

export type CreateSegmentResult = {
  __typename: 'CreateSegmentResult';
  segmentId: Scalars['String']['output'];
};

export type CreateSetupIntentInput = {
  cardCollectionEventId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSetupIntentResponse = {
  __typename: 'CreateSetupIntentResponse';
  clientSecret: Scalars['String']['output'];
};

export type CreateSubscriptionInput = {
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  trialPeriodDays?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSubscriptionResponse = {
  __typename: 'CreateSubscriptionResponse';
  id: Scalars['ID']['output'];
};

export type CreateTaskCommentInput = {
  comment: Scalars['String']['input'];
  complete?: InputMaybe<Scalars['Boolean']['input']>;
  taskId: Scalars['ID']['input'];
};

export type CreateTemplateError = {
  __typename: 'CreateTemplateError';
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateTemplateInput = {
  default?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['String']['input']>;
  s3Bucket: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  templateType: TemplateType;
};

export type CreateTemplateResult = CreateTemplateError | CreateTemplateSuccess;

export type CreateTemplateSuccess = {
  __typename: 'CreateTemplateSuccess';
  success: Scalars['Boolean']['output'];
  templateId: Scalars['String']['output'];
};

export type CreateWebAgentEndpointInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  dashboardUrl?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  displayUrl?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPasswordRequired?: InputMaybe<Scalars['Boolean']['input']>;
  loginUrl: Scalars['String']['input'];
  portalGuideUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CreateWebAgentEndpointResult = {
  __typename: 'CreateWebAgentEndpointResult';
  endpointId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Credentials = {
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/**
 * Never returned. The per-endpoint plan-documents support gate was removed;
 * this type stays in the union because deployed clients still send an inline
 * fragment on it, and removing it would fail their query validation.
 */
export type DataTypeNotSupported = {
  __typename: 'DataTypeNotSupported';
  executionId: Scalars['ID']['output'];
  status: DataTypeStatus;
};

export type DataTypeProcessing = {
  __typename: 'DataTypeProcessing';
  executionId: Scalars['ID']['output'];
  status: DataTypeStatus;
};

export enum DataTypeStatus {
  FAILED = 'FAILED',
  /**
   * Never set by the server anymore; kept for deployed-client compatibility
   * alongside DataTypeNotSupported.
   */
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  PROCESSING = 'PROCESSING',
  SUCCESS = 'SUCCESS',
  UNAVAILABLE = 'UNAVAILABLE'
}

export type DataTypesStatus = {
  __typename: 'DataTypesStatus';
  executionId: Scalars['ID']['output'];
  planDocuments: PlanDocumentsDataTypeStatus;
};

export type DeclareNoIncomeDocumentsInput = {
  issueId: Scalars['ID']['input'];
};

export type DeclinePaymentPreferencesInput = {
  eventId: Scalars['ID']['input'];
};

/** Input for deleting a navigator specialist page discovery */
export type DeleteNavigatorSpecialistPageDiscoveryInput = {
  id: Scalars['ID']['input'];
};

export type DeletePaymentProfileResponse = {
  __typename: 'DeletePaymentProfileResponse';
  success: Scalars['Boolean']['output'];
};

export type DeleteProviderInput = {
  id: Scalars['ID']['input'];
};

export type DeleteProviderResult = FormError | ProviderDeleted;

export type DeleteUserDocumentInput = {
  documentId: Scalars['ID']['input'];
  /** When set, the document must have an internal upload event on this issue. */
  issueId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type DeleteUserDocumentResult = {
  __typename: 'DeleteUserDocumentResult';
  deletedDocumentId: Scalars['ID']['output'];
};

export type DirectAwaitLoginResultInput = {
  linkId: Scalars['String']['input'];
  workflowId: Scalars['String']['input'];
};

export type DirectLoginToInstitutionResult = FailedLoginMaxReached | InvalidCredentials | LoginSuccess | MfaRequired | RpaError | SecurityQuestionRequired | SelectMfaMethodResponse;

export type DirectRequestNewMfaCodeResult = RpaError | SelectMfaMethodResponse;

export type DirectSelectMfaMethodResult = RpaError | SelectMfaMethodResponse;

export type DirectStartRelinkResult = {
  __typename: 'DirectStartRelinkResult';
  workflowId: Scalars['String']['output'];
};

export type DirectSubmitMfaCodeResult = InvalidCredentials | LoginSuccess | RpaError;

export type DirectSubmitSecurityAnswerResult = LoginSuccess | RpaError | SecurityQuestionRequired;

export type DismissFindingInput = {
  findingId: Scalars['ID']['input'];
};

export type DismissTaskDraftInput = {
  reason: TaskDraftDismissReason;
  suggestionId: Scalars['ID']['input'];
};

export enum DocumentStage {
  ANALYSIS_READY = 'ANALYSIS_READY',
  DEGRADED = 'DEGRADED',
  EXTRACTING = 'EXTRACTING',
  FAILED = 'FAILED',
  READ = 'READ',
  RETAKE_ASKED = 'RETAKE_ASKED',
  UPLOADED = 'UPLOADED'
}

/** The latest durable stage for one document intake attempt. */
export type DocumentStageState = {
  __typename: 'DocumentStageState';
  at: Scalars['String']['output'];
  attemptId: Scalars['String']['output'];
  attemptStartedAt: Scalars['String']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  /** Sender named on READ, carried through later stages of the same attempt. */
  sender?: Maybe<Scalars['String']['output']>;
  stage: DocumentStage;
};

/**
 * A single accumulator row — one (type, tier, network) combination
 * with its current numeric state.
 */
export type EligibilityAccumulator = {
  __typename: 'EligibilityAccumulator';
  limitAmount?: Maybe<Scalars['Float']['output']>;
  metAmount?: Maybe<Scalars['Float']['output']>;
  network: Scalars['String']['output'];
  period?: Maybe<Scalars['String']['output']>;
  remainingAmount?: Maybe<Scalars['Float']['output']>;
  serviceCategory?: Maybe<Scalars['String']['output']>;
  tier: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/**
 * Financial accumulator values extracted from a single eligibility
 * response for one membership. Contains plan year boundaries and the
 * set of accumulator rows (deductible, OOP max, coinsurance, copay)
 * broken down by tier, network, and service category.
 */
export type EligibilityAccumulatorSnapshot = {
  __typename: 'EligibilityAccumulatorSnapshot';
  accumulators: Array<EligibilityAccumulator>;
  planYearEnd?: Maybe<Scalars['String']['output']>;
  planYearStart?: Maybe<Scalars['String']['output']>;
};

/**
 * Attempt-log counts over one trailing window. `checked`/`skipped`/`failed`
 * partition `attempts`; the remaining fields are overlapping slices.
 */
export type EligibilityAttemptWindow = {
  __typename: 'EligibilityAttemptWindow';
  /**
   * Checked attempts whose 271 carried AAA rejection codes — the vendor
   * answered but the payer rejected the request. Counted inside `checked`.
   */
  aaaRejected: Scalars['Int']['output'];
  attempts: Scalars['Int']['output'];
  checked: Scalars['Int']['output'];
  /**
   * Attempts that dispatched at least one domain event (accumulator or a
   * benefit position observation) — the productive slice.
   */
  dispatched: Scalars['Int']['output'];
  /**
   * Checked attempts with a clean response but zero accumulator rows
   * (`dispatchReason = EMPTY_SNAPSHOT`, no error). Counted inside `checked`.
   */
  emptySnapshots: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  /**
   * Attempts the failure-backoff gate suppressed instead of re-hitting
   * the vendor (`errorCode = SUPPRESSED_FAILURE_BACKOFF`). Counted inside
   * `skipped`.
   */
  suppressed: Scalars['Int']['output'];
  windowDays: Scalars['Int']['output'];
};

/**
 * Structured error rendered on a SKIPPED or FAILED
 * `EligibilityCheckOutcome`. The field set is intentionally small and
 * action-oriented. Rich debugging context (HTTP status codes, zod
 * issues, vendor response headers, trading partner IDs, etc.) lives
 * in server-side logs and Sentry extras, not in the GraphQL response.
 */
export type EligibilityCheckError = {
  __typename: 'EligibilityCheckError';
  /**
   * Stable class-level identifier. Always the server-side error class
   * name — safe for programmatic branching on the client and for
   * Sentry issue grouping.
   */
  code: Scalars['String']['output'];
  /**
   * Human-readable message. Stable per `(code, subCode)` tuple — the
   * same combination always produces the same string. Safe to display
   * without further formatting.
   */
  message: Scalars['String']['output'];
  /**
   * Whether retrying the same request is likely to succeed without
   * human intervention. False for conditions requiring an upstream
   * data or configuration fix (missing member data, unresolved payer,
   * exhausted NPI tiers). True for transient vendor failures
   * (timeouts, rate limits, 5xx).
   */
  retryable: Scalars['Boolean']['output'];
  /**
   * Optional finer-grained classification within a `code`. Populated
   * for errors that have meaningful sub-conditions (e.g.
   * MemberDataInsufficientError's `EMPTY_MEMBER_ID`,
   * `INVALID_DATE_OF_BIRTH`). Null when the class is itself the
   * terminal classification.
   */
  subCode?: Maybe<Scalars['String']['output']>;
};

export type EligibilityCheckInput = {
  /**
   * When true, dispatch `receiveAccumulator` for memberships whose
   * snapshot differs from the latest projection. When false (the default),
   * returns the parsed snapshot without mutating any state.
   */
  dispatch?: Scalars['Boolean']['input'];
  /**
   * Force an `AccumulatorPositionChanged` observation for every tracked
   * benefit position even when nothing moved. Requires `dispatch: true` to
   * take effect. Forced observations carry `forced: true` so campaigns and
   * the run report exclude them. Intended for exercising the notification
   * pipeline end-to-end against real user data; not meant for production
   * operations. The field name is kept for tooling compatibility.
   */
  forceDeductibleChangeEvent?: Scalars['Boolean']['input'];
  /**
   * Override: use this payer ID verbatim, skipping the payer resolver.
   * When omitted, the resolver walks OVERRIDE → CARD → SEARCH tiers.
   */
  payerIdOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this payer name verbatim. Primarily needed when
   * synthesizing a check for a user with zero memberships — a membership
   * always carries a payer name, so patching it on an existing membership
   * is rarely useful.
   */
  payerNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this 10-digit NPI verbatim, skipping the NPI resolver.
   * When omitted, the resolver walks the user's historical data.
   *
   * Stedi requires a provider name alongside the NPI on every 270 — a
   * bare NPI is rejected with HTTP 400. When supplying this override,
   * the caller must also supply `providerOrganizationNameOverride` (or
   * populate the NPI registry with an entry matching this NPI
   * so the resolver fallback can attach a name).
   */
  providerNpiOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: organization name to send alongside `providerNpiOverride`.
   * Required when the NPI override is set; otherwise Stedi rejects the
   * request as missing the provider name. Only the organization-name
   * branch is exposed via override — individual-provider names
   * (firstName + lastName) are sourced from the NPI registry.
   */
  providerOrganizationNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this DOB (YYYY-MM-DD) verbatim, skipping the subscriber resolver.
   * When omitted, the resolver walks OVERRIDE → MEMBER → PERSON tiers.
   */
  subscriberDateOfBirthOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this first name verbatim, skipping the subscriber resolver.
   * When omitted, the resolver walks OVERRIDE → MEMBER → PERSON tiers.
   */
  subscriberFirstNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this last name verbatim, skipping the subscriber resolver.
   * When omitted, the resolver walks OVERRIDE → MEMBER → PERSON tiers.
   */
  subscriberLastNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: use this subscriber member ID verbatim, skipping the value
   * carried on the membership. When synthesizing a check for a user with
   * zero memberships, this is the member ID the 270 request is built with.
   *
   * Overrides apply to every membership the check runs against. The
   * automated refresh flow is always "run all memberships for this user,"
   * and admin-targeted single-membership checks are not a first-class
   * surface — use overrides only when you intend them to fan out.
   */
  subscriberMemberIdOverride?: InputMaybe<Scalars['String']['input']>;
  /** User whose memberships should be checked. */
  userId: Scalars['ID']['input'];
};

export type EligibilityCheckOutcome = {
  __typename: 'EligibilityCheckOutcome';
  /**
   * Coverage type of the membership being checked (MEDICAL, DENTAL, VISION,
   * PHARMACY, OTHER). Null when the member projection row does not carry one.
   */
  coverageType?: Maybe<Scalars['String']['output']>;
  /**
   * Stable reason code for the dispatch decision. One of:
   * `DRY_RUN` (input.dispatch was false),
   * `EMPTY_SNAPSHOT` (live dispatch, but vendor returned no accumulator rows),
   * `UNCHANGED` (values equal, no events fired),
   * `CHANGED` (values differ — accumulator event emitted),
   * `BASELINE` (no prior snapshot — first event for this materialization key),
   * `FORCED` (accumulator unchanged, but `forceDeductibleChangeEvent` caused
   * position observations to fire anyway).
   */
  dispatchReason?: Maybe<Scalars['String']['output']>;
  /**
   * Whether any domain event fired for this membership — a
   * `receiveAccumulator` (when values changed) or an
   * `observeAccumulatorPositionChange` (when a tracked position moved, was
   * first observed, or `forceDeductibleChangeEvent` bypassed the gate).
   * Null when `input.dispatch` was false.
   */
  dispatched?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Structured error describing why this outcome is SKIPPED or FAILED.
   * Null when status = CHECKED.
   */
  error?: Maybe<EligibilityCheckError>;
  memberId: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  /**
   * Accumulator snapshot extracted from the eligibility response. Populated
   * when status = CHECKED; null for SKIPPED and FAILED outcomes.
   */
  snapshot?: Maybe<EligibilityAccumulatorSnapshot>;
  /**
   * CHECKED: the eligibility call succeeded and `snapshot` is populated.
   * SKIPPED: the membership lacked required data; `error` describes why.
   * FAILED:  the eligibility call or extraction threw; `error` carries the structured cause.
   */
  status: EligibilityCheckStatus;
  /**
   * Opaque response id from the eligibility vendor — useful for
   * support/debugging and cross-referencing vendor logs.
   */
  vendorResponseId?: Maybe<Scalars['String']['output']>;
};

export type EligibilityCheckResult = {
  __typename: 'EligibilityCheckResult';
  /**
   * Top-level pre-flight error. Populated when the check could not be
   * attempted for any membership at all (e.g. the user has zero memberships,
   * or a targeted memberId didn't match). Distinct from per-outcome errors,
   * which describe why a specific membership was SKIPPED or FAILED.
   */
  error?: Maybe<EligibilityCheckError>;
  /** One outcome per membership that was considered (checked, skipped, or failed). */
  outcomes: Array<EligibilityCheckOutcome>;
  summary: EligibilityCheckSummary;
};

export enum EligibilityCheckStatus {
  CHECKED = 'CHECKED',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED'
}

export type EligibilityCheckSummary = {
  __typename: 'EligibilityCheckSummary';
  checked: Scalars['Int']['output'];
  considered: Scalars['Int']['output'];
  dispatched: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

export type EligibilityLastCheckOutcomes = {
  __typename: 'EligibilityLastCheckOutcomes';
  checked: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  /** Tracked users with no check attempt recorded yet. */
  neverChecked: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
};

/**
 * Population-level eligibility metrics. User counts read
 * `projection.UserEligibilityView` (one row per user with any
 * eligibility-domain data) — except `usersWithBenefits` and
 * `usersCheckedLast7Days`, which read `projection.UserDataView` and
 * `projection.EligibilityCheckAttemptView` respectively; attempt windows
 * read `projection.EligibilityCheckAttemptView` (one row per membership
 * check attempt).
 */
export type EligibilityOpsSummary = {
  __typename: 'EligibilityOpsSummary';
  /** Attempt-log volume over trailing windows (7 and 30 days). */
  attemptWindows: Array<EligibilityAttemptWindow>;
  /**
   * Users formally in the eligibility program (`enrolledAt` set). The
   * population the weekly scheduled refresh visits.
   */
  enrolledUsers: Scalars['Int']['output'];
  /** Breakdown of every tracked user's most recent check outcome. */
  lastCheckOutcomes: EligibilityLastCheckOutcomes;
  /**
   * Users with any eligibility-domain data on file — at least one
   * Person/Member/Attempt event has landed.
   */
  trackedUsers: Scalars['Int']['output'];
  /**
   * Distinct users with at least one CHECKED attempt in the last 7 days —
   * the vendor actually answered for them. Backoff-suppressed and
   * locally-skipped attempts do not count.
   */
  usersCheckedLast7Days: Scalars['Int']['output'];
  /**
   * Distinct users with at least one persisted accumulator snapshot — a
   * check has returned real benefits data for them at some point.
   */
  usersWithBenefits: Scalars['Int']['output'];
};

export type EndpointSlug = {
  __typename: 'EndpointSlug';
  id?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type EpicEndpointChange = EpicEndpointCreate | EpicEndpointDeactivate | EpicEndpointUpdateLoginUrl | EpicEndpointUpdateMetadata | EpicEndpointUpdateName;

export type EpicEndpointCreate = {
  __typename: 'EpicEndpointCreate';
  epicExternalId: Scalars['String']['output'];
  loginUrl: Scalars['String']['output'];
  metadata: Array<EpicMetadataEntry>;
  name: Scalars['String']['output'];
};

export type EpicEndpointDeactivate = {
  __typename: 'EpicEndpointDeactivate';
  epicExternalId: Scalars['String']['output'];
};

export type EpicEndpointUpdateLoginUrl = {
  __typename: 'EpicEndpointUpdateLoginUrl';
  epicExternalId: Scalars['String']['output'];
  newLoginUrl: Scalars['String']['output'];
  oldLoginUrl: Scalars['String']['output'];
};

export type EpicEndpointUpdateMetadata = {
  __typename: 'EpicEndpointUpdateMetadata';
  epicExternalId: Scalars['String']['output'];
  newMetadata: Array<EpicMetadataEntry>;
  oldMetadata: Array<EpicMetadataEntry>;
};

export type EpicEndpointUpdateName = {
  __typename: 'EpicEndpointUpdateName';
  epicExternalId: Scalars['String']['output'];
  newName: Scalars['String']['output'];
  oldName: Scalars['String']['output'];
};

export type EpicMetadataEntry = {
  __typename: 'EpicMetadataEntry';
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type EventTrackingResult = {
  __typename: 'EventTrackingResult';
  success: Scalars['Boolean']['output'];
};

export type ExecutionDocumentType = {
  __typename: 'ExecutionDocumentType';
  contentType: Scalars['String']['output'];
};

export type ExecutionResultArtifact = {
  __typename: 'ExecutionResultArtifact';
  artifactType: Scalars['String']['output'];
  crawlType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
};

export type ExecutionResultDocument = {
  __typename: 'ExecutionResultDocument';
  dataType?: Maybe<Scalars['String']['output']>;
  files: Array<ExecutionDocumentType>;
};

/** Input fields for editing an ExplanationOfBenefit resource */
export type ExplanationOfBenefitEditInput = {
  billablePeriodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  billablePeriodStart?: InputMaybe<Scalars['DateTime']['input']>;
  createdDate?: InputMaybe<Scalars['DateTime']['input']>;
  decision?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  network?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  serviceDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * A case's financial-assistance application: the durable composer that fills one
 * provider's form for one case. formState is the in-progress draft keyed by
 * canonical field key; submissionSnapshot is frozen at submit. providerForm is
 * null until an HA pins a form (or none is onboarded yet).
 */
export type FaApplication = {
  __typename: 'FaApplication';
  formName?: Maybe<Scalars['String']['output']>;
  /**
   * Per-field draft, the faForm FormState shape `{ values: { <key>: <value> },
   * provenance: { <key>: { source, confirmed } } }`, keyed by canonical field key.
   * JSON-encoded.
   */
  formState?: Maybe<Scalars['JSON']['output']>;
  formType?: Maybe<provider__FormType>;
  id: Scalars['ID']['output'];
  issueId: Scalars['ID']['output'];
  issuerName?: Maybe<Scalars['String']['output']>;
  providerFormId?: Maybe<Scalars['ID']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
  signedAt?: Maybe<Scalars['String']['output']>;
  status: fa__ApplicationStatus;
  /**
   * Frozen filed values plus the signed-PDF reference, set once at submit.
   * JSON-encoded; null until the application is submitted.
   */
  submissionSnapshot?: Maybe<Scalars['JSON']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type FaApplicationResult = FaApplication | FormError;

/**
 * A case's FA application rendered for filling: the form to show, the current
 * answers, and whether it has been filed. The owner-facing read model the FA
 * wizard/CLI drives, distinct from the HA-facing `FaApplication`.
 */
export type FaApplicationView = {
  __typename: 'FaApplicationView';
  /**
   * FormSpec version stamped on the aggregate when this application was filed.
   * Null while still a draft, and null for legacy submits that predate the stamp.
   * Compare to formSpecVersion (today's resolved spec) to detect post-filing
   * recalibration — do not present today's labels as historical when they differ.
   */
  filedFormSpecVersion?: Maybe<Scalars['Int']['output']>;
  /**
   * The resolved FormSpec — the pinned provider form's authored fields, else the
   * generic Granted baseline. The faForm FormSpec shape (sections -> fields).
   * JSON-encoded.
   */
  formSpec: Scalars['JSON']['output'];
  /**
   * The resolved FormSpec's version: the provider form's revision (always >= 1),
   * or 0 whenever the generic baseline serves — including a pinned form whose
   * stored spec is empty, so a baseline-era echo can never collide with the
   * form's first calibration. Echo back at submit (expectedFormSpecVersion) so a
   * recalibration between render and submit is refused instead of silently filed
   * against.
   */
  formSpecVersion: Scalars['Int']['output'];
  /**
   * The current draft answers, the faForm FormState shape `{ values, provenance }`
   * keyed by canonical field key. JSON-encoded.
   */
  formState: Scalars['JSON']['output'];
  /**
   * The pinned provider form's id; null when unpinned (the generic baseline is
   * being served). Echo back at submit (expectedProviderFormId) so a re-pin that
   * lands between render and submit is refused instead of silently filed against.
   */
  providerFormId?: Maybe<Scalars['ID']['output']>;
  /**
   * ISO 8601 staff-resend time that opened a working draft again. Null until
   * the first reopen, and cleared on the next submit. The wizard is terminal
   * only when submittedAt is set and this is null.
   */
  reopenedAt?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 most-recent skip time; null when not skipped (or un-skipped). */
  skippedAt?: Maybe<Scalars['String']['output']>;
  /** ISO 8601 first wizard-open time; null until the user has opened the wizard. */
  startedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The answers exactly as filed (the faForm FormState shape), frozen at submit.
   * Null while still a draft. A post-filing re-pin (allowSubmitted) moves
   * formState onto the onboarded form but never this — read it to show what the
   * user actually filed. JSON-encoded.
   */
  submissionSnapshot?: Maybe<Scalars['JSON']['output']>;
  /** ISO 8601 submit time; null while still a draft. Kept after a staff reopen. */
  submittedAt?: Maybe<Scalars['String']['output']>;
};

/**
 * The form view, or a FormError when the offer/wizard action can't apply — e.g.
 * skipping or opening the wizard for a case that has no FA application yet.
 */
export type FaApplicationViewResult = FaApplicationView | FormError;

/**
 * One pre-calibration audit finding: a flag the auditor raised on the detected
 * proposal for a human to resolve. `class` is one of coverage | semantic_key |
 * staff_side_candidate | rejected_but_real | fluency; `widgetId` (wN) points at
 * the widget when the finding is about a specific one (absent for a coverage
 * finding); `message` is the one-line reason; `confidence` is high | medium | low.
 * Flags only — never a mutation of the widget.
 */
export type FaAuditFinding = {
  __typename: 'FaAuditFinding';
  class: Scalars['String']['output'];
  confidence: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  widgetId?: Maybe<Scalars['String']['output']>;
};

export enum FaEligibilityOutcome {
  CATASTROPHIC_COVERED = 'CATASTROPHIC_COVERED',
  STRONG_CASE = 'STRONG_CASE'
}

export type FaEligibilityResult = {
  __typename: 'FaEligibilityResult';
  outcome: FaEligibilityOutcome;
};

export type FaExtractionValueInput = {
  /** 0..1; below the confirm threshold the value is surfaced to confirm, not pre-filled. */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  key: Scalars['String']['input'];
  /** Trust source (e.g. DOCUMENT_OCR, USER_CHAT, LLM_INFERENCE). Defaults to DOCUMENT_OCR. */
  source?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type FaFieldError = {
  __typename: 'FaFieldError';
  code: FaFieldErrorCode;
  /**
   * Canonical dotted field key, row-addressed for repeating-group rows
   * (application.employment.employers[0].employerName) — always a leaf key the
   * client can mount an input for.
   */
  key: Scalars['String']['output'];
  /** Server hint for CLI/log consumers; clients prefer copy keyed by code. */
  message?: Maybe<Scalars['String']['output']>;
};

/**
 * Stable machine-readable error classes: the client owns user-facing copy keyed
 * by these, and analytics groups error trends by them. Additions are
 * non-breaking; renames and removals are.
 */
export enum FaFieldErrorCode {
  /**
   * The upload is past the packet's per-document byte or page cap. Distinct from
   * UNSUPPORTED_DOCUMENT_FORMAT: the format is fine and the fix is a smaller or
   * shorter file, not a different one.
   */
  DOCUMENT_TOO_LARGE = 'DOCUMENT_TOO_LARGE',
  /**
   * The slot names the same document more than once. Distinct from
   * MIN_ITEMS_NOT_MET: the count looks met, but the packet dedupes ids before
   * merging, so the duplicate contributes no page and the answer is short.
   */
  DUPLICATE_DOCUMENT = 'DUPLICATE_DOCUMENT',
  MIN_ITEMS_NOT_MET = 'MIN_ITEMS_NOT_MET',
  MONEY_NOT_INTEGER_CENTS = 'MONEY_NOT_INTEGER_CENTS',
  REQUIRED_MISSING = 'REQUIRED_MISSING',
  /**
   * The upload is in a format the combined packet cannot bundle. Reported at
   * submit rather than at packet time because submit freezes the application:
   * after it, the applicant can no longer replace the file.
   */
  UNSUPPORTED_DOCUMENT_FORMAT = 'UNSUPPORTED_DOCUMENT_FORMAT',
  VALUE_NOT_CONFORMANT = 'VALUE_NOT_CONFORMANT'
}

export type FaFillReport = {
  __typename: 'FaFillReport';
  attempted: Scalars['Int']['output'];
  encodeErrors: Scalars['Int']['output'];
  filled: Scalars['Int']['output'];
  outcomes: Array<FaPacketFieldOutcome>;
  skippedEmpty: Scalars['Int']['output'];
};

/**
 * Which form the staff-triggered FA flow would deliver for a case, plus the
 * already-started state when the case has an application. Names are display
 * names, ready to render.
 */
export type FaFlowFormResolution = {
  __typename: 'FaFlowFormResolution';
  /**
   * The existing application's status; null when the FA flow has not started
   * for the case (no application yet).
   */
  applicationStatus?: Maybe<fa__ApplicationStatus>;
  /**
   * Read-only carry-over preview for the re-pin affordance: how many of the
   * draft's current answers would survive onto the resolved form. Non-null only
   * when a re-pin would change something (a draft exists and `formId` differs from
   * `pinnedFormId`); null otherwise. Lets the confirm dialog show "N of M answers
   * carry over" BEFORE the operator applies the re-pin, not just after.
   */
  carriedOver?: Maybe<Scalars['Int']['output']>;
  /** The resolved provider form's id; null when the resolution is BASELINE. */
  formId?: Maybe<Scalars['ID']['output']>;
  /** The resolved form's name; null when the resolution is BASELINE. */
  formName?: Maybe<Scalars['String']['output']>;
  /**
   * The resolved form's FormSpec version, carried so the HA confirm can pin the
   * re-pin to the exact spec the preview showed (`repinFaApplicationForm`'s
   * compare-and-swap re-checks it). Non-null only under drift, like carriedOver.
   */
  formSpecVersion?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether the user-visible FA offer event (the in-chat card) exists for the
   * application. False with a non-null applicationStatus means a draft exists
   * but no offer reached the chat — the send stays open to emit the missing
   * event.
   */
  hasOfferEvent: Scalars['Boolean']['output'];
  /**
   * The parent system whose form the linked facility inherits; null unless the
   * resolution is INHERITED.
   */
  inheritedFrom?: Maybe<Scalars['String']['output']>;
  /**
   * The provider form id currently pinned on the existing application; null when
   * there is no application, or it is unpinned (generic baseline). A mismatch with
   * `formId` means the case now resolves to a different form than the draft is
   * pinned to — the re-pin affordance keys off exactly this.
   */
  pinnedFormId?: Maybe<Scalars['ID']['output']>;
  /**
   * The directory provider id that owns the form pinned on the existing
   * application; null when there is no application or it is unpinned. Fill /
   * packet deep-links must use this (not the case's current providerId) so a
   * provider swap after hand-off still opens the form the draft is pinned to.
   */
  pinnedFormProviderId?: Maybe<Scalars['ID']['output']>;
  /**
   * The issuer (provider display name) of the form pinned on the existing
   * application; null when there is no application or it is unpinned (generic
   * baseline). A mismatch with providerName means the case's provider changed
   * after the hand-off.
   */
  pinnedFormProviderName?: Maybe<Scalars['String']['output']>;
  /** The directory provider linked to the case; null when none is linked. */
  providerId?: Maybe<Scalars['ID']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  resolution: FaFlowFormResolutionKind;
  /** Total answer keys currently held in the draft; paired with carriedOver, null when that is. */
  totalAnswers?: Maybe<Scalars['Int']['output']>;
};

/**
 * How the FA hand-off's form resolves for a case: the linked provider's own form
 * (OWN), the parent system's via partOf (INHERITED), or nothing calibrated
 * anywhere in the chain — the user gets the generic Granted baseline (BASELINE).
 */
export enum FaFlowFormResolutionKind {
  BASELINE = 'BASELINE',
  INHERITED = 'INHERITED',
  OWN = 'OWN'
}

/**
 * The form changed between render and submit — a staff re-pin or a form
 * recalibration landed after the client loaded the wizard. Nothing was filed and
 * answers are never rebased onto the new spec: the client re-fetches
 * faApplicationForIssue and has the user re-confirm on the current form.
 */
export type FaFormChangedError = {
  __typename: 'FaFormChangedError';
  /** The currently resolved FormSpec version (0 when the baseline serves). */
  currentFormSpecVersion: Scalars['Int']['output'];
  /** The currently pinned form id; null when the baseline now serves. */
  currentProviderFormId?: Maybe<Scalars['ID']['output']>;
  /** Server hint for CLI/log consumers; clients own user-facing copy. */
  message: Scalars['String']['output'];
};

export type FaFormFill = {
  __typename: 'FaFormFill';
  /**
   * Pre-calibration audit flags stored on the detected template (empty when the
   * form predates the auditor or read clean). The calibrate screen renders these
   * as needs-review flags — flags only, the widgets are never mutated.
   */
  auditFindings: Array<FaAuditFinding>;
  /**
   * When the form was last approved (ISO 8601), or null if never calibrated. The
   * calibrate editor uses its presence to tell a first calibration from a reopened
   * one — a reopen rebuilds proposals from the operator-edited template, so prior
   * choices would otherwise look like fresh proposer accepts in the delta stream.
   */
  calibratedAt?: Maybe<Scalars['String']['output']>;
  caseId: Scalars['ID']['output'];
  fields: Array<FaFormFillField>;
  formName: Scalars['String']['output'];
  issuerName: Scalars['String']['output'];
  /** Page count spanned by the template's fields. */
  pages: Scalars['Int']['output'];
  /**
   * Base64-encoded blank form PDF bytes, served through the API so the browser
   * renders it same-origin and never fetches S3 directly.
   */
  pdfBase64: Scalars['String']['output'];
  /**
   * True when this template's field keys came from the deterministic fallback
   * because the proposer's LLM call failed — measurably worse keys, so the
   * calibrate screen warns the reviewer to consider re-running detection. A
   * successful re-detect clears it.
   */
  proposerFallback: Scalars['Boolean']['output'];
  /**
   * The curated required documents (vision DocumentType, optional custom label
   * and count) this form requires, set at calibration time. Empty when never
   * calibrated. Round-tripped so a re-calibration pass doesn't silently erase
   * the curated list.
   */
  requiredDocs: Array<FaFormFillRequiredDoc>;
};

export type FaFormFillBbox = {
  __typename: 'FaFormFillBbox';
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  /** 1-indexed source page; 1 for single-page templates. */
  page: Scalars['Int']['output'];
  top: Scalars['Float']['output'];
  width: Scalars['Float']['output'];
};

export type FaFormFillField = {
  __typename: 'FaFormFillField';
  bbox: FaFormFillBbox;
  /**
   * Operator-curated shared question for a same-key checkbox cluster (the field
   * heading patients see, e.g. "Marital status"). Distinct from `patientLabel`,
   * which on a cluster member is that box's choice. Null when never curated
   * (FormSpec derives from the description group tail).
   */
  clusterLabel?: Maybe<Scalars['String']['output']>;
  /**
   * For a same-key checkbox cluster: "single" (oneOf, e.g. marital status) or
   * "multi" (anyOf, e.g. a checklist where several boxes may apply); null when
   * never calibrated (defaults to "single", today's behavior). Carried through
   * so a re-calibration round-trip doesn't silently erase a curated choice.
   */
  clusterType?: Maybe<Scalars['String']['output']>;
  /** Stored confidence band ("high" | "medium" | "low"); null when absent. */
  confidence?: Maybe<Scalars['String']['output']>;
  /**
   * True when the resolved FormSpec types this key as a calendar date (ISO
   * YYYY-MM-DD answers). Display surfaces and bakes render the stored ISO value
   * as the US MM/DD/YYYY the paper form expects; the stored value stays ISO.
   * Distinct from `type` (the physical control).
   */
  date: Scalars['Boolean']['output'];
  /**
   * Full untruncated source description. The calibrate editor persists this on
   * save so a re-open doesn't overwrite the stored description with the capped
   * `label`; empty for a staff-added widget with no detected description.
   * Byte-frozen input to the checkbox option slugs and the custom-key derivation,
   * so it stays the detector's raw text however the label is edited.
   */
  description: Scalars['String']['output'];
  /**
   * Calibrated wizard-type override for a text widget ("money" | "number" |
   * "longtext"); null when never set. Wins over the key-suffix type inference
   * when the FormSpec is derived. Carried through so a re-calibration
   * round-trip doesn't silently revert an overridden field to text.
   */
  fieldType?: Maybe<Scalars['String']['output']>;
  /**
   * Persistent widget id from the stored template (null on legacy templates).
   * Calibrate uses it to attach audit flags stably across approve/reopen.
   */
  id?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  /**
   * 48-char display cap of the field's source description (used for overlay tags
   * and error detail). Not patient copy — see `patientLabel`.
   */
  label: Scalars['String']['output'];
  /**
   * How a checked checkbox is inked on the filled PDF: "x" (default), "box", or
   * "oval". Used when the HA draws option widgets over printed words a form asks
   * the patient to circle; null/absent keeps today's "X" mark. Carried through so
   * a re-calibration round-trip doesn't silently revert a curated mark style.
   */
  markStyle?: Maybe<Scalars['String']['output']>;
  /**
   * True when the resolved FormSpec types this key as money (integer-cents answers).
   * The fill screen shows a dollars display for these but posts integer cents on
   * save, so an edited amount round-trips instead of being dropped as a
   * non-conformant display string. Distinct from `type` (the physical control).
   */
  money: Scalars['Boolean']['output'];
  /**
   * Optional subtitle / help under the question for a non-cluster field. The
   * operator's curated text when set (empty string = curated clear); null when
   * never curated (FormSpec derives leftover description sentences).
   */
  patientHelp?: Maybe<Scalars['String']['output']>;
  /**
   * The short label a patient reads as this field's question, and the one the
   * calibrate editor edits: the operator's curated text when calibration authored
   * one, else derived from `description` (detection's orientation prose stripped).
   * Falls back to the full description when nothing is derivable. On a checkbox
   * cluster member this is the box's choice; the shared question is `clusterLabel`.
   */
  patientLabel: Scalars['String']['output'];
  /** Anchor-row only: add-button copy, e.g. "Add a household member". */
  repeatAddLabel?: Maybe<Scalars['String']['output']>;
  /**
   * For a repeating-group cell: the row-addressed key its answer lives under
   * ("person.household[2].firstName"); null for every ordinary field. Every
   * printed row of a grid shares one member `key`, so the fill screen must key
   * its draft and its generated packet by THIS — the address the packet bake
   * reads a row's answer from. Only cells the server counts as active (inside the
   * group's contiguous full-row prefix) get one; anything else is a flat field to
   * the bake and the wizard alike, and keeps its plain `key`.
   */
  repeatCellKey?: Maybe<Scalars['String']['output']>;
  /**
   * Repeating-group membership: the derived group's canonical key. This field's
   * `key` stays its full unindexed canonical member key (e.g.
   * "person.household.income" under group "person.household"), shared across
   * every printed row; the bake adds the row index. Null on a non-repeating
   * field. Carried through like clusterType so a re-calibration round-trip
   * doesn't silently flatten a marked grid.
   */
  repeatGroup?: Maybe<Scalars['String']['output']>;
  /** Anchor-row only: singular per-entry label, e.g. "Household member". */
  repeatItemLabel?: Maybe<Scalars['String']['output']>;
  /** Anchor-row only: the wizard's add-row cap (marked row count); null elsewhere. */
  repeatMax?: Maybe<Scalars['Int']['output']>;
  /** 0-based printed row this box inks; null off a repeating group. */
  repeatRow?: Maybe<Scalars['Int']['output']>;
  /**
   * Whether calibration marked this field required; null when never calibrated
   * (a fresh detection defaults to not-required in the wizard). Carried through
   * so a re-calibration round-trip doesn't silently erase a curated flag.
   */
  required?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True when the resolved FormSpec (the form's authored fields, else the
   * baseline) types this key as a signature: its value may be a drawn-stroke PNG
   * data URL, which bakes render as an image, never as literal text. Distinct
   * from `type`, which is the physical control on the PDF.
   */
  signature: Scalars['Boolean']['output'];
  /**
   * Stored calibration review state ("proposed" | "accepted" | "rejected"); null
   * for a fresh detection with no persisted review. The calibrate screen restores
   * this so re-opening a calibrated form shows accepted fields, not all-proposed.
   */
  state?: Maybe<Scalars['String']['output']>;
  /** One of "text" or "checkbox". */
  type: Scalars['String']['output'];
};

/**
 * One curated required document: the vision DocumentType `type` (e.g.
 * "paystub", "governmentId"), an optional staff-authored display `label`
 * (falls back to the standard map when null), an optional `count` of
 * uploads required for this type (null/1 = just one), and `optional` — when
 * true the slot is a soft request (skipped by the submit gate), used for
 * income proofs where the applicant uploads only what they have.
 */
export type FaFormFillRequiredDoc = {
  __typename: 'FaFormFillRequiredDoc';
  count?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  optional?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Months of pay stubs for a cadence-based paystub requirement. Mutually
   * exclusive with `count`: the wizard asks the applicant their pay frequency
   * and derives the upload count from this period.
   */
  period?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
};

export type FaFormFillResult = FaFormFill | FormError;

export type FaPacket = {
  __typename: 'FaPacket';
  completeness: FaPacketCompleteness;
  documentId: Scalars['ID']['output'];
  fillReport: FaFillReport;
  verifier: FaVerifierResult;
  /**
   * The Temporal workflow id orchestrating this packet generation. Deterministic
   * for a given case + form type + input fingerprint.
   */
  workflowId: Scalars['String']['output'];
};

/**
 * The case's supporting documents measured against the FormSpec's own document
 * requirements — the same rule submit enforces, so a packet can never report a
 * complete document set for answers submit would have rejected.
 */
export type FaPacketCompleteness = {
  __typename: 'FaPacketCompleteness';
  /** Field keys of the requirements still unmet. */
  missing: Array<Scalars['String']['output']>;
  /** Documents bundled behind the filled form. */
  provided: Scalars['Int']['output'];
  /** Document requirements the form imposes; a doc group counts once, however many options it offers. */
  required: Scalars['Int']['output'];
  /**
   * Requirements met, for the "N of M" line. Not `required - missing.length`: an
   * unsatisfied anyOf group lists every option it would accept, so one unmet
   * requirement can contribute several keys to `missing`.
   */
  satisfied: Scalars['Int']['output'];
};

export type FaPacketFieldOutcome = {
  __typename: 'FaPacketFieldOutcome';
  detail?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  /** One of "filled", "empty", or "encode-error". */
  status: Scalars['String']['output'];
};

export type FaPacketResult = FaPacket | FormError;

export type FaPolicyInheritanceSource = {
  __typename: 'FaPolicyInheritanceSource';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type FaPolicyResolution = {
  __typename: 'FaPolicyResolution';
  /**
   * The system the policy came from, or would have. Set for INHERITED and
   * PARENT_INVALID, null everywhere else including OWN — a provider does not
   * inherit from itself. Carries the id so a surface can link to the row.
   */
  inheritedFromProvider?: Maybe<FaPolicyInheritanceSource>;
  /** Why the applicable policy will not parse, when it will not. */
  invalidReasons?: Maybe<Array<Scalars['String']['output']>>;
  kind: FaPolicyResolutionKind;
  /** JSON-encoded FaPolicy when one resolved, null otherwise. */
  policy?: Maybe<Scalars['String']['output']>;
};

export enum FaPolicyResolutionKind {
  /** Nothing published anywhere in the chain. */
  BASELINE = 'BASELINE',
  /** No policy of its own; the parent system's applies. */
  INHERITED = 'INHERITED',
  /** No such provider. */
  NOT_FOUND = 'NOT_FOUND',
  /** The provider published its own policy. `policy` is null when it will not parse. */
  OWN = 'OWN',
  /**
   * The facility published nothing and the system it would inherit from holds a
   * policy that will not parse. Distinct from BASELINE: a program exists and our
   * record of it is broken, which is a repair rather than an absence.
   */
  PARENT_INVALID = 'PARENT_INVALID'
}

export type FaStructuredValueInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/**
 * An invalid submission — nothing was filed. Every offending answer is reported
 * at once: one FaFieldError per mounted field, and anything that can't be keyed
 * to a mounted field folds into formMessage.
 */
export type FaSubmitValidationError = {
  __typename: 'FaSubmitValidationError';
  fieldErrors: Array<FaFieldError>;
  /**
   * Global-only failure, or validation errors that couldn't be keyed to a
   * mounted field (an unknown key or a malformed repeating group).
   */
  formMessage?: Maybe<Scalars['String']['output']>;
};

/**
 * One upload the applicant answered on a document field, resolved to its stored
 * Document.
 */
export type FaSupportingDocument = {
  __typename: 'FaSupportingDocument';
  documentId: Scalars['ID']['output'];
  /**
   * The stored file's own name, which carries the real extension (the Document
   * name often doesn't). Null when the document holds no readable file.
   */
  fileName?: Maybe<Scalars['String']['output']>;
  /** The document field key the upload was answered under. */
  key: Scalars['String']['output'];
  /** Display name for the collected-documents panel. */
  name: Scalars['String']['output'];
};

/**
 * The application's uploads, plus whichever of its answers point at a document
 * this issue does not hold.
 */
export type FaSupportingDocuments = {
  __typename: 'FaSupportingDocuments';
  documents: Array<FaSupportingDocument>;
  /**
   * Field keys whose answers name a document that doesn't resolve on this issue —
   * a stale ref, or one belonging to another case. Reported as KEYS, never as the
   * offending ids: the key is the application's own, an id that resolved nowhere
   * here is not this caller's to see. Non-empty means the bundle would be
   * incomplete, so callers must surface it rather than file the difference.
   */
  unresolvedFields: Array<Scalars['String']['output']>;
};

export type FaVerifierFailure = {
  __typename: 'FaVerifierFailure';
  key: Scalars['String']['output'];
  page: Scalars['Int']['output'];
};

export type FaVerifierResult = {
  __typename: 'FaVerifierResult';
  checked: Scalars['Int']['output'];
  failures: Array<FaVerifierFailure>;
  /**
   * No placement failures among the `checked` targets — and nothing more. With
   * `checked: 0` (a signature/checkbox-only fill) nothing was machine-verified;
   * read `ok` together with `checked` rather than rendering a bare "verified".
   */
  ok: Scalars['Boolean']['output'];
  passed: Scalars['Int']['output'];
  /** Checkboxes drawn but not read back (text extraction can't reliably locate a single mark), so they sit outside `ok`. */
  skippedCheckboxes: Scalars['Int']['output'];
  /** Image values (a drawn signature) rendered but not read back (text extraction can't see rasters), so they sit outside `ok`. */
  skippedImages: Scalars['Int']['output'];
};

export type FailedLoginMaxReached = {
  __typename: 'FailedLoginMaxReached';
  signInUrl: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type FairMarketValueResponse = {
  __typename: 'FairMarketValueResponse';
  code: Scalars['String']['output'];
  percentile50: SimpleMoney;
};

/**
 * A poverty-line band for the household's size. Floors exclusive, ceilings
 * inclusive.
 */
export enum FfgaIncomeBand {
  FROM_2X_TO_3X_FPL = 'FROM_2X_TO_3X_FPL',
  FROM_3X_TO_4X_FPL = 'FROM_3X_TO_4X_FPL',
  FROM_4X_TO_5X_FPL = 'FROM_4X_TO_5X_FPL',
  OVER_5X_FPL = 'OVER_5X_FPL',
  UNDER_2X_FPL = 'UNDER_2X_FPL'
}

export type FieldAttributes = {
  __typename: 'FieldAttributes';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type FieldError = {
  __typename: 'FieldError';
  /** Typically the message will be displayed to the user inline on the form field. */
  message: Scalars['String']['output'];
  /**
   * Indicates the field which has an error.
   * For nested fields (e.g. arrays or objects), use a period-separated path, e.g.:
   *   "user.email" or "user.addresses.0.street"
   */
  path: Scalars['String']['output'];
};

export type FilledField = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FilterBaseObject = {
  and?: InputMaybe<Array<FilterBaseObject>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterBaseObject>;
  or?: InputMaybe<Array<FilterBaseObject>>;
};

export type FilterBoolean = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FilterDecimal = {
  eq?: InputMaybe<Scalars['Decimal']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  neq?: InputMaybe<Scalars['Decimal']['input']>;
};

export type FilterFloat = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
};

export type FilterID = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  neq?: InputMaybe<Scalars['ID']['input']>;
};

export type FilterInt = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
};

export type FilterInt64 = {
  eq?: InputMaybe<Scalars['Int64']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Int64']['input']>;
  gte?: InputMaybe<Scalars['Int64']['input']>;
  in?: InputMaybe<Array<Scalars['Int64']['input']>>;
  lt?: InputMaybe<Scalars['Int64']['input']>;
  lte?: InputMaybe<Scalars['Int64']['input']>;
  neq?: InputMaybe<Scalars['Int64']['input']>;
};

export type FilterJSON = {
  eq?: InputMaybe<Scalars['JSON']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  neq?: InputMaybe<Scalars['JSON']['input']>;
};

export type FilterObject = {
  and?: InputMaybe<Array<FilterObject>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterObject>;
  or?: InputMaybe<Array<FilterObject>>;
};

export type FilterOwned = {
  and?: InputMaybe<Array<FilterOwned>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterOwned>;
  or?: InputMaybe<Array<FilterOwned>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type FilterParticipant = {
  eq?: InputMaybe<Participant>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Participant>;
  gte?: InputMaybe<Participant>;
  in?: InputMaybe<Array<Participant>>;
  lt?: InputMaybe<Participant>;
  lte?: InputMaybe<Participant>;
  neq?: InputMaybe<Participant>;
};

export type FilterPerson = {
  addresses?: InputMaybe<person__NestedFilterAddress>;
  and?: InputMaybe<Array<FilterPerson>>;
  createdAt?: InputMaybe<FilterString>;
  dateOfBirth?: InputMaybe<FilterString>;
  emailAddress?: InputMaybe<FilterString>;
  familyName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterPerson>;
  or?: InputMaybe<Array<FilterPerson>>;
  owner?: InputMaybe<NestedFilterUser>;
  phoneNumber?: InputMaybe<FilterString>;
  primary?: InputMaybe<FilterBoolean>;
  primaryAddress?: InputMaybe<person__NestedFilterAddress>;
};

export type FilterPersonal = {
  and?: InputMaybe<Array<FilterPersonal>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterPersonal>;
  or?: InputMaybe<Array<FilterPersonal>>;
  person?: InputMaybe<NestedFilterPerson>;
};

export type FilterSlugged = {
  and?: InputMaybe<Array<FilterSlugged>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<FilterSlugged>;
  or?: InputMaybe<Array<FilterSlugged>>;
  slug?: InputMaybe<FilterString>;
};

export type FilterString = {
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
};

export type FilterUser = {
  acceptedTermsAt?: InputMaybe<FilterString>;
  acceptedTermsVersion?: InputMaybe<FilterString>;
  accounts?: InputMaybe<fhirext__NestedFilterAccountVersion>;
  and?: InputMaybe<Array<FilterUser>>;
  anonymousConvertedAt?: InputMaybe<FilterString>;
  anonymousSessionId?: InputMaybe<FilterString>;
  attribution?: InputMaybe<FilterJSON>;
  createdAt?: InputMaybe<FilterString>;
  deletionRequestedAt?: InputMaybe<FilterString>;
  emails?: InputMaybe<user__NestedFilterEmail>;
  explanationOfBenefits?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitVersion>;
  firstAuthenticatedAt?: InputMaybe<FilterString>;
  flexpaLinks?: InputMaybe<flexpa__NestedFilterLink>;
  hasSeenHome?: InputMaybe<FilterBoolean>;
  hipaaRelease?: InputMaybe<consent__NestedFilterHipaaRelease>;
  id?: InputMaybe<FilterID>;
  invoices?: InputMaybe<fhirext__NestedFilterInvoiceVersion>;
  isAdmin?: InputMaybe<FilterBoolean>;
  isAnonymous?: InputMaybe<FilterBoolean>;
  issues?: InputMaybe<issue__NestedFilterIssue>;
  lastAuthenticatedAt?: InputMaybe<FilterString>;
  lastSessionRefreshedAt?: InputMaybe<FilterString>;
  not?: InputMaybe<FilterUser>;
  notesAsHtml?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<FilterUser>>;
  pendingAttribution?: InputMaybe<FilterJSON>;
  pendingAttributionExpiresAt?: InputMaybe<FilterString>;
  pendingInviteToken?: InputMaybe<FilterString>;
  pendingInviteTokenExpiresAt?: InputMaybe<FilterString>;
  pendingNateraIntake?: InputMaybe<FilterJSON>;
  persons?: InputMaybe<NestedFilterPerson>;
  primaryEmail?: InputMaybe<FilterString>;
  primaryPerson?: InputMaybe<NestedFilterPerson>;
  profile?: InputMaybe<user__NestedFilterProfile>;
  promoCodeUsages?: InputMaybe<payment__NestedFilterIssuePromoCodeUsage>;
  registrationSource?: InputMaybe<FilterString>;
  segmentationData?: InputMaybe<user__NestedFilterSegmentationData>;
  segments?: InputMaybe<segment__NestedFilterUserSegment>;
  source?: InputMaybe<partner__NestedFilterPartner>;
  stytchId?: InputMaybe<FilterString>;
  tasks?: InputMaybe<taskManagement__NestedFilterTask>;
  templateReleases?: InputMaybe<consent__NestedFilterTemplateRelease>;
  userExitInsuranceLinkFeedback?: InputMaybe<webAgent__NestedFilterUserExitInsuranceLinkFeedback>;
  webAgentLinks?: InputMaybe<webAgent__NestedFilterLink>;
};

export type FilterVerifiable = {
  and?: InputMaybe<Array<FilterVerifiable>>;
  id?: InputMaybe<FilterID>;
  lastVerified?: InputMaybe<FilterString>;
  not?: InputMaybe<FilterVerifiable>;
  or?: InputMaybe<Array<FilterVerifiable>>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type FilterasyncJob__JobStatus = {
  eq?: InputMaybe<asyncJob__JobStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<asyncJob__JobStatus>;
  gte?: InputMaybe<asyncJob__JobStatus>;
  in?: InputMaybe<Array<asyncJob__JobStatus>>;
  lt?: InputMaybe<asyncJob__JobStatus>;
  lte?: InputMaybe<asyncJob__JobStatus>;
  neq?: InputMaybe<asyncJob__JobStatus>;
};

export type FiltercaseFact__FactSource = {
  eq?: InputMaybe<caseFact__FactSource>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<caseFact__FactSource>;
  gte?: InputMaybe<caseFact__FactSource>;
  in?: InputMaybe<Array<caseFact__FactSource>>;
  lt?: InputMaybe<caseFact__FactSource>;
  lte?: InputMaybe<caseFact__FactSource>;
  neq?: InputMaybe<caseFact__FactSource>;
};

export type FiltercaseFact__FactStatus = {
  eq?: InputMaybe<caseFact__FactStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<caseFact__FactStatus>;
  gte?: InputMaybe<caseFact__FactStatus>;
  in?: InputMaybe<Array<caseFact__FactStatus>>;
  lt?: InputMaybe<caseFact__FactStatus>;
  lte?: InputMaybe<caseFact__FactStatus>;
  neq?: InputMaybe<caseFact__FactStatus>;
};

export type FiltercaseRoom__RoomStatus = {
  eq?: InputMaybe<caseRoom__RoomStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<caseRoom__RoomStatus>;
  gte?: InputMaybe<caseRoom__RoomStatus>;
  in?: InputMaybe<Array<caseRoom__RoomStatus>>;
  lt?: InputMaybe<caseRoom__RoomStatus>;
  lte?: InputMaybe<caseRoom__RoomStatus>;
  neq?: InputMaybe<caseRoom__RoomStatus>;
};

export type FiltercaseRoom__TurnStatus = {
  eq?: InputMaybe<caseRoom__TurnStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<caseRoom__TurnStatus>;
  gte?: InputMaybe<caseRoom__TurnStatus>;
  in?: InputMaybe<Array<caseRoom__TurnStatus>>;
  lt?: InputMaybe<caseRoom__TurnStatus>;
  lte?: InputMaybe<caseRoom__TurnStatus>;
  neq?: InputMaybe<caseRoom__TurnStatus>;
};

export type Filterconsent__ConsentType = {
  eq?: InputMaybe<consent__ConsentType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<consent__ConsentType>;
  gte?: InputMaybe<consent__ConsentType>;
  in?: InputMaybe<Array<consent__ConsentType>>;
  lt?: InputMaybe<consent__ConsentType>;
  lte?: InputMaybe<consent__ConsentType>;
  neq?: InputMaybe<consent__ConsentType>;
};

export type Filterdocument__TemplateCounterpartyType = {
  eq?: InputMaybe<document__TemplateCounterpartyType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<document__TemplateCounterpartyType>;
  gte?: InputMaybe<document__TemplateCounterpartyType>;
  in?: InputMaybe<Array<document__TemplateCounterpartyType>>;
  lt?: InputMaybe<document__TemplateCounterpartyType>;
  lte?: InputMaybe<document__TemplateCounterpartyType>;
  neq?: InputMaybe<document__TemplateCounterpartyType>;
};

export type Filterdocument__TemplateType = {
  eq?: InputMaybe<document__TemplateType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<document__TemplateType>;
  gte?: InputMaybe<document__TemplateType>;
  in?: InputMaybe<Array<document__TemplateType>>;
  lt?: InputMaybe<document__TemplateType>;
  lte?: InputMaybe<document__TemplateType>;
  neq?: InputMaybe<document__TemplateType>;
};

export type Filterdocument__UploadEntryPoint = {
  eq?: InputMaybe<document__UploadEntryPoint>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<document__UploadEntryPoint>;
  gte?: InputMaybe<document__UploadEntryPoint>;
  in?: InputMaybe<Array<document__UploadEntryPoint>>;
  lt?: InputMaybe<document__UploadEntryPoint>;
  lte?: InputMaybe<document__UploadEntryPoint>;
  neq?: InputMaybe<document__UploadEntryPoint>;
};

export type Filterdocument__UploadMethod = {
  eq?: InputMaybe<document__UploadMethod>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<document__UploadMethod>;
  gte?: InputMaybe<document__UploadMethod>;
  in?: InputMaybe<Array<document__UploadMethod>>;
  lt?: InputMaybe<document__UploadMethod>;
  lte?: InputMaybe<document__UploadMethod>;
  neq?: InputMaybe<document__UploadMethod>;
};

export type Filterdocument__UploadPlatform = {
  eq?: InputMaybe<document__UploadPlatform>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<document__UploadPlatform>;
  gte?: InputMaybe<document__UploadPlatform>;
  in?: InputMaybe<Array<document__UploadPlatform>>;
  lt?: InputMaybe<document__UploadPlatform>;
  lte?: InputMaybe<document__UploadPlatform>;
  neq?: InputMaybe<document__UploadPlatform>;
};

export type FiltereventTracking__EventType = {
  eq?: InputMaybe<eventTracking__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<eventTracking__EventType>;
  gte?: InputMaybe<eventTracking__EventType>;
  in?: InputMaybe<Array<eventTracking__EventType>>;
  lt?: InputMaybe<eventTracking__EventType>;
  lte?: InputMaybe<eventTracking__EventType>;
  neq?: InputMaybe<eventTracking__EventType>;
};

export type FiltereventTracking__LinkAttemptAbandonedReason = {
  eq?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  gte?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  in?: InputMaybe<Array<eventTracking__LinkAttemptAbandonedReason>>;
  lt?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  lte?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  neq?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
};

export type FiltereventTracking__LinkAttemptStatus = {
  eq?: InputMaybe<eventTracking__LinkAttemptStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<eventTracking__LinkAttemptStatus>;
  gte?: InputMaybe<eventTracking__LinkAttemptStatus>;
  in?: InputMaybe<Array<eventTracking__LinkAttemptStatus>>;
  lt?: InputMaybe<eventTracking__LinkAttemptStatus>;
  lte?: InputMaybe<eventTracking__LinkAttemptStatus>;
  neq?: InputMaybe<eventTracking__LinkAttemptStatus>;
};

export type Filterfa__ApplicationStatus = {
  eq?: InputMaybe<fa__ApplicationStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fa__ApplicationStatus>;
  gte?: InputMaybe<fa__ApplicationStatus>;
  in?: InputMaybe<Array<fa__ApplicationStatus>>;
  lt?: InputMaybe<fa__ApplicationStatus>;
  lte?: InputMaybe<fa__ApplicationStatus>;
  neq?: InputMaybe<fa__ApplicationStatus>;
};

export type Filterfeedback__AreaType = {
  eq?: InputMaybe<feedback__AreaType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<feedback__AreaType>;
  gte?: InputMaybe<feedback__AreaType>;
  in?: InputMaybe<Array<feedback__AreaType>>;
  lt?: InputMaybe<feedback__AreaType>;
  lte?: InputMaybe<feedback__AreaType>;
  neq?: InputMaybe<feedback__AreaType>;
};

export type Filterfeedback__SentimentType = {
  eq?: InputMaybe<feedback__SentimentType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<feedback__SentimentType>;
  gte?: InputMaybe<feedback__SentimentType>;
  in?: InputMaybe<Array<feedback__SentimentType>>;
  lt?: InputMaybe<feedback__SentimentType>;
  lte?: InputMaybe<feedback__SentimentType>;
  neq?: InputMaybe<feedback__SentimentType>;
};

export type FilterfhirEdit__CoverageRelationship = {
  eq?: InputMaybe<fhirEdit__CoverageRelationship>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirEdit__CoverageRelationship>;
  gte?: InputMaybe<fhirEdit__CoverageRelationship>;
  in?: InputMaybe<Array<fhirEdit__CoverageRelationship>>;
  lt?: InputMaybe<fhirEdit__CoverageRelationship>;
  lte?: InputMaybe<fhirEdit__CoverageRelationship>;
  neq?: InputMaybe<fhirEdit__CoverageRelationship>;
};

export type FilterfhirEdit__ExplanationOfBenefitDecision = {
  eq?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  gte?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  in?: InputMaybe<Array<fhirEdit__ExplanationOfBenefitDecision>>;
  lt?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  lte?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
  neq?: InputMaybe<fhirEdit__ExplanationOfBenefitDecision>;
};

export type FilterfhirEdit__ExplanationOfBenefitNetwork = {
  eq?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  gte?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  in?: InputMaybe<Array<fhirEdit__ExplanationOfBenefitNetwork>>;
  lt?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  lte?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
  neq?: InputMaybe<fhirEdit__ExplanationOfBenefitNetwork>;
};

export type FilterfhirEdit__ResourceEditStatus = {
  eq?: InputMaybe<fhirEdit__ResourceEditStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirEdit__ResourceEditStatus>;
  gte?: InputMaybe<fhirEdit__ResourceEditStatus>;
  in?: InputMaybe<Array<fhirEdit__ResourceEditStatus>>;
  lt?: InputMaybe<fhirEdit__ResourceEditStatus>;
  lte?: InputMaybe<fhirEdit__ResourceEditStatus>;
  neq?: InputMaybe<fhirEdit__ResourceEditStatus>;
};

export type Filterfhir__AccountStatus = {
  eq?: InputMaybe<fhir__AccountStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__AccountStatus>;
  gte?: InputMaybe<fhir__AccountStatus>;
  in?: InputMaybe<Array<fhir__AccountStatus>>;
  lt?: InputMaybe<fhir__AccountStatus>;
  lte?: InputMaybe<fhir__AccountStatus>;
  neq?: InputMaybe<fhir__AccountStatus>;
};

export type Filterfhir__ChargeItemStatus = {
  eq?: InputMaybe<fhir__ChargeItemStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__ChargeItemStatus>;
  gte?: InputMaybe<fhir__ChargeItemStatus>;
  in?: InputMaybe<Array<fhir__ChargeItemStatus>>;
  lt?: InputMaybe<fhir__ChargeItemStatus>;
  lte?: InputMaybe<fhir__ChargeItemStatus>;
  neq?: InputMaybe<fhir__ChargeItemStatus>;
};

export type Filterfhir__ClaimUse = {
  eq?: InputMaybe<fhir__ClaimUse>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__ClaimUse>;
  gte?: InputMaybe<fhir__ClaimUse>;
  in?: InputMaybe<Array<fhir__ClaimUse>>;
  lt?: InputMaybe<fhir__ClaimUse>;
  lte?: InputMaybe<fhir__ClaimUse>;
  neq?: InputMaybe<fhir__ClaimUse>;
};

export type Filterfhir__CoverageKind = {
  eq?: InputMaybe<fhir__CoverageKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__CoverageKind>;
  gte?: InputMaybe<fhir__CoverageKind>;
  in?: InputMaybe<Array<fhir__CoverageKind>>;
  lt?: InputMaybe<fhir__CoverageKind>;
  lte?: InputMaybe<fhir__CoverageKind>;
  neq?: InputMaybe<fhir__CoverageKind>;
};

export type Filterfhir__CoverageType = {
  eq?: InputMaybe<fhir__CoverageType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__CoverageType>;
  gte?: InputMaybe<fhir__CoverageType>;
  in?: InputMaybe<Array<fhir__CoverageType>>;
  lt?: InputMaybe<fhir__CoverageType>;
  lte?: InputMaybe<fhir__CoverageType>;
  neq?: InputMaybe<fhir__CoverageType>;
};

export type Filterfhir__ExplanationOfBenefitStatus = {
  eq?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  gte?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  in?: InputMaybe<Array<fhir__ExplanationOfBenefitStatus>>;
  lt?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  lte?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
  neq?: InputMaybe<fhir__ExplanationOfBenefitStatus>;
};

export type Filterfhir__FinancialResourceStatus = {
  eq?: InputMaybe<fhir__FinancialResourceStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__FinancialResourceStatus>;
  gte?: InputMaybe<fhir__FinancialResourceStatus>;
  in?: InputMaybe<Array<fhir__FinancialResourceStatus>>;
  lt?: InputMaybe<fhir__FinancialResourceStatus>;
  lte?: InputMaybe<fhir__FinancialResourceStatus>;
  neq?: InputMaybe<fhir__FinancialResourceStatus>;
};

export type Filterfhir__InvoiceStatus = {
  eq?: InputMaybe<fhir__InvoiceStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__InvoiceStatus>;
  gte?: InputMaybe<fhir__InvoiceStatus>;
  in?: InputMaybe<Array<fhir__InvoiceStatus>>;
  lt?: InputMaybe<fhir__InvoiceStatus>;
  lte?: InputMaybe<fhir__InvoiceStatus>;
  neq?: InputMaybe<fhir__InvoiceStatus>;
};

export type Filterfhir__PriceComponentType = {
  eq?: InputMaybe<fhir__PriceComponentType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhir__PriceComponentType>;
  gte?: InputMaybe<fhir__PriceComponentType>;
  in?: InputMaybe<Array<fhir__PriceComponentType>>;
  lt?: InputMaybe<fhir__PriceComponentType>;
  lte?: InputMaybe<fhir__PriceComponentType>;
  neq?: InputMaybe<fhir__PriceComponentType>;
};

export type Filterfhirext__FindingType = {
  eq?: InputMaybe<fhirext__FindingType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirext__FindingType>;
  gte?: InputMaybe<fhirext__FindingType>;
  in?: InputMaybe<Array<fhirext__FindingType>>;
  lt?: InputMaybe<fhirext__FindingType>;
  lte?: InputMaybe<fhirext__FindingType>;
  neq?: InputMaybe<fhirext__FindingType>;
};

export type Filterfhirext__ResourceType = {
  eq?: InputMaybe<fhirext__ResourceType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirext__ResourceType>;
  gte?: InputMaybe<fhirext__ResourceType>;
  in?: InputMaybe<Array<fhirext__ResourceType>>;
  lt?: InputMaybe<fhirext__ResourceType>;
  lte?: InputMaybe<fhirext__ResourceType>;
  neq?: InputMaybe<fhirext__ResourceType>;
};

export type Filterfhirext__ReviewStatus = {
  eq?: InputMaybe<fhirext__ReviewStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<fhirext__ReviewStatus>;
  gte?: InputMaybe<fhirext__ReviewStatus>;
  in?: InputMaybe<Array<fhirext__ReviewStatus>>;
  lt?: InputMaybe<fhirext__ReviewStatus>;
  lte?: InputMaybe<fhirext__ReviewStatus>;
  neq?: InputMaybe<fhirext__ReviewStatus>;
};

export type Filterflexpa__EndpointMode = {
  eq?: InputMaybe<flexpa__EndpointMode>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<flexpa__EndpointMode>;
  gte?: InputMaybe<flexpa__EndpointMode>;
  in?: InputMaybe<Array<flexpa__EndpointMode>>;
  lt?: InputMaybe<flexpa__EndpointMode>;
  lte?: InputMaybe<flexpa__EndpointMode>;
  neq?: InputMaybe<flexpa__EndpointMode>;
};

export type Filterflexpa__FlexpaImportStatus = {
  eq?: InputMaybe<flexpa__FlexpaImportStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<flexpa__FlexpaImportStatus>;
  gte?: InputMaybe<flexpa__FlexpaImportStatus>;
  in?: InputMaybe<Array<flexpa__FlexpaImportStatus>>;
  lt?: InputMaybe<flexpa__FlexpaImportStatus>;
  lte?: InputMaybe<flexpa__FlexpaImportStatus>;
  neq?: InputMaybe<flexpa__FlexpaImportStatus>;
};

export type Filterflexpa__LinkDeactivatedReason = {
  eq?: InputMaybe<flexpa__LinkDeactivatedReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<flexpa__LinkDeactivatedReason>;
  gte?: InputMaybe<flexpa__LinkDeactivatedReason>;
  in?: InputMaybe<Array<flexpa__LinkDeactivatedReason>>;
  lt?: InputMaybe<flexpa__LinkDeactivatedReason>;
  lte?: InputMaybe<flexpa__LinkDeactivatedReason>;
  neq?: InputMaybe<flexpa__LinkDeactivatedReason>;
};

export type Filterflexpa__OrganizationType = {
  eq?: InputMaybe<flexpa__OrganizationType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<flexpa__OrganizationType>;
  gte?: InputMaybe<flexpa__OrganizationType>;
  in?: InputMaybe<Array<flexpa__OrganizationType>>;
  lt?: InputMaybe<flexpa__OrganizationType>;
  lte?: InputMaybe<flexpa__OrganizationType>;
  neq?: InputMaybe<flexpa__OrganizationType>;
};

export type Filterforecasting__BenchmarkRunStatus = {
  eq?: InputMaybe<forecasting__BenchmarkRunStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<forecasting__BenchmarkRunStatus>;
  gte?: InputMaybe<forecasting__BenchmarkRunStatus>;
  in?: InputMaybe<Array<forecasting__BenchmarkRunStatus>>;
  lt?: InputMaybe<forecasting__BenchmarkRunStatus>;
  lte?: InputMaybe<forecasting__BenchmarkRunStatus>;
  neq?: InputMaybe<forecasting__BenchmarkRunStatus>;
};

export type Filterforecasting__ForecastSegment = {
  eq?: InputMaybe<forecasting__ForecastSegment>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<forecasting__ForecastSegment>;
  gte?: InputMaybe<forecasting__ForecastSegment>;
  in?: InputMaybe<Array<forecasting__ForecastSegment>>;
  lt?: InputMaybe<forecasting__ForecastSegment>;
  lte?: InputMaybe<forecasting__ForecastSegment>;
  neq?: InputMaybe<forecasting__ForecastSegment>;
};

export type Filteringestion__DistillationStatus = {
  eq?: InputMaybe<ingestion__DistillationStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__DistillationStatus>;
  gte?: InputMaybe<ingestion__DistillationStatus>;
  in?: InputMaybe<Array<ingestion__DistillationStatus>>;
  lt?: InputMaybe<ingestion__DistillationStatus>;
  lte?: InputMaybe<ingestion__DistillationStatus>;
  neq?: InputMaybe<ingestion__DistillationStatus>;
};

export type Filteringestion__ExtractionType = {
  eq?: InputMaybe<ingestion__ExtractionType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__ExtractionType>;
  gte?: InputMaybe<ingestion__ExtractionType>;
  in?: InputMaybe<Array<ingestion__ExtractionType>>;
  lt?: InputMaybe<ingestion__ExtractionType>;
  lte?: InputMaybe<ingestion__ExtractionType>;
  neq?: InputMaybe<ingestion__ExtractionType>;
};

export type Filteringestion__IngestionStatus = {
  eq?: InputMaybe<ingestion__IngestionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__IngestionStatus>;
  gte?: InputMaybe<ingestion__IngestionStatus>;
  in?: InputMaybe<Array<ingestion__IngestionStatus>>;
  lt?: InputMaybe<ingestion__IngestionStatus>;
  lte?: InputMaybe<ingestion__IngestionStatus>;
  neq?: InputMaybe<ingestion__IngestionStatus>;
};

export type Filteringestion__IngestionStepType = {
  eq?: InputMaybe<ingestion__IngestionStepType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__IngestionStepType>;
  gte?: InputMaybe<ingestion__IngestionStepType>;
  in?: InputMaybe<Array<ingestion__IngestionStepType>>;
  lt?: InputMaybe<ingestion__IngestionStepType>;
  lte?: InputMaybe<ingestion__IngestionStepType>;
  neq?: InputMaybe<ingestion__IngestionStepType>;
};

export type Filteringestion__IngestionStrategy = {
  eq?: InputMaybe<ingestion__IngestionStrategy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__IngestionStrategy>;
  gte?: InputMaybe<ingestion__IngestionStrategy>;
  in?: InputMaybe<Array<ingestion__IngestionStrategy>>;
  lt?: InputMaybe<ingestion__IngestionStrategy>;
  lte?: InputMaybe<ingestion__IngestionStrategy>;
  neq?: InputMaybe<ingestion__IngestionStrategy>;
};

export type Filteringestion__ResolutionStatus = {
  eq?: InputMaybe<ingestion__ResolutionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<ingestion__ResolutionStatus>;
  gte?: InputMaybe<ingestion__ResolutionStatus>;
  in?: InputMaybe<Array<ingestion__ResolutionStatus>>;
  lt?: InputMaybe<ingestion__ResolutionStatus>;
  lte?: InputMaybe<ingestion__ResolutionStatus>;
  neq?: InputMaybe<ingestion__ResolutionStatus>;
};

export type Filterissue__DocumentAnalysisStatus = {
  eq?: InputMaybe<issue__DocumentAnalysisStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__DocumentAnalysisStatus>;
  gte?: InputMaybe<issue__DocumentAnalysisStatus>;
  in?: InputMaybe<Array<issue__DocumentAnalysisStatus>>;
  lt?: InputMaybe<issue__DocumentAnalysisStatus>;
  lte?: InputMaybe<issue__DocumentAnalysisStatus>;
  neq?: InputMaybe<issue__DocumentAnalysisStatus>;
};

export type Filterissue__DocumentClassificationStatus = {
  eq?: InputMaybe<issue__DocumentClassificationStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__DocumentClassificationStatus>;
  gte?: InputMaybe<issue__DocumentClassificationStatus>;
  in?: InputMaybe<Array<issue__DocumentClassificationStatus>>;
  lt?: InputMaybe<issue__DocumentClassificationStatus>;
  lte?: InputMaybe<issue__DocumentClassificationStatus>;
  neq?: InputMaybe<issue__DocumentClassificationStatus>;
};

export type Filterissue__EventType = {
  eq?: InputMaybe<issue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__EventType>;
  gte?: InputMaybe<issue__EventType>;
  in?: InputMaybe<Array<issue__EventType>>;
  lt?: InputMaybe<issue__EventType>;
  lte?: InputMaybe<issue__EventType>;
  neq?: InputMaybe<issue__EventType>;
};

export type Filterissue__InputOutcome = {
  eq?: InputMaybe<issue__InputOutcome>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__InputOutcome>;
  gte?: InputMaybe<issue__InputOutcome>;
  in?: InputMaybe<Array<issue__InputOutcome>>;
  lt?: InputMaybe<issue__InputOutcome>;
  lte?: InputMaybe<issue__InputOutcome>;
  neq?: InputMaybe<issue__InputOutcome>;
};

export type Filterissue__PaymentAgreementContract = {
  eq?: InputMaybe<issue__PaymentAgreementContract>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__PaymentAgreementContract>;
  gte?: InputMaybe<issue__PaymentAgreementContract>;
  in?: InputMaybe<Array<issue__PaymentAgreementContract>>;
  lt?: InputMaybe<issue__PaymentAgreementContract>;
  lte?: InputMaybe<issue__PaymentAgreementContract>;
  neq?: InputMaybe<issue__PaymentAgreementContract>;
};

export type Filterissue__PaymentCaseType = {
  eq?: InputMaybe<issue__PaymentCaseType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__PaymentCaseType>;
  gte?: InputMaybe<issue__PaymentCaseType>;
  in?: InputMaybe<Array<issue__PaymentCaseType>>;
  lt?: InputMaybe<issue__PaymentCaseType>;
  lte?: InputMaybe<issue__PaymentCaseType>;
  neq?: InputMaybe<issue__PaymentCaseType>;
};

export type Filterissue__PaymentChargeResolvedReason = {
  eq?: InputMaybe<issue__PaymentChargeResolvedReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__PaymentChargeResolvedReason>;
  gte?: InputMaybe<issue__PaymentChargeResolvedReason>;
  in?: InputMaybe<Array<issue__PaymentChargeResolvedReason>>;
  lt?: InputMaybe<issue__PaymentChargeResolvedReason>;
  lte?: InputMaybe<issue__PaymentChargeResolvedReason>;
  neq?: InputMaybe<issue__PaymentChargeResolvedReason>;
};

export type Filterissue__PreAuthStatus = {
  eq?: InputMaybe<issue__PreAuthStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__PreAuthStatus>;
  gte?: InputMaybe<issue__PreAuthStatus>;
  in?: InputMaybe<Array<issue__PreAuthStatus>>;
  lt?: InputMaybe<issue__PreAuthStatus>;
  lte?: InputMaybe<issue__PreAuthStatus>;
  neq?: InputMaybe<issue__PreAuthStatus>;
};

export type Filterissue__PriorityOverride = {
  eq?: InputMaybe<issue__PriorityOverride>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__PriorityOverride>;
  gte?: InputMaybe<issue__PriorityOverride>;
  in?: InputMaybe<Array<issue__PriorityOverride>>;
  lt?: InputMaybe<issue__PriorityOverride>;
  lte?: InputMaybe<issue__PriorityOverride>;
  neq?: InputMaybe<issue__PriorityOverride>;
};

export type Filterissue__ProviderRelationship = {
  eq?: InputMaybe<issue__ProviderRelationship>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__ProviderRelationship>;
  gte?: InputMaybe<issue__ProviderRelationship>;
  in?: InputMaybe<Array<issue__ProviderRelationship>>;
  lt?: InputMaybe<issue__ProviderRelationship>;
  lte?: InputMaybe<issue__ProviderRelationship>;
  neq?: InputMaybe<issue__ProviderRelationship>;
};

export type Filterissue__ReengagementReason = {
  eq?: InputMaybe<issue__ReengagementReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__ReengagementReason>;
  gte?: InputMaybe<issue__ReengagementReason>;
  in?: InputMaybe<Array<issue__ReengagementReason>>;
  lt?: InputMaybe<issue__ReengagementReason>;
  lte?: InputMaybe<issue__ReengagementReason>;
  neq?: InputMaybe<issue__ReengagementReason>;
};

export type Filterissue__SavingsPreference = {
  eq?: InputMaybe<issue__SavingsPreference>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__SavingsPreference>;
  gte?: InputMaybe<issue__SavingsPreference>;
  in?: InputMaybe<Array<issue__SavingsPreference>>;
  lt?: InputMaybe<issue__SavingsPreference>;
  lte?: InputMaybe<issue__SavingsPreference>;
  neq?: InputMaybe<issue__SavingsPreference>;
};

export type Filterissue__UserClosureReason = {
  eq?: InputMaybe<issue__UserClosureReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<issue__UserClosureReason>;
  gte?: InputMaybe<issue__UserClosureReason>;
  in?: InputMaybe<Array<issue__UserClosureReason>>;
  lt?: InputMaybe<issue__UserClosureReason>;
  lte?: InputMaybe<issue__UserClosureReason>;
  neq?: InputMaybe<issue__UserClosureReason>;
};

export type FiltermodelExecution__LLMProvider = {
  eq?: InputMaybe<modelExecution__LLMProvider>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<modelExecution__LLMProvider>;
  gte?: InputMaybe<modelExecution__LLMProvider>;
  in?: InputMaybe<Array<modelExecution__LLMProvider>>;
  lt?: InputMaybe<modelExecution__LLMProvider>;
  lte?: InputMaybe<modelExecution__LLMProvider>;
  neq?: InputMaybe<modelExecution__LLMProvider>;
};

export type FilterpayerSync__ChangeKind = {
  eq?: InputMaybe<payerSync__ChangeKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<payerSync__ChangeKind>;
  gte?: InputMaybe<payerSync__ChangeKind>;
  in?: InputMaybe<Array<payerSync__ChangeKind>>;
  lt?: InputMaybe<payerSync__ChangeKind>;
  lte?: InputMaybe<payerSync__ChangeKind>;
  neq?: InputMaybe<payerSync__ChangeKind>;
};

export type FilterpayerSync__RunStatus = {
  eq?: InputMaybe<payerSync__RunStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<payerSync__RunStatus>;
  gte?: InputMaybe<payerSync__RunStatus>;
  in?: InputMaybe<Array<payerSync__RunStatus>>;
  lt?: InputMaybe<payerSync__RunStatus>;
  lte?: InputMaybe<payerSync__RunStatus>;
  neq?: InputMaybe<payerSync__RunStatus>;
};

export type Filterpayer__Transaction = {
  eq?: InputMaybe<payer__Transaction>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<payer__Transaction>;
  gte?: InputMaybe<payer__Transaction>;
  in?: InputMaybe<Array<payer__Transaction>>;
  lt?: InputMaybe<payer__Transaction>;
  lte?: InputMaybe<payer__Transaction>;
  neq?: InputMaybe<payer__Transaction>;
};

export type Filterpayment__PaymentStatus = {
  eq?: InputMaybe<payment__PaymentStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<payment__PaymentStatus>;
  gte?: InputMaybe<payment__PaymentStatus>;
  in?: InputMaybe<Array<payment__PaymentStatus>>;
  lt?: InputMaybe<payment__PaymentStatus>;
  lte?: InputMaybe<payment__PaymentStatus>;
  neq?: InputMaybe<payment__PaymentStatus>;
};

export type Filterpayment__PaymentTransactionType = {
  eq?: InputMaybe<payment__PaymentTransactionType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<payment__PaymentTransactionType>;
  gte?: InputMaybe<payment__PaymentTransactionType>;
  in?: InputMaybe<Array<payment__PaymentTransactionType>>;
  lt?: InputMaybe<payment__PaymentTransactionType>;
  lte?: InputMaybe<payment__PaymentTransactionType>;
  neq?: InputMaybe<payment__PaymentTransactionType>;
};

export type Filterpayment__SubscriptionStatus = {
  eq?: InputMaybe<payment__SubscriptionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<payment__SubscriptionStatus>;
  gte?: InputMaybe<payment__SubscriptionStatus>;
  in?: InputMaybe<Array<payment__SubscriptionStatus>>;
  lt?: InputMaybe<payment__SubscriptionStatus>;
  lte?: InputMaybe<payment__SubscriptionStatus>;
  neq?: InputMaybe<payment__SubscriptionStatus>;
};

export type Filterplan__PlanStatus = {
  eq?: InputMaybe<plan__PlanStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<plan__PlanStatus>;
  gte?: InputMaybe<plan__PlanStatus>;
  in?: InputMaybe<Array<plan__PlanStatus>>;
  lt?: InputMaybe<plan__PlanStatus>;
  lte?: InputMaybe<plan__PlanStatus>;
  neq?: InputMaybe<plan__PlanStatus>;
};

export type Filterplan__PlanType = {
  eq?: InputMaybe<plan__PlanType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<plan__PlanType>;
  gte?: InputMaybe<plan__PlanType>;
  in?: InputMaybe<Array<plan__PlanType>>;
  lt?: InputMaybe<plan__PlanType>;
  lte?: InputMaybe<plan__PlanType>;
  neq?: InputMaybe<plan__PlanType>;
};

export type Filterprojection__BenefitPositionKind = {
  eq?: InputMaybe<projection__BenefitPositionKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__BenefitPositionKind>;
  gte?: InputMaybe<projection__BenefitPositionKind>;
  in?: InputMaybe<Array<projection__BenefitPositionKind>>;
  lt?: InputMaybe<projection__BenefitPositionKind>;
  lte?: InputMaybe<projection__BenefitPositionKind>;
  neq?: InputMaybe<projection__BenefitPositionKind>;
};

export type Filterprojection__BenefitPositionNetwork = {
  eq?: InputMaybe<projection__BenefitPositionNetwork>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__BenefitPositionNetwork>;
  gte?: InputMaybe<projection__BenefitPositionNetwork>;
  in?: InputMaybe<Array<projection__BenefitPositionNetwork>>;
  lt?: InputMaybe<projection__BenefitPositionNetwork>;
  lte?: InputMaybe<projection__BenefitPositionNetwork>;
  neq?: InputMaybe<projection__BenefitPositionNetwork>;
};

export type Filterprojection__BenefitPositionObservation = {
  eq?: InputMaybe<projection__BenefitPositionObservation>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__BenefitPositionObservation>;
  gte?: InputMaybe<projection__BenefitPositionObservation>;
  in?: InputMaybe<Array<projection__BenefitPositionObservation>>;
  lt?: InputMaybe<projection__BenefitPositionObservation>;
  lte?: InputMaybe<projection__BenefitPositionObservation>;
  neq?: InputMaybe<projection__BenefitPositionObservation>;
};

export type Filterprojection__BenefitPositionScope = {
  eq?: InputMaybe<projection__BenefitPositionScope>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__BenefitPositionScope>;
  gte?: InputMaybe<projection__BenefitPositionScope>;
  in?: InputMaybe<Array<projection__BenefitPositionScope>>;
  lt?: InputMaybe<projection__BenefitPositionScope>;
  lte?: InputMaybe<projection__BenefitPositionScope>;
  neq?: InputMaybe<projection__BenefitPositionScope>;
};

export type Filterprojection__CaseLifecycle = {
  eq?: InputMaybe<projection__CaseLifecycle>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__CaseLifecycle>;
  gte?: InputMaybe<projection__CaseLifecycle>;
  in?: InputMaybe<Array<projection__CaseLifecycle>>;
  lt?: InputMaybe<projection__CaseLifecycle>;
  lte?: InputMaybe<projection__CaseLifecycle>;
  neq?: InputMaybe<projection__CaseLifecycle>;
};

export type Filterprojection__CaseWaitingActor = {
  eq?: InputMaybe<projection__CaseWaitingActor>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__CaseWaitingActor>;
  gte?: InputMaybe<projection__CaseWaitingActor>;
  in?: InputMaybe<Array<projection__CaseWaitingActor>>;
  lt?: InputMaybe<projection__CaseWaitingActor>;
  lte?: InputMaybe<projection__CaseWaitingActor>;
  neq?: InputMaybe<projection__CaseWaitingActor>;
};

export type Filterprojection__CdpProvider = {
  eq?: InputMaybe<projection__CdpProvider>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__CdpProvider>;
  gte?: InputMaybe<projection__CdpProvider>;
  in?: InputMaybe<Array<projection__CdpProvider>>;
  lt?: InputMaybe<projection__CdpProvider>;
  lte?: InputMaybe<projection__CdpProvider>;
  neq?: InputMaybe<projection__CdpProvider>;
};

export type Filterprojection__EligibilityCheckDispatchReason = {
  eq?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  gte?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  in?: InputMaybe<Array<projection__EligibilityCheckDispatchReason>>;
  lt?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  lte?: InputMaybe<projection__EligibilityCheckDispatchReason>;
  neq?: InputMaybe<projection__EligibilityCheckDispatchReason>;
};

export type Filterprojection__EligibilityCheckOutcome = {
  eq?: InputMaybe<projection__EligibilityCheckOutcome>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__EligibilityCheckOutcome>;
  gte?: InputMaybe<projection__EligibilityCheckOutcome>;
  in?: InputMaybe<Array<projection__EligibilityCheckOutcome>>;
  lt?: InputMaybe<projection__EligibilityCheckOutcome>;
  lte?: InputMaybe<projection__EligibilityCheckOutcome>;
  neq?: InputMaybe<projection__EligibilityCheckOutcome>;
};

export type Filterprojection__EnrichmentConfidence = {
  eq?: InputMaybe<projection__EnrichmentConfidence>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__EnrichmentConfidence>;
  gte?: InputMaybe<projection__EnrichmentConfidence>;
  in?: InputMaybe<Array<projection__EnrichmentConfidence>>;
  lt?: InputMaybe<projection__EnrichmentConfidence>;
  lte?: InputMaybe<projection__EnrichmentConfidence>;
  neq?: InputMaybe<projection__EnrichmentConfidence>;
};

export type Filterprojection__EnrichmentPriceRating = {
  eq?: InputMaybe<projection__EnrichmentPriceRating>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__EnrichmentPriceRating>;
  gte?: InputMaybe<projection__EnrichmentPriceRating>;
  in?: InputMaybe<Array<projection__EnrichmentPriceRating>>;
  lt?: InputMaybe<projection__EnrichmentPriceRating>;
  lte?: InputMaybe<projection__EnrichmentPriceRating>;
  neq?: InputMaybe<projection__EnrichmentPriceRating>;
};

export type Filterprojection__InsuranceDiscoveryOutcome = {
  eq?: InputMaybe<projection__InsuranceDiscoveryOutcome>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__InsuranceDiscoveryOutcome>;
  gte?: InputMaybe<projection__InsuranceDiscoveryOutcome>;
  in?: InputMaybe<Array<projection__InsuranceDiscoveryOutcome>>;
  lt?: InputMaybe<projection__InsuranceDiscoveryOutcome>;
  lte?: InputMaybe<projection__InsuranceDiscoveryOutcome>;
  neq?: InputMaybe<projection__InsuranceDiscoveryOutcome>;
};

export type Filterprojection__InsuranceDiscoveryTrigger = {
  eq?: InputMaybe<projection__InsuranceDiscoveryTrigger>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__InsuranceDiscoveryTrigger>;
  gte?: InputMaybe<projection__InsuranceDiscoveryTrigger>;
  in?: InputMaybe<Array<projection__InsuranceDiscoveryTrigger>>;
  lt?: InputMaybe<projection__InsuranceDiscoveryTrigger>;
  lte?: InputMaybe<projection__InsuranceDiscoveryTrigger>;
  neq?: InputMaybe<projection__InsuranceDiscoveryTrigger>;
};

export type Filterprojection__ProviderSetBy = {
  eq?: InputMaybe<projection__ProviderSetBy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__ProviderSetBy>;
  gte?: InputMaybe<projection__ProviderSetBy>;
  in?: InputMaybe<Array<projection__ProviderSetBy>>;
  lt?: InputMaybe<projection__ProviderSetBy>;
  lte?: InputMaybe<projection__ProviderSetBy>;
  neq?: InputMaybe<projection__ProviderSetBy>;
};

export type Filterprojection__ProxyOrigin = {
  eq?: InputMaybe<projection__ProxyOrigin>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__ProxyOrigin>;
  gte?: InputMaybe<projection__ProxyOrigin>;
  in?: InputMaybe<Array<projection__ProxyOrigin>>;
  lt?: InputMaybe<projection__ProxyOrigin>;
  lte?: InputMaybe<projection__ProxyOrigin>;
  neq?: InputMaybe<projection__ProxyOrigin>;
};

export type Filterprojection__ProxyStrategy = {
  eq?: InputMaybe<projection__ProxyStrategy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__ProxyStrategy>;
  gte?: InputMaybe<projection__ProxyStrategy>;
  in?: InputMaybe<Array<projection__ProxyStrategy>>;
  lt?: InputMaybe<projection__ProxyStrategy>;
  lte?: InputMaybe<projection__ProxyStrategy>;
  neq?: InputMaybe<projection__ProxyStrategy>;
};

export type Filterprojection__RequirementKind = {
  eq?: InputMaybe<projection__RequirementKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RequirementKind>;
  gte?: InputMaybe<projection__RequirementKind>;
  in?: InputMaybe<Array<projection__RequirementKind>>;
  lt?: InputMaybe<projection__RequirementKind>;
  lte?: InputMaybe<projection__RequirementKind>;
  neq?: InputMaybe<projection__RequirementKind>;
};

export type Filterprojection__RequirementTargetType = {
  eq?: InputMaybe<projection__RequirementTargetType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RequirementTargetType>;
  gte?: InputMaybe<projection__RequirementTargetType>;
  in?: InputMaybe<Array<projection__RequirementTargetType>>;
  lt?: InputMaybe<projection__RequirementTargetType>;
  lte?: InputMaybe<projection__RequirementTargetType>;
  neq?: InputMaybe<projection__RequirementTargetType>;
};

export type Filterprojection__RpaConnectionStatus = {
  eq?: InputMaybe<projection__RpaConnectionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RpaConnectionStatus>;
  gte?: InputMaybe<projection__RpaConnectionStatus>;
  in?: InputMaybe<Array<projection__RpaConnectionStatus>>;
  lt?: InputMaybe<projection__RpaConnectionStatus>;
  lte?: InputMaybe<projection__RpaConnectionStatus>;
  neq?: InputMaybe<projection__RpaConnectionStatus>;
};

export type Filterprojection__RpaSessionStatus = {
  eq?: InputMaybe<projection__RpaSessionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RpaSessionStatus>;
  gte?: InputMaybe<projection__RpaSessionStatus>;
  in?: InputMaybe<Array<projection__RpaSessionStatus>>;
  lt?: InputMaybe<projection__RpaSessionStatus>;
  lte?: InputMaybe<projection__RpaSessionStatus>;
  neq?: InputMaybe<projection__RpaSessionStatus>;
};

export type Filterprojection__RpaTaskKind = {
  eq?: InputMaybe<projection__RpaTaskKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RpaTaskKind>;
  gte?: InputMaybe<projection__RpaTaskKind>;
  in?: InputMaybe<Array<projection__RpaTaskKind>>;
  lt?: InputMaybe<projection__RpaTaskKind>;
  lte?: InputMaybe<projection__RpaTaskKind>;
  neq?: InputMaybe<projection__RpaTaskKind>;
};

export type Filterprojection__RpaTaskStatus = {
  eq?: InputMaybe<projection__RpaTaskStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__RpaTaskStatus>;
  gte?: InputMaybe<projection__RpaTaskStatus>;
  in?: InputMaybe<Array<projection__RpaTaskStatus>>;
  lt?: InputMaybe<projection__RpaTaskStatus>;
  lte?: InputMaybe<projection__RpaTaskStatus>;
  neq?: InputMaybe<projection__RpaTaskStatus>;
};

export type Filterprojection__StealthStrategy = {
  eq?: InputMaybe<projection__StealthStrategy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<projection__StealthStrategy>;
  gte?: InputMaybe<projection__StealthStrategy>;
  in?: InputMaybe<Array<projection__StealthStrategy>>;
  lt?: InputMaybe<projection__StealthStrategy>;
  lte?: InputMaybe<projection__StealthStrategy>;
  neq?: InputMaybe<projection__StealthStrategy>;
};

export type Filterprovider__ContactKind = {
  eq?: InputMaybe<provider__ContactKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__ContactKind>;
  gte?: InputMaybe<provider__ContactKind>;
  in?: InputMaybe<Array<provider__ContactKind>>;
  lt?: InputMaybe<provider__ContactKind>;
  lte?: InputMaybe<provider__ContactKind>;
  neq?: InputMaybe<provider__ContactKind>;
};

export type Filterprovider__ContactPurpose = {
  eq?: InputMaybe<provider__ContactPurpose>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__ContactPurpose>;
  gte?: InputMaybe<provider__ContactPurpose>;
  in?: InputMaybe<Array<provider__ContactPurpose>>;
  lt?: InputMaybe<provider__ContactPurpose>;
  lte?: InputMaybe<provider__ContactPurpose>;
  neq?: InputMaybe<provider__ContactPurpose>;
};

export type Filterprovider__FormType = {
  eq?: InputMaybe<provider__FormType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__FormType>;
  gte?: InputMaybe<provider__FormType>;
  in?: InputMaybe<Array<provider__FormType>>;
  lt?: InputMaybe<provider__FormType>;
  lte?: InputMaybe<provider__FormType>;
  neq?: InputMaybe<provider__FormType>;
};

export type Filterprovider__NegotiationStance = {
  eq?: InputMaybe<provider__NegotiationStance>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__NegotiationStance>;
  gte?: InputMaybe<provider__NegotiationStance>;
  in?: InputMaybe<Array<provider__NegotiationStance>>;
  lt?: InputMaybe<provider__NegotiationStance>;
  lte?: InputMaybe<provider__NegotiationStance>;
  neq?: InputMaybe<provider__NegotiationStance>;
};

export type Filterprovider__Ownership = {
  eq?: InputMaybe<provider__Ownership>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__Ownership>;
  gte?: InputMaybe<provider__Ownership>;
  in?: InputMaybe<Array<provider__Ownership>>;
  lt?: InputMaybe<provider__Ownership>;
  lte?: InputMaybe<provider__Ownership>;
  neq?: InputMaybe<provider__Ownership>;
};

export type Filterprovider__ProviderKind = {
  eq?: InputMaybe<provider__ProviderKind>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__ProviderKind>;
  gte?: InputMaybe<provider__ProviderKind>;
  in?: InputMaybe<Array<provider__ProviderKind>>;
  lt?: InputMaybe<provider__ProviderKind>;
  lte?: InputMaybe<provider__ProviderKind>;
  neq?: InputMaybe<provider__ProviderKind>;
};

export type Filterprovider__ResearchRunStatus = {
  eq?: InputMaybe<provider__ResearchRunStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__ResearchRunStatus>;
  gte?: InputMaybe<provider__ResearchRunStatus>;
  in?: InputMaybe<Array<provider__ResearchRunStatus>>;
  lt?: InputMaybe<provider__ResearchRunStatus>;
  lte?: InputMaybe<provider__ResearchRunStatus>;
  neq?: InputMaybe<provider__ResearchRunStatus>;
};

export type Filterprovider__Source = {
  eq?: InputMaybe<provider__Source>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__Source>;
  gte?: InputMaybe<provider__Source>;
  in?: InputMaybe<Array<provider__Source>>;
  lt?: InputMaybe<provider__Source>;
  lte?: InputMaybe<provider__Source>;
  neq?: InputMaybe<provider__Source>;
};

export type Filterprovider__SubmissionChannel = {
  eq?: InputMaybe<provider__SubmissionChannel>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<provider__SubmissionChannel>;
  gte?: InputMaybe<provider__SubmissionChannel>;
  in?: InputMaybe<Array<provider__SubmissionChannel>>;
  lt?: InputMaybe<provider__SubmissionChannel>;
  lte?: InputMaybe<provider__SubmissionChannel>;
  neq?: InputMaybe<provider__SubmissionChannel>;
};

export type Filtersegment__SegmentSource = {
  eq?: InputMaybe<segment__SegmentSource>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<segment__SegmentSource>;
  gte?: InputMaybe<segment__SegmentSource>;
  in?: InputMaybe<Array<segment__SegmentSource>>;
  lt?: InputMaybe<segment__SegmentSource>;
  lte?: InputMaybe<segment__SegmentSource>;
  neq?: InputMaybe<segment__SegmentSource>;
};

export type Filtersegment__SegmentStatus = {
  eq?: InputMaybe<segment__SegmentStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<segment__SegmentStatus>;
  gte?: InputMaybe<segment__SegmentStatus>;
  in?: InputMaybe<Array<segment__SegmentStatus>>;
  lt?: InputMaybe<segment__SegmentStatus>;
  lte?: InputMaybe<segment__SegmentStatus>;
  neq?: InputMaybe<segment__SegmentStatus>;
};

export type Filtersuggestion__SuggestedActionStatus = {
  eq?: InputMaybe<suggestion__SuggestedActionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<suggestion__SuggestedActionStatus>;
  gte?: InputMaybe<suggestion__SuggestedActionStatus>;
  in?: InputMaybe<Array<suggestion__SuggestedActionStatus>>;
  lt?: InputMaybe<suggestion__SuggestedActionStatus>;
  lte?: InputMaybe<suggestion__SuggestedActionStatus>;
  neq?: InputMaybe<suggestion__SuggestedActionStatus>;
};

export type FiltertaskManagement__TaskStatus = {
  eq?: InputMaybe<taskManagement__TaskStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<taskManagement__TaskStatus>;
  gte?: InputMaybe<taskManagement__TaskStatus>;
  in?: InputMaybe<Array<taskManagement__TaskStatus>>;
  lt?: InputMaybe<taskManagement__TaskStatus>;
  lte?: InputMaybe<taskManagement__TaskStatus>;
  neq?: InputMaybe<taskManagement__TaskStatus>;
};

export type FiltertaskManagement__TaskType = {
  eq?: InputMaybe<taskManagement__TaskType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<taskManagement__TaskType>;
  gte?: InputMaybe<taskManagement__TaskType>;
  in?: InputMaybe<Array<taskManagement__TaskType>>;
  lt?: InputMaybe<taskManagement__TaskType>;
  lte?: InputMaybe<taskManagement__TaskType>;
  neq?: InputMaybe<taskManagement__TaskType>;
};

export type FilterwebAgent__AiDiscoveryCrawlObjectiveResult = {
  eq?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  gte?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  in?: InputMaybe<Array<webAgent__AiDiscoveryCrawlObjectiveResult>>;
  lt?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  lte?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  neq?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
};

export type FilterwebAgent__AiDiscoveryCrawlObjectiveType = {
  eq?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  gte?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  in?: InputMaybe<Array<webAgent__AiDiscoveryCrawlObjectiveType>>;
  lt?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  lte?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
  neq?: InputMaybe<webAgent__AiDiscoveryCrawlObjectiveType>;
};

export type FilterwebAgent__AiDiscoveryCrawlStatus = {
  eq?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  gte?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  in?: InputMaybe<Array<webAgent__AiDiscoveryCrawlStatus>>;
  lt?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  lte?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
  neq?: InputMaybe<webAgent__AiDiscoveryCrawlStatus>;
};

export type FilterwebAgent__BrowserbaseStealthStrategy = {
  eq?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  gte?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  in?: InputMaybe<Array<webAgent__BrowserbaseStealthStrategy>>;
  lt?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  lte?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
  neq?: InputMaybe<webAgent__BrowserbaseStealthStrategy>;
};

export type FilterwebAgent__CDPProvider = {
  eq?: InputMaybe<webAgent__CDPProvider>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__CDPProvider>;
  gte?: InputMaybe<webAgent__CDPProvider>;
  in?: InputMaybe<Array<webAgent__CDPProvider>>;
  lt?: InputMaybe<webAgent__CDPProvider>;
  lte?: InputMaybe<webAgent__CDPProvider>;
  neq?: InputMaybe<webAgent__CDPProvider>;
};

export type FilterwebAgent__CrawlType = {
  eq?: InputMaybe<webAgent__CrawlType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__CrawlType>;
  gte?: InputMaybe<webAgent__CrawlType>;
  in?: InputMaybe<Array<webAgent__CrawlType>>;
  lt?: InputMaybe<webAgent__CrawlType>;
  lte?: InputMaybe<webAgent__CrawlType>;
  neq?: InputMaybe<webAgent__CrawlType>;
};

export type FilterwebAgent__EndpointSupportLevel = {
  eq?: InputMaybe<webAgent__EndpointSupportLevel>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__EndpointSupportLevel>;
  gte?: InputMaybe<webAgent__EndpointSupportLevel>;
  in?: InputMaybe<Array<webAgent__EndpointSupportLevel>>;
  lt?: InputMaybe<webAgent__EndpointSupportLevel>;
  lte?: InputMaybe<webAgent__EndpointSupportLevel>;
  neq?: InputMaybe<webAgent__EndpointSupportLevel>;
};

export type FilterwebAgent__EndpointType = {
  eq?: InputMaybe<webAgent__EndpointType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__EndpointType>;
  gte?: InputMaybe<webAgent__EndpointType>;
  in?: InputMaybe<Array<webAgent__EndpointType>>;
  lt?: InputMaybe<webAgent__EndpointType>;
  lte?: InputMaybe<webAgent__EndpointType>;
  neq?: InputMaybe<webAgent__EndpointType>;
};

export type FilterwebAgent__ExecutionOrigin = {
  eq?: InputMaybe<webAgent__ExecutionOrigin>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__ExecutionOrigin>;
  gte?: InputMaybe<webAgent__ExecutionOrigin>;
  in?: InputMaybe<Array<webAgent__ExecutionOrigin>>;
  lt?: InputMaybe<webAgent__ExecutionOrigin>;
  lte?: InputMaybe<webAgent__ExecutionOrigin>;
  neq?: InputMaybe<webAgent__ExecutionOrigin>;
};

export type FilterwebAgent__ExecutionProxyOrigin = {
  eq?: InputMaybe<webAgent__ExecutionProxyOrigin>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__ExecutionProxyOrigin>;
  gte?: InputMaybe<webAgent__ExecutionProxyOrigin>;
  in?: InputMaybe<Array<webAgent__ExecutionProxyOrigin>>;
  lt?: InputMaybe<webAgent__ExecutionProxyOrigin>;
  lte?: InputMaybe<webAgent__ExecutionProxyOrigin>;
  neq?: InputMaybe<webAgent__ExecutionProxyOrigin>;
};

export type FilterwebAgent__LinkDeactivatedReason = {
  eq?: InputMaybe<webAgent__LinkDeactivatedReason>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__LinkDeactivatedReason>;
  gte?: InputMaybe<webAgent__LinkDeactivatedReason>;
  in?: InputMaybe<Array<webAgent__LinkDeactivatedReason>>;
  lt?: InputMaybe<webAgent__LinkDeactivatedReason>;
  lte?: InputMaybe<webAgent__LinkDeactivatedReason>;
  neq?: InputMaybe<webAgent__LinkDeactivatedReason>;
};

export type FilterwebAgent__ManagedMfaOutcomeType = {
  eq?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  gte?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  in?: InputMaybe<Array<webAgent__ManagedMfaOutcomeType>>;
  lt?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  lte?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
  neq?: InputMaybe<webAgent__ManagedMfaOutcomeType>;
};

export type FilterwebAgent__MfaMethod = {
  eq?: InputMaybe<webAgent__MfaMethod>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__MfaMethod>;
  gte?: InputMaybe<webAgent__MfaMethod>;
  in?: InputMaybe<Array<webAgent__MfaMethod>>;
  lt?: InputMaybe<webAgent__MfaMethod>;
  lte?: InputMaybe<webAgent__MfaMethod>;
  neq?: InputMaybe<webAgent__MfaMethod>;
};

export type FilterwebAgent__MfaRequirement = {
  eq?: InputMaybe<webAgent__MfaRequirement>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__MfaRequirement>;
  gte?: InputMaybe<webAgent__MfaRequirement>;
  in?: InputMaybe<Array<webAgent__MfaRequirement>>;
  lt?: InputMaybe<webAgent__MfaRequirement>;
  lte?: InputMaybe<webAgent__MfaRequirement>;
  neq?: InputMaybe<webAgent__MfaRequirement>;
};

export type FilterwebAgent__MfaSupportLevel = {
  eq?: InputMaybe<webAgent__MfaSupportLevel>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__MfaSupportLevel>;
  gte?: InputMaybe<webAgent__MfaSupportLevel>;
  in?: InputMaybe<Array<webAgent__MfaSupportLevel>>;
  lt?: InputMaybe<webAgent__MfaSupportLevel>;
  lte?: InputMaybe<webAgent__MfaSupportLevel>;
  neq?: InputMaybe<webAgent__MfaSupportLevel>;
};

export type FilterwebAgent__SignInRobotType = {
  eq?: InputMaybe<webAgent__SignInRobotType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__SignInRobotType>;
  gte?: InputMaybe<webAgent__SignInRobotType>;
  in?: InputMaybe<Array<webAgent__SignInRobotType>>;
  lt?: InputMaybe<webAgent__SignInRobotType>;
  lte?: InputMaybe<webAgent__SignInRobotType>;
  neq?: InputMaybe<webAgent__SignInRobotType>;
};

export type FilterwebAgent__WebAgentExecutionArtifactType = {
  eq?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  gte?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  in?: InputMaybe<Array<webAgent__WebAgentExecutionArtifactType>>;
  lt?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  lte?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
  neq?: InputMaybe<webAgent__WebAgentExecutionArtifactType>;
};

export type FilterwebAgent__WebAgentExecutionEventType = {
  eq?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  gte?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  in?: InputMaybe<Array<webAgent__WebAgentExecutionEventType>>;
  lt?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  lte?: InputMaybe<webAgent__WebAgentExecutionEventType>;
  neq?: InputMaybe<webAgent__WebAgentExecutionEventType>;
};

export type FilterwebAgent__WebExecutionStatus = {
  eq?: InputMaybe<webAgent__WebExecutionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__WebExecutionStatus>;
  gte?: InputMaybe<webAgent__WebExecutionStatus>;
  in?: InputMaybe<Array<webAgent__WebExecutionStatus>>;
  lt?: InputMaybe<webAgent__WebExecutionStatus>;
  lte?: InputMaybe<webAgent__WebExecutionStatus>;
  neq?: InputMaybe<webAgent__WebExecutionStatus>;
};

export type FilterwebAgent__WebExecutionType = {
  eq?: InputMaybe<webAgent__WebExecutionType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<webAgent__WebExecutionType>;
  gte?: InputMaybe<webAgent__WebExecutionType>;
  in?: InputMaybe<Array<webAgent__WebExecutionType>>;
  lt?: InputMaybe<webAgent__WebExecutionType>;
  lte?: InputMaybe<webAgent__WebExecutionType>;
  neq?: InputMaybe<webAgent__WebExecutionType>;
};

export type FinalizeDocumentInput = {
  /** If true, the event occurred during case intake. */
  caseIntake?: InputMaybe<Scalars['Boolean']['input']>;
  documentId: Scalars['ID']['input'];
  /**
   * Document Label relates to the type of document that is being uploaded.
   *
   * e.g. InsuranceCard, ExplanationOfBenefits
   */
  documentLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * If present with issueId, will generate a internalDocumentUploaded
   * Id, if not this will be only added at the user level.
   */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If present, will also generate a new document uploaded event for
   * the issue.
   */
  issueId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Entry point of the Scanbot scan that produced this document's pages.
   * Absent when the document was picked rather than scanned. The server owns
   * the in-scope allowlist, so an unrecognised or absent value keeps the
   * document out of the scan-quality experiment's guardrail metrics.
   */
  scanbotEntryPoint?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional flag, defaults to true. Set to false to ingest the document without
   * engaging the case agent: no triage, no analysis chat replies. Extraction
   * still runs so the document stays usable (e.g. FA prefill). Used by the FA
   * wizard, whose uploads are form inputs, not new case activity.
   */
  startAnalysis?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional flag. Set to false to prevent initial document upload events from
   * showing up in the user's chat list.
   */
  userVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinalizeDocumentResult = {
  __typename: 'FinalizeDocumentResult';
  document: document__Document;
};

export type ForceDeactivateLinkInput = {
  linkId: Scalars['String']['input'];
  pushNotify?: InputMaybe<Scalars['Boolean']['input']>;
  requestManagedMfa?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ForecastingBenchmarkRun = {
  __typename: 'ForecastingBenchmarkRun';
  completedAt?: Maybe<Scalars['String']['output']>;
  /** Per-variable {before, after} for values that moved since the prior run. */
  diff?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reconciliationFailures: Array<Scalars['String']['output']>;
  segmentationVersion: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ForecastingHeadcountWeekInput = {
  /** Full-time front-line HAs working that week, net of PTO. Fractional OK. */
  fullTimeHAs: Scalars['Float']['input'];
  /** Monday, YYYY-MM-DD. */
  weekStart: Scalars['String']['input'];
};

export type ForecastingInvestment = {
  __typename: 'ForecastingInvestment';
  effectAmount: Scalars['Float']['output'];
  effectKind: Scalars['String']['output'];
  /** YYYY-MM-DD the modifier takes effect. */
  effectiveDate: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  rampWeeks?: Maybe<Scalars['Int']['output']>;
  targetVariable: Scalars['String']['output'];
};

export type ForecastingOverride = {
  __typename: 'ForecastingOverride';
  id: Scalars['ID']['output'];
  value: Scalars['Float']['output'];
  variableKey: Scalars['String']['output'];
};

export type ForecastingOverview = {
  __typename: 'ForecastingOverview';
  benchmarkComputedAt?: Maybe<Scalars['String']['output']>;
  /** Null while running on launch seeds (no successful benchmark run yet). */
  benchmarkRunId?: Maybe<Scalars['ID']['output']>;
  headcountFallbackWeeks: Scalars['JSON']['output'];
  /** Monday of projection week 1, YYYY-MM-DD. */
  horizonStart: Scalars['String']['output'];
  horizonWeeks: Scalars['Int']['output'];
  /** Per-segment weekly opened-lead actuals for forecast-vs-actual plotting. */
  leadActuals: Scalars['JSON']['output'];
  /** Engine ProjectionResult: escalations, funnel/queue paid, demand, backlog… */
  projection: Scalars['JSON']['output'];
  reconciliationFailures: Array<Scalars['String']['output']>;
  /** Registry entries: key, scope, value, benchmark, n, provenance, note. */
  registry: Scalars['JSON']['output'];
  scenarioId?: Maybe<Scalars['ID']['output']>;
  segmentationVersion: Scalars['String']['output'];
  usingSeedBenchmarks: Scalars['Boolean']['output'];
  /** Per segment, weeks whose volume was carried forward (no forecast supplied). */
  volumeFallbackWeeks: Scalars['JSON']['output'];
};

export type ForecastingScenario = {
  __typename: 'ForecastingScenario';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investments: Array<ForecastingInvestment>;
  name: Scalars['String']['output'];
  overrides: Array<ForecastingOverride>;
  updatedAt: Scalars['String']['output'];
};

export type ForecastingVolumeWeekInput = {
  leadsPerWeek: Scalars['Float']['input'];
  /** FA | NATERA | CANCER_TESTING | ER_BILLS | OTHER_LABS | OTHER_BILLS */
  segment: Scalars['String']['input'];
  /** Monday, YYYY-MM-DD. */
  weekStart: Scalars['String']['input'];
};

export type FormError = {
  __typename: 'FormError';
  /** Fields denotes specific fields that have an issue. */
  fields?: Maybe<Array<FieldError>>;
  message?: Maybe<Scalars['String']['output']>;
};

export type FormOptionsV2 = {
  /** Whether the patient is the signed-in user/account holder. */
  patientIsSelf?: InputMaybe<Scalars['Boolean']['input']>;
  patientIsSubscriber?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the patient signed the release themselves. */
  patientSignedRelease?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GenerateBenefitsSummaryInput = {
  documentId: Scalars['String']['input'];
  planId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GenerateCaseReplyDraftInput = {
  haDraft?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['ID']['input'];
  messageType?: InputMaybe<CaseReplyMessageType>;
  model?: InputMaybe<Scalars['String']['input']>;
  /**
   * The caller already holds a `caseConversationVerdict` of NO_REPLY_NEEDED and is
   * asking for a draft regardless. Scales the draft down to a brief
   * acknowledgement instead of a full status recap.
   *
   * Client-supplied deliberately: this module cannot read the verdict itself
   * without importing the suggestion service from CaseAutomationModule, which
   * would close the CaseAutomation → Issue → CaseReplyDraft → CaseAutomation DI
   * loop this module's imports exist to avoid. It is a prompt hint, never an
   * authorization input, so a wrong value costs a differently-sized draft and
   * nothing more.
   */
  noReplyNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  suggestionId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateFaPacketInput = {
  caseId: Scalars['ID']['input'];
  formType: provider__FormType;
  providerId: Scalars['ID']['input'];
  /**
   * Canonical field key to value. Checkbox fields take "checked"; text fields
   * take the literal string to draw. JSON-encoded (the Gel JSON scalar convention).
   * Optional: when omitted, the case's stored application draft (formState) is
   * used, so the fill runs straight from the fa::Application instance.
   */
  values?: InputMaybe<Scalars['JSON']['input']>;
};

export type GeoLocation = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
};

export type GetAttemptStatusInput = {
  executionId: Scalars['ID']['input'];
};

export type GetFormFillInput = {
  caseId: Scalars['ID']['input'];
  formType: provider__FormType;
  providerId: Scalars['ID']['input'];
};

export type GetPersonalizedPromptsResponse = {
  __typename: 'GetPersonalizedPromptsResponse';
  prompts: Array<PersonalizedPrompt>;
};

export type GetTemplateReleaseInput = {
  templateId: Scalars['String']['input'];
};

export type GetTemplateReleaseResult = {
  __typename: 'GetTemplateReleaseResult';
  /**
   * The template's form definition as an issuer-agnostic FormSpec, JSON-encoded
   * (the Gel JSON scalar convention). Sections mirror the release wizard's pages;
   * field types, required flags, and format patterns come from the shared field
   * registry. Additive: the legacy templateFields/templateAdditionalSections
   * remain until the FE has migrated onto the spec.
   */
  formSpec: Scalars['JSON']['output'];
  templateAdditionalSections: Array<AdditionalSection>;
  /**
   * Which counterparty this HIPAA template authorizes us to contact. Optional
   * until the rebuild backfill categorizes existing rows.
   */
  templateCounterpartyType?: Maybe<document__TemplateCounterpartyType>;
  templateFields: Array<FieldAttributes>;
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
  templateOrgDisplayName?: Maybe<Scalars['String']['output']>;
  templateOrgDisplayUrl?: Maybe<Scalars['String']['output']>;
  templateOrgLoginUrl?: Maybe<Scalars['String']['output']>;
  templateOrgSlug?: Maybe<Scalars['String']['output']>;
};

export type HaEventAck = {
  __typename: 'HaEventAck';
  accepted: Scalars['Int']['output'];
};

export type HaEventInput = {
  caseId?: InputMaybe<Scalars['ID']['input']>;
  eventType: HaEventType;
  occurredAt: Scalars['DateTime']['input'];
  props?: InputMaybe<HaEventPropsInput>;
  sessionId: Scalars['String']['input'];
};

export type HaEventPropsInput = {
  actionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  activeMs?: InputMaybe<Scalars['Int']['input']>;
  charsChanged?: InputMaybe<Scalars['Int']['input']>;
  docCount?: InputMaybe<Scalars['Int']['input']>;
  domains?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  panel?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  refining?: InputMaybe<Scalars['Boolean']['input']>;
  replayId?: InputMaybe<Scalars['String']['input']>;
  screen?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  suggestionId?: InputMaybe<Scalars['String']['input']>;
  taskId?: InputMaybe<Scalars['String']['input']>;
  usedSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  verb?: InputMaybe<Scalars['String']['input']>;
  view?: InputMaybe<Scalars['String']['input']>;
};

export enum HaEventType {
  HaActionTaken = 'HaActionTaken',
  HaCaseClosed = 'HaCaseClosed',
  HaCaseHeartbeat = 'HaCaseHeartbeat',
  HaCaseOpened = 'HaCaseOpened',
  HaCaseSelected = 'HaCaseSelected',
  HaPanelOpened = 'HaPanelOpened',
  HaReplySent = 'HaReplySent',
  HaScreenViewed = 'HaScreenViewed',
  HaSuggestReplyUsed = 'HaSuggestReplyUsed',
  HaViewChanged = 'HaViewChanged'
}

export type HaFeedbackInput = {
  actual?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  caseRef?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  cost?: InputMaybe<Scalars['String']['input']>;
  expected?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  issueId?: InputMaybe<Scalars['ID']['input']>;
  message: Scalars['String']['input'];
  occurredAt?: InputMaybe<Scalars['String']['input']>;
  pageUrl?: InputMaybe<Scalars['String']['input']>;
  problem?: InputMaybe<Scalars['String']['input']>;
  route?: InputMaybe<Scalars['String']['input']>;
  screen?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  viewport?: InputMaybe<Scalars['String']['input']>;
  workaround?: InputMaybe<Scalars['String']['input']>;
};

export type HaFeedbackResult = {
  __typename: 'HaFeedbackResult';
  accepted: Scalars['Boolean']['output'];
};

export type HaMyTasksFilter = {
  dueTo?: InputMaybe<Scalars['String']['input']>;
  hideCompleted: Scalars['Boolean']['input'];
  marketingReengagement: Scalars['Boolean']['input'];
};

export type IngestStaffTailgateFileInput = {
  documentId: Scalars['String']['input'];
  executionId: Scalars['String']['input'];
};

/**
 * A member's insurance. The check status and the memberships are independent:
 * a membership a payer confirmed stays listed while later checks fail.
 */
export type Insurance = {
  __typename: 'Insurance';
  /**
   * Whether the account has a profile person to match memberships against.
   * When false, every membership's accountHolder is false because the account
   * holder is unknown, not because the memberships are someone else's.
   */
  accountHolderKnown: Scalars['Boolean']['output'];
  checkStatus: InsuranceCheckStatus;
  /**
   * Active memberships first, then the account holder's, then subscribers
   * before dependents.
   */
  memberships: Array<InsuranceMembership>;
};

export type InsuranceAddress = {
  __typename: 'InsuranceAddress';
  city?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** Who bills an amount, when the plan prices the two apart. */
export enum InsuranceBilledBy {
  /** The facility: an emergency room, a hospital, a surgery center. */
  FACILITY = 'FACILITY',
  /** The professional who treats the member there. */
  PROFESSIONAL = 'PROFESSIONAL',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum InsuranceCareCategory {
  CHIROPRACTIC = 'CHIROPRACTIC',
  DENTAL_CARE = 'DENTAL_CARE',
  DURABLE_MEDICAL_EQUIPMENT = 'DURABLE_MEDICAL_EQUIPMENT',
  EMERGENCY_ROOM = 'EMERGENCY_ROOM',
  GENERIC_RX = 'GENERIC_RX',
  HOME_HEALTH = 'HOME_HEALTH',
  IMAGING = 'IMAGING',
  INPATIENT = 'INPATIENT',
  LAB_WORK = 'LAB_WORK',
  MATERNITY = 'MATERNITY',
  MENTAL_HEALTH = 'MENTAL_HEALTH',
  NON_PREFERRED_BRAND_RX = 'NON_PREFERRED_BRAND_RX',
  OCCUPATIONAL_THERAPY = 'OCCUPATIONAL_THERAPY',
  OUTPATIENT_SURGERY = 'OUTPATIENT_SURGERY',
  PHYSICAL_THERAPY = 'PHYSICAL_THERAPY',
  PREFERRED_BRAND_RX = 'PREFERRED_BRAND_RX',
  PREVENTIVE_CARE = 'PREVENTIVE_CARE',
  PRIMARY_CARE = 'PRIMARY_CARE',
  SKILLED_NURSING = 'SKILLED_NURSING',
  SPECIALIST = 'SPECIALIST',
  SPECIALTY_RX = 'SPECIALTY_RX',
  SPEECH_THERAPY = 'SPEECH_THERAPY',
  SUBSTANCE_USE = 'SUBSTANCE_USE',
  TELEHEALTH = 'TELEHEALTH',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED',
  URGENT_CARE = 'URGENT_CARE',
  VISION_CARE = 'VISION_CARE'
}

/** A stated cap on how much of a category of care the plan covers. */
export type InsuranceCareLimit = {
  __typename: 'InsuranceCareLimit';
  period?: Maybe<InsuranceLimitPeriod>;
  /** For example 20, for 20 visits. */
  quantity?: Maybe<Scalars['Float']['output']>;
  /** What the quantity measures. */
  unit?: Maybe<Scalars['String']['output']>;
  unlimited: Scalars['Boolean']['output'];
};

export enum InsuranceCheckProblem {
  INSURER_NOT_SUPPORTED = 'INSURER_NOT_SUPPORTED',
  INSURER_UNAVAILABLE = 'INSURER_UNAVAILABLE',
  MEMBER_NOT_FOUND = 'MEMBER_NOT_FOUND',
  OTHER = 'OTHER',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum InsuranceCheckRequirement {
  DATE_OF_BIRTH = 'DATE_OF_BIRTH',
  INSURER = 'INSURER',
  NAME = 'NAME',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum InsuranceCheckState {
  /** The most recent check was answered. */
  CHECKED = 'CHECKED',
  /** Checkable; the payer has not answered yet. */
  CHECKING = 'CHECKING',
  /** The most recent check failed, or checks are paused after repeated failures. */
  FAILING = 'FAILING',
  /** Memberships exist, but none has what a check needs. */
  NEEDS_INFO = 'NEEDS_INFO',
  /** No membership and no answer about insurance. */
  NOT_STARTED = 'NOT_STARTED',
  /** Checks were stopped for this member before any was answered or failed. */
  STOPPED = 'STOPPED',
  /** The member said they have no insurance, and none has been found. */
  UNINSURED = 'UNINSURED',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** Whether Granted can check a member's insurance with the payer, and whether it has. */
export type InsuranceCheckStatus = {
  __typename: 'InsuranceCheckStatus';
  /** The most recent attempt the payer answered. */
  lastAnsweredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The most recent check attempt, answered or not. */
  lastAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  /** Inputs a check still needs. Non-empty only in NEEDS_INFO. */
  missing: Array<InsuranceCheckRequirement>;
  /** Why checks are not being answered. Set only in FAILING. */
  problem?: Maybe<InsuranceCheckProblem>;
  state: InsuranceCheckState;
};

export type InsuranceContacts = {
  __typename: 'InsuranceContacts';
  /** Where paper claims are sent. */
  claimsAddress?: Maybe<InsuranceAddress>;
  memberServicesPhone?: Maybe<Scalars['String']['output']>;
  mentalHealthPhone?: Maybe<Scalars['String']['output']>;
  nurseLinePhone?: Maybe<Scalars['String']['output']>;
  pharmacyHelpPhone?: Maybe<Scalars['String']['output']>;
  preAuthorizationPhone?: Maybe<Scalars['String']['output']>;
  providerServicesPhone?: Maybe<Scalars['String']['output']>;
};

/**
 * What the member pays for one category of care on one network: every copay and
 * every coinsurance the plan states for it, and what the plan says about
 * covering it. Copays and coinsurances are listed apart: a payer states each on
 * its own row, and nothing it states says which copay a coinsurance goes with.
 */
export type InsuranceCostShare = {
  __typename: 'InsuranceCostShare';
  authRequired?: Maybe<Scalars['Boolean']['output']>;
  category: InsuranceCareCategory;
  /**
   * Every distinct coinsurance stated, as the member's share: 0.2 is 20%.
   * Several when the payer prices more than one service in the category.
   */
  coinsurances: Array<InsuranceCostShareAmount>;
  /**
   * Every distinct copay stated, in dollars per visit or fill. Several when the
   * payer prices more than one service in the category.
   */
  copays: Array<InsuranceCostShareAmount>;
  /**
   * False when the payer lists the category as not covered, true when it states
   * a copay, a coinsurance, or an unlimited benefit for the category's typical
   * service, null when it says neither. A category the payer prices only
   * through other services on its codes is null.
   */
  covered?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<InsuranceCareLimit>;
  /** IN_NETWORK or OUT_OF_NETWORK for a payer cost share; UNKNOWN only for a card copay. */
  network: InsuranceNetwork;
  /** The payer's messages on the coverage and limit it states. */
  notes: Array<Scalars['String']['output']>;
  source: InsuranceCostShareSource;
};

/** One copay or coinsurance a plan states for a category of care. */
export type InsuranceCostShareAmount = {
  __typename: 'InsuranceCostShareAmount';
  /** Dollars for a copay; the member's share as a fraction for a coinsurance. */
  amount: Scalars['Float']['output'];
  /** Whether the facility or the professional bills the amount; null when the payer does not say. */
  billedBy?: Maybe<InsuranceBilledBy>;
  /**
   * Whether the deductible must be met before the amount applies, as the payer
   * states it; null when not stated.
   */
  deductibleApplies?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The category's default, the amount to show first: the only amount of its
   * kind the plan states for the category's typical service (the amount for
   * another service on its codes, such as partial hospitalization under mental
   * health, is never the default), or, among amounts stated for the same service
   * type code, the one its labels single out (an amount that does not vary by
   * location, the standard provider tier, the category's billing side, and the
   * category's provider role, a primary care provider for telehealth, urgent
   * care, and preventive care). False on every amount when nothing the payer states says
   * which one a visit gets.
   */
  default: Scalars['Boolean']['output'];
  /** The payer's messages on the rows that state the amount. */
  notes: Array<Scalars['String']['output']>;
  /**
   * Whether a primary care provider or a specialist provides the care the amount
   * prices; null when the payer does not say.
   */
  providerRole?: Maybe<InsuranceProviderRole>;
  /** The provider tier the amount applies to; null when the payer does not tier it. */
  providerTier?: Maybe<InsuranceProviderTier>;
  /** True when the payer says the amount varies by where the care is given. */
  variesByLocation: Scalars['Boolean']['output'];
};

export enum InsuranceCostShareSource {
  CARD = 'CARD',
  PAYER = 'PAYER',
  PLAN_DOCUMENT = 'PLAN_DOCUMENT',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum InsuranceCoverageType {
  DENTAL = 'DENTAL',
  MEDICAL = 'MEDICAL',
  PHARMACY = 'PHARMACY',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED',
  VISION = 'VISION'
}

export type InsuranceDiscoveryCandidate = {
  __typename: 'InsuranceDiscoveryCandidate';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /**
   * Stable key for the membership this candidate would materialize, embedding
   * member id, payer id, relationship, and plan year.
   */
  materializationKey: Scalars['String']['output'];
  memberId?: Maybe<Scalars['String']['output']>;
  payerId?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type InsuranceDiscoveryRunError = {
  __typename: 'InsuranceDiscoveryRunError';
  /**
   * Stable error code for a FAILED run (an INSURANCE_DISCOVERY_ERROR_CODE
   * value).
   */
  code: Scalars['String']['output'];
  /**
   * Finer-grained classification within `code` — typically joined X12 AAA
   * codes for a payer rejection. Null when the code is itself terminal.
   */
  subCode?: Maybe<Scalars['String']['output']>;
};

export enum InsuranceDiscoveryRunOutcome {
  FAILED = 'FAILED',
  FOUND = 'FOUND',
  NOT_FOUND = 'NOT_FOUND'
}

export type InsuranceDiscoveryRunResult = {
  __typename: 'InsuranceDiscoveryRunResult';
  /** Coverages the vendor reported as active — the ones an apply enrolls. */
  activeCoveragesFound: Scalars['Int']['output'];
  /**
   * True only when `apply` was true — the run recorded the attempt and
   * dispatched the discovered active-coverage memberships. False for a
   * preview.
   */
  applied: Scalars['Boolean']['output'];
  /**
   * The active-coverage memberships this run would (preview) or did (apply)
   * emit, mapped to a display subset.
   */
  candidates: Array<InsuranceDiscoveryCandidate>;
  /**
   * Vendor confidence in the match: HIGH or REVIEW_NEEDED. Null when no
   * coverage was returned.
   */
  confidenceLevel?: Maybe<Scalars['String']['output']>;
  /** Total coverages the vendor returned, active and inactive. */
  coveragesFound: Scalars['Int']['output'];
  /**
   * Opaque Stedi discovery id, useful for cross-referencing vendor logs.
   * Null when the vendor call failed before returning a body.
   */
  discoveryId?: Maybe<Scalars['String']['output']>;
  /** Structured cause when `outcome` is FAILED. Null otherwise. */
  error?: Maybe<InsuranceDiscoveryRunError>;
  /**
   * The requesting NPI the check actually used — the override when supplied,
   * otherwise the registry selection.
   */
  npiUsed: Scalars['String']['output'];
  /**
   * FOUND when the vendor returned at least one coverage, NOT_FOUND when it
   * returned none, FAILED when the check could not complete or the payer
   * rejected the search.
   */
  outcome: InsuranceDiscoveryRunOutcome;
  /**
   * The subscriber date of birth (YYYY-MM-DD) the check searched with, when
   * one was resolved.
   */
  searchedDateOfBirth?: Maybe<Scalars['String']['output']>;
  /** The subscriber first name the check searched with. */
  searchedFirstName: Scalars['String']['output'];
  /** The subscriber last name the check searched with. */
  searchedLastName: Scalars['String']['output'];
  /** User the discovery ran for. */
  userId: Scalars['ID']['output'];
};

export enum InsuranceLimitPeriod {
  CALENDAR_YEAR = 'CALENDAR_YEAR',
  LIFETIME = 'LIFETIME',
  PLAN_YEAR = 'PLAN_YEAR',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED',
  VISIT = 'VISIT'
}

/**
 * One person's enrollment in one plan with one payer. Every field is a fact
 * reconciled from all of the member's evidence: one answer per question.
 */
export type InsuranceMembership = {
  __typename: 'InsuranceMembership';
  /**
   * True when this membership is the account holder's own, matched against the
   * account's profile person by date of birth, or by first name when either
   * lacks one. Several can be true: one per plan. False for every membership
   * when the account has no profile person (accountHolderKnown is false).
   */
  accountHolder: Scalars['Boolean']['output'];
  /** Why this membership's checks are not being answered. Null when they are. */
  checkProblem?: Maybe<InsuranceCheckProblem>;
  /** When the payer last answered a check for this membership. */
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Phone numbers and the claims address. Null when no source states any. */
  contacts?: Maybe<InsuranceContacts>;
  /**
   * What the member pays per category of care. Holds only a card's copays when
   * the payer reply's plan year has ended.
   */
  costShares: Array<InsuranceCostShare>;
  coverageType: InsuranceCoverageType;
  /**
   * The exclusions the payer names, in its own words. Empty when the payer
   * reply's plan year has ended.
   */
  exclusions: Array<Scalars['String']['output']>;
  /**
   * True on a dependent's membership whose figures come from the subscriber's
   * check: positions carry the family figures only.
   */
  figuresFromSubscriber: Scalars['Boolean']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  /**
   * Opaque; does not reveal the member ID. Stable across plan years, but it
   * changes when a membership known only from an onboarding answer gains a
   * member ID, and can change when a second person first appears under a
   * shared member ID. A client holding an ID that is gone re-selects the
   * membership by payer, person, and coverage type.
   */
  id: Scalars['ID']['output'];
  /** Null when no source states one, such as an onboarding answer. */
  memberId?: Maybe<Scalars['String']['output']>;
  /**
   * Inputs a check for this membership still needs; empty when it can be
   * checked. NAME and DATE_OF_BIRTH are the policyholder's, who for a family
   * member on someone else's policy is not this membership's person.
   */
  missing: Array<InsuranceCheckRequirement>;
  /** The payer from the payer catalog. Null when the payer was not resolved. */
  payer?: Maybe<Payer>;
  /** The payer's name: the payer catalog's when the payer was resolved, else the name the evidence states. */
  payerName: Scalars['String']['output'];
  /** Who the membership belongs to. */
  person: InsurancePerson;
  /** Pharmacy routing identifiers. Null when no source states any. */
  pharmacy?: Maybe<InsurancePharmacy>;
  plan: InsurancePlan;
  /**
   * The plan year of the payer reply that positions are read from. Cost shares are read
   * from the latest benefit reply, normally the same plan year. Null until a check
   * answers.
   */
  planYear?: Maybe<PlanYear>;
  /** Whose identity a check for this membership sends as the subscriber. */
  policyholder: InsurancePolicyholder;
  /**
   * The deductible and out-of-pocket figures, with history: the membership's
   * own service first, then each service the plan keeps a separate figure for.
   * Empty until a check answers, and when the plan year has ended.
   */
  positions: Array<InsurancePosition>;
  /**
   * The plan year before the one planYear reads, with the last figures stored
   * for it: the latest stored plan year that started before it, also while
   * planYear is ENDED. Null when none is stored, which includes a payer that
   * restates the same plan begin date every year.
   */
  previousPlanYear?: Maybe<PreviousPlanYear>;
  /** The person's relationship to the policy's subscriber, not to the account holder. */
  relationship: InsuranceRelationship;
  /** Every source that contributed evidence. */
  sources: Array<InsuranceSource>;
  /**
   * True when status and figures may be out of date: the payer last answered
   * more than 28 days ago, or the plan year is UNSTATED and the last answer came
   * before this calendar year. Status is not changed by it. False when the payer
   * never answered.
   */
  stale: Scalars['Boolean']['output'];
  status: InsuranceMembershipStatus;
  /** The subscriber's member ID when it differs from this person's. */
  subscriberMemberId?: Maybe<Scalars['String']['output']>;
};

export enum InsuranceMembershipStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  /** No payer answer and nothing that says the coverage ended. Never means inactive. */
  UNKNOWN = 'UNKNOWN',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum InsuranceNetwork {
  IN_NETWORK = 'IN_NETWORK',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK',
  /** The payer did not flag a network, or the figure is printed on a card. */
  UNKNOWN = 'UNKNOWN',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export type InsurancePerson = {
  __typename: 'InsurancePerson';
  dateOfBirth?: Maybe<Scalars['LocalDate']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type InsurancePharmacy = {
  __typename: 'InsurancePharmacy';
  pbmName?: Maybe<Scalars['String']['output']>;
  pbmPhone?: Maybe<Scalars['String']['output']>;
  rxBin?: Maybe<Scalars['String']['output']>;
  rxGroup?: Maybe<Scalars['String']['output']>;
  /** The pharmacy member ID when it differs from the member ID. */
  rxId?: Maybe<Scalars['String']['output']>;
  rxPcn?: Maybe<Scalars['String']['output']>;
};

export type InsurancePlan = {
  __typename: 'InsurancePlan';
  effectiveDate?: Maybe<Scalars['LocalDate']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The name of the plan's provider network. */
  network?: Maybe<Scalars['String']['output']>;
  terminationDate?: Maybe<Scalars['LocalDate']['output']>;
  type?: Maybe<InsurancePlanType>;
};

export enum InsurancePlanType {
  EPO = 'EPO',
  HDHP = 'HDHP',
  HMO = 'HMO',
  INDEMNITY = 'INDEMNITY',
  OAP = 'OAP',
  OTHER = 'OTHER',
  POS = 'POS',
  PPO = 'PPO',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** The person who holds a membership's policy, as the member rows name them. */
export type InsurancePolicyholder = {
  __typename: 'InsurancePolicyholder';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** True when the policyholder is the membership's own person. */
  self: Scalars['Boolean']['output'];
};

/**
 * One figure a member tracks: a deductible or out-of-pocket maximum, for the
 * individual or the family, in or out of network, for one service.
 */
export type InsurancePosition = {
  __typename: 'InsurancePosition';
  /**
   * The figure to lead with for its type: the membership's own service's
   * individual in-network deductible, else its family one, and the same for the
   * out-of-pocket maximum. At most one deductible and one out-of-pocket maximum
   * per membership; none when the payer reports neither in network.
   */
  headline: Scalars['Boolean']['output'];
  /**
   * Readings this plan year, newest first. Empty means unchanged, and always
   * empty for a service other than the membership's own.
   */
  history: Array<InsurancePositionReading>;
  kind: InsurancePositionKind;
  /** When the figure last moved. Null when it has not. */
  lastChangedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Null when the payer did not report it. */
  limitAmount?: Maybe<Scalars['Float']['output']>;
  metAmount: Scalars['Float']['output'];
  /**
   * The network the payer reported for the figure. UNKNOWN within the
   * in-network scope means the payer did not flag it; treat it as in-network.
   */
  network: InsuranceNetwork;
  /** Null when the payer did not report it. */
  remainingAmount?: Maybe<Scalars['Float']['output']>;
  scope: InsurancePositionScope;
  /** The membership's coverage type for its own figure, else the service the plan keeps a separate figure for. */
  service: InsuranceCoverageType;
};

export enum InsurancePositionKind {
  DEDUCTIBLE_FAMILY = 'DEDUCTIBLE_FAMILY',
  DEDUCTIBLE_INDIVIDUAL = 'DEDUCTIBLE_INDIVIDUAL',
  OOP_FAMILY = 'OOP_FAMILY',
  OOP_INDIVIDUAL = 'OOP_INDIVIDUAL',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export type InsurancePositionReading = {
  __typename: 'InsurancePositionReading';
  /** Change in the met amount since the previous reading on the same network. Set only on MOVED. */
  delta?: Maybe<Scalars['Float']['output']>;
  limitAmount?: Maybe<Scalars['Float']['output']>;
  metAmount?: Maybe<Scalars['Float']['output']>;
  /** Null on ENDED. */
  network?: Maybe<InsuranceNetwork>;
  observation: InsurancePositionReadingKind;
  observedAt: Scalars['DateTime']['output'];
};

export enum InsurancePositionReadingKind {
  /** A first reading, with nothing to compare against. */
  BASELINE = 'BASELINE',
  /** The payer stopped reporting the figure. */
  ENDED = 'ENDED',
  /** A change against the previous reading. */
  MOVED = 'MOVED',
  /** A reading on a different network than the previous one; not comparable with it. */
  RUNG_SWITCH = 'RUNG_SWITCH',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum InsurancePositionScope {
  IN_NETWORK = 'IN_NETWORK',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** Who provides the care an amount prices, when the plan prices them apart. */
export enum InsuranceProviderRole {
  /** A primary care provider. */
  PRIMARY_CARE = 'PRIMARY_CARE',
  /** A specialist. */
  SPECIALIST = 'SPECIALIST',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/**
 * Which of a plan's in-network providers an amount applies to, when the plan
 * prices them apart.
 */
export enum InsuranceProviderTier {
  /** The providers the plan designates for its lowest cost share. */
  PREFERRED = 'PREFERRED',
  /** All other in-network providers. */
  STANDARD = 'STANDARD',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

export enum InsuranceRelationship {
  CHILD = 'CHILD',
  OTHER = 'OTHER',
  SELF = 'SELF',
  SPOUSE = 'SPOUSE',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/** Where a piece of a membership's evidence came from. */
export enum InsuranceSource {
  /** A payer's answer to an eligibility check. */
  ELIGIBILITY_CHECK = 'ELIGIBILITY_CHECK',
  /** A membership an eligibility check's answer named. */
  ELIGIBILITY_DISCOVERY = 'ELIGIBILITY_DISCOVERY',
  INSURANCE_CARD = 'INSURANCE_CARD',
  /** A membership found by searching payers with the member's identity. */
  INSURANCE_DISCOVERY = 'INSURANCE_DISCOVERY',
  /** The member's own answer. */
  ONBOARDING_FORM = 'ONBOARDING_FORM',
  /** Any other origin. */
  OTHER = 'OTHER',
  PLAN_DOCUMENT = 'PLAN_DOCUMENT',
  /** A linked insurance portal. */
  PORTAL_LINK = 'PORTAL_LINK',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED'
}

/**
 * What the user says about having health coverage. Their own statement, not
 * anything read off a card.
 */
export enum InsuranceStatus {
  INSURED = 'INSURED',
  UNINSURED = 'UNINSURED'
}

export type IntakeCase = {
  __typename: 'IntakeCase';
  /**
   * False when this journey had already opened a case, which is what a retry and a
   * refreshed activation screen both get back.
   */
  created: Scalars['Boolean']['output'];
  issueId: Scalars['ID']['output'];
  /**
   * The case's live payment-preferences request. A repeat call returns the one
   * the first call raised rather than prompting the member twice.
   */
  paymentPreferencesEventId: Scalars['ID']['output'];
};

export type InvalidCredentials = {
  __typename: 'InvalidCredentials';
  error: FormError;
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type InviteBeneficiaryInput = {
  /** Beneficiary to mint an invite token for. */
  beneficiaryId: Scalars['ID']['input'];
};

/** Non-PHI partner identity surfaced by an invite-token resolution. */
export type InviteTokenPartner = {
  __typename: 'InviteTokenPartner';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/**
 * An invite token resolved to the non-PHI partner it came through, discriminated
 * by redemption state: an outstanding invite is `AvailableInviteToken`; once
 * redeemed it is `RedeemedInviteToken`, which additionally carries the bound user.
 */
export type InviteTokenResolution = AvailableInviteToken | RedeemedInviteToken;

export enum IssueType {
  BILL_DISPUTE = 'BILL_DISPUTE',
  DOCTOR_VISIT = 'DOCTOR_VISIT',
  MEDICAL_BILL = 'MEDICAL_BILL',
  ONBOARDING = 'ONBOARDING',
  OPEN_ENROLLMENT = 'OPEN_ENROLLMENT',
  OTHER = 'OTHER',
  UNKNOWN = 'UNKNOWN'
}

export type LatestDiscoveryCrawl = {
  __typename: 'LatestDiscoveryCrawl';
  id: Scalars['ID']['output'];
  objectives?: Maybe<Array<LatestDiscoveryCrawlObjective>>;
};

export type LatestDiscoveryCrawlObjective = {
  __typename: 'LatestDiscoveryCrawlObjective';
  dataSlug: Scalars['String']['output'];
  status: webAgent__AiDiscoveryCrawlObjectiveResult;
};

export type LatestIngestion = {
  __typename: 'LatestIngestion';
  id: Scalars['ID']['output'];
  status?: Maybe<ingestion__IngestionStatus>;
};

export type LlmInput = {
  /**
   * Optional instructions for the LLM to setup context. E.g. 'You are an assistant helping users with their medical bills'.
   * While this can be done within the prompt as well, this is advanatgeous to keep separate as we develop more complex LLM interactions
   */
  instructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * Maximum number of tokens to generate. The model will stop once it generates this many tokens, unless it generates an end-of-text token first.
   * If not specified, defaults to 4096.
   */
  maxResponseTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<LlmModel>;
  /** The prompt to send to the LLM. E.g. 'provide summary of the following EOB' */
  prompt: Scalars['String']['input'];
};

export enum LlmModel {
  GPT3 = 'GPT3',
  GPT4 = 'GPT4'
}

export type LlmResponse = {
  __typename: 'LlmResponse';
  completionTokens: Scalars['Int']['output'];
  message?: Maybe<Scalars['String']['output']>;
  promptTokens: Scalars['Int']['output'];
};

export type LocationInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type LogAircallCallInput = {
  aircallId: Scalars['String']['input'];
  callDate: Scalars['String']['input'];
  callType?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Float']['input']>;
  hasVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  isInbound?: InputMaybe<Scalars['Boolean']['input']>;
  issueId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Attach the call to this existing PhoneCallIssueTask (must be on the issue and not already have a call). Optional. */
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type LoginSuccess = {
  __typename: 'LoginSuccess';
  configureManagedMfa?: Maybe<Scalars['Boolean']['output']>;
  linkId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type LoginToInstitutionInput = {
  encryptedCredentials: Credentials;
  endpointId: Scalars['String']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['String']['input'];
};

export type ManagedMfaApprovalRequired = {
  __typename: 'ManagedMfaApprovalRequired';
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type ManagedMfaConfigurationInput = {
  isSupported: Scalars['Boolean']['input'];
  supportedMethods: Array<webAgent__MfaMethod>;
};

export type ManuallyEscalateIssueInput = {
  issueId: Scalars['ID']['input'];
};

export type MarkPromoCodeUsageAsUnusedInput = {
  issueId: Scalars['ID']['input'];
};

export type MarkPromoCodeUsageAsUnusedResponse = {
  __typename: 'MarkPromoCodeUsageAsUnusedResponse';
  promoCodeUsage?: Maybe<PromoCodeUsageInfo>;
};

export type MarkRetoolNotificationAsReadInput = {
  notificationId: Scalars['ID']['input'];
};

export type MatchingPersonResult = FormError | NoMatchingPerson | Person_Type;

export type MemberInput = {
  endpointId: Scalars['String']['input'];
  portalUsername: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type MergePersonsInput = {
  fromId: Scalars['ID']['input'];
  toId: Scalars['ID']['input'];
};

export type MetabaseResource = {
  dashboard: Scalars['Int']['input'];
};

export type MetabaseSignedUrl = {
  __typename: 'MetabaseSignedUrl';
  url: Scalars['String']['output'];
};

export type MetabaseSignedUrlInput = {
  resource: MetabaseResource;
};

export enum MfaMethodType {
  AUTHENTICATOR = 'AUTHENTICATOR',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SMS = 'SMS'
}

export type MfaOption = {
  __typename: 'MfaOption';
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  method: MfaMethodType;
};

export type MfaRequired = {
  __typename: 'MfaRequired';
  mfaOptions: Array<MfaOption>;
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  acceptBillPay?: Maybe<issue__BillPayRequestedEvent>;
  /**
   * Records that the advocate filed the task this draft proposed. False means the
   * draft was no longer pending — already accepted, dismissed, or superseded — and
   * nothing was recorded.
   */
  acceptTaskDraft: Scalars['Boolean']['output'];
  /**
   * Record that the authenticated user accepted the Terms/Privacy at the given
   * version (a FE constant), stamping the acceptance server-side at the moment
   * of the click. Idempotent: re-accepting re-affirms and moves the timestamp
   * forward on purpose. Identity recording is gated on this having happened.
   */
  acceptTerms: OnboardingAck;
  /**
   * Fee-only acknowledgement on the delayed-card Natera route. The member
   * sends the request id; the server checks ownership and enrollment and
   * writes stored fee/promo terms. Does not confirm preferences, place a
   * hold, or authorize provider payment.
   */
  acknowledgePaymentFee?: Maybe<issue__PaymentPreferencesRequestedEvent>;
  addUserQuitFeedback: BasicSuccessResponse;
  /** Answers the tailgate's open ask; returns the view at the next settled point. */
  answerStaffTailgate: StaffTailgateView;
  applyEpicEndpointChanges: ApplyEpicEndpointChangesResponse;
  applyPromoCodeUsage: ApplyPromoCodeUsageResponse;
  /**
   * Admin-only: release a staged delivery to ingestion. The pinned object version
   * the delivery was staged from is promoted to the ingest path; nothing about its
   * members is ingested before this. Idempotent by delivery id — a delivery that
   * is not awaiting approval is returned unchanged.
   */
  approveBeneficiaryDelivery: BeneficiaryDelivery;
  approveSuggestedAction: ApproveSuggestedActionResult;
  archiveConsentRelease: ArchiveConsentReleaseResult;
  archiveTemplate: ArchiveTemplateResult;
  assignPersonToPersonal?: Maybe<Personal>;
  assignUserSegment: AssignUserSegmentResult;
  authenticate: AuthenticateResult;
  /** @deprecated Use authenticate instead */
  authenticateMagicLink: AuthenticateMagicLinkResult;
  /**
   * Authenticate and redeem a partner invite in a single request: establishes the
   * session (cookie or token, per the existing auth headers) and, for a newly
   * created account, binds the user's partner source. Returns the bound `partner`.
   */
  authenticateWithInvite: AuthenticateWithInviteResult;
  batchGenerateBenefitsSummary: Scalars['Boolean']['output'];
  /** Bulk update the support level for multiple endpoints */
  bulkUpdateEndpointSupportLevels: BasicSuccessResponse;
  calibrateProviderForm?: Maybe<ProviderFormResult>;
  /**
   * Admin-only: remove a user from the eligibility program by emitting
   * `EligibilityEnrollmentEnded`. Idempotent — calling on an unenrolled
   * user is a no-op.
   */
  cancelEligibilityEnrollment: CancelEligibilityEnrollmentResult;
  /** Ends a tailgate in any phase the same way, as cancelled. */
  cancelStaffTailgate: StaffTailgateView;
  cancelSubscription: CancelSubscriptionResponse;
  /** Cancel an active tailgate session */
  cancelTailgate: BasicSuccessResponse;
  captureCardCollection?: Maybe<issue__CardCollectionRequestedEvent>;
  caseAdvisorChat: CaseAdvisorChatResult;
  chargeNegotiatedBill?: Maybe<ChargeNegotiatedBillResponse>;
  chargePaymentProfile: ChargePaymentProfileResponse;
  /**
   * The "I'm ready — try again" signal on a failed-charge alert: the user says
   * the charge can be re-run (funds moved or card sorted). Resolves the case's
   * open PaymentChargeFailedEvents and files the urgent retry-charge HA task —
   * the charge itself stays HA-run.
   */
  chargeRetryReady?: Maybe<issue__Issue>;
  checkAllInsuranceLinks?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Admin-only: run an eligibility verification for a user, optionally
   * dispatching the resulting accumulator snapshot as a domain event.
   * Used for manual end-to-end verification and one-off debug checks.
   */
  checkEligibility: EligibilityCheckResult;
  /**
   * Persist the FA prescreen answers (household size + annual income or income
   * band to UserMemory at USER_FORM trust) and return the eligibility verdict that
   * drives the next onboarding screen. The verdict is computed, never persisted
   * — it is derivable from the recorded answers.
   */
  checkFaEligibility: FaEligibilityResult;
  checkPersonMatch?: Maybe<MatchingPersonResult>;
  closeCase?: Maybe<issue__Issue>;
  closeCaseRoom: Scalars['Boolean']['output'];
  closeIssue?: Maybe<issue__Issue>;
  /**
   * Reads the activation checklist, and — only when `submit` is set — escalates
   * the funnel case once every required item is complete. Completeness is
   * validated here, not by the caller; an incomplete submit is returned
   * unescalated with the outstanding items listed.
   */
  completeNateraIntakeActivation: NateraIntakeActivation;
  /**
   * Merges many inputs into the case's application draft via the trust ladder:
   * direct structured entry outranks extracted candidates, and inference below the
   * confidence gate is surfaced to confirm rather than pre-filled. Creates the
   * application if absent. This is the "many inputs (extractions or structured) ->
   * a fill" entry point.
   */
  composeFaApplication: FaApplicationResult;
  /** Generate a snapshot of a FHIR resource. */
  computeResourceSnapshot: ResourceSnapshotResult;
  confirmPaymentPreferences?: Maybe<issue__PaymentPreferencesRequestedEvent>;
  /**
   * Confirm a simplified general-payment agreement: fee acknowledgement plus, for
   * a negotiation, the provider relationship. Rejects a request whose stored
   * contract is FULL.
   */
  confirmSimplifiedPaymentAgreement?: Maybe<issue__PaymentPreferencesRequestedEvent>;
  createApplePayIntent: CreateApplePayIntentResponse;
  createCohort: Scalars['String']['output'];
  createDataQualityFlagTask?: Maybe<taskManagement__Task>;
  /**
   * This is called first to create the initial document record, and
   * to get a presigned URL to upload the document to.
   */
  createDocument: CreateDocumentResult;
  createGeneralFeedback: CreateFeedbackResult;
  /**
   * Opens the case the caller's saved draft describes — the case linked to the
   * immutable `intake::IntakeRecord` it was opened from, plus the draft's
   * per-user answers written to user memory — and clears the draft.
   * Authenticated only: a case belongs to an account.
   *
   * Idempotent on `journeyId`: the record is the durable key, so a repeat call
   * whose draft is already cleared gets that same case back.
   */
  createIntakeCase: IntakeCase;
  createIssueChatEvent?: Maybe<issue__ChatEvent>;
  createIssueCommentEvent?: Maybe<issue__CommentEvent>;
  createIssueConnectAccountRequestedEvent?: Maybe<issue__ConnectAccountRequestedEvent>;
  createIssueFeedback: CreateFeedbackResult;
  createIssueTask?: Maybe<taskManagement__Task>;
  createIssueTemplateReleaseRequestedEvent?: Maybe<issue__TemplateReleaseRequestedEvent>;
  /**
   * Similar to createDocument, but allows for multiple files to be uploaded for a
   * single document.
   */
  createMultiFileDocument: CreateMultiFileDocumentResult;
  /**
   * Creates the funnel's case from the packet stored at magic-link send: the case
   * itself (carrying the bill amount and the intake packet), then — on the hub
   * route, or for any caller that sent no `mode` — its payment-preferences
   * request. Takes no answers from the caller beyond the route: a magic link
   * routinely opens in a different browser than the one that answered. Idempotent:
   * a caller who already has an un-escalated funnel case gets that one back, on
   * the route it was opened on.
   */
  createNateraIntakeCase: NateraIntakeCase;
  /** Create a new navigator specialist instruction */
  createNavigatorSpecialistInstructions: BasicSuccessResponse;
  /**
   * Admin-only: register a partner and, optionally, its groups in one call.
   * Fails if a partner with the same name already exists — names are unique and
   * a duplicate is rejected rather than merged.
   */
  createPartner: Partner;
  createPaymentPreferencesRequestedEvent?: Maybe<issue__PaymentPreferencesRequestedEvent>;
  createPaymentProfile: CreatePaymentProfileResponse;
  createPerson?: Maybe<PersonResult>;
  createPhoneCall?: Maybe<taskManagement__PhoneCall>;
  createPromoCode: CreatePromoCodeResponse;
  createProvider?: Maybe<ProviderResult>;
  /**
   * Create a manual edit to a FHIR resource. This is used to correct errors
   * or add missing data to a FHIR resource that was ingested from an original source.
   */
  createResourceEdit: Scalars['ID']['output'];
  createRetoolNotification: notification__RetoolNotification;
  createReviewPaymentAcceptanceIssueTask?: Maybe<taskManagement__Task>;
  createSegment: CreateSegmentResult;
  createSetupIntent: CreateSetupIntentResponse;
  createSubscription: CreateSubscriptionResponse;
  createTaskComment?: Maybe<taskManagement__TaskComment>;
  createTemplate: CreateTemplateResult;
  /** Create a new web agent endpoint */
  createWebAgentEndpoint: CreateWebAgentEndpointResult;
  /**
   * The proof-of-income checklist row's other answer: the member has no income
   * documents to give. Recorded as an answered proof-of-income request, so it is
   * the same answer the chat card gives.
   */
  declareNoIncomeDocuments: Scalars['Boolean']['output'];
  declinePaymentPreferences?: Maybe<issue__PaymentPreferencesRequestedEvent>;
  deleteForecastingInvestment: Scalars['Boolean']['output'];
  deleteForecastingScenario: Scalars['Boolean']['output'];
  /** Delete a navigator specialist page discovery */
  deleteNavigatorSpecialistPageDiscovery: BasicSuccessResponse;
  deletePaymentProfile: DeletePaymentProfileResponse;
  deleteProvider?: Maybe<DeleteProviderResult>;
  /**
   * Removes an internal or not-yet-visible document from a user's account (admin only).
   * Fails if the document was already sent to the user as a normal upload, is linked to
   * automation sources, or does not belong to the given user.
   */
  deleteUserDocument: DeleteUserDocumentResult;
  directAwaitLoginResult: DirectLoginToInstitutionResult;
  directLoginToInstitution: DirectLoginToInstitutionResult;
  directRequestNewMfaCode: DirectRequestNewMfaCodeResult;
  directSelectMfaMethod: DirectSelectMfaMethodResult;
  directStartLinkCreation: StartLinkCreationResult;
  directStartRelink: DirectStartRelinkResult;
  directSubmitMfaCode: DirectSubmitMfaCodeResult;
  directSubmitSecurityAnswer: DirectSubmitSecurityAnswerResult;
  dismissFinding: Scalars['Boolean']['output'];
  /**
   * Records that the advocate sent the draft back. False means the draft was no
   * longer pending and nothing was recorded.
   */
  dismissTaskDraft: Scalars['Boolean']['output'];
  /**
   * Run the currently-scheduled turn now (collapses its dispatchAt wait). The
   * scheduler is a singleton, so this expedites whatever turn is Scheduled;
   * no-op if none is pending. For operator/manual stepping.
   */
  expediteSchedulerTurn: Scalars['Boolean']['output'];
  /** Adds an hour to a held tailgate, up to six hours in all. */
  extendStaffTailgate: StaffTailgateView;
  /**
   * Fetch a fresh, short-lived recording URL from Aircall. The URL is deliberately
   * not persisted because Aircall returns an expiring presigned S3 URL.
   */
  fetchPhoneCallRecordingUrl: Scalars['String']['output'];
  /** Fetch the AI transcript for a recorded call from Aircall and persist it on the PhoneCallEvent. May 404 (retryable) until Aircall finishes processing. */
  fetchPhoneCallTranscript?: Maybe<issue__PhoneCallEvent>;
  /** This is called after the document has been successfully uploaded. */
  finalizeDocument: FinalizeDocumentResult;
  /** Ends a held tailgate: collects the downloads, closes the browser and saves the device profile. */
  finishStaffTailgate: StaffTailgateView;
  /** Deactivate a link forcing the user to relink it, optionally with a push notification */
  forceDeactivateLink?: Maybe<BasicSuccessResponse>;
  generateBenefitsSummary: Scalars['String']['output'];
  generateCaseRecommendation: Scalars['Boolean']['output'];
  generateCaseReplyDraft: CaseReplyDraftResult;
  /**
   * Generates a filled + bundled FA packet for a case against a provider's
   * calibrated form, stores it as an internal document, and returns the bake
   * reports. Runs through a Temporal workflow keyed on the case, form type, and a
   * fingerprint of the form bytes + values, so concurrent duplicate requests
   * coalesce onto a single run. (Dedup of an already-completed run is a follow-up.)
   * The bundled supporting documents come from the case application's own document
   * answers, never from the caller: uploads have no printed box, so they never
   * travel in `values`, and a caller-supplied list could only disagree with what
   * the applicant pushed. Refuses when an answer names a document the case does
   * not hold.
   */
  generateFaPacket: FaPacketResult;
  generateMetabaseSignedUrl: MetabaseSignedUrl;
  headlessLogin: AuthenticateResult;
  /** Non user-specific endpoint to retrieve existing users from Stytch. */
  importStytchUsers: StytchImportResult;
  /** Sends one file kept from a tailgate to ingestion; the original stays kept. */
  ingestStaffTailgateFile: BasicSuccessResponse;
  initiateAccountDeletion: Scalars['Boolean']['output'];
  initiateAccountDeletionV2: AccountDeletionResponse;
  /**
   * Admin-only: mint an invite token for a beneficiary. The token is NOT
   * returned — it rides the BeneficiaryInvited event into the restricted
   * instance and is read out-of-band from Gel to drive resolve/redeem.
   * Temporarily available for testing only. TODO: remove once the onboarding invite flow is wired.
   */
  inviteBeneficiary: Scalars['Boolean']['output'];
  /** Record an Aircall call placed/received on a case as a PhoneCallEvent on the case timeline. Idempotent on aircallId. */
  logAircallCall?: Maybe<issue__PhoneCallEvent>;
  logout: Scalars['Boolean']['output'];
  manuallyEscalateIssue?: Maybe<issue__Issue>;
  /** Write-once. Stamps shownAt on a CASE_ROOM_TASK_DRAFT suggestion when the card first renders. */
  markCaseRoomProposalShown: Scalars['Boolean']['output'];
  markPromoCodeUsageAsUnused?: Maybe<MarkPromoCodeUsageAsUnusedResponse>;
  markRetoolNotificationAsRead: notification__RetoolNotification;
  mergePersons?: Maybe<PersonResult>;
  /**
   * Admin-only: bind a beneficiary to the user who onboarded. Idempotent by
   * beneficiary id — a second onboard of an already-onboarded beneficiary is a
   * no-op.
   */
  onboardBeneficiary: Beneficiary;
  openCaseRoom: CaseRoom;
  openNewIssue?: Maybe<issue__Issue>;
  openNewIssueFromPreview?: Maybe<issue__Issue>;
  preAuthorizePaymentPreferences?: Maybe<issue__PaymentPreferencesRequestedEvent>;
  /**
   * Seeds a case's FA application from the financial / identity / residency data
   * already extracted from the user's uploaded documents (paystubs, W-2s, 1099s,
   * bank statements, government IDs, utility bills, and person records). Resolves
   * the form's fields, heuristically maps each field label onto extracted data,
   * and merges the results through the trust ladder as DOCUMENT_OCR extractions —
   * so validated data pre-fills and lower-confidence guesses surface for the
   * user to confirm rather than baking in. Pins the provider form when
   * providerId + formType are given; otherwise resolves it from the application's
   * already-pinned form. Returns a FormError when no form is pinned or no
   * extracted data is available to prefill.
   *
   * Owner-scoped, like saveFaApplicationDraft/submitFaApplication.
   */
  prefillFaApplication: FaApplicationResult;
  /**
   * Staff variant of prefillFaApplication: runs the same prefill pass for any
   * case a health advocate is working, impersonating the case owner. The owner
   * is resolved server-side and the pass runs as that owner — the extraction
   * reads, the prior-application flag gate, and the compose are all owner-scoped,
   * so a staff-triggered prefill produces exactly what the owner-triggered one
   * would. Pins the provider form when providerId + formType are given; otherwise
   * resolves it from the application's already-pinned form. Returns a FormError
   * when the case is not visible, no form is pinned, or no extracted data is
   * available to prefill. Internal staff mutation (admin-gated).
   */
  prefillFaApplicationAsStaff: FaApplicationResult;
  prepareProviderFormUpload?: Maybe<ProviderFormUploadResult>;
  processDocumentForAnalysis: ProcessDocumentForAnalysisResult;
  provideUserInputAnswer?: Maybe<issue__UserInputRequestedEvent>;
  /**
   * General purpose free from interface to an LLM to facilitate prototyping and RnD.
   * Estabilished LLM mutations should be moved to their appropriate graphs
   */
  queryOpenai: LlmResponse;
  /**
   * Admin-only: sweep every user with eligibility-relevant data and
   * re-evaluate enrollment against the current readiness predicate.
   * Dispatches `enrollInEligibility` per user; the aggregate's decide
   * is the gate, so users who pass the predicate AND aren't already
   * enrolled get enrolled, and everyone else is a no-op. Idempotent —
   * safe to re-run after data backfills or readiness-logic changes.
   */
  recalculateEligibilityEnrollment: StartEligibilityWorkflowResult;
  /**
   * Reclassify a session on the Integration Ops board. You can set a status
   * (with a 0-1 confidence), add an analysis, or both. The analysis is written to
   * Evidence Room and the StatusOverridden event points at it. Does not change the
   * run itself.
   *
   * Always saved as the signed-in staff member (HUMAN). The board only ships
   * this mutation, so it cannot post as an agent. Admin only.
   */
  reclassifyRpaSession: ReclassifyRpaSessionResponse;
  /**
   * Same as reclassifyRpaSession, but stamped AGENT with the agent's name.
   * The investigator is still the signed-in staff member.
   *
   * Propose first and wait for approval before calling this. Admin only.
   */
  reclassifyRpaSessionAsAgent: ReclassifyRpaSessionResponse;
  recordCalibrationDeltas: CalibrationDeltaAck;
  recordHaEvents: HaEventAck;
  /**
   * Record the primary person's identity for the authenticated user. Idempotent
   * on resume: re-submitting the same identity is a no-op. Rejected until the
   * user has accepted terms (see acceptTerms) — no identity without consent.
   */
  recordIdentity: OnboardingAck;
  /**
   * Records the carrier as user memory (USER_FORM trust) plus, when the identity
   * fields are supplied, a Member row (ONBOARDING_FORM) — the Member is what
   * enrolls the user for eligibility. Segmentation hasInsurance is a separate
   * client write via upsertUserSegmentationData.
   */
  recordInsurance: OnboardingAck;
  /**
   * Record what the user says about having coverage at all, as user memory
   * (USER_FORM trust). Separate from recordInsurance because an uninsured user
   * has no carrier to record, and "no coverage" is a fact worth holding: the
   * financial-assistance application asks for insurance or an acknowledgment
   * that there is none, and a case checklist can only stop asking for a member
   * card once the user has said one of the two.
   *
   * Recording again supersedes: a user who later gets coverage says so, and the
   * newer declaration wins.
   */
  recordInsuranceStatus: OnboardingAck;
  recordIssueEventFeedback: CreateFeedbackResult;
  /**
   * Fills the unanswered fields of the user's claimed express-arm packet. Resending
   * a stored answer is a no-op; a differing one is rejected with CONFLICT, so the
   * client resumes from the stored answers. Also rejected when no such packet is
   * waiting, a case is open, or the merged packet breaks the packet rules.
   */
  recordNateraIntakeAnswers: Scalars['Boolean']['output'];
  /**
   * Record the phone number onboarding collected, together with the TCPA consent
   * that authorizes texting it. The number lands on the primary Person; the
   * consent is recorded as an append-only domain event carrying the number it
   * covers, emitted only once that number stores. Re-submitting records a further
   * authorization rather than replacing one.
   */
  recordPhone: OnboardingAck;
  refreshCodes: Scalars['Boolean']['output'];
  rejectSuggestedAction: RejectSuggestedActionResult;
  removeNegotiationProfile?: Maybe<ProviderResult>;
  removeProviderContactPoint?: Maybe<ProviderResult>;
  removeProviderFaPolicy?: Maybe<ProviderResult>;
  removeProviderForm?: Maybe<ProviderResult>;
  removeUserSegment: RemoveUserSegmentResult;
  renameProviderForm?: Maybe<ProviderFormResult>;
  reopenIssue?: Maybe<issue__Issue>;
  /**
   * Re-pin a case's DRAFT financial-assistance application onto the provider form
   * that resolves for it right now — the facility's own calibrated form, the
   * parent system's via partOf, else none. The HA-facing fix for a draft started
   * on the generic baseline before the provider's form was onboarded: it reuses
   * the same resolution `faFlowFormPreview` shows and the same pointer-upsert the
   * draft save uses, so the wizard immediately serves the calibrated spec and the
   * answers already entered that also exist on the new form carry over untouched.
   * Refuses with a FormError when the case has no application or it is already
   * submitted (folded aggregate truth, not the pointer row). Signals a no-op
   * (RepinFaApplicationFormNoop) — not an error — when nothing resolves or the
   * resolvable form is already the pinned one. Internal staff mutation
   * (admin-gated).
   */
  repinFaApplicationForm: RepinFaApplicationFormResult;
  requestCardCollection?: Maybe<issue__CardCollectionRequestedEvent>;
  /**
   * Records that the member wants a reminder to finish activation and hands the
   * time to Customer.io as a person attribute and an event; the email itself is a
   * campaign built on those, not this mutation's promise. Rejected once the case
   * has escalated — there is nothing left to finish. Returns the checklist as
   * `completeNateraIntakeActivation` reads it, so the hub needs no second call.
   */
  requestNateraIntakeReminder: NateraIntakeActivation;
  /**
   * Ask for a research run on one provider.
   *
   * Idempotent while a run is open: a provider that already has a Requested or
   * Running run gets that run back and no second workflow. Null when there is no
   * such provider.
   */
  requestProviderResearch?: Maybe<ProviderResearchRun>;
  /**
   * Staff resend of an existing FA offer at any lifecycle point: stamps a
   * working draft (`reopenedAt`), keeps filing history and fee classification,
   * projects Gel Draft so Home shows the offer again, and bumps the existing
   * FA_FLOW event. Requires an application that already has a hand-off event.
   * Returns the issue.
   */
  resendFaFlowForIssue?: Maybe<issue__Issue>;
  resendMagicLink: ResendMagicLinkResult;
  /**
   * The ingestion pipeline generates a series of findings that we currently
   * expects staff members to review and approve.
   */
  reviewFinding: fhirext__Finding_Type;
  runAllHealthChecks: BasicSuccessResponse;
  /**
   * Admin-only: run Stedi Insurance Discovery for a single user. Preview (the
   * default) runs the vendor check and returns candidate coverages without
   * emitting anything. Apply additionally records the attempt and dispatches the
   * discovered active-coverage memberships through the normal reactor. The
   * requesting NPI defaults to a registry selection rotated by user id; override
   * per run. Subscriber identity defaults to the user's stored identity.
   */
  runInsuranceDiscovery: InsuranceDiscoveryRunResult;
  /**
   * Save FA form answers as a draft: merge the answers over the current draft
   * (each marked a confirmed user entry) without filing. The case stays a draft.
   * Owner-scoped — the household filling its own form.
   */
  saveFaApplicationDraft: FaApplicationView;
  /**
   * Persist the user-entered model inputs: weekly lead volumes per segment and
   * the weekly full-time-HA headcount plan. These are saved with the forecast —
   * nothing in code computes them.
   */
  saveForecastingForecastInputs: Scalars['Boolean']['output'];
  saveForecastingInvestment: ForecastingScenario;
  saveForecastingScenario: ForecastingScenario;
  /**
   * Upserts the caller's intake draft for the journey the draft names: the
   * staging row `createIntakeCase` opens from, keyed by a client-minted id the
   * client has to hold on to. It does not survive the caller losing that id.
   *
   * Callable on an anonymous session as well as an account; an authenticated
   * caller saves on their own user. A draft saved anonymously follows the
   * anonymous user, so it is only kept if that user is converted in place.
   */
  saveIntake: Scalars['Boolean']['output'];
  saveNotes: SaveNotesResponse;
  scheduleDelayedCharge: ScheduleDelayedChargeResponse;
  selectPlanForEvent?: Maybe<issue__PlanSelectionEvent>;
  sendCaseRoomMessage: SendCaseRoomMessageResult;
  sendDocumentToUser: SendDocumentToUserResult;
  /**
   * Sends multiple documents to the user on the same issue in one request.
   * Each document gets a distinct `sentAt` on its upload event so ordering is stable.
   */
  sendDocumentsToUser: SendDocumentsToUserResult;
  sendMagicLink: SendMagicLinkResult;
  setCasePriorityOverride?: Maybe<issue__Issue>;
  setCaseProvider?: Maybe<issue__Issue>;
  setEndpointCdpProvider?: Maybe<BasicSuccessResponse>;
  /**
   * Set (value present) or clear (value null) one scenario-scoped override.
   * Derived variables and the open book are rejected.
   */
  setForecastingOverride: ForecastingScenario;
  setProviderFormShaping?: Maybe<ProviderFormResult>;
  /**
   * Admin-only endpoint to convert an existing session to a shadow login session.
   * Throws an error if the current user is not an admin.
   * Returns a FormError if the target user does not exist.
   * The new session token will appear in the usual place on the response - either as
   * a cookie, or in the response extensions.
   */
  shadowLogin: AuthUserResult;
  signAndSaveTemplate: SignAndSaveTemplateResult;
  signAndSaveTemplateValues: SignAndSaveTemplateValuesResult;
  /**
   * Signs an anonymous session ID to create a JWT with 24-hour expiration.
   * The client should generate a UUID, call this mutation to sign it, then use
   * the returned token as the X-Anonymous-Session-ID header.
   *
   * Refused with FORBIDDEN when bot control is on and `botControlToken` fails
   * inspection.
   */
  signAnonymousSession: Scalars['String']['output'];
  /** Users give us consent to have access to their medical records by signing a HIPAA release form. */
  signHipaaRelease: SignHipaaReleaseResult;
  /**
   * Record that the user skipped the FA offer for a case. The application must
   * already exist (seeded by the FA hand-off) — skipping does not create one, and
   * returns a FormError when the case has no application. A skip is cleared when
   * the user subsequently opens the wizard (startFaApplicationForIssue) or saves a
   * draft (saveFaApplicationDraft). No-op once the application is submitted.
   * Owner-scoped.
   */
  skipFaApplicationForIssue: FaApplicationViewResult;
  staffOpenNewIssue?: Maybe<issue__Issue>;
  startBackfill: StartBackfillResult;
  /**
   * Admin-only: run an un-gated eligibility re-check across an explicit
   * list of users. Reuses the scheduled refresh's per-user check and
   * dispatches domain events, but checks exactly the supplied `userIds`
   * and defaults the failure-backoff gate off. Intended for re-probing
   * memberships suppressed under a prior requesting NPI after a registry
   * change, so the new NPI is actually sent instead of the streak being
   * skipped. The workflow never expands beyond the given cohort and
   * refuses one larger than `maxChecks`.
   */
  startCohortEligibilityRefresh: StartEligibilityWorkflowResult;
  startEventReplay: StartBackfillResult;
  startExperiment: Scalars['String']['output'];
  /**
   * Mark the FA wizard as opened for the first time for a case — stamps startedAt
   * on the application and clears any prior skip. Idempotent: subsequent calls
   * after the first do not change startedAt. The application must already exist —
   * opening the wizard does not create one, and returns a FormError when the case
   * has no application. Owner-scoped.
   */
  startFaApplicationForIssue: FaApplicationViewResult;
  /**
   * Staff-triggered FA offer: ensures the case's fa::Application and emits the
   * user-visible FA_FLOW hand-off event (the in-chat offer card). Idempotent — a
   * re-fire on a case whose application already has a hand-off keeps the
   * existing offer event rather than creating another. Returns the issue, which
   * reflects the existing or newly started flow. The wizard serves the pinned
   * provider's calibrated form when one exists, otherwise the granted baseline.
   */
  startFaFlowForIssue?: Maybe<issue__Issue>;
  startHealthCheck: BasicSuccessResponse;
  startLinkSignIn?: Maybe<StartLinkSignInResponse>;
  startManualIntake: StartManualIntakeResult;
  startPersonBackfill: StartBackfillResult;
  /**
   * Ask the user the questions behind a post-escalation action, starting with
   * the first. Scoped to that surface: this is the seam for an action the user
   * chose to answer, and the action must still be open on the case. Returns the
   * issue.
   */
  startPostEscalationQuestion?: Maybe<issue__Issue>;
  /**
   * Starts Reducto form-field detection on a provider form's blank PDF as a
   * Temporal workflow and returns immediately with the workflow id. Detection
   * takes ~2 min and writes the detected widgets into
   * ProviderForm.internalTemplate; poll `providerFormDetection` for completion.
   * A new request supersedes any in-flight detection for the same form.
   */
  startProviderFormDetection: StartProviderFormDetectionResult;
  /** Start RPA Debug workflow */
  startRPADebug: StartRPADebugResponse;
  /** Trigger a recrawl by looking up the link from an execution ID */
  startRecrawlFromExecution: StartRecrawlResponse;
  /** Trigger a recrawl for a specific link by link ID */
  startRecrawlFromLink: StartRecrawlResponse;
  /** Starts a tailgate on a member's active link, owned by the member and initiated by the calling HA. */
  startStaffTailgate: StartStaffTailgateResult;
  /** Start a tailgate session (ES-first: dispatches domain command, reactor starts workflow) */
  startTailgate: StartTailgateResult;
  stopCaseRoomTurn: Scalars['Boolean']['output'];
  stopExperiment: Scalars['Boolean']['output'];
  /** Stop RPA Debug workflow */
  stopRPADebug: BasicSuccessResponse;
  /**
   * Submit the FA form: merge any answers over the draft, validate the merged
   * state against the resolved FormSpec, and — only if every required field is
   * answered and every answer conforms to its field's type — file it (freeze the
   * snapshot, stamp submittedAt) and hand back to the standard case agent. An
   * incomplete or invalid submission returns FaSubmitValidationError with one
   * FaFieldError per offending field and nothing is filed.
   * Owner-scoped.
   */
  submitFaApplication: SubmitFaApplicationResult;
  submitHaFeedback: HaFeedbackResult;
  submitManagedMfaApproval: RpaCommandResult;
  submitMessage: RedisResponse;
  submitRecommendationFeedback: Scalars['Boolean']['output'];
  trackInsuranceLinkAttempt: EventTrackingResult;
  triggerNotifyUsersOfFindings: NotifyUsersOfFindingsResult;
  /** Update the crawl objective review for a web agent */
  updateCrawlObjectiveReview: BasicSuccessResponse;
  /** Update the crawl review for a web agent */
  updateCrawlReview: BasicSuccessResponse;
  updateDefaultTemplate: UpdateDefaultTemplateResult;
  updateDocumentName: UpdateDocumentNameResult;
  /** Update the support level for an endpoint */
  updateEndpointSupportLevel: BasicSuccessResponse;
  updateFileName: UpdateFileNameResult;
  updateFinding: Scalars['Boolean']['output'];
  updateInsuranceLinkAttemptInvestigationUrls: Array<Maybe<UpdateInsuranceLinkAttemptInvestigationUrlResult>>;
  updateIssue?: Maybe<issue__Issue>;
  updateIssueCommentEventPinned?: Maybe<issue__CommentEvent>;
  updateIssueEvent?: Maybe<issue__Event>;
  /** Update an existing navigator specialist instruction */
  updateNavigatorSpecialistInstructions: BasicSuccessResponse;
  /** Update the isActive flag for a navigator specialist page discovery */
  updateNavigatorSpecialistPageDiscoveryIsActive: BasicSuccessResponse;
  /** Update the discovery JSON for a navigator specialist page discovery */
  updateNavigatorSpecialistPageDiscoveryJson: BasicSuccessResponse;
  updatePaymentAgreementEvent?: Maybe<issue__PaymentAgreementRequestedEvent>;
  /**
   * Staff edit of a case's confirmed (FULL) payment preferences. Applies to the
   * next charge and records a staff-only PaymentPreferencesUpdatedEvent. A
   * simplified agreement or a case with no capture is refused, and so is a stale
   * expectedUpdatedAt. Returns the preferences row.
   */
  updatePaymentPreferences?: Maybe<issue__PaymentPreferences>;
  updatePaymentProfile: UpdatePaymentProfileResponse;
  updatePerson?: Maybe<PersonResult>;
  updatePersonAddress?: Maybe<PersonResult>;
  updatePromoCode: UpdatePromoCodeResponse;
  updateProvider?: Maybe<ProviderResult>;
  updateSubscriptionPaymentMethod: UpdateSubscriptionPaymentMethodResponse;
  updateTask?: Maybe<taskManagement__Task>;
  updateTaskComment?: Maybe<taskManagement__TaskComment>;
  updateTaskCommentPinned?: Maybe<taskManagement__TaskComment>;
  updateTemplates: UpdateTemplatesResult;
  /** Update an existing web agent endpoint */
  updateWebAgentEndpoint: BasicSuccessResponse;
  /**
   * Creates or updates a case's financial-assistance application and stores the
   * draft (formState) verbatim. Optionally pins the provider form to fill,
   * resolving the facility's own form or its parent system's. Use this to replace
   * the whole draft; use composeFaApplication to merge new inputs into it.
   */
  upsertFaApplication: FaApplicationResult;
  upsertNegotiationProfile?: Maybe<ProviderResult>;
  upsertProviderContactPoint?: Maybe<ProviderResult>;
  upsertProviderFaPolicy?: Maybe<ProviderResult>;
  upsertProviderForm?: Maybe<ProviderFormResult>;
  upsertUserSegmentationData: user__SegmentationData;
  validateTemplate: ValidateTemplateResult;
  /**
   * Validates typed values before the client creates and finalizes the signature
   * document. The sign mutation repeats the same validation against the current
   * authoritative FormSpec before writing the release.
   */
  validateTemplateValues: SignAndSaveTemplateValuesResult;
  verifyNegotiationProfile?: Maybe<ProviderResult>;
  verifyProvider?: Maybe<ProviderResult>;
};


export type MutationacceptBillPayArgs = {
  input: AcceptBillPayInput;
};


export type MutationacceptTaskDraftArgs = {
  input: AcceptTaskDraftInput;
};


export type MutationacceptTermsArgs = {
  input: AcceptTermsInput;
};


export type MutationacknowledgePaymentFeeArgs = {
  input: AcknowledgePaymentFeeInput;
};


export type MutationaddUserQuitFeedbackArgs = {
  input: AddUserQuitFeedbackInput;
};


export type MutationanswerStaffTailgateArgs = {
  input: AnswerStaffTailgateInput;
};


export type MutationapplyEpicEndpointChangesArgs = {
  input: ApplyEpicEndpointChangesInput;
};


export type MutationapplyPromoCodeUsageArgs = {
  input: ApplyPromoCodeUsageInput;
};


export type MutationapproveBeneficiaryDeliveryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationapproveSuggestedActionArgs = {
  input: ApproveSuggestedActionInput;
};


export type MutationarchiveConsentReleaseArgs = {
  input: ArchiveConsentReleaseInput;
};


export type MutationarchiveTemplateArgs = {
  input: ArchiveTemplateInput;
};


export type MutationassignPersonToPersonalArgs = {
  input: AssignPersonToPersonalInput;
};


export type MutationassignUserSegmentArgs = {
  input: AssignUserSegmentInput;
};


export type MutationauthenticateArgs = {
  input: AuthenticateInput;
};


export type MutationauthenticateMagicLinkArgs = {
  input: AuthenticateMagicLinkInput;
};


export type MutationauthenticateWithInviteArgs = {
  input: AuthenticateInput;
  inviteToken: Scalars['String']['input'];
};


export type MutationbatchGenerateBenefitsSummaryArgs = {
  input: BatchGenerateBenefitsSummaryInput;
};


export type MutationbulkUpdateEndpointSupportLevelsArgs = {
  input: BulkUpdateEndpointSupportLevelsInput;
};


export type MutationcalibrateProviderFormArgs = {
  input: CalibrateProviderFormInput;
};


export type MutationcancelEligibilityEnrollmentArgs = {
  input: CancelEligibilityEnrollmentInput;
};


export type MutationcancelStaffTailgateArgs = {
  input: StaffTailgateIdInput;
};


export type MutationcancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationcancelTailgateArgs = {
  input: CancelTailgateInput;
};


export type MutationcaptureCardCollectionArgs = {
  input: CaptureCardCollectionInput;
};


export type MutationcaseAdvisorChatArgs = {
  input: CaseAdvisorChatInput;
};


export type MutationchargeNegotiatedBillArgs = {
  input: ChargeNegotiatedBillInput;
};


export type MutationchargePaymentProfileArgs = {
  input: ChargePaymentProfileInput;
};


export type MutationchargeRetryReadyArgs = {
  input: ChargeRetryReadyInput;
};


export type MutationcheckEligibilityArgs = {
  input: EligibilityCheckInput;
};


export type MutationcheckFaEligibilityArgs = {
  input: CheckFaEligibilityInput;
};


export type MutationcheckPersonMatchArgs = {
  input: CheckPersonMatchInput;
};


export type MutationcloseCaseArgs = {
  input: CloseCaseInput;
};


export type MutationcloseCaseRoomArgs = {
  roomId: Scalars['ID']['input'];
};


export type MutationcloseIssueArgs = {
  input?: InputMaybe<CloseIssueInput>;
};


export type MutationcompleteNateraIntakeActivationArgs = {
  input: CompleteNateraIntakeActivationInput;
};


export type MutationcomposeFaApplicationArgs = {
  input: ComposeFaApplicationInput;
};


export type MutationcomputeResourceSnapshotArgs = {
  input: ComputeResourceSnapshotInput;
};


export type MutationconfirmPaymentPreferencesArgs = {
  input: ConfirmPaymentPreferencesInput;
};


export type MutationconfirmSimplifiedPaymentAgreementArgs = {
  input: ConfirmSimplifiedPaymentAgreementInput;
};


export type MutationcreateCohortArgs = {
  members: Array<MemberInput>;
  name: Scalars['String']['input'];
};


export type MutationcreateDataQualityFlagTaskArgs = {
  input: CreateDataQualityFlagTaskInput;
};


export type MutationcreateDocumentArgs = {
  input: CreateDocumentInput;
};


export type MutationcreateGeneralFeedbackArgs = {
  input: CreateGeneralFeedbackInput;
};


export type MutationcreateIntakeCaseArgs = {
  journeyId: Scalars['String']['input'];
};


export type MutationcreateIssueChatEventArgs = {
  input?: InputMaybe<CreateIssueChatEventInput>;
};


export type MutationcreateIssueCommentEventArgs = {
  input?: InputMaybe<CreateIssueCommentEventInput>;
};


export type MutationcreateIssueConnectAccountRequestedEventArgs = {
  input?: InputMaybe<CreateIssueConnectAccountRequestedEventInput>;
};


export type MutationcreateIssueFeedbackArgs = {
  input: CreateIssueFeedbackInput;
};


export type MutationcreateIssueTaskArgs = {
  input: CreateIssueTaskInput;
};


export type MutationcreateIssueTemplateReleaseRequestedEventArgs = {
  input?: InputMaybe<CreateIssueTemplateReleaseRequestedEventInput>;
};


export type MutationcreateMultiFileDocumentArgs = {
  input: CreateMultiFileDocumentInput;
};


export type MutationcreateNateraIntakeCaseArgs = {
  input?: InputMaybe<CreateNateraIntakeCaseInput>;
};


export type MutationcreateNavigatorSpecialistInstructionsArgs = {
  input: CreateNavigatorSpecialistInstructionsInput;
};


export type MutationcreatePartnerArgs = {
  input: CreatePartnerInput;
};


export type MutationcreatePaymentPreferencesRequestedEventArgs = {
  input: CreatePaymentPreferencesRequestedEventInput;
};


export type MutationcreatePersonArgs = {
  input: CreatePersonInput;
};


export type MutationcreatePhoneCallArgs = {
  input: CreatePhoneCallInput;
};


export type MutationcreatePromoCodeArgs = {
  input: CreatePromoCodeInput;
};


export type MutationcreateProviderArgs = {
  input: CreateProviderInput;
};


export type MutationcreateResourceEditArgs = {
  input: CreateResourceEditInput;
};


export type MutationcreateRetoolNotificationArgs = {
  input: CreateRetoolNotificationInput;
};


export type MutationcreateReviewPaymentAcceptanceIssueTaskArgs = {
  input: CreateReviewPaymentAcceptanceIssueTaskInput;
};


export type MutationcreateSegmentArgs = {
  input: CreateSegmentInput;
};


export type MutationcreateSetupIntentArgs = {
  input?: InputMaybe<CreateSetupIntentInput>;
};


export type MutationcreateSubscriptionArgs = {
  input: CreateSubscriptionInput;
};


export type MutationcreateTaskCommentArgs = {
  input: CreateTaskCommentInput;
};


export type MutationcreateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationcreateWebAgentEndpointArgs = {
  input?: InputMaybe<CreateWebAgentEndpointInput>;
};


export type MutationdeclareNoIncomeDocumentsArgs = {
  input: DeclareNoIncomeDocumentsInput;
};


export type MutationdeclinePaymentPreferencesArgs = {
  input: DeclinePaymentPreferencesInput;
};


export type MutationdeleteForecastingInvestmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteForecastingScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationdeleteNavigatorSpecialistPageDiscoveryArgs = {
  input?: InputMaybe<DeleteNavigatorSpecialistPageDiscoveryInput>;
};


export type MutationdeleteProviderArgs = {
  input: DeleteProviderInput;
};


export type MutationdeleteUserDocumentArgs = {
  input: DeleteUserDocumentInput;
};


export type MutationdirectAwaitLoginResultArgs = {
  input: DirectAwaitLoginResultInput;
};


export type MutationdirectLoginToInstitutionArgs = {
  input: LoginToInstitutionInput;
};


export type MutationdirectRequestNewMfaCodeArgs = {
  input: RequestNewMfaCodeInput;
};


export type MutationdirectSelectMfaMethodArgs = {
  input: SelectMfaMethodInput;
};


export type MutationdirectStartLinkCreationArgs = {
  input: StartLinkCreationInput;
};


export type MutationdirectStartRelinkArgs = {
  input: StartLinkRelinkInput;
};


export type MutationdirectSubmitMfaCodeArgs = {
  input: SubmitMfaCodeInput;
};


export type MutationdirectSubmitSecurityAnswerArgs = {
  input: SubmitSecurityAnswerInput;
};


export type MutationdismissFindingArgs = {
  input: DismissFindingInput;
};


export type MutationdismissTaskDraftArgs = {
  input: DismissTaskDraftInput;
};


export type MutationextendStaffTailgateArgs = {
  input: StaffTailgateIdInput;
};


export type MutationfetchPhoneCallRecordingUrlArgs = {
  phoneCallEventId: Scalars['ID']['input'];
};


export type MutationfetchPhoneCallTranscriptArgs = {
  phoneCallEventId: Scalars['ID']['input'];
};


export type MutationfinalizeDocumentArgs = {
  input: FinalizeDocumentInput;
};


export type MutationfinishStaffTailgateArgs = {
  input: StaffTailgateIdInput;
};


export type MutationforceDeactivateLinkArgs = {
  input?: InputMaybe<ForceDeactivateLinkInput>;
};


export type MutationgenerateBenefitsSummaryArgs = {
  input: GenerateBenefitsSummaryInput;
};


export type MutationgenerateCaseRecommendationArgs = {
  issueId: Scalars['ID']['input'];
};


export type MutationgenerateCaseReplyDraftArgs = {
  input: GenerateCaseReplyDraftInput;
};


export type MutationgenerateFaPacketArgs = {
  input: GenerateFaPacketInput;
};


export type MutationgenerateMetabaseSignedUrlArgs = {
  input: MetabaseSignedUrlInput;
};


export type MutationheadlessLoginArgs = {
  email: Scalars['String']['input'];
  passkey: Scalars['String']['input'];
};


export type MutationingestStaffTailgateFileArgs = {
  input: IngestStaffTailgateFileInput;
};


export type MutationinviteBeneficiaryArgs = {
  input: InviteBeneficiaryInput;
};


export type MutationlogAircallCallArgs = {
  input: LogAircallCallInput;
};


export type MutationmanuallyEscalateIssueArgs = {
  input: ManuallyEscalateIssueInput;
};


export type MutationmarkCaseRoomProposalShownArgs = {
  suggestionId: Scalars['ID']['input'];
};


export type MutationmarkPromoCodeUsageAsUnusedArgs = {
  input: MarkPromoCodeUsageAsUnusedInput;
};


export type MutationmarkRetoolNotificationAsReadArgs = {
  input: MarkRetoolNotificationAsReadInput;
};


export type MutationmergePersonsArgs = {
  input: MergePersonsInput;
};


export type MutationonboardBeneficiaryArgs = {
  input: OnboardBeneficiaryInput;
};


export type MutationopenCaseRoomArgs = {
  issueId: Scalars['ID']['input'];
};


export type MutationopenNewIssueArgs = {
  input?: InputMaybe<OpenNewIssueInput>;
};


export type MutationopenNewIssueFromPreviewArgs = {
  input?: InputMaybe<OpenNewIssueFromPreviewInput>;
};


export type MutationpreAuthorizePaymentPreferencesArgs = {
  input: PreAuthorizePaymentPreferencesInput;
};


export type MutationprefillFaApplicationArgs = {
  input: PrefillFaApplicationInput;
};


export type MutationprefillFaApplicationAsStaffArgs = {
  input: PrefillFaApplicationInput;
};


export type MutationprepareProviderFormUploadArgs = {
  input: PrepareProviderFormUploadInput;
};


export type MutationprocessDocumentForAnalysisArgs = {
  input: ProcessDocumentForAnalysisInput;
};


export type MutationprovideUserInputAnswerArgs = {
  input: ProvideUserInputAnswerInput;
};


export type MutationqueryOpenaiArgs = {
  input: LlmInput;
};


export type MutationrecalculateEligibilityEnrollmentArgs = {
  input: RecalculateEligibilityEnrollmentInput;
};


export type MutationreclassifyRpaSessionArgs = {
  input: ReclassifyRpaSessionInput;
};


export type MutationreclassifyRpaSessionAsAgentArgs = {
  input: ReclassifyRpaSessionAsAgentInput;
};


export type MutationrecordCalibrationDeltasArgs = {
  deltas: Array<CalibrationDeltaInput>;
};


export type MutationrecordHaEventsArgs = {
  events: Array<HaEventInput>;
};


export type MutationrecordIdentityArgs = {
  input: RecordIdentityInput;
};


export type MutationrecordInsuranceArgs = {
  input: RecordInsuranceInput;
};


export type MutationrecordInsuranceStatusArgs = {
  input: RecordInsuranceStatusInput;
};


export type MutationrecordIssueEventFeedbackArgs = {
  input: RecordIssueEventFeedbackInput;
};


export type MutationrecordNateraIntakeAnswersArgs = {
  input: RecordNateraIntakeAnswersInput;
};


export type MutationrecordPhoneArgs = {
  input: RecordPhoneInput;
};


export type MutationrejectSuggestedActionArgs = {
  input: RejectSuggestedActionInput;
};


export type MutationremoveNegotiationProfileArgs = {
  input: RemoveNegotiationProfileInput;
};


export type MutationremoveProviderContactPointArgs = {
  input: RemoveProviderContactPointInput;
};


export type MutationremoveProviderFaPolicyArgs = {
  input: RemoveProviderFaPolicyInput;
};


export type MutationremoveProviderFormArgs = {
  input: RemoveProviderFormInput;
};


export type MutationremoveUserSegmentArgs = {
  input: RemoveUserSegmentInput;
};


export type MutationrenameProviderFormArgs = {
  input: RenameProviderFormInput;
};


export type MutationreopenIssueArgs = {
  input: ReopenIssueInput;
};


export type MutationrepinFaApplicationFormArgs = {
  input: RepinFaApplicationFormInput;
};


export type MutationrequestCardCollectionArgs = {
  input: RequestCardCollectionInput;
};


export type MutationrequestNateraIntakeReminderArgs = {
  input: RequestNateraIntakeReminderInput;
};


export type MutationrequestProviderResearchArgs = {
  providerId: Scalars['ID']['input'];
};


export type MutationresendFaFlowForIssueArgs = {
  input: ResendFaFlowInput;
};


export type MutationresendMagicLinkArgs = {
  input: ResendMagicLinkInput;
};


export type MutationreviewFindingArgs = {
  input: ReviewFindingInput;
};


export type MutationrunAllHealthChecksArgs = {
  input?: InputMaybe<RunAllHealthChecksInput>;
};


export type MutationrunInsuranceDiscoveryArgs = {
  input: RunInsuranceDiscoveryInput;
};


export type MutationsaveFaApplicationDraftArgs = {
  input: SaveFaApplicationDraftInput;
};


export type MutationsaveForecastingForecastInputsArgs = {
  input: SaveForecastingForecastInputsInput;
};


export type MutationsaveForecastingInvestmentArgs = {
  input: SaveForecastingInvestmentInput;
};


export type MutationsaveForecastingScenarioArgs = {
  input: SaveForecastingScenarioInput;
};


export type MutationsaveIntakeArgs = {
  input: SaveIntakeInput;
};


export type MutationsaveNotesArgs = {
  input: SaveNotesInput;
};


export type MutationscheduleDelayedChargeArgs = {
  input: ScheduleDelayedChargeInput;
};


export type MutationselectPlanForEventArgs = {
  input: SelectPlanForEventInput;
};


export type MutationsendCaseRoomMessageArgs = {
  input: SendCaseRoomMessageInput;
};


export type MutationsendDocumentToUserArgs = {
  input: SendDocumentToUserInput;
};


export type MutationsendDocumentsToUserArgs = {
  input: SendDocumentsToUserInput;
};


export type MutationsendMagicLinkArgs = {
  input: SendMagicLinkInput;
};


export type MutationsetCasePriorityOverrideArgs = {
  input: SetCasePriorityOverrideInput;
};


export type MutationsetCaseProviderArgs = {
  input: SetCaseProviderInput;
};


export type MutationsetEndpointCdpProviderArgs = {
  input?: InputMaybe<SetEndpointCdpProviderInput>;
};


export type MutationsetForecastingOverrideArgs = {
  input: SetForecastingOverrideInput;
};


export type MutationsetProviderFormShapingArgs = {
  input: SetProviderFormShapingInput;
};


export type MutationshadowLoginArgs = {
  input: ShadowLoginInput;
};


export type MutationsignAndSaveTemplateArgs = {
  input: SignAndSaveTemplateInput;
};


export type MutationsignAndSaveTemplateValuesArgs = {
  input: SignAndSaveTemplateValuesInput;
};


export type MutationsignAnonymousSessionArgs = {
  botControlToken?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
};


export type MutationsignHipaaReleaseArgs = {
  input: SignHipaaReleaseInput;
};


export type MutationskipFaApplicationForIssueArgs = {
  input: SkipFaApplicationInput;
};


export type MutationstaffOpenNewIssueArgs = {
  input?: InputMaybe<StaffOpenNewIssueInput>;
};


export type MutationstartBackfillArgs = {
  input: StartBackfillInput;
};


export type MutationstartCohortEligibilityRefreshArgs = {
  input: StartCohortEligibilityRefreshInput;
};


export type MutationstartEventReplayArgs = {
  input: StartEventReplayInput;
};


export type MutationstartExperimentArgs = {
  cohortId: Scalars['String']['input'];
  initialState?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationstartFaApplicationForIssueArgs = {
  input: StartFaApplicationInput;
};


export type MutationstartFaFlowForIssueArgs = {
  input: StartFaFlowInput;
};


export type MutationstartHealthCheckArgs = {
  input?: InputMaybe<StartHealthCheckInput>;
};


export type MutationstartLinkSignInArgs = {
  input?: InputMaybe<StartLinkSignInInput>;
};


export type MutationstartManualIntakeArgs = {
  input: StartManualIntakeInput;
};


export type MutationstartPersonBackfillArgs = {
  input: StartPersonBackfillInput;
};


export type MutationstartPostEscalationQuestionArgs = {
  input: StartPostEscalationQuestionInput;
};


export type MutationstartProviderFormDetectionArgs = {
  input: StartProviderFormDetectionInput;
};


export type MutationstartRPADebugArgs = {
  input: StartRPADebugInput;
};


export type MutationstartRecrawlFromExecutionArgs = {
  input: StartRecrawlFromExecutionInput;
};


export type MutationstartRecrawlFromLinkArgs = {
  input: StartRecrawlFromLinkInput;
};


export type MutationstartStaffTailgateArgs = {
  input: StartStaffTailgateInput;
};


export type MutationstartTailgateArgs = {
  input: StartTailgateInput;
};


export type MutationstopCaseRoomTurnArgs = {
  roomId: Scalars['ID']['input'];
};


export type MutationstopExperimentArgs = {
  experimentId: Scalars['String']['input'];
};


export type MutationstopRPADebugArgs = {
  input: StopRPADebugInput;
};


export type MutationsubmitFaApplicationArgs = {
  input: SubmitFaApplicationInput;
};


export type MutationsubmitHaFeedbackArgs = {
  input: HaFeedbackInput;
};


export type MutationsubmitManagedMfaApprovalArgs = {
  input?: InputMaybe<SubmitManagedMfaApprovalInput>;
};


export type MutationsubmitMessageArgs = {
  input: RedisMessage;
};


export type MutationsubmitRecommendationFeedbackArgs = {
  input: RecommendationFeedbackInput;
};


export type MutationtrackInsuranceLinkAttemptArgs = {
  input: TrackInsuranceLinkAttemptInput;
};


export type MutationupdateCrawlObjectiveReviewArgs = {
  input: UpdateCrawlObjectiveReviewInput;
};


export type MutationupdateCrawlReviewArgs = {
  input: UpdateCrawlReviewInput;
};


export type MutationupdateDefaultTemplateArgs = {
  input: UpdateDefaultTemplateInput;
};


export type MutationupdateDocumentNameArgs = {
  input: UpdateDocumentNameInput;
};


export type MutationupdateEndpointSupportLevelArgs = {
  input: UpdateEndpointSupportLevelInput;
};


export type MutationupdateFileNameArgs = {
  input: UpdateFileNameInput;
};


export type MutationupdateFindingArgs = {
  input: UpdateFindingInput;
};


export type MutationupdateInsuranceLinkAttemptInvestigationUrlsArgs = {
  input: Array<InputMaybe<UpdateInsuranceLinkAttemptInvestigationUrlInput>>;
};


export type MutationupdateIssueArgs = {
  input?: InputMaybe<UpdateIssueInput>;
};


export type MutationupdateIssueCommentEventPinnedArgs = {
  input: UpdateIssueCommentEventPinnedInput;
};


export type MutationupdateIssueEventArgs = {
  input?: InputMaybe<UpdateIssueEventInput>;
};


export type MutationupdateNavigatorSpecialistInstructionsArgs = {
  input: UpdateNavigatorSpecialistInstructionsInput;
};


export type MutationupdateNavigatorSpecialistPageDiscoveryIsActiveArgs = {
  input?: InputMaybe<UpdateNavigatorSpecialistPageDiscoveryIsActiveInput>;
};


export type MutationupdateNavigatorSpecialistPageDiscoveryJsonArgs = {
  input?: InputMaybe<UpdateNavigatorSpecialistPageDiscoveryJsonInput>;
};


export type MutationupdatePaymentAgreementEventArgs = {
  input?: InputMaybe<UpdatePaymentAgreementEventInput>;
};


export type MutationupdatePaymentPreferencesArgs = {
  input: UpdatePaymentPreferencesInput;
};


export type MutationupdatePaymentProfileArgs = {
  input: UpdatePaymentProfileInput;
};


export type MutationupdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationupdatePersonAddressArgs = {
  input: UpdatePersonAddressInput;
};


export type MutationupdatePromoCodeArgs = {
  input: UpdatePromoCodeInput;
};


export type MutationupdateProviderArgs = {
  input: UpdateProviderInput;
};


export type MutationupdateSubscriptionPaymentMethodArgs = {
  input: UpdateSubscriptionPaymentMethodInput;
};


export type MutationupdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationupdateTaskCommentArgs = {
  input: UpdateTaskCommentInput;
};


export type MutationupdateTaskCommentPinnedArgs = {
  input: UpdateTaskCommentPinnedInput;
};


export type MutationupdateTemplatesArgs = {
  input: UpdateTemplatesInput;
};


export type MutationupdateWebAgentEndpointArgs = {
  input?: InputMaybe<UpdateWebAgentEndpointInput>;
};


export type MutationupsertFaApplicationArgs = {
  input: UpsertFaApplicationInput;
};


export type MutationupsertNegotiationProfileArgs = {
  input: UpsertNegotiationProfileInput;
};


export type MutationupsertProviderContactPointArgs = {
  input: UpsertProviderContactPointInput;
};


export type MutationupsertProviderFaPolicyArgs = {
  input: UpsertProviderFaPolicyInput;
};


export type MutationupsertProviderFormArgs = {
  input: UpsertProviderFormInput;
};


export type MutationupsertUserSegmentationDataArgs = {
  input: UpsertUserSegmentationDataInput;
};


export type MutationvalidateTemplateArgs = {
  input: ValidateTemplateInput;
};


export type MutationvalidateTemplateValuesArgs = {
  input: ValidateTemplateValuesInput;
};


export type MutationverifyNegotiationProfileArgs = {
  input: VerifyNegotiationProfileInput;
};


export type MutationverifyProviderArgs = {
  input: VerifyProviderInput;
};

export type NateraIntakeActivation = {
  __typename: 'NateraIntakeActivation';
  escalated: Scalars['Boolean']['output'];
  /**
   * Template the HIPAA_RELEASE item must sign, so the caller signs the same one
   * completeness reads. Always the release flagged default — the generic Granted
   * authorization, never an insurer-specific form: the counterparty that matters
   * at activation is Natera itself. Null only when no default release exists — a
   * misconfiguration, in which case the item is dropped from required and the
   * case escalates without a release for an advocate to collect, rather than
   * holding the member at a hub that can never complete.
   */
  hipaaTemplateId?: Maybe<Scalars['ID']['output']>;
  /**
   * The eligibility check found active coverage with a member ID and a group
   * ID, so the insurance-card item is settled without an upload.
   */
  insuranceVerified: Scalars['Boolean']['output'];
  issueId: Scalars['ID']['output'];
  /** Required items still outstanding. Empty if and only if the case is escalated. */
  missing: Array<NateraIntakeActivationItem>;
  /**
   * When the member asked to be reminded to finish, or null. Set by
   * `requestNateraIntakeReminder`; the hub shows the saved-state banner and
   * withdraws the offer while it is set.
   */
  reminderAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Every item this case asks for, conditional ones included only when they
   * apply. `missing` is a subset: an item here but not there is done. Empty once
   * the case is escalated — activation is over and there is no checklist left.
   */
  required: Array<NateraIntakeActivationItem>;
  /**
   * The member told us they have no coverage and no card is on file, so the
   * insurance-card item is settled by that answer rather than a document. The hub
   * records it without the upload tick, which would claim a document that does
   * not exist.
   */
  uninsuredDeclared: Scalars['Boolean']['output'];
  /**
   * How many documents the case holds for each document item in `required`. A
   * photo bundle is one document and a PDF is one document, whatever their page
   * count. The hub shows the number on a received row and keeps the row addable.
   */
  uploadCounts: Array<NateraIntakeActivationUploadCount>;
};

export enum NateraIntakeActivationItem {
  BILL_UPLOAD = 'BILL_UPLOAD',
  HIPAA_RELEASE = 'HIPAA_RELEASE',
  INCOME_DOCUMENT = 'INCOME_DOCUMENT',
  INSURANCE_CARD = 'INSURANCE_CARD',
  PAYMENT_PREFERENCES = 'PAYMENT_PREFERENCES'
}

export type NateraIntakeActivationUploadCount = {
  __typename: 'NateraIntakeActivationUploadCount';
  count: Scalars['Int']['output'];
  item: NateraIntakeActivationItem;
};

export type NateraIntakeCase = {
  __typename: 'NateraIntakeCase';
  /**
   * False when the caller already had an un-escalated funnel case, which is
   * returned as-is so a re-entry lands on their existing activation hub.
   */
  created: Scalars['Boolean']['output'];
  issueId: Scalars['ID']['output'];
  /**
   * The route this case is actually on, read from the label the server stamped —
   * not from the requested mode, and not from the flag. Clients route on this.
   */
  mode: NateraIntakeMode;
  /**
   * Always the payment request for a caller that sent no `mode`: such a client
   * selects this as required and renders nothing but the hub, so a chat case
   * raises its request early rather than hand one back empty.
   * @deprecated Use paymentPreferencesRequestId, which is null on a chat case that has not reached its payment step.
   */
  paymentPreferencesEventId: Scalars['ID']['output'];
  /**
   * The request the hub's payment step acts on. Null while a chat-route case has
   * not reached its own payment step: the intake flow raises the request itself,
   * after the HIPAA ask, so there is none to hand back at creation.
   */
  paymentPreferencesRequestId?: Maybe<Scalars['ID']['output']>;
};

/**
 * The funnel's inline financial-assistance read. LIKELY_QUALIFY is the only
 * branch that makes an income document a required activation item.
 */
export enum NateraIntakeFaRead {
  LIKELY_QUALIFY = 'LIKELY_QUALIFY',
  NEGOTIATION_UNAVAILABLE = 'NEGOTIATION_UNAVAILABLE',
  UNLIKELY_QUALIFY = 'UNLIKELY_QUALIFY'
}

/**
 * Retained so a bundle built before the funnel dropped its coverage screens can
 * still submit. Read only as a stand-in for a packet stored while the funnel
 * asked, until the member's own declaration exists in user memory.
 */
export enum NateraIntakeInsuranceStatus {
  INSURED = 'INSURED',
  UNINSURED = 'UNINSURED',
  UNSURE = 'UNSURE'
}

/**
 * Where a funnel case collects HIPAA, payment preferences and its documents.
 * HUB is the activation checklist; CHAT is the deterministic intake flow on the
 * case timeline.
 */
export enum NateraIntakeMode {
  CHAT = 'CHAT',
  HUB = 'HUB'
}

/**
 * Answers the Natera partner intake funnel collected before the account existed,
 * stored verbatim on the case. That funnel is a one-off built for the Natera
 * partnership rather than a general intake path, so this packet is shaped around
 * its questions and is not meant to grow into a shared contract.
 *
 * Every skippable answer is nullable and must be sent as an
 * explicit null rather than omitted — the warehouse reads this packet with plain
 * field access, and an absent key is not the same as a declined answer.
 *
 * Carries nothing about coverage. What the member says about having insurance is
 * user memory (`recordInsuranceStatus`), which the activation gate and the
 * post-escalation checklist both read; a copy here would be a second answer able
 * to disagree with the one they act on. The two coverage fields are still
 * accepted so that a bundle from before the screens were dropped does not fail
 * validation on the whole signup send during a deploy skew; a packet that
 * carries them is read only until memory holds the member's own answer.
 */
export type NateraIntakePacketInput = {
  /**
   * Which framing of the email step the member was served, so the arm survives to
   * the case even when the code is redeemed on a device the funnel never ran on.
   * Null from clients predating the experiment.
   */
  accountCopyVariant?: InputMaybe<Scalars['String']['input']>;
  /**
   * Null when, and only when, incomeDeclined is true. A range pick sends a figure
   * sampled from the band, with the band beside it; never a stand-in for a
   * declined answer.
   */
  annualHouseholdIncomeCents?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A figure the member typed. Null when skipped, and on every packet the banded funnel
   * sends — the two fields below carry the answer there.
   */
  billAmountCents?: InputMaybe<Scalars['Int']['input']>;
  /**
   * 1, 2, or 3 meaning "three or more". Natera settles a second bill at a higher
   * flat amount; at three or more there is no calibrated target to quote.
   */
  billCount: Scalars['Int']['input'];
  billRangeCeilingCents?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The range the member picked instead of typing a figure; both null on typed, skipped
   * and older-client packets. No representative figure rides alongside — the result
   * screen quotes the bill back, so a sampled one would be shown as theirs.
   */
  billRangeFloorCents?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The express experiment arm the user was served, raw. An express packet may
   * lack household, income and FA read, which \`recordNateraIntakeAnswers\` fills
   * in after sign-up; the case opens only once they are there.
   */
  expressArm?: InputMaybe<Scalars['String']['input']>;
  /** Null only on an express-arm packet, which reads FA after sign-up. */
  faRead?: InputMaybe<NateraIntakeFaRead>;
  feeling?: InputMaybe<Scalars['String']['input']>;
  /** Household size including an unborn child. */
  householdSize?: InputMaybe<Scalars['Int']['input']>;
  /** Null only on an express-arm packet, which collects income after sign-up. */
  incomeDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  incomeRangeCeilingCents?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The band the member picked, when the figure was a range pick rather than a typed
   * amount. Floor is null on the lowest band, ceiling on the open top band; both absent
   * from typed, declined, and older-client packets.
   */
  incomeRangeFloorCents?: InputMaybe<Scalars['Int']['input']>;
  /** @deprecated The funnel no longer asks. Recorded to user memory by recordInsuranceStatus. */
  insuranceCarrier?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated The funnel no longer asks. Recorded to user memory by recordInsuranceStatus. */
  insuranceStatus?: InputMaybe<NateraIntakeInsuranceStatus>;
  /** Where the hero questions were answered: offsite, onsite, or routing. */
  landingEntry?: InputMaybe<Scalars['String']['input']>;
  persona?: InputMaybe<Scalars['String']['input']>;
  /**
   * The playbook experiment arm the member was served, raw, so it survives to the
   * case whichever device redeems the code. Null when the member was never
   * enrolled or the client predates the experiment.
   */
  playbookArm?: InputMaybe<Scalars['String']['input']>;
  /**
   * The end price the result screen quoted, in cents, so a campaign quotes what the
   * member was shown rather than a later recompute. Zero is a real target: the
   * lowest tier is free. Absent from older clients, which the server re-derives.
   */
  projectedTargetCents?: InputMaybe<Scalars['Int']['input']>;
  story?: InputMaybe<Scalars['String']['input']>;
  /**
   * The story experiment arm the member was served, raw. Null when the member was
   * never enrolled or the client predates the experiment.
   */
  storyArm?: InputMaybe<Scalars['String']['input']>;
  /** 1–5, or null when the member skipped the question. */
  stressLevel?: InputMaybe<Scalars['Int']['input']>;
};

export enum NateraIntakeResumeDestination {
  ACTIVATION = 'ACTIVATION',
  HOME = 'HOME'
}

/**
 * What the charge would put on the invoice and take off the card. All money is
 * integer cents.
 */
export type NegotiatedBillChargePreview = {
  __typename: 'NegotiatedBillChargePreview';
  /** Bill line; 0 in success-fee-only mode. */
  billCents: Scalars['Int']['output'];
  exceedsMaxSettle: Scalars['Boolean']['output'];
  exceedsMaxSingleCharge: Scalars['Boolean']['output'];
  /**
   * Which rule in the fee-cap table produced feeCapCents — read back from the
   * capture's snapshot, not from live membership, so a cap stays explained by
   * what was captured. Null for a snapshot taken under an older cap table.
   */
  feeCapBasis?: Maybe<NegotiatedBillFeeCapBasis>;
  feeCapCents: Scalars['Int']['output'];
  /** The cap bound: the percentage fee was reduced to feeCapCents. */
  feeCapped: Scalars['Boolean']['output'];
  feePercent: Scalars['Int']['output'];
  /**
   * Zero cap — a full waive (FFGA on an FA case), as opposed to a $0 fee that
   * just fell out of no savings.
   */
  feeWaived: Scalars['Boolean']['output'];
  maxSettleCents?: Maybe<Scalars['Int']['output']>;
  /** Null on an accept-any capture, which stores no ceilings. */
  maxSingleChargeCents?: Maybe<Scalars['Int']['output']>;
  originalBillCents: Scalars['Int']['output'];
  promoCode?: Maybe<Scalars['String']['output']>;
  /** How much the promo takes off the fee; 0 when no promo applies. */
  promoDiscountCents: Scalars['Int']['output'];
  /** Post-cap, pre-promo fee — the amount that lands on the invoice's fee line. */
  rawFeeCents: Scalars['Int']['output'];
  savingsCents: Scalars['Int']['output'];
  settledCents: Scalars['Int']['output'];
  /** What the card is actually charged for the fee, after any promo. */
  successFeeCents: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
};

/**
 * What chargeNegotiatedBill would do with these inputs, without doing it. Exactly
 * one side is set. Null whenever the case can't be priced at all — no confirmed
 * payment-preferences capture, since the legacy bill-pay path prices differently.
 */
export type NegotiatedBillChargePreviewResult = {
  __typename: 'NegotiatedBillChargePreviewResult';
  /** Set when the charge would go through. */
  breakdown?: Maybe<NegotiatedBillChargePreview>;
  /**
   * The charge's own refusal message, raised before the click instead of after
   * it. Set when the charge would reject these inputs.
   */
  refusal?: Maybe<Scalars['String']['output']>;
};

/** Fee-cap rules, mirroring resolveFeeCap. FFGA on an FA case is a full waive. */
export enum NegotiatedBillFeeCapBasis {
  FFGA_FA_WAIVE = 'FFGA_FA_WAIVE',
  FFGA_NEGOTIATION = 'FFGA_NEGOTIATION',
  STANDARD_FA = 'STANDARD_FA',
  STANDARD_NEGOTIATION = 'STANDARD_NEGOTIATION'
}

export type NestedFilterPerson = {
  addresses?: InputMaybe<person__NestedFilterAddress>;
  createdAt?: InputMaybe<FilterString>;
  dateOfBirth?: InputMaybe<FilterString>;
  emailAddress?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  familyName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  phoneNumber?: InputMaybe<FilterString>;
  primary?: InputMaybe<FilterBoolean>;
  primaryAddress?: InputMaybe<person__NestedFilterAddress>;
};

export type NestedFilterUser = {
  acceptedTermsAt?: InputMaybe<FilterString>;
  acceptedTermsVersion?: InputMaybe<FilterString>;
  accounts?: InputMaybe<fhirext__NestedFilterAccountVersion>;
  anonymousConvertedAt?: InputMaybe<FilterString>;
  anonymousSessionId?: InputMaybe<FilterString>;
  attribution?: InputMaybe<FilterJSON>;
  createdAt?: InputMaybe<FilterString>;
  deletionRequestedAt?: InputMaybe<FilterString>;
  emails?: InputMaybe<user__NestedFilterEmail>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  explanationOfBenefits?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitVersion>;
  firstAuthenticatedAt?: InputMaybe<FilterString>;
  flexpaLinks?: InputMaybe<flexpa__NestedFilterLink>;
  hasSeenHome?: InputMaybe<FilterBoolean>;
  hipaaRelease?: InputMaybe<consent__NestedFilterHipaaRelease>;
  id?: InputMaybe<FilterID>;
  invoices?: InputMaybe<fhirext__NestedFilterInvoiceVersion>;
  isAdmin?: InputMaybe<FilterBoolean>;
  isAnonymous?: InputMaybe<FilterBoolean>;
  issues?: InputMaybe<issue__NestedFilterIssue>;
  lastAuthenticatedAt?: InputMaybe<FilterString>;
  lastSessionRefreshedAt?: InputMaybe<FilterString>;
  notesAsHtml?: InputMaybe<FilterString>;
  pendingAttribution?: InputMaybe<FilterJSON>;
  pendingAttributionExpiresAt?: InputMaybe<FilterString>;
  pendingInviteToken?: InputMaybe<FilterString>;
  pendingInviteTokenExpiresAt?: InputMaybe<FilterString>;
  pendingNateraIntake?: InputMaybe<FilterJSON>;
  persons?: InputMaybe<NestedFilterPerson>;
  primaryEmail?: InputMaybe<FilterString>;
  primaryPerson?: InputMaybe<NestedFilterPerson>;
  profile?: InputMaybe<user__NestedFilterProfile>;
  promoCodeUsages?: InputMaybe<payment__NestedFilterIssuePromoCodeUsage>;
  registrationSource?: InputMaybe<FilterString>;
  segmentationData?: InputMaybe<user__NestedFilterSegmentationData>;
  segments?: InputMaybe<segment__NestedFilterUserSegment>;
  source?: InputMaybe<partner__NestedFilterPartner>;
  stytchId?: InputMaybe<FilterString>;
  tasks?: InputMaybe<taskManagement__NestedFilterTask>;
  templateReleases?: InputMaybe<consent__NestedFilterTemplateRelease>;
  userExitInsuranceLinkFeedback?: InputMaybe<webAgent__NestedFilterUserExitInsuranceLinkFeedback>;
  webAgentLinks?: InputMaybe<webAgent__NestedFilterLink>;
};

export type NoMatchingPerson = {
  __typename: 'NoMatchingPerson';
  dob: Scalars['String']['output'];
  familyName?: Maybe<Scalars['String']['output']>;
  givenNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type NotifyUsersOfFindingsResult = {
  __typename: 'NotifyUsersOfFindingsResult';
  success: Scalars['Boolean']['output'];
  workflowId?: Maybe<Scalars['String']['output']>;
};

/** Root object type for user-defined types */
export type Object = {
  id: Scalars['ID']['output'];
};

export type OnboardBeneficiaryInput = {
  /** The beneficiary being onboarded. */
  beneficiaryId: Scalars['ID']['input'];
  /** The user who onboarded. Recorded on the beneficiary. */
  userId: Scalars['ID']['input'];
};

export type OnboardingAck = {
  __typename: 'OnboardingAck';
  ok: Scalars['Boolean']['output'];
};

/** Asked, not yet satisfied. */
export type OpenCaseRequirement = {
  __typename: 'OpenCaseRequirement';
  /** How many asks stand behind it; a re-ask does not mint a requirement. */
  askCount: Scalars['Int']['output'];
  key: Scalars['ID']['output'];
  kind: CaseRequirementKind;
  /**
   * How long the party in `waitingOn` has owed the move — the age to show. Each
   * kind dates it from whatever started that wait, so this is not always the
   * first ask: a declined payment agreement dates from the decline, which is when
   * the move became ours.
   */
  since: Scalars['DateTime']['output'];
  target: CaseRequirementTarget;
  waitingOn: CaseRequirementWaitingOn;
};

export type OpenNewIssueFromPreviewInput = {
  caseType: Scalars['String']['input'];
  /** @deprecated The endpoint now supports document uploads as part of the messages array. This flag should be false in those cases and will be removed in a future release. */
  isFromUpload?: InputMaybe<Scalars['Boolean']['input']>;
  messages: Array<PreviewMessage>;
  /**
   * Scan-surface provenance for a HOME scan upload — the case is created here,
   * not via finalizeDocument, so this is the only place HOME's entry point can
   * ride. The server owns the in-scope allowlist, so an unrecognised or absent
   * value keeps the document out of the scan-quality experiment's guardrail.
   */
  scanbotEntryPoint?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type OpenNewIssueInput = {
  additionalDetails?: InputMaybe<Scalars['String']['input']>;
  benefitsCoverage?: InputMaybe<Scalars['String']['input']>;
  benefitsInclude?: InputMaybe<Array<Scalars['String']['input']>>;
  benefitsPrice?: InputMaybe<Scalars['String']['input']>;
  benefitsQuestionType?: InputMaybe<Scalars['String']['input']>;
  billDisputeType?: InputMaybe<Scalars['String']['input']>;
  caseType?: InputMaybe<Scalars['String']['input']>;
  eobId?: InputMaybe<Scalars['String']['input']>;
  healthRecordKey?: InputMaybe<Scalars['String']['input']>;
  healthRecordKind?: InputMaybe<Scalars['String']['input']>;
  includeInitialSystemMessage?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  issueType?: InputMaybe<IssueType>;
  personId?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  withUserMessage?: InputMaybe<Scalars['String']['input']>;
};

export type OrderBaseObject = {
  id?: InputMaybe<Ordering>;
};

export type OrderObject = {
  id?: InputMaybe<Ordering>;
};

export type OrderOwned = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type OrderPerson = {
  createdAt?: InputMaybe<Ordering>;
  dateOfBirth?: InputMaybe<Ordering>;
  emailAddress?: InputMaybe<Ordering>;
  familyName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  phoneNumber?: InputMaybe<Ordering>;
  primary?: InputMaybe<Ordering>;
  primaryAddress?: InputMaybe<person__OrderAddress>;
};

export type OrderPersonal = {
  id?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
};

export type OrderSlugged = {
  id?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
};

export type OrderUser = {
  acceptedTermsAt?: InputMaybe<Ordering>;
  acceptedTermsVersion?: InputMaybe<Ordering>;
  anonymousConvertedAt?: InputMaybe<Ordering>;
  anonymousSessionId?: InputMaybe<Ordering>;
  attribution?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  deletionRequestedAt?: InputMaybe<Ordering>;
  firstAuthenticatedAt?: InputMaybe<Ordering>;
  hasSeenHome?: InputMaybe<Ordering>;
  hipaaRelease?: InputMaybe<consent__OrderHipaaRelease>;
  id?: InputMaybe<Ordering>;
  isAdmin?: InputMaybe<Ordering>;
  isAnonymous?: InputMaybe<Ordering>;
  lastAuthenticatedAt?: InputMaybe<Ordering>;
  lastSessionRefreshedAt?: InputMaybe<Ordering>;
  notesAsHtml?: InputMaybe<Ordering>;
  pendingAttribution?: InputMaybe<Ordering>;
  pendingAttributionExpiresAt?: InputMaybe<Ordering>;
  pendingInviteToken?: InputMaybe<Ordering>;
  pendingInviteTokenExpiresAt?: InputMaybe<Ordering>;
  pendingNateraIntake?: InputMaybe<Ordering>;
  primaryEmail?: InputMaybe<Ordering>;
  primaryPerson?: InputMaybe<OrderPerson>;
  profile?: InputMaybe<user__OrderProfile>;
  registrationSource?: InputMaybe<Ordering>;
  segmentationData?: InputMaybe<user__OrderSegmentationData>;
  source?: InputMaybe<partner__OrderPartner>;
  stytchId?: InputMaybe<Ordering>;
};

export type OrderVerifiable = {
  id?: InputMaybe<Ordering>;
  lastVerified?: InputMaybe<Ordering>;
  verified?: InputMaybe<Ordering>;
  verifiedBy?: InputMaybe<OrderUser>;
};

export type Ordering = {
  dir: directionEnum;
  nulls?: InputMaybe<nullsOrderingEnum>;
};

export type Owned = {
  id: Scalars['ID']['output'];
  owner: User;
};


export type OwnedownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum Participant {
  SERVICE = 'SERVICE',
  STAFF = 'STAFF',
  USER = 'USER'
}

/**
 * An external organization Granted has a partnership with. Non-PHI
 * configuration.
 */
export type Partner = {
  __typename: 'Partner';
  createdAt: Scalars['DateTime']['output'];
  groups: Array<PartnerGroup>;
  id: Scalars['ID']['output'];
  /**
   * False when the partner has been deactivated. Deactivated partners are
   * retained so existing links and lineage survive.
   */
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Stable, human-readable handle derived from the name at creation. Unique. */
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A group or unit within a partner. */
export type PartnerGroup = {
  __typename: 'PartnerGroup';
  createdAt: Scalars['DateTime']['output'];
  /**
   * The partner's own identifier for the group in their system. Null when not
   * yet known.
   */
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** A payer in the catalog. */
export type Payer = {
  __typename: 'Payer';
  /** Other names the payer is known by. */
  alternateNames: Array<Scalars['String']['output']>;
  /** Null when the payer's coverage has not been classified. */
  coverageTypes?: Maybe<Array<PayerCoverageType>>;
  displayName: Scalars['String']['output'];
  /** A shorter display name, when one is recorded. */
  displayNameShort?: Maybe<Scalars['String']['output']>;
  /** Null when support is not recorded or is a value this API does not know. */
  eligibilityCheckSupport?: Maybe<PayerSupportLevel>;
  employerIdentificationNumbers: Array<Scalars['String']['output']>;
  /** Whether enrolling with the payer requires a Medicare PTAN. Null when unstated. */
  enrollmentRequiresPtan?: Maybe<Scalars['Boolean']['output']>;
  /** Enrollment steps for the transactions that need enrollment. */
  enrollments: Array<PayerEnrollment>;
  id: Scalars['ID']['output'];
  /** False once the payer has left the clearinghouse network. */
  isActive: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the payer rejects an eligibility check that carries no member ID.
   * When false, the member's name and date of birth are enough.
   */
  memberIdRequired: Scalars['Boolean']['output'];
  /**
   * Two-letter state or territory codes, or NATIONAL. Null when the payer's
   * regions have not been classified.
   */
  operatingRegions?: Maybe<Array<Scalars['String']['output']>>;
  parentGroupId?: Maybe<Scalars['String']['output']>;
  parentGroupName?: Maybe<Scalars['String']['output']>;
  /**
   * Every payer ID currently accepted for this payer, including the primary.
   * Empty for an inactive payer.
   */
  payerIds: Array<Scalars['String']['output']>;
  /**
   * The payer ID most commonly used. This is the value an eligibility check sends
   * to identify the payer. For an inactive payer it is the last one the payer
   * had, which the clearinghouse may since have given to another payer.
   */
  primaryPayerId: Scalars['String']['output'];
  /** Insurance programs the payer serves, e.g. COMMERCIAL, MEDICARE, MEDICAID. */
  programs: Array<Scalars['String']['output']>;
  /**
   * Support for each transaction the clearinghouse reports a known level for.
   * Transactions with no recorded level, or a level this API does not know, are
   * omitted.
   */
  transactionSupport: Array<PayerSupport>;
  /** The clearinghouse's own ID for the payer. */
  vendorPayerId: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

/** Coverage a payer offers. */
export enum PayerCoverageType {
  DENTAL = 'DENTAL',
  MEDICAL = 'MEDICAL',
  VISION = 'VISION'
}

/** How enrollment for one transaction is completed. */
export type PayerEnrollment = {
  __typename: 'PayerEnrollment';
  /**
   * How claim payment advice can be grouped, e.g. NPI or TIN. Empty when the
   * transaction offers no choice.
   */
  remittanceAggregations: Array<Scalars['String']['output']>;
  /** Whether enrollment accepts a requested effective date. Null when unstated. */
  requestedEffectiveDateSupported?: Maybe<Scalars['Boolean']['output']>;
  /** Null when not recorded or a value this API does not know. */
  timeframe?: Maybe<PayerEnrollmentTimeframe>;
  transaction: PayerTransaction;
  /** Null when not recorded or a value this API does not know. */
  type?: Maybe<PayerEnrollmentType>;
};

/** How long enrollment for a transaction takes. */
export enum PayerEnrollmentTimeframe {
  DAYS = 'DAYS',
  HOURS = 'HOURS',
  INSTANT = 'INSTANT',
  OVER_4_WEEKS = 'OVER_4_WEEKS',
  WEEKS = 'WEEKS'
}

/** How enrollment for a transaction is completed. */
export enum PayerEnrollmentType {
  MULTI_STEP = 'MULTI_STEP',
  ONE_CLICK = 'ONE_CLICK'
}

/** Whether a payer accepts one transaction through the clearinghouse. */
export type PayerSupport = {
  __typename: 'PayerSupport';
  level: PayerSupportLevel;
  transaction: PayerTransaction;
};

/** Whether a payer accepts a transaction through the clearinghouse. */
export enum PayerSupportLevel {
  ENROLLMENT_REQUIRED = 'ENROLLMENT_REQUIRED',
  NOT_SUPPORTED = 'NOT_SUPPORTED',
  SUPPORTED = 'SUPPORTED'
}

/** A transaction a payer can support, or require enrollment for. */
export enum PayerTransaction {
  CLAIM_PAYMENT = 'CLAIM_PAYMENT',
  CLAIM_PAYMENT_WITH_FUNDS_TRANSFER = 'CLAIM_PAYMENT_WITH_FUNDS_TRANSFER',
  CLAIM_STATUS = 'CLAIM_STATUS',
  CLAIM_SUBMISSION = 'CLAIM_SUBMISSION',
  COORDINATION_OF_BENEFITS = 'COORDINATION_OF_BENEFITS',
  DENTAL_CLAIM = 'DENTAL_CLAIM',
  ELIGIBILITY_CHECK = 'ELIGIBILITY_CHECK',
  FUNDS_TRANSFER = 'FUNDS_TRANSFER',
  INSTITUTIONAL_CLAIM = 'INSTITUTIONAL_CLAIM',
  PROFESSIONAL_CLAIM = 'PROFESSIONAL_CLAIM',
  UNSOLICITED_CLAIM_ATTACHMENT = 'UNSOLICITED_CLAIM_ATTACHMENT'
}

export type PaymentProfile = {
  __typename: 'PaymentProfile';
  cardDetails?: Maybe<CardDetails>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  hasPaymentMethod: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  paymentMethodType?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stripeCustomerId: Scalars['String']['output'];
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

/**
 * What the user's claimed pending packet already answers, so activation can
 * resume at the first question it still lacks. Each field is null until answered;
 * income is answered once \`incomeDeclined\` is set.
 */
export type PendingNateraIntakeAnswers = {
  __typename: 'PendingNateraIntakeAnswers';
  annualHouseholdIncomeCents?: Maybe<Scalars['Int']['output']>;
  billCount: Scalars['Int']['output'];
  billRangeCeilingCents?: Maybe<Scalars['Int']['output']>;
  billRangeFloorCents?: Maybe<Scalars['Int']['output']>;
  expressArm?: Maybe<Scalars['String']['output']>;
  faRead?: Maybe<NateraIntakeFaRead>;
  householdSize?: Maybe<Scalars['Int']['output']>;
  incomeDeclined?: Maybe<Scalars['Boolean']['output']>;
  incomeRangeCeilingCents?: Maybe<Scalars['Int']['output']>;
  incomeRangeFloorCents?: Maybe<Scalars['Int']['output']>;
  insuranceCarrier?: Maybe<Scalars['String']['output']>;
};

export type Person = {
  addresses?: Maybe<Array<person__Address>>;
  createdAt: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenNames?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  matchKeys: Array<Scalars['String']['output']>;
  owner: User;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  primaryAddress?: Maybe<person__Address>;
};


export type PersonaddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};


export type PersonownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type PersonprimaryAddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};

export type PersonAddress = {
  city: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type PersonAddressUpsertInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type PersonResult = FormError | Person_Type;

export type PersonUpsertInput = {
  address?: InputMaybe<PersonAddressUpsertInput>;
  dob?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenNames?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Person_Type = BaseObject & Object & Owned & Person & {
  __typename: 'Person_Type';
  addresses?: Maybe<Array<person__Address>>;
  createdAt: Scalars['String']['output'];
  dateOfBirth: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenNames?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  matchKeys: Array<Scalars['String']['output']>;
  owner: User;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primary: Scalars['Boolean']['output'];
  primaryAddress?: Maybe<person__Address>;
};


export type Person_TypeaddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};


export type Person_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type Person_TypeprimaryAddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};

export type Personal = {
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
};


export type PersonalpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};

export type PersonalizedPrompt = {
  __typename: 'PersonalizedPrompt';
  caseType: CaseType;
  icon: PromptIcon;
  id: Scalars['String']['output'];
  response: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type PlanDocumentsDataTypeStatus = BenefitSummaryCreated | DataTypeNotSupported | DataTypeProcessing;

export type PlanEpicEndpointChangesInput = {
  epicJsonData: Scalars['String']['input'];
};

export type PlanEpicEndpointChangesResponse = {
  __typename: 'PlanEpicEndpointChangesResponse';
  changes: Array<EpicEndpointChange>;
};

export type PlanYear = {
  __typename: 'PlanYear';
  end?: Maybe<Scalars['LocalDate']['output']>;
  start?: Maybe<Scalars['LocalDate']['output']>;
  status: PlanYearStatus;
};

export enum PlanYearStatus {
  /** Today falls in the plan year. */
  CURRENT = 'CURRENT',
  /**
   * The plan year has ended and no check has answered for the new one.
   * Positions, the payer's cost shares, and exclusions are empty rather than
   * last year's.
   */
  ENDED = 'ENDED',
  /**
   * A value added after this client was built. The API never returns it; a
   * client reads any value it does not know as this one.
   */
  UNRECOGNIZED = 'UNRECOGNIZED',
  /** The payer stated no plan year. */
  UNSTATED = 'UNSTATED'
}

export type PreAuthorizePaymentPreferencesInput = {
  eventId: Scalars['ID']['input'];
};

export type PrefillFaApplicationInput = {
  formType?: InputMaybe<provider__FormType>;
  issueId: Scalars['ID']['input'];
  /**
   * Pin the form to prefill (paired with formType). When omitted, the form
   * already pinned on the application is used; if none is pinned, a FormError is
   * returned.
   */
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type PrepareProviderFormUploadInput = {
  /**
   * MIME type of the file that will be PUT to the returned URL. Supported:
   * application/pdf, application/msword, and
   * application/vnd.openxmlformats-officedocument.wordprocessingml.document.
   * Defaults to application/pdf. Word uploads are converted to PDF on upsert.
   */
  contentType?: InputMaybe<Scalars['String']['input']>;
  formType: provider__FormType;
  providerId: Scalars['ID']['input'];
};

export type PreviewMessage = {
  systemMessageInfo?: InputMaybe<SystemPreviewMessage>;
  type: PreviewMessageType;
  userMessageInfo?: InputMaybe<UserPreviewMessage>;
};

export enum PreviewMessageType {
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export type PreviewNegotiatedBillChargeInput = {
  issueId: Scalars['ID']['input'];
  negotiatedBillAmount: Scalars['Decimal']['input'];
  /**
   * Price against this bill amount instead of the stored one. The HA's charge
   * saves the edited bill amount before charging, so the preview has to price the
   * pending edit or it quotes a bill the charge won't use.
   */
  originalBillAmount?: InputMaybe<Scalars['Decimal']['input']>;
  successFeeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A plan year before the current one, and the last figures stored for it. */
export type PreviousPlanYear = {
  __typename: 'PreviousPlanYear';
  /** Null when the payer stated only the start. */
  end?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * The last deductible and out-of-pocket figures stored for the plan year, read
   * on its last day: its end, else twelve months after its start, and no later
   * than the day before the current plan year starts. Not necessarily final
   * totals: the payer's last answer for the year can predate its end, and a
   * calendar-year figure counts the calendar year, which can differ from the
   * plan year. Ordered and marked as the membership's positions are; history
   * covers that plan year.
   */
  positions: Array<InsurancePosition>;
  start: Scalars['LocalDate']['output'];
};

export type ProcessDocumentForAnalysisInput = {
  /** Document ID for the analysis */
  documentId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional event ID to retry. If not provided, a new event will be created.
   * If provided, the workflow will reuse this event for tracking.
   */
  eventId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Deprecated: a failed analysis is now handled by the bill-checker agent
   * rather than auto-escalation, so the upload workflow no longer reads this.
   * Kept optional for backward compatibility with existing clients.
   * @deprecated No longer influences workflow behavior; use domain events for future retries instead
   */
  isRetry?: InputMaybe<Scalars['Boolean']['input']>;
  /** Issue ID the document belongs to */
  issueId?: InputMaybe<Scalars['ID']['input']>;
};

export type ProcessDocumentForAnalysisResult = {
  __typename: 'ProcessDocumentForAnalysisResult';
  event?: Maybe<issue__DocumentAnalysisEvent>;
  /** Whether the workflow was started successfully */
  success: Scalars['Boolean']['output'];
  /** The Temporal workflow ID that was started */
  workflowId: Scalars['String']['output'];
};

export type PromoCodeUsageInfo = {
  __typename: 'PromoCodeUsageInfo';
  id: Scalars['ID']['output'];
  issueId?: Maybe<Scalars['ID']['output']>;
  promoCode: payment__PromoCode_Type;
  usedAt?: Maybe<Scalars['String']['output']>;
};

/** Semantic pictogram for a prompt; the client owns which glyph renders. */
export enum PromptIcon {
  AMBULANCE = 'AMBULANCE',
  CLIPBOARD_CHECK = 'CLIPBOARD_CHECK',
  DOLLAR = 'DOLLAR',
  GAVEL = 'GAVEL',
  MAP_PIN = 'MAP_PIN',
  PERCENT = 'PERCENT',
  SHIELD_CHECK = 'SHIELD_CHECK',
  WALLET = 'WALLET'
}

export type ProvideUserInputAnswerInput = {
  amountCents?: InputMaybe<Scalars['Int']['input']>;
  boolean?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  noIncomeDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  notInsured?: InputMaybe<Scalars['Boolean']['input']>;
  optionValue?: InputMaybe<Scalars['String']['input']>;
  optionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  skip?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ProviderContactPointInput = {
  kind: provider__ContactKind;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Defaults to General when omitted. */
  purpose?: InputMaybe<provider__ContactPurpose>;
  /**
   * Provenance. Defaults to ha; machine syncs pass their own source (notion,
   * research). Passing source: cms is rejected (reserved for the CMS refresh);
   * existing cms contacts remain editable.
   */
  source?: InputMaybe<provider__Source>;
  value: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderDeleted = {
  __typename: 'ProviderDeleted';
  deletedId: Scalars['ID']['output'];
};

export type ProviderFormDetection = {
  __typename: 'ProviderFormDetection';
  /** When detection last completed (ISO 8601); null if never detected. */
  detectedAt?: Maybe<Scalars['String']['output']>;
  /** Number of detected widgets in the stored template; null if never detected. */
  detectedWidgetCount?: Maybe<Scalars['Int']['output']>;
  /**
   * When detection last failed (ISO 8601); null if it never failed. The more
   * recent of detectedAt/detectionFailedAt is the terminal state.
   */
  detectionFailedAt?: Maybe<Scalars['String']['output']>;
};

export type ProviderFormDetectionInput = {
  formType: provider__FormType;
  providerId: Scalars['ID']['input'];
};

export type ProviderFormDetectionStarted = {
  __typename: 'ProviderFormDetectionStarted';
  /**
   * The form's detectedAt before this run (ISO 8601), or null if never detected.
   * The client polls until providerFormDetection.detectedAt differs from this.
   */
  priorDetectedAt?: Maybe<Scalars['String']['output']>;
  /**
   * The form's detectionFailedAt before this run (ISO 8601), or null. The client
   * polls until providerFormDetection.detectionFailedAt differs from this to
   * report a failed run.
   */
  priorFailedAt?: Maybe<Scalars['String']['output']>;
  workflowId: Scalars['String']['output'];
};

export type ProviderFormResult = FormError | provider__ProviderForm_Type;

export type ProviderFormUploadResult = FormError | ProviderFormUploadTarget;

export type ProviderFormUploadTarget = {
  __typename: 'ProviderFormUploadTarget';
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  /**
   * Presigned PUT URL, valid for five minutes. The upload must send the same
   * Content-Type passed to prepareProviderFormUpload (defaults to
   * application/pdf).
   */
  s3PutUrl: Scalars['String']['output'];
};

/**
 * The staff member who pressed the button. Deliberately narrow — a run records
 * who asked, not anything else about them.
 */
export type ProviderResearchRequester = {
  __typename: 'ProviderResearchRequester';
  id: Scalars['ID']['output'];
  primaryEmail?: Maybe<Scalars['String']['output']>;
};

/**
 * One headless research pass over a provider's public identity: what it cost,
 * what it kept, and whether it wrote anything back.
 *
 * Rows are never overwritten, so a provider's history is the list of its runs.
 */
export type ProviderResearchRun = {
  __typename: 'ProviderResearchRun';
  claimsKept?: Maybe<Scalars['Int']['output']>;
  contactsKept?: Maybe<Scalars['Int']['output']>;
  costUsd?: Maybe<Scalars['Float']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * False when the run produced a proposal that was refused at the write — a
   * finished run that changed nothing. Null until the run finishes.
   */
  notesWritten?: Maybe<Scalars['Boolean']['output']>;
  /**
   * ISO 8601. When the run was asked for, which is not when it started — a run
   * waits in `Requested` until a worker picks it up.
   */
  requestedAt: Scalars['String']['output'];
  requestedBy?: Maybe<ProviderResearchRequester>;
  skillVersion?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: provider__ResearchRunStatus;
  turns?: Maybe<Scalars['Int']['output']>;
};

export type ProviderResult = FormError | provider__Provider_Type;

export type ProviderSearchMatchHint = {
  __typename: 'ProviderSearchMatchHint';
  kind: ProviderSearchMatchKind;
  text: Scalars['String']['output'];
};

export enum ProviderSearchMatchKind {
  ALIAS = 'ALIAS',
  PHONE = 'PHONE'
}

export type ProviderSearchResult = {
  __typename: 'ProviderSearchResult';
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  kind?: Maybe<provider__ProviderKind>;
  matchHint?: Maybe<ProviderSearchMatchHint>;
  name: Scalars['String']['output'];
  /** Stored Phone contact values only. Fax/email/other kinds are excluded. */
  phones?: Maybe<Array<Scalars['String']['output']>>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<provider__Source>;
  state?: Maybe<Scalars['String']['output']>;
};

export type ProxyAssignmentInput = {
  device?: InputMaybe<webAgent__ProxyDevice>;
  geoTarget?: InputMaybe<ProxyGeoTargetInput>;
  origin: webAgent__ProxyOrigin;
  stickiness: ProxyStickinessInput;
};

export type ProxyGeoTargetInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  subdivision?: InputMaybe<Scalars['String']['input']>;
};

export type ProxyStickinessInput = {
  mode: webAgent__StickinessMode;
  ttlMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename: 'Query';
  BaseObject?: Maybe<Array<BaseObject>>;
  Object?: Maybe<Array<Object>>;
  Owned?: Maybe<Array<Owned>>;
  Person?: Maybe<Array<Person>>;
  Personal?: Maybe<Array<Personal>>;
  Slugged?: Maybe<Array<Slugged>>;
  User?: Maybe<Array<User>>;
  Verifiable?: Maybe<Array<Verifiable>>;
  /**
   * Internal types placeholder - ensures RpaStatusResult types are generated.
   * This query is not implemented and should not be used.
   * TODO: Remove when doneToStatusResult is refactored to not use these types.
   */
  _internalRpaStatusPlaceholder?: Maybe<RpaStatusResult>;
  /** Get address autocomplete suggestions (max 5 results, no pagination) */
  addressAutocomplete?: Maybe<AddressAutocompleteResponse>;
  /** Get detailed address information for a specific place ID */
  addressDetails?: Maybe<AddressDetails>;
  allRetoolNotifications: Array<notification__RetoolNotification>;
  asyncJob__Job?: Maybe<Array<asyncJob__Job>>;
  /**
   * Admin-only: every beneficiary in the restricted instance, newest first. The
   * verbatim attestation (memberSegments) is omitted here to bound the response;
   * fetch a single beneficiary to read it.
   */
  beneficiaries: Array<Beneficiary>;
  /**
   * Admin-only: a single beneficiary by id, including its verbatim 834 attestation
   * (memberSegments). Null when no beneficiary has the id.
   */
  beneficiary?: Maybe<Beneficiary>;
  /**
   * Admin-only: every delivery (raw 834 file landing) in the restricted instance,
   * newest first. The lineage a beneficiary's deliveryId points back to.
   */
  beneficiaryDeliveries: Array<BeneficiaryDelivery>;
  /**
   * Admin-only: every 834 transaction set (ST/SE header) in the restricted
   * instance, newest first. Carries the sponsor and payer read from the verbatim
   * header. The lineage a beneficiary's transactionSetId points back to.
   */
  beneficiaryTransactionSets: Array<BeneficiaryTransactionSet>;
  cache__SerifFairMarketValue?: Maybe<Array<cache__SerifFairMarketValue>>;
  /**
   * Dry-run of the calibrate → FormSpec translation: translates a draft
   * internalTemplate exactly as calibrateProviderForm would, without persisting,
   * and returns the resulting spec plus a report of every silent decision the
   * translator made (dropped widgets, same-key merges, type-inference notes,
   * option collisions, suppressed required-docs). Powers the calibrate screen's
   * approve-time preflight.
   */
  calibrationPreview?: Maybe<CalibrationPreviewResult>;
  caseCardOnFile: CaseCardOnFile;
  caseConversationVerdict: CaseConversationVerdict;
  caseFact__CaseFact?: Maybe<Array<caseFact__CaseFact>>;
  caseFact__CaseFactAudit?: Maybe<Array<caseFact__CaseFactAudit>>;
  caseRoom?: Maybe<CaseRoom>;
  /** A presigned GET, five minutes. Artifacts never travel through the connector. */
  caseRoomArtifactUrl: Scalars['String']['output'];
  /** Every event the broker logged for this room, oldest first, across all turns. Replay before subscribing. */
  caseRoomTranscript: Array<CaseRoomEvent>;
  caseRoom__Room?: Maybe<Array<caseRoom__Room>>;
  caseRoom__Turn?: Maybe<Array<caseRoom__Turn>>;
  /**
   * The session user's own case with every row, as GetIssue reads it: one
   * element, or none when the case isn't theirs.
   */
  caseRows: Array<issue__Issue>;
  /**
   * The session user's own case with the rows a conversation stream named: the
   * case fields a turn can change, the latest events, and those rows as
   * `userVisibleEvents`. Reads one fixed EdgeQL statement per event type, with
   * access policies on. An id the member can't see returns no row. Null when the
   * case isn't the session user's.
   */
  caseRowsById?: Maybe<issue__Issue>;
  /**
   * As `caseRowsById`, with every row at or after `after`: a `sentAt` exactly as
   * the case screen read it, so a row sharing that timestamp comes back too.
   */
  caseRowsSince?: Maybe<issue__Issue>;
  /**
   * Case state for one case, or null when nothing has been folded for it — which
   * is distinct from a case with nothing outstanding.
   */
  caseState?: Maybe<CaseState>;
  /**
   * The case's pending draft, and the trigger that generates one. Never errors and
   * never blocks: a case with nothing to offer answers NONE.
   */
  caseTaskDraft: CaseTaskDraft;
  /**
   * One page of the GrantCentral case worklist. Filters and orders every case
   * the filter admits, then reads detail for at most `first` of them. Admin only.
   */
  caseWorklistPage: CaseWorklistPage;
  /** Counts and facet options over the worklist's queue. Admin only. */
  caseWorklistSummary: CaseWorklistSummary;
  /** Check if the client version is supported by the API service. */
  checkClientVersion: CheckClientVersionResponse;
  /** Get the current supported binary version and update ID for the client. */
  clientSupportedVersion: ClientSupportedVersionResponse;
  coding__CPT?: Maybe<Array<coding__CPT>>;
  coding__CPTModifier?: Maybe<Array<coding__CPTModifier>>;
  coding__Coding?: Maybe<Array<coding__Coding>>;
  coding__HCPCS?: Maybe<Array<coding__HCPCS>>;
  coding__HCPCSModifier?: Maybe<Array<coding__HCPCSModifier>>;
  consent__Consent?: Maybe<Array<consent__Consent>>;
  consent__HipaaRelease?: Maybe<Array<consent__HipaaRelease>>;
  consent__TemplateRelease?: Maybe<Array<consent__TemplateRelease>>;
  countFlaggedExplanationOfBenefits: Scalars['Int']['output'];
  document__Document?: Maybe<Array<document__Document>>;
  document__DocumentSummary?: Maybe<Array<document__DocumentSummary>>;
  document__File?: Maybe<Array<document__File>>;
  document__ParseResult?: Maybe<Array<document__ParseResult>>;
  document__Template?: Maybe<Array<document__Template>>;
  document__TemplateField?: Maybe<Array<document__TemplateField>>;
  /**
   * Admin-only: population-level eligibility metrics for the internal
   * eligibility-ops dashboard. All counts are computed live from the
   * eligibility projections and include internal users.
   */
  eligibilityOpsSummary: EligibilityOpsSummary;
  eventStore__Event?: Maybe<Array<eventStore__Event>>;
  eventTracking__BaseEvent?: Maybe<Array<eventTracking__BaseEvent>>;
  eventTracking__InsuranceLinkAttempt?: Maybe<Array<eventTracking__InsuranceLinkAttempt>>;
  /**
   * Reads the case's financial-assistance application: its status, the pinned
   * provider form (issuer + name), and the in-progress draft (formState). Null
   * when the case has no application yet. Internal staff query.
   */
  faApplication?: Maybe<FaApplication>;
  /**
   * The case's financial-assistance application rendered as a fillable form: the
   * resolved FormSpec (the pinned provider form, else the generic baseline), the
   * current draft answers (FormState), and submittedAt once filed. Null when the
   * FA flow has not started for the case. Owner-scoped — the household filling its
   * own form (not the HA-facing `faApplication`).
   */
  faApplicationForIssue?: Maybe<FaApplicationView>;
  /**
   * The supporting documents the case's FA application carries, derived from the
   * application's own document answers against the resolved FormSpec — the same
   * composer the packet bake files from, so the staff bundle and the filed packet
   * can never carry different sets. Scoped to documents actually attached to this
   * issue, so a stale or foreign ref in the answers resolves to nothing rather
   * than surfacing. Empty when the case has no application. Internal staff query.
   */
  faApplicationSupportingDocuments: FaSupportingDocuments;
  /**
   * The send preview for the staff-triggered FA flow (`startFaFlowForIssue`):
   * which form the user would get if the offer fired right now — the linked
   * provider's own calibrated form, one inherited from its parent system, or
   * the generic Granted baseline — resolved by the same facility → partOf →
   * baseline walk the hand-off pins with, so the preview cannot disagree with
   * the send. Also carries the existing application's status and pinned-form
   * issuer when the flow already started. Null when the issue is not visible
   * to the caller. Internal staff query.
   */
  faFlowFormPreview?: Maybe<FaFlowFormResolution>;
  fa__Application?: Maybe<Array<fa__Application>>;
  feedback__GeneralFeedback?: Maybe<Array<feedback__GeneralFeedback>>;
  feedback__IssueEventFeedback?: Maybe<Array<feedback__IssueEventFeedback>>;
  feedback__IssueFeedback?: Maybe<Array<feedback__IssueFeedback>>;
  feedback__Option?: Maybe<Array<feedback__Option>>;
  feedback__StaffFeedback?: Maybe<Array<feedback__StaffFeedback>>;
  feedback__UserFeedback?: Maybe<Array<feedback__UserFeedback>>;
  fhirEdit__CoverageEdit?: Maybe<Array<fhirEdit__CoverageEdit>>;
  fhirEdit__CoverageSnapshot?: Maybe<Array<fhirEdit__CoverageSnapshot>>;
  fhirEdit__ExplanationOfBenefitEdit?: Maybe<Array<fhirEdit__ExplanationOfBenefitEdit>>;
  fhirEdit__ExplanationOfBenefitSnapshot?: Maybe<Array<fhirEdit__ExplanationOfBenefitSnapshot>>;
  fhirEdit__ResourceEdit?: Maybe<Array<fhirEdit__ResourceEdit>>;
  fhirEdit__ResourceSnapshot?: Maybe<Array<fhirEdit__ResourceSnapshot>>;
  fhir__Account?: Maybe<Array<fhir__Account>>;
  fhir__AccountBalance?: Maybe<Array<fhir__AccountBalance>>;
  fhir__AccountGuarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  fhir__Address?: Maybe<Array<fhir__Address>>;
  fhir__Annotation?: Maybe<Array<fhir__Annotation>>;
  fhir__ChargeItem?: Maybe<Array<fhir__ChargeItem>>;
  fhir__ChargeItemPerformer?: Maybe<Array<fhir__ChargeItemPerformer>>;
  fhir__ClinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  fhir__CodeableConcept?: Maybe<Array<fhir__CodeableConcept>>;
  fhir__CodeableReference?: Maybe<Array<fhir__CodeableReference>>;
  fhir__Coding?: Maybe<Array<fhir__Coding>>;
  fhir__ContactPoint?: Maybe<Array<fhir__ContactPoint>>;
  fhir__Coverage?: Maybe<Array<fhir__Coverage>>;
  fhir__CoverageClass?: Maybe<Array<fhir__CoverageClass>>;
  fhir__Encounter?: Maybe<Array<fhir__Encounter>>;
  fhir__EncounterParticipant?: Maybe<Array<fhir__EncounterParticipant>>;
  fhir__ExplanationOfBenefit?: Maybe<Array<fhir__ExplanationOfBenefit>>;
  fhir__ExplanationOfBenefitCareTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  fhir__ExplanationOfBenefitDiagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  fhir__ExplanationOfBenefitItem?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  fhir__ExplanationOfBenefitItemAdjudication?: Maybe<Array<fhir__ExplanationOfBenefitItemAdjudication>>;
  fhir__ExplanationOfBenefitItemReviewOutcome?: Maybe<Array<fhir__ExplanationOfBenefitItemReviewOutcome>>;
  fhir__ExplanationOfBenefitTotal?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  fhir__FHIRResource?: Maybe<Array<fhir__FHIRResource>>;
  fhir__HumanName?: Maybe<Array<fhir__HumanName>>;
  fhir__Identifier?: Maybe<Array<fhir__Identifier>>;
  fhir__Invoice?: Maybe<Array<fhir__Invoice>>;
  fhir__InvoiceLineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  fhir__InvoiceParticipant?: Maybe<Array<fhir__InvoiceParticipant>>;
  fhir__Location?: Maybe<Array<fhir__Location>>;
  fhir__MonetaryComponent?: Maybe<Array<fhir__MonetaryComponent>>;
  fhir__Money?: Maybe<Array<fhir__Money>>;
  fhir__Patient?: Maybe<Array<fhir__Patient>>;
  fhir__Practitioner?: Maybe<Array<fhir__Practitioner>>;
  fhir__Quantity?: Maybe<Array<fhir__Quantity>>;
  fhir__Reference?: Maybe<Array<fhir__Reference>>;
  fhirext__Account?: Maybe<Array<fhirext__Account>>;
  fhirext__AccountVersion?: Maybe<Array<fhirext__AccountVersion>>;
  fhirext__Coverage?: Maybe<Array<fhirext__Coverage>>;
  fhirext__CoverageExtension?: Maybe<Array<fhirext__CoverageExtension>>;
  fhirext__CoverageVersion?: Maybe<Array<fhirext__CoverageVersion>>;
  fhirext__Encounter?: Maybe<Array<fhirext__Encounter>>;
  fhirext__EncounterVersion?: Maybe<Array<fhirext__EncounterVersion>>;
  fhirext__ExplanationOfBenefit?: Maybe<Array<fhirext__ExplanationOfBenefit>>;
  fhirext__ExplanationOfBenefitExtension?: Maybe<Array<fhirext__ExplanationOfBenefitExtension>>;
  fhirext__ExplanationOfBenefitTotalsByType?: Maybe<Array<fhirext__ExplanationOfBenefitTotalsByType>>;
  fhirext__ExplanationOfBenefitVersion?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  fhirext__Finding?: Maybe<Array<fhirext__Finding>>;
  fhirext__FindingReview?: Maybe<Array<fhirext__FindingReview>>;
  fhirext__Invoice?: Maybe<Array<fhirext__Invoice>>;
  fhirext__InvoiceTotalsByType?: Maybe<Array<fhirext__InvoiceTotalsByType>>;
  fhirext__InvoiceVersion?: Maybe<Array<fhirext__InvoiceVersion>>;
  fhirext__Patient?: Maybe<Array<fhirext__Patient>>;
  fhirext__PatientVersion?: Maybe<Array<fhirext__PatientVersion>>;
  fhirext__Practitioner?: Maybe<Array<fhirext__Practitioner>>;
  fhirext__PractitionerVersion?: Maybe<Array<fhirext__PractitionerVersion>>;
  fhirext__ResourceAssociation?: Maybe<Array<fhirext__ResourceAssociation>>;
  fhirext__ResourceIdentifier?: Maybe<Array<fhirext__ResourceIdentifier>>;
  fhirext__ResourceVersion?: Maybe<Array<fhirext__ResourceVersion>>;
  flexpa__Endpoint?: Maybe<Array<flexpa__Endpoint>>;
  flexpa__FlexpaImport?: Maybe<Array<flexpa__FlexpaImport>>;
  flexpa__Link?: Maybe<Array<flexpa__Link>>;
  flexpa__Organization?: Maybe<Array<flexpa__Organization>>;
  forecastingBenchmarkRuns: Array<ForecastingBenchmarkRun>;
  /**
   * Everything the forecast screen needs in one shot: the variable registry
   * (with provenance), both 12-week projections, fallback labeling, and
   * benchmark-run metadata. Pass a scenarioId to view that scenario; omit for
   * the read-only Baseline. JSON payload shapes are owned by
   * ts/apps/api/src/forecasting/engine/types.ts.
   */
  forecastingOverview: ForecastingOverview;
  forecastingScenarios: Array<ForecastingScenario>;
  forecasting__BenchmarkRun?: Maybe<Array<forecasting__BenchmarkRun>>;
  forecasting__HeadcountForecast?: Maybe<Array<forecasting__HeadcountForecast>>;
  forecasting__Investment?: Maybe<Array<forecasting__Investment>>;
  forecasting__MarketingForecast?: Maybe<Array<forecasting__MarketingForecast>>;
  forecasting__Scenario?: Maybe<Array<forecasting__Scenario>>;
  forecasting__VariableOverride?: Maybe<Array<forecasting__VariableOverride>>;
  /**
   * The issue's applied-but-unredeemed promo code with its discount shape, so a
   * returning session can rehydrate intake pricing. Null when none is linked.
   */
  getActivePromoForIssue?: Maybe<ActivePromoForIssue>;
  /** Get the status of a specific execution attempt */
  getAttemptStatus: AttemptStatus;
  /**
   * Loads a provider form ready to fill for a case: the issuer + form name, a
   * short-lived presigned URL for the blank PDF, and the detected/calibrated
   * fields (from ProviderForm.internalTemplate via the same mapping the bake
   * uses). Internal staff query; the caseId is carried for future case-data
   * resolution but does not yet drive prefilled values.
   */
  getFormFill: FaFormFillResult;
  getPaymentProfile?: Maybe<PaymentProfile>;
  getPersonalizedPrompts: GetPersonalizedPromptsResponse;
  getSubscription?: Maybe<BillingSubscription>;
  getSubscriptionProducts: Array<SubscriptionProduct>;
  getTemplateRelease: GetTemplateReleaseResult;
  getUpdatesPrompts: Array<UpdatesPrompt>;
  getWelcomePrompts: Array<WelcomePrompt>;
  /**
   * The authenticated admin's tasks, ordered by due date then ID. Preserves
   * caseless tasks and parked-case/completed visibility. At most 51 rows.
   */
  haMyTasks: Array<taskManagement__Task>;
  haMyTasksCount: Scalars['Int']['output'];
  /**
   * Whether the authenticated user holds a Natera funnel packet that no case has
   * been opened from yet. The app gates on it to route a member who signed in
   * and left before activation back to it.
   */
  hasPendingNateraIntake: Scalars['Boolean']['output'];
  ingestion__Distillation?: Maybe<Array<ingestion__Distillation>>;
  ingestion__Extract?: Maybe<Array<ingestion__Extract>>;
  ingestion__Ingestion?: Maybe<Array<ingestion__Ingestion>>;
  ingestion__IngestionStep?: Maybe<Array<ingestion__IngestionStep>>;
  intake__IntakeDraft?: Maybe<Array<intake__IntakeDraft>>;
  intake__IntakeRecord?: Maybe<Array<intake__IntakeRecord>>;
  integration__BaseEndpoint?: Maybe<Array<integration__BaseEndpoint>>;
  integration__BaseLink?: Maybe<Array<integration__BaseLink>>;
  integration__Organization?: Maybe<Array<integration__Organization>>;
  issueCount: Scalars['Int']['output'];
  issue__AskReraisedEvent?: Maybe<Array<issue__AskReraisedEvent>>;
  issue__BenefitsContext?: Maybe<Array<issue__BenefitsContext>>;
  issue__BenefitsSummaryGeneratedEvent?: Maybe<Array<issue__BenefitsSummaryGeneratedEvent>>;
  issue__BillDisputeEvent?: Maybe<Array<issue__BillDisputeEvent>>;
  issue__BillPayPostEscalationAction?: Maybe<Array<issue__BillPayPostEscalationAction>>;
  issue__BillPayRequestedEvent?: Maybe<Array<issue__BillPayRequestedEvent>>;
  issue__BillPaySuccessEvent?: Maybe<Array<issue__BillPaySuccessEvent>>;
  issue__BillPaymentRequestedEvent?: Maybe<Array<issue__BillPaymentRequestedEvent>>;
  issue__BillPaymentSuccessEvent?: Maybe<Array<issue__BillPaymentSuccessEvent>>;
  issue__CardCollectionRequestedEvent?: Maybe<Array<issue__CardCollectionRequestedEvent>>;
  issue__ChatEvent?: Maybe<Array<issue__ChatEvent>>;
  issue__ClosedEvent?: Maybe<Array<issue__ClosedEvent>>;
  issue__ClosurePaymentRequestedEvent?: Maybe<Array<issue__ClosurePaymentRequestedEvent>>;
  issue__CommentEvent?: Maybe<Array<issue__CommentEvent>>;
  issue__CompleteFaApplicationPostEscalationAction?: Maybe<Array<issue__CompleteFaApplicationPostEscalationAction>>;
  issue__ConnectAccountRequestedEvent?: Maybe<Array<issue__ConnectAccountRequestedEvent>>;
  issue__ConnectEhrPostEscalationAction?: Maybe<Array<issue__ConnectEhrPostEscalationAction>>;
  issue__ConnectInsurancePostEscalationAction?: Maybe<Array<issue__ConnectInsurancePostEscalationAction>>;
  issue__ConnectInsuranceRequestedEvent?: Maybe<Array<issue__ConnectInsuranceRequestedEvent>>;
  issue__DocumentAnalysisEvent?: Maybe<Array<issue__DocumentAnalysisEvent>>;
  issue__DocumentClassificationFailedEvent?: Maybe<Array<issue__DocumentClassificationFailedEvent>>;
  issue__DocumentUploadedEvent?: Maybe<Array<issue__DocumentUploadedEvent>>;
  issue__Event?: Maybe<Array<issue__Event>>;
  issue__FaEligibilityInfoPostEscalationAction?: Maybe<Array<issue__FaEligibilityInfoPostEscalationAction>>;
  issue__FinancialAssistanceFlowEvent?: Maybe<Array<issue__FinancialAssistanceFlowEvent>>;
  issue__HAAssignedEvent?: Maybe<Array<issue__HAAssignedEvent>>;
  issue__HipaaReleaseRequestedEvent?: Maybe<Array<issue__HipaaReleaseRequestedEvent>>;
  issue__InternalDocumentUploadedEvent?: Maybe<Array<issue__InternalDocumentUploadedEvent>>;
  issue__Issue?: Maybe<Array<issue__Issue>>;
  issue__IssueDocumentSummary?: Maybe<Array<issue__IssueDocumentSummary>>;
  issue__OutreachEvent?: Maybe<Array<issue__OutreachEvent>>;
  issue__PaymentAgreementPostEscalationAction?: Maybe<Array<issue__PaymentAgreementPostEscalationAction>>;
  issue__PaymentAgreementRequestedEvent?: Maybe<Array<issue__PaymentAgreementRequestedEvent>>;
  issue__PaymentChargeFailedEvent?: Maybe<Array<issue__PaymentChargeFailedEvent>>;
  issue__PaymentChargeResolvedEvent?: Maybe<Array<issue__PaymentChargeResolvedEvent>>;
  issue__PaymentPreferences?: Maybe<Array<issue__PaymentPreferences>>;
  issue__PaymentPreferencesPostEscalationAction?: Maybe<Array<issue__PaymentPreferencesPostEscalationAction>>;
  issue__PaymentPreferencesRequestedEvent?: Maybe<Array<issue__PaymentPreferencesRequestedEvent>>;
  issue__PaymentPreferencesUpdatedEvent?: Maybe<Array<issue__PaymentPreferencesUpdatedEvent>>;
  issue__PhoneCallEvent?: Maybe<Array<issue__PhoneCallEvent>>;
  issue__PlanSelectionEvent?: Maybe<Array<issue__PlanSelectionEvent>>;
  issue__PostEscalationAction?: Maybe<Array<issue__PostEscalationAction>>;
  issue__PostEscalationActionsEvent?: Maybe<Array<issue__PostEscalationActionsEvent>>;
  issue__PreAuthRequestedEvent?: Maybe<Array<issue__PreAuthRequestedEvent>>;
  issue__ReopenedEvent?: Maybe<Array<issue__ReopenedEvent>>;
  issue__ResolutionPreferences?: Maybe<Array<issue__ResolutionPreferences>>;
  issue__SignTemplatePostEscalationAction?: Maybe<Array<issue__SignTemplatePostEscalationAction>>;
  issue__TemplateReleaseRequestedEvent?: Maybe<Array<issue__TemplateReleaseRequestedEvent>>;
  issue__ToolExecutionEvent?: Maybe<Array<issue__ToolExecutionEvent>>;
  issue__UploadBillPostEscalationAction?: Maybe<Array<issue__UploadBillPostEscalationAction>>;
  issue__UploadEobPostEscalationAction?: Maybe<Array<issue__UploadEobPostEscalationAction>>;
  issue__UploadMemberIdPostEscalationAction?: Maybe<Array<issue__UploadMemberIdPostEscalationAction>>;
  issue__UploadProofOfIncomePostEscalationAction?: Maybe<Array<issue__UploadProofOfIncomePostEscalationAction>>;
  issue__UserInputRequestedEvent?: Maybe<Array<issue__UserInputRequestedEvent>>;
  issue__UserMultiSelectionRequestedEvent?: Maybe<Array<issue__UserMultiSelectionRequestedEvent>>;
  issue__UserSelectionRequestedEvent?: Maybe<Array<issue__UserSelectionRequestedEvent>>;
  me?: Maybe<User>;
  modelExecution__LLMExecution?: Maybe<Array<modelExecution__LLMExecution>>;
  modelExecution__VellumLLMExecution?: Maybe<Array<modelExecution__VellumLLMExecution>>;
  /**
   * The signed-in member's insurance: whether Granted can check it with the
   * payer, and every insurance membership on the account, reconciled from all
   * of its evidence.
   */
  myInsurance: Insurance;
  /**
   * What an advocate is shown about a Natera case, independent of which of the
   * two sources produced it — the pre-account partner funnel, whose answers are
   * one packet on the case, or the in-chat intake the Case Agent runs after a
   * bill upload. The two never run on the same case.
   *
   * The shape is `nateraCaseIntakeSchema` in `@medbillai/schemas/nateraCaseIntake`,
   * which both ends parse. It is a contract rather than a projection: it is
   * assembled per request from the sources that already exist, and a maintained
   * projection can serve the same shape later without this query or the card
   * changing.
   *
   * Carried as JSON for the same reason `formSpec` and `wizardLayout` are. The
   * shape is a zod schema with invariants GraphQL cannot state — an answered
   * field carries a value and an unanswered one carries none, and a read that
   * screened against a ceiling must name that ceiling — and mirroring it into a
   * dozen wrapper types would make the schema a second, weaker statement of a
   * contract that already has one home.
   *
   * Null when the case is not a Natera case at all, and also when its intake
   * packet exists but cannot be read, so the caller falls back to showing that
   * packet verbatim rather than standing a half-empty card in front of what the
   * member actually said.
   *
   * Admin-only: this is Grant Central's advocate surface, not a member read.
   */
  nateraCaseIntake?: Maybe<Scalars['JSON']['output']>;
  /**
   * Where a signed-in member belongs instead of the Natera funnel: ACTIVATION
   * when there are answers to open a case from or a funnel case still awaiting
   * activation, HOME otherwise. Errors rather than answering HOME when a read
   * fails.
   */
  nateraIntakeResumeDestination: NateraIntakeResumeDestination;
  notification__RetoolNotification?: Maybe<Array<notification__RetoolNotification>>;
  partner__InviteLink?: Maybe<Array<partner__InviteLink>>;
  partner__Partner?: Maybe<Array<partner__Partner>>;
  partner__PartnerGroup?: Maybe<Array<partner__PartnerGroup>>;
  /**
   * Admin-only: every registered partner, newest first, each with its groups.
   * The operator surface for reviewing configured partners.
   */
  partners: Array<Partner>;
  /**
   * The payer a payer ID belongs to, including a payer ID the payer no longer
   * uses. Null when no catalog payer has it.
   */
  payerByPayerId?: Maybe<Payer>;
  payerSync__PayerChange?: Maybe<Array<payerSync__PayerChange>>;
  payerSync__Run?: Maybe<Array<payerSync__Run>>;
  payer__Payer?: Maybe<Array<payer__Payer>>;
  payer__PayerAlias?: Maybe<Array<payer__PayerAlias>>;
  payer__TransactionEnrollment?: Maybe<Array<payer__TransactionEnrollment>>;
  payment__IssuePromoCodeUsage?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  payment__PaymentProfile?: Maybe<Array<payment__PaymentProfile>>;
  payment__PaymentTransaction?: Maybe<Array<payment__PaymentTransaction>>;
  payment__PromoCode?: Maybe<Array<payment__PromoCode>>;
  payment__Subscription?: Maybe<Array<payment__Subscription>>;
  /** The claimed pending packet's answers, or null when no claimed packet is waiting or a case is already open. */
  pendingNateraIntakeAnswers?: Maybe<PendingNateraIntakeAnswers>;
  person__Address?: Maybe<Array<person__Address>>;
  planEpicEndpointChanges: PlanEpicEndpointChangesResponse;
  plan__BenefitsSummaryResult?: Maybe<Array<plan__BenefitsSummaryResult>>;
  plan__Plan?: Maybe<Array<plan__Plan>>;
  /**
   * Commonly held payers to offer before a member searches, most enrolled first,
   * after any the viewer's partner's members commonly hold. Only active payers
   * that accept eligibility checks.
   */
  popularPayers: Array<Payer>;
  previewNegotiatedBillCharge?: Maybe<NegotiatedBillChargePreviewResult>;
  projection__BenefitPositionObservationView?: Maybe<Array<projection__BenefitPositionObservationView>>;
  projection__CaseAskView?: Maybe<Array<projection__CaseAskView>>;
  projection__CaseBillAmountView?: Maybe<Array<projection__CaseBillAmountView>>;
  projection__CaseFlowView?: Maybe<Array<projection__CaseFlowView>>;
  projection__CasePriorPaymentView?: Maybe<Array<projection__CasePriorPaymentView>>;
  projection__CaseProviderView?: Maybe<Array<projection__CaseProviderView>>;
  projection__CaseReengagementFeed?: Maybe<Array<projection__CaseReengagementFeed>>;
  projection__CaseView?: Maybe<Array<projection__CaseView>>;
  projection__EligibilityCheckAttemptView?: Maybe<Array<projection__EligibilityCheckAttemptView>>;
  projection__InsuranceDiscoveryAttemptView?: Maybe<Array<projection__InsuranceDiscoveryAttemptView>>;
  projection__RpaBrowserFingerprint?: Maybe<Array<projection__RpaBrowserFingerprint>>;
  projection__RpaConnection?: Maybe<Array<projection__RpaConnection>>;
  projection__RpaEgressIp?: Maybe<Array<projection__RpaEgressIp>>;
  projection__RpaExperimentView?: Maybe<Array<projection__RpaExperimentView>>;
  projection__RpaLinkView?: Maybe<Array<projection__RpaLinkView>>;
  projection__RpaProviderAttempt?: Maybe<Array<projection__RpaProviderAttempt>>;
  projection__RpaSession?: Maybe<Array<projection__RpaSession>>;
  projection__RpaSessionSummary?: Maybe<Array<projection__RpaSessionSummary>>;
  projection__RpaSessionTimeline?: Maybe<Array<projection__RpaSessionTimeline>>;
  projection__RpaTask?: Maybe<Array<projection__RpaTask>>;
  projection__RpaTimelineEntry?: Maybe<Array<projection__RpaTimelineEntry>>;
  projection__UserDataView?: Maybe<Array<projection__UserDataView>>;
  projection__UserEligibilityView?: Maybe<Array<projection__UserEligibilityView>>;
  projection__UserEnrichmentData?: Maybe<Array<projection__UserEnrichmentData>>;
  projection__UserMemory?: Maybe<Array<projection__UserMemory>>;
  /**
   * How a provider's FA policy resolves: its own, the one it inherits from its
   * `partOf` system, or neither.
   *
   * Resolved on the server rather than by the caller. A facility's own policy
   * wins even when it will not parse, and a system whose policy is corrupt is a
   * different answer from a system with none — rules a second implementation in a
   * screen would eventually get wrong.
   */
  providerFaPolicyResolution?: Maybe<FaPolicyResolution>;
  /**
   * Reads a provider form's durable detection state: `detectedAt` (stamped on
   * completion), `detectionFailedAt` (stamped when a run exhausts its retries),
   * and the detected field count. The client polls this and stops on either
   * terminal: detection is done once `detectedAt` advances past the value
   * `startProviderFormDetection` returned, and failed once `detectionFailedAt`
   * advances past its prior value. Both are null before the first run. Internal
   * staff query.
   */
  providerFormDetection: ProviderFormDetection;
  /**
   * A provider's research runs, newest first — `limit` defaults to 10 and is
   * clamped to 1..50. Empty for a provider nobody has researched yet.
   */
  providerResearchRuns: Array<ProviderResearchRun>;
  provider__ContactPoint?: Maybe<Array<provider__ContactPoint>>;
  provider__NegotiationProfile?: Maybe<Array<provider__NegotiationProfile>>;
  provider__Provider?: Maybe<Array<provider__Provider>>;
  provider__ProviderForm?: Maybe<Array<provider__ProviderForm>>;
  provider__ResearchRun?: Maybe<Array<provider__ResearchRun>>;
  queryFlaggedExplanationOfBenefits: Array<fhirext__ExplanationOfBenefitVersion>;
  queryFlaggedExplanationOfBenefitsForUser: Array<fhirext__ExplanationOfBenefitVersion>;
  queryIssues?: Maybe<Array<issue__Issue>>;
  queryIssuesV2?: Maybe<Array<issue__Issue>>;
  /**
   * One ingestion-v2 document row by kind and materialization key, scoped to
   * the current user. Returns null when the key does not resolve to a row the
   * user can view.
   */
  queryUserDocument?: Maybe<UserHealthRecord>;
  /**
   * All of the current user's ingestion-v2 document rows of the given kind
   * (projection::UserDataView). `data` is the canonical v2 JSON for the kind
   * (v2.BankStatement, v2.Paystub, v2.W2, v2.Form1099, v2.UtilityBill,
   * v2.GovernmentId), returned verbatim. Document kinds carry no enrichment
   * overlay, so `enrichment` is always null.
   */
  queryUserDocuments: Array<UserHealthRecord>;
  /**
   * One ingestion-v2 EOB by its materialization key, scoped to the current user.
   * Returns null when the key does not resolve to an EOB the user can view.
   */
  queryUserEob?: Maybe<UserHealthRecord>;
  /**
   * All of the current user's ingestion-v2 EOB rows (projection::UserDataView,
   * kind = "claim"). `data` is the canonical v2.EOB JSON, returned verbatim.
   */
  queryUserEobs: Array<UserHealthRecord>;
  /** One ingestion-v2 invoice by its materialization key, scoped to the current user. */
  queryUserInvoice?: Maybe<UserHealthRecord>;
  /**
   * All of the current user's ingestion-v2 invoice rows (projection::UserDataView,
   * kind = "invoice"). `data` is the canonical v2.Invoice JSON, returned verbatim.
   */
  queryUserInvoices: Array<UserHealthRecord>;
  queryUserUploadedDocuments: Array<Maybe<UserUploadedDocumentsResult>>;
  queryWebAgentExecutions: Array<WebAgentExecutionResult>;
  /**
   * Resolve a partner invite token to its partner — and, once redeemed, the
   * onboarding user — without consuming it. Public: onboarding reads the partner
   * at entry, before the user authenticates, to render partner branding.
   */
  resolveInviteToken: InviteTokenResolution;
  rpaFacts: RpaFacts;
  /** Returns link views with optional lastSessionAt, filtered by time range and/or linkIds. */
  rpaLinkViews: Array<RpaLinkView>;
  rpaScheduleForecast: Array<RpaForecastEntry>;
  /**
   * The analyses recorded against one session, newest first, read from Evidence
   * Room. A reclassification's `annotationId` names the one behind it. Loaded on
   * demand: the status chip and the KPIs come from the event stream and never
   * wait on this.
   */
  rpaSessionAnnotations: Array<RpaSessionAnnotation>;
  /** Returns minimal session dots for viewport rendering, scoped by time + linkIds. */
  rpaSessionDots: Array<RpaSessionDot>;
  /**
   * Returns the read-time graded outcome (D11) per session id, keyed by sessionId
   * so the browser-fingerprint bridge rows (projection__RpaBrowserFingerprint,
   * which carry sessionId) can be joined against the derived outcome. The grade is
   * computed on read from the session-summary fold (task status + timeline), never
   * the null terminal sessionStatus.
   */
  rpaSessionOutcomeGrades: Array<RpaSessionOutcomeGrade>;
  /** Returns a single session timeline (loaded on demand when session is selected). */
  rpaSessionTimeline?: Maybe<RpaSessionTimeline>;
  /**
   * Investigator annotations read from the committed event log, without projection lag.
   * Accepts up to 5000 session IDs (the Ops metrics page limit).
   */
  rpaStatusOverrides: Array<RpaStatusOverrideEntry>;
  /**
   * The Runner's Playwright trace zips for one execution, one per browser. Only
   * new-robot (sign_in@1) executions keep their trace in S3 rather than as
   * artifact rows on the execution; every other execution returns an empty list.
   */
  runnerTraces: Array<RunnerTrace>;
  /**
   * Search the payer catalog by payer name or payer ID. Returns active payers,
   * most relevant first: an exact payer ID, then names starting with the query,
   * then names containing it.
   */
  searchPayers: Array<Payer>;
  /**
   * Provider directory typeahead (server-owned). With `state`: empty query
   * returns labs; typed query returns name/alias/phone matches (labs first,
   * then in-state). Unscoped is the same match without the state pin. Name
   * tokens AND-match after punctuation is stripped; a phone query matches
   * ContactKind.Phone digits only (never Fax). Default limit 20.
   * provider::Provider is readableByAll.
   */
  searchProviders: Array<ProviderSearchResult>;
  segment__PartnerSegment?: Maybe<Array<segment__PartnerSegment>>;
  segment__Segment?: Maybe<Array<segment__Segment>>;
  segment__UserSegment?: Maybe<Array<segment__UserSegment>>;
  segment__UtmSegment?: Maybe<Array<segment__UtmSegment>>;
  showWelcomeScreen: Scalars['Boolean']['output'];
  /** The tailgate as its workflow sees it now, for the tailgate screen to poll. */
  staffTailgate: StaffTailgateView;
  suggestion__SuggestedAction?: Maybe<Array<suggestion__SuggestedAction>>;
  taskManagement__DataQualityFlagTask?: Maybe<Array<taskManagement__DataQualityFlagTask>>;
  taskManagement__FollowUpClosurePendingIssueTask?: Maybe<Array<taskManagement__FollowUpClosurePendingIssueTask>>;
  taskManagement__FollowUpUserUnresponsiveIssueTask?: Maybe<Array<taskManagement__FollowUpUserUnresponsiveIssueTask>>;
  taskManagement__GeneralIssueTask?: Maybe<Array<taskManagement__GeneralIssueTask>>;
  taskManagement__IssueResearchTask?: Maybe<Array<taskManagement__IssueResearchTask>>;
  taskManagement__IssueTask?: Maybe<Array<taskManagement__IssueTask>>;
  taskManagement__IssueUserMessagingTask?: Maybe<Array<taskManagement__IssueUserMessagingTask>>;
  taskManagement__PhoneCall?: Maybe<Array<taskManagement__PhoneCall>>;
  taskManagement__PhoneCallIssueTask?: Maybe<Array<taskManagement__PhoneCallIssueTask>>;
  taskManagement__ProcessCustomerBillPaymentIssueTask?: Maybe<Array<taskManagement__ProcessCustomerBillPaymentIssueTask>>;
  taskManagement__RetryChargeIssueTask?: Maybe<Array<taskManagement__RetryChargeIssueTask>>;
  taskManagement__ReviewCaseIntakeIssueTask?: Maybe<Array<taskManagement__ReviewCaseIntakeIssueTask>>;
  taskManagement__ReviewEscalatedCaseTask?: Maybe<Array<taskManagement__ReviewEscalatedCaseTask>>;
  taskManagement__ReviewFindingTask?: Maybe<Array<taskManagement__ReviewFindingTask>>;
  taskManagement__ReviewIssueChatTask?: Maybe<Array<taskManagement__ReviewIssueChatTask>>;
  taskManagement__ReviewPaymentAcceptanceIssueTask?: Maybe<Array<taskManagement__ReviewPaymentAcceptanceIssueTask>>;
  taskManagement__ReviewSuggestionTask?: Maybe<Array<taskManagement__ReviewSuggestionTask>>;
  taskManagement__SendFormIssueTask?: Maybe<Array<taskManagement__SendFormIssueTask>>;
  taskManagement__Task?: Maybe<Array<taskManagement__Task>>;
  taskManagement__TaskComment?: Maybe<Array<taskManagement__TaskComment>>;
  templateFieldAttributes: TemplateFieldAttributesResult;
  templateFile: TemplateFileResult;
  templateStorageValues: TemplateStorageValuesResult;
  unreadRetoolNotificationCount: Scalars['Int']['output'];
  unreadRetoolNotifications: Array<notification__RetoolNotification>;
  /** A user's insurance. Staff only. */
  userInsurance: Insurance;
  user__Email?: Maybe<Array<user__Email>>;
  user__Profile?: Maybe<Array<user__Profile>>;
  user__SegmentationData?: Maybe<Array<user__SegmentationData>>;
  viewDocument: ViewDocumentResult;
  viewDocumentFile: ViewDocumentFileResult;
  /**
   * The partner bound to the authenticated user's source, or null when the user
   * did not join through a partner. Onboarding renders co-branding and partner
   * context from this on resume, without re-presenting the invite token.
   */
  viewerPartner?: Maybe<InviteTokenPartner>;
  webAgent__AiConversationLogArtifact?: Maybe<Array<webAgent__AiConversationLogArtifact>>;
  webAgent__AiDiscoveryCrawl?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  webAgent__AiDiscoveryCrawlObjective?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  webAgent__CrawlDataSummaryArtifact?: Maybe<Array<webAgent__CrawlDataSummaryArtifact>>;
  webAgent__Endpoint?: Maybe<Array<webAgent__Endpoint>>;
  webAgent__EndpointSupportLevelHistory?: Maybe<Array<webAgent__EndpointSupportLevelHistory>>;
  webAgent__ExecutionClassification?: Maybe<Array<webAgent__ExecutionClassification>>;
  webAgent__InitialPageLoadSpan?: Maybe<Array<webAgent__InitialPageLoadSpan>>;
  webAgent__Link?: Maybe<Array<webAgent__Link>>;
  webAgent__LinkProviderProfile?: Maybe<Array<webAgent__LinkProviderProfile>>;
  webAgent__LinkSecret?: Maybe<Array<webAgent__LinkSecret>>;
  webAgent__ManagedMfaConfiguration?: Maybe<Array<webAgent__ManagedMfaConfiguration>>;
  webAgent__ManagedMfaConfigured?: Maybe<Array<webAgent__ManagedMfaConfigured>>;
  webAgent__ManagedMfaFailed?: Maybe<Array<webAgent__ManagedMfaFailed>>;
  webAgent__ManagedMfaOutcome?: Maybe<Array<webAgent__ManagedMfaOutcome>>;
  webAgent__ManagedMfaRejected?: Maybe<Array<webAgent__ManagedMfaRejected>>;
  webAgent__MfaCodeRequest?: Maybe<Array<webAgent__MfaCodeRequest>>;
  webAgent__MfaConfigurationSummaryArtifact?: Maybe<Array<webAgent__MfaConfigurationSummaryArtifact>>;
  webAgent__MfaEmail?: Maybe<Array<webAgent__MfaEmail>>;
  webAgent__MfaNumber?: Maybe<Array<webAgent__MfaNumber>>;
  webAgent__MfaReceiver?: Maybe<Array<webAgent__MfaReceiver>>;
  webAgent__NavigatorSpecialistInstructions?: Maybe<Array<webAgent__NavigatorSpecialistInstructions>>;
  webAgent__NavigatorSpecialistPageDiscovery?: Maybe<Array<webAgent__NavigatorSpecialistPageDiscovery>>;
  webAgent__PlaywrightHarArtifact?: Maybe<Array<webAgent__PlaywrightHarArtifact>>;
  webAgent__PlaywrightInterceptedResponsesArtifact?: Maybe<Array<webAgent__PlaywrightInterceptedResponsesArtifact>>;
  webAgent__PlaywrightPageSourceArtifact?: Maybe<Array<webAgent__PlaywrightPageSourceArtifact>>;
  webAgent__PlaywrightScreenshotArtifact?: Maybe<Array<webAgent__PlaywrightScreenshotArtifact>>;
  webAgent__PlaywrightTraceArtifact?: Maybe<Array<webAgent__PlaywrightTraceArtifact>>;
  webAgent__RecipeFinishedEvent?: Maybe<Array<webAgent__RecipeFinishedEvent>>;
  webAgent__RecipeStartedEvent?: Maybe<Array<webAgent__RecipeStartedEvent>>;
  webAgent__RequestResponseSpan?: Maybe<Array<webAgent__RequestResponseSpan>>;
  webAgent__RobotFinishedEvent?: Maybe<Array<webAgent__RobotFinishedEvent>>;
  webAgent__RobotStartedEvent?: Maybe<Array<webAgent__RobotStartedEvent>>;
  webAgent__SignInRobotResultArtifact?: Maybe<Array<webAgent__SignInRobotResultArtifact>>;
  webAgent__Span?: Maybe<Array<webAgent__Span>>;
  webAgent__UrlOpenedEvent?: Maybe<Array<webAgent__UrlOpenedEvent>>;
  webAgent__UserExitInsuranceLinkFeedback?: Maybe<Array<webAgent__UserExitInsuranceLinkFeedback>>;
  webAgent__WebAgentArtifact?: Maybe<Array<webAgent__WebAgentArtifact>>;
  webAgent__WebAgentExecution?: Maybe<Array<webAgent__WebAgentExecution>>;
  webAgent__WebAgentExecutionArtifact?: Maybe<Array<webAgent__WebAgentExecutionArtifact>>;
  webAgent__WebAgentExecutionEvent?: Maybe<Array<webAgent__WebAgentExecutionEvent>>;
};


export type QueryBaseObjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterBaseObject>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderBaseObject>;
};


export type QueryObjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterObject>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderObject>;
};


export type QueryOwnedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterOwned>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderOwned>;
};


export type QueryPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type QueryPersonalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPersonal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPersonal>;
};


export type QuerySluggedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterSlugged>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderSlugged>;
};


export type QueryUserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type QueryVerifiableArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterVerifiable>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderVerifiable>;
};


export type QueryaddressAutocompleteArgs = {
  input: AddressAutocompleteInput;
};


export type QueryaddressDetailsArgs = {
  input: AddressDetailsInput;
};


export type QueryallRetoolNotificationsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryasyncJob__JobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<asyncJob__FilterJob>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<asyncJob__OrderJob>;
};


export type QuerybeneficiaryArgs = {
  id: Scalars['ID']['input'];
};


export type Querycache__SerifFairMarketValueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<cache__FilterSerifFairMarketValue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<cache__OrderSerifFairMarketValue>;
};


export type QuerycalibrationPreviewArgs = {
  input: CalibrationPreviewInput;
};


export type QuerycaseCardOnFileArgs = {
  issueId: Scalars['ID']['input'];
};


export type QuerycaseConversationVerdictArgs = {
  issueId: Scalars['ID']['input'];
};


export type QuerycaseFact__CaseFactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<caseFact__FilterCaseFact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<caseFact__OrderCaseFact>;
};


export type QuerycaseFact__CaseFactAuditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<caseFact__FilterCaseFactAudit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<caseFact__OrderCaseFactAudit>;
};


export type QuerycaseRoomArgs = {
  roomId: Scalars['ID']['input'];
};


export type QuerycaseRoomArtifactUrlArgs = {
  path: Scalars['String']['input'];
  roomId: Scalars['ID']['input'];
};


export type QuerycaseRoomTranscriptArgs = {
  roomId: Scalars['ID']['input'];
};


export type QuerycaseRoom__RoomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<caseRoom__FilterRoom>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<caseRoom__OrderRoom>;
};


export type QuerycaseRoom__TurnArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<caseRoom__FilterTurn>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<caseRoom__OrderTurn>;
};


export type QuerycaseRowsArgs = {
  benefitsSummarySchemaVersion: Scalars['Int']['input'];
  issueId: Scalars['ID']['input'];
};


export type QuerycaseRowsByIdArgs = {
  benefitsSummarySchemaVersion: Scalars['Int']['input'];
  eventIds: Array<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
};


export type QuerycaseRowsSinceArgs = {
  after: Scalars['String']['input'];
  benefitsSummarySchemaVersion: Scalars['Int']['input'];
  issueId: Scalars['ID']['input'];
};


export type QuerycaseStateArgs = {
  issueId: Scalars['ID']['input'];
};


export type QuerycaseTaskDraftArgs = {
  issueId: Scalars['ID']['input'];
};


export type QuerycaseWorklistPageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter: CaseWorklistFilter;
  first: Scalars['Int']['input'];
  sort: CaseWorklistSort;
};


export type QuerycaseWorklistSummaryArgs = {
  filter: CaseWorklistFilter;
};


export type QuerycheckClientVersionArgs = {
  input: CheckClientVersionInput;
};


export type Querycoding__CPTArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterCPT>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderCPT>;
};


export type Querycoding__CPTModifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterCPTModifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderCPTModifier>;
};


export type Querycoding__CodingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderCoding>;
};


export type Querycoding__HCPCSArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterHCPCS>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderHCPCS>;
};


export type Querycoding__HCPCSModifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<coding__FilterHCPCSModifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<coding__OrderHCPCSModifier>;
};


export type Queryconsent__ConsentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterConsent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderConsent>;
};


export type Queryconsent__HipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type Queryconsent__TemplateReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type Querydocument__DocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type Querydocument__DocumentSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocumentSummary>;
};


export type Querydocument__FileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterFile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderFile>;
};


export type Querydocument__ParseResultArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterParseResult>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderParseResult>;
};


export type Querydocument__TemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};


export type Querydocument__TemplateFieldArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplateField>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplateField>;
};


export type QueryeventStore__EventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<eventStore__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<eventStore__OrderEvent>;
};


export type QueryeventTracking__BaseEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<eventTracking__FilterBaseEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<eventTracking__OrderBaseEvent>;
};


export type QueryeventTracking__InsuranceLinkAttemptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<eventTracking__FilterInsuranceLinkAttempt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<eventTracking__OrderInsuranceLinkAttempt>;
};


export type QueryfaApplicationArgs = {
  issueId: Scalars['ID']['input'];
};


export type QueryfaApplicationForIssueArgs = {
  issueId: Scalars['ID']['input'];
};


export type QueryfaApplicationSupportingDocumentsArgs = {
  issueId: Scalars['ID']['input'];
};


export type QueryfaFlowFormPreviewArgs = {
  issueId: Scalars['ID']['input'];
};


export type Queryfa__ApplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fa__FilterApplication>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fa__OrderApplication>;
};


export type Queryfeedback__GeneralFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterGeneralFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderGeneralFeedback>;
};


export type Queryfeedback__IssueEventFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type Queryfeedback__IssueFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueFeedback>;
};


export type Queryfeedback__OptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};


export type Queryfeedback__StaffFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterStaffFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderStaffFeedback>;
};


export type Queryfeedback__UserFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterUserFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderUserFeedback>;
};


export type QueryfhirEdit__CoverageEditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterCoverageEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderCoverageEdit>;
};


export type QueryfhirEdit__CoverageSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterCoverageSnapshot>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderCoverageSnapshot>;
};


export type QueryfhirEdit__ExplanationOfBenefitEditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterExplanationOfBenefitEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderExplanationOfBenefitEdit>;
};


export type QueryfhirEdit__ExplanationOfBenefitSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterExplanationOfBenefitSnapshot>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderExplanationOfBenefitSnapshot>;
};


export type QueryfhirEdit__ResourceEditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type QueryfhirEdit__ResourceSnapshotArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceSnapshot>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceSnapshot>;
};


export type Queryfhir__AccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccount>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccount>;
};


export type Queryfhir__AccountBalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type Queryfhir__AccountGuarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type Queryfhir__AddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAddress>;
};


export type Queryfhir__AnnotationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type Queryfhir__ChargeItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItem>;
};


export type Queryfhir__ChargeItemPerformerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItemPerformer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItemPerformer>;
};


export type Queryfhir__ClinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type Queryfhir__CodeableConceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type Queryfhir__CodeableReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableReference>;
};


export type Queryfhir__CodingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type Queryfhir__ContactPointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};


export type Queryfhir__CoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverage>;
};


export type Queryfhir__CoverageClassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type Queryfhir__EncounterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounter>;
};


export type Queryfhir__EncounterParticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type Queryfhir__ExplanationOfBenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefit>;
};


export type Queryfhir__ExplanationOfBenefitCareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type Queryfhir__ExplanationOfBenefitDiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type Queryfhir__ExplanationOfBenefitItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type Queryfhir__ExplanationOfBenefitItemAdjudicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemAdjudication>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemAdjudication>;
};


export type Queryfhir__ExplanationOfBenefitItemReviewOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemReviewOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemReviewOutcome>;
};


export type Queryfhir__ExplanationOfBenefitTotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type Queryfhir__FHIRResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterFHIRResource>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderFHIRResource>;
};


export type Queryfhir__HumanNameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type Queryfhir__IdentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type Queryfhir__InvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoice>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoice>;
};


export type Queryfhir__InvoiceLineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type Queryfhir__InvoiceParticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type Queryfhir__LocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type Queryfhir__MonetaryComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMonetaryComponent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMonetaryComponent>;
};


export type Queryfhir__MoneyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type Queryfhir__PatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterPatient>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderPatient>;
};


export type Queryfhir__PractitionerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterPractitioner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderPractitioner>;
};


export type Queryfhir__QuantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type Queryfhir__ReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type Queryfhirext__AccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterAccount>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderAccount>;
};


export type Queryfhirext__AccountVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterAccountVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderAccountVersion>;
};


export type Queryfhirext__CoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverage>;
};


export type Queryfhirext__CoverageExtensionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverageExtension>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverageExtension>;
};


export type Queryfhirext__CoverageVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverageVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverageVersion>;
};


export type Queryfhirext__EncounterArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterEncounter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderEncounter>;
};


export type Queryfhirext__EncounterVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterEncounterVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderEncounterVersion>;
};


export type Queryfhirext__ExplanationOfBenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefit>;
};


export type Queryfhirext__ExplanationOfBenefitExtensionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitExtension>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitExtension>;
};


export type Queryfhirext__ExplanationOfBenefitTotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type Queryfhirext__ExplanationOfBenefitVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type Queryfhirext__FindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type Queryfhirext__FindingReviewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFindingReview>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFindingReview>;
};


export type Queryfhirext__InvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoice>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoice>;
};


export type Queryfhirext__InvoiceTotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
};


export type Queryfhirext__InvoiceVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type Queryfhirext__PatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterPatient>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderPatient>;
};


export type Queryfhirext__PatientVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterPatientVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderPatientVersion>;
};


export type Queryfhirext__PractitionerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterPractitioner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderPractitioner>;
};


export type Queryfhirext__PractitionerVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterPractitionerVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderPractitionerVersion>;
};


export type Queryfhirext__ResourceAssociationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceAssociation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceAssociation>;
};


export type Queryfhirext__ResourceIdentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceIdentifier>;
};


export type Queryfhirext__ResourceVersionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type Queryflexpa__EndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderEndpoint>;
};


export type Queryflexpa__FlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type Queryflexpa__LinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type Queryflexpa__OrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderOrganization>;
};


export type QueryforecastingBenchmarkRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryforecastingOverviewArgs = {
  horizonWeeks?: InputMaybe<Scalars['Int']['input']>;
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
};


export type Queryforecasting__BenchmarkRunArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterBenchmarkRun>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderBenchmarkRun>;
};


export type Queryforecasting__HeadcountForecastArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterHeadcountForecast>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderHeadcountForecast>;
};


export type Queryforecasting__InvestmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterInvestment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderInvestment>;
};


export type Queryforecasting__MarketingForecastArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterMarketingForecast>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderMarketingForecast>;
};


export type Queryforecasting__ScenarioArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterScenario>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderScenario>;
};


export type Queryforecasting__VariableOverrideArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterVariableOverride>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderVariableOverride>;
};


export type QuerygetActivePromoForIssueArgs = {
  issueId: Scalars['ID']['input'];
};


export type QuerygetAttemptStatusArgs = {
  input: GetAttemptStatusInput;
};


export type QuerygetFormFillArgs = {
  input: GetFormFillInput;
};


export type QuerygetTemplateReleaseArgs = {
  input: GetTemplateReleaseInput;
};


export type QueryhaMyTasksArgs = {
  filter: HaMyTasksFilter;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};


export type QueryhaMyTasksCountArgs = {
  filter: HaMyTasksFilter;
};


export type Queryingestion__DistillationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterDistillation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderDistillation>;
};


export type Queryingestion__ExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type Queryingestion__IngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type Queryingestion__IngestionStepArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestionStep>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestionStep>;
};


export type Queryintake__IntakeDraftArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<intake__FilterIntakeDraft>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<intake__OrderIntakeDraft>;
};


export type Queryintake__IntakeRecordArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<intake__FilterIntakeRecord>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<intake__OrderIntakeRecord>;
};


export type Queryintegration__BaseEndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type Queryintegration__BaseLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseLink>;
};


export type Queryintegration__OrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};


export type Queryissue__AskReraisedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterAskReraisedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderAskReraisedEvent>;
};


export type Queryissue__BenefitsContextArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsContext>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsContext>;
};


export type Queryissue__BenefitsSummaryGeneratedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsSummaryGeneratedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsSummaryGeneratedEvent>;
};


export type Queryissue__BillDisputeEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillDisputeEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillDisputeEvent>;
};


export type Queryissue__BillPayPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPayPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPayPostEscalationAction>;
};


export type Queryissue__BillPayRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPayRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPayRequestedEvent>;
};


export type Queryissue__BillPaySuccessEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaySuccessEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaySuccessEvent>;
};


export type Queryissue__BillPaymentRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaymentRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaymentRequestedEvent>;
};


export type Queryissue__BillPaymentSuccessEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaymentSuccessEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaymentSuccessEvent>;
};


export type Queryissue__CardCollectionRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterCardCollectionRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderCardCollectionRequestedEvent>;
};


export type Queryissue__ChatEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterChatEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderChatEvent>;
};


export type Queryissue__ClosedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterClosedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderClosedEvent>;
};


export type Queryissue__ClosurePaymentRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterClosurePaymentRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderClosurePaymentRequestedEvent>;
};


export type Queryissue__CommentEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterCommentEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderCommentEvent>;
};


export type Queryissue__CompleteFaApplicationPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterCompleteFaApplicationPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderCompleteFaApplicationPostEscalationAction>;
};


export type Queryissue__ConnectAccountRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};


export type Queryissue__ConnectEhrPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectEhrPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectEhrPostEscalationAction>;
};


export type Queryissue__ConnectInsurancePostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectInsurancePostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectInsurancePostEscalationAction>;
};


export type Queryissue__ConnectInsuranceRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectInsuranceRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectInsuranceRequestedEvent>;
};


export type Queryissue__DocumentAnalysisEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentAnalysisEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentAnalysisEvent>;
};


export type Queryissue__DocumentClassificationFailedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentClassificationFailedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentClassificationFailedEvent>;
};


export type Queryissue__DocumentUploadedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};


export type Queryissue__EventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type Queryissue__FaEligibilityInfoPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterFaEligibilityInfoPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderFaEligibilityInfoPostEscalationAction>;
};


export type Queryissue__FinancialAssistanceFlowEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterFinancialAssistanceFlowEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderFinancialAssistanceFlowEvent>;
};


export type Queryissue__HAAssignedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterHAAssignedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderHAAssignedEvent>;
};


export type Queryissue__HipaaReleaseRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterHipaaReleaseRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderHipaaReleaseRequestedEvent>;
};


export type Queryissue__InternalDocumentUploadedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterInternalDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderInternalDocumentUploadedEvent>;
};


export type Queryissue__IssueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type Queryissue__IssueDocumentSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssueDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssueDocumentSummary>;
};


export type Queryissue__OutreachEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterOutreachEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderOutreachEvent>;
};


export type Queryissue__PaymentAgreementPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentAgreementPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentAgreementPostEscalationAction>;
};


export type Queryissue__PaymentAgreementRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentAgreementRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentAgreementRequestedEvent>;
};


export type Queryissue__PaymentChargeFailedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentChargeFailedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentChargeFailedEvent>;
};


export type Queryissue__PaymentChargeResolvedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentChargeResolvedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentChargeResolvedEvent>;
};


export type Queryissue__PaymentPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferences>;
};


export type Queryissue__PaymentPreferencesPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferencesPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferencesPostEscalationAction>;
};


export type Queryissue__PaymentPreferencesRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferencesRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferencesRequestedEvent>;
};


export type Queryissue__PaymentPreferencesUpdatedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferencesUpdatedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferencesUpdatedEvent>;
};


export type Queryissue__PhoneCallEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPhoneCallEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPhoneCallEvent>;
};


export type Queryissue__PlanSelectionEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPlanSelectionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPlanSelectionEvent>;
};


export type Queryissue__PostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPostEscalationAction>;
};


export type Queryissue__PostEscalationActionsEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPostEscalationActionsEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPostEscalationActionsEvent>;
};


export type Queryissue__PreAuthRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPreAuthRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPreAuthRequestedEvent>;
};


export type Queryissue__ReopenedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterReopenedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderReopenedEvent>;
};


export type Queryissue__ResolutionPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterResolutionPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderResolutionPreferences>;
};


export type Queryissue__SignTemplatePostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterSignTemplatePostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderSignTemplatePostEscalationAction>;
};


export type Queryissue__TemplateReleaseRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterTemplateReleaseRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderTemplateReleaseRequestedEvent>;
};


export type Queryissue__ToolExecutionEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterToolExecutionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderToolExecutionEvent>;
};


export type Queryissue__UploadBillPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUploadBillPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUploadBillPostEscalationAction>;
};


export type Queryissue__UploadEobPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUploadEobPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUploadEobPostEscalationAction>;
};


export type Queryissue__UploadMemberIdPostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUploadMemberIdPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUploadMemberIdPostEscalationAction>;
};


export type Queryissue__UploadProofOfIncomePostEscalationActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUploadProofOfIncomePostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUploadProofOfIncomePostEscalationAction>;
};


export type Queryissue__UserInputRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUserInputRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUserInputRequestedEvent>;
};


export type Queryissue__UserMultiSelectionRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUserMultiSelectionRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUserMultiSelectionRequestedEvent>;
};


export type Queryissue__UserSelectionRequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterUserSelectionRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderUserSelectionRequestedEvent>;
};


export type QuerymodelExecution__LLMExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type QuerymodelExecution__VellumLLMExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterVellumLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderVellumLLMExecution>;
};


export type QuerynateraCaseIntakeArgs = {
  issueId: Scalars['ID']['input'];
};


export type Querynotification__RetoolNotificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<notification__FilterRetoolNotification>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<notification__OrderRetoolNotification>;
};


export type Querypartner__InviteLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterInviteLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderInviteLink>;
};


export type Querypartner__PartnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};


export type Querypartner__PartnerGroupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartnerGroup>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartnerGroup>;
};


export type QuerypayerByPayerIdArgs = {
  payerId: Scalars['String']['input'];
};


export type QuerypayerSync__PayerChangeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payerSync__FilterPayerChange>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payerSync__OrderPayerChange>;
};


export type QuerypayerSync__RunArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payerSync__FilterRun>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payerSync__OrderRun>;
};


export type Querypayer__PayerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayer>;
};


export type Querypayer__PayerAliasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayerAlias>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayerAlias>;
};


export type Querypayer__TransactionEnrollmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterTransactionEnrollment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderTransactionEnrollment>;
};


export type Querypayment__IssuePromoCodeUsageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type Querypayment__PaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};


export type Querypayment__PaymentTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


export type Querypayment__PromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};


export type Querypayment__SubscriptionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterSubscription>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderSubscription>;
};


export type Queryperson__AddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<person__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<person__OrderAddress>;
};


export type QueryplanEpicEndpointChangesArgs = {
  input: PlanEpicEndpointChangesInput;
};


export type Queryplan__BenefitsSummaryResultArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterBenefitsSummaryResult>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderBenefitsSummaryResult>;
};


export type Queryplan__PlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type QuerypreviewNegotiatedBillChargeArgs = {
  input: PreviewNegotiatedBillChargeInput;
};


export type Queryprojection__BenefitPositionObservationViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterBenefitPositionObservationView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderBenefitPositionObservationView>;
};


export type Queryprojection__CaseAskViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseAskView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseAskView>;
};


export type Queryprojection__CaseBillAmountViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseBillAmountView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseBillAmountView>;
};


export type Queryprojection__CaseFlowViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseFlowView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseFlowView>;
};


export type Queryprojection__CasePriorPaymentViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCasePriorPaymentView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCasePriorPaymentView>;
};


export type Queryprojection__CaseProviderViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseProviderView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseProviderView>;
};


export type Queryprojection__CaseReengagementFeedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseReengagementFeed>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseReengagementFeed>;
};


export type Queryprojection__CaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};


export type Queryprojection__EligibilityCheckAttemptViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterEligibilityCheckAttemptView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderEligibilityCheckAttemptView>;
};


export type Queryprojection__InsuranceDiscoveryAttemptViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterInsuranceDiscoveryAttemptView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderInsuranceDiscoveryAttemptView>;
};


export type Queryprojection__RpaBrowserFingerprintArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaBrowserFingerprint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaBrowserFingerprint>;
};


export type Queryprojection__RpaConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};


export type Queryprojection__RpaEgressIpArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaEgressIp>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaEgressIp>;
};


export type Queryprojection__RpaExperimentViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaExperimentView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaExperimentView>;
};


export type Queryprojection__RpaLinkViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaLinkView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaLinkView>;
};


export type Queryprojection__RpaProviderAttemptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaProviderAttempt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaProviderAttempt>;
};


export type Queryprojection__RpaSessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};


export type Queryprojection__RpaSessionSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSessionSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSessionSummary>;
};


export type Queryprojection__RpaSessionTimelineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSessionTimeline>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSessionTimeline>;
};


export type Queryprojection__RpaTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTask>;
};


export type Queryprojection__RpaTimelineEntryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTimelineEntry>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTimelineEntry>;
};


export type Queryprojection__UserDataViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterUserDataView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderUserDataView>;
};


export type Queryprojection__UserEligibilityViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterUserEligibilityView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderUserEligibilityView>;
};


export type Queryprojection__UserEnrichmentDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterUserEnrichmentData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderUserEnrichmentData>;
};


export type Queryprojection__UserMemoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterUserMemory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderUserMemory>;
};


export type QueryproviderFaPolicyResolutionArgs = {
  providerId: Scalars['ID']['input'];
};


export type QueryproviderFormDetectionArgs = {
  input: ProviderFormDetectionInput;
};


export type QueryproviderResearchRunsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  providerId: Scalars['ID']['input'];
};


export type Queryprovider__ContactPointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};


export type Queryprovider__NegotiationProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterNegotiationProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderNegotiationProfile>;
};


export type Queryprovider__ProviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type Queryprovider__ProviderFormArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProviderForm>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProviderForm>;
};


export type Queryprovider__ResearchRunArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterResearchRun>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderResearchRun>;
};


export type QueryqueryFlaggedExplanationOfBenefitsForUserArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryqueryIssuesArgs = {
  input?: InputMaybe<QueryIssuesInput>;
};


export type QueryqueryIssuesV2Args = {
  after?: InputMaybe<Scalars['Int']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryqueryUserDocumentArgs = {
  key: Scalars['ID']['input'];
  kind: UserDocumentKind;
};


export type QueryqueryUserDocumentsArgs = {
  kind: UserDocumentKind;
};


export type QueryqueryUserEobArgs = {
  key: Scalars['ID']['input'];
};


export type QueryqueryUserInvoiceArgs = {
  key: Scalars['ID']['input'];
};


export type QueryqueryUserUploadedDocumentsArgs = {
  input: UserUploadedDocumentsInput;
};


export type QueryqueryWebAgentExecutionsArgs = {
  input: QueryWebAgentExecutionsInput;
};


export type QueryresolveInviteTokenArgs = {
  inviteToken: Scalars['String']['input'];
};


export type QueryrpaFactsArgs = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  linkIds: Array<Scalars['String']['input']>;
};


export type QueryrpaLinkViewsArgs = {
  input: RpaLinkViewsInput;
};


export type QueryrpaScheduleForecastArgs = {
  input: RpaScheduleForecastInput;
};


export type QueryrpaSessionAnnotationsArgs = {
  sessionId: Scalars['String']['input'];
};


export type QueryrpaSessionDotsArgs = {
  input: RpaSessionDotsInput;
};


export type QueryrpaSessionOutcomeGradesArgs = {
  input: RpaSessionOutcomeGradesInput;
};


export type QueryrpaSessionTimelineArgs = {
  input: RpaSessionTimelineInput;
};


export type QueryrpaStatusOverridesArgs = {
  sessionIds: Array<Scalars['String']['input']>;
};


export type QueryrunnerTracesArgs = {
  executionId: Scalars['String']['input'];
};


export type QuerysearchPayersArgs = {
  input: SearchPayersInput;
};


export type QuerysearchProvidersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
};


export type Querysegment__PartnerSegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterPartnerSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderPartnerSegment>;
};


export type Querysegment__SegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};


export type Querysegment__UserSegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterUserSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderUserSegment>;
};


export type Querysegment__UtmSegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterUtmSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderUtmSegment>;
};


export type QuerystaffTailgateArgs = {
  executionId: Scalars['String']['input'];
};


export type Querysuggestion__SuggestedActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<suggestion__FilterSuggestedAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<suggestion__OrderSuggestedAction>;
};


export type QuerytaskManagement__DataQualityFlagTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterDataQualityFlagTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderDataQualityFlagTask>;
};


export type QuerytaskManagement__FollowUpClosurePendingIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterFollowUpClosurePendingIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderFollowUpClosurePendingIssueTask>;
};


export type QuerytaskManagement__FollowUpUserUnresponsiveIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterFollowUpUserUnresponsiveIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderFollowUpUserUnresponsiveIssueTask>;
};


export type QuerytaskManagement__GeneralIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterGeneralIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderGeneralIssueTask>;
};


export type QuerytaskManagement__IssueResearchTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueResearchTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueResearchTask>;
};


export type QuerytaskManagement__IssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};


export type QuerytaskManagement__IssueUserMessagingTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueUserMessagingTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueUserMessagingTask>;
};


export type QuerytaskManagement__PhoneCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterPhoneCall>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderPhoneCall>;
};


export type QuerytaskManagement__PhoneCallIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterPhoneCallIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderPhoneCallIssueTask>;
};


export type QuerytaskManagement__ProcessCustomerBillPaymentIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterProcessCustomerBillPaymentIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderProcessCustomerBillPaymentIssueTask>;
};


export type QuerytaskManagement__RetryChargeIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterRetryChargeIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderRetryChargeIssueTask>;
};


export type QuerytaskManagement__ReviewCaseIntakeIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewCaseIntakeIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewCaseIntakeIssueTask>;
};


export type QuerytaskManagement__ReviewEscalatedCaseTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewEscalatedCaseTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewEscalatedCaseTask>;
};


export type QuerytaskManagement__ReviewFindingTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewFindingTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewFindingTask>;
};


export type QuerytaskManagement__ReviewIssueChatTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewIssueChatTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewIssueChatTask>;
};


export type QuerytaskManagement__ReviewPaymentAcceptanceIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewPaymentAcceptanceIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewPaymentAcceptanceIssueTask>;
};


export type QuerytaskManagement__ReviewSuggestionTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterReviewSuggestionTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderReviewSuggestionTask>;
};


export type QuerytaskManagement__SendFormIssueTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterSendFormIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderSendFormIssueTask>;
};


export type QuerytaskManagement__TaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};


export type QuerytaskManagement__TaskCommentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type QuerytemplateFieldAttributesArgs = {
  input: TemplateFieldAttributesInput;
};


export type QuerytemplateFileArgs = {
  input: TemplateFileInput;
};


export type QueryunreadRetoolNotificationsArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryuserInsuranceArgs = {
  userId: Scalars['ID']['input'];
};


export type Queryuser__EmailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterEmail>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderEmail>;
};


export type Queryuser__ProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type Queryuser__SegmentationDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterSegmentationData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderSegmentationData>;
};


export type QueryviewDocumentArgs = {
  input: ViewDocumentInput;
};


export type QueryviewDocumentFileArgs = {
  input: ViewDocumentFileInput;
};


export type QuerywebAgent__AiConversationLogArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiConversationLogArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiConversationLogArtifact>;
};


export type QuerywebAgent__AiDiscoveryCrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type QuerywebAgent__AiDiscoveryCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type QuerywebAgent__CrawlDataSummaryArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterCrawlDataSummaryArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderCrawlDataSummaryArtifact>;
};


export type QuerywebAgent__EndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type QuerywebAgent__EndpointSupportLevelHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};


export type QuerywebAgent__ExecutionClassificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterExecutionClassification>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderExecutionClassification>;
};


export type QuerywebAgent__InitialPageLoadSpanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterInitialPageLoadSpan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderInitialPageLoadSpan>;
};


export type QuerywebAgent__LinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type QuerywebAgent__LinkProviderProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkProviderProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkProviderProfile>;
};


export type QuerywebAgent__LinkSecretArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkSecret>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkSecret>;
};


export type QuerywebAgent__ManagedMfaConfigurationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaConfiguration>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaConfiguration>;
};


export type QuerywebAgent__ManagedMfaConfiguredArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaConfigured>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaConfigured>;
};


export type QuerywebAgent__ManagedMfaFailedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaFailed>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaFailed>;
};


export type QuerywebAgent__ManagedMfaOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type QuerywebAgent__ManagedMfaRejectedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaRejected>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaRejected>;
};


export type QuerywebAgent__MfaCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type QuerywebAgent__MfaConfigurationSummaryArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaConfigurationSummaryArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaConfigurationSummaryArtifact>;
};


export type QuerywebAgent__MfaEmailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaEmail>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaEmail>;
};


export type QuerywebAgent__MfaNumberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaNumber>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaNumber>;
};


export type QuerywebAgent__MfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};


export type QuerywebAgent__NavigatorSpecialistInstructionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterNavigatorSpecialistInstructions>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderNavigatorSpecialistInstructions>;
};


export type QuerywebAgent__NavigatorSpecialistPageDiscoveryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterNavigatorSpecialistPageDiscovery>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderNavigatorSpecialistPageDiscovery>;
};


export type QuerywebAgent__PlaywrightHarArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightHarArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightHarArtifact>;
};


export type QuerywebAgent__PlaywrightInterceptedResponsesArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightInterceptedResponsesArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightInterceptedResponsesArtifact>;
};


export type QuerywebAgent__PlaywrightPageSourceArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightPageSourceArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightPageSourceArtifact>;
};


export type QuerywebAgent__PlaywrightScreenshotArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightScreenshotArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightScreenshotArtifact>;
};


export type QuerywebAgent__PlaywrightTraceArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightTraceArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightTraceArtifact>;
};


export type QuerywebAgent__RecipeFinishedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRecipeFinishedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRecipeFinishedEvent>;
};


export type QuerywebAgent__RecipeStartedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRecipeStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRecipeStartedEvent>;
};


export type QuerywebAgent__RequestResponseSpanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRequestResponseSpan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRequestResponseSpan>;
};


export type QuerywebAgent__RobotFinishedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRobotFinishedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRobotFinishedEvent>;
};


export type QuerywebAgent__RobotStartedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRobotStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRobotStartedEvent>;
};


export type QuerywebAgent__SignInRobotResultArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterSignInRobotResultArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderSignInRobotResultArtifact>;
};


export type QuerywebAgent__SpanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterSpan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderSpan>;
};


export type QuerywebAgent__UrlOpenedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterUrlOpenedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderUrlOpenedEvent>;
};


export type QuerywebAgent__UserExitInsuranceLinkFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterUserExitInsuranceLinkFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderUserExitInsuranceLinkFeedback>;
};


export type QuerywebAgent__WebAgentArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentArtifact>;
};


export type QuerywebAgent__WebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type QuerywebAgent__WebAgentExecutionArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionArtifact>;
};


export type QuerywebAgent__WebAgentExecutionEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionEvent>;
};

export type QueryIssuesInput = {
  after?: InputMaybe<Scalars['Int']['input']>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryWebAgentExecutionsInput = {
  userId: Scalars['ID']['input'];
};

export type RPADebugMode =
  { endpointMode: RPADebugModeEndpoint; linkMode?: never; urlMode?: never; }
  |  { endpointMode?: never; linkMode: RPADebugModeLink; urlMode?: never; }
  |  { endpointMode?: never; linkMode?: never; urlMode: RPADebugModeUrl; };

export type RPADebugModeEndpoint = {
  endpointId: Scalars['ID']['input'];
};

export type RPADebugModeLink = {
  linkId: Scalars['String']['input'];
  rehydrate: Scalars['Boolean']['input'];
};

export type RPADebugModeUrl = {
  url: Scalars['String']['input'];
};

export type RecalculateEligibilityEnrollmentInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ReclassifyRpaSessionAsAgentInput = {
  /**
   * Which agent is posting, e.g. "claude-code/reclassify-link-attempt-status".
   * Shown next to the investigator in the history.
   */
  agentName: Scalars['String']['input'];
  confidence?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Short analysis, max 500 characters. Stored as an Evidence Room annotation
   * attributed to the investigator, with this agent recorded as having posted it.
   */
  note?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['String']['input'];
  status?: InputMaybe<RpaOpsStatusOverride>;
};

export type ReclassifyRpaSessionInput = {
  /** 0-1. Required when `status` is set. */
  confidence?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Short analysis, max 500 characters. Stored as an Evidence Room annotation;
   * the event carries a pointer to it. Read it back with `rpaSessionAnnotations`.
   */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The `WebAgentExecution.id` shown on the ops board (equal to the RpaSession id). */
  sessionId: Scalars['String']['input'];
  /** Omit for a note-only entry. */
  status?: InputMaybe<RpaOpsStatusOverride>;
};

export type ReclassifyRpaSessionResponse = {
  __typename: 'ReclassifyRpaSessionResponse';
  accepted: Scalars['Boolean']['output'];
};

export type RecommendationFeedbackInput = {
  issueId: Scalars['ID']['input'];
  /**
   * Freeform HA correction. Non-empty after trimming — the resolver rejects
   * whitespace-only input with a GrantedError.
   */
  notes: Scalars['String']['input'];
};

export type RecordIdentityInput = {
  dateOfBirth: Scalars['LocalDate']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type RecordInsuranceInput = {
  /**
   * Carrier display name. Recorded verbatim as user memory and used as the
   * Member's payerName — it is what the payer search matches on.
   */
  carrier: Scalars['String']['input'];
  /**
   * `webAgent::Endpoint.slug` of the picked carrier; keys the Member row when no
   * payerId is sent. Falls back to the display name when both are absent.
   */
  carrierSlug?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['LocalDate']['input']>;
  /**
   * Subscriber identity for the Member row. All three or none — a partial set
   * records the carrier as memory only.
   *
   * Nullable on purpose — already-shipped mobile builds don't send them.
   * TODO: make required once those builds are forced past a
   * `supportedClientUpdateId` bump.
   */
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /**
   * The member ID on the user's insurance card, for payers that reject an
   * eligibility check without one. Spaces and dashes are ignored. Stored on the
   * Member row, so it needs the subscriber identity too.
   */
  memberId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Primary payer ID of the payer picked from the payer catalog. Stored on the
   * Member row and keys it; eligibility checks it before matching the name.
   */
  payerId?: InputMaybe<Scalars['String']['input']>;
};

export type RecordInsuranceStatusInput = {
  status: InsuranceStatus;
};

export type RecordIssueEventFeedbackInput = {
  eventId: Scalars['ID']['input'];
  rating: Scalars['Int']['input'];
  review?: InputMaybe<Scalars['String']['input']>;
  selectedOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Post-sign-up answers for an express-arm packet. The income fields are one
 * answer: send \`incomeDeclined: true\` alone, or \`incomeDeclined: false\` with a
 * figure (and its band, for a range pick).
 */
export type RecordNateraIntakeAnswersInput = {
  annualHouseholdIncomeCents?: InputMaybe<Scalars['Int']['input']>;
  faRead?: InputMaybe<NateraIntakeFaRead>;
  householdSize?: InputMaybe<Scalars['Int']['input']>;
  incomeDeclined?: InputMaybe<Scalars['Boolean']['input']>;
  incomeRangeCeilingCents?: InputMaybe<Scalars['Int']['input']>;
  incomeRangeFloorCents?: InputMaybe<Scalars['Int']['input']>;
  insuranceCarrier?: InputMaybe<Scalars['String']['input']>;
  projectedTargetCents?: InputMaybe<Scalars['Int']['input']>;
};

export type RecordPhoneInput = {
  /**
   * Version identifier of the TCPA disclosure the user agreed to (a FE
   * constant). Persisted for compliance; the server stamps the time.
   */
  consentVersion: Scalars['String']['input'];
  /**
   * The number as the user typed it. Normalized to E.164 before it is stored, so
   * the client sends back exactly what it showed.
   */
  phoneNumber: Scalars['String']['input'];
};

/** A redeemed invite: the partner plus the user it is now bound to. */
export type RedeemedInviteToken = {
  __typename: 'RedeemedInviteToken';
  partner: InviteTokenPartner;
  /** The onboarding user this invite is bound to. Always present once redeemed. */
  userId: Scalars['ID']['output'];
};

export type RedisMessage = {
  message: Scalars['String']['input'];
  requestChannel: Scalars['String']['input'];
  responseChannel: Scalars['String']['input'];
};

export type RedisResponse = {
  __typename: 'RedisResponse';
  message: Scalars['String']['output'];
};

export type RefreshAccountUpdatesPrompt = BaseUpdatesPrompt & {
  __typename: 'RefreshAccountUpdatesPrompt';
  count: Scalars['Int']['output'];
  type: UpdatesPromptType;
};

export type RejectSuggestedActionInput = {
  actionId: Scalars['ID']['input'];
  /**
   * The advocate's own words. Only carries the "Other" case now that the coded
   * half has its own field — the two used to share this one column, which made
   * the codes impossible to aggregate.
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  reasonCode?: InputMaybe<SuggestionRejectReason>;
};

/**
 * What became of a reject. `success` alone could not tell the advocate why
 * nothing happened, so every failure read as the same shrug: "Could not reject".
 */
export enum RejectSuggestedActionOutcome {
  /**
   * Closed some other way already — ACCEPTED, MODIFIED, or SUPERSEDED. The
   * status itself is deliberately not on the wire, so a client must not claim
   * which one: rejecting is refused for all three, but only ACCEPTED means the
   * suggestion actually went out.
   */
  ALREADY_CLOSED = 'ALREADY_CLOSED',
  /**
   * Already rejected before this call — almost always by the send path, which
   * closes the open suggestion the moment an advocate sends their own reply while
   * the card offering "Not this" is still on their screen. The row is in the state
   * they asked for, so this is a success.
   */
  ALREADY_REJECTED = 'ALREADY_REJECTED',
  /** Something else went wrong server-side. */
  FAILED = 'FAILED',
  /** No such SuggestedAction. */
  NOT_FOUND = 'NOT_FOUND',
  /** Rejected on this call. */
  REJECTED = 'REJECTED'
}

export type RejectSuggestedActionResult = {
  __typename: 'RejectSuggestedActionResult';
  actionId: Scalars['ID']['output'];
  outcome: RejectSuggestedActionOutcome;
  /** True for REJECTED and ALREADY_REJECTED — the row ended up rejected either way. */
  success: Scalars['Boolean']['output'];
};

export type RemoveNegotiationProfileInput = {
  providerId: Scalars['ID']['input'];
};

export type RemoveProviderContactPointInput = {
  contactPointId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};

export type RemoveProviderFaPolicyInput = {
  providerId: Scalars['ID']['input'];
};

export type RemoveProviderFormInput = {
  formId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
};

export type RemoveUserSegmentInput = {
  segmentId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type RemoveUserSegmentResult = {
  __typename: 'RemoveUserSegmentResult';
  removedCount: Scalars['Int']['output'];
};

export type RenameProviderFormInput = {
  formId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
};

export type ReopenIssueInput = {
  issueId: Scalars['ID']['input'];
};

export type RepinFaApplicationFormInput = {
  /**
   * Explicit opt-in to re-pin a SUBMITTED application — the migration of a filed
   * generic-baseline application onto the provider's newly onboarded form. The
   * submission record never moves (it lives in the aggregate's submissionSnapshot
   * and event history); the re-pin moves the working form pointer and spec
   * version, and clears only non-conformant values, exactly as a draft re-pin
   * does. Baseline-only: a submitted application already pinned to a provider
   * form refuses, since its snapshot was filed under that form's spec. Omitted
   * or false keeps the draft-only behavior.
   */
  allowSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The provider form id the HA confirmed in the preview dialog. Used as a
   * compare-and-swap: the server refuses (a FormError) when the form that resolves
   * for the case now differs — a recalibration or repromotion landed between
   * preview and confirm — so a dialog showing form A can never silently apply
   * form B. Taken from `faFlowFormPreview.formId`.
   */
  expectedFormId: Scalars['ID']['input'];
  /**
   * The FormSpec version the HA confirmed (`faFlowFormPreview.formSpecVersion`).
   * The second compare-and-swap dimension: the same form id can be repromoted to a
   * newer spec between preview and confirm, and the server refuses if the version
   * no longer matches so the aggregate stamps exactly the spec the operator saw.
   */
  expectedFormSpecVersion: Scalars['Int']['input'];
  issueId: Scalars['ID']['input'];
};

/** A re-pin that had no effect; carries the reason and a ready-to-render message. */
export type RepinFaApplicationFormNoop = {
  __typename: 'RepinFaApplicationFormNoop';
  message: Scalars['String']['output'];
  reason: RepinFaApplicationFormNoopReason;
};

/**
 * Why a re-pin changed nothing. Surfaced as a distinct result member (not a
 * FormError) so the caller shows a neutral message rather than a failure.
 */
export enum RepinFaApplicationFormNoopReason {
  /** The resolvable form is already the one pinned on the draft. */
  ALREADY_PINNED = 'ALREADY_PINNED',
  /** No calibrated form resolves for the case's provider — the draft stays on the generic baseline. */
  NO_RESOLVABLE_FORM = 'NO_RESOLVABLE_FORM'
}

export type RepinFaApplicationFormResult = FormError | RepinFaApplicationFormNoop | RepinnedFaApplicationForm;

/**
 * A successful re-pin: the provider form now pinned on the draft, plus how many of
 * the draft's existing answers carry over to it. These are the numbers the HA
 * confirm dialog shows ("N of M answers carry over; the user fills the rest").
 */
export type RepinnedFaApplicationForm = {
  __typename: 'RepinnedFaApplicationForm';
  /**
   * How many of the draft's current answer keys exist as a field on the newly
   * pinned form — the answers that carry over.
   */
  carriedOver: Scalars['Int']['output'];
  /** The provider form now pinned on the application. */
  formId: Scalars['ID']['output'];
  formName?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  /**
   * OWN when the case's linked provider owns the form; INHERITED when it resolves
   * from the parent system via partOf. Never BASELINE (a re-pin always lands on a
   * concrete form).
   */
  resolution: FaFlowFormResolutionKind;
  /** Total answer keys currently held in the draft. */
  totalAnswers: Scalars['Int']['output'];
};

/**
 * cardRequestKey is minted per send. Re-sending it returns the event the first
 * attempt created. A new key supersedes any still-pending card-only request.
 */
export type RequestCardCollectionInput = {
  cardRequestKey: Scalars['String']['input'];
  issueId: Scalars['ID']['input'];
};

export type RequestNateraIntakeReminderInput = {
  issueId: Scalars['ID']['input'];
  remindAt: Scalars['DateTime']['input'];
};

export type RequestNewMfaCodeInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['String']['input'];
};

export type ResendFaFlowInput = {
  issueId: Scalars['ID']['input'];
};

export type ResendMagicLinkInput = {
  /** If specified, magic links sent by Stytch will redirect to this URI. */
  clientRedirectUri?: InputMaybe<Scalars['String']['input']>;
  /** Challenge token for PKCE flow. */
  codeChallenge?: InputMaybe<Scalars['String']['input']>;
  /**
   * Send a link that can be opened in any browser (no PKCE); any codeChallenge
   * passed is dropped. The client gates this to Meta in-app browsers by flag.
   */
  crossBrowserLink?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  /**
   * When true, sends an email OTP (code + code-carrying link) instead of a
   * PKCE-bound magic link.
   */
  useEmailOtp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ResendMagicLinkResult = {
  __typename: 'ResendMagicLinkResult';
  success: Scalars['Boolean']['output'];
};

export type ResourceSnapshotResult = {
  __typename: 'ResourceSnapshotResult';
  computedAt: Scalars['DateTime']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  snapshotId: Scalars['ID']['output'];
};

export type ReviewFindingInput = {
  findingId: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  status: fhirext__ReviewStatus;
};

export type RpaCommandReceived = {
  __typename: 'RpaCommandReceived';
  workflowId: Scalars['String']['output'];
};

export type RpaCommandResult = RpaCommandReceived | RpaCommunicationError;

export type RpaCommunicationError = {
  __typename: 'RpaCommunicationError';
  cause?: Maybe<Scalars['String']['output']>;
};

export type RpaDayOfWeekRateRow = {
  __typename: 'RpaDayOfWeekRateRow';
  dayOfWeek: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaDistributionRow = {
  __typename: 'RpaDistributionRow';
  p5: Scalars['Float']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
};

export type RpaDone = {
  __typename: 'RpaDone';
  result?: Maybe<RpaDoneResult>;
};

export type RpaDoneResult = FailedLoginMaxReached | InvalidCredentials | LoginSuccess | ManagedMfaApprovalRequired | MfaRequired | RpaError | SecurityQuestionRequired | SelectMfaMethodResponse;

export type RpaEndpointClassificationRow = {
  __typename: 'RpaEndpointClassificationRow';
  classification: Scalars['String']['output'];
  endpointName: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointDistributionRow = {
  __typename: 'RpaEndpointDistributionRow';
  endpointName: Scalars['String']['output'];
  p5: Scalars['Float']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
};

export type RpaEndpointDurationRow = {
  __typename: 'RpaEndpointDurationRow';
  endpointName: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointLazyDecisionRow = {
  __typename: 'RpaEndpointLazyDecisionRow';
  endpointName: Scalars['String']['output'];
  lazyDecision: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointMfaMethodsRow = {
  __typename: 'RpaEndpointMfaMethodsRow';
  endpointName: Scalars['String']['output'];
  value: Array<Array<Scalars['String']['output']>>;
};

export type RpaEndpointProviderDurationRow = {
  __typename: 'RpaEndpointProviderDurationRow';
  endpointName: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointProviderRow = {
  __typename: 'RpaEndpointProviderRow';
  endpointName: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointRow = {
  __typename: 'RpaEndpointRow';
  endpointName: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaEndpointTimeRow = {
  __typename: 'RpaEndpointTimeRow';
  endpointName: Scalars['String']['output'];
  timeWindow: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaError = {
  __typename: 'RpaError';
  cause: Scalars['String']['output'];
  signInUrl?: Maybe<Scalars['String']['output']>;
};

export type RpaFacts = {
  __typename: 'RpaFacts';
  cohortConnectionLossRate?: Maybe<Array<RpaScalarRow>>;
  cohortDaySuccessRate?: Maybe<Array<RpaDayOfWeekRateRow>>;
  cohortLinkRelinkDaySuccessRate?: Maybe<Array<RpaDayOfWeekRateRow>>;
  cohortLinkRelinkMfaMethods?: Maybe<Array<RpaMfaMethodsRow>>;
  cohortLinkRelinkMfaRate?: Maybe<Array<RpaScalarRow>>;
  cohortLinkRelinkSuccessRate?: Maybe<Array<RpaScalarRow>>;
  cohortLinkRelinkTimeSuccessRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  cohortLinkSessionCount?: Maybe<Array<RpaScalarRow>>;
  cohortMfaInterval?: Maybe<Array<RpaScalarRow>>;
  cohortMfaIntervalDistribution?: Maybe<Array<RpaDistributionRow>>;
  cohortMfaMethods?: Maybe<Array<RpaMfaMethodsRow>>;
  cohortMfaRate?: Maybe<Array<RpaScalarRow>>;
  cohortRelinkSessionCount?: Maybe<Array<RpaScalarRow>>;
  cohortSecurityChallengeRate?: Maybe<Array<RpaScalarRow>>;
  cohortSuccessRate?: Maybe<Array<RpaScalarRow>>;
  cohortSyncSessionCount?: Maybe<Array<RpaScalarRow>>;
  cohortSyncTailgateDaySuccessRate?: Maybe<Array<RpaDayOfWeekRateRow>>;
  cohortSyncTailgateMfaIntervalDistribution?: Maybe<Array<RpaDistributionRow>>;
  cohortSyncTailgateMfaRate?: Maybe<Array<RpaScalarRow>>;
  cohortSyncTailgateSecurityChallengeRate?: Maybe<Array<RpaScalarRow>>;
  cohortSyncTailgateSuccessRate?: Maybe<Array<RpaScalarRow>>;
  cohortSyncTailgateTimeMfaRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  cohortSyncTailgateTimeSuccessRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  cohortTailgateSessionCount?: Maybe<Array<RpaScalarRow>>;
  cohortTimeMfaRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  cohortTimeSuccessRate?: Maybe<Array<RpaTimeWindowRateRow>>;
  lazyDecisionMfaRate?: Maybe<Array<RpaEndpointLazyDecisionRow>>;
  lazyEligibilityRate?: Maybe<Array<RpaEndpointRow>>;
  lazyFallbackClassificationDistribution?: Maybe<Array<RpaEndpointClassificationRow>>;
  lazySkipRate?: Maybe<Array<RpaEndpointRow>>;
  linkDaySessionCount?: Maybe<Array<RpaLinkDayRow>>;
  linkDaySuccessCount?: Maybe<Array<RpaLinkDayRow>>;
  linkMfaCount?: Maybe<Array<RpaLinkRow>>;
  linkMfaInterval?: Maybe<Array<RpaLinkDurationRow>>;
  linkMfaMethods?: Maybe<Array<RpaLinkMfaMethodsRow>>;
  linkRelinkDaySessionCount?: Maybe<Array<RpaRelinkDayRow>>;
  linkRelinkDaySuccessCount?: Maybe<Array<RpaRelinkDayRow>>;
  linkRelinkMfaCount?: Maybe<Array<RpaRelinkRow>>;
  linkRelinkMfaMethods?: Maybe<Array<RpaRelinkMfaMethodsRow>>;
  linkRelinkSessionCount?: Maybe<Array<RpaRelinkRow>>;
  linkRelinkSuccessCount?: Maybe<Array<RpaRelinkRow>>;
  linkRelinkTimeSessionCount?: Maybe<Array<RpaRelinkTimeRow>>;
  linkRelinkTimeSuccessCount?: Maybe<Array<RpaRelinkTimeRow>>;
  linkSecurityChallengeCount?: Maybe<Array<RpaLinkRow>>;
  linkSecurityChallengeSessionCount?: Maybe<Array<RpaLinkRow>>;
  linkSessionCount?: Maybe<Array<RpaLinkRow>>;
  linkSuccessCount?: Maybe<Array<RpaLinkRow>>;
  linkTimeMfaCount?: Maybe<Array<RpaLinkTimeRow>>;
  linkTimeSessionCount?: Maybe<Array<RpaLinkTimeRow>>;
  linkTimeSuccessCount?: Maybe<Array<RpaLinkTimeRow>>;
  portalCredentialRejectionRate?: Maybe<Array<RpaEndpointRow>>;
  portalMfaInterval?: Maybe<Array<RpaEndpointDurationRow>>;
  portalMfaMethods?: Maybe<Array<RpaEndpointMfaMethodsRow>>;
  portalMfaRate?: Maybe<Array<RpaEndpointRow>>;
  portalProviderMfaInterval?: Maybe<Array<RpaEndpointProviderDurationRow>>;
  portalSecurityChallengeRate?: Maybe<Array<RpaEndpointRow>>;
  portalSessionTtlDistribution?: Maybe<Array<RpaEndpointDistributionRow>>;
  portalSuccessRate?: Maybe<Array<RpaEndpointRow>>;
  portalSyncReuseRate?: Maybe<Array<RpaEndpointRow>>;
  portalTimeMfaRate?: Maybe<Array<RpaEndpointTimeRow>>;
  portalTimeSuccessRate?: Maybe<Array<RpaEndpointTimeRow>>;
  providerConnectionLoss?: Maybe<Array<RpaProviderRow>>;
  providerGlobalFailureStreak?: Maybe<Array<RpaProviderRow>>;
  providerGlobalSuccess?: Maybe<Array<RpaProviderRow>>;
  providerPortalFailureStreak?: Maybe<Array<RpaEndpointProviderRow>>;
  providerPortalMfaRate?: Maybe<Array<RpaEndpointProviderRow>>;
  providerPortalSuccess?: Maybe<Array<RpaEndpointProviderRow>>;
  syncTailgateDaySessionCount?: Maybe<Array<RpaLinkDayRow>>;
  syncTailgateDaySuccessCount?: Maybe<Array<RpaLinkDayRow>>;
  syncTailgateMfaCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateMfaInterval?: Maybe<Array<RpaLinkDurationRow>>;
  syncTailgateMfaIntervalDistribution?: Maybe<Array<RpaLinkDistributionRow>>;
  syncTailgateMfaTimestamps?: Maybe<Array<RpaLinkTimestampsRow>>;
  syncTailgateSecChallengeCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateSecChallengeSessionCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateSessionCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateSuccessCount?: Maybe<Array<RpaLinkRow>>;
  syncTailgateTimeSessionCount?: Maybe<Array<RpaLinkTimeRow>>;
  syncTailgateTimeSuccessCount?: Maybe<Array<RpaLinkTimeRow>>;
};

export type RpaForecastEntry = {
  __typename: 'RpaForecastEntry';
  blockId: Scalars['String']['output'];
  dayOfWeek: Scalars['String']['output'];
  dispatchAt: Scalars['DateTime']['output'];
  linkId: Scalars['String']['output'];
  member: RpaForecastMember;
  provider: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  status: RpaForecastStatus;
  timeOfDay: Scalars['String']['output'];
};

export type RpaForecastMember = {
  __typename: 'RpaForecastMember';
  endpointId: Scalars['String']['output'];
  portalUsername: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum RpaForecastStatus {
  Committed = 'Committed',
  Projected = 'Projected'
}

export type RpaLinkDayRow = {
  __typename: 'RpaLinkDayRow';
  dayOfWeek: Scalars['String']['output'];
  linkId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaLinkDistributionRow = {
  __typename: 'RpaLinkDistributionRow';
  linkId: Scalars['String']['output'];
  p5: Scalars['Float']['output'];
  p50: Scalars['Float']['output'];
  p95: Scalars['Float']['output'];
};

export type RpaLinkDurationRow = {
  __typename: 'RpaLinkDurationRow';
  linkId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaLinkMfaMethodsRow = {
  __typename: 'RpaLinkMfaMethodsRow';
  linkId: Scalars['String']['output'];
  value: Array<Array<Scalars['String']['output']>>;
};

export type RpaLinkRow = {
  __typename: 'RpaLinkRow';
  linkId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaLinkTimeRow = {
  __typename: 'RpaLinkTimeRow';
  linkId: Scalars['String']['output'];
  timeWindow: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaLinkTimestampsRow = {
  __typename: 'RpaLinkTimestampsRow';
  linkId: Scalars['String']['output'];
  value: Array<Scalars['DateTime']['output']>;
};

export type RpaLinkView = {
  __typename: 'RpaLinkView';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  endpointId: Scalars['String']['output'];
  endpointName: Scalars['String']['output'];
  lastSessionAt?: Maybe<Scalars['DateTime']['output']>;
  linkId: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type RpaLinkViewsInput = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  linkIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type RpaMfaMethodsRow = {
  __typename: 'RpaMfaMethodsRow';
  value: Array<Array<Scalars['String']['output']>>;
};

export type RpaOperating = {
  __typename: 'RpaOperating';
  stage: Scalars['String']['output'];
};

/**
 * Statuses an investigator can set. In progress, superseded, and unclassified
 * cannot be set.
 */
export enum RpaOpsStatusOverride {
  GRANTED_FAILURE = 'GRANTED_FAILURE',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  PORTAL_BLOCK = 'PORTAL_BLOCK',
  SUCCESS = 'SUCCESS',
  SUCCESS_NO_DATA = 'SUCCESS_NO_DATA',
  USER_FAILURE = 'USER_FAILURE'
}

/**
 * Read-time graded outcome axis (D11). All variants are nullary, so the
 * discriminated OutcomeGrade fold maps to a flat enum rather than a payload union.
 * SoftBlock is provisional (failure-text heuristic).
 */
export enum RpaOutcomeGrade {
  Fail = 'Fail',
  MfaChallenged = 'MfaChallenged',
  NoChallenge = 'NoChallenge',
  SoftBlock = 'SoftBlock'
}

export type RpaProviderRow = {
  __typename: 'RpaProviderRow';
  provider: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaRelinkDayRow = {
  __typename: 'RpaRelinkDayRow';
  dayOfWeek: Scalars['String']['output'];
  endpointId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaRelinkMfaMethodsRow = {
  __typename: 'RpaRelinkMfaMethodsRow';
  endpointId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Array<Array<Scalars['String']['output']>>;
};

export type RpaRelinkRow = {
  __typename: 'RpaRelinkRow';
  endpointId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaRelinkTimeRow = {
  __typename: 'RpaRelinkTimeRow';
  endpointId: Scalars['String']['output'];
  timeWindow: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaScalarRow = {
  __typename: 'RpaScalarRow';
  value: Scalars['Float']['output'];
};

export type RpaScheduleForecastInput = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  experimentId: Scalars['String']['input'];
};

export type RpaSessionAnnotation = {
  __typename: 'RpaSessionAnnotation';
  /**
   * Evidence Room artifact ID. A reclassification event names this in its
   * `annotationId` when the investigator wrote an analysis.
   */
  annotationId: Scalars['String']['output'];
  /** The accountable investigator, whether they typed it or an agent did. */
  author: Scalars['String']['output'];
  /** The analysis itself, as the investigator wrote it. */
  markdown: Scalars['String']['output'];
  occurredAt: Scalars['String']['output'];
  /** The agent that posted on the investigator's behalf, when one did. */
  via?: Maybe<Scalars['String']['output']>;
};

export type RpaSessionDot = {
  __typename: 'RpaSessionDot';
  linkId: Scalars['String']['output'];
  origin: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['DateTime']['output'];
};

export type RpaSessionDotsInput = {
  after: Scalars['DateTime']['input'];
  before: Scalars['DateTime']['input'];
  linkIds: Array<Scalars['String']['input']>;
};

export type RpaSessionOutcomeGrade = {
  __typename: 'RpaSessionOutcomeGrade';
  grade: RpaOutcomeGrade;
  sessionId: Scalars['String']['output'];
};

export type RpaSessionOutcomeGradesInput = {
  sessionIds: Array<Scalars['String']['input']>;
};

export type RpaSessionTimeline = {
  __typename: 'RpaSessionTimeline';
  endpointName: Scalars['String']['output'];
  events: Array<RpaTimelineEvent>;
  origin: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
};

export type RpaSessionTimelineInput = {
  sessionId: Scalars['String']['input'];
};

export type RpaStatusOverrideEntry = {
  __typename: 'RpaStatusOverrideEntry';
  eventDetail: Scalars['JSON']['output'];
  eventId: Scalars['String']['output'];
  occurredAt: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  sessionId: Scalars['String']['output'];
};

export type RpaStatusResult = RpaDone | RpaOperating;

export type RpaTimeWindowRateRow = {
  __typename: 'RpaTimeWindowRateRow';
  timeWindow: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type RpaTimelineEvent = {
  __typename: 'RpaTimelineEvent';
  event: Scalars['JSON']['output'];
  occurredAt: Scalars['String']['output'];
};

export type RunAllHealthChecksInput = {
  checks: Array<StartHealthCheckInput>;
};

export type RunInsuranceDiscoveryInput = {
  /**
   * When true, record the attempt and dispatch the discovered
   * active-coverage memberships through the normal reactor. When false (the
   * default), run the vendor check and return candidates without emitting
   * anything.
   */
  apply?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Override: 10-digit requesting NPI. When omitted, an NPI is selected
   * from the platform registry, rotated by user id.
   */
  providerNpiOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: subscriber date of birth (YYYY-MM-DD) to search with. When
   * omitted, defaults to the user's stored identity.
   */
  subscriberDateOfBirthOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: subscriber first name to search with. When omitted, defaults
   * to the user's stored identity.
   */
  subscriberFirstNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * Override: subscriber last name to search with. When omitted, defaults
   * to the user's stored identity.
   */
  subscriberLastNameOverride?: InputMaybe<Scalars['String']['input']>;
  /**
   * User to run insurance discovery for. Discovery targets users who may
   * have no membership on file yet, so no membership is required.
   */
  userId: Scalars['ID']['input'];
};

export type RunnerTrace = {
  __typename: 'RunnerTrace';
  bucket: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

/** Satisfied, by the latest evidence against it. */
export type SatisfiedCaseRequirement = {
  __typename: 'SatisfiedCaseRequirement';
  askCount: Scalars['Int']['output'];
  key: Scalars['ID']['output'];
  kind: CaseRequirementKind;
  since: Scalars['DateTime']['output'];
  target: CaseRequirementTarget;
};

export type SaveFaApplicationDraftInput = {
  /**
   * Answers to merge over the draft: a per-field map of write-contract entries —
   * `{ [fieldKey]: { op: "write", value } | { op: "confirm", confirmedValue } |
   * { op: "clear" } }` — not a bare `{ fieldKey: value }` map. Values are typed per
   * field (money is integer cents, multiselect is an array, …). JSON-encoded (the
   * JSON scalar arrives as a string).
   */
  answers: Scalars['JSON']['input'];
  issueId: Scalars['ID']['input'];
};

export type SaveForecastingForecastInputsInput = {
  headcount?: InputMaybe<Array<ForecastingHeadcountWeekInput>>;
  volumes?: InputMaybe<Array<ForecastingVolumeWeekInput>>;
};

export type SaveForecastingInvestmentInput = {
  effectAmount: Scalars['Float']['input'];
  /** add | multiply | shiftPoints */
  effectKind: Scalars['String']['input'];
  effectiveDate: Scalars['String']['input'];
  enabled: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** Headcount adds phase in linearly over this many weeks (default 4). */
  rampWeeks?: InputMaybe<Scalars['Int']['input']>;
  scenarioId: Scalars['ID']['input'];
  /** e.g. weeklyHeadcount, abandonmentRate.NATERA, minutesPerCase.NATERA, minutesPerCase.ALL, weeklyLeads.NATERA */
  targetVariable: Scalars['String']['input'];
};

export type SaveForecastingScenarioInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type SaveIntakeInput = {
  /**
   * The in-progress intake draft, as `intakeDraftSchema` in `@medbillai/schemas`
   * defines it. JSON-encoded (the JSON scalar arrives as a string) and validated
   * server-side.
   */
  draft: Scalars['JSON']['input'];
};

export type SaveNotesInput = {
  notesAsHtml: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type SaveNotesResponse = FormError | SaveNotesSuccess;

export type SaveNotesSuccess = {
  __typename: 'SaveNotesSuccess';
  success: Scalars['Boolean']['output'];
};

export type ScheduleDelayedChargeInput = {
  amount: Scalars['Decimal']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  issueId?: InputMaybe<Scalars['ID']['input']>;
  latencyMinutes: Scalars['Int']['input'];
};

export type ScheduleDelayedChargeResponse = {
  __typename: 'ScheduleDelayedChargeResponse';
  workflowId: Scalars['String']['output'];
};

export type SearchPayersInput = {
  /** Only return payers that accept eligibility checks without enrollment. */
  eligibilityCheckSupportedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Most payers to return. Defaults to 25, at most 50. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Payer name or payer ID. Case-insensitive. */
  query: Scalars['String']['input'];
  /**
   * Two-letter state or territory code. Keeps payers operating there,
   * nationally, or with no recorded operating regions.
   */
  region?: InputMaybe<Scalars['String']['input']>;
};

export type SecurityQuestionRequired = {
  __typename: 'SecurityQuestionRequired';
  securityQuestions: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

/**
 * A row the case screen showed as unseen, named by the `__typename` it was read
 * with. The server marks it seen only if it still matches the case, is unseen
 * and user-visible, and was not sent by the member.
 */
export type SeenEventInput = {
  id: Scalars['ID']['input'];
  typename: Scalars['String']['input'];
};

export type SelectMfaMethodInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  selectedDisplay?: InputMaybe<Scalars['String']['input']>;
  selectedMethod?: InputMaybe<MfaMethodType>;
  selectedMethodId: Scalars['Int']['input'];
  workflowId: Scalars['String']['input'];
};

export type SelectMfaMethodResponse = {
  __typename: 'SelectMfaMethodResponse';
  idempotencyKey?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  workflowId: Scalars['String']['output'];
};

export type SelectPlanForEventInput = {
  eventId: Scalars['ID']['input'];
  planId: Scalars['ID']['input'];
};

export type SendCaseRoomMessageInput = {
  message: Scalars['String']['input'];
  preset?: InputMaybe<CaseRoomPreset>;
  /** Client-generated and unique per send. Retrying with the same value yields the same turn. */
  requestId: Scalars['ID']['input'];
  roomId: Scalars['ID']['input'];
};

export type SendCaseRoomMessageResult = {
  __typename: 'SendCaseRoomMessageResult';
  turnId: Scalars['ID']['output'];
  turnIndex: Scalars['Int']['output'];
};

export type SendDocumentToUserInput = {
  documentId: Scalars['ID']['input'];
  issueId: Scalars['ID']['input'];
};

export type SendDocumentToUserResult = {
  __typename: 'SendDocumentToUserResult';
  document: document__Document;
};

export type SendDocumentsToUserInput = {
  documentIds: Array<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
};

export type SendDocumentsToUserResult = {
  __typename: 'SendDocumentsToUserResult';
  documents: Array<document__Document>;
};

export type SendMagicLinkInput = {
  /**
   * Anonymous session ID (JWT) from a prior pre-auth session.
   * When provided, the anonymous user record is converted to a full user on login.
   */
  anonymousSessionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Ad attribution (UTM params and click ids) the sender arrived with, as a
   * JSON-encoded object of the keys `attributionSchema` in `@medbillai/schemas`
   * allows. Held against the address so a sign-up finished in another browser
   * keeps its campaign. A send without it leaves any pending attribution alone.
   */
  attribution?: InputMaybe<Scalars['JSON']['input']>;
  /** Bot control token for bot protection (e.g. reCAPTCHA, device fingerprinting). */
  botControlToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * If specified, magic links sent by Stytch will redirect to this URI.
   * In particular, this is useful for both local development and for the
   * Expo app - where we want to deeplink back into the app.
   */
  clientRedirectUri?: InputMaybe<Scalars['String']['input']>;
  /** Challenge token for PKCE flow. */
  codeChallenge?: InputMaybe<Scalars['String']['input']>;
  /**
   * Send a link that can be opened in any browser (no PKCE); any codeChallenge
   * passed is dropped. The client gates this to Meta in-app browsers by flag.
   */
  crossBrowserLink?: InputMaybe<Scalars['Boolean']['input']>;
  email: Scalars['String']['input'];
  /**
   * Admin app flag - when true, only allows existing admin users to log in.
   * Does not create new users.
   */
  forAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Partner invite token, when the sender arrived through an invite. Held
   * against the address until the next authenticate redeems it, so an invited
   * signup finished in another browser — which an OTP email link cannot carry
   * params into — still binds its partner. Every send overwrites, and a send
   * without one clears any invite already pending.
   */
  inviteToken?: InputMaybe<Scalars['String']['input']>;
  /**
   * Natera intake answers collected before the account existed. Stored against the
   * user this send creates, so the intake survives the member opening their magic
   * link in a different browser.
   */
  nateraIntake?: InputMaybe<NateraIntakePacketInput>;
  /** Source of the registration (e.g., ios, android, web). */
  sourcePlatform?: InputMaybe<Scalars['String']['input']>;
  /**
   * When true, sends an email OTP (code + code-carrying link) instead of a
   * PKCE-bound magic link.
   */
  useEmailOtp?: InputMaybe<Scalars['Boolean']['input']>;
  /** User segmentation data for the web onboarding flow. */
  userSegmentationData?: InputMaybe<UserSegmentationData>;
};

export type SendMagicLinkResponse = {
  __typename: 'SendMagicLinkResponse';
  created: Scalars['Boolean']['output'];
  user: AuthUser;
};

export type SendMagicLinkResult = FormError | SendMagicLinkResponse;

/**
 * Staff promote/demote of a case's priority. The override beats every derived
 * criterion in issue::Issue.isHighPriority, in both directions. Omit `override`
 * (or pass null) to clear it and hand the case back to derived classification —
 * which is not the same as demoting it.
 *
 * Admin-only: a member promoting their own case would put it in front of an HA.
 */
export type SetCasePriorityOverrideInput = {
  issueId: Scalars['ID']['input'];
  override?: InputMaybe<issue__PriorityOverride>;
};

/**
 * Resolve the provider a case is about. Pass providerId to link the case to a
 * directory provider (providerName is denormalized from the provider's name unless
 * overridden). Pass only providerName to record a free-text label before a
 * directory match exists (e.g. an import/OCR prefill). Pass clearProvider to unset
 * both.
 */
export type SetCaseProviderInput = {
  clearProvider?: InputMaybe<Scalars['Boolean']['input']>;
  issueId: Scalars['ID']['input'];
  providerId?: InputMaybe<Scalars['ID']['input']>;
  providerName?: InputMaybe<Scalars['String']['input']>;
};

export type SetEndpointCdpProviderInput = {
  cdpProvider: webAgent__CDPProvider;
  endpointId: Scalars['ID']['input'];
};

export type SetForecastingOverrideInput = {
  scenarioId: Scalars['ID']['input'];
  /** Omit or pass null to clear the override (one-click reset). */
  value?: InputMaybe<Scalars['Float']['input']>;
  /** e.g. abandonmentRate.NATERA, winRate.OTHER_LABS, minutesPerFullHaWeek */
  variableKey: Scalars['String']['input'];
};

export type SetProviderFormShapingInput = {
  /**
   * ProviderForm.revision as read when this layout was authored. The write is
   * rejected when the stored revision differs: an approval (which bumps it)
   * landed in between, and the layout should be re-authored against it.
   */
  expectedRevision: Scalars['Int']['input'];
  formId: Scalars['ID']['input'];
  /**
   * The authored WizardLayout annotation, JSON-encoded (the Gel JSON scalar
   * convention). Must parse against the shaping contract; unlike a stored
   * annotation (linted and ignored when malformed), a malformed input is
   * rejected — the shape screen only ever authors valid layouts.
   */
  wizardLayout: Scalars['JSON']['input'];
};

export type ShadowLoginInput = {
  /** One of email or userId. */
  email?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type SignAndSaveTemplateInput = {
  formFields: Array<FilledField>;
  formOptions: FormOptionsV2;
  patient?: InputMaybe<PersonUpsertInput>;
  signatureDocumentId: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['String']['input']>;
  subscriber?: InputMaybe<PersonUpsertInput>;
  templateEventId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type SignAndSaveTemplateResult = {
  __typename: 'SignAndSaveTemplateResult';
  success: Scalars['Boolean']['output'];
};

export type SignAndSaveTemplateSuccess = {
  __typename: 'SignAndSaveTemplateSuccess';
  success: Scalars['Boolean']['output'];
};

export type SignAndSaveTemplateValuesInput = {
  formOptions: FormOptionsV2;
  /**
   * The rendered FormSpec's typed values keyed by field key — `{ "u-fullName":
   * "Ada Lovelace", "u-dob": "12/10/1985" }`, the per-field schema's own output,
   * not the document's string projection. Dates carry the document's MM/DD/YYYY,
   * and each value's JSON type must match its field's kind. Visibility is the
   * server's call: it resolves the authoritative FormSpec and applies
   * `formOptions`, so omitting a key and sending it blank are the same
   * submission, and either is rejected when the field is required and visible.
   * Identity and subscriber answers the form gates away are derived from
   * `formOptions`; keys the resolved spec does not define are dropped. Accepted
   * as a JSON object or as the JSON-encoded string of one.
   */
  formValues: Scalars['JSON']['input'];
  patient?: InputMaybe<PersonUpsertInput>;
  signatureDocumentId: Scalars['String']['input'];
  startedAt?: InputMaybe<Scalars['String']['input']>;
  subscriber?: InputMaybe<PersonUpsertInput>;
  templateEventId?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type SignAndSaveTemplateValuesResult = SignAndSaveTemplateSuccess | TemplateSubmitValidationError;

export type SignHipaaReleaseInput = {
  dateOfBirth: Scalars['String']['input'];
  name: Scalars['String']['input'];
  signatureDocumentId: Scalars['String']['input'];
};

export type SignHipaaReleaseResult = FormError | consent__HipaaRelease_Type;

export type SimpleMoney = {
  __typename: 'SimpleMoney';
  currency: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SkipFaApplicationInput = {
  issueId: Scalars['ID']['input'];
};

export type Slugged = {
  id: Scalars['ID']['output'];
  slug?: Maybe<Scalars['String']['output']>;
};

export type StaffOpenNewIssueInput = {
  caseType?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

export type StaffTailgateAction = {
  __typename: 'StaffTailgateAction';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type StaffTailgateAnswer =
  { action: Scalars['String']['input']; chosen?: never; confirmed?: never; submitted?: never; }
  |  { action?: never; chosen: Array<Scalars['String']['input']>; confirmed?: never; submitted?: never; }
  |  { action?: never; chosen?: never; confirmed: Scalars['Boolean']['input']; submitted?: never; }
  |  { action?: never; chosen?: never; confirmed?: never; submitted: Array<StaffTailgateFieldValue>; };

/** An ask as the sign_in@1 contract states it: one form, and the actions it offers. */
export type StaffTailgateAsk = {
  __typename: 'StaffTailgateAsk';
  actions: Array<StaffTailgateAction>;
  askId: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  form: StaffTailgateForm;
  kind: Scalars['String']['output'];
  /** The portal's message when it rejected the last answer, if any. */
  portalMessage?: Maybe<Scalars['String']['output']>;
};

export type StaffTailgateBrowser = {
  __typename: 'StaffTailgateBrowser';
  sessionId: Scalars['String']['output'];
  vncUrl: Scalars['String']['output'];
};

export type StaffTailgateChoice = {
  __typename: 'StaffTailgateChoice';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type StaffTailgateChoose = {
  __typename: 'StaffTailgateChoose';
  maxChoices: Scalars['Int']['output'];
  options: Array<StaffTailgateChoice>;
};

export type StaffTailgateConfirm = {
  __typename: 'StaffTailgateConfirm';
  prompt: Scalars['String']['output'];
};

export type StaffTailgateEnding = {
  __typename: 'StaffTailgateEnding';
  outcome: StaffTailgateOutcome;
  reason: Scalars['String']['output'];
};

export type StaffTailgateField = {
  __typename: 'StaffTailgateField';
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** True for a field whose value is a secret (a code, an answer): it reaches the browser, never the record. */
  secret: Scalars['Boolean']['output'];
};

export type StaffTailgateFieldValue = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type StaffTailgateFile = {
  __typename: 'StaffTailgateFile';
  contentType: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sentToIngestion: Scalars['Boolean']['output'];
  sha256: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  takenAt: Scalars['DateTime']['output'];
};

export type StaffTailgateFillIn = {
  __typename: 'StaffTailgateFillIn';
  fields: Array<StaffTailgateField>;
};

export type StaffTailgateForm = StaffTailgateChoose | StaffTailgateConfirm | StaffTailgateFillIn;

export type StaffTailgateIdInput = {
  executionId: Scalars['String']['input'];
};

export enum StaffTailgateOutcome {
  /** The held browser was lost (the browser service restarted, or its host was replaced). Files downloaded before were kept; the device profile wasn't saved. */
  BROWSER_LOST = 'BROWSER_LOST',
  CANCELLED = 'CANCELLED',
  /** The HA pressed Done. */
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  /** The hold ran out without an extension. */
  HOLD_EXPIRED = 'HOLD_EXPIRED',
  /** The member's own sign-in took over. */
  MEMBER_SIGNED_IN = 'MEMBER_SIGNED_IN'
}

export enum StaffTailgatePhase {
  ENDED = 'ENDED',
  HELD = 'HELD',
  NEEDS_ANSWER = 'NEEDS_ANSWER',
  SIGNING_IN = 'SIGNING_IN'
}

export enum StaffTailgateRefusal {
  /** The link is missing or not active. */
  LINK_NOT_ACTIVE = 'LINK_NOT_ACTIVE',
  /** The member's own sign-in to this portal is in progress. */
  MEMBER_SIGNING_IN = 'MEMBER_SIGNING_IN',
  /** The staff-tailgate flag is off for the caller. */
  NOT_ENABLED = 'NOT_ENABLED',
  /** The portal can't be signed in to by the new sign-in. */
  PORTAL_NOT_SUPPORTED = 'PORTAL_NOT_SUPPORTED',
  /** Another tailgate on this portal is running, or still closing its browser. */
  TAILGATE_RUNNING = 'TAILGATE_RUNNING'
}

export type StaffTailgateRefused = {
  __typename: 'StaffTailgateRefused';
  message: Scalars['String']['output'];
  refusal: StaffTailgateRefusal;
};

export type StaffTailgateStarted = {
  __typename: 'StaffTailgateStarted';
  executionId: Scalars['String']['output'];
};

export type StaffTailgateStep = {
  __typename: 'StaffTailgateStep';
  at: Scalars['DateTime']['output'];
  label: Scalars['String']['output'];
};

export type StaffTailgateView = {
  __typename: 'StaffTailgateView';
  /** The open ask, while the phase is NEEDS_ANSWER. */
  ask?: Maybe<StaffTailgateAsk>;
  /** Every browser open now, with its live view. */
  browsers: Array<StaffTailgateBrowser>;
  /** How the tailgate ended, once the phase is ENDED. */
  ending?: Maybe<StaffTailgateEnding>;
  executionId: Scalars['String']['output'];
  files: Array<StaffTailgateFile>;
  /** When a held tailgate ends unless extended or finished. */
  holdUntil?: Maybe<Scalars['DateTime']['output']>;
  linkId: Scalars['String']['output'];
  memberUserId: Scalars['String']['output'];
  phase: StaffTailgatePhase;
  portalName: Scalars['String']['output'];
  steps: Array<StaffTailgateStep>;
};

export type StartBackfillInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  cacheBuster?: InputMaybe<Scalars['String']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  dataTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  docsPerWorkflow?: InputMaybe<Scalars['Int']['input']>;
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']['input']>;
  excludeJsonFiles?: InputMaybe<Scalars['Boolean']['input']>;
  maxDocsPerUser?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StartBackfillResult = {
  __typename: 'StartBackfillResult';
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

export type StartCohortEligibilityRefreshInput = {
  /**
   * When true, apply the failure-backoff gate. Defaults false — the run's
   * purpose is an un-gated re-check, and gating it would skip the very
   * memberships it targets.
   */
  applyFailureBackoff?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Concurrent per-user checks. Defaults to the scheduled-refresh
   * concurrency.
   */
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  /** When true, resolve and report the cohort size without checking anyone. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Upper bound on the resolved cohort. The run fails rather than check a
   * larger cohort, guarding against an accidental oversized list.
   */
  maxChecks?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Users to re-check. Deduplicated; the workflow checks exactly these
   * and no others.
   */
  userIds: Array<Scalars['String']['input']>;
};

export type StartEligibilityWorkflowResult = {
  __typename: 'StartEligibilityWorkflowResult';
  runId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

/**
 * Input for a bounded event-replay run.
 *
 * Scope rule: at least one of `fromTimestamp` or `aggregateIds` must be set.
 * `aggregateType` alone is not sufficient — every replay must commit to either
 * a time window or a specific set of aggregates. Requests without one of the
 * two are rejected.
 */
export type StartEventReplayInput = {
  /**
   * Specific aggregate IDs to replay (e.g., a list of userIds for UserData).
   * Required unless `fromTimestamp` is provided.
   */
  aggregateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Aggregate type to replay (e.g., "UserData"). Required — replay is always
   * bounded to a specific aggregate family.
   */
  aggregateType: Scalars['String']['input'];
  /**
   * Events per page. Defaults to 100. Each page triggers a `continueAsNew`.
   * Smaller batches reduce burst pressure on the event worker, which matters
   * for ordering when many same-aggregate events are in the stream.
   */
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Resume cursor (eventId). Set when restarting after a failure — the workflow
   * will pick up strictly after this eventId.
   */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Event type tags to include (e.g., ["PersonReceived"]). Filter applied to
   * the event's `data._tag` field. Omit to include all event types for the
   * given aggregate.
   */
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Inclusive lower bound on event timestamp. ISO 8601. Required unless
   * `aggregateIds` is provided.
   */
  fromTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inclusive upper bound on event timestamp. ISO 8601. Omit for no upper bound. */
  toTimestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type StartFaApplicationInput = {
  issueId: Scalars['ID']['input'];
};

export type StartFaFlowInput = {
  /** True when the HA preview resolved the generic baseline (no calibrated form). The send then rejects if the case has since resolved to a form, so it can't quietly file a provider form the operator never saw. */
  expectBaseline?: InputMaybe<Scalars['Boolean']['input']>;
  /** The provider form the HA preview resolved; pins the send to that exact form rather than re-resolving. */
  formId?: InputMaybe<Scalars['ID']['input']>;
  handoffMessage?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['ID']['input'];
  /** The provider the HA preview resolved; pins the send to the same provider. */
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type StartHealthCheckInput = {
  cdpProvider: webAgent__CDPProvider;
  geoLocation?: InputMaybe<GeoLocation>;
  linkId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type StartLinkCreationInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  endpointId: Scalars['String']['input'];
  freshContext?: InputMaybe<Scalars['Boolean']['input']>;
  issueId?: InputMaybe<Scalars['String']['input']>;
  proxyAssignment?: InputMaybe<ProxyAssignmentInput>;
  requestManagedMfa?: InputMaybe<Scalars['Boolean']['input']>;
  useStealthBrowser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartLinkCreationResult = {
  __typename: 'StartLinkCreationResult';
  workflowId: Scalars['String']['output'];
};

export type StartLinkRelinkInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  freshContext?: InputMaybe<Scalars['Boolean']['input']>;
  linkId: Scalars['String']['input'];
  proxyAssignment?: InputMaybe<ProxyAssignmentInput>;
  requestManagedMfa?: InputMaybe<Scalars['Boolean']['input']>;
  useStealthBrowser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartLinkSignInInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  freshContext?: InputMaybe<Scalars['Boolean']['input']>;
  linkId: Scalars['String']['input'];
  proxyAssignment?: InputMaybe<ProxyAssignmentInput>;
  useStealthBrowser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartLinkSignInResponse = {
  __typename: 'StartLinkSignInResponse';
  success: Scalars['Boolean']['output'];
};

export type StartManualIntakeInput = {
  documentId: Scalars['ID']['input'];
  issueId: Scalars['ID']['input'];
};

export type StartManualIntakeResult = {
  __typename: 'StartManualIntakeResult';
  /** Whether this explicit request created the intake's first question. */
  started: Scalars['Boolean']['output'];
};

export type StartPersonBackfillInput = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  concurrency?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  excludeInternalUsers?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StartPostEscalationQuestionInput = {
  actionType: StartablePostEscalationQuestionFlowType;
  issueId: Scalars['ID']['input'];
};

export type StartProviderFormDetectionInput = {
  formType: provider__FormType;
  providerId: Scalars['ID']['input'];
};

export type StartProviderFormDetectionResult = FormError | ProviderFormDetectionStarted;

export type StartRPADebugInput = {
  browserbaseConfig?: InputMaybe<BrowserbaseConfig>;
  cdpProvider: webAgent__CDPProvider;
  mode: RPADebugMode;
  proxyAssignment?: InputMaybe<ProxyAssignmentInput>;
  useStealthBrowser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartRPADebugResponse = {
  __typename: 'StartRPADebugResponse';
  executionId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StartRecrawlFromExecutionInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  executionId: Scalars['String']['input'];
  freshContext?: InputMaybe<Scalars['Boolean']['input']>;
  proxyAssignment?: InputMaybe<ProxyAssignmentInput>;
  useStealthBrowser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartRecrawlFromLinkInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  freshContext?: InputMaybe<Scalars['Boolean']['input']>;
  linkId: Scalars['String']['input'];
  proxyAssignment?: InputMaybe<ProxyAssignmentInput>;
  useStealthBrowser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartRecrawlResponse = {
  __typename: 'StartRecrawlResponse';
  /** Whether the recrawl was successfully started */
  success: Scalars['Boolean']['output'];
  /** The workflow ID for tracking the recrawl */
  workflowId?: Maybe<Scalars['String']['output']>;
};

export type StartStaffTailgateInput = {
  linkId: Scalars['String']['input'];
};

export type StartStaffTailgateResult = StaffTailgateRefused | StaffTailgateStarted;

export type StartTailgateInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  freshContext?: InputMaybe<Scalars['Boolean']['input']>;
  linkId: Scalars['String']['input'];
  proxyAssignment?: InputMaybe<ProxyAssignmentInput>;
  useStealthBrowser?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StartTailgateResult = {
  __typename: 'StartTailgateResult';
  sessionId: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
};

/**
 * The post-escalation actions whose questions a user can start answering.
 *
 * A subset of issue__PostEscalationActionType — most actions resolve some other
 * way. The caller names the action it is answering; the server decides which
 * questions that action asks.
 */
export enum StartablePostEscalationQuestionFlowType {
  PROVIDE_FA_ELIGIBILITY_INFO = 'PROVIDE_FA_ELIGIBILITY_INFO'
}

export type StopRPADebugInput = {
  executionId: Scalars['String']['input'];
};

/**
 * Display-only discount shape from Stripe. Charge must attach the PromotionCode —
 * do not recompute the success-fee line amount from these fields.
 */
export type StripePromoDiscountPreview = {
  __typename: 'StripePromoDiscountPreview';
  amountOffCents?: Maybe<Scalars['Int']['output']>;
  code: Scalars['String']['output'];
  percentOff?: Maybe<Scalars['Float']['output']>;
  stripePromotionCodeId: Scalars['String']['output'];
};

export type StytchImportError = {
  __typename: 'StytchImportError';
  email?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stytchId: Scalars['String']['output'];
};

export type StytchImportResult = {
  __typename: 'StytchImportResult';
  errors?: Maybe<Array<StytchImportError>>;
  importedEmails?: Maybe<Array<Scalars['String']['output']>>;
  knownEmails?: Maybe<Array<Scalars['String']['output']>>;
};

export type SubmitFaApplicationInput = {
  /**
   * Optional final answers to merge before filing: the same per-field write-contract
   * entry map as SaveFaApplicationDraft (`{ [fieldKey]: { op, … } }`), not a bare
   * `{ fieldKey: value }` map. JSON-encoded. Omit to submit the draft as-is.
   */
  answers?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * The FormSpec version the client rendered (FaApplicationView.formSpecVersion).
   * When provided, submit refuses with FaFormChangedError if the form was
   * re-pinned or recalibrated since — the user re-confirms on the current form
   * instead of filing answers against a spec they never saw. Omit BOTH expected
   * fields to skip the check (clients shipped before they existed); providing
   * one without the other is rejected as invalid input.
   */
  expectedFormSpecVersion?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The pinned form id the client rendered (FaApplicationView.providerFormId).
   * Required alongside expectedFormSpecVersion — send an explicit null when the
   * generic baseline was rendered. Providing one of the pair without the other
   * is rejected as invalid input.
   */
  expectedProviderFormId?: InputMaybe<Scalars['ID']['input']>;
  issueId: Scalars['ID']['input'];
};

export type SubmitFaApplicationResult = FaApplicationView | FaFormChangedError | FaSubmitValidationError;

export type SubmitManagedMfaApprovalInput = {
  approved: Scalars['Boolean']['input'];
  workflowId: Scalars['String']['input'];
};

export type SubmitMfaCodeInput = {
  code: Scalars['String']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['String']['input'];
};

export type SubmitSecurityAnswerInput = {
  answers: Array<Scalars['String']['input']>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['String']['input'];
};

export type Subscription = {
  __typename: 'Subscription';
  /**
   * The live view of one room.
   *
   * Fire-and-forget: a browser that is away misses what was published while it
   * was gone, and reads `caseRoomTranscript` to catch up when it returns.
   */
  caseRoomEvents: CaseRoomEvent;
  conversationEvents: ConversationSubscriptionEvent;
};


export type SubscriptioncaseRoomEventsArgs = {
  roomId: Scalars['ID']['input'];
};


export type SubscriptionconversationEventsArgs = {
  issueId: Scalars['String']['input'];
};

export type SubscriptionPrice = {
  __typename: 'SubscriptionPrice';
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  unitAmount: Scalars['Int']['output'];
};

export type SubscriptionProduct = {
  __typename: 'SubscriptionProduct';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  prices: Array<SubscriptionPrice>;
};

export enum SubscriptionStatusGql {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  INCOMPLETE = 'INCOMPLETE',
  INCOMPLETE_EXPIRED = 'INCOMPLETE_EXPIRED',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  TRIALING = 'TRIALING',
  UNPAID = 'UNPAID'
}

/**
 * The advocate's reason for sending a suggestion back. An enum, not a free string:
 * splitting the code out of `comment` was pointless if the column can still fill
 * with one-off spellings that never aggregate. The send path writes two further
 * codes (`wrote_own`, `replied_anyway`) that are server-authored and deliberately
 * absent here — no client may claim them, which keeps the two populations
 * separable.
 */
export enum SuggestionRejectReason {
  NOT_NEEDED = 'NOT_NEEDED',
  OTHER = 'OTHER',
  TOO_LONG = 'TOO_LONG',
  WRONG_FACTS = 'WRONG_FACTS',
  WRONG_TONE = 'WRONG_TONE'
}

export type SystemPreviewMessage = {
  messageId: Scalars['String']['input'];
};

/**
 * Where the task creation originated. Logged on every createIssueTask call so
 * analytics queries can attribute tasks to the surface that produced them
 * (e.g. "tasks created from a CRI recommendation step per HA per day").
 * Optional and not persisted on the Task itself today — see AUT-1015 for the
 * deliberate decision to log-only and defer schema-level provenance.
 */
export enum TaskCreationSource {
  CRI_RECOMMENDATION = 'CRI_RECOMMENDATION',
  MANUAL = 'MANUAL',
  OTHER = 'OTHER'
}

/**
 * Why an advocate sent a draft back. An enum for the same reason
 * SuggestionRejectReason is one: a free-text column fills with one-off spellings
 * that never aggregate. UNSPECIFIED exists because dismissing must stay one
 * click — the reason is asked afterwards and may be skipped.
 */
export enum TaskDraftDismissReason {
  ALREADY_DONE = 'ALREADY_DONE',
  CREATING_SOMETHING_ELSE = 'CREATING_SOMETHING_ELSE',
  NOT_USEFUL = 'NOT_USEFUL',
  UNSPECIFIED = 'UNSPECIFIED',
  WRONG_FACTS = 'WRONG_FACTS',
  WRONG_NEXT_STEP = 'WRONG_NEXT_STEP'
}

export type TemplateFieldAttributesError = {
  __typename: 'TemplateFieldAttributesError';
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type TemplateFieldAttributesInput = {
  templateId: Scalars['String']['input'];
};

export type TemplateFieldAttributesResult = TemplateFieldAttributesError | TemplateFieldAttributesSuccess;

export type TemplateFieldAttributesSuccess = {
  __typename: 'TemplateFieldAttributesSuccess';
  additionalSections: Array<AdditionalSection>;
  fields: Array<FieldAttributes>;
  success: Scalars['Boolean']['output'];
};

export type TemplateFile = {
  __typename: 'TemplateFile';
  fileBase64: Scalars['String']['output'];
};

export type TemplateFileInput = {
  templateId: Scalars['String']['input'];
};

export type TemplateFileResult = FormError | TemplateFile;

export type TemplateStorageValuesResult = {
  __typename: 'TemplateStorageValuesResult';
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  s3PutUrl: Scalars['String']['output'];
};

export type TemplateSubmitFieldError = {
  __typename: 'TemplateSubmitFieldError';
  code: TemplateSubmitFieldErrorCode;
  /** The FormSpec field key, e.g. `u-fullName`. */
  key: Scalars['String']['output'];
  /** Server hint for CLI/log consumers; clients own the copy, keyed by code. */
  message: Scalars['String']['output'];
};

/**
 * Stable machine-readable error classes: the client owns user-facing copy keyed
 * by these. Additions are non-breaking; renames and removals are.
 */
export enum TemplateSubmitFieldErrorCode {
  REQUIRED_MISSING = 'REQUIRED_MISSING',
  VALUE_NOT_CONFORMANT = 'VALUE_NOT_CONFORMANT'
}

/**
 * An invalid submission — no template release or person record was written. Every
 * offending answer is reported at once, keyed by the field key the wizard
 * rendered, so the form can route each message to its own input. A key the form
 * isn't currently showing is the client's to fold into its own form-level copy.
 */
export type TemplateSubmitValidationError = {
  __typename: 'TemplateSubmitValidationError';
  fieldErrors: Array<TemplateSubmitFieldError>;
  /**
   * Whole-submission failure, member-facing: the payload could not be read as a
   * field-keyed answer map, so no `fieldErrors` name it. Null when every failure
   * is field-keyed.
   */
  formMessage?: Maybe<Scalars['String']['output']>;
};

export enum TemplateType {
  HIPAA_RELEASE = 'HIPAA_RELEASE'
}

export type TrackInsuranceLinkAttemptInput = {
  abandonedReason?: InputMaybe<eventTracking__LinkAttemptAbandonedReason>;
  additionalData?: InputMaybe<Scalars['JSON']['input']>;
  baseEndpointId?: InputMaybe<Scalars['String']['input']>;
  baseLinkId?: InputMaybe<Scalars['String']['input']>;
  status: eventTracking__LinkAttemptStatus;
  webAgentExecutionId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Satisfied under an ask whose request has not been captured.
 *
 * The request and the satisfaction reach the projection independently and only
 * the request names a target, so a satisfaction can arrive with nothing to place
 * it against. This variant carries that fact; naming a target here would read as
 * satisfied against a party nobody asked.
 */
export type UnattestedCaseRequirement = {
  __typename: 'UnattestedCaseRequirement';
  authorizationId: Scalars['ID']['output'];
  key: Scalars['ID']['output'];
  kind: CaseRequirementKind;
  since: Scalars['DateTime']['output'];
};

export type UnreadIssuesUpdatesPrompt = BaseUpdatesPrompt & {
  __typename: 'UnreadIssuesUpdatesPrompt';
  count: Scalars['Int']['output'];
  issueIds: Array<Scalars['String']['output']>;
  type: UpdatesPromptType;
};

export type UpdateCrawlObjectiveReviewInput = {
  categorization: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  objectiveId: Scalars['ID']['input'];
};

export type UpdateCrawlReviewInput = {
  categorization: Scalars['String']['input'];
  crawlId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDefaultError = {
  __typename: 'UpdateDefaultError';
  errors: Array<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
};

export type UpdateDefaultSuccess = {
  __typename: 'UpdateDefaultSuccess';
  templateId: Scalars['String']['output'];
};

export type UpdateDefaultTemplateInput = {
  templateId: Scalars['String']['input'];
};

export type UpdateDefaultTemplateResult = UpdateDefaultError | UpdateDefaultSuccess;

export type UpdateDocumentNameInput = {
  documentId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateDocumentNameResult = {
  __typename: 'UpdateDocumentNameResult';
  document: document__Document;
};

export type UpdateEndpointSupportLevelInput = {
  endpointId: Scalars['ID']['input'];
  supportLevel: webAgent__EndpointSupportLevel;
};

export type UpdateFileNameInput = {
  fileId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateFileNameResult = {
  __typename: 'UpdateFileNameResult';
  file: document__File;
};

export type UpdateFindingInput = {
  explanation?: InputMaybe<Scalars['String']['input']>;
  findingId: Scalars['ID']['input'];
};

export type UpdateInsuranceLinkAttemptInvestigationUrlInput = {
  id: Scalars['ID']['input'];
  investigationUrl: Scalars['String']['input'];
};

export type UpdateInsuranceLinkAttemptInvestigationUrlResult = {
  __typename: 'UpdateInsuranceLinkAttemptInvestigationUrlResult';
  id: Scalars['ID']['output'];
};

export type UpdateIssueCommentEventPinnedInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commentEventId: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIssueEventInput = {
  actionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  caseIntake?: InputMaybe<Scalars['Boolean']['input']>;
  eventId: Scalars['ID']['input'];
  userVisible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateIssueInput = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  caseManagementClosureReason?: InputMaybe<Scalars['String']['input']>;
  caseManagementRelatedIssueCount?: InputMaybe<Scalars['Int']['input']>;
  caseManagementType?: InputMaybe<Scalars['String']['input']>;
  clearReengagementReason?: InputMaybe<Scalars['Boolean']['input']>;
  coverageType?: InputMaybe<Scalars['String']['input']>;
  dollarAmountSaved?: InputMaybe<Scalars['Decimal']['input']>;
  estimatedDollarAmountSaved?: InputMaybe<Scalars['Decimal']['input']>;
  followUpDate?: InputMaybe<Scalars['String']['input']>;
  issueId: Scalars['ID']['input'];
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  nextSteps?: InputMaybe<Scalars['String']['input']>;
  /**
   * Park a billing case with marketing for re-engagement. Staff-only. Omitting
   * the field (or passing null) leaves the stored value alone; the only way to
   * unset it here is clearReengagementReason, which wins if both are supplied.
   * Member activity on the case (a message, an upload, completing a requested
   * action) also clears it — schema triggers, see dbschema/issue.gel.
   */
  reengagementReason?: InputMaybe<issue__ReengagementReason>;
  /**
   * With userLastSeenNow, the unseen rows to mark seen, one update per type.
   * Clients that omit it get the older path, which marks every unseen row.
   */
  seenEvents?: InputMaybe<Array<SeenEventInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalBillDollarAmount?: InputMaybe<Scalars['Decimal']['input']>;
  userLastSeenNow?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating a navigator specialist instruction */
export type UpdateNavigatorSpecialistInstructionsInput = {
  id: Scalars['ID']['input'];
  /** The instruction content to update */
  instructions: Scalars['String']['input'];
};

/** Input for updating the isActive flag of a navigator specialist page discovery */
export type UpdateNavigatorSpecialistPageDiscoveryIsActiveInput = {
  id: Scalars['ID']['input'];
  isActive: Scalars['Boolean']['input'];
};

/** Input for updating the discovery JSON of a navigator specialist page discovery */
export type UpdateNavigatorSpecialistPageDiscoveryJsonInput = {
  discoveryJson: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdatePaymentAgreementEventInput = {
  eventId: Scalars['ID']['input'];
  userAccepted: Scalars['Boolean']['input'];
};

/**
 * maxSingleCharge is the fee-inclusive card ceiling in integer cents; null means
 * no ceiling (accept any savings). The server derives the bill-only maxSettle
 * from it, and leaves both untouched when maxSingleCharge is unchanged.
 * expectedUpdatedAt is the preferences row's updatedAt as the editor read it;
 * the save is refused with CONFLICT if the row has changed since (compared to
 * the millisecond).
 */
export type UpdatePaymentPreferencesInput = {
  autoPayAuthorized: Scalars['Boolean']['input'];
  expectedUpdatedAt: Scalars['DateTime']['input'];
  issueId: Scalars['ID']['input'];
  maxSingleCharge?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePaymentProfileInput = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
};

export type UpdatePaymentProfileResponse = {
  __typename: 'UpdatePaymentProfileResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdatePersonAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePersonInput = {
  address?: InputMaybe<PersonAddress>;
  dob?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenNames?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePromoCodeInput = {
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePromoCodeResponse = {
  __typename: 'UpdatePromoCodeResponse';
  promoCode: payment__PromoCode_Type;
};

export type UpdateProviderInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  clearPartOf?: InputMaybe<Scalars['Boolean']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  faPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<provider__ProviderKind>;
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  npi?: InputMaybe<Scalars['String']['input']>;
  partOfId?: InputMaybe<Scalars['ID']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Machine syncs only: stamps lastSyncedAt with this write so the row stays
   * machine-owned under the human-edit latch (updatedAt > lastSyncedAt means
   * human-owned). Leave unset for human edits.
   */
  stampLastSynced?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  systemName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionPaymentMethodInput = {
  paymentMethodId: Scalars['String']['input'];
};

export type UpdateSubscriptionPaymentMethodResponse = {
  __typename: 'UpdateSubscriptionPaymentMethodResponse';
  success: Scalars['Boolean']['output'];
};

export type UpdateTaskCommentInput = {
  comment: Scalars['String']['input'];
  commentId: Scalars['ID']['input'];
};

export type UpdateTaskCommentPinnedInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTaskInput = {
  additionalDetailsRequested?: InputMaybe<Scalars['String']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  formSender?: InputMaybe<Scalars['String']['input']>;
  formType?: InputMaybe<Scalars['String']['input']>;
  hasAllInformation?: InputMaybe<Scalars['Boolean']['input']>;
  minutesSpent?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  researchNotes?: InputMaybe<Scalars['String']['input']>;
  sendingMethod?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<taskManagement__TaskStatus>;
  taskId: Scalars['ID']['input'];
  /** @deprecated Use minutesSpent instead */
  timeSpent?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTemplateItem = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type UpdateTemplatesInput = {
  templates: Array<UpdateTemplateItem>;
};

export type UpdateTemplatesResult = FormError | UpdateTemplatesSuccess;

export type UpdateTemplatesSuccess = {
  __typename: 'UpdateTemplatesSuccess';
  success: Scalars['Boolean']['output'];
};

export type UpdateWebAgentEndpointInput = {
  cdpProvider?: InputMaybe<webAgent__CDPProvider>;
  dashboardUrl?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  displayUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isPasswordRequired?: InputMaybe<Scalars['Boolean']['input']>;
  loginUrl?: InputMaybe<Scalars['String']['input']>;
  managedMfaConfiguration?: InputMaybe<ManagedMfaConfigurationInput>;
  portalGuideUrl?: InputMaybe<Scalars['String']['input']>;
  supportLevel?: InputMaybe<webAgent__EndpointSupportLevel>;
};

export type UpdatesPrompt = BillsToReviewUpdatesPrompt | RefreshAccountUpdatesPrompt | UnreadIssuesUpdatesPrompt;

export enum UpdatesPromptType {
  BILLS_TO_REVIEW = 'BILLS_TO_REVIEW',
  REFRESH_ACCOUNT = 'REFRESH_ACCOUNT',
  UNREAD_ISSUES = 'UNREAD_ISSUES'
}

export type UpsertFaApplicationInput = {
  /** The complete per-field draft (FormState shape), stored verbatim. JSON-encoded. */
  formState: Scalars['JSON']['input'];
  formType?: InputMaybe<provider__FormType>;
  issueId: Scalars['ID']['input'];
  /**
   * Pin the form to fill (paired with formType). Resolves the facility's own form
   * or its parent system's; ignored without formType.
   */
  providerId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertNegotiationProfileInput = {
  discountPctMax?: InputMaybe<Scalars['Int']['input']>;
  discountPctMin?: InputMaybe<Scalars['Int']['input']>;
  hipaaTurnaroundDays?: InputMaybe<Scalars['Int']['input']>;
  insuredStance?: InputMaybe<provider__NegotiationStance>;
  offersPaymentPlans?: InputMaybe<Scalars['Boolean']['input']>;
  paymentPlanMaxMonths?: InputMaybe<Scalars['Int']['input']>;
  pricingVsMarket?: InputMaybe<Scalars['Float']['input']>;
  providerId: Scalars['ID']['input'];
};

export type UpsertProviderContactPointInput = {
  contactPointId?: InputMaybe<Scalars['ID']['input']>;
  kind: provider__ContactKind;
  notes?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['ID']['input'];
  /** Defaults to General when omitted. */
  purpose?: InputMaybe<provider__ContactPurpose>;
  /**
   * Provenance. Defaults to ha on insert and is preserved on update when
   * omitted. Passing source: cms is rejected (reserved for the CMS refresh);
   * existing cms contacts remain editable.
   */
  source?: InputMaybe<provider__Source>;
  value: Scalars['String']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpsertProviderFaPolicyInput = {
  /**
   * The fields staff author, JSON-encoded: the two FPL ceilings, the non-offering
   * assertion with its reason, and application links.
   *
   * Deliberately an edit rather than a whole policy. The server validates it,
   * merges it onto the stored record, carries provenance across untouched, and
   * stamps authorship itself — a client that could supply provenance could rewrite
   * the source, discard the preserved source columns, or forge the edit stamp that
   * decides whether the importer may overwrite this row.
   */
  edit: Scalars['JSON']['input'];
  providerId: Scalars['ID']['input'];
};

export type UpsertProviderFormInput = {
  formType: provider__FormType;
  name: Scalars['String']['input'];
  providerId: Scalars['ID']['input'];
  /**
   * The s3Key returned by prepareProviderFormUpload for the same provider and
   * form type. The object is verified server-side before the form is persisted.
   */
  s3Key: Scalars['String']['input'];
  submissionChannel?: InputMaybe<provider__SubmissionChannel>;
  /**
   * The input describes the complete desired form: omitting submitToId or
   * submissionChannel clears any previously stored value.
   */
  submitToId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertUserSegmentationDataInput = {
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  hasInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  heardAboutUsFrom?: InputMaybe<Scalars['String']['input']>;
  usageScope?: InputMaybe<Scalars['String']['input']>;
  usageScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  useCases?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type User = {
  acceptedTermsAt?: Maybe<Scalars['String']['output']>;
  acceptedTermsVersion?: Maybe<Scalars['String']['output']>;
  accounts?: Maybe<Array<fhirext__AccountVersion>>;
  anonymousConvertedAt?: Maybe<Scalars['String']['output']>;
  anonymousSessionId?: Maybe<Scalars['String']['output']>;
  attribution?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  deletionRequestedAt?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<user__Email>>;
  explanationOfBenefits?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  firstAuthenticatedAt?: Maybe<Scalars['String']['output']>;
  flexpaLinks?: Maybe<Array<flexpa__Link>>;
  hasSeenHome: Scalars['Boolean']['output'];
  hipaaRelease?: Maybe<consent__HipaaRelease>;
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<fhirext__InvoiceVersion>>;
  isAdmin: Scalars['Boolean']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  issues?: Maybe<Array<issue__Issue>>;
  lastAuthenticatedAt?: Maybe<Scalars['String']['output']>;
  lastSessionRefreshedAt?: Maybe<Scalars['String']['output']>;
  notesAsHtml?: Maybe<Scalars['String']['output']>;
  pendingAttribution?: Maybe<Scalars['JSON']['output']>;
  pendingAttributionExpiresAt?: Maybe<Scalars['String']['output']>;
  pendingInviteToken?: Maybe<Scalars['String']['output']>;
  pendingInviteTokenExpiresAt?: Maybe<Scalars['String']['output']>;
  pendingNateraIntake?: Maybe<Scalars['JSON']['output']>;
  persons?: Maybe<Array<Person>>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPerson?: Maybe<Person>;
  profile: user__Profile;
  promoCodeUsages?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  registrationSource?: Maybe<Scalars['String']['output']>;
  segmentationData?: Maybe<user__SegmentationData>;
  segments?: Maybe<Array<segment__UserSegment>>;
  source?: Maybe<partner__Partner>;
  stytchId?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<taskManagement__Task>>;
  templateReleases?: Maybe<Array<consent__TemplateRelease>>;
  userExitInsuranceLinkFeedback?: Maybe<Array<webAgent__UserExitInsuranceLinkFeedback>>;
  webAgentLinks?: Maybe<Array<webAgent__Link>>;
};


export type UseraccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterAccountVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderAccountVersion>;
};


export type UseremailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterEmail>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderEmail>;
};


export type UserexplanationOfBenefitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type UserflexpaLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type UserhipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type UserinvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type UserissuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type UserpersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type UserprimaryPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type UserprofileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type UserpromoCodeUsagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type UsersegmentationDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterSegmentationData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderSegmentationData>;
};


export type UsersegmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterUserSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderUserSegment>;
};


export type UsersourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};


export type UsertasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};


export type UsertemplateReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type UseruserExitInsuranceLinkFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterUserExitInsuranceLinkFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderUserExitInsuranceLinkFeedback>;
};


export type UserwebAgentLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type UserDocumentFile = {
  __typename: 'UserDocumentFile';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserDocumentIngestion = {
  __typename: 'UserDocumentIngestion';
  id: Scalars['ID']['output'];
  status: Scalars['String']['output'];
};

export type UserDocumentIssue = {
  __typename: 'UserDocumentIssue';
  id: Scalars['ID']['output'];
};

export type UserDocumentIssueEvent = {
  __typename: 'UserDocumentIssueEvent';
  id: Scalars['ID']['output'];
  issue: UserDocumentIssue;
};

/**
 * Document kinds readable through queryUserDocuments. Each value maps to a
 * `projection::UserDataView.kind` literal: BANK_STATEMENT → "bankStatement",
 * PAYSTUB → "paystub", W2 → "w2", FORM_1099 → "form1099", UTILITY_BILL →
 * "utilityBill", GOVERNMENT_ID → "governmentId", FINANCIAL_DOCUMENT →
 * "financialDocument" (category-level: award letters, Medicaid determinations,
 * and assistance proof all land here; `data.documentType` carries the fine type).
 */
export enum UserDocumentKind {
  BANK_STATEMENT = 'BANK_STATEMENT',
  FINANCIAL_DOCUMENT = 'FINANCIAL_DOCUMENT',
  FORM_1099 = 'FORM_1099',
  GOVERNMENT_ID = 'GOVERNMENT_ID',
  PAYSTUB = 'PAYSTUB',
  UTILITY_BILL = 'UTILITY_BILL',
  W2 = 'W2'
}

/**
 * A single ingestion-v2 record (EOB, invoice, or FA/proof-of-* document)
 * sourced directly from `projection::UserDataView`, with its enrichment
 * overlay stitched in where one exists (EOBs and invoices only). The `data`
 * blob conforms to the `@medbillai/schemas` v2 schema for its kind; clients
 * parse it with those schemas.
 */
export type UserHealthRecord = {
  __typename: 'UserHealthRecord';
  /** The v2.EOB / v2.Invoice blob, verbatim from UserDataView.data. */
  data: Scalars['JSON']['output'];
  /**
   * Stitched UserEnrichmentData overlay (enrichments fields plus title and
   * overallPriceRating), or null when the enrichment pipeline has not produced
   * a row for this record yet.
   */
  enrichment?: Maybe<Scalars['JSON']['output']>;
  /** Materialization key (projection::UserDataView.key), the row identity. */
  key: Scalars['ID']['output'];
  /**
   * Record kind: "claim" for an EOB, "invoice" for an invoice, or a document
   * kind (bankStatement/paystub/w2/form1099/utilityBill/governmentId). Matches
   * the underlying UserDataView.kind verbatim.
   */
  kind: Scalars['String']['output'];
  /** When the projection row was last materialized. */
  updatedAt: Scalars['DateTime']['output'];
};

export type UserPreviewMessage = {
  documentId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};

export type UserSegmentAssignment = {
  assignedBy: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  segmentKey: Scalars['String']['input'];
  source: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserSegmentationData = {
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  usageScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  useCases?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserUploadedDocumentsInput = {
  userId: Scalars['ID']['input'];
};

export type UserUploadedDocumentsResult = {
  __typename: 'UserUploadedDocumentsResult';
  createdAt: Scalars['DateTime']['output'];
  dataType?: Maybe<Scalars['String']['output']>;
  files: Array<UserDocumentFile>;
  id: Scalars['ID']['output'];
  issueEvent: Array<UserDocumentIssueEvent>;
  latestIngestion?: Maybe<UserDocumentIngestion>;
  name: Scalars['String']['output'];
};

export type User_Type = BaseObject & Object & User & {
  __typename: 'User_Type';
  acceptedTermsAt?: Maybe<Scalars['String']['output']>;
  acceptedTermsVersion?: Maybe<Scalars['String']['output']>;
  accounts?: Maybe<Array<fhirext__AccountVersion>>;
  anonymousConvertedAt?: Maybe<Scalars['String']['output']>;
  anonymousSessionId?: Maybe<Scalars['String']['output']>;
  attribution?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  deletionRequestedAt?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<user__Email>>;
  explanationOfBenefits?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  firstAuthenticatedAt?: Maybe<Scalars['String']['output']>;
  flexpaLinks?: Maybe<Array<flexpa__Link>>;
  hasSeenHome: Scalars['Boolean']['output'];
  hipaaRelease?: Maybe<consent__HipaaRelease>;
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<fhirext__InvoiceVersion>>;
  isAdmin: Scalars['Boolean']['output'];
  isAnonymous: Scalars['Boolean']['output'];
  issues?: Maybe<Array<issue__Issue>>;
  lastAuthenticatedAt?: Maybe<Scalars['String']['output']>;
  lastSessionRefreshedAt?: Maybe<Scalars['String']['output']>;
  notesAsHtml?: Maybe<Scalars['String']['output']>;
  pendingAttribution?: Maybe<Scalars['JSON']['output']>;
  pendingAttributionExpiresAt?: Maybe<Scalars['String']['output']>;
  pendingInviteToken?: Maybe<Scalars['String']['output']>;
  pendingInviteTokenExpiresAt?: Maybe<Scalars['String']['output']>;
  pendingNateraIntake?: Maybe<Scalars['JSON']['output']>;
  persons?: Maybe<Array<Person>>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPerson?: Maybe<Person>;
  profile: user__Profile;
  promoCodeUsages?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  registrationSource?: Maybe<Scalars['String']['output']>;
  segmentationData?: Maybe<user__SegmentationData>;
  segments?: Maybe<Array<segment__UserSegment>>;
  source?: Maybe<partner__Partner>;
  stytchId?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<taskManagement__Task>>;
  templateReleases?: Maybe<Array<consent__TemplateRelease>>;
  userExitInsuranceLinkFeedback?: Maybe<Array<webAgent__UserExitInsuranceLinkFeedback>>;
  webAgentLinks?: Maybe<Array<webAgent__Link>>;
};


export type User_TypeaccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterAccountVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderAccountVersion>;
};


export type User_TypeemailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterEmail>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderEmail>;
};


export type User_TypeexplanationOfBenefitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type User_TypeflexpaLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type User_TypehipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type User_TypeinvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type User_TypeissuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type User_TypepersonsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type User_TypeprimaryPersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type User_TypeprofileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type User_TypepromoCodeUsagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type User_TypesegmentationDataArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterSegmentationData>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderSegmentationData>;
};


export type User_TypesegmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterUserSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderUserSegment>;
};


export type User_TypesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};


export type User_TypetasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};


export type User_TypetemplateReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type User_TypeuserExitInsuranceLinkFeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterUserExitInsuranceLinkFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderUserExitInsuranceLinkFeedback>;
};


export type User_TypewebAgentLinksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type ValidateTemplateError = {
  __typename: 'ValidateTemplateError';
  errors: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type ValidateTemplateInput = {
  s3Bucket: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
};

export type ValidateTemplateResult = ValidateTemplateError | ValidateTemplateSuccess;

export type ValidateTemplateSuccess = {
  __typename: 'ValidateTemplateSuccess';
  valid: Scalars['Boolean']['output'];
};

export type ValidateTemplateValuesInput = {
  formOptions: FormOptionsV2;
  formValues: Scalars['JSON']['input'];
  patient?: InputMaybe<PersonUpsertInput>;
  templateId: Scalars['String']['input'];
};

export type Verifiable = {
  id: Scalars['ID']['output'];
  lastVerified?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type VerifiableverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type VerifyNegotiationProfileInput = {
  providerId: Scalars['ID']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VerifyProviderInput = {
  id: Scalars['ID']['input'];
  verified?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ViewDocumentFileInput = {
  fileId: Scalars['ID']['input'];
};

export type ViewDocumentFileResult = {
  __typename: 'ViewDocumentFileResult';
  fileId: Scalars['ID']['output'];
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
};

export type ViewDocumentInput = {
  documentId: Scalars['ID']['input'];
};

export type ViewDocumentResult = {
  __typename: 'ViewDocumentResult';
  documentId: Scalars['ID']['output'];
  documentUrl: Scalars['String']['output'];
};

/**
 * What the document pipeline is working on: the reason on a WAIT_STARTED /
 * WAIT_ENDED pair, and the hold named by `waitingOnKind` on TURN_COMPLETED. A
 * turn holds only for DOCUMENT_READ or EXTRACTION.
 */
export enum WaitReason {
  ANALYSIS = 'ANALYSIS',
  DOCUMENT_READ = 'DOCUMENT_READ',
  EXTRACTION = 'EXTRACTION'
}

export type WebAgentExecutionResult = {
  __typename: 'WebAgentExecutionResult';
  artifacts: Array<ExecutionResultArtifact>;
  cdpProvider?: Maybe<webAgent__CDPProvider>;
  createdAt: Scalars['DateTime']['output'];
  documents: Array<ExecutionResultDocument>;
  endpoint?: Maybe<EndpointSlug>;
  id: Scalars['ID']['output'];
  lastUserMfaMethods: Array<webAgent__MfaMethod>;
  latestDiscoveryCrawl: Array<LatestDiscoveryCrawl>;
  latestIngestion?: Maybe<LatestIngestion>;
  type?: Maybe<webAgent__WebExecutionType>;
};

export type WelcomePrompt = {
  __typename: 'WelcomePrompt';
  completed: Scalars['Boolean']['output'];
  type: WelcomePromptType;
};

export enum WelcomePromptType {
  CONNECT_INSURANCE = 'CONNECT_INSURANCE',
  OPEN_CASE = 'OPEN_CASE'
}

export type asyncJob__FilterJob = {
  and?: InputMaybe<Array<asyncJob__FilterJob>>;
  costUsd?: InputMaybe<FilterFloat>;
  createdAt?: InputMaybe<FilterString>;
  deliveredAt?: InputMaybe<FilterString>;
  durationMs?: InputMaybe<FilterInt>;
  error?: InputMaybe<FilterString>;
  finishedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  input?: InputMaybe<FilterJSON>;
  isOpen?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  kind?: InputMaybe<FilterString>;
  model?: InputMaybe<FilterString>;
  not?: InputMaybe<asyncJob__FilterJob>;
  or?: InputMaybe<Array<asyncJob__FilterJob>>;
  parentJob?: InputMaybe<asyncJob__NestedFilterJob>;
  report?: InputMaybe<FilterString>;
  requestKey?: InputMaybe<FilterString>;
  result?: InputMaybe<FilterJSON>;
  reviewTask?: InputMaybe<taskManagement__NestedFilterIssueTask>;
  skillVersion?: InputMaybe<FilterString>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterasyncJob__JobStatus>;
  turns?: InputMaybe<FilterInt>;
  workflowId?: InputMaybe<FilterString>;
};

export type asyncJob__Job = {
  costUsd?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  deliveredAt?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  input: Scalars['JSON']['output'];
  isOpen: Scalars['Boolean']['output'];
  issue: issue__Issue;
  kind: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  parentJob?: Maybe<asyncJob__Job>;
  report?: Maybe<Scalars['String']['output']>;
  requestKey?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  reviewTask?: Maybe<taskManagement__IssueTask>;
  skillVersion?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: asyncJob__JobStatus;
  turns?: Maybe<Scalars['Int']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};


export type asyncJob__JobissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type asyncJob__JobparentJobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<asyncJob__FilterJob>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<asyncJob__OrderJob>;
};


export type asyncJob__JobreviewTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};

export enum asyncJob__JobStatus {
  Cancelled = 'Cancelled',
  Done = 'Done',
  Failed = 'Failed',
  NeedsInput = 'NeedsInput',
  Queued = 'Queued',
  Running = 'Running'
}

export type asyncJob__Job_Type = BaseObject & Object & asyncJob__Job & {
  __typename: 'asyncJob__Job_Type';
  costUsd?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['String']['output'];
  deliveredAt?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  input: Scalars['JSON']['output'];
  isOpen: Scalars['Boolean']['output'];
  issue: issue__Issue;
  kind: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  parentJob?: Maybe<asyncJob__Job>;
  report?: Maybe<Scalars['String']['output']>;
  requestKey?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  reviewTask?: Maybe<taskManagement__IssueTask>;
  skillVersion?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: asyncJob__JobStatus;
  turns?: Maybe<Scalars['Int']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};


export type asyncJob__Job_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type asyncJob__Job_TypeparentJobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<asyncJob__FilterJob>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<asyncJob__OrderJob>;
};


export type asyncJob__Job_TypereviewTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};

export type asyncJob__NestedFilterJob = {
  costUsd?: InputMaybe<FilterFloat>;
  createdAt?: InputMaybe<FilterString>;
  deliveredAt?: InputMaybe<FilterString>;
  durationMs?: InputMaybe<FilterInt>;
  error?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  finishedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  input?: InputMaybe<FilterJSON>;
  isOpen?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  kind?: InputMaybe<FilterString>;
  model?: InputMaybe<FilterString>;
  parentJob?: InputMaybe<asyncJob__NestedFilterJob>;
  report?: InputMaybe<FilterString>;
  requestKey?: InputMaybe<FilterString>;
  result?: InputMaybe<FilterJSON>;
  reviewTask?: InputMaybe<taskManagement__NestedFilterIssueTask>;
  skillVersion?: InputMaybe<FilterString>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterasyncJob__JobStatus>;
  turns?: InputMaybe<FilterInt>;
  workflowId?: InputMaybe<FilterString>;
};

export type asyncJob__OrderJob = {
  costUsd?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  deliveredAt?: InputMaybe<Ordering>;
  durationMs?: InputMaybe<Ordering>;
  error?: InputMaybe<Ordering>;
  finishedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  input?: InputMaybe<Ordering>;
  isOpen?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  kind?: InputMaybe<Ordering>;
  model?: InputMaybe<Ordering>;
  parentJob?: InputMaybe<asyncJob__OrderJob>;
  report?: InputMaybe<Ordering>;
  requestKey?: InputMaybe<Ordering>;
  result?: InputMaybe<Ordering>;
  reviewTask?: InputMaybe<taskManagement__OrderIssueTask>;
  skillVersion?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  turns?: InputMaybe<Ordering>;
  workflowId?: InputMaybe<Ordering>;
};

export type cache__FilterSerifFairMarketValue = {
  and?: InputMaybe<Array<cache__FilterSerifFairMarketValue>>;
  fetchedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<cache__FilterSerifFairMarketValue>;
  or?: InputMaybe<Array<cache__FilterSerifFairMarketValue>>;
  response?: InputMaybe<FilterJSON>;
};

export type cache__OrderSerifFairMarketValue = {
  fetchedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  response?: InputMaybe<Ordering>;
};

/** Cache for Serif Health API fair market value responses */
export type cache__SerifFairMarketValue = {
  fetchedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  response: Scalars['JSON']['output'];
};

/** Cache for Serif Health API fair market value responses */
export type cache__SerifFairMarketValue_Type = BaseObject & Object & cache__SerifFairMarketValue & {
  __typename: 'cache__SerifFairMarketValue_Type';
  fetchedAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  response: Scalars['JSON']['output'];
};

export type caseFact__CaseFact = {
  entityKey: Scalars['String']['output'];
  factType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  source: caseFact__FactSource;
  sourceId?: Maybe<Scalars['String']['output']>;
  status: caseFact__FactStatus;
  updatedAt: Scalars['String']['output'];
  valueJson: Scalars['JSON']['output'];
};


export type caseFact__CaseFactissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type caseFact__CaseFactAudit = {
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  entityKey: Scalars['String']['output'];
  factType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  proposedStatus: caseFact__FactStatus;
  proposedValueJson: Scalars['JSON']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  source: caseFact__FactSource;
  sourceId?: Maybe<Scalars['String']['output']>;
};


export type caseFact__CaseFactAuditissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type caseFact__CaseFactAudit_Type = BaseObject & Object & caseFact__CaseFactAudit & {
  __typename: 'caseFact__CaseFactAudit_Type';
  accepted: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  entityKey: Scalars['String']['output'];
  factType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  proposedStatus: caseFact__FactStatus;
  proposedValueJson: Scalars['JSON']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  source: caseFact__FactSource;
  sourceId?: Maybe<Scalars['String']['output']>;
};


export type caseFact__CaseFactAudit_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type caseFact__CaseFact_Type = BaseObject & Object & caseFact__CaseFact & {
  __typename: 'caseFact__CaseFact_Type';
  entityKey: Scalars['String']['output'];
  factType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  source: caseFact__FactSource;
  sourceId?: Maybe<Scalars['String']['output']>;
  status: caseFact__FactStatus;
  updatedAt: Scalars['String']['output'];
  valueJson: Scalars['JSON']['output'];
};


export type caseFact__CaseFact_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export enum caseFact__FactSource {
  DOCUMENT_OCR = 'DOCUMENT_OCR',
  INSURANCE_LINK = 'INSURANCE_LINK',
  LLM_INFERENCE = 'LLM_INFERENCE',
  MULTI_SELECT = 'MULTI_SELECT',
  STAFF_ENTRY = 'STAFF_ENTRY',
  USER_CHAT = 'USER_CHAT'
}

export enum caseFact__FactStatus {
  CONFIRMED = 'CONFIRMED',
  UNCERTAIN = 'UNCERTAIN',
  UNOBTAINABLE = 'UNOBTAINABLE'
}

export type caseFact__FilterCaseFact = {
  and?: InputMaybe<Array<caseFact__FilterCaseFact>>;
  entityKey?: InputMaybe<FilterString>;
  factType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<caseFact__FilterCaseFact>;
  or?: InputMaybe<Array<caseFact__FilterCaseFact>>;
  source?: InputMaybe<FiltercaseFact__FactSource>;
  sourceId?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltercaseFact__FactStatus>;
  updatedAt?: InputMaybe<FilterString>;
  valueJson?: InputMaybe<FilterJSON>;
};

export type caseFact__FilterCaseFactAudit = {
  accepted?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<caseFact__FilterCaseFactAudit>>;
  createdAt?: InputMaybe<FilterString>;
  entityKey?: InputMaybe<FilterString>;
  factType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<caseFact__FilterCaseFactAudit>;
  or?: InputMaybe<Array<caseFact__FilterCaseFactAudit>>;
  proposedStatus?: InputMaybe<FiltercaseFact__FactStatus>;
  proposedValueJson?: InputMaybe<FilterJSON>;
  rejectionReason?: InputMaybe<FilterString>;
  source?: InputMaybe<FiltercaseFact__FactSource>;
  sourceId?: InputMaybe<FilterString>;
};

export type caseFact__OrderCaseFact = {
  entityKey?: InputMaybe<Ordering>;
  factType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  source?: InputMaybe<Ordering>;
  sourceId?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  valueJson?: InputMaybe<Ordering>;
};

export type caseFact__OrderCaseFactAudit = {
  accepted?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  entityKey?: InputMaybe<Ordering>;
  factType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  proposedStatus?: InputMaybe<Ordering>;
  proposedValueJson?: InputMaybe<Ordering>;
  rejectionReason?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
  sourceId?: InputMaybe<Ordering>;
};

export type caseRoom__FilterRoom = {
  and?: InputMaybe<Array<caseRoom__FilterRoom>>;
  closeReason?: InputMaybe<FilterString>;
  closedAt?: InputMaybe<FilterString>;
  costUsd?: InputMaybe<FilterFloat>;
  engine?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  imageDigest?: InputMaybe<FilterString>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  lastActiveAt?: InputMaybe<FilterString>;
  model?: InputMaybe<FilterString>;
  not?: InputMaybe<caseRoom__FilterRoom>;
  openedAt?: InputMaybe<FilterString>;
  openedBy?: InputMaybe<NestedFilterUser>;
  or?: InputMaybe<Array<caseRoom__FilterRoom>>;
  s3Prefix?: InputMaybe<FilterString>;
  sdkSessionId?: InputMaybe<FilterString>;
  snapshotAt?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltercaseRoom__RoomStatus>;
  turnCount?: InputMaybe<FilterInt>;
};

export type caseRoom__FilterTurn = {
  and?: InputMaybe<Array<caseRoom__FilterTurn>>;
  artifacts?: InputMaybe<FilterInt>;
  blockedCalls?: InputMaybe<FilterInt>;
  cacheReadTokens?: InputMaybe<FilterInt>;
  costUsd?: InputMaybe<FilterFloat>;
  errorCode?: InputMaybe<FilterString>;
  finishedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  index?: InputMaybe<FilterInt>;
  inputTokens?: InputMaybe<FilterInt>;
  invocationClaimedAt?: InputMaybe<FilterString>;
  isRunning?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<caseRoom__FilterTurn>;
  or?: InputMaybe<Array<caseRoom__FilterTurn>>;
  outputTokens?: InputMaybe<FilterInt>;
  preset?: InputMaybe<FilterString>;
  proposals?: InputMaybe<FilterInt>;
  requestId?: InputMaybe<FilterString>;
  room?: InputMaybe<caseRoom__NestedFilterRoom>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltercaseRoom__TurnStatus>;
  toolCalls?: InputMaybe<FilterInt>;
  webRequests?: InputMaybe<FilterInt>;
};

export type caseRoom__NestedFilterRoom = {
  closeReason?: InputMaybe<FilterString>;
  closedAt?: InputMaybe<FilterString>;
  costUsd?: InputMaybe<FilterFloat>;
  engine?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  imageDigest?: InputMaybe<FilterString>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  lastActiveAt?: InputMaybe<FilterString>;
  model?: InputMaybe<FilterString>;
  openedAt?: InputMaybe<FilterString>;
  openedBy?: InputMaybe<NestedFilterUser>;
  s3Prefix?: InputMaybe<FilterString>;
  sdkSessionId?: InputMaybe<FilterString>;
  snapshotAt?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltercaseRoom__RoomStatus>;
  turnCount?: InputMaybe<FilterInt>;
};

export type caseRoom__OrderRoom = {
  closeReason?: InputMaybe<Ordering>;
  closedAt?: InputMaybe<Ordering>;
  costUsd?: InputMaybe<Ordering>;
  engine?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  imageDigest?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  lastActiveAt?: InputMaybe<Ordering>;
  model?: InputMaybe<Ordering>;
  openedAt?: InputMaybe<Ordering>;
  openedBy?: InputMaybe<OrderUser>;
  s3Prefix?: InputMaybe<Ordering>;
  sdkSessionId?: InputMaybe<Ordering>;
  snapshotAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  turnCount?: InputMaybe<Ordering>;
};

export type caseRoom__OrderTurn = {
  artifacts?: InputMaybe<Ordering>;
  blockedCalls?: InputMaybe<Ordering>;
  cacheReadTokens?: InputMaybe<Ordering>;
  costUsd?: InputMaybe<Ordering>;
  errorCode?: InputMaybe<Ordering>;
  finishedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  index?: InputMaybe<Ordering>;
  inputTokens?: InputMaybe<Ordering>;
  invocationClaimedAt?: InputMaybe<Ordering>;
  isRunning?: InputMaybe<Ordering>;
  outputTokens?: InputMaybe<Ordering>;
  preset?: InputMaybe<Ordering>;
  proposals?: InputMaybe<Ordering>;
  requestId?: InputMaybe<Ordering>;
  room?: InputMaybe<caseRoom__OrderRoom>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  toolCalls?: InputMaybe<Ordering>;
  webRequests?: InputMaybe<Ordering>;
};

export type caseRoom__Room = {
  closeReason?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  costUsd: Scalars['Float']['output'];
  engine?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageDigest?: Maybe<Scalars['String']['output']>;
  issue: issue__Issue;
  lastActiveAt?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['String']['output'];
  openedBy: User;
  s3Prefix: Scalars['String']['output'];
  sdkSessionId?: Maybe<Scalars['String']['output']>;
  snapshotAt: Scalars['String']['output'];
  status: caseRoom__RoomStatus;
  turnCount: Scalars['Int']['output'];
};


export type caseRoom__RoomissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type caseRoom__RoomopenedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum caseRoom__RoomStatus {
  Closed = 'Closed',
  Open = 'Open'
}

export type caseRoom__Room_Type = BaseObject & Object & caseRoom__Room & {
  __typename: 'caseRoom__Room_Type';
  closeReason?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  costUsd: Scalars['Float']['output'];
  engine?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageDigest?: Maybe<Scalars['String']['output']>;
  issue: issue__Issue;
  lastActiveAt?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['String']['output'];
  openedBy: User;
  s3Prefix: Scalars['String']['output'];
  sdkSessionId?: Maybe<Scalars['String']['output']>;
  snapshotAt: Scalars['String']['output'];
  status: caseRoom__RoomStatus;
  turnCount: Scalars['Int']['output'];
};


export type caseRoom__Room_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type caseRoom__Room_TypeopenedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type caseRoom__Turn = {
  artifacts?: Maybe<Scalars['Int']['output']>;
  blockedCalls?: Maybe<Scalars['Int']['output']>;
  cacheReadTokens?: Maybe<Scalars['Int']['output']>;
  costUsd?: Maybe<Scalars['Float']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  invocationClaimedAt?: Maybe<Scalars['String']['output']>;
  isRunning: Scalars['Boolean']['output'];
  outputTokens?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Scalars['Int']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  room: caseRoom__Room;
  startedAt: Scalars['String']['output'];
  status: caseRoom__TurnStatus;
  toolCalls?: Maybe<Scalars['Int']['output']>;
  webRequests?: Maybe<Scalars['Int']['output']>;
};


export type caseRoom__TurnroomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<caseRoom__FilterRoom>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<caseRoom__OrderRoom>;
};

export enum caseRoom__TurnStatus {
  BudgetExceeded = 'BudgetExceeded',
  Completed = 'Completed',
  Failed = 'Failed',
  Running = 'Running',
  Stopped = 'Stopped',
  TimedOut = 'TimedOut'
}

export type caseRoom__Turn_Type = BaseObject & Object & caseRoom__Turn & {
  __typename: 'caseRoom__Turn_Type';
  artifacts?: Maybe<Scalars['Int']['output']>;
  blockedCalls?: Maybe<Scalars['Int']['output']>;
  cacheReadTokens?: Maybe<Scalars['Int']['output']>;
  costUsd?: Maybe<Scalars['Float']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  invocationClaimedAt?: Maybe<Scalars['String']['output']>;
  isRunning: Scalars['Boolean']['output'];
  outputTokens?: Maybe<Scalars['Int']['output']>;
  preset?: Maybe<Scalars['String']['output']>;
  proposals?: Maybe<Scalars['Int']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
  room: caseRoom__Room;
  startedAt: Scalars['String']['output'];
  status: caseRoom__TurnStatus;
  toolCalls?: Maybe<Scalars['Int']['output']>;
  webRequests?: Maybe<Scalars['Int']['output']>;
};


export type caseRoom__Turn_TyperoomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<caseRoom__FilterRoom>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<caseRoom__OrderRoom>;
};

/** Current Procedural Terminology (CPT) codes are used to describe medical, surgical, and diagnostic services. These are maintained by the American Medical Association (AMA). */
export type coding__CPT = {
  code: Scalars['String']['output'];
  conceptId: Scalars['Int']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  mediumText?: Maybe<Scalars['String']['output']>;
  shortText?: Maybe<Scalars['String']['output']>;
  spanishText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** CPT Modifiers are used to provide additional information about a procedure or service. */
export type coding__CPTModifier = {
  code: Scalars['String']['output'];
  conceptId: Scalars['Int']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['String']['output']>;
  longText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** CPT Modifiers are used to provide additional information about a procedure or service. */
export type coding__CPTModifier_Type = BaseObject & Object & coding__CPTModifier & coding__Coding & {
  __typename: 'coding__CPTModifier_Type';
  code: Scalars['String']['output'];
  conceptId: Scalars['Int']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  level?: Maybe<Scalars['String']['output']>;
  longText?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** Current Procedural Terminology (CPT) codes are used to describe medical, surgical, and diagnostic services. These are maintained by the American Medical Association (AMA). */
export type coding__CPT_Type = BaseObject & Object & coding__CPT & coding__Coding & {
  __typename: 'coding__CPT_Type';
  code: Scalars['String']['output'];
  conceptId: Scalars['Int']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  mediumText?: Maybe<Scalars['String']['output']>;
  shortText?: Maybe<Scalars['String']['output']>;
  spanishText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** Abstract representation of a code and its description for a given coding taxonomy. Examples include CPT, ICD-10, HCPCS, etc. */
export type coding__Coding = {
  code: Scalars['String']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

export type coding__FilterCPT = {
  and?: InputMaybe<Array<coding__FilterCPT>>;
  code?: InputMaybe<FilterString>;
  conceptId?: InputMaybe<FilterInt>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  longText?: InputMaybe<FilterString>;
  mediumText?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterCPT>;
  or?: InputMaybe<Array<coding__FilterCPT>>;
  shortText?: InputMaybe<FilterString>;
  spanishText?: InputMaybe<FilterString>;
};

export type coding__FilterCPTModifier = {
  and?: InputMaybe<Array<coding__FilterCPTModifier>>;
  code?: InputMaybe<FilterString>;
  conceptId?: InputMaybe<FilterInt>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  level?: InputMaybe<FilterString>;
  longText?: InputMaybe<FilterString>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterCPTModifier>;
  or?: InputMaybe<Array<coding__FilterCPTModifier>>;
};

export type coding__FilterCoding = {
  and?: InputMaybe<Array<coding__FilterCoding>>;
  code?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  longText?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterCoding>;
  or?: InputMaybe<Array<coding__FilterCoding>>;
};

export type coding__FilterHCPCS = {
  and?: InputMaybe<Array<coding__FilterHCPCS>>;
  code?: InputMaybe<FilterString>;
  coverageCode?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  longText?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterHCPCS>;
  or?: InputMaybe<Array<coding__FilterHCPCS>>;
};

export type coding__FilterHCPCSModifier = {
  and?: InputMaybe<Array<coding__FilterHCPCSModifier>>;
  code?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  longText?: InputMaybe<FilterString>;
  not?: InputMaybe<coding__FilterHCPCSModifier>;
  or?: InputMaybe<Array<coding__FilterHCPCSModifier>>;
};

/** Healthcare Common Procedure Coding System (HCPCS) codes are used to identify items, services, and procedures. Level II codes are maintained by CMS. */
export type coding__HCPCS = {
  code: Scalars['String']['output'];
  coverageCode?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** HCPCS Modifiers are used to provide additional information about a procedure or service. */
export type coding__HCPCSModifier = {
  code: Scalars['String']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** HCPCS Modifiers are used to provide additional information about a procedure or service. */
export type coding__HCPCSModifier_Type = BaseObject & Object & coding__Coding & coding__HCPCSModifier & {
  __typename: 'coding__HCPCSModifier_Type';
  code: Scalars['String']['output'];
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

/** Healthcare Common Procedure Coding System (HCPCS) codes are used to identify items, services, and procedures. Level II codes are maintained by CMS. */
export type coding__HCPCS_Type = BaseObject & Object & coding__Coding & coding__HCPCS & {
  __typename: 'coding__HCPCS_Type';
  code: Scalars['String']['output'];
  coverageCode?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  longText?: Maybe<Scalars['String']['output']>;
  validity?: Maybe<Scalars['JSON']['output']>;
};

export type coding__OrderCPT = {
  code?: InputMaybe<Ordering>;
  conceptId?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
  mediumText?: InputMaybe<Ordering>;
  shortText?: InputMaybe<Ordering>;
  spanishText?: InputMaybe<Ordering>;
};

export type coding__OrderCPTModifier = {
  code?: InputMaybe<Ordering>;
  conceptId?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  level?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
};

export type coding__OrderCoding = {
  code?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
};

export type coding__OrderHCPCS = {
  code?: InputMaybe<Ordering>;
  coverageCode?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
};

export type coding__OrderHCPCSModifier = {
  code?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  longText?: InputMaybe<Ordering>;
};

export type consent__Consent = {
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  user: User;
};


export type consent__ConsentpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__ConsentuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum consent__ConsentType {
  HIPAA_RELEASE = 'HIPAA_RELEASE',
  TEMPLATE_RELEASE = 'TEMPLATE_RELEASE'
}

export type consent__FilterConsent = {
  and?: InputMaybe<Array<consent__FilterConsent>>;
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<consent__FilterConsent>;
  or?: InputMaybe<Array<consent__FilterConsent>>;
  person?: InputMaybe<NestedFilterPerson>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__FilterHipaaRelease = {
  and?: InputMaybe<Array<consent__FilterHipaaRelease>>;
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  dateOfBirth?: InputMaybe<FilterString>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<consent__FilterHipaaRelease>;
  or?: InputMaybe<Array<consent__FilterHipaaRelease>>;
  person?: InputMaybe<NestedFilterPerson>;
  signatureDocument?: InputMaybe<document__NestedFilterDocument>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__FilterTemplateRelease = {
  and?: InputMaybe<Array<consent__FilterTemplateRelease>>;
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentValues?: InputMaybe<FilterJSON>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<consent__FilterTemplateRelease>;
  or?: InputMaybe<Array<consent__FilterTemplateRelease>>;
  person?: InputMaybe<NestedFilterPerson>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__HipaaRelease = {
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Person>;
  signatureDocument?: Maybe<document__Document>;
  user: User;
};


export type consent__HipaaReleasepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__HipaaReleasesignatureDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type consent__HipaaReleaseuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type consent__HipaaRelease_Type = BaseObject & Object & Personal & consent__Consent & consent__HipaaRelease & {
  __typename: 'consent__HipaaRelease_Type';
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  person?: Maybe<Person>;
  signatureDocument?: Maybe<document__Document>;
  user: User;
};


export type consent__HipaaRelease_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__HipaaRelease_TypesignatureDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type consent__HipaaRelease_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type consent__NestedFilterHipaaRelease = {
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  dateOfBirth?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  person?: InputMaybe<NestedFilterPerson>;
  signatureDocument?: InputMaybe<document__NestedFilterDocument>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__NestedFilterTemplateRelease = {
  archivedAt?: InputMaybe<FilterString>;
  consentType?: InputMaybe<Filterconsent__ConsentType>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentValues?: InputMaybe<FilterJSON>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<FilterString>;
  grantedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  person?: InputMaybe<NestedFilterPerson>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  user?: InputMaybe<NestedFilterUser>;
};

export type consent__OrderConsent = {
  archivedAt?: InputMaybe<Ordering>;
  consentType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  expirationDate?: InputMaybe<Ordering>;
  grantedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  user?: InputMaybe<OrderUser>;
};

export type consent__OrderHipaaRelease = {
  archivedAt?: InputMaybe<Ordering>;
  consentType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dateOfBirth?: InputMaybe<Ordering>;
  expirationDate?: InputMaybe<Ordering>;
  grantedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  signatureDocument?: InputMaybe<document__OrderDocument>;
  user?: InputMaybe<OrderUser>;
};

export type consent__OrderTemplateRelease = {
  archivedAt?: InputMaybe<Ordering>;
  consentType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  documentValues?: InputMaybe<Ordering>;
  expirationDate?: InputMaybe<Ordering>;
  grantedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  template?: InputMaybe<document__OrderTemplate>;
  user?: InputMaybe<OrderUser>;
};

export type consent__TemplateRelease = {
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  document: document__Document;
  documentValues?: Maybe<Scalars['JSON']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  template: document__Template;
  user: User;
};


export type consent__TemplateReleasedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type consent__TemplateReleasepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__TemplateReleasetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};


export type consent__TemplateReleaseuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type consent__TemplateRelease_Type = BaseObject & Object & Personal & consent__Consent & consent__TemplateRelease & {
  __typename: 'consent__TemplateRelease_Type';
  archivedAt?: Maybe<Scalars['String']['output']>;
  consentType: consent__ConsentType;
  createdAt: Scalars['String']['output'];
  document: document__Document;
  documentValues?: Maybe<Scalars['JSON']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  grantedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  template: document__Template;
  user: User;
};


export type consent__TemplateRelease_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type consent__TemplateRelease_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type consent__TemplateRelease_TypetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};


export type consent__TemplateRelease_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Enum value used to specify ordering direction. */
export enum directionEnum {
  ASC = 'ASC',
  DESC = 'DESC'
}

export type document__Document = {
  createdAt: Scalars['String']['output'];
  dataType?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<document__File>>;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  internalIssueEvent?: Maybe<Array<issue__InternalDocumentUploadedEvent>>;
  issueDocumentSummary?: Maybe<issue__IssueDocumentSummary>;
  issueEvent?: Maybe<Array<issue__DocumentUploadedEvent>>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  name: Scalars['String']['output'];
  owner: User;
  pageEnd?: Maybe<Scalars['Int']['output']>;
  pageStart?: Maybe<Scalars['Int']['output']>;
  participant: Participant;
  person?: Maybe<Person>;
  resources?: Maybe<Array<fhirext__ResourceVersion>>;
  sides?: Maybe<Array<Scalars['String']['output']>>;
  source?: Maybe<webAgent__WebAgentExecution>;
  sourceCrawlObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: Maybe<flexpa__FlexpaImport>;
  splitChildren?: Maybe<Array<document__Document>>;
  splitFrom?: Maybe<document__Document>;
  splitIndex?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<document__DocumentSummary>;
  template?: Maybe<document__Template>;
  uploadEntryPoint?: Maybe<document__UploadEntryPoint>;
  uploadMethod?: Maybe<document__UploadMethod>;
  uploadPlatform?: Maybe<document__UploadPlatform>;
  uploadPurpose?: Maybe<Scalars['String']['output']>;
  uploadSessionId?: Maybe<Scalars['String']['output']>;
  userVisible: Scalars['Boolean']['output'];
  vellumDocumentId?: Maybe<Scalars['String']['output']>;
};


export type document__DocumentfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterFile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderFile>;
};


export type document__DocumentingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type document__DocumentinternalIssueEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterInternalDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderInternalDocumentUploadedEvent>;
};


export type document__DocumentissueDocumentSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssueDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssueDocumentSummary>;
};


export type document__DocumentissueEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};


export type document__DocumentlatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type document__DocumentownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type document__DocumentpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type document__DocumentresourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type document__DocumentsourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type document__DocumentsourceCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type document__DocumentsourceFlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type document__DocumentsplitChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type document__DocumentsplitFromArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type document__DocumentsummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocumentSummary>;
};


export type document__DocumenttemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type document__DocumentSummary = {
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  documentDetails?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type document__DocumentSummarydocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type document__DocumentSummary_Type = BaseObject & Object & document__DocumentSummary & {
  __typename: 'document__DocumentSummary_Type';
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  documentDetails?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type document__DocumentSummary_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type document__Document_Type = BaseObject & Object & Owned & Personal & document__Document & {
  __typename: 'document__Document_Type';
  createdAt: Scalars['String']['output'];
  dataType?: Maybe<Scalars['String']['output']>;
  files?: Maybe<Array<document__File>>;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  internalIssueEvent?: Maybe<Array<issue__InternalDocumentUploadedEvent>>;
  issueDocumentSummary?: Maybe<issue__IssueDocumentSummary>;
  issueEvent?: Maybe<Array<issue__DocumentUploadedEvent>>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  name: Scalars['String']['output'];
  owner: User;
  pageEnd?: Maybe<Scalars['Int']['output']>;
  pageStart?: Maybe<Scalars['Int']['output']>;
  participant: Participant;
  person?: Maybe<Person>;
  resources?: Maybe<Array<fhirext__ResourceVersion>>;
  sides?: Maybe<Array<Scalars['String']['output']>>;
  source?: Maybe<webAgent__WebAgentExecution>;
  sourceCrawlObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: Maybe<flexpa__FlexpaImport>;
  splitChildren?: Maybe<Array<document__Document>>;
  splitFrom?: Maybe<document__Document>;
  splitIndex?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<document__DocumentSummary>;
  template?: Maybe<document__Template>;
  uploadEntryPoint?: Maybe<document__UploadEntryPoint>;
  uploadMethod?: Maybe<document__UploadMethod>;
  uploadPlatform?: Maybe<document__UploadPlatform>;
  uploadPurpose?: Maybe<Scalars['String']['output']>;
  uploadSessionId?: Maybe<Scalars['String']['output']>;
  userVisible: Scalars['Boolean']['output'];
  vellumDocumentId?: Maybe<Scalars['String']['output']>;
};


export type document__Document_TypefilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterFile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderFile>;
};


export type document__Document_TypeingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type document__Document_TypeinternalIssueEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterInternalDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderInternalDocumentUploadedEvent>;
};


export type document__Document_TypeissueDocumentSummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssueDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssueDocumentSummary>;
};


export type document__Document_TypeissueEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};


export type document__Document_TypelatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type document__Document_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type document__Document_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type document__Document_TyperesourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type document__Document_TypesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type document__Document_TypesourceCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type document__Document_TypesourceFlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type document__Document_TypesplitChildrenArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type document__Document_TypesplitFromArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type document__Document_TypesummaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocumentSummary>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocumentSummary>;
};


export type document__Document_TypetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type document__File = {
  contentHash?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  document: document__Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3ETag?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  sizeBytes?: Maybe<Scalars['Int64']['output']>;
  uploaded: Scalars['Boolean']['output'];
  uploadedAt?: Maybe<Scalars['String']['output']>;
};


export type document__FiledocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type document__File_Type = BaseObject & Object & document__File & {
  __typename: 'document__File_Type';
  contentHash?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  document: document__Document;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  s3Bucket: Scalars['String']['output'];
  s3ETag?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  sizeBytes?: Maybe<Scalars['Int64']['output']>;
  uploaded: Scalars['Boolean']['output'];
  uploadedAt?: Maybe<Scalars['String']['output']>;
};


export type document__File_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type document__FilterDocument = {
  and?: InputMaybe<Array<document__FilterDocument>>;
  createdAt?: InputMaybe<FilterString>;
  dataType?: InputMaybe<FilterString>;
  files?: InputMaybe<document__NestedFilterFile>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  internalIssueEvent?: InputMaybe<issue__NestedFilterInternalDocumentUploadedEvent>;
  issueDocumentSummary?: InputMaybe<issue__NestedFilterIssueDocumentSummary>;
  issueEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterDocument>;
  or?: InputMaybe<Array<document__FilterDocument>>;
  owner?: InputMaybe<NestedFilterUser>;
  pageEnd?: InputMaybe<FilterInt>;
  pageStart?: InputMaybe<FilterInt>;
  participant?: InputMaybe<FilterParticipant>;
  person?: InputMaybe<NestedFilterPerson>;
  resources?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  sides?: InputMaybe<FilterString>;
  source?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  sourceCrawlObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  splitChildren?: InputMaybe<document__NestedFilterDocument>;
  splitFrom?: InputMaybe<document__NestedFilterDocument>;
  splitIndex?: InputMaybe<FilterInt>;
  summary?: InputMaybe<document__NestedFilterDocumentSummary>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  uploadEntryPoint?: InputMaybe<Filterdocument__UploadEntryPoint>;
  uploadMethod?: InputMaybe<Filterdocument__UploadMethod>;
  uploadPlatform?: InputMaybe<Filterdocument__UploadPlatform>;
  uploadPurpose?: InputMaybe<FilterString>;
  uploadSessionId?: InputMaybe<FilterString>;
  userVisible?: InputMaybe<FilterBoolean>;
  vellumDocumentId?: InputMaybe<FilterString>;
};

export type document__FilterDocumentSummary = {
  and?: InputMaybe<Array<document__FilterDocumentSummary>>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentDetails?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  modelId?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterDocumentSummary>;
  or?: InputMaybe<Array<document__FilterDocumentSummary>>;
  summary?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type document__FilterFile = {
  and?: InputMaybe<Array<document__FilterFile>>;
  contentHash?: InputMaybe<FilterString>;
  contentType?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterFile>;
  or?: InputMaybe<Array<document__FilterFile>>;
  s3Bucket?: InputMaybe<FilterString>;
  s3ETag?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  sizeBytes?: InputMaybe<FilterInt64>;
  uploaded?: InputMaybe<FilterBoolean>;
  uploadedAt?: InputMaybe<FilterString>;
};

export type document__FilterParseResult = {
  and?: InputMaybe<Array<document__FilterParseResult>>;
  contentHash?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  id?: InputMaybe<FilterID>;
  markdownContent?: InputMaybe<FilterString>;
  markdownKey?: InputMaybe<FilterString>;
  model?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterParseResult>;
  or?: InputMaybe<Array<document__FilterParseResult>>;
  owner?: InputMaybe<NestedFilterUser>;
  updatedAt?: InputMaybe<FilterString>;
};

export type document__FilterTemplate = {
  and?: InputMaybe<Array<document__FilterTemplate>>;
  archived?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  default?: InputMaybe<FilterBoolean>;
  defaultValidFor?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  fields?: InputMaybe<document__NestedFilterTemplateField>;
  formSpec?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<document__FilterTemplate>;
  or?: InputMaybe<Array<document__FilterTemplate>>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  templateCounterpartyType?: InputMaybe<Filterdocument__TemplateCounterpartyType>;
  templateType?: InputMaybe<Filterdocument__TemplateType>;
};

export type document__FilterTemplateField = {
  and?: InputMaybe<Array<document__FilterTemplateField>>;
  id?: InputMaybe<FilterID>;
  label?: InputMaybe<FilterString>;
  nameId?: InputMaybe<FilterString>;
  not?: InputMaybe<document__FilterTemplateField>;
  or?: InputMaybe<Array<document__FilterTemplateField>>;
  required?: InputMaybe<FilterBoolean>;
  template?: InputMaybe<document__NestedFilterTemplate>;
};

export type document__NestedFilterDocument = {
  createdAt?: InputMaybe<FilterString>;
  dataType?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<document__NestedFilterFile>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  internalIssueEvent?: InputMaybe<issue__NestedFilterInternalDocumentUploadedEvent>;
  issueDocumentSummary?: InputMaybe<issue__NestedFilterIssueDocumentSummary>;
  issueEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  name?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  pageEnd?: InputMaybe<FilterInt>;
  pageStart?: InputMaybe<FilterInt>;
  participant?: InputMaybe<FilterParticipant>;
  person?: InputMaybe<NestedFilterPerson>;
  resources?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  sides?: InputMaybe<FilterString>;
  source?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  sourceCrawlObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  splitChildren?: InputMaybe<document__NestedFilterDocument>;
  splitFrom?: InputMaybe<document__NestedFilterDocument>;
  splitIndex?: InputMaybe<FilterInt>;
  summary?: InputMaybe<document__NestedFilterDocumentSummary>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  uploadEntryPoint?: InputMaybe<Filterdocument__UploadEntryPoint>;
  uploadMethod?: InputMaybe<Filterdocument__UploadMethod>;
  uploadPlatform?: InputMaybe<Filterdocument__UploadPlatform>;
  uploadPurpose?: InputMaybe<FilterString>;
  uploadSessionId?: InputMaybe<FilterString>;
  userVisible?: InputMaybe<FilterBoolean>;
  vellumDocumentId?: InputMaybe<FilterString>;
};

export type document__NestedFilterDocumentSummary = {
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentDetails?: InputMaybe<FilterJSON>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  modelId?: InputMaybe<FilterString>;
  summary?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type document__NestedFilterFile = {
  contentHash?: InputMaybe<FilterString>;
  contentType?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  s3Bucket?: InputMaybe<FilterString>;
  s3ETag?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  sizeBytes?: InputMaybe<FilterInt64>;
  uploaded?: InputMaybe<FilterBoolean>;
  uploadedAt?: InputMaybe<FilterString>;
};

export type document__NestedFilterTemplate = {
  archived?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  default?: InputMaybe<FilterBoolean>;
  defaultValidFor?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<document__NestedFilterTemplateField>;
  formSpec?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  templateCounterpartyType?: InputMaybe<Filterdocument__TemplateCounterpartyType>;
  templateType?: InputMaybe<Filterdocument__TemplateType>;
};

export type document__NestedFilterTemplateField = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  label?: InputMaybe<FilterString>;
  nameId?: InputMaybe<FilterString>;
  required?: InputMaybe<FilterBoolean>;
  template?: InputMaybe<document__NestedFilterTemplate>;
};

export type document__OrderDocument = {
  createdAt?: InputMaybe<Ordering>;
  dataType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issueDocumentSummary?: InputMaybe<issue__OrderIssueDocumentSummary>;
  latestIngestion?: InputMaybe<ingestion__OrderIngestion>;
  name?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  pageEnd?: InputMaybe<Ordering>;
  pageStart?: InputMaybe<Ordering>;
  participant?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  source?: InputMaybe<webAgent__OrderWebAgentExecution>;
  sourceCrawlObjective?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
  sourceFlexpaImport?: InputMaybe<flexpa__OrderFlexpaImport>;
  splitFrom?: InputMaybe<document__OrderDocument>;
  splitIndex?: InputMaybe<Ordering>;
  summary?: InputMaybe<document__OrderDocumentSummary>;
  template?: InputMaybe<document__OrderTemplate>;
  uploadEntryPoint?: InputMaybe<Ordering>;
  uploadMethod?: InputMaybe<Ordering>;
  uploadPlatform?: InputMaybe<Ordering>;
  uploadPurpose?: InputMaybe<Ordering>;
  uploadSessionId?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
  vellumDocumentId?: InputMaybe<Ordering>;
};

export type document__OrderDocumentSummary = {
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  documentDetails?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  modelId?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type document__OrderFile = {
  contentHash?: InputMaybe<Ordering>;
  contentType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  s3Bucket?: InputMaybe<Ordering>;
  s3ETag?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
  sizeBytes?: InputMaybe<Ordering>;
  uploaded?: InputMaybe<Ordering>;
  uploadedAt?: InputMaybe<Ordering>;
};

export type document__OrderParseResult = {
  contentHash?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  id?: InputMaybe<Ordering>;
  markdownContent?: InputMaybe<Ordering>;
  markdownKey?: InputMaybe<Ordering>;
  model?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  updatedAt?: InputMaybe<Ordering>;
};

export type document__OrderTemplate = {
  archived?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  default?: InputMaybe<Ordering>;
  defaultValidFor?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  displayName?: InputMaybe<Ordering>;
  formSpec?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  organization?: InputMaybe<integration__OrderOrganization>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
  templateCounterpartyType?: InputMaybe<Ordering>;
  templateType?: InputMaybe<Ordering>;
};

export type document__OrderTemplateField = {
  id?: InputMaybe<Ordering>;
  label?: InputMaybe<Ordering>;
  nameId?: InputMaybe<Ordering>;
  required?: InputMaybe<Ordering>;
  template?: InputMaybe<document__OrderTemplate>;
};

export type document__ParseResult = {
  contentHash?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  id: Scalars['ID']['output'];
  markdownContent?: Maybe<Scalars['String']['output']>;
  markdownKey?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  owner: User;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type document__ParseResultdocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type document__ParseResultownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type document__ParseResult_Type = BaseObject & Object & document__ParseResult & {
  __typename: 'document__ParseResult_Type';
  contentHash?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  id: Scalars['ID']['output'];
  markdownContent?: Maybe<Scalars['String']['output']>;
  markdownKey?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  owner: User;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type document__ParseResult_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type document__ParseResult_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type document__Template = {
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  default: Scalars['Boolean']['output'];
  defaultValidFor?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  fields?: Maybe<Array<document__TemplateField>>;
  formSpec?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<integration__Organization>;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  templateCounterpartyType?: Maybe<document__TemplateCounterpartyType>;
  templateType: document__TemplateType;
};


export type document__TemplatecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type document__TemplatefieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplateField>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplateField>;
};


export type document__TemplateorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export enum document__TemplateCounterpartyType {
  INSURER = 'INSURER',
  PROVIDER = 'PROVIDER'
}

export type document__TemplateField = {
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  nameId: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  template: document__Template;
};


export type document__TemplateFieldtemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type document__TemplateField_Type = BaseObject & Object & document__TemplateField & {
  __typename: 'document__TemplateField_Type';
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  nameId: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  template: document__Template;
};


export type document__TemplateField_TypetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export enum document__TemplateType {
  HIPAA_RELEASE = 'HIPAA_RELEASE'
}

export type document__Template_Type = BaseObject & Object & document__Template & {
  __typename: 'document__Template_Type';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  default: Scalars['Boolean']['output'];
  defaultValidFor?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  fields?: Maybe<Array<document__TemplateField>>;
  formSpec?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<integration__Organization>;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  templateCounterpartyType?: Maybe<document__TemplateCounterpartyType>;
  templateType: document__TemplateType;
};


export type document__Template_TypecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type document__Template_TypefieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplateField>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplateField>;
};


export type document__Template_TypeorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export enum document__UploadEntryPoint {
  CASE_CHAT = 'CASE_CHAT',
  FA_WIZARD = 'FA_WIZARD',
  HOME = 'HOME',
  OTHER = 'OTHER',
  POST_ESCALATION = 'POST_ESCALATION'
}

export enum document__UploadMethod {
  FILE = 'FILE',
  GALLERY = 'GALLERY',
  SCANNER = 'SCANNER',
  WEB_PREAUTH = 'WEB_PREAUTH'
}

export enum document__UploadPlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WEB_DESKTOP = 'WEB_DESKTOP',
  WEB_MOBILE = 'WEB_MOBILE'
}

export type eventStore__Event = {
  aggregateId: Scalars['String']['output'];
  aggregateType: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  sequence: Scalars['Int64']['output'];
  timestamp: Scalars['String']['output'];
  version: Scalars['Int64']['output'];
};

export type eventStore__Event_Type = BaseObject & Object & eventStore__Event & {
  __typename: 'eventStore__Event_Type';
  aggregateId: Scalars['String']['output'];
  aggregateType: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  sequence: Scalars['Int64']['output'];
  timestamp: Scalars['String']['output'];
  version: Scalars['Int64']['output'];
};

export type eventStore__FilterEvent = {
  aggregateId?: InputMaybe<FilterString>;
  aggregateType?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<eventStore__FilterEvent>>;
  data?: InputMaybe<FilterJSON>;
  eventId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  metadata?: InputMaybe<FilterJSON>;
  not?: InputMaybe<eventStore__FilterEvent>;
  or?: InputMaybe<Array<eventStore__FilterEvent>>;
  sequence?: InputMaybe<FilterInt64>;
  timestamp?: InputMaybe<FilterString>;
  version?: InputMaybe<FilterInt64>;
};

export type eventStore__OrderEvent = {
  aggregateId?: InputMaybe<Ordering>;
  aggregateType?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  eventId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  metadata?: InputMaybe<Ordering>;
  sequence?: InputMaybe<Ordering>;
  timestamp?: InputMaybe<Ordering>;
  version?: InputMaybe<Ordering>;
};

export type eventTracking__BaseEvent = {
  additionalData?: Maybe<Scalars['JSON']['output']>;
  createdAt: Scalars['String']['output'];
  eventType: eventTracking__EventType;
  id: Scalars['ID']['output'];
  owner: User;
};


export type eventTracking__BaseEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum eventTracking__EventType {
  INSURANCE_LINK_ATTEMPT = 'INSURANCE_LINK_ATTEMPT'
}

export type eventTracking__FilterBaseEvent = {
  additionalData?: InputMaybe<FilterJSON>;
  and?: InputMaybe<Array<eventTracking__FilterBaseEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FiltereventTracking__EventType>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<eventTracking__FilterBaseEvent>;
  or?: InputMaybe<Array<eventTracking__FilterBaseEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type eventTracking__FilterInsuranceLinkAttempt = {
  abandonedReason?: InputMaybe<FiltereventTracking__LinkAttemptAbandonedReason>;
  additionalData?: InputMaybe<FilterJSON>;
  and?: InputMaybe<Array<eventTracking__FilterInsuranceLinkAttempt>>;
  baseEndpoint?: InputMaybe<integration__NestedFilterBaseEndpoint>;
  baseLink?: InputMaybe<integration__NestedFilterBaseLink>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FiltereventTracking__EventType>;
  id?: InputMaybe<FilterID>;
  investigationUrl?: InputMaybe<FilterString>;
  not?: InputMaybe<eventTracking__FilterInsuranceLinkAttempt>;
  or?: InputMaybe<Array<eventTracking__FilterInsuranceLinkAttempt>>;
  owner?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<FiltereventTracking__LinkAttemptStatus>;
  webAgentExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
};

export type eventTracking__InsuranceLinkAttempt = {
  abandonedReason?: Maybe<eventTracking__LinkAttemptAbandonedReason>;
  additionalData?: Maybe<Scalars['JSON']['output']>;
  baseEndpoint?: Maybe<integration__BaseEndpoint>;
  baseLink?: Maybe<integration__BaseLink>;
  createdAt: Scalars['String']['output'];
  eventType: eventTracking__EventType;
  id: Scalars['ID']['output'];
  investigationUrl?: Maybe<Scalars['String']['output']>;
  owner: User;
  status: eventTracking__LinkAttemptStatus;
  webAgentExecution?: Maybe<webAgent__WebAgentExecution>;
};


export type eventTracking__InsuranceLinkAttemptbaseEndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type eventTracking__InsuranceLinkAttemptbaseLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseLink>;
};


export type eventTracking__InsuranceLinkAttemptownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type eventTracking__InsuranceLinkAttemptwebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type eventTracking__InsuranceLinkAttempt_Type = BaseObject & Object & Owned & eventTracking__BaseEvent & eventTracking__InsuranceLinkAttempt & {
  __typename: 'eventTracking__InsuranceLinkAttempt_Type';
  abandonedReason?: Maybe<eventTracking__LinkAttemptAbandonedReason>;
  additionalData?: Maybe<Scalars['JSON']['output']>;
  baseEndpoint?: Maybe<integration__BaseEndpoint>;
  baseLink?: Maybe<integration__BaseLink>;
  createdAt: Scalars['String']['output'];
  eventType: eventTracking__EventType;
  id: Scalars['ID']['output'];
  investigationUrl?: Maybe<Scalars['String']['output']>;
  owner: User;
  status: eventTracking__LinkAttemptStatus;
  webAgentExecution?: Maybe<webAgent__WebAgentExecution>;
};


export type eventTracking__InsuranceLinkAttempt_TypebaseEndpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type eventTracking__InsuranceLinkAttempt_TypebaseLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseLink>;
};


export type eventTracking__InsuranceLinkAttempt_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type eventTracking__InsuranceLinkAttempt_TypewebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export enum eventTracking__LinkAttemptAbandonedReason {
  ABANDONED_CREDENTIALS = 'ABANDONED_CREDENTIALS',
  ABANDONED_MFA = 'ABANDONED_MFA',
  ABANDONED_RELINK = 'ABANDONED_RELINK',
  FLEXPA_EMPLOYER_PLAN = 'FLEXPA_EMPLOYER_PLAN',
  INSURANCE_NOT_FOUND = 'INSURANCE_NOT_FOUND'
}

export enum eventTracking__LinkAttemptStatus {
  ABANDONED = 'ABANDONED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED'
}

export type eventTracking__OrderBaseEvent = {
  additionalData?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type eventTracking__OrderInsuranceLinkAttempt = {
  abandonedReason?: InputMaybe<Ordering>;
  additionalData?: InputMaybe<Ordering>;
  baseEndpoint?: InputMaybe<integration__OrderBaseEndpoint>;
  baseLink?: InputMaybe<integration__OrderBaseLink>;
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  investigationUrl?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
  webAgentExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type fa__Application = {
  applicationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  owner: User;
  providerForm?: Maybe<provider__ProviderForm>;
  signedAt?: Maybe<Scalars['String']['output']>;
  status: fa__ApplicationStatus;
  updatedAt: Scalars['String']['output'];
};


export type fa__ApplicationissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type fa__ApplicationownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fa__ApplicationproviderFormArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProviderForm>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProviderForm>;
};

export enum fa__ApplicationStatus {
  Approved = 'Approved',
  AtHospital = 'AtHospital',
  Closed = 'Closed',
  Denied = 'Denied',
  Draft = 'Draft',
  Partial = 'Partial',
  Submitted = 'Submitted'
}

export type fa__Application_Type = BaseObject & Object & fa__Application & {
  __typename: 'fa__Application_Type';
  applicationId: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  owner: User;
  providerForm?: Maybe<provider__ProviderForm>;
  signedAt?: Maybe<Scalars['String']['output']>;
  status: fa__ApplicationStatus;
  updatedAt: Scalars['String']['output'];
};


export type fa__Application_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type fa__Application_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fa__Application_TypeproviderFormArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProviderForm>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProviderForm>;
};

export type fa__FilterApplication = {
  and?: InputMaybe<Array<fa__FilterApplication>>;
  applicationId?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<fa__FilterApplication>;
  or?: InputMaybe<Array<fa__FilterApplication>>;
  owner?: InputMaybe<NestedFilterUser>;
  providerForm?: InputMaybe<provider__NestedFilterProviderForm>;
  signedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterfa__ApplicationStatus>;
  updatedAt?: InputMaybe<FilterString>;
};

export type fa__NestedFilterApplication = {
  applicationId?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  owner?: InputMaybe<NestedFilterUser>;
  providerForm?: InputMaybe<provider__NestedFilterProviderForm>;
  signedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterfa__ApplicationStatus>;
  updatedAt?: InputMaybe<FilterString>;
};

export type fa__OrderApplication = {
  applicationId?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  owner?: InputMaybe<OrderUser>;
  providerForm?: InputMaybe<provider__OrderProviderForm>;
  signedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export enum feedback__AreaType {
  GENERAL = 'GENERAL',
  ISSUE = 'ISSUE',
  ISSUE_EVENT = 'ISSUE_EVENT'
}

export type feedback__FilterGeneralFeedback = {
  and?: InputMaybe<Array<feedback__FilterGeneralFeedback>>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<feedback__FilterGeneralFeedback>;
  or?: InputMaybe<Array<feedback__FilterGeneralFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__FilterIssueEventFeedback = {
  and?: InputMaybe<Array<feedback__FilterIssueEventFeedback>>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  event?: InputMaybe<issue__NestedFilterEvent>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<feedback__FilterIssueEventFeedback>;
  or?: InputMaybe<Array<feedback__FilterIssueEventFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__FilterIssueFeedback = {
  and?: InputMaybe<Array<feedback__FilterIssueFeedback>>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  closedEvent?: InputMaybe<issue__NestedFilterClosedEvent>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<feedback__FilterIssueFeedback>;
  or?: InputMaybe<Array<feedback__FilterIssueFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__FilterOption = {
  and?: InputMaybe<Array<feedback__FilterOption>>;
  archived?: InputMaybe<FilterBoolean>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<feedback__FilterOption>;
  or?: InputMaybe<Array<feedback__FilterOption>>;
  order?: InputMaybe<FilterInt>;
  sentiment?: InputMaybe<Filterfeedback__SentimentType>;
  value?: InputMaybe<FilterString>;
};

export type feedback__FilterStaffFeedback = {
  and?: InputMaybe<Array<feedback__FilterStaffFeedback>>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<feedback__FilterStaffFeedback>;
  or?: InputMaybe<Array<feedback__FilterStaffFeedback>>;
  review?: InputMaybe<FilterString>;
  sentiment?: InputMaybe<Filterfeedback__SentimentType>;
};

export type feedback__FilterUserFeedback = {
  and?: InputMaybe<Array<feedback__FilterUserFeedback>>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<feedback__FilterUserFeedback>;
  or?: InputMaybe<Array<feedback__FilterUserFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__GeneralFeedback = {
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__GeneralFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__GeneralFeedbackselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__GeneralFeedback_Type = BaseObject & Object & Owned & feedback__GeneralFeedback & feedback__UserFeedback & {
  __typename: 'feedback__GeneralFeedback_Type';
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__GeneralFeedback_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__GeneralFeedback_TypeselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__IssueEventFeedback = {
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  event: issue__Event;
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__IssueEventFeedbackeventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type feedback__IssueEventFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__IssueEventFeedbackselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__IssueEventFeedback_Type = BaseObject & Object & Owned & feedback__IssueEventFeedback & feedback__UserFeedback & {
  __typename: 'feedback__IssueEventFeedback_Type';
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  event: issue__Event;
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__IssueEventFeedback_TypeeventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type feedback__IssueEventFeedback_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__IssueEventFeedback_TypeselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__IssueFeedback = {
  area: feedback__AreaType;
  closedEvent: issue__ClosedEvent;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__IssueFeedbackclosedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterClosedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderClosedEvent>;
};


export type feedback__IssueFeedbackissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type feedback__IssueFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__IssueFeedbackselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__IssueFeedback_Type = BaseObject & Object & Owned & feedback__IssueFeedback & feedback__UserFeedback & {
  __typename: 'feedback__IssueFeedback_Type';
  area: feedback__AreaType;
  closedEvent: issue__ClosedEvent;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__IssueFeedback_TypeclosedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterClosedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderClosedEvent>;
};


export type feedback__IssueFeedback_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type feedback__IssueFeedback_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__IssueFeedback_TypeselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type feedback__NestedFilterIssueEventFeedback = {
  area?: InputMaybe<Filterfeedback__AreaType>;
  createdAt?: InputMaybe<FilterString>;
  event?: InputMaybe<issue__NestedFilterEvent>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__NestedFilterIssueFeedback = {
  area?: InputMaybe<Filterfeedback__AreaType>;
  closedEvent?: InputMaybe<issue__NestedFilterClosedEvent>;
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  owner?: InputMaybe<NestedFilterUser>;
  rating?: InputMaybe<FilterInt>;
  review?: InputMaybe<FilterString>;
  selectedOptions?: InputMaybe<feedback__NestedFilterOption>;
};

export type feedback__NestedFilterOption = {
  archived?: InputMaybe<FilterBoolean>;
  area?: InputMaybe<Filterfeedback__AreaType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  order?: InputMaybe<FilterInt>;
  sentiment?: InputMaybe<Filterfeedback__SentimentType>;
  value?: InputMaybe<FilterString>;
};

export type feedback__Option = {
  archived: Scalars['Boolean']['output'];
  area: feedback__AreaType;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  sentiment: feedback__SentimentType;
  value: Scalars['String']['output'];
};

export type feedback__Option_Type = BaseObject & Object & feedback__Option & {
  __typename: 'feedback__Option_Type';
  archived: Scalars['Boolean']['output'];
  area: feedback__AreaType;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  sentiment: feedback__SentimentType;
  value: Scalars['String']['output'];
};

export type feedback__OrderGeneralFeedback = {
  area?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  rating?: InputMaybe<Ordering>;
  review?: InputMaybe<Ordering>;
};

export type feedback__OrderIssueEventFeedback = {
  area?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  event?: InputMaybe<issue__OrderEvent>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  rating?: InputMaybe<Ordering>;
  review?: InputMaybe<Ordering>;
};

export type feedback__OrderIssueFeedback = {
  area?: InputMaybe<Ordering>;
  closedEvent?: InputMaybe<issue__OrderClosedEvent>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  owner?: InputMaybe<OrderUser>;
  rating?: InputMaybe<Ordering>;
  review?: InputMaybe<Ordering>;
};

export type feedback__OrderOption = {
  archived?: InputMaybe<Ordering>;
  area?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  order?: InputMaybe<Ordering>;
  sentiment?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type feedback__OrderStaffFeedback = {
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  review?: InputMaybe<Ordering>;
  sentiment?: InputMaybe<Ordering>;
};

export type feedback__OrderUserFeedback = {
  area?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  rating?: InputMaybe<Ordering>;
  review?: InputMaybe<Ordering>;
};

export enum feedback__SentimentType {
  NEGATIVE = 'NEGATIVE',
  NEUTRAL = 'NEUTRAL',
  POSITIVE = 'POSITIVE'
}

export type feedback__StaffFeedback = {
  createdAt: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  review?: Maybe<Scalars['String']['output']>;
  sentiment: feedback__SentimentType;
};


export type feedback__StaffFeedbackcreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__StaffFeedbackissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type feedback__StaffFeedback_Type = BaseObject & Object & feedback__StaffFeedback & {
  __typename: 'feedback__StaffFeedback_Type';
  createdAt: Scalars['String']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  review?: Maybe<Scalars['String']['output']>;
  sentiment: feedback__SentimentType;
};


export type feedback__StaffFeedback_TypecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__StaffFeedback_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type feedback__UserFeedback = {
  area: feedback__AreaType;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  rating: Scalars['Int']['output'];
  review?: Maybe<Scalars['String']['output']>;
  selectedOptions?: Maybe<Array<feedback__Option>>;
};


export type feedback__UserFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type feedback__UserFeedbackselectedOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterOption>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderOption>;
};

export type fhirEdit__CoverageEdit = {
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  editor: User;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  rationale: Scalars['String']['output'];
  relationship?: Maybe<fhirEdit__CoverageRelationship>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  startDate?: Maybe<Scalars['String']['output']>;
  status: fhirEdit__ResourceEditStatus;
  terminationDate?: Maybe<Scalars['String']['output']>;
};


export type fhirEdit__CoverageEditeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirEdit__CoverageEdit_Type = BaseObject & Object & fhirEdit__CoverageEdit & fhirEdit__ResourceEdit & {
  __typename: 'fhirEdit__CoverageEdit_Type';
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  editor: User;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insuranceName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  rationale: Scalars['String']['output'];
  relationship?: Maybe<fhirEdit__CoverageRelationship>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  startDate?: Maybe<Scalars['String']['output']>;
  status: fhirEdit__ResourceEditStatus;
  terminationDate?: Maybe<Scalars['String']['output']>;
};


export type fhirEdit__CoverageEdit_TypeeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum fhirEdit__CoverageRelationship {
  CHILD = 'CHILD',
  DEPENDENT = 'DEPENDENT',
  OTHER = 'OTHER',
  SELF = 'SELF',
  SPOUSE = 'SPOUSE'
}

export type fhirEdit__CoverageSnapshot = {
  baseResource?: Maybe<fhirext__ResourceVersion>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  computedAt: Scalars['String']['output'];
  coverageType?: Maybe<fhir__CoverageType>;
  edit?: Maybe<fhirEdit__ResourceEdit>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirEdit__CoverageSnapshotbaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__CoverageSnapshotbeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__CoverageSnapshotclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirEdit__CoverageSnapshoteditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__CoverageSnapshotidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirEdit__CoverageSnapshotownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__CoverageSnapshotpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirEdit__CoverageSnapshotrelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__CoverageSnapshotsubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__CoverageSnapshottypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirEdit__CoverageSnapshot_Type = BaseObject & Object & Owned & Personal & fhirEdit__CoverageSnapshot & fhirEdit__ResourceSnapshot & fhir__Coverage & fhir__FHIRResource & fhirext__CoverageExtension & {
  __typename: 'fhirEdit__CoverageSnapshot_Type';
  baseResource?: Maybe<fhirext__ResourceVersion>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  computedAt: Scalars['String']['output'];
  coverageType?: Maybe<fhir__CoverageType>;
  edit?: Maybe<fhirEdit__ResourceEdit>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirEdit__CoverageSnapshot_TypebaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__CoverageSnapshot_TypebeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__CoverageSnapshot_TypeclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirEdit__CoverageSnapshot_TypeeditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__CoverageSnapshot_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirEdit__CoverageSnapshot_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__CoverageSnapshot_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirEdit__CoverageSnapshot_TyperelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__CoverageSnapshot_TypesubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__CoverageSnapshot_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export enum fhirEdit__ExplanationOfBenefitDecision {
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
  PARTIAL = 'PARTIAL',
  PENDING = 'PENDING'
}

export type fhirEdit__ExplanationOfBenefitEdit = {
  billablePeriodEnd?: Maybe<Scalars['String']['output']>;
  billablePeriodStart?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhirEdit__ExplanationOfBenefitDecision>;
  editor: User;
  id: Scalars['ID']['output'];
  network?: Maybe<fhirEdit__ExplanationOfBenefitNetwork>;
  rationale: Scalars['String']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhirEdit__ResourceEditStatus;
};


export type fhirEdit__ExplanationOfBenefitEditeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirEdit__ExplanationOfBenefitEdit_Type = BaseObject & Object & fhirEdit__ExplanationOfBenefitEdit & fhirEdit__ResourceEdit & {
  __typename: 'fhirEdit__ExplanationOfBenefitEdit_Type';
  billablePeriodEnd?: Maybe<Scalars['String']['output']>;
  billablePeriodStart?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdDate?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhirEdit__ExplanationOfBenefitDecision>;
  editor: User;
  id: Scalars['ID']['output'];
  network?: Maybe<fhirEdit__ExplanationOfBenefitNetwork>;
  rationale: Scalars['String']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhirEdit__ResourceEditStatus;
};


export type fhirEdit__ExplanationOfBenefitEdit_TypeeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum fhirEdit__ExplanationOfBenefitNetwork {
  IN_NETWORK = 'IN_NETWORK',
  OTHER = 'OTHER',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK'
}

export type fhirEdit__ExplanationOfBenefitSnapshot = {
  baseResource?: Maybe<fhirext__ResourceVersion>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  computedAt: Scalars['String']['output'];
  created?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  edit?: Maybe<fhirEdit__ResourceEdit>;
  facility?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirEdit__ExplanationOfBenefitSnapshotbaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotcareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotdecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirEdit__ExplanationOfBenefitSnapshoteditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotnetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirEdit__ExplanationOfBenefitSnapshotproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshottotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirEdit__ExplanationOfBenefitSnapshottotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirEdit__ExplanationOfBenefitSnapshottypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirEdit__ExplanationOfBenefitSnapshot_Type = BaseObject & Object & Owned & Personal & fhirEdit__ExplanationOfBenefitSnapshot & fhirEdit__ResourceSnapshot & fhir__ExplanationOfBenefit & fhir__FHIRResource & fhirext__ExplanationOfBenefitExtension & {
  __typename: 'fhirEdit__ExplanationOfBenefitSnapshot_Type';
  baseResource?: Maybe<fhirext__ResourceVersion>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  computedAt: Scalars['String']['output'];
  created?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  edit?: Maybe<fhirEdit__ResourceEdit>;
  facility?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypebaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypecareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypedecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypediagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeeditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypefacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypenetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypepatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypetotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypetotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirEdit__ExplanationOfBenefitSnapshot_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirEdit__FilterCoverageEdit = {
  and?: InputMaybe<Array<fhirEdit__FilterCoverageEdit>>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  editor?: InputMaybe<NestedFilterUser>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  insuranceName?: InputMaybe<FilterString>;
  memberId?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirEdit__FilterCoverageEdit>;
  or?: InputMaybe<Array<fhirEdit__FilterCoverageEdit>>;
  planName?: InputMaybe<FilterString>;
  rationale?: InputMaybe<FilterString>;
  relationship?: InputMaybe<FilterfhirEdit__CoverageRelationship>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  startDate?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterfhirEdit__ResourceEditStatus>;
  terminationDate?: InputMaybe<FilterString>;
};

export type fhirEdit__FilterCoverageSnapshot = {
  and?: InputMaybe<Array<fhirEdit__FilterCoverageSnapshot>>;
  baseResource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  computedAt?: InputMaybe<FilterString>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  edit?: InputMaybe<fhirEdit__NestedFilterResourceEdit>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  isActive?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirEdit__FilterCoverageSnapshot>;
  or?: InputMaybe<Array<fhirEdit__FilterCoverageSnapshot>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirEdit__FilterExplanationOfBenefitEdit = {
  and?: InputMaybe<Array<fhirEdit__FilterExplanationOfBenefitEdit>>;
  billablePeriodEnd?: InputMaybe<FilterString>;
  billablePeriodStart?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  createdDate?: InputMaybe<FilterString>;
  decision?: InputMaybe<FilterfhirEdit__ExplanationOfBenefitDecision>;
  editor?: InputMaybe<NestedFilterUser>;
  id?: InputMaybe<FilterID>;
  network?: InputMaybe<FilterfhirEdit__ExplanationOfBenefitNetwork>;
  not?: InputMaybe<fhirEdit__FilterExplanationOfBenefitEdit>;
  or?: InputMaybe<Array<fhirEdit__FilterExplanationOfBenefitEdit>>;
  rationale?: InputMaybe<FilterString>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterfhirEdit__ResourceEditStatus>;
};

export type fhirEdit__FilterExplanationOfBenefitSnapshot = {
  and?: InputMaybe<Array<fhirEdit__FilterExplanationOfBenefitSnapshot>>;
  baseResource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  computedAt?: InputMaybe<FilterString>;
  created?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  edit?: InputMaybe<fhirEdit__NestedFilterResourceEdit>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  not?: InputMaybe<fhirEdit__FilterExplanationOfBenefitSnapshot>;
  or?: InputMaybe<Array<fhirEdit__FilterExplanationOfBenefitSnapshot>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  person?: InputMaybe<NestedFilterPerson>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirEdit__FilterResourceEdit = {
  and?: InputMaybe<Array<fhirEdit__FilterResourceEdit>>;
  createdAt?: InputMaybe<FilterString>;
  editor?: InputMaybe<NestedFilterUser>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirEdit__FilterResourceEdit>;
  or?: InputMaybe<Array<fhirEdit__FilterResourceEdit>>;
  rationale?: InputMaybe<FilterString>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  status?: InputMaybe<FilterfhirEdit__ResourceEditStatus>;
};

export type fhirEdit__FilterResourceSnapshot = {
  and?: InputMaybe<Array<fhirEdit__FilterResourceSnapshot>>;
  baseResource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  computedAt?: InputMaybe<FilterString>;
  edit?: InputMaybe<fhirEdit__NestedFilterResourceEdit>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirEdit__FilterResourceSnapshot>;
  or?: InputMaybe<Array<fhirEdit__FilterResourceSnapshot>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
};

export type fhirEdit__NestedFilterResourceEdit = {
  createdAt?: InputMaybe<FilterString>;
  editor?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  rationale?: InputMaybe<FilterString>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  status?: InputMaybe<FilterfhirEdit__ResourceEditStatus>;
};

export type fhirEdit__OrderCoverageEdit = {
  coverageType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  editor?: InputMaybe<OrderUser>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  insuranceName?: InputMaybe<Ordering>;
  memberId?: InputMaybe<Ordering>;
  planName?: InputMaybe<Ordering>;
  rationale?: InputMaybe<Ordering>;
  relationship?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  startDate?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  terminationDate?: InputMaybe<Ordering>;
};

export type fhirEdit__OrderCoverageSnapshot = {
  baseResource?: InputMaybe<fhirext__OrderResourceVersion>;
  beneficiary?: InputMaybe<fhir__OrderReference>;
  computedAt?: InputMaybe<Ordering>;
  coverageType?: InputMaybe<Ordering>;
  edit?: InputMaybe<fhirEdit__OrderResourceEdit>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  memberId?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirEdit__OrderExplanationOfBenefitEdit = {
  billablePeriodEnd?: InputMaybe<Ordering>;
  billablePeriodStart?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdDate?: InputMaybe<Ordering>;
  decision?: InputMaybe<Ordering>;
  editor?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  rationale?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
};

export type fhirEdit__OrderExplanationOfBenefitSnapshot = {
  baseResource?: InputMaybe<fhirext__OrderResourceVersion>;
  computedAt?: InputMaybe<Ordering>;
  created?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  edit?: InputMaybe<fhirEdit__OrderResourceEdit>;
  facility?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  network?: InputMaybe<fhir__OrderCodeableConcept>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  person?: InputMaybe<OrderPerson>;
  provider?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  totalsByType?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhirEdit__OrderResourceEdit = {
  createdAt?: InputMaybe<Ordering>;
  editor?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  rationale?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
};

export type fhirEdit__OrderResourceSnapshot = {
  baseResource?: InputMaybe<fhirext__OrderResourceVersion>;
  computedAt?: InputMaybe<Ordering>;
  edit?: InputMaybe<fhirEdit__OrderResourceEdit>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
};

export type fhirEdit__ResourceEdit = {
  createdAt: Scalars['String']['output'];
  editor: User;
  id: Scalars['ID']['output'];
  rationale: Scalars['String']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  status: fhirEdit__ResourceEditStatus;
};


export type fhirEdit__ResourceEditeditorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum fhirEdit__ResourceEditStatus {
  ACTIVE = 'ACTIVE',
  SUPERSEDED = 'SUPERSEDED'
}

export type fhirEdit__ResourceSnapshot = {
  baseResource?: Maybe<fhirext__ResourceVersion>;
  computedAt: Scalars['String']['output'];
  edit?: Maybe<fhirEdit__ResourceEdit>;
  id: Scalars['ID']['output'];
  owner: User;
  person?: Maybe<Person>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
};


export type fhirEdit__ResourceSnapshotbaseResourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirEdit__ResourceSnapshoteditArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirEdit__FilterResourceEdit>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirEdit__OrderResourceEdit>;
};


export type fhirEdit__ResourceSnapshotownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirEdit__ResourceSnapshotpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};

export type fhir__Account = {
  balance?: Maybe<fhir__AccountBalance>;
  billingStatus?: Maybe<fhir__CodeableConcept>;
  calculatedAt?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Array<fhir__Reference>>;
  currency?: Maybe<fhir__CodeableConcept>;
  description?: Maybe<Scalars['String']['output']>;
  guarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  servicePeriod?: Maybe<Scalars['JSON']['output']>;
  status: fhir__AccountStatus;
  subject?: Maybe<Array<fhir__Reference>>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__AccountbalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type fhir__AccountbillingStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__AccountcoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__AccountcurrencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__AccountguarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type fhir__AccountidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__AccountownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__AccounttypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__AccountBalance = {
  aggregate?: Maybe<fhir__CodeableConcept>;
  amount?: Maybe<fhir__Money>;
  estimate?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  term?: Maybe<fhir__CodeableConcept>;
};


export type fhir__AccountBalanceaggregateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__AccountBalanceamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__AccountBalanceownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountBalancetermArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__AccountBalance_Type = BaseObject & Object & Owned & fhir__AccountBalance & {
  __typename: 'fhir__AccountBalance_Type';
  aggregate?: Maybe<fhir__CodeableConcept>;
  amount?: Maybe<fhir__Money>;
  estimate?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  term?: Maybe<fhir__CodeableConcept>;
};


export type fhir__AccountBalance_TypeaggregateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__AccountBalance_TypeamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__AccountBalance_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountBalance_TypetermArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__AccountGuarantor = {
  id: Scalars['ID']['output'];
  onHold?: Maybe<Scalars['Boolean']['output']>;
  owner: User;
  party: fhir__Reference;
  period?: Maybe<Scalars['JSON']['output']>;
};


export type fhir__AccountGuarantorownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountGuarantorpartyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__AccountGuarantor_Type = BaseObject & Object & Owned & fhir__AccountGuarantor & {
  __typename: 'fhir__AccountGuarantor_Type';
  id: Scalars['ID']['output'];
  onHold?: Maybe<Scalars['Boolean']['output']>;
  owner: User;
  party: fhir__Reference;
  period?: Maybe<Scalars['JSON']['output']>;
};


export type fhir__AccountGuarantor_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__AccountGuarantor_TypepartyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export enum fhir__AccountStatus {
  ACTIVE = 'ACTIVE',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR',
  INACTIVE = 'INACTIVE',
  ON_HOLD = 'ON_HOLD',
  UNKNOWN = 'UNKNOWN'
}

export type fhir__Address = {
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type fhir__Address_Type = BaseObject & Object & fhir__Address & {
  __typename: 'fhir__Address_Type';
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

export type fhir__Annotation = {
  authorReference?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};


export type fhir__AnnotationauthorReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__Annotation_Type = BaseObject & Object & fhir__Annotation & {
  __typename: 'fhir__Annotation_Type';
  authorReference?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};


export type fhir__Annotation_TypeauthorReferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__ChargeItem = {
  code?: Maybe<fhir__CodeableConcept>;
  enteredDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Array<fhir__Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Scalars['JSON']['output']>;
  owner: User;
  performer?: Maybe<Array<fhir__ChargeItemPerformer>>;
  quantity?: Maybe<fhir__Quantity>;
  reason?: Maybe<Array<fhir__CodeableConcept>>;
  service?: Maybe<Array<fhir__CodeableReference>>;
  status: fhir__ChargeItemStatus;
  subject?: Maybe<fhir__Reference>;
};


export type fhir__ChargeItemcodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ChargeItemnoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhir__ChargeItemownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ChargeItemperformerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItemPerformer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItemPerformer>;
};


export type fhir__ChargeItemquantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ChargeItemreasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ChargeItemserviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableReference>;
};


export type fhir__ChargeItemsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__ChargeItemPerformer = {
  actor?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  operation?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ChargeItemPerformeractorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ChargeItemPerformeroperationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ChargeItemPerformer_Type = BaseObject & Object & fhir__ChargeItemPerformer & {
  __typename: 'fhir__ChargeItemPerformer_Type';
  actor?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  operation?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ChargeItemPerformer_TypeactorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ChargeItemPerformer_TypeoperationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export enum fhir__ChargeItemStatus {
  ABORTED = 'ABORTED',
  BILLABLE = 'BILLABLE',
  BILLED = 'BILLED',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR',
  NOT_BILLABLE = 'NOT_BILLABLE',
  PLANNED = 'PLANNED',
  UNKNOWN = 'UNKNOWN'
}

export type fhir__ChargeItem_Type = BaseObject & Object & Owned & fhir__ChargeItem & {
  __typename: 'fhir__ChargeItem_Type';
  code?: Maybe<fhir__CodeableConcept>;
  enteredDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  note?: Maybe<Array<fhir__Annotation>>;
  occurrenceDateTime?: Maybe<Scalars['String']['output']>;
  occurrencePeriod?: Maybe<Scalars['JSON']['output']>;
  owner: User;
  performer?: Maybe<Array<fhir__ChargeItemPerformer>>;
  quantity?: Maybe<fhir__Quantity>;
  reason?: Maybe<Array<fhir__CodeableConcept>>;
  service?: Maybe<Array<fhir__CodeableReference>>;
  status: fhir__ChargeItemStatus;
  subject?: Maybe<fhir__Reference>;
};


export type fhir__ChargeItem_TypecodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ChargeItem_TypenoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhir__ChargeItem_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ChargeItem_TypeperformerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItemPerformer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItemPerformer>;
};


export type fhir__ChargeItem_TypequantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ChargeItem_TypereasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ChargeItem_TypeserviceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableReference>;
};


export type fhir__ChargeItem_TypesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export enum fhir__ClaimUse {
  CLAIM = 'CLAIM',
  PREAUTHORIZATION = 'PREAUTHORIZATION',
  PREDETERMINATION = 'PREDETERMINATION'
}

export type fhir__ClinicalNote = {
  author?: Maybe<fhir__Reference>;
  category?: Maybe<fhir__CodeableConcept>;
  dateTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  text: Scalars['String']['output'];
};


export type fhir__ClinicalNoteauthorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ClinicalNotecategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ClinicalNoteownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ClinicalNote_Type = BaseObject & Object & Owned & fhir__ClinicalNote & {
  __typename: 'fhir__ClinicalNote_Type';
  author?: Maybe<fhir__Reference>;
  category?: Maybe<fhir__CodeableConcept>;
  dateTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  text: Scalars['String']['output'];
};


export type fhir__ClinicalNote_TypeauthorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ClinicalNote_TypecategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ClinicalNote_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__CodeableConcept = {
  coding?: Maybe<Array<fhir__Coding>>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};


export type fhir__CodeableConceptcodingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhir__CodeableConcept_Type = BaseObject & Object & fhir__CodeableConcept & {
  __typename: 'fhir__CodeableConcept_Type';
  coding?: Maybe<Array<fhir__Coding>>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};


export type fhir__CodeableConcept_TypecodingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhir__CodeableReference = {
  concept?: Maybe<fhir__CodeableConcept>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<fhir__Reference>;
};


export type fhir__CodeableReferenceconceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CodeableReferencereferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__CodeableReference_Type = BaseObject & Object & fhir__CodeableReference & {
  __typename: 'fhir__CodeableReference_Type';
  concept?: Maybe<fhir__CodeableConcept>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  reference?: Maybe<fhir__Reference>;
};


export type fhir__CodeableReference_TypeconceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CodeableReference_TypereferenceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__Coding = {
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  system?: Maybe<Scalars['String']['output']>;
};

export type fhir__Coding_Type = BaseObject & Object & fhir__Coding & {
  __typename: 'fhir__Coding_Type';
  code?: Maybe<Scalars['String']['output']>;
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  system?: Maybe<Scalars['String']['output']>;
};

export type fhir__ContactPoint = {
  id: Scalars['ID']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  use?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type fhir__ContactPoint_Type = BaseObject & Object & fhir__ContactPoint & {
  __typename: 'fhir__ContactPoint_Type';
  id: Scalars['ID']['output'];
  rank?: Maybe<Scalars['Int']['output']>;
  system?: Maybe<Scalars['String']['output']>;
  use?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type fhir__Coverage = {
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  kind: fhir__CoverageKind;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  relationship?: Maybe<fhir__CodeableConcept>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__CoveragebeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__CoverageclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhir__CoverageidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__CoverageownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__CoveragerelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CoveragesubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__CoveragetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__CoverageClass = {
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: fhir__CodeableConcept;
  value: fhir__Identifier;
};


export type fhir__CoverageClasstypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CoverageClassvalueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};

export type fhir__CoverageClass_Type = BaseObject & Object & fhir__CoverageClass & {
  __typename: 'fhir__CoverageClass_Type';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  type: fhir__CodeableConcept;
  value: fhir__Identifier;
};


export type fhir__CoverageClass_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__CoverageClass_TypevalueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};

export enum fhir__CoverageKind {
  INSURANCE = 'INSURANCE',
  OTHER = 'OTHER',
  SELF_PAY = 'SELF_PAY'
}

/** Type of coverage: MEDICAL, DENTAL, VISION, PHARMACY, OTHER. */
export enum fhir__CoverageType {
  DENTAL = 'DENTAL',
  MEDICAL = 'MEDICAL',
  OTHER = 'OTHER',
  PHARMACY = 'PHARMACY',
  VISION = 'VISION'
}

export type fhir__Encounter = {
  actualPeriod?: Maybe<Scalars['JSON']['output']>;
  class?: Maybe<Array<fhir__Coding>>;
  clinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  diagnosis?: Maybe<Array<fhir__CodeableConcept>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  location?: Maybe<Array<fhir__Location>>;
  owner: User;
  participant?: Maybe<Array<fhir__EncounterParticipant>>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<fhir__Reference>;
  type?: Maybe<Array<fhir__Coding>>;
};


export type fhir__EncounterclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type fhir__EncounterclinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type fhir__EncounterdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__EncounteridentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__EncounterlocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type fhir__EncounterownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__EncounterparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type fhir__EncountersubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__EncountertypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhir__EncounterParticipant = {
  id: Scalars['ID']['output'];
  identifier?: Maybe<fhir__Identifier>;
  owner: User;
  text: Scalars['String']['output'];
};


export type fhir__EncounterParticipantidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__EncounterParticipantownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__EncounterParticipant_Type = BaseObject & Object & Owned & fhir__EncounterParticipant & {
  __typename: 'fhir__EncounterParticipant_Type';
  id: Scalars['ID']['output'];
  identifier?: Maybe<fhir__Identifier>;
  owner: User;
  text: Scalars['String']['output'];
};


export type fhir__EncounterParticipant_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__EncounterParticipant_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ExplanationOfBenefit = {
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  provider?: Maybe<fhir__Reference>;
  status: fhir__ExplanationOfBenefitStatus;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhir__ExplanationOfBenefitcareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhir__ExplanationOfBenefitdecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhir__ExplanationOfBenefitfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ExplanationOfBenefitidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__ExplanationOfBenefititemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhir__ExplanationOfBenefitownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ExplanationOfBenefitproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__ExplanationOfBenefittotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhir__ExplanationOfBenefittypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitCareTeam = {
  id: Scalars['ID']['output'];
  owner: User;
  provider?: Maybe<fhir__Reference>;
};


export type fhir__ExplanationOfBenefitCareTeamownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitCareTeamproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__ExplanationOfBenefitCareTeam_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitCareTeam & {
  __typename: 'fhir__ExplanationOfBenefitCareTeam_Type';
  id: Scalars['ID']['output'];
  owner: User;
  provider?: Maybe<fhir__Reference>;
};


export type fhir__ExplanationOfBenefitCareTeam_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitCareTeam_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};

export type fhir__ExplanationOfBenefitDiagnosis = {
  diagnosisCodeableConcept?: Maybe<fhir__CodeableConcept>;
  id: Scalars['ID']['output'];
  owner: User;
  sequence: Scalars['Int64']['output'];
};


export type fhir__ExplanationOfBenefitDiagnosisdiagnosisCodeableConceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitDiagnosisownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ExplanationOfBenefitDiagnosis_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitDiagnosis & {
  __typename: 'fhir__ExplanationOfBenefitDiagnosis_Type';
  diagnosisCodeableConcept?: Maybe<fhir__CodeableConcept>;
  id: Scalars['ID']['output'];
  owner: User;
  sequence: Scalars['Int64']['output'];
};


export type fhir__ExplanationOfBenefitDiagnosis_TypediagnosisCodeableConceptArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitDiagnosis_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ExplanationOfBenefitItem = {
  adjudication?: Maybe<Array<fhir__ExplanationOfBenefitItemAdjudication>>;
  diagnosisSequence?: Maybe<Array<Scalars['Int64']['output']>>;
  id: Scalars['ID']['output'];
  net?: Maybe<fhir__Money>;
  owner: User;
  productOrService?: Maybe<fhir__CodeableConcept>;
  quantity?: Maybe<fhir__Quantity>;
  reviewOutcome?: Maybe<fhir__ExplanationOfBenefitItemReviewOutcome>;
  sequence: Scalars['Int64']['output'];
  unitPrice?: Maybe<fhir__Money>;
};


export type fhir__ExplanationOfBenefitItemadjudicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemAdjudication>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemAdjudication>;
};


export type fhir__ExplanationOfBenefitItemnetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitItemownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemproductOrServiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemquantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ExplanationOfBenefitItemreviewOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemReviewOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemReviewOutcome>;
};


export type fhir__ExplanationOfBenefitItemunitPriceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhir__ExplanationOfBenefitItemAdjudication = {
  amount?: Maybe<fhir__Money>;
  category: fhir__CodeableConcept;
  id: Scalars['ID']['output'];
  owner: User;
  quantity?: Maybe<fhir__Quantity>;
  reason?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationcategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationquantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ExplanationOfBenefitItemAdjudicationreasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitItemAdjudication_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitItemAdjudication & {
  __typename: 'fhir__ExplanationOfBenefitItemAdjudication_Type';
  amount?: Maybe<fhir__Money>;
  category: fhir__CodeableConcept;
  id: Scalars['ID']['output'];
  owner: User;
  quantity?: Maybe<fhir__Quantity>;
  reason?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypeamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypecategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypequantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ExplanationOfBenefitItemAdjudication_TypereasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitItemReviewOutcome = {
  decision?: Maybe<fhir__CodeableConcept>;
  id: Scalars['ID']['output'];
  owner: User;
  reason?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcomedecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcomeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcomereasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitItemReviewOutcome_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitItemReviewOutcome & {
  __typename: 'fhir__ExplanationOfBenefitItemReviewOutcome_Type';
  decision?: Maybe<fhir__CodeableConcept>;
  id: Scalars['ID']['output'];
  owner: User;
  reason?: Maybe<fhir__CodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcome_TypedecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcome_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItemReviewOutcome_TypereasonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__ExplanationOfBenefitItem_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitItem & {
  __typename: 'fhir__ExplanationOfBenefitItem_Type';
  adjudication?: Maybe<Array<fhir__ExplanationOfBenefitItemAdjudication>>;
  diagnosisSequence?: Maybe<Array<Scalars['Int64']['output']>>;
  id: Scalars['ID']['output'];
  net?: Maybe<fhir__Money>;
  owner: User;
  productOrService?: Maybe<fhir__CodeableConcept>;
  quantity?: Maybe<fhir__Quantity>;
  reviewOutcome?: Maybe<fhir__ExplanationOfBenefitItemReviewOutcome>;
  sequence: Scalars['Int64']['output'];
  unitPrice?: Maybe<fhir__Money>;
};


export type fhir__ExplanationOfBenefitItem_TypeadjudicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemAdjudication>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemAdjudication>;
};


export type fhir__ExplanationOfBenefitItem_TypenetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitItem_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__ExplanationOfBenefitItem_TypeproductOrServiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitItem_TypequantityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterQuantity>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderQuantity>;
};


export type fhir__ExplanationOfBenefitItem_TypereviewOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItemReviewOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItemReviewOutcome>;
};


export type fhir__ExplanationOfBenefitItem_TypeunitPriceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export enum fhir__ExplanationOfBenefitStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR'
}

export type fhir__ExplanationOfBenefitTotal = {
  amount: fhir__Money;
  category: fhir__CodeableConcept;
  id: Scalars['ID']['output'];
  owner: User;
};


export type fhir__ExplanationOfBenefitTotalamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitTotalcategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitTotalownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__ExplanationOfBenefitTotal_Type = BaseObject & Object & Owned & fhir__ExplanationOfBenefitTotal & {
  __typename: 'fhir__ExplanationOfBenefitTotal_Type';
  amount: fhir__Money;
  category: fhir__CodeableConcept;
  id: Scalars['ID']['output'];
  owner: User;
};


export type fhir__ExplanationOfBenefitTotal_TypeamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__ExplanationOfBenefitTotal_TypecategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhir__ExplanationOfBenefitTotal_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__FHIRResource = {
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  owner: User;
};


export type fhir__FHIRResourceidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__FHIRResourceownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__FilterAccount = {
  and?: InputMaybe<Array<fhir__FilterAccount>>;
  balance?: InputMaybe<fhir__NestedFilterAccountBalance>;
  billingStatus?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  calculatedAt?: InputMaybe<FilterString>;
  coverage?: InputMaybe<fhir__NestedFilterReference>;
  currency?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  description?: InputMaybe<FilterString>;
  guarantor?: InputMaybe<fhir__NestedFilterAccountGuarantor>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhir__FilterAccount>;
  or?: InputMaybe<Array<fhir__FilterAccount>>;
  owner?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<Filterfhir__AccountStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterAccountBalance = {
  aggregate?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  and?: InputMaybe<Array<fhir__FilterAccountBalance>>;
  estimate?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterAccountBalance>;
  or?: InputMaybe<Array<fhir__FilterAccountBalance>>;
  owner?: InputMaybe<NestedFilterUser>;
  term?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterAccountGuarantor = {
  and?: InputMaybe<Array<fhir__FilterAccountGuarantor>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterAccountGuarantor>;
  onHold?: InputMaybe<FilterBoolean>;
  or?: InputMaybe<Array<fhir__FilterAccountGuarantor>>;
  owner?: InputMaybe<NestedFilterUser>;
  party?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__FilterAddress = {
  and?: InputMaybe<Array<fhir__FilterAddress>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterAddress>;
  or?: InputMaybe<Array<fhir__FilterAddress>>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterAnnotation = {
  and?: InputMaybe<Array<fhir__FilterAnnotation>>;
  authorReference?: InputMaybe<fhir__NestedFilterReference>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterAnnotation>;
  or?: InputMaybe<Array<fhir__FilterAnnotation>>;
  text?: InputMaybe<FilterString>;
  time?: InputMaybe<FilterString>;
};

export type fhir__FilterChargeItem = {
  and?: InputMaybe<Array<fhir__FilterChargeItem>>;
  code?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  enteredDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterChargeItem>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  occurrenceDateTime?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<fhir__FilterChargeItem>>;
  owner?: InputMaybe<NestedFilterUser>;
  performer?: InputMaybe<fhir__NestedFilterChargeItemPerformer>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  service?: InputMaybe<fhir__NestedFilterCodeableReference>;
  status?: InputMaybe<Filterfhir__ChargeItemStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__FilterChargeItemPerformer = {
  actor?: InputMaybe<fhir__NestedFilterReference>;
  and?: InputMaybe<Array<fhir__FilterChargeItemPerformer>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterChargeItemPerformer>;
  operation?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  or?: InputMaybe<Array<fhir__FilterChargeItemPerformer>>;
};

export type fhir__FilterClinicalNote = {
  and?: InputMaybe<Array<fhir__FilterClinicalNote>>;
  author?: InputMaybe<fhir__NestedFilterReference>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  dateTime?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterClinicalNote>;
  or?: InputMaybe<Array<fhir__FilterClinicalNote>>;
  owner?: InputMaybe<NestedFilterUser>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterCodeableConcept = {
  and?: InputMaybe<Array<fhir__FilterCodeableConcept>>;
  coding?: InputMaybe<fhir__NestedFilterCoding>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterCodeableConcept>;
  or?: InputMaybe<Array<fhir__FilterCodeableConcept>>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterCodeableReference = {
  and?: InputMaybe<Array<fhir__FilterCodeableReference>>;
  concept?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterCodeableReference>;
  or?: InputMaybe<Array<fhir__FilterCodeableReference>>;
  reference?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__FilterCoding = {
  and?: InputMaybe<Array<fhir__FilterCoding>>;
  code?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterCoding>;
  or?: InputMaybe<Array<fhir__FilterCoding>>;
  system?: InputMaybe<FilterString>;
};

export type fhir__FilterContactPoint = {
  and?: InputMaybe<Array<fhir__FilterContactPoint>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterContactPoint>;
  or?: InputMaybe<Array<fhir__FilterContactPoint>>;
  rank?: InputMaybe<FilterInt>;
  system?: InputMaybe<FilterString>;
  use?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterString>;
};

export type fhir__FilterCoverage = {
  and?: InputMaybe<Array<fhir__FilterCoverage>>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhir__FilterCoverage>;
  or?: InputMaybe<Array<fhir__FilterCoverage>>;
  owner?: InputMaybe<NestedFilterUser>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterCoverageClass = {
  and?: InputMaybe<Array<fhir__FilterCoverageClass>>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhir__FilterCoverageClass>;
  or?: InputMaybe<Array<fhir__FilterCoverageClass>>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  value?: InputMaybe<fhir__NestedFilterIdentifier>;
};

export type fhir__FilterEncounter = {
  and?: InputMaybe<Array<fhir__FilterEncounter>>;
  class?: InputMaybe<fhir__NestedFilterCoding>;
  clinicalNote?: InputMaybe<fhir__NestedFilterClinicalNote>;
  diagnosis?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  location?: InputMaybe<fhir__NestedFilterLocation>;
  not?: InputMaybe<fhir__FilterEncounter>;
  or?: InputMaybe<Array<fhir__FilterEncounter>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterEncounterParticipant>;
  serviceProvider?: InputMaybe<FilterString>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCoding>;
};

export type fhir__FilterEncounterParticipant = {
  and?: InputMaybe<Array<fhir__FilterEncounterParticipant>>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  not?: InputMaybe<fhir__FilterEncounterParticipant>;
  or?: InputMaybe<Array<fhir__FilterEncounterParticipant>>;
  owner?: InputMaybe<NestedFilterUser>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterExplanationOfBenefit = {
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefit>>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefit>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefit>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhir__FilterExplanationOfBenefitCareTeam = {
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitCareTeam>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitCareTeam>>;
  owner?: InputMaybe<NestedFilterUser>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__FilterExplanationOfBenefitDiagnosis = {
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitDiagnosis>>;
  diagnosisCodeableConcept?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitDiagnosis>>;
  owner?: InputMaybe<NestedFilterUser>;
  sequence?: InputMaybe<FilterInt64>;
};

export type fhir__FilterExplanationOfBenefitItem = {
  adjudication?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItemAdjudication>;
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItem>>;
  id?: InputMaybe<FilterID>;
  net?: InputMaybe<fhir__NestedFilterMoney>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItem>>;
  owner?: InputMaybe<NestedFilterUser>;
  productOrService?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reviewOutcome?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItemReviewOutcome>;
  sequence?: InputMaybe<FilterInt64>;
  unitPrice?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhir__FilterExplanationOfBenefitItemAdjudication = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItemAdjudication>>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitItemAdjudication>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItemAdjudication>>;
  owner?: InputMaybe<NestedFilterUser>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterExplanationOfBenefitItemReviewOutcome = {
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItemReviewOutcome>>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitItemReviewOutcome>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitItemReviewOutcome>>;
  owner?: InputMaybe<NestedFilterUser>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterExplanationOfBenefitTotal = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  and?: InputMaybe<Array<fhir__FilterExplanationOfBenefitTotal>>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  or?: InputMaybe<Array<fhir__FilterExplanationOfBenefitTotal>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type fhir__FilterFHIRResource = {
  and?: InputMaybe<Array<fhir__FilterFHIRResource>>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  not?: InputMaybe<fhir__FilterFHIRResource>;
  or?: InputMaybe<Array<fhir__FilterFHIRResource>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type fhir__FilterHumanName = {
  and?: InputMaybe<Array<fhir__FilterHumanName>>;
  family?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterHumanName>;
  or?: InputMaybe<Array<fhir__FilterHumanName>>;
  text?: InputMaybe<FilterString>;
};

export type fhir__FilterIdentifier = {
  and?: InputMaybe<Array<fhir__FilterIdentifier>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterIdentifier>;
  or?: InputMaybe<Array<fhir__FilterIdentifier>>;
  system?: InputMaybe<FilterString>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterString>;
};

export type fhir__FilterInvoice = {
  account?: InputMaybe<fhir__NestedFilterReference>;
  and?: InputMaybe<Array<fhir__FilterInvoice>>;
  creation?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  issuer?: InputMaybe<fhir__NestedFilterReference>;
  lineItem?: InputMaybe<fhir__NestedFilterInvoiceLineItem>;
  not?: InputMaybe<fhir__FilterInvoice>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  or?: InputMaybe<Array<fhir__FilterInvoice>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterInvoiceParticipant>;
  paymentTerms?: InputMaybe<FilterString>;
  recipient?: InputMaybe<fhir__NestedFilterReference>;
  status?: InputMaybe<Filterfhir__InvoiceStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  totalGross?: InputMaybe<fhir__NestedFilterMoney>;
  totalNet?: InputMaybe<fhir__NestedFilterMoney>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterInvoiceLineItem = {
  and?: InputMaybe<Array<fhir__FilterInvoiceLineItem>>;
  chargeItem?: InputMaybe<fhir__NestedFilterChargeItem>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterInvoiceLineItem>;
  or?: InputMaybe<Array<fhir__FilterInvoiceLineItem>>;
  owner?: InputMaybe<NestedFilterUser>;
  priceComponent?: InputMaybe<fhir__NestedFilterMonetaryComponent>;
  sequence?: InputMaybe<FilterInt64>;
};

export type fhir__FilterInvoiceParticipant = {
  actor?: InputMaybe<fhir__NestedFilterReference>;
  and?: InputMaybe<Array<fhir__FilterInvoiceParticipant>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterInvoiceParticipant>;
  or?: InputMaybe<Array<fhir__FilterInvoiceParticipant>>;
  owner?: InputMaybe<NestedFilterUser>;
  role?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterLocation = {
  address?: InputMaybe<fhir__NestedFilterAddress>;
  and?: InputMaybe<Array<fhir__FilterLocation>>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhir__FilterLocation>;
  or?: InputMaybe<Array<fhir__FilterLocation>>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__FilterMonetaryComponent = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  and?: InputMaybe<Array<fhir__FilterMonetaryComponent>>;
  code?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  factor?: InputMaybe<FilterDecimal>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterMonetaryComponent>;
  or?: InputMaybe<Array<fhir__FilterMonetaryComponent>>;
  type?: InputMaybe<Filterfhir__PriceComponentType>;
};

export type fhir__FilterMoney = {
  and?: InputMaybe<Array<fhir__FilterMoney>>;
  currency?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterMoney>;
  or?: InputMaybe<Array<fhir__FilterMoney>>;
  value?: InputMaybe<FilterDecimal>;
};

export type fhir__FilterPatient = {
  and?: InputMaybe<Array<fhir__FilterPatient>>;
  birthDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhir__FilterPatient>;
  or?: InputMaybe<Array<fhir__FilterPatient>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type fhir__FilterPractitioner = {
  and?: InputMaybe<Array<fhir__FilterPractitioner>>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhir__FilterPractitioner>;
  or?: InputMaybe<Array<fhir__FilterPractitioner>>;
  owner?: InputMaybe<NestedFilterUser>;
  telecom?: InputMaybe<fhir__NestedFilterContactPoint>;
};

export type fhir__FilterQuantity = {
  and?: InputMaybe<Array<fhir__FilterQuantity>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhir__FilterQuantity>;
  or?: InputMaybe<Array<fhir__FilterQuantity>>;
  value?: InputMaybe<FilterDecimal>;
};

export type fhir__FilterReference = {
  and?: InputMaybe<Array<fhir__FilterReference>>;
  display?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  not?: InputMaybe<fhir__FilterReference>;
  or?: InputMaybe<Array<fhir__FilterReference>>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
};

export enum fhir__FinancialResourceStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR'
}

export type fhir__HumanName = {
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type fhir__HumanName_Type = BaseObject & Object & fhir__HumanName & {
  __typename: 'fhir__HumanName_Type';
  family?: Maybe<Scalars['String']['output']>;
  given?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type fhir__Identifier = {
  id: Scalars['ID']['output'];
  system?: Maybe<Scalars['String']['output']>;
  type?: Maybe<fhir__CodeableConcept>;
  use?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};


export type fhir__IdentifiertypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__Identifier_Type = BaseObject & Object & fhir__Identifier & {
  __typename: 'fhir__Identifier_Type';
  id: Scalars['ID']['output'];
  system?: Maybe<Scalars['String']['output']>;
  type?: Maybe<fhir__CodeableConcept>;
  use?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};


export type fhir__Identifier_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__Invoice = {
  account?: Maybe<fhir__Reference>;
  creation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  issuer?: Maybe<fhir__Reference>;
  lineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  note?: Maybe<Array<fhir__Annotation>>;
  owner: User;
  participant?: Maybe<Array<fhir__InvoiceParticipant>>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  periodPeriod?: Maybe<Scalars['JSON']['output']>;
  recipient?: Maybe<fhir__Reference>;
  status: fhir__InvoiceStatus;
  subject?: Maybe<fhir__Reference>;
  totalGross?: Maybe<fhir__Money>;
  totalNet?: Maybe<fhir__Money>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__InvoiceaccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoiceidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__InvoiceissuerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoicelineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type fhir__InvoicenoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhir__InvoiceownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type fhir__InvoicerecipientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoicesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoicetotalGrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__InvoicetotalNetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__InvoicetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__InvoiceLineItem = {
  chargeItem?: Maybe<fhir__ChargeItem>;
  id: Scalars['ID']['output'];
  owner: User;
  priceComponent?: Maybe<Array<fhir__MonetaryComponent>>;
  sequence: Scalars['Int64']['output'];
  servicedPeriod?: Maybe<Scalars['JSON']['output']>;
};


export type fhir__InvoiceLineItemchargeItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItem>;
};


export type fhir__InvoiceLineItemownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceLineItempriceComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMonetaryComponent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMonetaryComponent>;
};

export type fhir__InvoiceLineItem_Type = BaseObject & Object & Owned & fhir__InvoiceLineItem & {
  __typename: 'fhir__InvoiceLineItem_Type';
  chargeItem?: Maybe<fhir__ChargeItem>;
  id: Scalars['ID']['output'];
  owner: User;
  priceComponent?: Maybe<Array<fhir__MonetaryComponent>>;
  sequence: Scalars['Int64']['output'];
  servicedPeriod?: Maybe<Scalars['JSON']['output']>;
};


export type fhir__InvoiceLineItem_TypechargeItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterChargeItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderChargeItem>;
};


export type fhir__InvoiceLineItem_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceLineItem_TypepriceComponentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMonetaryComponent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMonetaryComponent>;
};

export type fhir__InvoiceParticipant = {
  actor?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  owner: User;
  role?: Maybe<fhir__CodeableConcept>;
};


export type fhir__InvoiceParticipantactorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoiceParticipantownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceParticipantroleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__InvoiceParticipant_Type = BaseObject & Object & Owned & fhir__InvoiceParticipant & {
  __typename: 'fhir__InvoiceParticipant_Type';
  actor?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  owner: User;
  role?: Maybe<fhir__CodeableConcept>;
};


export type fhir__InvoiceParticipant_TypeactorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhir__InvoiceParticipant_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__InvoiceParticipant_TyperoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export enum fhir__InvoiceStatus {
  BALANCED = 'BALANCED',
  CANCELLED = 'CANCELLED',
  DRAFT = 'DRAFT',
  ENTERED_IN_ERROR = 'ENTERED_IN_ERROR',
  ISSUED = 'ISSUED'
}

export type fhir__Location = {
  address?: Maybe<fhir__Address>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__LocationaddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAddress>;
};


export type fhir__LocationtypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__Location_Type = BaseObject & Object & fhir__Location & {
  __typename: 'fhir__Location_Type';
  address?: Maybe<fhir__Address>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhir__Location_TypeaddressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAddress>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAddress>;
};


export type fhir__Location_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__MonetaryComponent = {
  amount?: Maybe<fhir__Money>;
  code?: Maybe<fhir__CodeableConcept>;
  factor?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<fhir__PriceComponentType>;
};


export type fhir__MonetaryComponentamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__MonetaryComponentcodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__MonetaryComponent_Type = BaseObject & Object & fhir__MonetaryComponent & {
  __typename: 'fhir__MonetaryComponent_Type';
  amount?: Maybe<fhir__Money>;
  code?: Maybe<fhir__CodeableConcept>;
  factor?: Maybe<Scalars['Decimal']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<fhir__PriceComponentType>;
};


export type fhir__MonetaryComponent_TypeamountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhir__MonetaryComponent_TypecodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__Money = {
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type fhir__Money_Type = BaseObject & Object & fhir__Money & {
  __typename: 'fhir__Money_Type';
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type fhir__NestedFilterAccountBalance = {
  aggregate?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  estimate?: InputMaybe<FilterBoolean>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  term?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterAccountGuarantor = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  onHold?: InputMaybe<FilterBoolean>;
  owner?: InputMaybe<NestedFilterUser>;
  party?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__NestedFilterAddress = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterAnnotation = {
  authorReference?: InputMaybe<fhir__NestedFilterReference>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  text?: InputMaybe<FilterString>;
  time?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterChargeItem = {
  code?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  enteredDate?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  occurrenceDateTime?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  performer?: InputMaybe<fhir__NestedFilterChargeItemPerformer>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  service?: InputMaybe<fhir__NestedFilterCodeableReference>;
  status?: InputMaybe<Filterfhir__ChargeItemStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__NestedFilterChargeItemPerformer = {
  actor?: InputMaybe<fhir__NestedFilterReference>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  operation?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterClinicalNote = {
  author?: InputMaybe<fhir__NestedFilterReference>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  dateTime?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterCodeableConcept = {
  coding?: InputMaybe<fhir__NestedFilterCoding>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterCodeableReference = {
  concept?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  display?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  reference?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__NestedFilterCoding = {
  code?: InputMaybe<FilterString>;
  display?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  system?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterContactPoint = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  rank?: InputMaybe<FilterInt>;
  system?: InputMaybe<FilterString>;
  use?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterCoverageClass = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  value?: InputMaybe<fhir__NestedFilterIdentifier>;
};

export type fhir__NestedFilterEncounterParticipant = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  owner?: InputMaybe<NestedFilterUser>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterExplanationOfBenefitCareTeam = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
};

export type fhir__NestedFilterExplanationOfBenefitDiagnosis = {
  diagnosisCodeableConcept?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  sequence?: InputMaybe<FilterInt64>;
};

export type fhir__NestedFilterExplanationOfBenefitItem = {
  adjudication?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItemAdjudication>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  net?: InputMaybe<fhir__NestedFilterMoney>;
  owner?: InputMaybe<NestedFilterUser>;
  productOrService?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reviewOutcome?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItemReviewOutcome>;
  sequence?: InputMaybe<FilterInt64>;
  unitPrice?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhir__NestedFilterExplanationOfBenefitItemAdjudication = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  quantity?: InputMaybe<fhir__NestedFilterQuantity>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterExplanationOfBenefitItemReviewOutcome = {
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  reason?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterExplanationOfBenefitTotal = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  category?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type fhir__NestedFilterHumanName = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  family?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  text?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterIdentifier = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  system?: InputMaybe<FilterString>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterString>;
};

export type fhir__NestedFilterInvoiceLineItem = {
  chargeItem?: InputMaybe<fhir__NestedFilterChargeItem>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  priceComponent?: InputMaybe<fhir__NestedFilterMonetaryComponent>;
  sequence?: InputMaybe<FilterInt64>;
};

export type fhir__NestedFilterInvoiceParticipant = {
  actor?: InputMaybe<fhir__NestedFilterReference>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  role?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterLocation = {
  address?: InputMaybe<fhir__NestedFilterAddress>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhir__NestedFilterMonetaryComponent = {
  amount?: InputMaybe<fhir__NestedFilterMoney>;
  code?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  factor?: InputMaybe<FilterDecimal>;
  id?: InputMaybe<FilterID>;
  type?: InputMaybe<Filterfhir__PriceComponentType>;
};

export type fhir__NestedFilterMoney = {
  currency?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  value?: InputMaybe<FilterDecimal>;
};

export type fhir__NestedFilterQuantity = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  value?: InputMaybe<FilterDecimal>;
};

export type fhir__NestedFilterReference = {
  display?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
};

export type fhir__OrderAccount = {
  balance?: InputMaybe<fhir__OrderAccountBalance>;
  billingStatus?: InputMaybe<fhir__OrderCodeableConcept>;
  calculatedAt?: InputMaybe<Ordering>;
  currency?: InputMaybe<fhir__OrderCodeableConcept>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderAccountBalance = {
  aggregate?: InputMaybe<fhir__OrderCodeableConcept>;
  amount?: InputMaybe<fhir__OrderMoney>;
  estimate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  term?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderAccountGuarantor = {
  id?: InputMaybe<Ordering>;
  onHold?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  party?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderAddress = {
  id?: InputMaybe<Ordering>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderAnnotation = {
  authorReference?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  text?: InputMaybe<Ordering>;
  time?: InputMaybe<Ordering>;
};

export type fhir__OrderChargeItem = {
  code?: InputMaybe<fhir__OrderCodeableConcept>;
  enteredDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  occurrenceDateTime?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  quantity?: InputMaybe<fhir__OrderQuantity>;
  status?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderChargeItemPerformer = {
  actor?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  operation?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderClinicalNote = {
  author?: InputMaybe<fhir__OrderReference>;
  category?: InputMaybe<fhir__OrderCodeableConcept>;
  dateTime?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderCodeableConcept = {
  id?: InputMaybe<Ordering>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderCodeableReference = {
  concept?: InputMaybe<fhir__OrderCodeableConcept>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  reference?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderCoding = {
  code?: InputMaybe<Ordering>;
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  system?: InputMaybe<Ordering>;
};

export type fhir__OrderContactPoint = {
  id?: InputMaybe<Ordering>;
  rank?: InputMaybe<Ordering>;
  system?: InputMaybe<Ordering>;
  use?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type fhir__OrderCoverage = {
  beneficiary?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderCoverageClass = {
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  value?: InputMaybe<fhir__OrderIdentifier>;
};

export type fhir__OrderEncounter = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  serviceProvider?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderEncounterParticipant = {
  id?: InputMaybe<Ordering>;
  identifier?: InputMaybe<fhir__OrderIdentifier>;
  owner?: InputMaybe<OrderUser>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderExplanationOfBenefit = {
  created?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  facility?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  provider?: InputMaybe<fhir__OrderReference>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhir__OrderExplanationOfBenefitCareTeam = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  provider?: InputMaybe<fhir__OrderReference>;
};

export type fhir__OrderExplanationOfBenefitDiagnosis = {
  diagnosisCodeableConcept?: InputMaybe<fhir__OrderCodeableConcept>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  sequence?: InputMaybe<Ordering>;
};

export type fhir__OrderExplanationOfBenefitItem = {
  id?: InputMaybe<Ordering>;
  net?: InputMaybe<fhir__OrderMoney>;
  owner?: InputMaybe<OrderUser>;
  productOrService?: InputMaybe<fhir__OrderCodeableConcept>;
  quantity?: InputMaybe<fhir__OrderQuantity>;
  reviewOutcome?: InputMaybe<fhir__OrderExplanationOfBenefitItemReviewOutcome>;
  sequence?: InputMaybe<Ordering>;
  unitPrice?: InputMaybe<fhir__OrderMoney>;
};

export type fhir__OrderExplanationOfBenefitItemAdjudication = {
  amount?: InputMaybe<fhir__OrderMoney>;
  category?: InputMaybe<fhir__OrderCodeableConcept>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  quantity?: InputMaybe<fhir__OrderQuantity>;
  reason?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderExplanationOfBenefitItemReviewOutcome = {
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  reason?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderExplanationOfBenefitTotal = {
  amount?: InputMaybe<fhir__OrderMoney>;
  category?: InputMaybe<fhir__OrderCodeableConcept>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type fhir__OrderFHIRResource = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type fhir__OrderHumanName = {
  family?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  text?: InputMaybe<Ordering>;
};

export type fhir__OrderIdentifier = {
  id?: InputMaybe<Ordering>;
  system?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type fhir__OrderInvoice = {
  account?: InputMaybe<fhir__OrderReference>;
  creation?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issuer?: InputMaybe<fhir__OrderReference>;
  owner?: InputMaybe<OrderUser>;
  paymentTerms?: InputMaybe<Ordering>;
  recipient?: InputMaybe<fhir__OrderReference>;
  status?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
  totalGross?: InputMaybe<fhir__OrderMoney>;
  totalNet?: InputMaybe<fhir__OrderMoney>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderInvoiceLineItem = {
  chargeItem?: InputMaybe<fhir__OrderChargeItem>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  sequence?: InputMaybe<Ordering>;
};

export type fhir__OrderInvoiceParticipant = {
  actor?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  role?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderLocation = {
  address?: InputMaybe<fhir__OrderAddress>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhir__OrderMonetaryComponent = {
  amount?: InputMaybe<fhir__OrderMoney>;
  code?: InputMaybe<fhir__OrderCodeableConcept>;
  factor?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type fhir__OrderMoney = {
  currency?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type fhir__OrderPatient = {
  birthDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type fhir__OrderPractitioner = {
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type fhir__OrderQuantity = {
  id?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
};

export type fhir__OrderReference = {
  display?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  identifier?: InputMaybe<fhir__OrderIdentifier>;
  resource?: InputMaybe<fhirext__OrderResourceVersion>;
};

export type fhir__Patient = {
  birthDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
};


export type fhir__PatientidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__PatientnameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhir__PatientownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhir__Practitioner = {
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  telecom?: Maybe<Array<fhir__ContactPoint>>;
};


export type fhir__PractitioneridentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__PractitionernameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhir__PractitionerownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhir__PractitionertelecomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};

export enum fhir__PriceComponentType {
  BASE = 'BASE',
  DEDUCTION = 'DEDUCTION',
  DISCOUNT = 'DISCOUNT',
  INFORMATIONAL = 'INFORMATIONAL',
  SURCHARGE = 'SURCHARGE',
  TAX = 'TAX'
}

export type fhir__Quantity = {
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type fhir__Quantity_Type = BaseObject & Object & fhir__Quantity & {
  __typename: 'fhir__Quantity_Type';
  id: Scalars['ID']['output'];
  value?: Maybe<Scalars['Decimal']['output']>;
};

export type fhir__Reference = {
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<fhir__Identifier>;
  resource?: Maybe<fhirext__ResourceVersion>;
};


export type fhir__ReferenceidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__ReferenceresourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};

export type fhir__Reference_Type = BaseObject & Object & fhir__Reference & {
  __typename: 'fhir__Reference_Type';
  display?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<fhir__Identifier>;
  resource?: Maybe<fhirext__ResourceVersion>;
};


export type fhir__Reference_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhir__Reference_TyperesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};

export type fhirext__Account = {
  __typename: 'fhirext__Account';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  balance?: Maybe<fhir__AccountBalance>;
  billingStatus?: Maybe<fhir__CodeableConcept>;
  calculatedAt?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Array<fhir__Reference>>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<fhir__CodeableConcept>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  guarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  servicePeriod?: Maybe<Scalars['JSON']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__AccountStatus;
  subject?: Maybe<Array<fhir__Reference>>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__AccountassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__AccountbalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type fhirext__AccountbillingStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountcoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountcurrencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__AccountguarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type fhirext__AccountidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__AccountingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__AccountlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__AccountrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccounttypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__AccountVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  balance?: Maybe<fhir__AccountBalance>;
  billingStatus?: Maybe<fhir__CodeableConcept>;
  calculatedAt?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Array<fhir__Reference>>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<fhir__CodeableConcept>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  guarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  servicePeriod?: Maybe<Scalars['JSON']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__AccountStatus;
  subject?: Maybe<Array<fhir__Reference>>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__AccountVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__AccountVersionbalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type fhirext__AccountVersionbillingStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountVersioncoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountVersioncurrencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__AccountVersionguarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type fhirext__AccountVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__AccountVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__AccountVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__AccountVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersionsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__AccountVersion_Type = BaseObject & Object & Owned & fhir__Account & fhir__FHIRResource & fhirext__AccountVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__AccountVersion_Type';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  balance?: Maybe<fhir__AccountBalance>;
  billingStatus?: Maybe<fhir__CodeableConcept>;
  calculatedAt?: Maybe<Scalars['String']['output']>;
  coverage?: Maybe<Array<fhir__Reference>>;
  createdAt: Scalars['String']['output'];
  currency?: Maybe<fhir__CodeableConcept>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  guarantor?: Maybe<Array<fhir__AccountGuarantor>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Scalars['String']['output']>;
  owner: User;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  servicePeriod?: Maybe<Scalars['JSON']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__AccountStatus;
  subject?: Maybe<Array<fhir__Reference>>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__AccountVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__AccountVersion_TypebalanceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountBalance>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountBalance>;
};


export type fhirext__AccountVersion_TypebillingStatusArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountVersion_TypecoverageArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountVersion_TypecurrencyArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__AccountVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__AccountVersion_TypeguarantorArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAccountGuarantor>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAccountGuarantor>;
};


export type fhirext__AccountVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__AccountVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__AccountVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__AccountVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__AccountVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__AccountVersion_TypesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__AccountVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__Coverage = {
  __typename: 'fhirext__Coverage';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__CoverageassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__CoveragebeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirext__CoveragefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__CoverageidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__CoverageingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__CoveragelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoveragelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__CoveragepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__CoveragerelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoveragerelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__CoveragesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoveragesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoveragesubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoveragetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__CoverageExtension = {
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  coverageType?: Maybe<fhir__CoverageType>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  relationship?: Maybe<fhir__CodeableConcept>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__CoverageExtensionbeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageExtensionclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirext__CoverageExtensionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__CoverageExtensionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__CoverageExtensionrelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__CoverageExtensionsubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageExtensiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__CoverageVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__CoverageVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__CoverageVersionbeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageVersionclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirext__CoverageVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__CoverageVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__CoverageVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__CoverageVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__CoverageVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__CoverageVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoverageVersionrelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__CoverageVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoverageVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersionsubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__CoverageVersion_Type = BaseObject & Object & Owned & Personal & fhir__Coverage & fhir__FHIRResource & fhirext__CoverageExtension & fhirext__CoverageVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__CoverageVersion_Type';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  beneficiary: fhir__Reference;
  class?: Maybe<Array<fhir__CoverageClass>>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  groupId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  kind: fhir__CoverageKind;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  memberId?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  owner: User;
  period?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  relationship?: Maybe<fhir__CodeableConcept>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__FinancialResourceStatus;
  subscriber?: Maybe<fhir__Reference>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__CoverageVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__CoverageVersion_TypebeneficiaryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageVersion_TypeclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoverageClass>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoverageClass>;
};


export type fhirext__CoverageVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__CoverageVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__CoverageVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__CoverageVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__CoverageVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__CoverageVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoverageVersion_TyperelationshipArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__CoverageVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__CoverageVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__CoverageVersion_TypesubscriberArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__CoverageVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__Encounter = {
  __typename: 'fhirext__Encounter';
  actualPeriod?: Maybe<Scalars['JSON']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  class?: Maybe<Array<fhir__Coding>>;
  clinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  diagnosis?: Maybe<Array<fhir__CodeableConcept>>;
  encounterDate: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  location?: Maybe<Array<fhir__Location>>;
  owner: User;
  participant?: Maybe<Array<fhir__EncounterParticipant>>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  subject?: Maybe<fhir__Reference>;
  type?: Maybe<Array<fhir__Coding>>;
};


export type fhirext__EncounterassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__EncounterclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type fhirext__EncounterclinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type fhirext__EncounterdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__EncounterfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__EncounteridentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__EncounteringestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__EncounterlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterlocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type fhirext__EncounterownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__EncounterparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type fhirext__EncounterpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__EncounterrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncountersourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncountersourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncountersubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__EncountertypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhirext__EncounterVersion = {
  actualPeriod?: Maybe<Scalars['JSON']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  class?: Maybe<Array<fhir__Coding>>;
  clinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  diagnosis?: Maybe<Array<fhir__CodeableConcept>>;
  encounterDate: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  location?: Maybe<Array<fhir__Location>>;
  owner: User;
  participant?: Maybe<Array<fhir__EncounterParticipant>>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  subject?: Maybe<fhir__Reference>;
  type?: Maybe<Array<fhir__Coding>>;
};


export type fhirext__EncounterVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__EncounterVersionclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type fhirext__EncounterVersionclinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type fhirext__EncounterVersiondiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__EncounterVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__EncounterVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__EncounterVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__EncounterVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersionlocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type fhirext__EncounterVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__EncounterVersionparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type fhirext__EncounterVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__EncounterVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncounterVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncounterVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersionsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__EncounterVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhirext__EncounterVersion_Type = BaseObject & Object & Owned & Personal & fhir__Encounter & fhir__FHIRResource & fhirext__EncounterVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__EncounterVersion_Type';
  actualPeriod?: Maybe<Scalars['JSON']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  class?: Maybe<Array<fhir__Coding>>;
  clinicalNote?: Maybe<Array<fhir__ClinicalNote>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  diagnosis?: Maybe<Array<fhir__CodeableConcept>>;
  encounterDate: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  location?: Maybe<Array<fhir__Location>>;
  owner: User;
  participant?: Maybe<Array<fhir__EncounterParticipant>>;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  subject?: Maybe<fhir__Reference>;
  type?: Maybe<Array<fhir__Coding>>;
};


export type fhirext__EncounterVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__EncounterVersion_TypeclassArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};


export type fhirext__EncounterVersion_TypeclinicalNoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterClinicalNote>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderClinicalNote>;
};


export type fhirext__EncounterVersion_TypediagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__EncounterVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__EncounterVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__EncounterVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__EncounterVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersion_TypelocationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterLocation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderLocation>;
};


export type fhirext__EncounterVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__EncounterVersion_TypeparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterEncounterParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderEncounterParticipant>;
};


export type fhirext__EncounterVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__EncounterVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncounterVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__EncounterVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__EncounterVersion_TypesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__EncounterVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCoding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCoding>;
};

export type fhirext__ExplanationOfBenefit = {
  __typename: 'fhirext__ExplanationOfBenefit';
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  findings?: Maybe<Array<fhirext__Finding>>;
  hasUserVisibleFindings: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirext__ExplanationOfBenefitassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__ExplanationOfBenefitcareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirext__ExplanationOfBenefitdecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitdiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirext__ExplanationOfBenefitfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__ExplanationOfBenefitidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__ExplanationOfBenefitingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__ExplanationOfBenefititemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirext__ExplanationOfBenefitlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitnetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__ExplanationOfBenefitproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefittotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirext__ExplanationOfBenefittotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirext__ExplanationOfBenefittypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__ExplanationOfBenefitExtension = {
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  provider?: Maybe<fhir__Reference>;
  serviceDate?: Maybe<Scalars['String']['output']>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirext__ExplanationOfBenefitExtensioncareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirext__ExplanationOfBenefitExtensiondecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitExtensiondiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirext__ExplanationOfBenefitExtensionfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitExtensionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__ExplanationOfBenefitExtensionitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirext__ExplanationOfBenefitExtensionnetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitExtensionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitExtensionpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitExtensionproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitExtensiontotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirext__ExplanationOfBenefitExtensiontotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirext__ExplanationOfBenefitExtensiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__ExplanationOfBenefitTotalsByType = {
  benefit?: Maybe<fhir__Money>;
  coinsurance?: Maybe<fhir__Money>;
  copay?: Maybe<fhir__Money>;
  deductible?: Maybe<fhir__Money>;
  discount?: Maybe<fhir__Money>;
  drugCost?: Maybe<fhir__Money>;
  eligible?: Maybe<fhir__Money>;
  id: Scalars['ID']['output'];
  memberLiability?: Maybe<fhir__Money>;
  nonCovered?: Maybe<fhir__Money>;
  owner: User;
  paidByPatient?: Maybe<fhir__Money>;
  paidByPatientCash?: Maybe<fhir__Money>;
  paidByPatientOther?: Maybe<fhir__Money>;
  paidToPatient?: Maybe<fhir__Money>;
  paidToProvider?: Maybe<fhir__Money>;
  priorPayerPaid?: Maybe<fhir__Money>;
  submitted?: Maybe<fhir__Money>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypebenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypecoinsuranceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypecopayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypedeductibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypediscountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypedrugCostArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypeeligibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypememberLiabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypenonCoveredArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidByPatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidByPatientCashArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidByPatientOtherArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidToPatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepaidToProviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypepriorPayerPaidArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByTypesubmittedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__ExplanationOfBenefitTotalsByType_Type = BaseObject & Object & Owned & fhirext__ExplanationOfBenefitTotalsByType & {
  __typename: 'fhirext__ExplanationOfBenefitTotalsByType_Type';
  benefit?: Maybe<fhir__Money>;
  coinsurance?: Maybe<fhir__Money>;
  copay?: Maybe<fhir__Money>;
  deductible?: Maybe<fhir__Money>;
  discount?: Maybe<fhir__Money>;
  drugCost?: Maybe<fhir__Money>;
  eligible?: Maybe<fhir__Money>;
  id: Scalars['ID']['output'];
  memberLiability?: Maybe<fhir__Money>;
  nonCovered?: Maybe<fhir__Money>;
  owner: User;
  paidByPatient?: Maybe<fhir__Money>;
  paidByPatientCash?: Maybe<fhir__Money>;
  paidByPatientOther?: Maybe<fhir__Money>;
  paidToPatient?: Maybe<fhir__Money>;
  paidToProvider?: Maybe<fhir__Money>;
  priorPayerPaid?: Maybe<fhir__Money>;
  submitted?: Maybe<fhir__Money>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypebenefitArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypecoinsuranceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypecopayArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypedeductibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypediscountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypedrugCostArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypeeligibleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypememberLiabilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypenonCoveredArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidByPatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidByPatientCashArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidByPatientOtherArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidToPatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepaidToProviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypepriorPayerPaidArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__ExplanationOfBenefitTotalsByType_TypesubmittedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__ExplanationOfBenefitVersion = {
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  fairMarketValue?: Maybe<Array<FairMarketValueResponse>>;
  findings?: Maybe<Array<fhirext__Finding>>;
  hasUserVisibleFindings: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirext__ExplanationOfBenefitVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__ExplanationOfBenefitVersioncareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirext__ExplanationOfBenefitVersiondecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitVersiondiagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirext__ExplanationOfBenefitVersionfacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__ExplanationOfBenefitVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__ExplanationOfBenefitVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__ExplanationOfBenefitVersionitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirext__ExplanationOfBenefitVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersionnetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitVersionpatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__ExplanationOfBenefitVersionproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersiontotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirext__ExplanationOfBenefitVersiontotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirext__ExplanationOfBenefitVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__ExplanationOfBenefitVersion_Type = BaseObject & Object & Owned & Personal & fhir__ExplanationOfBenefit & fhir__FHIRResource & fhirext__ExplanationOfBenefitExtension & fhirext__ExplanationOfBenefitVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__ExplanationOfBenefitVersion_Type';
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  billablePeriod?: Maybe<Scalars['JSON']['output']>;
  careTeam?: Maybe<Array<fhir__ExplanationOfBenefitCareTeam>>;
  created?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  decision?: Maybe<fhir__CodeableConcept>;
  diagnosis?: Maybe<Array<fhir__ExplanationOfBenefitDiagnosis>>;
  facility?: Maybe<fhir__Reference>;
  fairMarketValue?: Maybe<Array<FairMarketValueResponse>>;
  findings?: Maybe<Array<fhirext__Finding>>;
  hasUserVisibleFindings: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  item?: Maybe<Array<fhir__ExplanationOfBenefitItem>>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  network?: Maybe<fhir__CodeableConcept>;
  owner: User;
  patient?: Maybe<fhir__Reference>;
  person?: Maybe<Person>;
  provider?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__ExplanationOfBenefitStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Array<fhir__ExplanationOfBenefitTotal>>;
  totalsByType?: Maybe<fhirext__ExplanationOfBenefitTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
  use: fhir__ClaimUse;
};


export type fhirext__ExplanationOfBenefitVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__ExplanationOfBenefitVersion_TypecareTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitCareTeam>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitCareTeam>;
};


export type fhirext__ExplanationOfBenefitVersion_TypedecisionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitVersion_TypediagnosisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitDiagnosis>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitDiagnosis>;
};


export type fhirext__ExplanationOfBenefitVersion_TypefacilityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeitemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitItem>;
};


export type fhirext__ExplanationOfBenefitVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersion_TypenetworkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ExplanationOfBenefitVersion_TypepatientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__ExplanationOfBenefitVersion_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__ExplanationOfBenefitVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ExplanationOfBenefitVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ExplanationOfBenefitVersion_TypetotalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterExplanationOfBenefitTotal>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderExplanationOfBenefitTotal>;
};


export type fhirext__ExplanationOfBenefitVersion_TypetotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
};


export type fhirext__ExplanationOfBenefitVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__FilterAccount = {
  and?: InputMaybe<Array<fhirext__FilterAccount>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  balance?: InputMaybe<fhir__NestedFilterAccountBalance>;
  billingStatus?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  calculatedAt?: InputMaybe<FilterString>;
  coverage?: InputMaybe<fhir__NestedFilterReference>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  guarantor?: InputMaybe<fhir__NestedFilterAccountGuarantor>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterAccount>;
  or?: InputMaybe<Array<fhirext__FilterAccount>>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__AccountStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterAccountVersion = {
  and?: InputMaybe<Array<fhirext__FilterAccountVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  balance?: InputMaybe<fhir__NestedFilterAccountBalance>;
  billingStatus?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  calculatedAt?: InputMaybe<FilterString>;
  coverage?: InputMaybe<fhir__NestedFilterReference>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  guarantor?: InputMaybe<fhir__NestedFilterAccountGuarantor>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterAccountVersion>;
  or?: InputMaybe<Array<fhirext__FilterAccountVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__AccountStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterCoverage = {
  and?: InputMaybe<Array<fhirext__FilterCoverage>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isActive?: InputMaybe<FilterBoolean>;
  isLatest?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterCoverage>;
  or?: InputMaybe<Array<fhirext__FilterCoverage>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterCoverageExtension = {
  and?: InputMaybe<Array<fhirext__FilterCoverageExtension>>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  isActive?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterCoverageExtension>;
  or?: InputMaybe<Array<fhirext__FilterCoverageExtension>>;
  owner?: InputMaybe<NestedFilterUser>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterCoverageVersion = {
  and?: InputMaybe<Array<fhirext__FilterCoverageVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isActive?: InputMaybe<FilterBoolean>;
  isLatest?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  not?: InputMaybe<fhirext__FilterCoverageVersion>;
  or?: InputMaybe<Array<fhirext__FilterCoverageVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterEncounter = {
  and?: InputMaybe<Array<fhirext__FilterEncounter>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  class?: InputMaybe<fhir__NestedFilterCoding>;
  clinicalNote?: InputMaybe<fhir__NestedFilterClinicalNote>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  diagnosis?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  encounterDate?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  location?: InputMaybe<fhir__NestedFilterLocation>;
  not?: InputMaybe<fhirext__FilterEncounter>;
  or?: InputMaybe<Array<fhirext__FilterEncounter>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterEncounterParticipant>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceProvider?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCoding>;
};

export type fhirext__FilterEncounterVersion = {
  and?: InputMaybe<Array<fhirext__FilterEncounterVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  class?: InputMaybe<fhir__NestedFilterCoding>;
  clinicalNote?: InputMaybe<fhir__NestedFilterClinicalNote>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  diagnosis?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  encounterDate?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  location?: InputMaybe<fhir__NestedFilterLocation>;
  not?: InputMaybe<fhirext__FilterEncounterVersion>;
  or?: InputMaybe<Array<fhirext__FilterEncounterVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterEncounterParticipant>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceProvider?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCoding>;
};

export type fhirext__FilterExplanationOfBenefit = {
  amountOwed?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<fhirext__FilterExplanationOfBenefit>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  hasUserVisibleFindings?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  not?: InputMaybe<fhirext__FilterExplanationOfBenefit>;
  or?: InputMaybe<Array<fhirext__FilterExplanationOfBenefit>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  person?: InputMaybe<NestedFilterPerson>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirext__FilterExplanationOfBenefitExtension = {
  and?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitExtension>>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  not?: InputMaybe<fhirext__FilterExplanationOfBenefitExtension>;
  or?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitExtension>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  serviceDate?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirext__FilterExplanationOfBenefitTotalsByType = {
  and?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitTotalsByType>>;
  benefit?: InputMaybe<fhir__NestedFilterMoney>;
  coinsurance?: InputMaybe<fhir__NestedFilterMoney>;
  copay?: InputMaybe<fhir__NestedFilterMoney>;
  deductible?: InputMaybe<fhir__NestedFilterMoney>;
  discount?: InputMaybe<fhir__NestedFilterMoney>;
  drugCost?: InputMaybe<fhir__NestedFilterMoney>;
  eligible?: InputMaybe<fhir__NestedFilterMoney>;
  id?: InputMaybe<FilterID>;
  memberLiability?: InputMaybe<fhir__NestedFilterMoney>;
  nonCovered?: InputMaybe<fhir__NestedFilterMoney>;
  not?: InputMaybe<fhirext__FilterExplanationOfBenefitTotalsByType>;
  or?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitTotalsByType>>;
  owner?: InputMaybe<NestedFilterUser>;
  paidByPatient?: InputMaybe<fhir__NestedFilterMoney>;
  paidByPatientCash?: InputMaybe<fhir__NestedFilterMoney>;
  paidByPatientOther?: InputMaybe<fhir__NestedFilterMoney>;
  paidToPatient?: InputMaybe<fhir__NestedFilterMoney>;
  paidToProvider?: InputMaybe<fhir__NestedFilterMoney>;
  priorPayerPaid?: InputMaybe<fhir__NestedFilterMoney>;
  submitted?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhirext__FilterExplanationOfBenefitVersion = {
  amountOwed?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  hasUserVisibleFindings?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  not?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  or?: InputMaybe<Array<fhirext__FilterExplanationOfBenefitVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  person?: InputMaybe<NestedFilterPerson>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirext__FilterFinding = {
  and?: InputMaybe<Array<fhirext__FilterFinding>>;
  confidence?: InputMaybe<FilterDecimal>;
  createdAt?: InputMaybe<FilterString>;
  details?: InputMaybe<FilterJSON>;
  explanation?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  lastReviewStatus?: InputMaybe<Filterfhirext__ReviewStatus>;
  not?: InputMaybe<fhirext__FilterFinding>;
  note?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<fhirext__FilterFinding>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  reviews?: InputMaybe<fhirext__NestedFilterFindingReview>;
  type?: InputMaybe<Filterfhirext__FindingType>;
  userDismissed?: InputMaybe<FilterBoolean>;
  userNotified?: InputMaybe<FilterBoolean>;
};

export type fhirext__FilterFindingReview = {
  and?: InputMaybe<Array<fhirext__FilterFindingReview>>;
  createdAt?: InputMaybe<FilterString>;
  finding?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirext__FilterFindingReview>;
  note?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<fhirext__FilterFindingReview>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  reviewer?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<Filterfhirext__ReviewStatus>;
};

export type fhirext__FilterInvoice = {
  account?: InputMaybe<fhir__NestedFilterReference>;
  amountOwed?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<fhirext__FilterInvoice>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  creation?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  issuer?: InputMaybe<fhir__NestedFilterReference>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  lineItem?: InputMaybe<fhir__NestedFilterInvoiceLineItem>;
  not?: InputMaybe<fhirext__FilterInvoice>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  or?: InputMaybe<Array<fhirext__FilterInvoice>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterInvoiceParticipant>;
  paymentTerms?: InputMaybe<FilterString>;
  person?: InputMaybe<NestedFilterPerson>;
  recipient?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__InvoiceStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  title?: InputMaybe<FilterString>;
  totalGross?: InputMaybe<fhir__NestedFilterMoney>;
  totalNet?: InputMaybe<fhir__NestedFilterMoney>;
  totalsByType?: InputMaybe<fhirext__NestedFilterInvoiceTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterInvoiceTotalsByType = {
  and?: InputMaybe<Array<fhirext__FilterInvoiceTotalsByType>>;
  base?: InputMaybe<fhir__NestedFilterMoney>;
  deduction?: InputMaybe<fhir__NestedFilterMoney>;
  discount?: InputMaybe<fhir__NestedFilterMoney>;
  gross?: InputMaybe<fhir__NestedFilterMoney>;
  id?: InputMaybe<FilterID>;
  informational?: InputMaybe<fhir__NestedFilterMoney>;
  net?: InputMaybe<fhir__NestedFilterMoney>;
  not?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  or?: InputMaybe<Array<fhirext__FilterInvoiceTotalsByType>>;
  owner?: InputMaybe<NestedFilterUser>;
  surcharge?: InputMaybe<fhir__NestedFilterMoney>;
  tax?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhirext__FilterInvoiceVersion = {
  account?: InputMaybe<fhir__NestedFilterReference>;
  amountOwed?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<fhirext__FilterInvoiceVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  creation?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  issuer?: InputMaybe<fhir__NestedFilterReference>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  lineItem?: InputMaybe<fhir__NestedFilterInvoiceLineItem>;
  not?: InputMaybe<fhirext__FilterInvoiceVersion>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  or?: InputMaybe<Array<fhirext__FilterInvoiceVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterInvoiceParticipant>;
  paymentTerms?: InputMaybe<FilterString>;
  person?: InputMaybe<NestedFilterPerson>;
  recipient?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__InvoiceStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  title?: InputMaybe<FilterString>;
  totalGross?: InputMaybe<fhir__NestedFilterMoney>;
  totalNet?: InputMaybe<fhir__NestedFilterMoney>;
  totalsByType?: InputMaybe<fhirext__NestedFilterInvoiceTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__FilterPatient = {
  and?: InputMaybe<Array<fhirext__FilterPatient>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  birthDate?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhirext__FilterPatient>;
  or?: InputMaybe<Array<fhirext__FilterPatient>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
};

export type fhirext__FilterPatientVersion = {
  and?: InputMaybe<Array<fhirext__FilterPatientVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  birthDate?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhirext__FilterPatientVersion>;
  or?: InputMaybe<Array<fhirext__FilterPatientVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
};

export type fhirext__FilterPractitioner = {
  and?: InputMaybe<Array<fhirext__FilterPractitioner>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhirext__FilterPractitioner>;
  or?: InputMaybe<Array<fhirext__FilterPractitioner>>;
  owner?: InputMaybe<NestedFilterUser>;
  primaryEmail?: InputMaybe<FilterString>;
  primaryPhoneNumber?: InputMaybe<FilterString>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  telecom?: InputMaybe<fhir__NestedFilterContactPoint>;
};

export type fhirext__FilterPractitionerVersion = {
  and?: InputMaybe<Array<fhirext__FilterPractitionerVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<fhir__NestedFilterHumanName>;
  not?: InputMaybe<fhirext__FilterPractitionerVersion>;
  or?: InputMaybe<Array<fhirext__FilterPractitionerVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  primaryEmail?: InputMaybe<FilterString>;
  primaryPhoneNumber?: InputMaybe<FilterString>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  telecom?: InputMaybe<fhir__NestedFilterContactPoint>;
};

export type fhirext__FilterResourceAssociation = {
  and?: InputMaybe<Array<fhirext__FilterResourceAssociation>>;
  confidence?: InputMaybe<FilterDecimal>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirext__FilterResourceAssociation>;
  or?: InputMaybe<Array<fhirext__FilterResourceAssociation>>;
  owner?: InputMaybe<NestedFilterUser>;
  source?: InputMaybe<FilterID>;
  sourceType?: InputMaybe<Filterfhirext__ResourceType>;
  target?: InputMaybe<FilterID>;
  targetType?: InputMaybe<Filterfhirext__ResourceType>;
  type?: InputMaybe<FilterString>;
};

export type fhirext__FilterResourceIdentifier = {
  and?: InputMaybe<Array<fhirext__FilterResourceIdentifier>>;
  hash?: InputMaybe<FilterString>;
  hashInput?: InputMaybe<FilterJSON>;
  hashVersion?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<fhirext__FilterResourceIdentifier>;
  or?: InputMaybe<Array<fhirext__FilterResourceIdentifier>>;
  owner?: InputMaybe<NestedFilterUser>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceOrganization?: InputMaybe<integration__NestedFilterOrganization>;
};

export type fhirext__FilterResourceVersion = {
  and?: InputMaybe<Array<fhirext__FilterResourceVersion>>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  not?: InputMaybe<fhirext__FilterResourceVersion>;
  or?: InputMaybe<Array<fhirext__FilterResourceVersion>>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
};

export type fhirext__Finding = {
  confidence?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastReviewStatus?: Maybe<fhirext__ReviewStatus>;
  note?: Maybe<Scalars['String']['output']>;
  owner: User;
  participant: Participant;
  resource: fhirext__ResourceVersion;
  reviews?: Maybe<Array<fhirext__FindingReview>>;
  type: fhirext__FindingType;
  userDismissed: Scalars['Boolean']['output'];
  userNotified: Scalars['Boolean']['output'];
};


export type fhirext__FindingownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__FindingresourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__FindingreviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFindingReview>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFindingReview>;
};

export type fhirext__FindingReview = {
  createdAt: Scalars['String']['output'];
  finding: fhirext__Finding;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  owner: User;
  participant: Participant;
  reviewer?: Maybe<User>;
  status: fhirext__ReviewStatus;
};


export type fhirext__FindingReviewfindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__FindingReviewownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__FindingReviewreviewerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirext__FindingReview_Type = BaseObject & Object & Owned & fhirext__FindingReview & {
  __typename: 'fhirext__FindingReview_Type';
  createdAt: Scalars['String']['output'];
  finding: fhirext__Finding;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  owner: User;
  participant: Participant;
  reviewer?: Maybe<User>;
  status: fhirext__ReviewStatus;
};


export type fhirext__FindingReview_TypefindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__FindingReview_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__FindingReview_TypereviewerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum fhirext__FindingType {
  CATEGORY_TOTALS_MISMATCH = 'CATEGORY_TOTALS_MISMATCH',
  DENIAL = 'DENIAL',
  EOB_HIGH_TOTAL_VALUE = 'EOB_HIGH_TOTAL_VALUE',
  EOB_TOTALS_INVALID = 'EOB_TOTALS_INVALID',
  EOB_TOTAL_MISMATCH = 'EOB_TOTAL_MISMATCH',
  HIGH_TOTAL = 'HIGH_TOTAL',
  LINE_ITEM_TOTALS_MISMATCH = 'LINE_ITEM_TOTALS_MISMATCH',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK'
}

export type fhirext__Finding_Type = BaseObject & Object & Owned & fhirext__Finding & {
  __typename: 'fhirext__Finding_Type';
  confidence?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastReviewStatus?: Maybe<fhirext__ReviewStatus>;
  note?: Maybe<Scalars['String']['output']>;
  owner: User;
  participant: Participant;
  resource: fhirext__ResourceVersion;
  reviews?: Maybe<Array<fhirext__FindingReview>>;
  type: fhirext__FindingType;
  userDismissed: Scalars['Boolean']['output'];
  userNotified: Scalars['Boolean']['output'];
};


export type fhirext__Finding_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__Finding_TyperesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__Finding_TypereviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFindingReview>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFindingReview>;
};

export type fhirext__Invoice = {
  __typename: 'fhirext__Invoice';
  account?: Maybe<fhir__Reference>;
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  creation?: Maybe<Scalars['String']['output']>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  issuer?: Maybe<fhir__Reference>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  lineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  note?: Maybe<Array<fhir__Annotation>>;
  owner: User;
  participant?: Maybe<Array<fhir__InvoiceParticipant>>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  periodPeriod?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  recipient?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__InvoiceStatus;
  subject?: Maybe<fhir__Reference>;
  title?: Maybe<Scalars['String']['output']>;
  totalGross?: Maybe<fhir__Money>;
  totalNet?: Maybe<fhir__Money>;
  totalsByType?: Maybe<fhirext__InvoiceTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__InvoiceaccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__InvoicefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__InvoiceidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__InvoiceingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__InvoiceissuerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoicelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoicelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoicelineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type fhirext__InvoicenoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhirext__InvoiceownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type fhirext__InvoicepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__InvoicerecipientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoicerelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoicesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoicesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoicesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoicetotalGrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoicetotalNetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoicetotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
};


export type fhirext__InvoicetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__InvoiceTotalsByType = {
  base?: Maybe<fhir__Money>;
  deduction?: Maybe<fhir__Money>;
  discount?: Maybe<fhir__Money>;
  gross?: Maybe<fhir__Money>;
  id: Scalars['ID']['output'];
  informational?: Maybe<fhir__Money>;
  net?: Maybe<fhir__Money>;
  owner: User;
  surcharge?: Maybe<fhir__Money>;
  tax?: Maybe<fhir__Money>;
};


export type fhirext__InvoiceTotalsByTypebaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypedeductionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypediscountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypegrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypeinformationalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypenetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceTotalsByTypesurchargeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByTypetaxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__InvoiceTotalsByType_Type = BaseObject & Object & Owned & fhirext__InvoiceTotalsByType & {
  __typename: 'fhirext__InvoiceTotalsByType_Type';
  base?: Maybe<fhir__Money>;
  deduction?: Maybe<fhir__Money>;
  discount?: Maybe<fhir__Money>;
  gross?: Maybe<fhir__Money>;
  id: Scalars['ID']['output'];
  informational?: Maybe<fhir__Money>;
  net?: Maybe<fhir__Money>;
  owner: User;
  surcharge?: Maybe<fhir__Money>;
  tax?: Maybe<fhir__Money>;
};


export type fhirext__InvoiceTotalsByType_TypebaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypedeductionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypediscountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypegrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypeinformationalArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypenetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceTotalsByType_TypesurchargeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceTotalsByType_TypetaxArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__InvoiceVersion = {
  account?: Maybe<fhir__Reference>;
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  creation?: Maybe<Scalars['String']['output']>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  issuer?: Maybe<fhir__Reference>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  lineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  note?: Maybe<Array<fhir__Annotation>>;
  owner: User;
  participant?: Maybe<Array<fhir__InvoiceParticipant>>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  periodPeriod?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  recipient?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__InvoiceStatus;
  subject?: Maybe<fhir__Reference>;
  title?: Maybe<Scalars['String']['output']>;
  totalGross?: Maybe<fhir__Money>;
  totalNet?: Maybe<fhir__Money>;
  totalsByType?: Maybe<fhirext__InvoiceTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__InvoiceVersionaccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__InvoiceVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__InvoiceVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__InvoiceVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__InvoiceVersionissuerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersionlineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type fhirext__InvoiceVersionnoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhirext__InvoiceVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceVersionparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type fhirext__InvoiceVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__InvoiceVersionrecipientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoiceVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoiceVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersionsubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersiontotalGrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceVersiontotalNetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceVersiontotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
};


export type fhirext__InvoiceVersiontypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__InvoiceVersion_Type = BaseObject & Object & Owned & Personal & fhir__FHIRResource & fhir__Invoice & fhirext__InvoiceVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__InvoiceVersion_Type';
  account?: Maybe<fhir__Reference>;
  amountOwed?: Maybe<Scalars['Decimal']['output']>;
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  creation?: Maybe<Scalars['String']['output']>;
  currentAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  issuer?: Maybe<fhir__Reference>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  lineItem?: Maybe<Array<fhir__InvoiceLineItem>>;
  note?: Maybe<Array<fhir__Annotation>>;
  owner: User;
  participant?: Maybe<Array<fhir__InvoiceParticipant>>;
  paymentTerms?: Maybe<Scalars['String']['output']>;
  periodPeriod?: Maybe<Scalars['JSON']['output']>;
  person?: Maybe<Person>;
  recipient?: Maybe<fhir__Reference>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  serviceDate?: Maybe<Scalars['String']['output']>;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  status: fhir__InvoiceStatus;
  subject?: Maybe<fhir__Reference>;
  title?: Maybe<Scalars['String']['output']>;
  totalGross?: Maybe<fhir__Money>;
  totalNet?: Maybe<fhir__Money>;
  totalsByType?: Maybe<fhirext__InvoiceTotalsByType>;
  type?: Maybe<fhir__CodeableConcept>;
};


export type fhirext__InvoiceVersion_TypeaccountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__InvoiceVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__InvoiceVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__InvoiceVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__InvoiceVersion_TypeissuerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersion_TypelineItemArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceLineItem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceLineItem>;
};


export type fhirext__InvoiceVersion_TypenoteArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterAnnotation>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderAnnotation>;
};


export type fhirext__InvoiceVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__InvoiceVersion_TypeparticipantArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterInvoiceParticipant>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderInvoiceParticipant>;
};


export type fhirext__InvoiceVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__InvoiceVersion_TyperecipientArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoiceVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__InvoiceVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__InvoiceVersion_TypesubjectArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterReference>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderReference>;
};


export type fhirext__InvoiceVersion_TypetotalGrossArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceVersion_TypetotalNetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterMoney>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderMoney>;
};


export type fhirext__InvoiceVersion_TypetotalsByTypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceTotalsByType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
};


export type fhirext__InvoiceVersion_TypetypeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterCodeableConcept>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__NestedFilterAccountVersion = {
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  balance?: InputMaybe<fhir__NestedFilterAccountBalance>;
  billingStatus?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  calculatedAt?: InputMaybe<FilterString>;
  coverage?: InputMaybe<fhir__NestedFilterReference>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  guarantor?: InputMaybe<fhir__NestedFilterAccountGuarantor>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  name?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__AccountStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__NestedFilterCoverageVersion = {
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  beneficiary?: InputMaybe<fhir__NestedFilterReference>;
  class?: InputMaybe<fhir__NestedFilterCoverageClass>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  groupId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isActive?: InputMaybe<FilterBoolean>;
  isLatest?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterfhir__CoverageKind>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  memberId?: InputMaybe<FilterString>;
  network?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  person?: InputMaybe<NestedFilterPerson>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  relationship?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__FinancialResourceStatus>;
  subscriber?: InputMaybe<fhir__NestedFilterReference>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__NestedFilterExplanationOfBenefitTotalsByType = {
  benefit?: InputMaybe<fhir__NestedFilterMoney>;
  coinsurance?: InputMaybe<fhir__NestedFilterMoney>;
  copay?: InputMaybe<fhir__NestedFilterMoney>;
  deductible?: InputMaybe<fhir__NestedFilterMoney>;
  discount?: InputMaybe<fhir__NestedFilterMoney>;
  drugCost?: InputMaybe<fhir__NestedFilterMoney>;
  eligible?: InputMaybe<fhir__NestedFilterMoney>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  memberLiability?: InputMaybe<fhir__NestedFilterMoney>;
  nonCovered?: InputMaybe<fhir__NestedFilterMoney>;
  owner?: InputMaybe<NestedFilterUser>;
  paidByPatient?: InputMaybe<fhir__NestedFilterMoney>;
  paidByPatientCash?: InputMaybe<fhir__NestedFilterMoney>;
  paidByPatientOther?: InputMaybe<fhir__NestedFilterMoney>;
  paidToPatient?: InputMaybe<fhir__NestedFilterMoney>;
  paidToProvider?: InputMaybe<fhir__NestedFilterMoney>;
  priorPayerPaid?: InputMaybe<fhir__NestedFilterMoney>;
  submitted?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhirext__NestedFilterExplanationOfBenefitVersion = {
  amountOwed?: InputMaybe<FilterDecimal>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  careTeam?: InputMaybe<fhir__NestedFilterExplanationOfBenefitCareTeam>;
  created?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  decision?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  diagnosis?: InputMaybe<fhir__NestedFilterExplanationOfBenefitDiagnosis>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  facility?: InputMaybe<fhir__NestedFilterReference>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  hasUserVisibleFindings?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  item?: InputMaybe<fhir__NestedFilterExplanationOfBenefitItem>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  network?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  owner?: InputMaybe<NestedFilterUser>;
  patient?: InputMaybe<fhir__NestedFilterReference>;
  person?: InputMaybe<NestedFilterPerson>;
  provider?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__ExplanationOfBenefitStatus>;
  summary?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  total?: InputMaybe<fhir__NestedFilterExplanationOfBenefitTotal>;
  totalsByType?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
  use?: InputMaybe<Filterfhir__ClaimUse>;
};

export type fhirext__NestedFilterFinding = {
  confidence?: InputMaybe<FilterDecimal>;
  createdAt?: InputMaybe<FilterString>;
  details?: InputMaybe<FilterJSON>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  explanation?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  lastReviewStatus?: InputMaybe<Filterfhirext__ReviewStatus>;
  note?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  reviews?: InputMaybe<fhirext__NestedFilterFindingReview>;
  type?: InputMaybe<Filterfhirext__FindingType>;
  userDismissed?: InputMaybe<FilterBoolean>;
  userNotified?: InputMaybe<FilterBoolean>;
};

export type fhirext__NestedFilterFindingReview = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  finding?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  note?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<FilterParticipant>;
  reviewer?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<Filterfhirext__ReviewStatus>;
};

export type fhirext__NestedFilterInvoiceTotalsByType = {
  base?: InputMaybe<fhir__NestedFilterMoney>;
  deduction?: InputMaybe<fhir__NestedFilterMoney>;
  discount?: InputMaybe<fhir__NestedFilterMoney>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gross?: InputMaybe<fhir__NestedFilterMoney>;
  id?: InputMaybe<FilterID>;
  informational?: InputMaybe<fhir__NestedFilterMoney>;
  net?: InputMaybe<fhir__NestedFilterMoney>;
  owner?: InputMaybe<NestedFilterUser>;
  surcharge?: InputMaybe<fhir__NestedFilterMoney>;
  tax?: InputMaybe<fhir__NestedFilterMoney>;
};

export type fhirext__NestedFilterInvoiceVersion = {
  account?: InputMaybe<fhir__NestedFilterReference>;
  amountOwed?: InputMaybe<FilterDecimal>;
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  creation?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  identifier?: InputMaybe<fhir__NestedFilterIdentifier>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  issuer?: InputMaybe<fhir__NestedFilterReference>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  lineItem?: InputMaybe<fhir__NestedFilterInvoiceLineItem>;
  note?: InputMaybe<fhir__NestedFilterAnnotation>;
  owner?: InputMaybe<NestedFilterUser>;
  participant?: InputMaybe<fhir__NestedFilterInvoiceParticipant>;
  paymentTerms?: InputMaybe<FilterString>;
  person?: InputMaybe<NestedFilterPerson>;
  recipient?: InputMaybe<fhir__NestedFilterReference>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  serviceDate?: InputMaybe<FilterString>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
  status?: InputMaybe<Filterfhir__InvoiceStatus>;
  subject?: InputMaybe<fhir__NestedFilterReference>;
  title?: InputMaybe<FilterString>;
  totalGross?: InputMaybe<fhir__NestedFilterMoney>;
  totalNet?: InputMaybe<fhir__NestedFilterMoney>;
  totalsByType?: InputMaybe<fhirext__NestedFilterInvoiceTotalsByType>;
  type?: InputMaybe<fhir__NestedFilterCodeableConcept>;
};

export type fhirext__NestedFilterResourceVersion = {
  associations?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  createdAt?: InputMaybe<FilterString>;
  currentAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  findings?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  isLatest?: InputMaybe<FilterBoolean>;
  latestJsonExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  latestLlmExtract?: InputMaybe<ingestion__NestedFilterExtract>;
  owner?: InputMaybe<NestedFilterUser>;
  relatedDocuments?: InputMaybe<document__NestedFilterDocument>;
  resourceId?: InputMaybe<FilterID>;
  resourceType?: InputMaybe<Filterfhirext__ResourceType>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceExtracts?: InputMaybe<ingestion__NestedFilterExtract>;
};

export type fhirext__OrderAccount = {
  balance?: InputMaybe<fhir__OrderAccountBalance>;
  billingStatus?: InputMaybe<fhir__OrderCodeableConcept>;
  calculatedAt?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currency?: InputMaybe<fhir__OrderCodeableConcept>;
  currentAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  name?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderAccountVersion = {
  balance?: InputMaybe<fhir__OrderAccountBalance>;
  billingStatus?: InputMaybe<fhir__OrderCodeableConcept>;
  calculatedAt?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currency?: InputMaybe<fhir__OrderCodeableConcept>;
  currentAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  name?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderCoverage = {
  beneficiary?: InputMaybe<fhir__OrderReference>;
  coverageType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isActive?: InputMaybe<Ordering>;
  isLatest?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  memberId?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderCoverageExtension = {
  beneficiary?: InputMaybe<fhir__OrderReference>;
  coverageType?: InputMaybe<Ordering>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  memberId?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderCoverageVersion = {
  beneficiary?: InputMaybe<fhir__OrderReference>;
  coverageType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  groupId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isActive?: InputMaybe<Ordering>;
  isLatest?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  memberId?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  relationship?: InputMaybe<fhir__OrderCodeableConcept>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  subscriber?: InputMaybe<fhir__OrderReference>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderEncounter = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  encounterDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceProvider?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  subject?: InputMaybe<fhir__OrderReference>;
};

export type fhirext__OrderEncounterVersion = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  encounterDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceProvider?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  subject?: InputMaybe<fhir__OrderReference>;
};

export type fhirext__OrderExplanationOfBenefit = {
  amountOwed?: InputMaybe<Ordering>;
  created?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  facility?: InputMaybe<fhir__OrderReference>;
  hasUserVisibleFindings?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  network?: InputMaybe<fhir__OrderCodeableConcept>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  person?: InputMaybe<OrderPerson>;
  provider?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  totalsByType?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhirext__OrderExplanationOfBenefitExtension = {
  created?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  facility?: InputMaybe<fhir__OrderReference>;
  id?: InputMaybe<Ordering>;
  network?: InputMaybe<fhir__OrderCodeableConcept>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  provider?: InputMaybe<fhir__OrderReference>;
  serviceDate?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  totalsByType?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhirext__OrderExplanationOfBenefitTotalsByType = {
  benefit?: InputMaybe<fhir__OrderMoney>;
  coinsurance?: InputMaybe<fhir__OrderMoney>;
  copay?: InputMaybe<fhir__OrderMoney>;
  deductible?: InputMaybe<fhir__OrderMoney>;
  discount?: InputMaybe<fhir__OrderMoney>;
  drugCost?: InputMaybe<fhir__OrderMoney>;
  eligible?: InputMaybe<fhir__OrderMoney>;
  id?: InputMaybe<Ordering>;
  memberLiability?: InputMaybe<fhir__OrderMoney>;
  nonCovered?: InputMaybe<fhir__OrderMoney>;
  owner?: InputMaybe<OrderUser>;
  paidByPatient?: InputMaybe<fhir__OrderMoney>;
  paidByPatientCash?: InputMaybe<fhir__OrderMoney>;
  paidByPatientOther?: InputMaybe<fhir__OrderMoney>;
  paidToPatient?: InputMaybe<fhir__OrderMoney>;
  paidToProvider?: InputMaybe<fhir__OrderMoney>;
  priorPayerPaid?: InputMaybe<fhir__OrderMoney>;
  submitted?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__OrderExplanationOfBenefitVersion = {
  amountOwed?: InputMaybe<Ordering>;
  created?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  decision?: InputMaybe<fhir__OrderCodeableConcept>;
  facility?: InputMaybe<fhir__OrderReference>;
  hasUserVisibleFindings?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  network?: InputMaybe<fhir__OrderCodeableConcept>;
  owner?: InputMaybe<OrderUser>;
  patient?: InputMaybe<fhir__OrderReference>;
  person?: InputMaybe<OrderPerson>;
  provider?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  totalsByType?: InputMaybe<fhirext__OrderExplanationOfBenefitTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
  use?: InputMaybe<Ordering>;
};

export type fhirext__OrderFinding = {
  confidence?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  details?: InputMaybe<Ordering>;
  explanation?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastReviewStatus?: InputMaybe<Ordering>;
  note?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  participant?: InputMaybe<Ordering>;
  resource?: InputMaybe<fhirext__OrderResourceVersion>;
  type?: InputMaybe<Ordering>;
  userDismissed?: InputMaybe<Ordering>;
  userNotified?: InputMaybe<Ordering>;
};

export type fhirext__OrderFindingReview = {
  createdAt?: InputMaybe<Ordering>;
  finding?: InputMaybe<fhirext__OrderFinding>;
  id?: InputMaybe<Ordering>;
  note?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  participant?: InputMaybe<Ordering>;
  reviewer?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
};

export type fhirext__OrderInvoice = {
  account?: InputMaybe<fhir__OrderReference>;
  amountOwed?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  creation?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  issuer?: InputMaybe<fhir__OrderReference>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  paymentTerms?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  recipient?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
  title?: InputMaybe<Ordering>;
  totalGross?: InputMaybe<fhir__OrderMoney>;
  totalNet?: InputMaybe<fhir__OrderMoney>;
  totalsByType?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderInvoiceTotalsByType = {
  base?: InputMaybe<fhir__OrderMoney>;
  deduction?: InputMaybe<fhir__OrderMoney>;
  discount?: InputMaybe<fhir__OrderMoney>;
  gross?: InputMaybe<fhir__OrderMoney>;
  id?: InputMaybe<Ordering>;
  informational?: InputMaybe<fhir__OrderMoney>;
  net?: InputMaybe<fhir__OrderMoney>;
  owner?: InputMaybe<OrderUser>;
  surcharge?: InputMaybe<fhir__OrderMoney>;
  tax?: InputMaybe<fhir__OrderMoney>;
};

export type fhirext__OrderInvoiceVersion = {
  account?: InputMaybe<fhir__OrderReference>;
  amountOwed?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  creation?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  issuer?: InputMaybe<fhir__OrderReference>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  paymentTerms?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  recipient?: InputMaybe<fhir__OrderReference>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  serviceDate?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
  subject?: InputMaybe<fhir__OrderReference>;
  title?: InputMaybe<Ordering>;
  totalGross?: InputMaybe<fhir__OrderMoney>;
  totalNet?: InputMaybe<fhir__OrderMoney>;
  totalsByType?: InputMaybe<fhirext__OrderInvoiceTotalsByType>;
  type?: InputMaybe<fhir__OrderCodeableConcept>;
};

export type fhirext__OrderPatient = {
  birthDate?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__OrderPatientVersion = {
  birthDate?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  person?: InputMaybe<OrderPerson>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__OrderPractitioner = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  primaryEmail?: InputMaybe<Ordering>;
  primaryPhoneNumber?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__OrderPractitionerVersion = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  primaryEmail?: InputMaybe<Ordering>;
  primaryPhoneNumber?: InputMaybe<Ordering>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__OrderResourceAssociation = {
  confidence?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  source?: InputMaybe<Ordering>;
  sourceType?: InputMaybe<Ordering>;
  target?: InputMaybe<Ordering>;
  targetType?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type fhirext__OrderResourceIdentifier = {
  hash?: InputMaybe<Ordering>;
  hashInput?: InputMaybe<Ordering>;
  hashVersion?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceOrganization?: InputMaybe<integration__OrderOrganization>;
};

export type fhirext__OrderResourceVersion = {
  createdAt?: InputMaybe<Ordering>;
  currentAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  isLatest?: InputMaybe<Ordering>;
  latestJsonExtract?: InputMaybe<ingestion__OrderExtract>;
  latestLlmExtract?: InputMaybe<ingestion__OrderExtract>;
  owner?: InputMaybe<OrderUser>;
  resourceId?: InputMaybe<Ordering>;
  resourceType?: InputMaybe<Ordering>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
};

export type fhirext__Patient = {
  __typename: 'fhirext__Patient';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
};


export type fhirext__PatientassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PatientfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PatientidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PatientingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PatientlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientnameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PatientownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PatientpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__PatientrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};

export type fhirext__PatientVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
};


export type fhirext__PatientVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PatientVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PatientVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PatientVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PatientVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientVersionnameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PatientVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PatientVersionpersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__PatientVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};

export type fhirext__PatientVersion_Type = BaseObject & Object & Owned & Personal & fhir__FHIRResource & fhir__Patient & fhirext__PatientVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__PatientVersion_Type';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  birthDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  person?: Maybe<Person>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
};


export type fhirext__PatientVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PatientVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PatientVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PatientVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PatientVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PatientVersion_TypenameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PatientVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PatientVersion_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type fhirext__PatientVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PatientVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};

export type fhirext__Practitioner = {
  __typename: 'fhirext__Practitioner';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  telecom?: Maybe<Array<fhir__ContactPoint>>;
};


export type fhirext__PractitionerassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PractitionerfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PractitioneridentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PractitioneringestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PractitionerlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionernameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PractitionerownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PractitionerrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionersourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionersourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionertelecomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};

export type fhirext__PractitionerVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  telecom?: Maybe<Array<fhir__ContactPoint>>;
};


export type fhirext__PractitionerVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PractitionerVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PractitionerVersionidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PractitionerVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PractitionerVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersionnameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PractitionerVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PractitionerVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionerVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionerVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersiontelecomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};

export type fhirext__PractitionerVersion_Type = BaseObject & Object & Owned & fhir__FHIRResource & fhir__Practitioner & fhirext__PractitionerVersion & fhirext__ResourceVersion & {
  __typename: 'fhirext__PractitionerVersion_Type';
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Array<fhir__Identifier>>;
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  name?: Maybe<Array<fhir__HumanName>>;
  owner: User;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
  telecom?: Maybe<Array<fhir__ContactPoint>>;
};


export type fhirext__PractitionerVersion_TypeassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__PractitionerVersion_TypefindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__PractitionerVersion_TypeidentifierArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterIdentifier>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderIdentifier>;
};


export type fhirext__PractitionerVersion_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__PractitionerVersion_TypelatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersion_TypelatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersion_TypenameArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterHumanName>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderHumanName>;
};


export type fhirext__PractitionerVersion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__PractitionerVersion_TyperelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionerVersion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__PractitionerVersion_TypesourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__PractitionerVersion_TypetelecomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhir__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhir__OrderContactPoint>;
};

export type fhirext__ResourceAssociation = {
  confidence?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  evidences?: Maybe<Array<Scalars['JSON']['output']>>;
  id: Scalars['ID']['output'];
  owner: User;
  source: Scalars['ID']['output'];
  sourceType: fhirext__ResourceType;
  target: Scalars['ID']['output'];
  targetType: fhirext__ResourceType;
  type: Scalars['String']['output'];
};


export type fhirext__ResourceAssociationownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirext__ResourceAssociation_Type = BaseObject & Object & Owned & fhirext__ResourceAssociation & {
  __typename: 'fhirext__ResourceAssociation_Type';
  confidence?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  evidences?: Maybe<Array<Scalars['JSON']['output']>>;
  id: Scalars['ID']['output'];
  owner: User;
  source: Scalars['ID']['output'];
  sourceType: fhirext__ResourceType;
  target: Scalars['ID']['output'];
  targetType: fhirext__ResourceType;
  type: Scalars['String']['output'];
};


export type fhirext__ResourceAssociation_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type fhirext__ResourceIdentifier = {
  hash: Scalars['String']['output'];
  hashInput: Scalars['JSON']['output'];
  hashVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceOrganization?: Maybe<integration__Organization>;
};


export type fhirext__ResourceIdentifierownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ResourceIdentifiersourceOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type fhirext__ResourceIdentifier_Type = BaseObject & Object & Owned & fhirext__ResourceIdentifier & {
  __typename: 'fhirext__ResourceIdentifier_Type';
  hash: Scalars['String']['output'];
  hashInput: Scalars['JSON']['output'];
  hashVersion: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceOrganization?: Maybe<integration__Organization>;
};


export type fhirext__ResourceIdentifier_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ResourceIdentifier_TypesourceOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export enum fhirext__ResourceType {
  ACCOUNT = 'ACCOUNT',
  COVERAGE = 'COVERAGE',
  ENCOUNTER = 'ENCOUNTER',
  EXPLANATION_OF_BENEFIT = 'EXPLANATION_OF_BENEFIT',
  INVOICE = 'INVOICE',
  PATIENT = 'PATIENT',
  PRACTITIONER = 'PRACTITIONER'
}

export type fhirext__ResourceVersion = {
  associations?: Maybe<Array<fhirext__ResourceVersion>>;
  createdAt: Scalars['String']['output'];
  currentAt: Scalars['String']['output'];
  findings?: Maybe<Array<fhirext__Finding>>;
  id: Scalars['ID']['output'];
  ingestion?: Maybe<ingestion__Ingestion>;
  isLatest?: Maybe<Scalars['Boolean']['output']>;
  latestJsonExtract?: Maybe<ingestion__Extract>;
  latestLlmExtract?: Maybe<ingestion__Extract>;
  owner: User;
  relatedDocuments?: Maybe<Array<document__Document>>;
  resourceId: Scalars['ID']['output'];
  resourceType: fhirext__ResourceType;
  sourceDocument?: Maybe<document__Document>;
  sourceExtracts?: Maybe<Array<ingestion__Extract>>;
};


export type fhirext__ResourceVersionassociationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type fhirext__ResourceVersionfindingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};


export type fhirext__ResourceVersioningestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type fhirext__ResourceVersionlatestJsonExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ResourceVersionlatestLlmExtractArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};


export type fhirext__ResourceVersionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type fhirext__ResourceVersionrelatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ResourceVersionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type fhirext__ResourceVersionsourceExtractsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterExtract>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderExtract>;
};

export enum fhirext__ReviewStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED'
}

export type flexpa__Endpoint = {
  displayName?: Maybe<Scalars['String']['output']>;
  externalIds: Array<Scalars['JSON']['output']>;
  flexpaId: Scalars['String']['output'];
  flexpaOrganization?: Maybe<flexpa__Organization>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label?: Maybe<Array<Scalars['String']['output']>>;
  metadata: Array<Scalars['JSON']['output']>;
  mode: flexpa__EndpointMode;
  name: Scalars['String']['output'];
  organization?: Maybe<integration__Organization>;
  refreshable: Scalars['Boolean']['output'];
  resources?: Maybe<Array<Scalars['String']['output']>>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type flexpa__EndpointflexpaOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderOrganization>;
};


export type flexpa__EndpointorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export enum flexpa__EndpointMode {
  LIVE = 'LIVE',
  TEST = 'TEST'
}

export type flexpa__Endpoint_Type = BaseObject & Object & flexpa__Endpoint & integration__BaseEndpoint & {
  __typename: 'flexpa__Endpoint_Type';
  displayName?: Maybe<Scalars['String']['output']>;
  externalIds: Array<Scalars['JSON']['output']>;
  flexpaId: Scalars['String']['output'];
  flexpaOrganization?: Maybe<flexpa__Organization>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label?: Maybe<Array<Scalars['String']['output']>>;
  metadata: Array<Scalars['JSON']['output']>;
  mode: flexpa__EndpointMode;
  name: Scalars['String']['output'];
  organization?: Maybe<integration__Organization>;
  refreshable: Scalars['Boolean']['output'];
  resources?: Maybe<Array<Scalars['String']['output']>>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type flexpa__Endpoint_TypeflexpaOrganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderOrganization>;
};


export type flexpa__Endpoint_TypeorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type flexpa__FilterEndpoint = {
  and?: InputMaybe<Array<flexpa__FilterEndpoint>>;
  displayName?: InputMaybe<FilterString>;
  flexpaId?: InputMaybe<FilterString>;
  flexpaOrganization?: InputMaybe<flexpa__NestedFilterOrganization>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  mode?: InputMaybe<Filterflexpa__EndpointMode>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<flexpa__FilterEndpoint>;
  or?: InputMaybe<Array<flexpa__FilterEndpoint>>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  refreshable?: InputMaybe<FilterBoolean>;
  slug?: InputMaybe<FilterString>;
};

export type flexpa__FilterFlexpaImport = {
  and?: InputMaybe<Array<flexpa__FilterFlexpaImport>>;
  bundleDocument?: InputMaybe<document__NestedFilterDocument>;
  endedAt?: InputMaybe<FilterString>;
  flexpaLink?: InputMaybe<flexpa__NestedFilterLink>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  not?: InputMaybe<flexpa__FilterFlexpaImport>;
  or?: InputMaybe<Array<flexpa__FilterFlexpaImport>>;
  owner?: InputMaybe<NestedFilterUser>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterflexpa__FlexpaImportStatus>;
  workflowId?: InputMaybe<FilterString>;
};

export type flexpa__FilterLink = {
  accessToken?: InputMaybe<FilterString>;
  active?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<flexpa__FilterLink>>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  deactivatedReason?: InputMaybe<Filterflexpa__LinkDeactivatedReason>;
  endpoint?: InputMaybe<flexpa__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  imports?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  lastRefreshedAt?: InputMaybe<FilterString>;
  lastSyncedAt?: InputMaybe<FilterString>;
  not?: InputMaybe<flexpa__FilterLink>;
  or?: InputMaybe<Array<flexpa__FilterLink>>;
  owner?: InputMaybe<NestedFilterUser>;
  patientDOB?: InputMaybe<FilterString>;
  patientId?: InputMaybe<FilterString>;
  patientName?: InputMaybe<FilterString>;
  refreshError?: InputMaybe<FilterString>;
  refreshExpiresAt?: InputMaybe<FilterString>;
  refreshToken?: InputMaybe<FilterString>;
  tokenExpiresAt?: InputMaybe<FilterString>;
};

export type flexpa__FilterOrganization = {
  and?: InputMaybe<Array<flexpa__FilterOrganization>>;
  flexpaId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<flexpa__FilterOrganization>;
  note?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<flexpa__FilterOrganization>>;
  orgType?: InputMaybe<Filterflexpa__OrganizationType>;
};

export type flexpa__FlexpaImport = {
  bundleDocument?: Maybe<document__Document>;
  endedAt?: Maybe<Scalars['String']['output']>;
  flexpaLink: flexpa__Link;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  owner: User;
  startedAt: Scalars['String']['output'];
  status: flexpa__FlexpaImportStatus;
  workflowId: Scalars['String']['output'];
};


export type flexpa__FlexpaImportbundleDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type flexpa__FlexpaImportflexpaLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type flexpa__FlexpaImportingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type flexpa__FlexpaImportownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum flexpa__FlexpaImportStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type flexpa__FlexpaImport_Type = BaseObject & Object & Owned & flexpa__FlexpaImport & {
  __typename: 'flexpa__FlexpaImport_Type';
  bundleDocument?: Maybe<document__Document>;
  endedAt?: Maybe<Scalars['String']['output']>;
  flexpaLink: flexpa__Link;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  owner: User;
  startedAt: Scalars['String']['output'];
  status: flexpa__FlexpaImportStatus;
  workflowId: Scalars['String']['output'];
};


export type flexpa__FlexpaImport_TypebundleDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type flexpa__FlexpaImport_TypeflexpaLinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderLink>;
};


export type flexpa__FlexpaImport_TypeingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type flexpa__FlexpaImport_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type flexpa__Link = {
  accessToken: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  deactivatedReason?: Maybe<flexpa__LinkDeactivatedReason>;
  endpoint: flexpa__Endpoint;
  id: Scalars['ID']['output'];
  imports?: Maybe<Array<flexpa__FlexpaImport>>;
  lastRefreshedAt?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  owner: User;
  patientDOB?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  refreshError?: Maybe<Scalars['String']['output']>;
  refreshExpiresAt?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenExpiresAt: Scalars['String']['output'];
};


export type flexpa__LinkendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderEndpoint>;
};


export type flexpa__LinkimportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type flexpa__LinkownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum flexpa__LinkDeactivatedReason {
  EXPIRED = 'EXPIRED',
  REFRESH_ERROR = 'REFRESH_ERROR',
  REVOKED = 'REVOKED'
}

export type flexpa__Link_Type = BaseObject & Object & Owned & flexpa__Link & integration__BaseLink & {
  __typename: 'flexpa__Link_Type';
  accessToken: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  deactivatedReason?: Maybe<flexpa__LinkDeactivatedReason>;
  endpoint: flexpa__Endpoint;
  id: Scalars['ID']['output'];
  imports?: Maybe<Array<flexpa__FlexpaImport>>;
  lastRefreshedAt?: Maybe<Scalars['String']['output']>;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  owner: User;
  patientDOB?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  refreshError?: Maybe<Scalars['String']['output']>;
  refreshExpiresAt?: Maybe<Scalars['String']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  tokenExpiresAt: Scalars['String']['output'];
};


export type flexpa__Link_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderEndpoint>;
};


export type flexpa__Link_TypeimportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type flexpa__Link_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type flexpa__NestedFilterEndpoint = {
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  flexpaId?: InputMaybe<FilterString>;
  flexpaOrganization?: InputMaybe<flexpa__NestedFilterOrganization>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  mode?: InputMaybe<Filterflexpa__EndpointMode>;
  name?: InputMaybe<FilterString>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  refreshable?: InputMaybe<FilterBoolean>;
  slug?: InputMaybe<FilterString>;
};

export type flexpa__NestedFilterFlexpaImport = {
  bundleDocument?: InputMaybe<document__NestedFilterDocument>;
  endedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  flexpaLink?: InputMaybe<flexpa__NestedFilterLink>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  owner?: InputMaybe<NestedFilterUser>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterflexpa__FlexpaImportStatus>;
  workflowId?: InputMaybe<FilterString>;
};

export type flexpa__NestedFilterLink = {
  accessToken?: InputMaybe<FilterString>;
  active?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  deactivatedReason?: InputMaybe<Filterflexpa__LinkDeactivatedReason>;
  endpoint?: InputMaybe<flexpa__NestedFilterEndpoint>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  imports?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  lastRefreshedAt?: InputMaybe<FilterString>;
  lastSyncedAt?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  patientDOB?: InputMaybe<FilterString>;
  patientId?: InputMaybe<FilterString>;
  patientName?: InputMaybe<FilterString>;
  refreshError?: InputMaybe<FilterString>;
  refreshExpiresAt?: InputMaybe<FilterString>;
  refreshToken?: InputMaybe<FilterString>;
  tokenExpiresAt?: InputMaybe<FilterString>;
};

export type flexpa__NestedFilterOrganization = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  flexpaId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  name?: InputMaybe<FilterString>;
  note?: InputMaybe<FilterString>;
  orgType?: InputMaybe<Filterflexpa__OrganizationType>;
};

export type flexpa__OrderEndpoint = {
  displayName?: InputMaybe<Ordering>;
  flexpaId?: InputMaybe<Ordering>;
  flexpaOrganization?: InputMaybe<flexpa__OrderOrganization>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  mode?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  organization?: InputMaybe<integration__OrderOrganization>;
  refreshable?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
};

export type flexpa__OrderFlexpaImport = {
  bundleDocument?: InputMaybe<document__OrderDocument>;
  endedAt?: InputMaybe<Ordering>;
  flexpaLink?: InputMaybe<flexpa__OrderLink>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  workflowId?: InputMaybe<Ordering>;
};

export type flexpa__OrderLink = {
  accessToken?: InputMaybe<Ordering>;
  active?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  deactivatedAt?: InputMaybe<Ordering>;
  deactivatedReason?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<flexpa__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  lastRefreshedAt?: InputMaybe<Ordering>;
  lastSyncedAt?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  patientDOB?: InputMaybe<Ordering>;
  patientId?: InputMaybe<Ordering>;
  patientName?: InputMaybe<Ordering>;
  refreshError?: InputMaybe<Ordering>;
  refreshExpiresAt?: InputMaybe<Ordering>;
  refreshToken?: InputMaybe<Ordering>;
  tokenExpiresAt?: InputMaybe<Ordering>;
};

export type flexpa__OrderOrganization = {
  flexpaId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  note?: InputMaybe<Ordering>;
  orgType?: InputMaybe<Ordering>;
};

export type flexpa__Organization = {
  flexpaId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orgType?: Maybe<flexpa__OrganizationType>;
};

export enum flexpa__OrganizationType {
  PAYER = 'PAYER',
  PROVIDER = 'PROVIDER',
  VENDOR = 'VENDOR'
}

export type flexpa__Organization_Type = BaseObject & Object & flexpa__Organization & {
  __typename: 'flexpa__Organization_Type';
  flexpaId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  orgType?: Maybe<flexpa__OrganizationType>;
};

/** One scheduled recompute of the case-forecasting model benchmarks. Never user-triggered; the latest SUCCEEDED run is the active benchmark set. */
export type forecasting__BenchmarkRun = {
  completedAt?: Maybe<Scalars['String']['output']>;
  diff?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  segmentationVersion: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
  status: forecasting__BenchmarkRunStatus;
  variables?: Maybe<Scalars['JSON']['output']>;
};

export enum forecasting__BenchmarkRunStatus {
  FAILED = 'FAILED',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED'
}

/** One scheduled recompute of the case-forecasting model benchmarks. Never user-triggered; the latest SUCCEEDED run is the active benchmark set. */
export type forecasting__BenchmarkRun_Type = BaseObject & Object & forecasting__BenchmarkRun & {
  __typename: 'forecasting__BenchmarkRun_Type';
  completedAt?: Maybe<Scalars['String']['output']>;
  diff?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  segmentationVersion: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
  status: forecasting__BenchmarkRunStatus;
  variables?: Maybe<Scalars['JSON']['output']>;
};

export type forecasting__FilterBenchmarkRun = {
  and?: InputMaybe<Array<forecasting__FilterBenchmarkRun>>;
  completedAt?: InputMaybe<FilterString>;
  diff?: InputMaybe<FilterJSON>;
  error?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<forecasting__FilterBenchmarkRun>;
  or?: InputMaybe<Array<forecasting__FilterBenchmarkRun>>;
  segmentationVersion?: InputMaybe<FilterString>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterforecasting__BenchmarkRunStatus>;
  variables?: InputMaybe<FilterJSON>;
};

export type forecasting__FilterHeadcountForecast = {
  and?: InputMaybe<Array<forecasting__FilterHeadcountForecast>>;
  createdAt?: InputMaybe<FilterString>;
  fullTimeHAs?: InputMaybe<FilterFloat>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<forecasting__FilterHeadcountForecast>;
  or?: InputMaybe<Array<forecasting__FilterHeadcountForecast>>;
  updatedAt?: InputMaybe<FilterString>;
  weekStart?: InputMaybe<FilterString>;
};

export type forecasting__FilterInvestment = {
  and?: InputMaybe<Array<forecasting__FilterInvestment>>;
  createdAt?: InputMaybe<FilterString>;
  effect?: InputMaybe<FilterJSON>;
  effectiveDate?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<forecasting__FilterInvestment>;
  or?: InputMaybe<Array<forecasting__FilterInvestment>>;
  scenario?: InputMaybe<forecasting__NestedFilterScenario>;
  targetVariable?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type forecasting__FilterMarketingForecast = {
  and?: InputMaybe<Array<forecasting__FilterMarketingForecast>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  leadsPerWeek?: InputMaybe<FilterFloat>;
  not?: InputMaybe<forecasting__FilterMarketingForecast>;
  or?: InputMaybe<Array<forecasting__FilterMarketingForecast>>;
  segment?: InputMaybe<Filterforecasting__ForecastSegment>;
  updatedAt?: InputMaybe<FilterString>;
  weekStart?: InputMaybe<FilterString>;
};

export type forecasting__FilterScenario = {
  and?: InputMaybe<Array<forecasting__FilterScenario>>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  investments?: InputMaybe<forecasting__NestedFilterInvestment>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<forecasting__FilterScenario>;
  or?: InputMaybe<Array<forecasting__FilterScenario>>;
  overrides?: InputMaybe<forecasting__NestedFilterVariableOverride>;
  updatedAt?: InputMaybe<FilterString>;
};

export type forecasting__FilterVariableOverride = {
  and?: InputMaybe<Array<forecasting__FilterVariableOverride>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<forecasting__FilterVariableOverride>;
  or?: InputMaybe<Array<forecasting__FilterVariableOverride>>;
  scenario?: InputMaybe<forecasting__NestedFilterScenario>;
  updatedAt?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterJSON>;
  variableKey?: InputMaybe<FilterString>;
};

export enum forecasting__ForecastSegment {
  CANCER_TESTING = 'CANCER_TESTING',
  ER_BILLS = 'ER_BILLS',
  FA = 'FA',
  NATERA = 'NATERA',
  OTHER_BILLS = 'OTHER_BILLS',
  OTHER_LABS = 'OTHER_LABS'
}

/** User-entered full-time front-line HA headcount for a week (net of PTO — not knowable from data). Weekly supply H(t) = headcount × minutes-per-full-HA-week benchmark. */
export type forecasting__HeadcountForecast = {
  createdAt: Scalars['String']['output'];
  fullTimeHAs: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  weekStart: Scalars['String']['output'];
};

/** User-entered full-time front-line HA headcount for a week (net of PTO — not knowable from data). Weekly supply H(t) = headcount × minutes-per-full-HA-week benchmark. */
export type forecasting__HeadcountForecast_Type = BaseObject & Object & forecasting__HeadcountForecast & {
  __typename: 'forecasting__HeadcountForecast_Type';
  createdAt: Scalars['String']['output'];
  fullTimeHAs: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  weekStart: Scalars['String']['output'];
};

/** Dated modifier on a named variable within a scenario, e.g. 'hire HA (Sep 1)' → headcount +1 through a ramp curve. */
export type forecasting__Investment = {
  createdAt: Scalars['String']['output'];
  effect: Scalars['JSON']['output'];
  effectiveDate: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scenario: forecasting__Scenario;
  targetVariable: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


/** Dated modifier on a named variable within a scenario, e.g. 'hire HA (Sep 1)' → headcount +1 through a ramp curve. */
export type forecasting__InvestmentscenarioArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterScenario>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderScenario>;
};

/** Dated modifier on a named variable within a scenario, e.g. 'hire HA (Sep 1)' → headcount +1 through a ramp curve. */
export type forecasting__Investment_Type = BaseObject & Object & forecasting__Investment & {
  __typename: 'forecasting__Investment_Type';
  createdAt: Scalars['String']['output'];
  effect: Scalars['JSON']['output'];
  effectiveDate: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scenario: forecasting__Scenario;
  targetVariable: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


/** Dated modifier on a named variable within a scenario, e.g. 'hire HA (Sep 1)' → headcount +1 through a ramp curve. */
export type forecasting__Investment_TypescenarioArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterScenario>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderScenario>;
};

/** User-entered weekly lead forecast V_s(t) — opened valid cases expected for a segment-week. Persisted model input; nothing in code computes it. Missing weeks carry the last entered value forward, labeled 'no forecast supplied'. */
export type forecasting__MarketingForecast = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leadsPerWeek: Scalars['Float']['output'];
  segment: forecasting__ForecastSegment;
  updatedAt: Scalars['String']['output'];
  weekStart: Scalars['String']['output'];
};

/** User-entered weekly lead forecast V_s(t) — opened valid cases expected for a segment-week. Persisted model input; nothing in code computes it. Missing weeks carry the last entered value forward, labeled 'no forecast supplied'. */
export type forecasting__MarketingForecast_Type = BaseObject & Object & forecasting__MarketingForecast & {
  __typename: 'forecasting__MarketingForecast_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  leadsPerWeek: Scalars['Float']['output'];
  segment: forecasting__ForecastSegment;
  updatedAt: Scalars['String']['output'];
  weekStart: Scalars['String']['output'];
};

export type forecasting__NestedFilterInvestment = {
  createdAt?: InputMaybe<FilterString>;
  effect?: InputMaybe<FilterJSON>;
  effectiveDate?: InputMaybe<FilterString>;
  enabled?: InputMaybe<FilterBoolean>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  scenario?: InputMaybe<forecasting__NestedFilterScenario>;
  targetVariable?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type forecasting__NestedFilterScenario = {
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  investments?: InputMaybe<forecasting__NestedFilterInvestment>;
  name?: InputMaybe<FilterString>;
  overrides?: InputMaybe<forecasting__NestedFilterVariableOverride>;
  updatedAt?: InputMaybe<FilterString>;
};

export type forecasting__NestedFilterVariableOverride = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  scenario?: InputMaybe<forecasting__NestedFilterScenario>;
  updatedAt?: InputMaybe<FilterString>;
  value?: InputMaybe<FilterJSON>;
  variableKey?: InputMaybe<FilterString>;
};

export type forecasting__OrderBenchmarkRun = {
  completedAt?: InputMaybe<Ordering>;
  diff?: InputMaybe<Ordering>;
  error?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  segmentationVersion?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  variables?: InputMaybe<Ordering>;
};

export type forecasting__OrderHeadcountForecast = {
  createdAt?: InputMaybe<Ordering>;
  fullTimeHAs?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  weekStart?: InputMaybe<Ordering>;
};

export type forecasting__OrderInvestment = {
  createdAt?: InputMaybe<Ordering>;
  effect?: InputMaybe<Ordering>;
  effectiveDate?: InputMaybe<Ordering>;
  enabled?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  scenario?: InputMaybe<forecasting__OrderScenario>;
  targetVariable?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type forecasting__OrderMarketingForecast = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  leadsPerWeek?: InputMaybe<Ordering>;
  segment?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  weekStart?: InputMaybe<Ordering>;
};

export type forecasting__OrderScenario = {
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type forecasting__OrderVariableOverride = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  scenario?: InputMaybe<forecasting__OrderScenario>;
  updatedAt?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
  variableKey?: InputMaybe<Ordering>;
};

/** Named set of overrides + investments compared against Baseline. Baseline itself is not a row — it is the absence of a scenario. */
export type forecasting__Scenario = {
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investments?: Maybe<Array<forecasting__Investment>>;
  name: Scalars['String']['output'];
  overrides?: Maybe<Array<forecasting__VariableOverride>>;
  updatedAt: Scalars['String']['output'];
};


/** Named set of overrides + investments compared against Baseline. Baseline itself is not a row — it is the absence of a scenario. */
export type forecasting__ScenarioinvestmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterInvestment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderInvestment>;
};


/** Named set of overrides + investments compared against Baseline. Baseline itself is not a row — it is the absence of a scenario. */
export type forecasting__ScenariooverridesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterVariableOverride>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderVariableOverride>;
};

/** Named set of overrides + investments compared against Baseline. Baseline itself is not a row — it is the absence of a scenario. */
export type forecasting__Scenario_Type = BaseObject & Object & forecasting__Scenario & {
  __typename: 'forecasting__Scenario_Type';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  investments?: Maybe<Array<forecasting__Investment>>;
  name: Scalars['String']['output'];
  overrides?: Maybe<Array<forecasting__VariableOverride>>;
  updatedAt: Scalars['String']['output'];
};


/** Named set of overrides + investments compared against Baseline. Baseline itself is not a row — it is the absence of a scenario. */
export type forecasting__Scenario_TypeinvestmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterInvestment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderInvestment>;
};


/** Named set of overrides + investments compared against Baseline. Baseline itself is not a row — it is the absence of a scenario. */
export type forecasting__Scenario_TypeoverridesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterVariableOverride>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderVariableOverride>;
};

/** Scenario-scoped override of one registry variable. Never mutates the benchmark; derived variables and the open book are not overridable (enforced in the API). */
export type forecasting__VariableOverride = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  scenario: forecasting__Scenario;
  updatedAt: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
  variableKey: Scalars['String']['output'];
};


/** Scenario-scoped override of one registry variable. Never mutates the benchmark; derived variables and the open book are not overridable (enforced in the API). */
export type forecasting__VariableOverridescenarioArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterScenario>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderScenario>;
};

/** Scenario-scoped override of one registry variable. Never mutates the benchmark; derived variables and the open book are not overridable (enforced in the API). */
export type forecasting__VariableOverride_Type = BaseObject & Object & forecasting__VariableOverride & {
  __typename: 'forecasting__VariableOverride_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  scenario: forecasting__Scenario;
  updatedAt: Scalars['String']['output'];
  value: Scalars['JSON']['output'];
  variableKey: Scalars['String']['output'];
};


/** Scenario-scoped override of one registry variable. Never mutates the benchmark; derived variables and the open book are not overridable (enforced in the API). */
export type forecasting__VariableOverride_TypescenarioArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<forecasting__FilterScenario>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<forecasting__OrderScenario>;
};

export type ingestion__Distillation = {
  determinedIngestable: Scalars['Boolean']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  owner: User;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceWebAgentExecution?: Maybe<webAgent__WebAgentExecution>;
  startedAt: Scalars['String']['output'];
  status: ingestion__DistillationStatus;
  summary?: Maybe<Scalars['JSON']['output']>;
  temporalWorkflowId: Scalars['String']['output'];
};


export type ingestion__DistillationownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__DistillationsourceWebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export enum ingestion__DistillationStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export type ingestion__Distillation_Type = BaseObject & Object & Owned & ingestion__Distillation & {
  __typename: 'ingestion__Distillation_Type';
  determinedIngestable: Scalars['Boolean']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  owner: User;
  sourceName?: Maybe<Scalars['String']['output']>;
  sourceWebAgentExecution?: Maybe<webAgent__WebAgentExecution>;
  startedAt: Scalars['String']['output'];
  status: ingestion__DistillationStatus;
  summary?: Maybe<Scalars['JSON']['output']>;
  temporalWorkflowId: Scalars['String']['output'];
};


export type ingestion__Distillation_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__Distillation_TypesourceWebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type ingestion__Extract = {
  contentDate?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingestion?: Maybe<ingestion__Ingestion>;
  meta?: Maybe<Scalars['JSON']['output']>;
  multiple: Scalars['Boolean']['output'];
  owner: User;
  source: document__Document;
  success: Scalars['Boolean']['output'];
  type: ingestion__ExtractionType;
};


export type ingestion__ExtractingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type ingestion__ExtractownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__ExtractsourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export type ingestion__Extract_Type = BaseObject & Object & Owned & ingestion__Extract & {
  __typename: 'ingestion__Extract_Type';
  contentDate?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  dataType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ingestion?: Maybe<ingestion__Ingestion>;
  meta?: Maybe<Scalars['JSON']['output']>;
  multiple: Scalars['Boolean']['output'];
  owner: User;
  source: document__Document;
  success: Scalars['Boolean']['output'];
  type: ingestion__ExtractionType;
};


export type ingestion__Extract_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type ingestion__Extract_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__Extract_TypesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export enum ingestion__ExtractionType {
  JSON = 'JSON',
  LLM_FHIR = 'LLM_FHIR'
}

export type ingestion__FilterDistillation = {
  and?: InputMaybe<Array<ingestion__FilterDistillation>>;
  determinedIngestable?: InputMaybe<FilterBoolean>;
  endedAt?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<ingestion__FilterDistillation>;
  or?: InputMaybe<Array<ingestion__FilterDistillation>>;
  owner?: InputMaybe<NestedFilterUser>;
  sourceName?: InputMaybe<FilterString>;
  sourceWebAgentExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__DistillationStatus>;
  summary?: InputMaybe<FilterJSON>;
  temporalWorkflowId?: InputMaybe<FilterString>;
};

export type ingestion__FilterExtract = {
  and?: InputMaybe<Array<ingestion__FilterExtract>>;
  contentDate?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  dataType?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  meta?: InputMaybe<FilterJSON>;
  multiple?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<ingestion__FilterExtract>;
  or?: InputMaybe<Array<ingestion__FilterExtract>>;
  owner?: InputMaybe<NestedFilterUser>;
  source?: InputMaybe<document__NestedFilterDocument>;
  success?: InputMaybe<FilterBoolean>;
  type?: InputMaybe<Filteringestion__ExtractionType>;
};

export type ingestion__FilterIngestion = {
  and?: InputMaybe<Array<ingestion__FilterIngestion>>;
  endedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  initiatedBy?: InputMaybe<NestedFilterUser>;
  initiatorRole?: InputMaybe<FilterParticipant>;
  meta?: InputMaybe<FilterJSON>;
  not?: InputMaybe<ingestion__FilterIngestion>;
  or?: InputMaybe<Array<ingestion__FilterIngestion>>;
  owner?: InputMaybe<NestedFilterUser>;
  resolutionStatus?: InputMaybe<Filteringestion__ResolutionStatus>;
  resources?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  sourceCrawlObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceFlexpaImport?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  sourceWebAgentExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__IngestionStatus>;
  steps?: InputMaybe<ingestion__NestedFilterIngestionStep>;
  strategy?: InputMaybe<Filteringestion__IngestionStrategy>;
  workflowId?: InputMaybe<FilterString>;
};

export type ingestion__FilterIngestionStep = {
  and?: InputMaybe<Array<ingestion__FilterIngestionStep>>;
  error?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  not?: InputMaybe<ingestion__FilterIngestionStep>;
  or?: InputMaybe<Array<ingestion__FilterIngestionStep>>;
  owner?: InputMaybe<NestedFilterUser>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__IngestionStatus>;
  type?: InputMaybe<Filteringestion__IngestionStepType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type ingestion__Ingestion = {
  endedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatedBy?: Maybe<User>;
  initiatorRole?: Maybe<Participant>;
  meta?: Maybe<Scalars['JSON']['output']>;
  owner: User;
  resolutionStatus: ingestion__ResolutionStatus;
  resources?: Maybe<Array<fhirext__ResourceVersion>>;
  sourceCrawlObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  sourceDocument?: Maybe<document__Document>;
  sourceFlexpaImport?: Maybe<flexpa__FlexpaImport>;
  sourceWebAgentExecution?: Maybe<webAgent__WebAgentExecution>;
  startedAt: Scalars['String']['output'];
  status: ingestion__IngestionStatus;
  steps?: Maybe<Array<ingestion__IngestionStep>>;
  strategy: ingestion__IngestionStrategy;
  workflowId: Scalars['String']['output'];
};


export type ingestion__IngestioninitiatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__IngestionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__IngestionresourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type ingestion__IngestionsourceCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type ingestion__IngestionsourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type ingestion__IngestionsourceFlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type ingestion__IngestionsourceWebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type ingestion__IngestionstepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestionStep>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestionStep>;
};

export enum ingestion__IngestionStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PARTIAL = 'PARTIAL'
}

export type ingestion__IngestionStep = {
  error?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  ingestion: ingestion__Ingestion;
  owner: User;
  startedAt: Scalars['String']['output'];
  status?: Maybe<ingestion__IngestionStatus>;
  type: ingestion__IngestionStepType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type ingestion__IngestionStepingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type ingestion__IngestionStepownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum ingestion__IngestionStepType {
  ANALYZED = 'ANALYZED',
  ASSOCIATED = 'ASSOCIATED',
  BENEFITS_SUMMARIZED = 'BENEFITS_SUMMARIZED',
  CLASSIFIED = 'CLASSIFIED',
  DATA_QUALITY_ASSESSED = 'DATA_QUALITY_ASSESSED',
  ENRICHED = 'ENRICHED',
  EXTRACTED = 'EXTRACTED',
  INDEXED = 'INDEXED',
  PLANS_CREATED = 'PLANS_CREATED',
  PREPROCESSED = 'PREPROCESSED',
  RECONCILED = 'RECONCILED',
  TRANSFORMED = 'TRANSFORMED',
  UPLOADED = 'UPLOADED'
}

export type ingestion__IngestionStep_Type = BaseObject & Object & Owned & ingestion__IngestionStep & {
  __typename: 'ingestion__IngestionStep_Type';
  error?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  ingestion: ingestion__Ingestion;
  owner: User;
  startedAt: Scalars['String']['output'];
  status?: Maybe<ingestion__IngestionStatus>;
  type: ingestion__IngestionStepType;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type ingestion__IngestionStep_TypeingestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type ingestion__IngestionStep_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum ingestion__IngestionStrategy {
  CLASSIC = 'CLASSIC',
  INDEX_ONLY = 'INDEX_ONLY',
  UNIVERSAL = 'UNIVERSAL'
}

export type ingestion__Ingestion_Type = BaseObject & Object & Owned & ingestion__Ingestion & {
  __typename: 'ingestion__Ingestion_Type';
  endedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initiatedBy?: Maybe<User>;
  initiatorRole?: Maybe<Participant>;
  meta?: Maybe<Scalars['JSON']['output']>;
  owner: User;
  resolutionStatus: ingestion__ResolutionStatus;
  resources?: Maybe<Array<fhirext__ResourceVersion>>;
  sourceCrawlObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  sourceDocument?: Maybe<document__Document>;
  sourceFlexpaImport?: Maybe<flexpa__FlexpaImport>;
  sourceWebAgentExecution?: Maybe<webAgent__WebAgentExecution>;
  startedAt: Scalars['String']['output'];
  status: ingestion__IngestionStatus;
  steps?: Maybe<Array<ingestion__IngestionStep>>;
  strategy: ingestion__IngestionStrategy;
  workflowId: Scalars['String']['output'];
};


export type ingestion__Ingestion_TypeinitiatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__Ingestion_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type ingestion__Ingestion_TyperesourcesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};


export type ingestion__Ingestion_TypesourceCrawlObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type ingestion__Ingestion_TypesourceDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type ingestion__Ingestion_TypesourceFlexpaImportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<flexpa__FilterFlexpaImport>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<flexpa__OrderFlexpaImport>;
};


export type ingestion__Ingestion_TypesourceWebAgentExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type ingestion__Ingestion_TypestepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestionStep>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestionStep>;
};

export type ingestion__NestedFilterExtract = {
  contentDate?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  dataType?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  meta?: InputMaybe<FilterJSON>;
  multiple?: InputMaybe<FilterBoolean>;
  owner?: InputMaybe<NestedFilterUser>;
  source?: InputMaybe<document__NestedFilterDocument>;
  success?: InputMaybe<FilterBoolean>;
  type?: InputMaybe<Filteringestion__ExtractionType>;
};

export type ingestion__NestedFilterIngestion = {
  endedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  initiatedBy?: InputMaybe<NestedFilterUser>;
  initiatorRole?: InputMaybe<FilterParticipant>;
  meta?: InputMaybe<FilterJSON>;
  owner?: InputMaybe<NestedFilterUser>;
  resolutionStatus?: InputMaybe<Filteringestion__ResolutionStatus>;
  resources?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  sourceCrawlObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  sourceDocument?: InputMaybe<document__NestedFilterDocument>;
  sourceFlexpaImport?: InputMaybe<flexpa__NestedFilterFlexpaImport>;
  sourceWebAgentExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__IngestionStatus>;
  steps?: InputMaybe<ingestion__NestedFilterIngestionStep>;
  strategy?: InputMaybe<Filteringestion__IngestionStrategy>;
  workflowId?: InputMaybe<FilterString>;
};

export type ingestion__NestedFilterIngestionStep = {
  error?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  ingestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  owner?: InputMaybe<NestedFilterUser>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filteringestion__IngestionStatus>;
  type?: InputMaybe<Filteringestion__IngestionStepType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type ingestion__OrderDistillation = {
  determinedIngestable?: InputMaybe<Ordering>;
  endedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  sourceName?: InputMaybe<Ordering>;
  sourceWebAgentExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  temporalWorkflowId?: InputMaybe<Ordering>;
};

export type ingestion__OrderExtract = {
  contentDate?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  dataType?: InputMaybe<Ordering>;
  error?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  meta?: InputMaybe<Ordering>;
  multiple?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  source?: InputMaybe<document__OrderDocument>;
  success?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type ingestion__OrderIngestion = {
  endedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  initiatedBy?: InputMaybe<OrderUser>;
  initiatorRole?: InputMaybe<Ordering>;
  meta?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resolutionStatus?: InputMaybe<Ordering>;
  sourceCrawlObjective?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
  sourceDocument?: InputMaybe<document__OrderDocument>;
  sourceFlexpaImport?: InputMaybe<flexpa__OrderFlexpaImport>;
  sourceWebAgentExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  strategy?: InputMaybe<Ordering>;
  workflowId?: InputMaybe<Ordering>;
};

export type ingestion__OrderIngestionStep = {
  id?: InputMaybe<Ordering>;
  ingestion?: InputMaybe<ingestion__OrderIngestion>;
  owner?: InputMaybe<OrderUser>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export enum ingestion__ResolutionStatus {
  NOT_RESOLVABLE = 'NOT_RESOLVABLE',
  RESOLVED = 'RESOLVED',
  UNKNOWN = 'UNKNOWN'
}

export type intake__FilterIntakeDraft = {
  and?: InputMaybe<Array<intake__FilterIntakeDraft>>;
  draft?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  journeyId?: InputMaybe<FilterString>;
  not?: InputMaybe<intake__FilterIntakeDraft>;
  or?: InputMaybe<Array<intake__FilterIntakeDraft>>;
  owner?: InputMaybe<NestedFilterUser>;
  updatedAt?: InputMaybe<FilterString>;
};

export type intake__FilterIntakeRecord = {
  and?: InputMaybe<Array<intake__FilterIntakeRecord>>;
  id?: InputMaybe<FilterID>;
  intake?: InputMaybe<FilterJSON>;
  journeyId?: InputMaybe<FilterString>;
  not?: InputMaybe<intake__FilterIntakeRecord>;
  or?: InputMaybe<Array<intake__FilterIntakeRecord>>;
  owner?: InputMaybe<NestedFilterUser>;
};

/** The in-progress generic-intake draft, upserted by `saveIntake` on every step and consumed by `createIntakeCase`. Sits beside `User.pendingNateraIntake`, which the live Natera funnel still owns. The `outcomes` per-screen replay log lives here, so a resumed flow can replay its transitions and stop at the first mismatch. */
export type intake__IntakeDraft = {
  draft: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  journeyId: Scalars['String']['output'];
  owner: User;
  updatedAt: Scalars['String']['output'];
};


/** The in-progress generic-intake draft, upserted by `saveIntake` on every step and consumed by `createIntakeCase`. Sits beside `User.pendingNateraIntake`, which the live Natera funnel still owns. The `outcomes` per-screen replay log lives here, so a resumed flow can replay its transitions and stop at the first mismatch. */
export type intake__IntakeDraftownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** The in-progress generic-intake draft, upserted by `saveIntake` on every step and consumed by `createIntakeCase`. Sits beside `User.pendingNateraIntake`, which the live Natera funnel still owns. The `outcomes` per-screen replay log lives here, so a resumed flow can replay its transitions and stop at the first mismatch. */
export type intake__IntakeDraft_Type = BaseObject & Object & Owned & intake__IntakeDraft & {
  __typename: 'intake__IntakeDraft_Type';
  draft: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  journeyId: Scalars['String']['output'];
  owner: User;
  updatedAt: Scalars['String']['output'];
};


/** The in-progress generic-intake draft, upserted by `saveIntake` on every step and consumed by `createIntakeCase`. Sits beside `User.pendingNateraIntake`, which the live Natera funnel still owns. The `outcomes` per-screen replay log lives here, so a resumed flow can replay its transitions and stop at the first mismatch. */
export type intake__IntakeDraft_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** The immutable envelope the case was opened from: `intakeDraftSchema` in @medbillai/schemas minus `outcomes`, which is deliberately omitted because nothing reads a replay log on a case — the writer strips it. Readonly like issue::Issue.nateraIntake: the record the case was opened from, not a live answer set. */
export type intake__IntakeRecord = {
  id: Scalars['ID']['output'];
  intake: Scalars['JSON']['output'];
  journeyId: Scalars['String']['output'];
  owner: User;
};


/** The immutable envelope the case was opened from: `intakeDraftSchema` in @medbillai/schemas minus `outcomes`, which is deliberately omitted because nothing reads a replay log on a case — the writer strips it. Readonly like issue::Issue.nateraIntake: the record the case was opened from, not a live answer set. */
export type intake__IntakeRecordownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** The immutable envelope the case was opened from: `intakeDraftSchema` in @medbillai/schemas minus `outcomes`, which is deliberately omitted because nothing reads a replay log on a case — the writer strips it. Readonly like issue::Issue.nateraIntake: the record the case was opened from, not a live answer set. */
export type intake__IntakeRecord_Type = BaseObject & Object & Owned & intake__IntakeRecord & {
  __typename: 'intake__IntakeRecord_Type';
  id: Scalars['ID']['output'];
  intake: Scalars['JSON']['output'];
  journeyId: Scalars['String']['output'];
  owner: User;
};


/** The immutable envelope the case was opened from: `intakeDraftSchema` in @medbillai/schemas minus `outcomes`, which is deliberately omitted because nothing reads a replay log on a case — the writer strips it. Readonly like issue::Issue.nateraIntake: the record the case was opened from, not a live answer set. */
export type intake__IntakeRecord_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type intake__NestedFilterIntakeRecord = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  intake?: InputMaybe<FilterJSON>;
  journeyId?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type intake__OrderIntakeDraft = {
  draft?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  journeyId?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  updatedAt?: InputMaybe<Ordering>;
};

export type intake__OrderIntakeRecord = {
  id?: InputMaybe<Ordering>;
  intake?: InputMaybe<Ordering>;
  journeyId?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type integration__BaseEndpoint = {
  displayName?: Maybe<Scalars['String']['output']>;
  externalIds: Array<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  metadata: Array<Scalars['JSON']['output']>;
  organization?: Maybe<integration__Organization>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type integration__BaseEndpointorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type integration__BaseLink = {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
};


export type integration__BaseLinkownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type integration__FilterBaseEndpoint = {
  and?: InputMaybe<Array<integration__FilterBaseEndpoint>>;
  displayName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<integration__FilterBaseEndpoint>;
  or?: InputMaybe<Array<integration__FilterBaseEndpoint>>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  slug?: InputMaybe<FilterString>;
};

export type integration__FilterBaseLink = {
  active?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<integration__FilterBaseLink>>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<integration__FilterBaseLink>;
  or?: InputMaybe<Array<integration__FilterBaseLink>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type integration__FilterOrganization = {
  and?: InputMaybe<Array<integration__FilterOrganization>>;
  displayName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<integration__FilterOrganization>;
  or?: InputMaybe<Array<integration__FilterOrganization>>;
  partOf?: InputMaybe<integration__NestedFilterOrganization>;
  slug?: InputMaybe<FilterString>;
};

export type integration__NestedFilterBaseEndpoint = {
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  slug?: InputMaybe<FilterString>;
};

export type integration__NestedFilterBaseLink = {
  active?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type integration__NestedFilterOrganization = {
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  partOf?: InputMaybe<integration__NestedFilterOrganization>;
  slug?: InputMaybe<FilterString>;
};

export type integration__OrderBaseEndpoint = {
  displayName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  organization?: InputMaybe<integration__OrderOrganization>;
  slug?: InputMaybe<Ordering>;
};

export type integration__OrderBaseLink = {
  active?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  deactivatedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type integration__OrderOrganization = {
  displayName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  partOf?: InputMaybe<integration__OrderOrganization>;
  slug?: InputMaybe<Ordering>;
};

export type integration__Organization = {
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  partOf?: Maybe<integration__Organization>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type integration__OrganizationpartOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

export type integration__Organization_Type = BaseObject & Object & Slugged & integration__Organization & {
  __typename: 'integration__Organization_Type';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  partOf?: Maybe<integration__Organization>;
  slug?: Maybe<Scalars['String']['output']>;
};


export type integration__Organization_TypepartOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};

/** Alternative payment strategies the user can opt into when their discount threshold is high. */
export enum issue__AlternativePaymentOption {
  INCOME_BASED_ADJUSTMENT = 'INCOME_BASED_ADJUSTMENT',
  MONTHLY_PAYMENT_PLAN = 'MONTHLY_PAYMENT_PLAN',
  WAIT_AND_SAVE = 'WAIT_AND_SAVE'
}

export type issue__AskReraisedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  reraisedAsk: issue__Event;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__AskReraisedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__AskReraisedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__AskReraisedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__AskReraisedEventreraisedAskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__AskReraisedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__AskReraisedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__AskReraisedEvent_Type = BaseObject & Object & issue__AskReraisedEvent & issue__Event & {
  __typename: 'issue__AskReraisedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  reraisedAsk: issue__Event;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__AskReraisedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__AskReraisedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__AskReraisedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__AskReraisedEvent_TypereraisedAskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__AskReraisedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__AskReraisedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BenefitsContext = {
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  selectedAt?: Maybe<Scalars['String']['output']>;
  selectedPlan?: Maybe<plan__Plan>;
};


export type issue__BenefitsContextissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BenefitsContextselectedPlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};

export type issue__BenefitsContext_Type = BaseObject & Object & issue__BenefitsContext & {
  __typename: 'issue__BenefitsContext_Type';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  selectedAt?: Maybe<Scalars['String']['output']>;
  selectedPlan?: Maybe<plan__Plan>;
};


export type issue__BenefitsContext_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BenefitsContext_TypeselectedPlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};

export type issue__BenefitsSummaryGeneratedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  plan: plan__Plan;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BenefitsSummaryGeneratedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BenefitsSummaryGeneratedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BenefitsSummaryGeneratedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BenefitsSummaryGeneratedEventplanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__BenefitsSummaryGeneratedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BenefitsSummaryGeneratedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BenefitsSummaryGeneratedEvent_Type = BaseObject & Object & issue__BenefitsSummaryGeneratedEvent & issue__Event & {
  __typename: 'issue__BenefitsSummaryGeneratedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  plan: plan__Plan;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypeplanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BenefitsSummaryGeneratedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillDisputeEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eob?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  eobId?: Maybe<Scalars['ID']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  healthRecordKey?: Maybe<Scalars['String']['output']>;
  healthRecordKind?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Array<fhirext__InvoiceVersion>>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillDisputeEventeobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type issue__BillDisputeEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillDisputeEventinvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type issue__BillDisputeEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillDisputeEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillDisputeEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillDisputeEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillDisputeEvent_Type = BaseObject & Object & issue__BillDisputeEvent & issue__Event & {
  __typename: 'issue__BillDisputeEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eob?: Maybe<Array<fhirext__ExplanationOfBenefitVersion>>;
  eobId?: Maybe<Scalars['ID']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  healthRecordKey?: Maybe<Scalars['String']['output']>;
  healthRecordKind?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Array<fhirext__InvoiceVersion>>;
  invoiceId?: Maybe<Scalars['ID']['output']>;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillDisputeEvent_TypeeobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterExplanationOfBenefitVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderExplanationOfBenefitVersion>;
};


export type issue__BillDisputeEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillDisputeEvent_TypeinvoiceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterInvoiceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderInvoiceVersion>;
};


export type issue__BillDisputeEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillDisputeEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillDisputeEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillDisputeEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPayPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__BillPayRequestedEvent;
};


export type issue__BillPayPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPayPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPayRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPayRequestedEvent>;
};

export type issue__BillPayPostEscalationAction_Type = BaseObject & Object & issue__BillPayPostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__BillPayPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__BillPayRequestedEvent;
};


export type issue__BillPayPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPayPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPayRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPayRequestedEvent>;
};

/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent = {
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  availableAlternativePaymentOptions: Array<issue__AlternativePaymentOption>;
  availableMinimumDiscountOptions: Array<Scalars['Int']['output']>;
  availableSuccessFeeOptions: Array<Scalars['Int']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  declinedAt?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  preAuthStatus?: Maybe<issue__PreAuthStatus>;
  preAuthTransaction?: Maybe<payment__PaymentTransaction>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventpreAuthTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_Type = BaseObject & Object & issue__BillPayRequestedEvent & issue__Event & issue__PreAuthRequestedEvent & {
  __typename: 'issue__BillPayRequestedEvent_Type';
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  availableAlternativePaymentOptions: Array<issue__AlternativePaymentOption>;
  availableMinimumDiscountOptions: Array<Scalars['Int']['output']>;
  availableSuccessFeeOptions: Array<Scalars['Int']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  declinedAt?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  preAuthStatus?: Maybe<issue__PreAuthStatus>;
  preAuthTransaction?: Maybe<payment__PaymentTransaction>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypepreAuthTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Bill pay offer sent to the user. Contains the available options the user can choose from. */
export type issue__BillPayRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeTransaction: payment__PaymentTransaction;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  negotiatedBillAmount: Scalars['Decimal']['output'];
  originalBillAmount: Scalars['Decimal']['output'];
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  successFeeAmount: Scalars['Decimal']['output'];
  successFeePercent: Scalars['Int']['output'];
  totalCharged: Scalars['Decimal']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventchargeTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_Type = BaseObject & Object & issue__BillPaySuccessEvent & issue__Event & {
  __typename: 'issue__BillPaySuccessEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeTransaction: payment__PaymentTransaction;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  negotiatedBillAmount: Scalars['Decimal']['output'];
  originalBillAmount: Scalars['Decimal']['output'];
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  successFeeAmount: Scalars['Decimal']['output'];
  successFeePercent: Scalars['Int']['output'];
  totalCharged: Scalars['Decimal']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypechargeTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Records a successful bill pay charge — the HA charged the negotiated amount plus success fee. */
export type issue__BillPaySuccessEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPaymentRequestedEvent = {
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  billAmount?: Maybe<Scalars['Decimal']['output']>;
  billPaid: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillPaymentRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillPaymentRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPaymentRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillPaymentRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillPaymentRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPaymentRequestedEvent_Type = BaseObject & Object & issue__BillPaymentRequestedEvent & issue__Event & {
  __typename: 'issue__BillPaymentRequestedEvent_Type';
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  billAmount?: Maybe<Scalars['Decimal']['output']>;
  billPaid: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillPaymentRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillPaymentRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPaymentRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillPaymentRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillPaymentRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPaymentSuccessEvent = {
  actionRequired: Scalars['Boolean']['output'];
  billAmount: Scalars['Decimal']['output'];
  billPaymentRequest: issue__BillPaymentRequestedEvent;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  stripePaymentIntentId: Scalars['String']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillPaymentSuccessEventbillPaymentRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaymentRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaymentRequestedEvent>;
};


export type issue__BillPaymentSuccessEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillPaymentSuccessEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPaymentSuccessEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillPaymentSuccessEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillPaymentSuccessEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__BillPaymentSuccessEvent_Type = BaseObject & Object & issue__BillPaymentSuccessEvent & issue__Event & {
  __typename: 'issue__BillPaymentSuccessEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  billAmount: Scalars['Decimal']['output'];
  billPaymentRequest: issue__BillPaymentRequestedEvent;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  stripePaymentIntentId: Scalars['String']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__BillPaymentSuccessEvent_TypebillPaymentRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBillPaymentRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBillPaymentRequestedEvent>;
};


export type issue__BillPaymentSuccessEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__BillPaymentSuccessEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__BillPaymentSuccessEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__BillPaymentSuccessEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__BillPaymentSuccessEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  cardDeclinedAt?: Maybe<Scalars['String']['output']>;
  cardRequestKey: Scalars['String']['output'];
  cardSucceededAt?: Maybe<Scalars['String']['output']>;
  cardSupersededAt?: Maybe<Scalars['String']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  preAuthStatus?: Maybe<issue__PreAuthStatus>;
  preAuthTransaction?: Maybe<payment__PaymentTransaction>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEventpreAuthTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEvent_Type = BaseObject & Object & issue__CardCollectionRequestedEvent & issue__Event & issue__PreAuthRequestedEvent & {
  __typename: 'issue__CardCollectionRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  cardDeclinedAt?: Maybe<Scalars['String']['output']>;
  cardRequestKey: Scalars['String']['output'];
  cardSucceededAt?: Maybe<Scalars['String']['output']>;
  cardSupersededAt?: Maybe<Scalars['String']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  preAuthStatus?: Maybe<issue__PreAuthStatus>;
  preAuthTransaction?: Maybe<payment__PaymentTransaction>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEvent_TypepreAuthTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** HA card-only request. Distinct from PaymentPreferencesRequestedEvent. Stripe payment-method references stay on payment::PaymentProfile. */
export type issue__CardCollectionRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ChatEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chatBody: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ChatEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ChatEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ChatEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ChatEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ChatEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ChatEvent_Type = BaseObject & Object & issue__ChatEvent & issue__Event & {
  __typename: 'issue__ChatEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chatBody: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ChatEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ChatEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ChatEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ChatEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ChatEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ClosedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  caseManagementClosureReason?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  feedback?: Maybe<feedback__IssueFeedback>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userClosureReason?: Maybe<issue__UserClosureReason>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ClosedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ClosedEventfeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueFeedback>;
};


export type issue__ClosedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ClosedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ClosedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ClosedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ClosedEvent_Type = BaseObject & Object & issue__ClosedEvent & issue__Event & {
  __typename: 'issue__ClosedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  caseManagementClosureReason?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  feedback?: Maybe<feedback__IssueFeedback>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userClosureReason?: Maybe<issue__UserClosureReason>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ClosedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ClosedEvent_TypefeedbackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueFeedback>;
};


export type issue__ClosedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ClosedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ClosedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ClosedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ClosurePaymentRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeDate?: Maybe<Scalars['String']['output']>;
  chargeDelayDays?: Maybe<Scalars['Int']['output']>;
  dollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  successFee?: Maybe<Scalars['Decimal']['output']>;
  totalBillDollarAmount?: Maybe<Scalars['Decimal']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ClosurePaymentRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ClosurePaymentRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ClosurePaymentRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ClosurePaymentRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ClosurePaymentRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ClosurePaymentRequestedEvent_Type = BaseObject & Object & issue__ClosurePaymentRequestedEvent & issue__Event & {
  __typename: 'issue__ClosurePaymentRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeDate?: Maybe<Scalars['String']['output']>;
  chargeDelayDays?: Maybe<Scalars['Int']['output']>;
  dollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  successFee?: Maybe<Scalars['Decimal']['output']>;
  totalBillDollarAmount?: Maybe<Scalars['Decimal']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ClosurePaymentRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ClosurePaymentRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ClosurePaymentRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ClosurePaymentRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ClosurePaymentRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__CommentEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  comment: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  pinned: Scalars['Boolean']['output'];
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__CommentEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__CommentEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__CommentEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__CommentEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__CommentEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__CommentEvent_Type = BaseObject & Object & issue__CommentEvent & issue__Event & {
  __typename: 'issue__CommentEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  comment: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  pinned: Scalars['Boolean']['output'];
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__CommentEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__CommentEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__CommentEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__CommentEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__CommentEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__CompleteFaApplicationPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__FinancialAssistanceFlowEvent;
};


export type issue__CompleteFaApplicationPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__CompleteFaApplicationPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterFinancialAssistanceFlowEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderFinancialAssistanceFlowEvent>;
};

export type issue__CompleteFaApplicationPostEscalationAction_Type = BaseObject & Object & issue__CompleteFaApplicationPostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__CompleteFaApplicationPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__FinancialAssistanceFlowEvent;
};


export type issue__CompleteFaApplicationPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__CompleteFaApplicationPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterFinancialAssistanceFlowEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderFinancialAssistanceFlowEvent>;
};

export type issue__ConnectAccountRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  buttonText: Scalars['String']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chatBody?: Maybe<Scalars['String']['output']>;
  endpointType: webAgent__EndpointType;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  showSkipButton?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ConnectAccountRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ConnectAccountRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectAccountRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ConnectAccountRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ConnectAccountRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ConnectAccountRequestedEvent_Type = BaseObject & Object & issue__ConnectAccountRequestedEvent & issue__Event & {
  __typename: 'issue__ConnectAccountRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  buttonText: Scalars['String']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chatBody?: Maybe<Scalars['String']['output']>;
  endpointType: webAgent__EndpointType;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  showSkipButton?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ConnectAccountRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ConnectAccountRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectAccountRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ConnectAccountRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ConnectAccountRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ConnectEhrPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__ConnectAccountRequestedEvent;
};


export type issue__ConnectEhrPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectEhrPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__ConnectEhrPostEscalationAction_Type = BaseObject & Object & issue__ConnectEhrPostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__ConnectEhrPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__ConnectAccountRequestedEvent;
};


export type issue__ConnectEhrPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectEhrPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__ConnectInsurancePostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__ConnectAccountRequestedEvent;
};


export type issue__ConnectInsurancePostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectInsurancePostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__ConnectInsurancePostEscalationAction_Type = BaseObject & Object & issue__ConnectInsurancePostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__ConnectInsurancePostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__ConnectAccountRequestedEvent;
};


export type issue__ConnectInsurancePostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectInsurancePostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__ConnectInsuranceRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  insuranceLinkMessage?: Maybe<Scalars['String']['output']>;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ConnectInsuranceRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ConnectInsuranceRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectInsuranceRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ConnectInsuranceRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ConnectInsuranceRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ConnectInsuranceRequestedEvent_Type = BaseObject & Object & issue__ConnectInsuranceRequestedEvent & issue__Event & {
  __typename: 'issue__ConnectInsuranceRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  insuranceLinkMessage?: Maybe<Scalars['String']['output']>;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ConnectInsuranceRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ConnectInsuranceRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ConnectInsuranceRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ConnectInsuranceRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ConnectInsuranceRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__DocumentAnalysisEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  errorIsRetriable?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  status: issue__DocumentAnalysisStatus;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentAnalysisEventdocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentAnalysisEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentAnalysisEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentAnalysisEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentAnalysisEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentAnalysisEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__DocumentAnalysisEvent_Type = BaseObject & Object & issue__DocumentAnalysisEvent & issue__Event & {
  __typename: 'issue__DocumentAnalysisEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  errorIsRetriable?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  status: issue__DocumentAnalysisStatus;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentAnalysisEvent_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentAnalysisEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentAnalysisEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentAnalysisEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentAnalysisEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentAnalysisEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__DocumentAnalysisStatus {
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  MISSING_REQUIRED_DATA = 'MISSING_REQUIRED_DATA',
  NOT_ANALYZABLE = 'NOT_ANALYZABLE',
  PENDING = 'PENDING'
}

export type issue__DocumentClassificationFailedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  classificationResolvedAt?: Maybe<Scalars['String']['output']>;
  classificationStatus?: Maybe<issue__DocumentClassificationStatus>;
  document: document__Document;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentClassificationFailedEventdocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentClassificationFailedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentClassificationFailedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentClassificationFailedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentClassificationFailedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentClassificationFailedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__DocumentClassificationFailedEvent_Type = BaseObject & Object & issue__DocumentClassificationFailedEvent & issue__Event & {
  __typename: 'issue__DocumentClassificationFailedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  classificationResolvedAt?: Maybe<Scalars['String']['output']>;
  classificationStatus?: Maybe<issue__DocumentClassificationStatus>;
  document: document__Document;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentClassificationFailedEvent_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentClassificationFailedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentClassificationFailedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentClassificationFailedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentClassificationFailedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentClassificationFailedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__DocumentClassificationStatus {
  AUTO = 'AUTO',
  REVIEW = 'REVIEW',
  UNKNOWN = 'UNKNOWN'
}

export type issue__DocumentUploadedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  documentLabel?: Maybe<Scalars['String']['output']>;
  /** Reload source for the document's member-visible stage. */
  documentStage?: Maybe<DocumentStageState>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentUploadedEventdocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentUploadedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentUploadedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentUploadedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentUploadedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentUploadedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__DocumentUploadedEvent_Type = BaseObject & Object & issue__DocumentUploadedEvent & issue__Event & {
  __typename: 'issue__DocumentUploadedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  document: document__Document;
  documentLabel?: Maybe<Scalars['String']['output']>;
  documentStage?: Maybe<DocumentStageState>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  previewPromptMessage?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  uploadFailed?: Maybe<Scalars['Boolean']['output']>;
  uploading?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__DocumentUploadedEvent_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__DocumentUploadedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__DocumentUploadedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__DocumentUploadedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__DocumentUploadedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__DocumentUploadedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__Event = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__EventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__EventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__EventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__EventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__EventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__EventType {
  ASK_RERAISED = 'ASK_RERAISED',
  BENEFITS_SUMMARY_GENERATED = 'BENEFITS_SUMMARY_GENERATED',
  BILL_DISPUTE = 'BILL_DISPUTE',
  BILL_PAYMENT_REQUESTED = 'BILL_PAYMENT_REQUESTED',
  BILL_PAYMENT_SUCCESS = 'BILL_PAYMENT_SUCCESS',
  BILL_PAY_REQUESTED = 'BILL_PAY_REQUESTED',
  BILL_PAY_SUCCESS = 'BILL_PAY_SUCCESS',
  CARD_COLLECTION_REQUESTED = 'CARD_COLLECTION_REQUESTED',
  CHAT = 'CHAT',
  CLOSED = 'CLOSED',
  CLOSURE_PAYMENT_REQUESTED = 'CLOSURE_PAYMENT_REQUESTED',
  COMMENT = 'COMMENT',
  CONNECT_ACCOUNT_REQUESTED = 'CONNECT_ACCOUNT_REQUESTED',
  CONNECT_INSURANCE_REQUESTED = 'CONNECT_INSURANCE_REQUESTED',
  DOCUMENT_ANALYSIS = 'DOCUMENT_ANALYSIS',
  DOCUMENT_ANALYSIS_COMPLETE = 'DOCUMENT_ANALYSIS_COMPLETE',
  DOCUMENT_ANALYSIS_SELECT_VISIT = 'DOCUMENT_ANALYSIS_SELECT_VISIT',
  DOCUMENT_ANALYSIS_STARTED = 'DOCUMENT_ANALYSIS_STARTED',
  DOCUMENT_CLASSIFICATION_FAILED = 'DOCUMENT_CLASSIFICATION_FAILED',
  DOCUMENT_UPLOADED = 'DOCUMENT_UPLOADED',
  FA_FLOW = 'FA_FLOW',
  HA_ASSIGNED = 'HA_ASSIGNED',
  HIPAA_RELEASE_REQUESTED = 'HIPAA_RELEASE_REQUESTED',
  INTERNAL_DOCUMENT_UPLOADED = 'INTERNAL_DOCUMENT_UPLOADED',
  OUTREACH = 'OUTREACH',
  PAYMENT_AGREEMENT_REQUESTED = 'PAYMENT_AGREEMENT_REQUESTED',
  PAYMENT_CHARGE_FAILED = 'PAYMENT_CHARGE_FAILED',
  PAYMENT_CHARGE_RESOLVED = 'PAYMENT_CHARGE_RESOLVED',
  PAYMENT_PREFERENCES_REQUESTED = 'PAYMENT_PREFERENCES_REQUESTED',
  PAYMENT_PREFERENCES_UPDATED = 'PAYMENT_PREFERENCES_UPDATED',
  PHONE_CALL = 'PHONE_CALL',
  PLAN_SELECTION = 'PLAN_SELECTION',
  POST_ESCALATION_ACTIONS = 'POST_ESCALATION_ACTIONS',
  REOPENED = 'REOPENED',
  TEMPLATE_RELEASE_REQUESTED = 'TEMPLATE_RELEASE_REQUESTED',
  TOOL_EXECUTION = 'TOOL_EXECUTION',
  USER_INPUT_REQUESTED = 'USER_INPUT_REQUESTED',
  USER_MULTI_SELECTION_REQUESTED = 'USER_MULTI_SELECTION_REQUESTED',
  USER_SELECTION_REQUESTED = 'USER_SELECTION_REQUESTED'
}

export type issue__FaEligibilityInfoPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
};


export type issue__FaEligibilityInfoPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type issue__FaEligibilityInfoPostEscalationAction_Type = BaseObject & Object & issue__FaEligibilityInfoPostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__FaEligibilityInfoPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
};


export type issue__FaEligibilityInfoPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type issue__FilterAskReraisedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterAskReraisedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterAskReraisedEvent>;
  or?: InputMaybe<Array<issue__FilterAskReraisedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  reraisedAsk?: InputMaybe<issue__NestedFilterEvent>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBenefitsContext = {
  and?: InputMaybe<Array<issue__FilterBenefitsContext>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<issue__FilterBenefitsContext>;
  or?: InputMaybe<Array<issue__FilterBenefitsContext>>;
  selectedAt?: InputMaybe<FilterString>;
  selectedPlan?: InputMaybe<plan__NestedFilterPlan>;
};

export type issue__FilterBenefitsSummaryGeneratedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBenefitsSummaryGeneratedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBenefitsSummaryGeneratedEvent>;
  or?: InputMaybe<Array<issue__FilterBenefitsSummaryGeneratedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  plan?: InputMaybe<plan__NestedFilterPlan>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillDisputeEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillDisputeEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eob?: InputMaybe<fhirext__NestedFilterExplanationOfBenefitVersion>;
  eobId?: InputMaybe<FilterID>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  healthRecordKey?: InputMaybe<FilterString>;
  healthRecordKind?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  invoice?: InputMaybe<fhirext__NestedFilterInvoiceVersion>;
  invoiceId?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBillDisputeEvent>;
  or?: InputMaybe<Array<issue__FilterBillDisputeEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillPayPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterBillPayPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterBillPayRequestedEvent>;
  not?: InputMaybe<issue__FilterBillPayPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterBillPayPostEscalationAction>>;
};

export type issue__FilterBillPayRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillPayRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  declinedAt?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBillPayRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterBillPayRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  preAuthStatus?: InputMaybe<Filterissue__PreAuthStatus>;
  preAuthTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillPaySuccessEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillPaySuccessEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chargeTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  negotiatedBillAmount?: InputMaybe<FilterDecimal>;
  not?: InputMaybe<issue__FilterBillPaySuccessEvent>;
  or?: InputMaybe<Array<issue__FilterBillPaySuccessEvent>>;
  originalBillAmount?: InputMaybe<FilterDecimal>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  successFeeAmount?: InputMaybe<FilterDecimal>;
  successFeePercent?: InputMaybe<FilterInt>;
  totalCharged?: InputMaybe<FilterDecimal>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillPaymentRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillPaymentRequestedEvent>>;
  billAmount?: InputMaybe<FilterDecimal>;
  billPaid?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBillPaymentRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterBillPaymentRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterBillPaymentSuccessEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterBillPaymentSuccessEvent>>;
  billAmount?: InputMaybe<FilterDecimal>;
  billPaymentRequest?: InputMaybe<issue__NestedFilterBillPaymentRequestedEvent>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterBillPaymentSuccessEvent>;
  or?: InputMaybe<Array<issue__FilterBillPaymentSuccessEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  stripePaymentIntentId?: InputMaybe<FilterString>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterCardCollectionRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterCardCollectionRequestedEvent>>;
  cardDeclinedAt?: InputMaybe<FilterString>;
  cardRequestKey?: InputMaybe<FilterString>;
  cardSucceededAt?: InputMaybe<FilterString>;
  cardSupersededAt?: InputMaybe<FilterString>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterCardCollectionRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterCardCollectionRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  preAuthStatus?: InputMaybe<Filterissue__PreAuthStatus>;
  preAuthTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterChatEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterChatEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chatBody?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterChatEvent>;
  or?: InputMaybe<Array<issue__FilterChatEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterClosedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterClosedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  caseManagementClosureReason?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  feedback?: InputMaybe<feedback__NestedFilterIssueFeedback>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterClosedEvent>;
  or?: InputMaybe<Array<issue__FilterClosedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userClosureReason?: InputMaybe<Filterissue__UserClosureReason>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterClosurePaymentRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterClosurePaymentRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chargeDate?: InputMaybe<FilterString>;
  chargeDelayDays?: InputMaybe<FilterInt>;
  dollarAmountSaved?: InputMaybe<FilterDecimal>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterClosurePaymentRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterClosurePaymentRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  successFee?: InputMaybe<FilterDecimal>;
  totalBillDollarAmount?: InputMaybe<FilterDecimal>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterCommentEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterCommentEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  comment?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterCommentEvent>;
  or?: InputMaybe<Array<issue__FilterCommentEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  pinned?: InputMaybe<FilterBoolean>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterCompleteFaApplicationPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterCompleteFaApplicationPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterFinancialAssistanceFlowEvent>;
  not?: InputMaybe<issue__FilterCompleteFaApplicationPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterCompleteFaApplicationPostEscalationAction>>;
};

export type issue__FilterConnectAccountRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterConnectAccountRequestedEvent>>;
  buttonText?: InputMaybe<FilterString>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chatBody?: InputMaybe<FilterString>;
  endpointType?: InputMaybe<FilterwebAgent__EndpointType>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterConnectAccountRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterConnectAccountRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  showSkipButton?: InputMaybe<FilterBoolean>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterConnectEhrPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterConnectEhrPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterConnectAccountRequestedEvent>;
  not?: InputMaybe<issue__FilterConnectEhrPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterConnectEhrPostEscalationAction>>;
};

export type issue__FilterConnectInsurancePostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterConnectInsurancePostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterConnectAccountRequestedEvent>;
  not?: InputMaybe<issue__FilterConnectInsurancePostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterConnectInsurancePostEscalationAction>>;
};

export type issue__FilterConnectInsuranceRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterConnectInsuranceRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  insuranceLinkMessage?: InputMaybe<FilterString>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterConnectInsuranceRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterConnectInsuranceRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterDocumentAnalysisEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterDocumentAnalysisEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  document?: InputMaybe<document__NestedFilterDocument>;
  errorIsRetriable?: InputMaybe<FilterBoolean>;
  errorMessage?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterDocumentAnalysisEvent>;
  or?: InputMaybe<Array<issue__FilterDocumentAnalysisEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  status?: InputMaybe<Filterissue__DocumentAnalysisStatus>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterDocumentClassificationFailedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterDocumentClassificationFailedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  classificationResolvedAt?: InputMaybe<FilterString>;
  classificationStatus?: InputMaybe<Filterissue__DocumentClassificationStatus>;
  document?: InputMaybe<document__NestedFilterDocument>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterDocumentClassificationFailedEvent>;
  or?: InputMaybe<Array<issue__FilterDocumentClassificationFailedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterDocumentUploadedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterDocumentUploadedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentLabel?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  or?: InputMaybe<Array<issue__FilterDocumentUploadedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterEvent>;
  or?: InputMaybe<Array<issue__FilterEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterFaEligibilityInfoPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterFaEligibilityInfoPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<issue__FilterFaEligibilityInfoPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterFaEligibilityInfoPostEscalationAction>>;
};

export type issue__FilterFinancialAssistanceFlowEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterFinancialAssistanceFlowEvent>>;
  application?: InputMaybe<fa__NestedFilterApplication>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  handoffMessage?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isResolved?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterFinancialAssistanceFlowEvent>;
  or?: InputMaybe<Array<issue__FilterFinancialAssistanceFlowEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterHAAssignedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterHAAssignedEvent>>;
  assigneeAverageCaseRating?: InputMaybe<FilterFloat>;
  assigneeProfile?: InputMaybe<user__NestedFilterProfile>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterHAAssignedEvent>;
  or?: InputMaybe<Array<issue__FilterHAAssignedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterHipaaReleaseRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterHipaaReleaseRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  hipaaRelease?: InputMaybe<consent__NestedFilterHipaaRelease>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterHipaaReleaseRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterHipaaReleaseRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterInternalDocumentUploadedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterInternalDocumentUploadedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  internalDocument?: InputMaybe<document__NestedFilterDocument>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterInternalDocumentUploadedEvent>;
  or?: InputMaybe<Array<issue__FilterInternalDocumentUploadedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterIssue = {
  actions?: InputMaybe<issue__NestedFilterEvent>;
  additionalDetails?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<issue__FilterIssue>>;
  assignee?: InputMaybe<NestedFilterUser>;
  benefitsContext?: InputMaybe<issue__NestedFilterBenefitsContext>;
  benefitsCoverage?: InputMaybe<FilterString>;
  benefitsPrice?: InputMaybe<FilterString>;
  benefitsQuestionType?: InputMaybe<FilterString>;
  billDisputeType?: InputMaybe<FilterString>;
  caseManagementClosureReason?: InputMaybe<FilterString>;
  caseManagementRelatedIssueCount?: InputMaybe<FilterInt>;
  caseManagementType?: InputMaybe<FilterString>;
  caseRecommendation?: InputMaybe<FilterJSON>;
  caseRecommendationGeneratedAt?: InputMaybe<FilterString>;
  caseRef?: InputMaybe<FilterString>;
  caseSeq?: InputMaybe<FilterInt64>;
  caseType?: InputMaybe<FilterString>;
  closedAt?: InputMaybe<FilterString>;
  coverageType?: InputMaybe<FilterString>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  dollarAmountSaved?: InputMaybe<FilterDecimal>;
  engineState?: InputMaybe<FilterString>;
  eobId?: InputMaybe<FilterString>;
  estimatedDollarAmountSaved?: InputMaybe<FilterDecimal>;
  events?: InputMaybe<issue__NestedFilterEvent>;
  firstUnseenEvent?: InputMaybe<issue__NestedFilterEvent>;
  followUpDate?: InputMaybe<FilterString>;
  hasActions?: InputMaybe<FilterBoolean>;
  hasReengagementReason?: InputMaybe<FilterBoolean>;
  hasStaffParticipant?: InputMaybe<FilterBoolean>;
  healthRecordKey?: InputMaybe<FilterString>;
  healthRecordKind?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  intake?: InputMaybe<intake__NestedFilterIntakeRecord>;
  isEscalated?: InputMaybe<FilterBoolean>;
  isPriorityDemoted?: InputMaybe<FilterBoolean>;
  issueType?: InputMaybe<FilterString>;
  labelsText?: InputMaybe<FilterString>;
  lastEvent?: InputMaybe<issue__NestedFilterEvent>;
  lastNonUserEvent?: InputMaybe<issue__NestedFilterEvent>;
  lastSeenAt?: InputMaybe<FilterString>;
  nateraIntake?: InputMaybe<FilterJSON>;
  nextSteps?: InputMaybe<FilterString>;
  not?: InputMaybe<issue__FilterIssue>;
  openedAt?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<issue__FilterIssue>>;
  owner?: InputMaybe<NestedFilterUser>;
  ownerSegmentsText?: InputMaybe<FilterString>;
  paymentPreferences?: InputMaybe<issue__NestedFilterPaymentPreferences>;
  person?: InputMaybe<NestedFilterPerson>;
  priorityOverride?: InputMaybe<Filterissue__PriorityOverride>;
  priorityOverrideSetAt?: InputMaybe<FilterString>;
  priorityOverrideSetBy?: InputMaybe<NestedFilterUser>;
  promoCodeUsages?: InputMaybe<payment__NestedFilterIssuePromoCodeUsage>;
  providerDetail?: InputMaybe<provider__NestedFilterProvider>;
  providerName?: InputMaybe<FilterString>;
  reengagementReason?: InputMaybe<Filterissue__ReengagementReason>;
  resolutionPreferences?: InputMaybe<issue__NestedFilterResolutionPreferences>;
  staffDisplayProfile?: InputMaybe<user__NestedFilterProfile>;
  tasks?: InputMaybe<taskManagement__NestedFilterIssueTask>;
  title?: InputMaybe<FilterString>;
  titleIsGenerated?: InputMaybe<FilterBoolean>;
  totalBillDollarAmount?: InputMaybe<FilterDecimal>;
  userVisibleEvents?: InputMaybe<issue__NestedFilterEvent>;
};

export type issue__FilterIssueDocumentSummary = {
  analysisResult?: InputMaybe<FilterJSON>;
  and?: InputMaybe<Array<issue__FilterIssueDocumentSummary>>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentDetails?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  modelId?: InputMaybe<FilterString>;
  not?: InputMaybe<issue__FilterIssueDocumentSummary>;
  or?: InputMaybe<Array<issue__FilterIssueDocumentSummary>>;
  schemaVersion?: InputMaybe<FilterInt>;
  summary?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__FilterOutreachEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterOutreachEvent>>;
  ask?: InputMaybe<issue__NestedFilterEvent>;
  askKind?: InputMaybe<FilterString>;
  attemptNumber?: InputMaybe<FilterInt>;
  caseIntake?: InputMaybe<FilterBoolean>;
  channel?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterOutreachEvent>;
  or?: InputMaybe<Array<issue__FilterOutreachEvent>>;
  outreachBody?: InputMaybe<FilterString>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPaymentAgreementPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterPaymentAgreementPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterPaymentAgreementRequestedEvent>;
  not?: InputMaybe<issue__FilterPaymentAgreementPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterPaymentAgreementPostEscalationAction>>;
};

export type issue__FilterPaymentAgreementRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPaymentAgreementRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPaymentAgreementRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterPaymentAgreementRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userAccepted?: InputMaybe<FilterBoolean>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPaymentChargeFailedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPaymentChargeFailedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPaymentChargeFailedEvent>;
  or?: InputMaybe<Array<issue__FilterPaymentChargeFailedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  paymentResolvedAt?: InputMaybe<FilterString>;
  paymentResolvedReason?: InputMaybe<Filterissue__PaymentChargeResolvedReason>;
  paymentTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPaymentChargeResolvedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPaymentChargeResolvedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chargeRecoveryReason?: InputMaybe<Filterissue__PaymentChargeResolvedReason>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPaymentChargeResolvedEvent>;
  or?: InputMaybe<Array<issue__FilterPaymentChargeResolvedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  resolvedFailure?: InputMaybe<issue__NestedFilterPaymentChargeFailedEvent>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPaymentPreferences = {
  acceptAny?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPaymentPreferences>>;
  appliedPromoCode?: InputMaybe<payment__NestedFilterPromoCode>;
  autoPayAuthorized?: InputMaybe<FilterBoolean>;
  caseType?: InputMaybe<Filterissue__PaymentCaseType>;
  contract?: InputMaybe<Filterissue__PaymentAgreementContract>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  maxSettle?: InputMaybe<FilterInt64>;
  maxSingleCharge?: InputMaybe<FilterInt64>;
  not?: InputMaybe<issue__FilterPaymentPreferences>;
  note?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<issue__FilterPaymentPreferences>>;
  paymentPlanMaxMonthly?: InputMaybe<FilterInt64>;
  paymentPlanRequested?: InputMaybe<FilterBoolean>;
  providerRelationship?: InputMaybe<Filterissue__ProviderRelationship>;
  requestedEvent?: InputMaybe<issue__NestedFilterPaymentPreferencesRequestedEvent>;
  resolvedFeeCap?: InputMaybe<FilterInt64>;
  successFeePercent?: InputMaybe<FilterInt>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__FilterPaymentPreferencesPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterPaymentPreferencesPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterPaymentPreferencesRequestedEvent>;
  not?: InputMaybe<issue__FilterPaymentPreferencesPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterPaymentPreferencesPostEscalationAction>>;
};

export type issue__FilterPaymentPreferencesRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPaymentPreferencesRequestedEvent>>;
  appliedPromoCode?: InputMaybe<payment__NestedFilterPromoCode>;
  cancelledAt?: InputMaybe<FilterString>;
  caseIntake?: InputMaybe<FilterBoolean>;
  caseType?: InputMaybe<Filterissue__PaymentCaseType>;
  confirmedAt?: InputMaybe<FilterString>;
  contract?: InputMaybe<Filterissue__PaymentAgreementContract>;
  declinedAt?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  feeAcknowledgedAt?: InputMaybe<FilterString>;
  feePercentSnapshot?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPaymentPreferencesRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterPaymentPreferencesRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  preAuthStatus?: InputMaybe<Filterissue__PreAuthStatus>;
  preAuthTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  preferences?: InputMaybe<issue__NestedFilterPaymentPreferences>;
  requestKey?: InputMaybe<FilterString>;
  resolvedFeeCap?: InputMaybe<FilterInt64>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPaymentPreferencesUpdatedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPaymentPreferencesUpdatedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPaymentPreferencesUpdatedEvent>;
  or?: InputMaybe<Array<issue__FilterPaymentPreferencesUpdatedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  prefsAutoPayAfter?: InputMaybe<FilterBoolean>;
  prefsAutoPayBefore?: InputMaybe<FilterBoolean>;
  prefsMaxChargeAfter?: InputMaybe<FilterInt64>;
  prefsMaxChargeBefore?: InputMaybe<FilterInt64>;
  prefsMaxSettleAfter?: InputMaybe<FilterInt64>;
  prefsMaxSettleBefore?: InputMaybe<FilterInt64>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPhoneCallEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  aircallId?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<issue__FilterPhoneCallEvent>>;
  callOutcome?: InputMaybe<FilterString>;
  callType?: InputMaybe<FilterString>;
  caseIntake?: InputMaybe<FilterBoolean>;
  durationMinutes?: InputMaybe<FilterFloat>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  hasVoicemail?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  isInbound?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPhoneCallEvent>;
  or?: InputMaybe<Array<issue__FilterPhoneCallEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  phoneNumber?: InputMaybe<FilterString>;
  recordingUrl?: InputMaybe<FilterString>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  summary?: InputMaybe<FilterString>;
  summaryFetchedAt?: InputMaybe<FilterString>;
  summarySource?: InputMaybe<FilterString>;
  transcript?: InputMaybe<FilterString>;
  transcriptFetchedAt?: InputMaybe<FilterString>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPlanSelectionEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPlanSelectionEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  isResolved?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPlanSelectionEvent>;
  options?: InputMaybe<plan__NestedFilterPlan>;
  or?: InputMaybe<Array<issue__FilterPlanSelectionEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  selectedPlan?: InputMaybe<plan__NestedFilterPlan>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<issue__FilterPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterPostEscalationAction>>;
};

export type issue__FilterPostEscalationActionsEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  actions?: InputMaybe<issue__NestedFilterPostEscalationAction>;
  and?: InputMaybe<Array<issue__FilterPostEscalationActionsEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPostEscalationActionsEvent>;
  or?: InputMaybe<Array<issue__FilterPostEscalationActionsEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterPreAuthRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterPreAuthRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterPreAuthRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterPreAuthRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  preAuthStatus?: InputMaybe<Filterissue__PreAuthStatus>;
  preAuthTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterReopenedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterReopenedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterReopenedEvent>;
  or?: InputMaybe<Array<issue__FilterReopenedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterResolutionPreferences = {
  and?: InputMaybe<Array<issue__FilterResolutionPreferences>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minimumDiscountPercent?: InputMaybe<FilterInt>;
  not?: InputMaybe<issue__FilterResolutionPreferences>;
  or?: InputMaybe<Array<issue__FilterResolutionPreferences>>;
  owner?: InputMaybe<NestedFilterUser>;
  savingsPreference?: InputMaybe<Filterissue__SavingsPreference>;
  successFeePercent?: InputMaybe<FilterInt>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__FilterSignTemplatePostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterSignTemplatePostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterTemplateReleaseRequestedEvent>;
  not?: InputMaybe<issue__FilterSignTemplatePostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterSignTemplatePostEscalationAction>>;
};

export type issue__FilterTemplateReleaseRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterTemplateReleaseRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterTemplateReleaseRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterTemplateReleaseRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  release?: InputMaybe<consent__NestedFilterTemplateRelease>;
  requestKey?: InputMaybe<FilterString>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterToolExecutionEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterToolExecutionEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  not?: InputMaybe<issue__FilterToolExecutionEvent>;
  or?: InputMaybe<Array<issue__FilterToolExecutionEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  toolInput?: InputMaybe<FilterJSON>;
  toolName?: InputMaybe<FilterString>;
  toolOutput?: InputMaybe<FilterString>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterUploadBillPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterUploadBillPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  not?: InputMaybe<issue__FilterUploadBillPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterUploadBillPostEscalationAction>>;
};

export type issue__FilterUploadEobPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterUploadEobPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  not?: InputMaybe<issue__FilterUploadEobPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterUploadEobPostEscalationAction>>;
};

export type issue__FilterUploadMemberIdPostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterUploadMemberIdPostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  not?: InputMaybe<issue__FilterUploadMemberIdPostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterUploadMemberIdPostEscalationAction>>;
};

export type issue__FilterUploadProofOfIncomePostEscalationAction = {
  and?: InputMaybe<Array<issue__FilterUploadProofOfIncomePostEscalationAction>>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  linkedEvent?: InputMaybe<issue__NestedFilterDocumentUploadedEvent>;
  not?: InputMaybe<issue__FilterUploadProofOfIncomePostEscalationAction>;
  or?: InputMaybe<Array<issue__FilterUploadProofOfIncomePostEscalationAction>>;
};

export type issue__FilterUserInputRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterUserInputRequestedEvent>>;
  answerValue?: InputMaybe<FilterJSON>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  fieldSpec?: InputMaybe<FilterJSON>;
  freeTextAllowed?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  isResolved?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  message?: InputMaybe<FilterString>;
  not?: InputMaybe<issue__FilterUserInputRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterUserInputRequestedEvent>>;
  outcome?: InputMaybe<Filterissue__InputOutcome>;
  participant?: InputMaybe<FilterParticipant>;
  resolvedAt?: InputMaybe<FilterString>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  skippable?: InputMaybe<FilterBoolean>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterUserMultiSelectionRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterUserMultiSelectionRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  message?: InputMaybe<FilterString>;
  not?: InputMaybe<issue__FilterUserMultiSelectionRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterUserMultiSelectionRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FilterUserSelectionRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<issue__FilterUserSelectionRequestedEvent>>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  message?: InputMaybe<FilterString>;
  not?: InputMaybe<issue__FilterUserSelectionRequestedEvent>;
  or?: InputMaybe<Array<issue__FilterUserSelectionRequestedEvent>>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__FinancialAssistanceFlowEvent = {
  actionRequired: Scalars['Boolean']['output'];
  application: fa__Application;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  handoffMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__FinancialAssistanceFlowEventapplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fa__FilterApplication>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fa__OrderApplication>;
};


export type issue__FinancialAssistanceFlowEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__FinancialAssistanceFlowEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__FinancialAssistanceFlowEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__FinancialAssistanceFlowEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__FinancialAssistanceFlowEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__FinancialAssistanceFlowEvent_Type = BaseObject & Object & issue__Event & issue__FinancialAssistanceFlowEvent & {
  __typename: 'issue__FinancialAssistanceFlowEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  application: fa__Application;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  handoffMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__FinancialAssistanceFlowEvent_TypeapplicationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fa__FilterApplication>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fa__OrderApplication>;
};


export type issue__FinancialAssistanceFlowEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__FinancialAssistanceFlowEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__FinancialAssistanceFlowEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__FinancialAssistanceFlowEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__FinancialAssistanceFlowEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__HAAssignedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  assigneeAverageCaseRating?: Maybe<Scalars['Float']['output']>;
  assigneeProfile: user__Profile;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__HAAssignedEventassigneeProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__HAAssignedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__HAAssignedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__HAAssignedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__HAAssignedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__HAAssignedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__HAAssignedEvent_Type = BaseObject & Object & issue__Event & issue__HAAssignedEvent & {
  __typename: 'issue__HAAssignedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  assigneeAverageCaseRating?: Maybe<Scalars['Float']['output']>;
  assigneeProfile: user__Profile;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__HAAssignedEvent_TypeassigneeProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__HAAssignedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__HAAssignedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__HAAssignedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__HAAssignedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__HAAssignedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__HipaaReleaseRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  hipaaRelease: consent__HipaaRelease;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__HipaaReleaseRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__HipaaReleaseRequestedEventhipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type issue__HipaaReleaseRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__HipaaReleaseRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__HipaaReleaseRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__HipaaReleaseRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__HipaaReleaseRequestedEvent_Type = BaseObject & Object & issue__Event & issue__HipaaReleaseRequestedEvent & {
  __typename: 'issue__HipaaReleaseRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  hipaaRelease: consent__HipaaRelease;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__HipaaReleaseRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__HipaaReleaseRequestedEvent_TypehipaaReleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterHipaaRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderHipaaRelease>;
};


export type issue__HipaaReleaseRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__HipaaReleaseRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__HipaaReleaseRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__HipaaReleaseRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__InputOutcome {
  ANSWERED = 'ANSWERED',
  SKIPPED = 'SKIPPED'
}

export type issue__InternalDocumentUploadedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  internalDocument: document__Document;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__InternalDocumentUploadedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__InternalDocumentUploadedEventinternalDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__InternalDocumentUploadedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__InternalDocumentUploadedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__InternalDocumentUploadedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__InternalDocumentUploadedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__InternalDocumentUploadedEvent_Type = BaseObject & Object & issue__Event & issue__InternalDocumentUploadedEvent & {
  __typename: 'issue__InternalDocumentUploadedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  internalDocument: document__Document;
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__InternalDocumentUploadedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__InternalDocumentUploadedEvent_TypeinternalDocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__InternalDocumentUploadedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__InternalDocumentUploadedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__InternalDocumentUploadedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__InternalDocumentUploadedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__Issue = {
  actions?: Maybe<Array<issue__Event>>;
  additionalDetails?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  benefitsContext?: Maybe<issue__BenefitsContext>;
  benefitsCoverage?: Maybe<Scalars['String']['output']>;
  benefitsInclude?: Maybe<Array<Scalars['String']['output']>>;
  benefitsPrice?: Maybe<Scalars['String']['output']>;
  benefitsQuestionType?: Maybe<Scalars['String']['output']>;
  billDisputeType?: Maybe<Scalars['String']['output']>;
  caseManagementClosureReason?: Maybe<Scalars['String']['output']>;
  caseManagementRelatedIssueCount?: Maybe<Scalars['Int']['output']>;
  caseManagementType?: Maybe<Scalars['String']['output']>;
  caseRecommendation?: Maybe<Scalars['JSON']['output']>;
  caseRecommendationGeneratedAt?: Maybe<Scalars['String']['output']>;
  caseRef: Scalars['String']['output'];
  caseSeq: Scalars['Int64']['output'];
  caseType?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  completedPostEscalationActions: Array<issue__PostEscalationActionType>;
  coverageType?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<document__Document>>;
  dollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  engineState: Scalars['String']['output'];
  eobId?: Maybe<Scalars['String']['output']>;
  estimatedDollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  events?: Maybe<Array<issue__Event>>;
  firstUnseenEvent?: Maybe<issue__Event>;
  followUpDate?: Maybe<Scalars['String']['output']>;
  hasActions: Scalars['Boolean']['output'];
  hasReengagementReason: Scalars['Boolean']['output'];
  hasStaffParticipant: Scalars['Boolean']['output'];
  healthRecordKey?: Maybe<Scalars['String']['output']>;
  healthRecordKind?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intake?: Maybe<intake__IntakeRecord>;
  isEscalated: Scalars['Boolean']['output'];
  isPriorityDemoted: Scalars['Boolean']['output'];
  issueType?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  labelsText?: Maybe<Scalars['String']['output']>;
  lastEvent?: Maybe<issue__Event>;
  lastNonUserEvent?: Maybe<issue__Event>;
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  nateraIntake?: Maybe<Scalars['JSON']['output']>;
  nextSteps?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['String']['output'];
  owner: User;
  ownerSegmentsText: Scalars['String']['output'];
  paymentPreferences?: Maybe<issue__PaymentPreferences>;
  /**
   * Actions with pending uploads awaiting classification. Used to show
   * "processing" state in the UI so members know their upload was received.
   */
  pendingPostEscalationActions: Array<issue__PostEscalationActionType>;
  person?: Maybe<Person>;
  priorityOverride?: Maybe<issue__PriorityOverride>;
  priorityOverrideSetAt?: Maybe<Scalars['String']['output']>;
  priorityOverrideSetBy?: Maybe<User>;
  promoCodeUsages?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  providerDetail?: Maybe<provider__Provider>;
  providerName?: Maybe<Scalars['String']['output']>;
  /**
   * The latest HA recommendation for this issue, or null if no
   * recommendation is stored. `null` does NOT distinguish "never run" from
   * "generation attempted and failed" — the generator stamps the Gel
   * scalar `caseRecommendationGeneratedAt` only on first attempt so the UI
   * can render an "unavailable" state without clobbering the timestamp on
   * retried/regenerated runs that fail. Query `caseRecommendationGeneratedAt`
   * alongside `recommendation` to disambiguate:
   *   - caseRecommendationGeneratedAt null + recommendation null → never generated
   *   - caseRecommendationGeneratedAt set  + recommendation null → attempted and failed
   *   - caseRecommendationGeneratedAt set  + recommendation set  → available
   */
  recommendation?: Maybe<CaseRecommendation>;
  reengagementReason?: Maybe<issue__ReengagementReason>;
  resolutionPreferences?: Maybe<issue__ResolutionPreferences>;
  staffDisplayProfile?: Maybe<user__Profile>;
  tasks?: Maybe<Array<taskManagement__IssueTask>>;
  title?: Maybe<Scalars['String']['output']>;
  titleIsGenerated?: Maybe<Scalars['Boolean']['output']>;
  totalBillDollarAmount?: Maybe<Scalars['Decimal']['output']>;
  userVisibleEvents?: Maybe<Array<issue__Event>>;
};


export type issue__IssueactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssueassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__IssuebenefitsContextArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsContext>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsContext>;
};


export type issue__IssuedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__IssueeventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssuefirstUnseenEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssueintakeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<intake__FilterIntakeRecord>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<intake__OrderIntakeRecord>;
};


export type issue__IssuelastEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssuelastNonUserEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__IssueownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__IssuepaymentPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferences>;
};


export type issue__IssuepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type issue__IssuepriorityOverrideSetByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__IssuepromoCodeUsagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type issue__IssueproviderDetailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type issue__IssueresolutionPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterResolutionPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderResolutionPreferences>;
};


export type issue__IssuestaffDisplayProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__IssuetasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};


export type issue__IssueuserVisibleEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};

export type issue__IssueDocumentSummary = {
  analysisResult: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  documentDetails?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  modelId?: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type issue__IssueDocumentSummarydocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__IssueDocumentSummaryissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type issue__IssueDocumentSummary_Type = BaseObject & Object & document__DocumentSummary & issue__IssueDocumentSummary & {
  __typename: 'issue__IssueDocumentSummary_Type';
  analysisResult: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  document: document__Document;
  documentDetails?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  modelId?: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Int']['output'];
  summary: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type issue__IssueDocumentSummary_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__IssueDocumentSummary_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type issue__Issue_Type = BaseObject & Object & Owned & Personal & issue__Issue & {
  __typename: 'issue__Issue_Type';
  actions?: Maybe<Array<issue__Event>>;
  additionalDetails?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  benefitsContext?: Maybe<issue__BenefitsContext>;
  benefitsCoverage?: Maybe<Scalars['String']['output']>;
  benefitsInclude?: Maybe<Array<Scalars['String']['output']>>;
  benefitsPrice?: Maybe<Scalars['String']['output']>;
  benefitsQuestionType?: Maybe<Scalars['String']['output']>;
  billDisputeType?: Maybe<Scalars['String']['output']>;
  caseManagementClosureReason?: Maybe<Scalars['String']['output']>;
  caseManagementRelatedIssueCount?: Maybe<Scalars['Int']['output']>;
  caseManagementType?: Maybe<Scalars['String']['output']>;
  caseRecommendation?: Maybe<Scalars['JSON']['output']>;
  caseRecommendationGeneratedAt?: Maybe<Scalars['String']['output']>;
  caseRef: Scalars['String']['output'];
  caseSeq: Scalars['Int64']['output'];
  caseType?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  completedPostEscalationActions: Array<issue__PostEscalationActionType>;
  coverageType?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<document__Document>>;
  dollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  engineState: Scalars['String']['output'];
  eobId?: Maybe<Scalars['String']['output']>;
  estimatedDollarAmountSaved?: Maybe<Scalars['Decimal']['output']>;
  events?: Maybe<Array<issue__Event>>;
  firstUnseenEvent?: Maybe<issue__Event>;
  followUpDate?: Maybe<Scalars['String']['output']>;
  hasActions: Scalars['Boolean']['output'];
  hasReengagementReason: Scalars['Boolean']['output'];
  hasStaffParticipant: Scalars['Boolean']['output'];
  healthRecordKey?: Maybe<Scalars['String']['output']>;
  healthRecordKind?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intake?: Maybe<intake__IntakeRecord>;
  isEscalated: Scalars['Boolean']['output'];
  isPriorityDemoted: Scalars['Boolean']['output'];
  issueType?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Scalars['String']['output']>>;
  labelsText?: Maybe<Scalars['String']['output']>;
  lastEvent?: Maybe<issue__Event>;
  lastNonUserEvent?: Maybe<issue__Event>;
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  nateraIntake?: Maybe<Scalars['JSON']['output']>;
  nextSteps?: Maybe<Scalars['String']['output']>;
  openedAt: Scalars['String']['output'];
  owner: User;
  ownerSegmentsText: Scalars['String']['output'];
  paymentPreferences?: Maybe<issue__PaymentPreferences>;
  pendingPostEscalationActions: Array<issue__PostEscalationActionType>;
  person?: Maybe<Person>;
  priorityOverride?: Maybe<issue__PriorityOverride>;
  priorityOverrideSetAt?: Maybe<Scalars['String']['output']>;
  priorityOverrideSetBy?: Maybe<User>;
  promoCodeUsages?: Maybe<Array<payment__IssuePromoCodeUsage>>;
  providerDetail?: Maybe<provider__Provider>;
  providerName?: Maybe<Scalars['String']['output']>;
  /**
   * See the docstring on `issue__Issue.recommendation` — `null` plus a
   * non-null `caseRecommendationGeneratedAt` means generation was attempted
   * and failed; query both fields together.
   */
  recommendation?: Maybe<CaseRecommendation>;
  reengagementReason?: Maybe<issue__ReengagementReason>;
  resolutionPreferences?: Maybe<issue__ResolutionPreferences>;
  staffDisplayProfile?: Maybe<user__Profile>;
  tasks?: Maybe<Array<taskManagement__IssueTask>>;
  title?: Maybe<Scalars['String']['output']>;
  titleIsGenerated?: Maybe<Scalars['Boolean']['output']>;
  totalBillDollarAmount?: Maybe<Scalars['Decimal']['output']>;
  userVisibleEvents?: Maybe<Array<issue__Event>>;
};


export type issue__Issue_TypeactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__Issue_TypebenefitsContextArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsContext>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsContext>;
};


export type issue__Issue_TypedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type issue__Issue_TypeeventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypefirstUnseenEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypeintakeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<intake__FilterIntakeRecord>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<intake__OrderIntakeRecord>;
};


export type issue__Issue_TypelastEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypelastNonUserEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__Issue_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__Issue_TypepaymentPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferences>;
};


export type issue__Issue_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};


export type issue__Issue_TypepriorityOverrideSetByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__Issue_TypepromoCodeUsagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderIssuePromoCodeUsage>;
};


export type issue__Issue_TypeproviderDetailArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type issue__Issue_TyperesolutionPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterResolutionPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderResolutionPreferences>;
};


export type issue__Issue_TypestaffDisplayProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__Issue_TypetasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};


export type issue__Issue_TypeuserVisibleEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};

export type issue__NestedFilterBenefitsContext = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  selectedAt?: InputMaybe<FilterString>;
  selectedPlan?: InputMaybe<plan__NestedFilterPlan>;
};

export type issue__NestedFilterBenefitsSummaryGeneratedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  plan?: InputMaybe<plan__NestedFilterPlan>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterBillPayRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  declinedAt?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  preAuthStatus?: InputMaybe<Filterissue__PreAuthStatus>;
  preAuthTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterBillPaymentRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  billAmount?: InputMaybe<FilterDecimal>;
  billPaid?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterClosedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  caseManagementClosureReason?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  feedback?: InputMaybe<feedback__NestedFilterIssueFeedback>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userClosureReason?: InputMaybe<Filterissue__UserClosureReason>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterConnectAccountRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  buttonText?: InputMaybe<FilterString>;
  caseIntake?: InputMaybe<FilterBoolean>;
  chatBody?: InputMaybe<FilterString>;
  endpointType?: InputMaybe<FilterwebAgent__EndpointType>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  showSkipButton?: InputMaybe<FilterBoolean>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterDocumentUploadedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentLabel?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterFinancialAssistanceFlowEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  application?: InputMaybe<fa__NestedFilterApplication>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  handoffMessage?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isResolved?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterInternalDocumentUploadedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  internalDocument?: InputMaybe<document__NestedFilterDocument>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterIssue = {
  actions?: InputMaybe<issue__NestedFilterEvent>;
  additionalDetails?: InputMaybe<FilterString>;
  assignee?: InputMaybe<NestedFilterUser>;
  benefitsContext?: InputMaybe<issue__NestedFilterBenefitsContext>;
  benefitsCoverage?: InputMaybe<FilterString>;
  benefitsPrice?: InputMaybe<FilterString>;
  benefitsQuestionType?: InputMaybe<FilterString>;
  billDisputeType?: InputMaybe<FilterString>;
  caseManagementClosureReason?: InputMaybe<FilterString>;
  caseManagementRelatedIssueCount?: InputMaybe<FilterInt>;
  caseManagementType?: InputMaybe<FilterString>;
  caseRecommendation?: InputMaybe<FilterJSON>;
  caseRecommendationGeneratedAt?: InputMaybe<FilterString>;
  caseRef?: InputMaybe<FilterString>;
  caseSeq?: InputMaybe<FilterInt64>;
  caseType?: InputMaybe<FilterString>;
  closedAt?: InputMaybe<FilterString>;
  coverageType?: InputMaybe<FilterString>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  dollarAmountSaved?: InputMaybe<FilterDecimal>;
  engineState?: InputMaybe<FilterString>;
  eobId?: InputMaybe<FilterString>;
  estimatedDollarAmountSaved?: InputMaybe<FilterDecimal>;
  events?: InputMaybe<issue__NestedFilterEvent>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  firstUnseenEvent?: InputMaybe<issue__NestedFilterEvent>;
  followUpDate?: InputMaybe<FilterString>;
  hasActions?: InputMaybe<FilterBoolean>;
  hasReengagementReason?: InputMaybe<FilterBoolean>;
  hasStaffParticipant?: InputMaybe<FilterBoolean>;
  healthRecordKey?: InputMaybe<FilterString>;
  healthRecordKind?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  intake?: InputMaybe<intake__NestedFilterIntakeRecord>;
  isEscalated?: InputMaybe<FilterBoolean>;
  isPriorityDemoted?: InputMaybe<FilterBoolean>;
  issueType?: InputMaybe<FilterString>;
  labelsText?: InputMaybe<FilterString>;
  lastEvent?: InputMaybe<issue__NestedFilterEvent>;
  lastNonUserEvent?: InputMaybe<issue__NestedFilterEvent>;
  lastSeenAt?: InputMaybe<FilterString>;
  nateraIntake?: InputMaybe<FilterJSON>;
  nextSteps?: InputMaybe<FilterString>;
  openedAt?: InputMaybe<FilterString>;
  owner?: InputMaybe<NestedFilterUser>;
  ownerSegmentsText?: InputMaybe<FilterString>;
  paymentPreferences?: InputMaybe<issue__NestedFilterPaymentPreferences>;
  person?: InputMaybe<NestedFilterPerson>;
  priorityOverride?: InputMaybe<Filterissue__PriorityOverride>;
  priorityOverrideSetAt?: InputMaybe<FilterString>;
  priorityOverrideSetBy?: InputMaybe<NestedFilterUser>;
  promoCodeUsages?: InputMaybe<payment__NestedFilterIssuePromoCodeUsage>;
  providerDetail?: InputMaybe<provider__NestedFilterProvider>;
  providerName?: InputMaybe<FilterString>;
  reengagementReason?: InputMaybe<Filterissue__ReengagementReason>;
  resolutionPreferences?: InputMaybe<issue__NestedFilterResolutionPreferences>;
  staffDisplayProfile?: InputMaybe<user__NestedFilterProfile>;
  tasks?: InputMaybe<taskManagement__NestedFilterIssueTask>;
  title?: InputMaybe<FilterString>;
  titleIsGenerated?: InputMaybe<FilterBoolean>;
  totalBillDollarAmount?: InputMaybe<FilterDecimal>;
  userVisibleEvents?: InputMaybe<issue__NestedFilterEvent>;
};

export type issue__NestedFilterIssueDocumentSummary = {
  analysisResult?: InputMaybe<FilterJSON>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  documentDetails?: InputMaybe<FilterJSON>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  modelId?: InputMaybe<FilterString>;
  schemaVersion?: InputMaybe<FilterInt>;
  summary?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__NestedFilterPaymentAgreementRequestedEvent = {
  acceptedAt?: InputMaybe<FilterString>;
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userAccepted?: InputMaybe<FilterBoolean>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterPaymentChargeFailedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  paymentResolvedAt?: InputMaybe<FilterString>;
  paymentResolvedReason?: InputMaybe<Filterissue__PaymentChargeResolvedReason>;
  paymentTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterPaymentPreferences = {
  acceptAny?: InputMaybe<FilterBoolean>;
  appliedPromoCode?: InputMaybe<payment__NestedFilterPromoCode>;
  autoPayAuthorized?: InputMaybe<FilterBoolean>;
  caseType?: InputMaybe<Filterissue__PaymentCaseType>;
  contract?: InputMaybe<Filterissue__PaymentAgreementContract>;
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  maxSettle?: InputMaybe<FilterInt64>;
  maxSingleCharge?: InputMaybe<FilterInt64>;
  note?: InputMaybe<FilterString>;
  paymentPlanMaxMonthly?: InputMaybe<FilterInt64>;
  paymentPlanRequested?: InputMaybe<FilterBoolean>;
  providerRelationship?: InputMaybe<Filterissue__ProviderRelationship>;
  requestedEvent?: InputMaybe<issue__NestedFilterPaymentPreferencesRequestedEvent>;
  resolvedFeeCap?: InputMaybe<FilterInt64>;
  successFeePercent?: InputMaybe<FilterInt>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__NestedFilterPaymentPreferencesRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  appliedPromoCode?: InputMaybe<payment__NestedFilterPromoCode>;
  cancelledAt?: InputMaybe<FilterString>;
  caseIntake?: InputMaybe<FilterBoolean>;
  caseType?: InputMaybe<Filterissue__PaymentCaseType>;
  confirmedAt?: InputMaybe<FilterString>;
  contract?: InputMaybe<Filterissue__PaymentAgreementContract>;
  declinedAt?: InputMaybe<FilterString>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  feeAcknowledgedAt?: InputMaybe<FilterString>;
  feePercentSnapshot?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  preAuthStatus?: InputMaybe<Filterissue__PreAuthStatus>;
  preAuthTransaction?: InputMaybe<payment__NestedFilterPaymentTransaction>;
  preferences?: InputMaybe<issue__NestedFilterPaymentPreferences>;
  requestKey?: InputMaybe<FilterString>;
  resolvedFeeCap?: InputMaybe<FilterInt64>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterPhoneCallEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  aircallId?: InputMaybe<FilterString>;
  callOutcome?: InputMaybe<FilterString>;
  callType?: InputMaybe<FilterString>;
  caseIntake?: InputMaybe<FilterBoolean>;
  durationMinutes?: InputMaybe<FilterFloat>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasVoicemail?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  isInbound?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  phoneNumber?: InputMaybe<FilterString>;
  recordingUrl?: InputMaybe<FilterString>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  summary?: InputMaybe<FilterString>;
  summaryFetchedAt?: InputMaybe<FilterString>;
  summarySource?: InputMaybe<FilterString>;
  transcript?: InputMaybe<FilterString>;
  transcriptFetchedAt?: InputMaybe<FilterString>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__NestedFilterPostEscalationAction = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isRequired?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
};

export type issue__NestedFilterResolutionPreferences = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minimumDiscountPercent?: InputMaybe<FilterInt>;
  owner?: InputMaybe<NestedFilterUser>;
  savingsPreference?: InputMaybe<Filterissue__SavingsPreference>;
  successFeePercent?: InputMaybe<FilterInt>;
  updatedAt?: InputMaybe<FilterString>;
};

export type issue__NestedFilterTemplateReleaseRequestedEvent = {
  actionRequired?: InputMaybe<FilterBoolean>;
  caseIntake?: InputMaybe<FilterBoolean>;
  eventFeedbacks?: InputMaybe<feedback__NestedFilterIssueEventFeedback>;
  eventType?: InputMaybe<Filterissue__EventType>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  llmExecution?: InputMaybe<modelExecution__NestedFilterLLMExecution>;
  participant?: InputMaybe<FilterParticipant>;
  release?: InputMaybe<consent__NestedFilterTemplateRelease>;
  requestKey?: InputMaybe<FilterString>;
  seenAt?: InputMaybe<FilterString>;
  sentAt?: InputMaybe<FilterString>;
  sentBy?: InputMaybe<NestedFilterUser>;
  sentByProfile?: InputMaybe<user__NestedFilterProfile>;
  template?: InputMaybe<document__NestedFilterTemplate>;
  userVisible?: InputMaybe<FilterBoolean>;
};

export type issue__OrderAskReraisedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  reraisedAsk?: InputMaybe<issue__OrderEvent>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBenefitsContext = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  selectedAt?: InputMaybe<Ordering>;
  selectedPlan?: InputMaybe<plan__OrderPlan>;
};

export type issue__OrderBenefitsSummaryGeneratedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  plan?: InputMaybe<plan__OrderPlan>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillDisputeEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eobId?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  healthRecordKey?: InputMaybe<Ordering>;
  healthRecordKind?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  invoiceId?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillPayPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderBillPayRequestedEvent>;
};

export type issue__OrderBillPayRequestedEvent = {
  acceptedAt?: InputMaybe<Ordering>;
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  declinedAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  preAuthStatus?: InputMaybe<Ordering>;
  preAuthTransaction?: InputMaybe<payment__OrderPaymentTransaction>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillPaySuccessEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  chargeTransaction?: InputMaybe<payment__OrderPaymentTransaction>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  negotiatedBillAmount?: InputMaybe<Ordering>;
  originalBillAmount?: InputMaybe<Ordering>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  successFeeAmount?: InputMaybe<Ordering>;
  successFeePercent?: InputMaybe<Ordering>;
  totalCharged?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillPaymentRequestedEvent = {
  acceptedAt?: InputMaybe<Ordering>;
  actionRequired?: InputMaybe<Ordering>;
  billAmount?: InputMaybe<Ordering>;
  billPaid?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderBillPaymentSuccessEvent = {
  actionRequired?: InputMaybe<Ordering>;
  billAmount?: InputMaybe<Ordering>;
  billPaymentRequest?: InputMaybe<issue__OrderBillPaymentRequestedEvent>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  stripePaymentIntentId?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderCardCollectionRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  cardDeclinedAt?: InputMaybe<Ordering>;
  cardRequestKey?: InputMaybe<Ordering>;
  cardSucceededAt?: InputMaybe<Ordering>;
  cardSupersededAt?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  preAuthStatus?: InputMaybe<Ordering>;
  preAuthTransaction?: InputMaybe<payment__OrderPaymentTransaction>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderChatEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  chatBody?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderClosedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  caseManagementClosureReason?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  feedback?: InputMaybe<feedback__OrderIssueFeedback>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userClosureReason?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderClosurePaymentRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  chargeDate?: InputMaybe<Ordering>;
  chargeDelayDays?: InputMaybe<Ordering>;
  dollarAmountSaved?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  successFee?: InputMaybe<Ordering>;
  totalBillDollarAmount?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderCommentEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  comment?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  pinned?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderCompleteFaApplicationPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderFinancialAssistanceFlowEvent>;
};

export type issue__OrderConnectAccountRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  buttonText?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  chatBody?: InputMaybe<Ordering>;
  endpointType?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  showSkipButton?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderConnectEhrPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__OrderConnectInsurancePostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderConnectAccountRequestedEvent>;
};

export type issue__OrderConnectInsuranceRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  insuranceLinkMessage?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderDocumentAnalysisEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  errorIsRetriable?: InputMaybe<Ordering>;
  errorMessage?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  status?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderDocumentClassificationFailedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  classificationResolvedAt?: InputMaybe<Ordering>;
  classificationStatus?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderDocumentUploadedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  documentLabel?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderFaEligibilityInfoPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
};

export type issue__OrderFinancialAssistanceFlowEvent = {
  actionRequired?: InputMaybe<Ordering>;
  application?: InputMaybe<fa__OrderApplication>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  handoffMessage?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isResolved?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderHAAssignedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  assigneeAverageCaseRating?: InputMaybe<Ordering>;
  assigneeProfile?: InputMaybe<user__OrderProfile>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderHipaaReleaseRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  hipaaRelease?: InputMaybe<consent__OrderHipaaRelease>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderInternalDocumentUploadedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  internalDocument?: InputMaybe<document__OrderDocument>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderIssue = {
  additionalDetails?: InputMaybe<Ordering>;
  assignee?: InputMaybe<OrderUser>;
  benefitsContext?: InputMaybe<issue__OrderBenefitsContext>;
  benefitsCoverage?: InputMaybe<Ordering>;
  benefitsPrice?: InputMaybe<Ordering>;
  benefitsQuestionType?: InputMaybe<Ordering>;
  billDisputeType?: InputMaybe<Ordering>;
  caseManagementClosureReason?: InputMaybe<Ordering>;
  caseManagementRelatedIssueCount?: InputMaybe<Ordering>;
  caseManagementType?: InputMaybe<Ordering>;
  caseRecommendation?: InputMaybe<Ordering>;
  caseRecommendationGeneratedAt?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  caseSeq?: InputMaybe<Ordering>;
  caseType?: InputMaybe<Ordering>;
  closedAt?: InputMaybe<Ordering>;
  coverageType?: InputMaybe<Ordering>;
  dollarAmountSaved?: InputMaybe<Ordering>;
  engineState?: InputMaybe<Ordering>;
  eobId?: InputMaybe<Ordering>;
  estimatedDollarAmountSaved?: InputMaybe<Ordering>;
  firstUnseenEvent?: InputMaybe<issue__OrderEvent>;
  followUpDate?: InputMaybe<Ordering>;
  hasActions?: InputMaybe<Ordering>;
  hasReengagementReason?: InputMaybe<Ordering>;
  hasStaffParticipant?: InputMaybe<Ordering>;
  healthRecordKey?: InputMaybe<Ordering>;
  healthRecordKind?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  intake?: InputMaybe<intake__OrderIntakeRecord>;
  isEscalated?: InputMaybe<Ordering>;
  isPriorityDemoted?: InputMaybe<Ordering>;
  issueType?: InputMaybe<Ordering>;
  labelsText?: InputMaybe<Ordering>;
  lastEvent?: InputMaybe<issue__OrderEvent>;
  lastNonUserEvent?: InputMaybe<issue__OrderEvent>;
  lastSeenAt?: InputMaybe<Ordering>;
  nateraIntake?: InputMaybe<Ordering>;
  nextSteps?: InputMaybe<Ordering>;
  openedAt?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  ownerSegmentsText?: InputMaybe<Ordering>;
  paymentPreferences?: InputMaybe<issue__OrderPaymentPreferences>;
  person?: InputMaybe<OrderPerson>;
  priorityOverride?: InputMaybe<Ordering>;
  priorityOverrideSetAt?: InputMaybe<Ordering>;
  priorityOverrideSetBy?: InputMaybe<OrderUser>;
  providerDetail?: InputMaybe<provider__OrderProvider>;
  providerName?: InputMaybe<Ordering>;
  reengagementReason?: InputMaybe<Ordering>;
  resolutionPreferences?: InputMaybe<issue__OrderResolutionPreferences>;
  staffDisplayProfile?: InputMaybe<user__OrderProfile>;
  title?: InputMaybe<Ordering>;
  titleIsGenerated?: InputMaybe<Ordering>;
  totalBillDollarAmount?: InputMaybe<Ordering>;
};

export type issue__OrderIssueDocumentSummary = {
  analysisResult?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  documentDetails?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  modelId?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type issue__OrderOutreachEvent = {
  actionRequired?: InputMaybe<Ordering>;
  ask?: InputMaybe<issue__OrderEvent>;
  askKind?: InputMaybe<Ordering>;
  attemptNumber?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  channel?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  outreachBody?: InputMaybe<Ordering>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPaymentAgreementPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderPaymentAgreementRequestedEvent>;
};

export type issue__OrderPaymentAgreementRequestedEvent = {
  acceptedAt?: InputMaybe<Ordering>;
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userAccepted?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPaymentChargeFailedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  paymentResolvedAt?: InputMaybe<Ordering>;
  paymentResolvedReason?: InputMaybe<Ordering>;
  paymentTransaction?: InputMaybe<payment__OrderPaymentTransaction>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPaymentChargeResolvedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  chargeRecoveryReason?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  resolvedFailure?: InputMaybe<issue__OrderPaymentChargeFailedEvent>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPaymentPreferences = {
  acceptAny?: InputMaybe<Ordering>;
  appliedPromoCode?: InputMaybe<payment__OrderPromoCode>;
  autoPayAuthorized?: InputMaybe<Ordering>;
  caseType?: InputMaybe<Ordering>;
  contract?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  maxSettle?: InputMaybe<Ordering>;
  maxSingleCharge?: InputMaybe<Ordering>;
  note?: InputMaybe<Ordering>;
  paymentPlanMaxMonthly?: InputMaybe<Ordering>;
  paymentPlanRequested?: InputMaybe<Ordering>;
  providerRelationship?: InputMaybe<Ordering>;
  requestedEvent?: InputMaybe<issue__OrderPaymentPreferencesRequestedEvent>;
  resolvedFeeCap?: InputMaybe<Ordering>;
  successFeePercent?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type issue__OrderPaymentPreferencesPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderPaymentPreferencesRequestedEvent>;
};

export type issue__OrderPaymentPreferencesRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  appliedPromoCode?: InputMaybe<payment__OrderPromoCode>;
  cancelledAt?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  caseType?: InputMaybe<Ordering>;
  confirmedAt?: InputMaybe<Ordering>;
  contract?: InputMaybe<Ordering>;
  declinedAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  feeAcknowledgedAt?: InputMaybe<Ordering>;
  feePercentSnapshot?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  preAuthStatus?: InputMaybe<Ordering>;
  preAuthTransaction?: InputMaybe<payment__OrderPaymentTransaction>;
  preferences?: InputMaybe<issue__OrderPaymentPreferences>;
  requestKey?: InputMaybe<Ordering>;
  resolvedFeeCap?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPaymentPreferencesUpdatedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  prefsAutoPayAfter?: InputMaybe<Ordering>;
  prefsAutoPayBefore?: InputMaybe<Ordering>;
  prefsMaxChargeAfter?: InputMaybe<Ordering>;
  prefsMaxChargeBefore?: InputMaybe<Ordering>;
  prefsMaxSettleAfter?: InputMaybe<Ordering>;
  prefsMaxSettleBefore?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPhoneCallEvent = {
  actionRequired?: InputMaybe<Ordering>;
  aircallId?: InputMaybe<Ordering>;
  callOutcome?: InputMaybe<Ordering>;
  callType?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  durationMinutes?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  hasVoicemail?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isInbound?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  phoneNumber?: InputMaybe<Ordering>;
  recordingUrl?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  summary?: InputMaybe<Ordering>;
  summaryFetchedAt?: InputMaybe<Ordering>;
  summarySource?: InputMaybe<Ordering>;
  transcript?: InputMaybe<Ordering>;
  transcriptFetchedAt?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPlanSelectionEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isResolved?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  selectedPlan?: InputMaybe<plan__OrderPlan>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
};

export type issue__OrderPostEscalationActionsEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderPreAuthRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  preAuthStatus?: InputMaybe<Ordering>;
  preAuthTransaction?: InputMaybe<payment__OrderPaymentTransaction>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderReopenedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderResolutionPreferences = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minimumDiscountPercent?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  savingsPreference?: InputMaybe<Ordering>;
  successFeePercent?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type issue__OrderSignTemplatePostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderTemplateReleaseRequestedEvent>;
};

export type issue__OrderTemplateReleaseRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  release?: InputMaybe<consent__OrderTemplateRelease>;
  requestKey?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  template?: InputMaybe<document__OrderTemplate>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderToolExecutionEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  toolInput?: InputMaybe<Ordering>;
  toolName?: InputMaybe<Ordering>;
  toolOutput?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderUploadBillPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__OrderUploadEobPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__OrderUploadMemberIdPostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__OrderUploadProofOfIncomePostEscalationAction = {
  id?: InputMaybe<Ordering>;
  isRequired?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  linkedEvent?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__OrderUserInputRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  answerValue?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  fieldSpec?: InputMaybe<Ordering>;
  freeTextAllowed?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isResolved?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  message?: InputMaybe<Ordering>;
  outcome?: InputMaybe<Ordering>;
  participant?: InputMaybe<Ordering>;
  resolvedAt?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  skippable?: InputMaybe<Ordering>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderUserMultiSelectionRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  message?: InputMaybe<Ordering>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OrderUserSelectionRequestedEvent = {
  actionRequired?: InputMaybe<Ordering>;
  caseIntake?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  llmExecution?: InputMaybe<modelExecution__OrderLLMExecution>;
  message?: InputMaybe<Ordering>;
  participant?: InputMaybe<Ordering>;
  seenAt?: InputMaybe<Ordering>;
  sentAt?: InputMaybe<Ordering>;
  sentBy?: InputMaybe<OrderUser>;
  sentByProfile?: InputMaybe<user__OrderProfile>;
  userVisible?: InputMaybe<Ordering>;
};

export type issue__OutreachEvent = {
  actionRequired: Scalars['Boolean']['output'];
  ask: issue__Event;
  askKind: Scalars['String']['output'];
  attemptNumber: Scalars['Int']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  channel: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  outreachBody: Scalars['String']['output'];
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__OutreachEventaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__OutreachEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__OutreachEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__OutreachEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__OutreachEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__OutreachEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__OutreachEvent_Type = BaseObject & Object & issue__Event & issue__OutreachEvent & {
  __typename: 'issue__OutreachEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  ask: issue__Event;
  askKind: Scalars['String']['output'];
  attemptNumber: Scalars['Int']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  channel: Scalars['String']['output'];
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  outreachBody: Scalars['String']['output'];
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__OutreachEvent_TypeaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type issue__OutreachEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__OutreachEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__OutreachEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__OutreachEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__OutreachEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__PaymentAgreementContract {
  FULL = 'FULL',
  SIMPLIFIED = 'SIMPLIFIED'
}

export type issue__PaymentAgreementPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__PaymentAgreementRequestedEvent;
};


export type issue__PaymentAgreementPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentAgreementPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentAgreementRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentAgreementRequestedEvent>;
};

export type issue__PaymentAgreementPostEscalationAction_Type = BaseObject & Object & issue__PaymentAgreementPostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__PaymentAgreementPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__PaymentAgreementRequestedEvent;
};


export type issue__PaymentAgreementPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentAgreementPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentAgreementRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentAgreementRequestedEvent>;
};

export type issue__PaymentAgreementRequestedEvent = {
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userAccepted?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentAgreementRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentAgreementRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentAgreementRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentAgreementRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentAgreementRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PaymentAgreementRequestedEvent_Type = BaseObject & Object & issue__Event & issue__PaymentAgreementRequestedEvent & {
  __typename: 'issue__PaymentAgreementRequestedEvent_Type';
  acceptedAt?: Maybe<Scalars['String']['output']>;
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userAccepted?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentAgreementRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentAgreementRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentAgreementRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentAgreementRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentAgreementRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__PaymentCaseType {
  FA = 'FA',
  NEGOTIATION = 'NEGOTIATION'
}

export type issue__PaymentChargeFailedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  paymentResolvedAt?: Maybe<Scalars['String']['output']>;
  paymentResolvedReason?: Maybe<issue__PaymentChargeResolvedReason>;
  paymentTransaction: payment__PaymentTransaction;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentChargeFailedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentChargeFailedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentChargeFailedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentChargeFailedEventpaymentTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


export type issue__PaymentChargeFailedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentChargeFailedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PaymentChargeFailedEvent_Type = BaseObject & Object & issue__Event & issue__PaymentChargeFailedEvent & {
  __typename: 'issue__PaymentChargeFailedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  paymentResolvedAt?: Maybe<Scalars['String']['output']>;
  paymentResolvedReason?: Maybe<issue__PaymentChargeResolvedReason>;
  paymentTransaction: payment__PaymentTransaction;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentChargeFailedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentChargeFailedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentChargeFailedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentChargeFailedEvent_TypepaymentTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


export type issue__PaymentChargeFailedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentChargeFailedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PaymentChargeResolvedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeRecoveryReason?: Maybe<issue__PaymentChargeResolvedReason>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  resolvedFailure: issue__PaymentChargeFailedEvent;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentChargeResolvedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentChargeResolvedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentChargeResolvedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentChargeResolvedEventresolvedFailureArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentChargeFailedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentChargeFailedEvent>;
};


export type issue__PaymentChargeResolvedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentChargeResolvedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PaymentChargeResolvedEvent_Type = BaseObject & Object & issue__Event & issue__PaymentChargeResolvedEvent & {
  __typename: 'issue__PaymentChargeResolvedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  chargeRecoveryReason?: Maybe<issue__PaymentChargeResolvedReason>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  resolvedFailure: issue__PaymentChargeFailedEvent;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PaymentChargeResolvedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PaymentChargeResolvedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentChargeResolvedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PaymentChargeResolvedEvent_TyperesolvedFailureArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentChargeFailedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentChargeFailedEvent>;
};


export type issue__PaymentChargeResolvedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PaymentChargeResolvedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__PaymentChargeResolvedReason {
  CARD_UPDATED = 'CARD_UPDATED',
  RETRY_READY = 'RETRY_READY'
}

/** Confirmed payment preferences, captured when the user confirms a PaymentPreferencesRequestedEvent. One per case. */
export type issue__PaymentPreferences = {
  acceptAny?: Maybe<Scalars['Boolean']['output']>;
  appliedPromoCode?: Maybe<payment__PromoCode>;
  autoPayAuthorized?: Maybe<Scalars['Boolean']['output']>;
  caseType: issue__PaymentCaseType;
  contract: issue__PaymentAgreementContract;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  maxSettle?: Maybe<Scalars['Int64']['output']>;
  maxSingleCharge?: Maybe<Scalars['Int64']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paymentPlanMaxMonthly?: Maybe<Scalars['Int64']['output']>;
  paymentPlanRequested?: Maybe<Scalars['Boolean']['output']>;
  providerRelationship?: Maybe<issue__ProviderRelationship>;
  requestedEvent: issue__PaymentPreferencesRequestedEvent;
  resolvedFeeCap: Scalars['Int64']['output'];
  successFeePercent: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};


/** Confirmed payment preferences, captured when the user confirms a PaymentPreferencesRequestedEvent. One per case. */
export type issue__PaymentPreferencesappliedPromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};


/** Confirmed payment preferences, captured when the user confirms a PaymentPreferencesRequestedEvent. One per case. */
export type issue__PaymentPreferencesissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Confirmed payment preferences, captured when the user confirms a PaymentPreferencesRequestedEvent. One per case. */
export type issue__PaymentPreferencesrequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferencesRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferencesRequestedEvent>;
};

export type issue__PaymentPreferencesPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__PaymentPreferencesRequestedEvent;
};


export type issue__PaymentPreferencesPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentPreferencesPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferencesRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferencesRequestedEvent>;
};

export type issue__PaymentPreferencesPostEscalationAction_Type = BaseObject & Object & issue__PaymentPreferencesPostEscalationAction & issue__PostEscalationAction & {
  __typename: 'issue__PaymentPreferencesPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__PaymentPreferencesRequestedEvent;
};


export type issue__PaymentPreferencesPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PaymentPreferencesPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferencesRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferencesRequestedEvent>;
};

/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  appliedPromoCode?: Maybe<payment__PromoCode>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  caseType: issue__PaymentCaseType;
  confirmedAt?: Maybe<Scalars['String']['output']>;
  contract: issue__PaymentAgreementContract;
  declinedAt?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  feeAcknowledgedAt?: Maybe<Scalars['String']['output']>;
  feePercentSnapshot: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  preAuthStatus?: Maybe<issue__PreAuthStatus>;
  preAuthTransaction?: Maybe<payment__PaymentTransaction>;
  preferences?: Maybe<issue__PaymentPreferences>;
  requestKey?: Maybe<Scalars['String']['output']>;
  resolvedFeeCap: Scalars['Int64']['output'];
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEventappliedPromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEventpreAuthTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEventpreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferences>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent_Type = BaseObject & Object & issue__Event & issue__PaymentPreferencesRequestedEvent & issue__PreAuthRequestedEvent & {
  __typename: 'issue__PaymentPreferencesRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  appliedPromoCode?: Maybe<payment__PromoCode>;
  cancelledAt?: Maybe<Scalars['String']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  caseType: issue__PaymentCaseType;
  confirmedAt?: Maybe<Scalars['String']['output']>;
  contract: issue__PaymentAgreementContract;
  declinedAt?: Maybe<Scalars['String']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  feeAcknowledgedAt?: Maybe<Scalars['String']['output']>;
  feePercentSnapshot: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  preAuthStatus?: Maybe<issue__PreAuthStatus>;
  preAuthTransaction?: Maybe<payment__PaymentTransaction>;
  preferences?: Maybe<issue__PaymentPreferences>;
  requestKey?: Maybe<Scalars['String']['output']>;
  resolvedFeeCap: Scalars['Int64']['output'];
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent_TypeappliedPromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent_TypepreAuthTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent_TypepreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferences>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferences>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Payment preferences prompt sent to the user. Confirmed answers land on PaymentPreferences. */
export type issue__PaymentPreferencesRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  prefsAutoPayAfter: Scalars['Boolean']['output'];
  prefsAutoPayBefore: Scalars['Boolean']['output'];
  prefsMaxChargeAfter?: Maybe<Scalars['Int64']['output']>;
  prefsMaxChargeBefore?: Maybe<Scalars['Int64']['output']>;
  prefsMaxSettleAfter?: Maybe<Scalars['Int64']['output']>;
  prefsMaxSettleBefore?: Maybe<Scalars['Int64']['output']>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEvent_Type = BaseObject & Object & issue__Event & issue__PaymentPreferencesUpdatedEvent & {
  __typename: 'issue__PaymentPreferencesUpdatedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  prefsAutoPayAfter: Scalars['Boolean']['output'];
  prefsAutoPayBefore: Scalars['Boolean']['output'];
  prefsMaxChargeAfter?: Maybe<Scalars['Int64']['output']>;
  prefsMaxChargeBefore?: Maybe<Scalars['Int64']['output']>;
  prefsMaxSettleAfter?: Maybe<Scalars['Int64']['output']>;
  prefsMaxSettleBefore?: Maybe<Scalars['Int64']['output']>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Staff edit of a case's confirmed PaymentPreferences, with the values before and after. Staff-only. */
export type issue__PaymentPreferencesUpdatedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Confirmed payment preferences, captured when the user confirms a PaymentPreferencesRequestedEvent. One per case. */
export type issue__PaymentPreferences_Type = BaseObject & Object & issue__PaymentPreferences & {
  __typename: 'issue__PaymentPreferences_Type';
  acceptAny?: Maybe<Scalars['Boolean']['output']>;
  appliedPromoCode?: Maybe<payment__PromoCode>;
  autoPayAuthorized?: Maybe<Scalars['Boolean']['output']>;
  caseType: issue__PaymentCaseType;
  contract: issue__PaymentAgreementContract;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  maxSettle?: Maybe<Scalars['Int64']['output']>;
  maxSingleCharge?: Maybe<Scalars['Int64']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  paymentPlanMaxMonthly?: Maybe<Scalars['Int64']['output']>;
  paymentPlanRequested?: Maybe<Scalars['Boolean']['output']>;
  providerRelationship?: Maybe<issue__ProviderRelationship>;
  requestedEvent: issue__PaymentPreferencesRequestedEvent;
  resolvedFeeCap: Scalars['Int64']['output'];
  successFeePercent: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};


/** Confirmed payment preferences, captured when the user confirms a PaymentPreferencesRequestedEvent. One per case. */
export type issue__PaymentPreferences_TypeappliedPromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};


/** Confirmed payment preferences, captured when the user confirms a PaymentPreferencesRequestedEvent. One per case. */
export type issue__PaymentPreferences_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Confirmed payment preferences, captured when the user confirms a PaymentPreferencesRequestedEvent. One per case. */
export type issue__PaymentPreferences_TyperequestedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPaymentPreferencesRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPaymentPreferencesRequestedEvent>;
};

export type issue__PhoneCallEvent = {
  actionRequired: Scalars['Boolean']['output'];
  aircallId: Scalars['String']['output'];
  callOutcome?: Maybe<Scalars['String']['output']>;
  callType?: Maybe<Scalars['String']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  durationMinutes?: Maybe<Scalars['Float']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  hasVoicemail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInbound: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryFetchedAt?: Maybe<Scalars['String']['output']>;
  summarySource?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  transcriptFetchedAt?: Maybe<Scalars['String']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PhoneCallEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PhoneCallEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PhoneCallEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PhoneCallEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PhoneCallEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PhoneCallEvent_Type = BaseObject & Object & issue__Event & issue__PhoneCallEvent & {
  __typename: 'issue__PhoneCallEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  aircallId: Scalars['String']['output'];
  callOutcome?: Maybe<Scalars['String']['output']>;
  callType?: Maybe<Scalars['String']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  durationMinutes?: Maybe<Scalars['Float']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  hasVoicemail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInbound: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  summary?: Maybe<Scalars['String']['output']>;
  summaryFetchedAt?: Maybe<Scalars['String']['output']>;
  summarySource?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  transcriptFetchedAt?: Maybe<Scalars['String']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PhoneCallEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PhoneCallEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PhoneCallEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PhoneCallEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PhoneCallEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PlanSelectionEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  options?: Maybe<Array<plan__Plan>>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  selectedPlan?: Maybe<plan__Plan>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PlanSelectionEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PlanSelectionEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PlanSelectionEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PlanSelectionEventoptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__PlanSelectionEventselectedPlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__PlanSelectionEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PlanSelectionEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PlanSelectionEvent_Type = BaseObject & Object & issue__Event & issue__PlanSelectionEvent & {
  __typename: 'issue__PlanSelectionEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  options?: Maybe<Array<plan__Plan>>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  selectedPlan?: Maybe<plan__Plan>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PlanSelectionEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PlanSelectionEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PlanSelectionEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PlanSelectionEvent_TypeoptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__PlanSelectionEvent_TypeselectedPlanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type issue__PlanSelectionEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PlanSelectionEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
};


export type issue__PostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

/**
 * Mirrors `issue::PostEscalationActionType` in `dbschema/issue.gel`. This copy
 * shadows the Gel-derived enum in the stitched schema, so a member added there
 * and not here makes `completedPostEscalationActions` return a value the gateway
 * cannot serialize — which fails the whole `issue__Issue` query, not just that
 * field. Keep the two in lockstep.
 */
export enum issue__PostEscalationActionType {
  ACCEPT_BILL_PAY = 'ACCEPT_BILL_PAY',
  ACCEPT_PAYMENT_AGREEMENT = 'ACCEPT_PAYMENT_AGREEMENT',
  COMPLETE_FA_APPLICATION = 'COMPLETE_FA_APPLICATION',
  CONFIRM_PAYMENT_PREFERENCES = 'CONFIRM_PAYMENT_PREFERENCES',
  CONNECT_EHR = 'CONNECT_EHR',
  CONNECT_INSURANCE = 'CONNECT_INSURANCE',
  PROVIDE_FA_ELIGIBILITY_INFO = 'PROVIDE_FA_ELIGIBILITY_INFO',
  SIGN_TEMPLATE = 'SIGN_TEMPLATE',
  UPLOAD_BILL = 'UPLOAD_BILL',
  UPLOAD_EOB = 'UPLOAD_EOB',
  UPLOAD_MEMBER_ID = 'UPLOAD_MEMBER_ID',
  UPLOAD_PROOF_OF_INCOME = 'UPLOAD_PROOF_OF_INCOME'
}

export type issue__PostEscalationActionsEvent = {
  actionRequired: Scalars['Boolean']['output'];
  actions?: Maybe<Array<issue__PostEscalationAction>>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PostEscalationActionsEventactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPostEscalationAction>;
};


export type issue__PostEscalationActionsEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PostEscalationActionsEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PostEscalationActionsEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PostEscalationActionsEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PostEscalationActionsEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__PostEscalationActionsEvent_Type = BaseObject & Object & issue__Event & issue__PostEscalationActionsEvent & {
  __typename: 'issue__PostEscalationActionsEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  actions?: Maybe<Array<issue__PostEscalationAction>>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__PostEscalationActionsEvent_TypeactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPostEscalationAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPostEscalationAction>;
};


export type issue__PostEscalationActionsEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__PostEscalationActionsEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__PostEscalationActionsEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__PostEscalationActionsEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__PostEscalationActionsEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** Payment-request events that may carry a card pre-authorization hold. Shared parent so polymorphic queries read one pre-auth definition (dbschema/CLAUDE.md sibling-field hazard). */
export type issue__PreAuthRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  preAuthStatus?: Maybe<issue__PreAuthStatus>;
  preAuthTransaction?: Maybe<payment__PaymentTransaction>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


/** Payment-request events that may carry a card pre-authorization hold. Shared parent so polymorphic queries read one pre-auth definition (dbschema/CLAUDE.md sibling-field hazard). */
export type issue__PreAuthRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


/** Payment-request events that may carry a card pre-authorization hold. Shared parent so polymorphic queries read one pre-auth definition (dbschema/CLAUDE.md sibling-field hazard). */
export type issue__PreAuthRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** Payment-request events that may carry a card pre-authorization hold. Shared parent so polymorphic queries read one pre-auth definition (dbschema/CLAUDE.md sibling-field hazard). */
export type issue__PreAuthRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


/** Payment-request events that may carry a card pre-authorization hold. Shared parent so polymorphic queries read one pre-auth definition (dbschema/CLAUDE.md sibling-field hazard). */
export type issue__PreAuthRequestedEventpreAuthTransactionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentTransaction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentTransaction>;
};


/** Payment-request events that may carry a card pre-authorization hold. Shared parent so polymorphic queries read one pre-auth definition (dbschema/CLAUDE.md sibling-field hazard). */
export type issue__PreAuthRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Payment-request events that may carry a card pre-authorization hold. Shared parent so polymorphic queries read one pre-auth definition (dbschema/CLAUDE.md sibling-field hazard). */
export type issue__PreAuthRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export enum issue__PreAuthStatus {
  AUTHORIZED = 'AUTHORIZED',
  FAILED = 'FAILED',
  NOT_REQUIRED = 'NOT_REQUIRED',
  PENDING = 'PENDING'
}

export enum issue__PriorityOverride {
  DEMOTED = 'DEMOTED',
  PROMOTED = 'PROMOTED'
}

export enum issue__ProviderRelationship {
  FREQUENT = 'FREQUENT',
  ONE_OFF = 'ONE_OFF'
}

export enum issue__ReengagementReason {
  FA_ABANDONMENT = 'FA_ABANDONMENT',
  LAST_DITCH_EFFORT = 'LAST_DITCH_EFFORT',
  MISSING_DOCUMENTS = 'MISSING_DOCUMENTS',
  MISSING_PAYMENT_AGREEMENT = 'MISSING_PAYMENT_AGREEMENT',
  OTHER = 'OTHER',
  SAVINGS_SECURED_CONFIRM_PAYMENT = 'SAVINGS_SECURED_CONFIRM_PAYMENT',
  USER_ABANDONMENT = 'USER_ABANDONMENT'
}

export type issue__ReopenedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ReopenedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ReopenedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ReopenedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ReopenedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ReopenedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ReopenedEvent_Type = BaseObject & Object & issue__Event & issue__ReopenedEvent & {
  __typename: 'issue__ReopenedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ReopenedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ReopenedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ReopenedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ReopenedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ReopenedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferences = {
  alternativePaymentOptions: Array<issue__AlternativePaymentOption>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minimumDiscountPercent: Scalars['Int']['output'];
  owner: User;
  savingsPreference: issue__SavingsPreference;
  successFeePercent: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};


/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferencesissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferencesownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferences_Type = BaseObject & Object & Owned & issue__ResolutionPreferences & {
  __typename: 'issue__ResolutionPreferences_Type';
  alternativePaymentOptions: Array<issue__AlternativePaymentOption>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minimumDiscountPercent: Scalars['Int']['output'];
  owner: User;
  savingsPreference: issue__SavingsPreference;
  successFeePercent: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};


/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferences_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


/** User's bill pay preferences — stored when they accept a BillPayRequestedEvent. */
export type issue__ResolutionPreferences_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** User's savings preference: ANY accepts any discount, MINIMUM requires a threshold. */
export enum issue__SavingsPreference {
  ANY = 'ANY',
  MINIMUM = 'MINIMUM'
}

export type issue__SignTemplatePostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__TemplateReleaseRequestedEvent;
};


export type issue__SignTemplatePostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__SignTemplatePostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterTemplateReleaseRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderTemplateReleaseRequestedEvent>;
};

export type issue__SignTemplatePostEscalationAction_Type = BaseObject & Object & issue__PostEscalationAction & issue__SignTemplatePostEscalationAction & {
  __typename: 'issue__SignTemplatePostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent: issue__TemplateReleaseRequestedEvent;
};


export type issue__SignTemplatePostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__SignTemplatePostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterTemplateReleaseRequestedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderTemplateReleaseRequestedEvent>;
};

export type issue__TemplateReleaseRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  release?: Maybe<consent__TemplateRelease>;
  requestKey?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  template: document__Template;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__TemplateReleaseRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__TemplateReleaseRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__TemplateReleaseRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__TemplateReleaseRequestedEventreleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type issue__TemplateReleaseRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__TemplateReleaseRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__TemplateReleaseRequestedEventtemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type issue__TemplateReleaseRequestedEvent_Type = BaseObject & Object & issue__Event & issue__TemplateReleaseRequestedEvent & {
  __typename: 'issue__TemplateReleaseRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  release?: Maybe<consent__TemplateRelease>;
  requestKey?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  template: document__Template;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__TemplateReleaseRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__TemplateReleaseRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__TemplateReleaseRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__TemplateReleaseRequestedEvent_TypereleaseArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<consent__FilterTemplateRelease>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<consent__OrderTemplateRelease>;
};


export type issue__TemplateReleaseRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__TemplateReleaseRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};


export type issue__TemplateReleaseRequestedEvent_TypetemplateArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterTemplate>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderTemplate>;
};

export type issue__ToolExecutionEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  toolInput: Scalars['JSON']['output'];
  toolName: Scalars['String']['output'];
  toolOutput: Scalars['String']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ToolExecutionEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ToolExecutionEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ToolExecutionEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ToolExecutionEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ToolExecutionEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__ToolExecutionEvent_Type = BaseObject & Object & issue__Event & issue__ToolExecutionEvent & {
  __typename: 'issue__ToolExecutionEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  toolInput: Scalars['JSON']['output'];
  toolName: Scalars['String']['output'];
  toolOutput: Scalars['String']['output'];
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__ToolExecutionEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__ToolExecutionEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__ToolExecutionEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__ToolExecutionEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__ToolExecutionEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UploadBillPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadBillPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadBillPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadBillPostEscalationAction_Type = BaseObject & Object & issue__PostEscalationAction & issue__UploadBillPostEscalationAction & {
  __typename: 'issue__UploadBillPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadBillPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadBillPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadEobPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadEobPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadEobPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadEobPostEscalationAction_Type = BaseObject & Object & issue__PostEscalationAction & issue__UploadEobPostEscalationAction & {
  __typename: 'issue__UploadEobPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadEobPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadEobPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadMemberIdPostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadMemberIdPostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadMemberIdPostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadMemberIdPostEscalationAction_Type = BaseObject & Object & issue__PostEscalationAction & issue__UploadMemberIdPostEscalationAction & {
  __typename: 'issue__UploadMemberIdPostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadMemberIdPostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadMemberIdPostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadProofOfIncomePostEscalationAction = {
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadProofOfIncomePostEscalationActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadProofOfIncomePostEscalationActionlinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export type issue__UploadProofOfIncomePostEscalationAction_Type = BaseObject & Object & issue__PostEscalationAction & issue__UploadProofOfIncomePostEscalationAction & {
  __typename: 'issue__UploadProofOfIncomePostEscalationAction_Type';
  id: Scalars['ID']['output'];
  isRequired: Scalars['Boolean']['output'];
  issue: issue__Issue;
  linkedEvent?: Maybe<issue__DocumentUploadedEvent>;
};


export type issue__UploadProofOfIncomePostEscalationAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UploadProofOfIncomePostEscalationAction_TypelinkedEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterDocumentUploadedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderDocumentUploadedEvent>;
};

export enum issue__UserClosureReason {
  MOVED_TO_DIFFERENT_CASE = 'MOVED_TO_DIFFERENT_CASE',
  NO_LONGER_NEED_HELP = 'NO_LONGER_NEED_HELP',
  RESOLVED = 'RESOLVED'
}

export type issue__UserInputRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  answerValue?: Maybe<Scalars['JSON']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  fieldSpec: Scalars['JSON']['output'];
  freeTextAllowed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<issue__InputOutcome>;
  participant: Participant;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  skippable?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserInputRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserInputRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserInputRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserInputRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserInputRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UserInputRequestedEvent_Type = BaseObject & Object & issue__Event & issue__UserInputRequestedEvent & {
  __typename: 'issue__UserInputRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  answerValue?: Maybe<Scalars['JSON']['output']>;
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  fieldSpec: Scalars['JSON']['output'];
  freeTextAllowed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isResolved: Scalars['Boolean']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<issue__InputOutcome>;
  participant: Participant;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  skippable?: Maybe<Scalars['Boolean']['output']>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserInputRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserInputRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserInputRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserInputRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserInputRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UserMultiSelectionRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserMultiSelectionRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserMultiSelectionRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserMultiSelectionRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserMultiSelectionRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserMultiSelectionRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UserMultiSelectionRequestedEvent_Type = BaseObject & Object & issue__Event & issue__UserMultiSelectionRequestedEvent & {
  __typename: 'issue__UserMultiSelectionRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserMultiSelectionRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserMultiSelectionRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserMultiSelectionRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserMultiSelectionRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserMultiSelectionRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UserSelectionRequestedEvent = {
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserSelectionRequestedEventeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserSelectionRequestedEventissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserSelectionRequestedEventllmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserSelectionRequestedEventsentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserSelectionRequestedEventsentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type issue__UserSelectionRequestedEvent_Type = BaseObject & Object & issue__Event & issue__UserSelectionRequestedEvent & {
  __typename: 'issue__UserSelectionRequestedEvent_Type';
  actionRequired: Scalars['Boolean']['output'];
  caseIntake?: Maybe<Scalars['Boolean']['output']>;
  eventFeedbacks?: Maybe<Array<feedback__IssueEventFeedback>>;
  eventType: issue__EventType;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  llmExecution?: Maybe<modelExecution__LLMExecution>;
  message?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  participant: Participant;
  seenAt?: Maybe<Scalars['String']['output']>;
  sentAt: Scalars['String']['output'];
  sentBy?: Maybe<User>;
  sentByProfile?: Maybe<user__Profile>;
  userVisible?: Maybe<Scalars['Boolean']['output']>;
};


export type issue__UserSelectionRequestedEvent_TypeeventFeedbacksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<feedback__FilterIssueEventFeedback>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<feedback__OrderIssueEventFeedback>;
};


export type issue__UserSelectionRequestedEvent_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type issue__UserSelectionRequestedEvent_TypellmExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<modelExecution__FilterLLMExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<modelExecution__OrderLLMExecution>;
};


export type issue__UserSelectionRequestedEvent_TypesentByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type issue__UserSelectionRequestedEvent_TypesentByProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<user__FilterProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<user__OrderProfile>;
};

export type modelExecution__FilterLLMExecution = {
  and?: InputMaybe<Array<modelExecution__FilterLLMExecution>>;
  createdAt?: InputMaybe<FilterString>;
  executionId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  llmProvider?: InputMaybe<FiltermodelExecution__LLMProvider>;
  not?: InputMaybe<modelExecution__FilterLLMExecution>;
  or?: InputMaybe<Array<modelExecution__FilterLLMExecution>>;
};

export type modelExecution__FilterVellumLLMExecution = {
  and?: InputMaybe<Array<modelExecution__FilterVellumLLMExecution>>;
  createdAt?: InputMaybe<FilterString>;
  executionId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  llmProvider?: InputMaybe<FiltermodelExecution__LLMProvider>;
  not?: InputMaybe<modelExecution__FilterVellumLLMExecution>;
  or?: InputMaybe<Array<modelExecution__FilterVellumLLMExecution>>;
};

export type modelExecution__LLMExecution = {
  createdAt: Scalars['String']['output'];
  executionId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  llmProvider: modelExecution__LLMProvider;
};

export enum modelExecution__LLMProvider {
  VELLUM = 'VELLUM'
}

export type modelExecution__NestedFilterLLMExecution = {
  createdAt?: InputMaybe<FilterString>;
  executionId?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  llmProvider?: InputMaybe<FiltermodelExecution__LLMProvider>;
};

export type modelExecution__OrderLLMExecution = {
  createdAt?: InputMaybe<Ordering>;
  executionId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  llmProvider?: InputMaybe<Ordering>;
};

export type modelExecution__OrderVellumLLMExecution = {
  createdAt?: InputMaybe<Ordering>;
  executionId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  llmProvider?: InputMaybe<Ordering>;
};

export type modelExecution__VellumLLMExecution = {
  createdAt: Scalars['String']['output'];
  executionId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  llmProvider: modelExecution__LLMProvider;
};

export type modelExecution__VellumLLMExecution_Type = BaseObject & Object & modelExecution__LLMExecution & modelExecution__VellumLLMExecution & {
  __typename: 'modelExecution__VellumLLMExecution_Type';
  createdAt: Scalars['String']['output'];
  executionId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  llmProvider: modelExecution__LLMProvider;
};

export type notification__FilterRetoolNotification = {
  and?: InputMaybe<Array<notification__FilterRetoolNotification>>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<notification__FilterRetoolNotification>;
  or?: InputMaybe<Array<notification__FilterRetoolNotification>>;
  owner?: InputMaybe<NestedFilterUser>;
  readAt?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type notification__OrderRetoolNotification = {
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  owner?: InputMaybe<OrderUser>;
  readAt?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type notification__RetoolNotification = {
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  readAt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type notification__RetoolNotificationissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type notification__RetoolNotificationownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type notification__RetoolNotification_Type = BaseObject & Object & Owned & notification__RetoolNotification & {
  __typename: 'notification__RetoolNotification_Type';
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  readAt?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type notification__RetoolNotification_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type notification__RetoolNotification_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Enum value used to specify how nulls are ordered. */
export enum nullsOrderingEnum {
  BIGGEST = 'BIGGEST',
  SMALLEST = 'SMALLEST'
}

export type partner__FilterInviteLink = {
  and?: InputMaybe<Array<partner__FilterInviteLink>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  label?: InputMaybe<FilterString>;
  not?: InputMaybe<partner__FilterInviteLink>;
  or?: InputMaybe<Array<partner__FilterInviteLink>>;
  partner?: InputMaybe<partner__NestedFilterPartner>;
  token?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type partner__FilterPartner = {
  and?: InputMaybe<Array<partner__FilterPartner>>;
  createdAt?: InputMaybe<FilterString>;
  groups?: InputMaybe<partner__NestedFilterPartnerGroup>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<partner__FilterPartner>;
  or?: InputMaybe<Array<partner__FilterPartner>>;
  slug?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type partner__FilterPartnerGroup = {
  and?: InputMaybe<Array<partner__FilterPartnerGroup>>;
  createdAt?: InputMaybe<FilterString>;
  externalId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<partner__FilterPartnerGroup>;
  or?: InputMaybe<Array<partner__FilterPartnerGroup>>;
  partner?: InputMaybe<partner__NestedFilterPartner>;
  updatedAt?: InputMaybe<FilterString>;
};

export type partner__InviteLink = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  partner: partner__Partner;
  token: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


export type partner__InviteLinkpartnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};

export type partner__InviteLink_Type = BaseObject & Object & partner__InviteLink & {
  __typename: 'partner__InviteLink_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  partner: partner__Partner;
  token: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


export type partner__InviteLink_TypepartnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};

export type partner__NestedFilterPartner = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  groups?: InputMaybe<partner__NestedFilterPartnerGroup>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  name?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type partner__NestedFilterPartnerGroup = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  partner?: InputMaybe<partner__NestedFilterPartner>;
  updatedAt?: InputMaybe<FilterString>;
};

export type partner__OrderInviteLink = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  label?: InputMaybe<Ordering>;
  partner?: InputMaybe<partner__OrderPartner>;
  token?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type partner__OrderPartner = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type partner__OrderPartnerGroup = {
  createdAt?: InputMaybe<Ordering>;
  externalId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  partner?: InputMaybe<partner__OrderPartner>;
  updatedAt?: InputMaybe<Ordering>;
};

export type partner__Partner = {
  createdAt: Scalars['String']['output'];
  groups?: Maybe<Array<partner__PartnerGroup>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type partner__PartnergroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartnerGroup>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartnerGroup>;
};

export type partner__PartnerGroup = {
  createdAt: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partner: partner__Partner;
  updatedAt: Scalars['String']['output'];
};


export type partner__PartnerGrouppartnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};

export type partner__PartnerGroup_Type = BaseObject & Object & partner__PartnerGroup & {
  __typename: 'partner__PartnerGroup_Type';
  createdAt: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  partner: partner__Partner;
  updatedAt: Scalars['String']['output'];
};


export type partner__PartnerGroup_TypepartnerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartner>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartner>;
};

export type partner__Partner_Type = BaseObject & Object & Slugged & partner__Partner & {
  __typename: 'partner__Partner_Type';
  createdAt: Scalars['String']['output'];
  groups?: Maybe<Array<partner__PartnerGroup>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type partner__Partner_TypegroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<partner__FilterPartnerGroup>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<partner__OrderPartnerGroup>;
};

export enum payerSync__ChangeKind {
  ADDED = 'ADDED',
  CHANGED = 'CHANGED',
  INACTIVATED = 'INACTIVATED',
  REACTIVATED = 'REACTIVATED'
}

export type payerSync__FilterPayerChange = {
  and?: InputMaybe<Array<payerSync__FilterPayerChange>>;
  changedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<FilterpayerSync__ChangeKind>;
  not?: InputMaybe<payerSync__FilterPayerChange>;
  or?: InputMaybe<Array<payerSync__FilterPayerChange>>;
  payer?: InputMaybe<payer__NestedFilterPayer>;
  previous?: InputMaybe<FilterJSON>;
  syncRun?: InputMaybe<payerSync__NestedFilterRun>;
};

export type payerSync__FilterRun = {
  addedCount?: InputMaybe<FilterInt64>;
  and?: InputMaybe<Array<payerSync__FilterRun>>;
  changedCount?: InputMaybe<FilterInt64>;
  changes?: InputMaybe<payerSync__NestedFilterPayerChange>;
  dryRun?: InputMaybe<FilterBoolean>;
  error?: InputMaybe<FilterString>;
  finishedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  inactivatedCount?: InputMaybe<FilterInt64>;
  not?: InputMaybe<payerSync__FilterRun>;
  or?: InputMaybe<Array<payerSync__FilterRun>>;
  reactivatedCount?: InputMaybe<FilterInt64>;
  receivedCount?: InputMaybe<FilterInt64>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterpayerSync__RunStatus>;
  unchangedCount?: InputMaybe<FilterInt64>;
  unrecognizedValueCount?: InputMaybe<FilterInt64>;
  workflowId?: InputMaybe<FilterString>;
};

export type payerSync__NestedFilterPayerChange = {
  changedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<FilterpayerSync__ChangeKind>;
  payer?: InputMaybe<payer__NestedFilterPayer>;
  previous?: InputMaybe<FilterJSON>;
  syncRun?: InputMaybe<payerSync__NestedFilterRun>;
};

export type payerSync__NestedFilterRun = {
  addedCount?: InputMaybe<FilterInt64>;
  changedCount?: InputMaybe<FilterInt64>;
  changes?: InputMaybe<payerSync__NestedFilterPayerChange>;
  dryRun?: InputMaybe<FilterBoolean>;
  error?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  finishedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  inactivatedCount?: InputMaybe<FilterInt64>;
  reactivatedCount?: InputMaybe<FilterInt64>;
  receivedCount?: InputMaybe<FilterInt64>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterpayerSync__RunStatus>;
  unchangedCount?: InputMaybe<FilterInt64>;
  unrecognizedValueCount?: InputMaybe<FilterInt64>;
  workflowId?: InputMaybe<FilterString>;
};

export type payerSync__OrderPayerChange = {
  changedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  payer?: InputMaybe<payer__OrderPayer>;
  previous?: InputMaybe<Ordering>;
  syncRun?: InputMaybe<payerSync__OrderRun>;
};

export type payerSync__OrderRun = {
  addedCount?: InputMaybe<Ordering>;
  changedCount?: InputMaybe<Ordering>;
  dryRun?: InputMaybe<Ordering>;
  error?: InputMaybe<Ordering>;
  finishedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  inactivatedCount?: InputMaybe<Ordering>;
  reactivatedCount?: InputMaybe<Ordering>;
  receivedCount?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  unchangedCount?: InputMaybe<Ordering>;
  unrecognizedValueCount?: InputMaybe<Ordering>;
  workflowId?: InputMaybe<Ordering>;
};

export type payerSync__PayerChange = {
  changedAt: Scalars['String']['output'];
  changedFields: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: payerSync__ChangeKind;
  payer: payer__Payer;
  previous?: Maybe<Scalars['JSON']['output']>;
  syncRun: payerSync__Run;
};


export type payerSync__PayerChangepayerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayer>;
};


export type payerSync__PayerChangesyncRunArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payerSync__FilterRun>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payerSync__OrderRun>;
};

export type payerSync__PayerChange_Type = BaseObject & Object & payerSync__PayerChange & {
  __typename: 'payerSync__PayerChange_Type';
  changedAt: Scalars['String']['output'];
  changedFields: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind: payerSync__ChangeKind;
  payer: payer__Payer;
  previous?: Maybe<Scalars['JSON']['output']>;
  syncRun: payerSync__Run;
};


export type payerSync__PayerChange_TypepayerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayer>;
};


export type payerSync__PayerChange_TypesyncRunArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payerSync__FilterRun>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payerSync__OrderRun>;
};

export type payerSync__Run = {
  addedCount?: Maybe<Scalars['Int64']['output']>;
  changedCount?: Maybe<Scalars['Int64']['output']>;
  changes?: Maybe<Array<payerSync__PayerChange>>;
  dryRun: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactivatedCount?: Maybe<Scalars['Int64']['output']>;
  reactivatedCount?: Maybe<Scalars['Int64']['output']>;
  receivedCount?: Maybe<Scalars['Int64']['output']>;
  startedAt: Scalars['String']['output'];
  status: payerSync__RunStatus;
  unchangedCount?: Maybe<Scalars['Int64']['output']>;
  unrecognizedValueCount?: Maybe<Scalars['Int64']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};


export type payerSync__RunchangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payerSync__FilterPayerChange>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payerSync__OrderPayerChange>;
};

export enum payerSync__RunStatus {
  ABORTED = 'ABORTED',
  FAILED = 'FAILED',
  RUNNING = 'RUNNING',
  SUCCEEDED = 'SUCCEEDED'
}

export type payerSync__Run_Type = BaseObject & Object & payerSync__Run & {
  __typename: 'payerSync__Run_Type';
  addedCount?: Maybe<Scalars['Int64']['output']>;
  changedCount?: Maybe<Scalars['Int64']['output']>;
  changes?: Maybe<Array<payerSync__PayerChange>>;
  dryRun: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactivatedCount?: Maybe<Scalars['Int64']['output']>;
  reactivatedCount?: Maybe<Scalars['Int64']['output']>;
  receivedCount?: Maybe<Scalars['Int64']['output']>;
  startedAt: Scalars['String']['output'];
  status: payerSync__RunStatus;
  unchangedCount?: Maybe<Scalars['Int64']['output']>;
  unrecognizedValueCount?: Maybe<Scalars['Int64']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};


export type payerSync__Run_TypechangesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payerSync__FilterPayerChange>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payerSync__OrderPayerChange>;
};

export type payer__FilterPayer = {
  aliases?: InputMaybe<payer__NestedFilterPayerAlias>;
  and?: InputMaybe<Array<payer__FilterPayer>>;
  claimPaymentSupport?: InputMaybe<FilterString>;
  claimPaymentWithFundsTransferSupport?: InputMaybe<FilterString>;
  claimStatusSupport?: InputMaybe<FilterString>;
  claimSubmissionSupport?: InputMaybe<FilterString>;
  coordinationOfBenefitsSupport?: InputMaybe<FilterString>;
  dentalClaimSupport?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  displayNameShort?: InputMaybe<FilterString>;
  eligibilityCheckSupport?: InputMaybe<FilterString>;
  enrollmentRequiresPtan?: InputMaybe<FilterBoolean>;
  enrollments?: InputMaybe<payer__NestedFilterTransactionEnrollment>;
  fundsTransferSupport?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  inactiveSince?: InputMaybe<FilterString>;
  institutionalClaimSupport?: InputMaybe<FilterString>;
  isActive?: InputMaybe<FilterBoolean>;
  logoUrl?: InputMaybe<FilterString>;
  not?: InputMaybe<payer__FilterPayer>;
  or?: InputMaybe<Array<payer__FilterPayer>>;
  parentGroupId?: InputMaybe<FilterString>;
  parentGroupName?: InputMaybe<FilterString>;
  primaryPayerId?: InputMaybe<FilterString>;
  professionalClaimSupport?: InputMaybe<FilterString>;
  unsolicitedClaimAttachmentSupport?: InputMaybe<FilterString>;
  vendorPayerId?: InputMaybe<FilterString>;
  websiteUrl?: InputMaybe<FilterString>;
};

export type payer__FilterPayerAlias = {
  and?: InputMaybe<Array<payer__FilterPayerAlias>>;
  id?: InputMaybe<FilterID>;
  inactiveSince?: InputMaybe<FilterString>;
  not?: InputMaybe<payer__FilterPayerAlias>;
  or?: InputMaybe<Array<payer__FilterPayerAlias>>;
  payer?: InputMaybe<payer__NestedFilterPayer>;
  value?: InputMaybe<FilterString>;
};

export type payer__FilterTransactionEnrollment = {
  and?: InputMaybe<Array<payer__FilterTransactionEnrollment>>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<payer__FilterTransactionEnrollment>;
  or?: InputMaybe<Array<payer__FilterTransactionEnrollment>>;
  payer?: InputMaybe<payer__NestedFilterPayer>;
  requestedEffectiveDateSupported?: InputMaybe<FilterBoolean>;
  timeframe?: InputMaybe<FilterString>;
  transaction?: InputMaybe<Filterpayer__Transaction>;
  type?: InputMaybe<FilterString>;
};

export type payer__NestedFilterPayer = {
  aliases?: InputMaybe<payer__NestedFilterPayerAlias>;
  claimPaymentSupport?: InputMaybe<FilterString>;
  claimPaymentWithFundsTransferSupport?: InputMaybe<FilterString>;
  claimStatusSupport?: InputMaybe<FilterString>;
  claimSubmissionSupport?: InputMaybe<FilterString>;
  coordinationOfBenefitsSupport?: InputMaybe<FilterString>;
  dentalClaimSupport?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  displayNameShort?: InputMaybe<FilterString>;
  eligibilityCheckSupport?: InputMaybe<FilterString>;
  enrollmentRequiresPtan?: InputMaybe<FilterBoolean>;
  enrollments?: InputMaybe<payer__NestedFilterTransactionEnrollment>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  fundsTransferSupport?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  inactiveSince?: InputMaybe<FilterString>;
  institutionalClaimSupport?: InputMaybe<FilterString>;
  isActive?: InputMaybe<FilterBoolean>;
  logoUrl?: InputMaybe<FilterString>;
  parentGroupId?: InputMaybe<FilterString>;
  parentGroupName?: InputMaybe<FilterString>;
  primaryPayerId?: InputMaybe<FilterString>;
  professionalClaimSupport?: InputMaybe<FilterString>;
  unsolicitedClaimAttachmentSupport?: InputMaybe<FilterString>;
  vendorPayerId?: InputMaybe<FilterString>;
  websiteUrl?: InputMaybe<FilterString>;
};

export type payer__NestedFilterPayerAlias = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  inactiveSince?: InputMaybe<FilterString>;
  payer?: InputMaybe<payer__NestedFilterPayer>;
  value?: InputMaybe<FilterString>;
};

export type payer__NestedFilterTransactionEnrollment = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  payer?: InputMaybe<payer__NestedFilterPayer>;
  requestedEffectiveDateSupported?: InputMaybe<FilterBoolean>;
  timeframe?: InputMaybe<FilterString>;
  transaction?: InputMaybe<Filterpayer__Transaction>;
  type?: InputMaybe<FilterString>;
};

export type payer__OrderPayer = {
  claimPaymentSupport?: InputMaybe<Ordering>;
  claimPaymentWithFundsTransferSupport?: InputMaybe<Ordering>;
  claimStatusSupport?: InputMaybe<Ordering>;
  claimSubmissionSupport?: InputMaybe<Ordering>;
  coordinationOfBenefitsSupport?: InputMaybe<Ordering>;
  dentalClaimSupport?: InputMaybe<Ordering>;
  displayName?: InputMaybe<Ordering>;
  displayNameShort?: InputMaybe<Ordering>;
  eligibilityCheckSupport?: InputMaybe<Ordering>;
  enrollmentRequiresPtan?: InputMaybe<Ordering>;
  fundsTransferSupport?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  inactiveSince?: InputMaybe<Ordering>;
  institutionalClaimSupport?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  logoUrl?: InputMaybe<Ordering>;
  parentGroupId?: InputMaybe<Ordering>;
  parentGroupName?: InputMaybe<Ordering>;
  primaryPayerId?: InputMaybe<Ordering>;
  professionalClaimSupport?: InputMaybe<Ordering>;
  unsolicitedClaimAttachmentSupport?: InputMaybe<Ordering>;
  vendorPayerId?: InputMaybe<Ordering>;
  websiteUrl?: InputMaybe<Ordering>;
};

export type payer__OrderPayerAlias = {
  id?: InputMaybe<Ordering>;
  inactiveSince?: InputMaybe<Ordering>;
  payer?: InputMaybe<payer__OrderPayer>;
  value?: InputMaybe<Ordering>;
};

export type payer__OrderTransactionEnrollment = {
  id?: InputMaybe<Ordering>;
  payer?: InputMaybe<payer__OrderPayer>;
  requestedEffectiveDateSupported?: InputMaybe<Ordering>;
  timeframe?: InputMaybe<Ordering>;
  transaction?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type payer__Payer = {
  aliases?: Maybe<Array<payer__PayerAlias>>;
  alternateNames: Array<Scalars['String']['output']>;
  claimPaymentSupport?: Maybe<Scalars['String']['output']>;
  claimPaymentWithFundsTransferSupport?: Maybe<Scalars['String']['output']>;
  claimStatusSupport?: Maybe<Scalars['String']['output']>;
  claimSubmissionSupport?: Maybe<Scalars['String']['output']>;
  coordinationOfBenefitsSupport?: Maybe<Scalars['String']['output']>;
  coverageTypes?: Maybe<Array<Scalars['String']['output']>>;
  dentalClaimSupport?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayNameShort?: Maybe<Scalars['String']['output']>;
  eligibilityCheckSupport?: Maybe<Scalars['String']['output']>;
  employerIdentificationNumbers: Array<Scalars['String']['output']>;
  enrollmentRequiresPtan?: Maybe<Scalars['Boolean']['output']>;
  enrollments?: Maybe<Array<payer__TransactionEnrollment>>;
  fundsTransferSupport?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactiveSince?: Maybe<Scalars['String']['output']>;
  institutionalClaimSupport?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  operatingRegions?: Maybe<Array<Scalars['String']['output']>>;
  parentGroupId?: Maybe<Scalars['String']['output']>;
  parentGroupName?: Maybe<Scalars['String']['output']>;
  primaryPayerId: Scalars['String']['output'];
  professionalClaimSupport?: Maybe<Scalars['String']['output']>;
  programs: Array<Scalars['String']['output']>;
  unsolicitedClaimAttachmentSupport?: Maybe<Scalars['String']['output']>;
  vendorPayerId: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


export type payer__PayeraliasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayerAlias>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayerAlias>;
};


export type payer__PayerenrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterTransactionEnrollment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderTransactionEnrollment>;
};

export type payer__PayerAlias = {
  id: Scalars['ID']['output'];
  inactiveSince?: Maybe<Scalars['String']['output']>;
  payer: payer__Payer;
  value: Scalars['String']['output'];
};


export type payer__PayerAliaspayerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayer>;
};

export type payer__PayerAlias_Type = BaseObject & Object & payer__PayerAlias & {
  __typename: 'payer__PayerAlias_Type';
  id: Scalars['ID']['output'];
  inactiveSince?: Maybe<Scalars['String']['output']>;
  payer: payer__Payer;
  value: Scalars['String']['output'];
};


export type payer__PayerAlias_TypepayerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayer>;
};

export type payer__Payer_Type = BaseObject & Object & payer__Payer & {
  __typename: 'payer__Payer_Type';
  aliases?: Maybe<Array<payer__PayerAlias>>;
  alternateNames: Array<Scalars['String']['output']>;
  claimPaymentSupport?: Maybe<Scalars['String']['output']>;
  claimPaymentWithFundsTransferSupport?: Maybe<Scalars['String']['output']>;
  claimStatusSupport?: Maybe<Scalars['String']['output']>;
  claimSubmissionSupport?: Maybe<Scalars['String']['output']>;
  coordinationOfBenefitsSupport?: Maybe<Scalars['String']['output']>;
  coverageTypes?: Maybe<Array<Scalars['String']['output']>>;
  dentalClaimSupport?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayNameShort?: Maybe<Scalars['String']['output']>;
  eligibilityCheckSupport?: Maybe<Scalars['String']['output']>;
  employerIdentificationNumbers: Array<Scalars['String']['output']>;
  enrollmentRequiresPtan?: Maybe<Scalars['Boolean']['output']>;
  enrollments?: Maybe<Array<payer__TransactionEnrollment>>;
  fundsTransferSupport?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inactiveSince?: Maybe<Scalars['String']['output']>;
  institutionalClaimSupport?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  operatingRegions?: Maybe<Array<Scalars['String']['output']>>;
  parentGroupId?: Maybe<Scalars['String']['output']>;
  parentGroupName?: Maybe<Scalars['String']['output']>;
  primaryPayerId: Scalars['String']['output'];
  professionalClaimSupport?: Maybe<Scalars['String']['output']>;
  programs: Array<Scalars['String']['output']>;
  unsolicitedClaimAttachmentSupport?: Maybe<Scalars['String']['output']>;
  vendorPayerId: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


export type payer__Payer_TypealiasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayerAlias>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayerAlias>;
};


export type payer__Payer_TypeenrollmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterTransactionEnrollment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderTransactionEnrollment>;
};

export enum payer__Transaction {
  CLAIM_PAYMENT = 'CLAIM_PAYMENT',
  CLAIM_PAYMENT_WITH_FUNDS_TRANSFER = 'CLAIM_PAYMENT_WITH_FUNDS_TRANSFER',
  CLAIM_STATUS = 'CLAIM_STATUS',
  CLAIM_SUBMISSION = 'CLAIM_SUBMISSION',
  COORDINATION_OF_BENEFITS = 'COORDINATION_OF_BENEFITS',
  DENTAL_CLAIM = 'DENTAL_CLAIM',
  ELIGIBILITY_CHECK = 'ELIGIBILITY_CHECK',
  FUNDS_TRANSFER = 'FUNDS_TRANSFER',
  INSTITUTIONAL_CLAIM = 'INSTITUTIONAL_CLAIM',
  PROFESSIONAL_CLAIM = 'PROFESSIONAL_CLAIM',
  UNSOLICITED_CLAIM_ATTACHMENT = 'UNSOLICITED_CLAIM_ATTACHMENT'
}

export type payer__TransactionEnrollment = {
  id: Scalars['ID']['output'];
  payer: payer__Payer;
  remittanceAggregations: Array<Scalars['String']['output']>;
  requestedEffectiveDateSupported?: Maybe<Scalars['Boolean']['output']>;
  timeframe?: Maybe<Scalars['String']['output']>;
  transaction: payer__Transaction;
  type?: Maybe<Scalars['String']['output']>;
};


export type payer__TransactionEnrollmentpayerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayer>;
};

export type payer__TransactionEnrollment_Type = BaseObject & Object & payer__TransactionEnrollment & {
  __typename: 'payer__TransactionEnrollment_Type';
  id: Scalars['ID']['output'];
  payer: payer__Payer;
  remittanceAggregations: Array<Scalars['String']['output']>;
  requestedEffectiveDateSupported?: Maybe<Scalars['Boolean']['output']>;
  timeframe?: Maybe<Scalars['String']['output']>;
  transaction: payer__Transaction;
  type?: Maybe<Scalars['String']['output']>;
};


export type payer__TransactionEnrollment_TypepayerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payer__FilterPayer>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payer__OrderPayer>;
};

export type payment__FilterIssuePromoCodeUsage = {
  and?: InputMaybe<Array<payment__FilterIssuePromoCodeUsage>>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<payment__FilterIssuePromoCodeUsage>;
  or?: InputMaybe<Array<payment__FilterIssuePromoCodeUsage>>;
  owner?: InputMaybe<NestedFilterUser>;
  promoCode?: InputMaybe<payment__NestedFilterPromoCode>;
  usedAt?: InputMaybe<FilterString>;
};

export type payment__FilterPaymentProfile = {
  and?: InputMaybe<Array<payment__FilterPaymentProfile>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<payment__FilterPaymentProfile>;
  or?: InputMaybe<Array<payment__FilterPaymentProfile>>;
  owner?: InputMaybe<NestedFilterUser>;
  stripeCustomerId?: InputMaybe<FilterString>;
  stripePaymentMethodId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__FilterPaymentTransaction = {
  amount?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<payment__FilterPaymentTransaction>>;
  billAmount?: InputMaybe<FilterDecimal>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<FilterString>;
  failedAt?: InputMaybe<FilterString>;
  failureCode?: InputMaybe<FilterString>;
  failureDeclineCode?: InputMaybe<FilterString>;
  failureMessage?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<payment__FilterPaymentTransaction>;
  or?: InputMaybe<Array<payment__FilterPaymentTransaction>>;
  owner?: InputMaybe<NestedFilterUser>;
  paymentProfile?: InputMaybe<payment__NestedFilterPaymentProfile>;
  status?: InputMaybe<Filterpayment__PaymentStatus>;
  stripeInvoiceId?: InputMaybe<FilterString>;
  stripePaymentIntentId?: InputMaybe<FilterString>;
  stripeReceiptUrl?: InputMaybe<FilterString>;
  successFeeAmount?: InputMaybe<FilterDecimal>;
  transactionType?: InputMaybe<Filterpayment__PaymentTransactionType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__FilterPromoCode = {
  and?: InputMaybe<Array<payment__FilterPromoCode>>;
  code?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<payment__FilterPromoCode>;
  or?: InputMaybe<Array<payment__FilterPromoCode>>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__FilterSubscription = {
  and?: InputMaybe<Array<payment__FilterSubscription>>;
  cancelAtPeriodEnd?: InputMaybe<FilterBoolean>;
  canceledAt?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  currentPeriodEnd?: InputMaybe<FilterString>;
  currentPeriodStart?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<payment__FilterSubscription>;
  or?: InputMaybe<Array<payment__FilterSubscription>>;
  owner?: InputMaybe<NestedFilterUser>;
  paymentProfile?: InputMaybe<payment__NestedFilterPaymentProfile>;
  status?: InputMaybe<Filterpayment__SubscriptionStatus>;
  stripePriceId?: InputMaybe<FilterString>;
  stripeSubscriptionId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__IssuePromoCodeUsage = {
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  promoCode: payment__PromoCode;
  usedAt?: Maybe<Scalars['String']['output']>;
};


export type payment__IssuePromoCodeUsageissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type payment__IssuePromoCodeUsageownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__IssuePromoCodeUsagepromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};

export type payment__IssuePromoCodeUsage_Type = BaseObject & Object & Owned & payment__IssuePromoCodeUsage & {
  __typename: 'payment__IssuePromoCodeUsage_Type';
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  promoCode: payment__PromoCode;
  usedAt?: Maybe<Scalars['String']['output']>;
};


export type payment__IssuePromoCodeUsage_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type payment__IssuePromoCodeUsage_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__IssuePromoCodeUsage_TypepromoCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPromoCode>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPromoCode>;
};

export type payment__NestedFilterIssuePromoCodeUsage = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  owner?: InputMaybe<NestedFilterUser>;
  promoCode?: InputMaybe<payment__NestedFilterPromoCode>;
  usedAt?: InputMaybe<FilterString>;
};

export type payment__NestedFilterPaymentProfile = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  stripeCustomerId?: InputMaybe<FilterString>;
  stripePaymentMethodId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__NestedFilterPaymentTransaction = {
  amount?: InputMaybe<FilterDecimal>;
  billAmount?: InputMaybe<FilterDecimal>;
  createdAt?: InputMaybe<FilterString>;
  currency?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  failedAt?: InputMaybe<FilterString>;
  failureCode?: InputMaybe<FilterString>;
  failureDeclineCode?: InputMaybe<FilterString>;
  failureMessage?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  owner?: InputMaybe<NestedFilterUser>;
  paymentProfile?: InputMaybe<payment__NestedFilterPaymentProfile>;
  status?: InputMaybe<Filterpayment__PaymentStatus>;
  stripeInvoiceId?: InputMaybe<FilterString>;
  stripePaymentIntentId?: InputMaybe<FilterString>;
  stripeReceiptUrl?: InputMaybe<FilterString>;
  successFeeAmount?: InputMaybe<FilterDecimal>;
  transactionType?: InputMaybe<Filterpayment__PaymentTransactionType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__NestedFilterPromoCode = {
  code?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  updatedAt?: InputMaybe<FilterString>;
};

export type payment__OrderIssuePromoCodeUsage = {
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  owner?: InputMaybe<OrderUser>;
  promoCode?: InputMaybe<payment__OrderPromoCode>;
  usedAt?: InputMaybe<Ordering>;
};

export type payment__OrderPaymentProfile = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  stripeCustomerId?: InputMaybe<Ordering>;
  stripePaymentMethodId?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type payment__OrderPaymentTransaction = {
  amount?: InputMaybe<Ordering>;
  billAmount?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currency?: InputMaybe<Ordering>;
  failedAt?: InputMaybe<Ordering>;
  failureCode?: InputMaybe<Ordering>;
  failureDeclineCode?: InputMaybe<Ordering>;
  failureMessage?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  owner?: InputMaybe<OrderUser>;
  paymentProfile?: InputMaybe<payment__OrderPaymentProfile>;
  status?: InputMaybe<Ordering>;
  stripeInvoiceId?: InputMaybe<Ordering>;
  stripePaymentIntentId?: InputMaybe<Ordering>;
  stripeReceiptUrl?: InputMaybe<Ordering>;
  successFeeAmount?: InputMaybe<Ordering>;
  transactionType?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type payment__OrderPromoCode = {
  code?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type payment__OrderSubscription = {
  cancelAtPeriodEnd?: InputMaybe<Ordering>;
  canceledAt?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  currentPeriodEnd?: InputMaybe<Ordering>;
  currentPeriodStart?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  paymentProfile?: InputMaybe<payment__OrderPaymentProfile>;
  status?: InputMaybe<Ordering>;
  stripePriceId?: InputMaybe<Ordering>;
  stripeSubscriptionId?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type payment__PaymentProfile = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  stripeCustomerId: Scalars['String']['output'];
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type payment__PaymentProfileownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type payment__PaymentProfile_Type = BaseObject & Object & Owned & payment__PaymentProfile & {
  __typename: 'payment__PaymentProfile_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
  stripeCustomerId: Scalars['String']['output'];
  stripePaymentMethodId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};


export type payment__PaymentProfile_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Status of a payment transaction, matching Stripe PaymentIntent statuses. */
export enum payment__PaymentStatus {
  CANCELED = 'CANCELED',
  PROCESSING = 'PROCESSING',
  REQUIRES_ACTION = 'REQUIRES_ACTION',
  REQUIRES_CAPTURE = 'REQUIRES_CAPTURE',
  REQUIRES_CONFIRMATION = 'REQUIRES_CONFIRMATION',
  REQUIRES_PAYMENT_METHOD = 'REQUIRES_PAYMENT_METHOD',
  SUCCEEDED = 'SUCCEEDED'
}

export type payment__PaymentTransaction = {
  amount: Scalars['Decimal']['output'];
  billAmount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  failedAt?: Maybe<Scalars['String']['output']>;
  failureCode?: Maybe<Scalars['String']['output']>;
  failureDeclineCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  paymentProfile: payment__PaymentProfile;
  status: payment__PaymentStatus;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripeReceiptUrl?: Maybe<Scalars['String']['output']>;
  successFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  transactionType?: Maybe<payment__PaymentTransactionType>;
  updatedAt: Scalars['String']['output'];
};


export type payment__PaymentTransactionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type payment__PaymentTransactionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__PaymentTransactionpaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};

/** Type of payment transaction. */
export enum payment__PaymentTransactionType {
  CAPTURE = 'CAPTURE',
  CHARGE = 'CHARGE',
  PRE_AUTHORIZATION = 'PRE_AUTHORIZATION'
}

export type payment__PaymentTransaction_Type = BaseObject & Object & Owned & payment__PaymentTransaction & {
  __typename: 'payment__PaymentTransaction_Type';
  amount: Scalars['Decimal']['output'];
  billAmount?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  failedAt?: Maybe<Scalars['String']['output']>;
  failureCode?: Maybe<Scalars['String']['output']>;
  failureDeclineCode?: Maybe<Scalars['String']['output']>;
  failureMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue?: Maybe<issue__Issue>;
  owner: User;
  paymentProfile: payment__PaymentProfile;
  status: payment__PaymentStatus;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  stripePaymentIntentId?: Maybe<Scalars['String']['output']>;
  stripeReceiptUrl?: Maybe<Scalars['String']['output']>;
  successFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  transactionType?: Maybe<payment__PaymentTransactionType>;
  updatedAt: Scalars['String']['output'];
};


export type payment__PaymentTransaction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type payment__PaymentTransaction_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__PaymentTransaction_TypepaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};

export type payment__PromoCode = {
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type payment__PromoCode_Type = BaseObject & Object & payment__PromoCode & {
  __typename: 'payment__PromoCode_Type';
  code: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  updatedAt: Scalars['String']['output'];
};

export type payment__Subscription = {
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  currentPeriodStart?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  paymentProfile: payment__PaymentProfile;
  status: payment__SubscriptionStatus;
  stripePriceId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


export type payment__SubscriptionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__SubscriptionpaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};

/** Status of a Stripe subscription. */
export enum payment__SubscriptionStatus {
  ACTIVE = 'ACTIVE',
  CANCELED = 'CANCELED',
  INCOMPLETE = 'INCOMPLETE',
  INCOMPLETE_EXPIRED = 'INCOMPLETE_EXPIRED',
  PAST_DUE = 'PAST_DUE',
  PAUSED = 'PAUSED',
  TRIALING = 'TRIALING',
  UNPAID = 'UNPAID'
}

export type payment__Subscription_Type = BaseObject & Object & Owned & payment__Subscription & {
  __typename: 'payment__Subscription_Type';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  canceledAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currentPeriodEnd?: Maybe<Scalars['String']['output']>;
  currentPeriodStart?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  paymentProfile: payment__PaymentProfile;
  status: payment__SubscriptionStatus;
  stripePriceId: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};


export type payment__Subscription_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type payment__Subscription_TypepaymentProfileArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<payment__FilterPaymentProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<payment__OrderPaymentProfile>;
};

export type person__Address = {
  city: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  primary: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};


export type person__AddresspersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};

export type person__Address_Type = BaseObject & Object & Personal & person__Address & {
  __typename: 'person__Address_Type';
  city: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  person?: Maybe<Person>;
  primary: Scalars['Boolean']['output'];
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};


export type person__Address_TypepersonArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterPerson>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderPerson>;
};

export type person__FilterAddress = {
  and?: InputMaybe<Array<person__FilterAddress>>;
  city?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<person__FilterAddress>;
  or?: InputMaybe<Array<person__FilterAddress>>;
  person?: InputMaybe<NestedFilterPerson>;
  primary?: InputMaybe<FilterBoolean>;
  state?: InputMaybe<FilterString>;
  street?: InputMaybe<FilterString>;
  street2?: InputMaybe<FilterString>;
  zip?: InputMaybe<FilterString>;
};

export type person__NestedFilterAddress = {
  city?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  person?: InputMaybe<NestedFilterPerson>;
  primary?: InputMaybe<FilterBoolean>;
  state?: InputMaybe<FilterString>;
  street?: InputMaybe<FilterString>;
  street2?: InputMaybe<FilterString>;
  zip?: InputMaybe<FilterString>;
};

export type person__OrderAddress = {
  city?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  person?: InputMaybe<OrderPerson>;
  primary?: InputMaybe<Ordering>;
  state?: InputMaybe<Ordering>;
  street?: InputMaybe<Ordering>;
  street2?: InputMaybe<Ordering>;
  zip?: InputMaybe<Ordering>;
};

export type plan__BenefitsSummaryResult = {
  createdAt: Scalars['String']['output'];
  event?: Maybe<issue__BenefitsSummaryGeneratedEvent>;
  id: Scalars['ID']['output'];
  owner: User;
  plan: plan__Plan;
  schemaVersion: Scalars['Int']['output'];
  summary: Scalars['JSON']['output'];
  updatedAt: Scalars['String']['output'];
};


export type plan__BenefitsSummaryResulteventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsSummaryGeneratedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsSummaryGeneratedEvent>;
};


export type plan__BenefitsSummaryResultownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type plan__BenefitsSummaryResultplanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};

export type plan__BenefitsSummaryResult_Type = BaseObject & Object & Owned & plan__BenefitsSummaryResult & {
  __typename: 'plan__BenefitsSummaryResult_Type';
  createdAt: Scalars['String']['output'];
  event?: Maybe<issue__BenefitsSummaryGeneratedEvent>;
  id: Scalars['ID']['output'];
  owner: User;
  plan: plan__Plan;
  schemaVersion: Scalars['Int']['output'];
  summary: Scalars['JSON']['output'];
  updatedAt: Scalars['String']['output'];
};


export type plan__BenefitsSummaryResult_TypeeventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterBenefitsSummaryGeneratedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderBenefitsSummaryGeneratedEvent>;
};


export type plan__BenefitsSummaryResult_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type plan__BenefitsSummaryResult_TypeplanArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};

export type plan__FilterBenefitsSummaryResult = {
  and?: InputMaybe<Array<plan__FilterBenefitsSummaryResult>>;
  createdAt?: InputMaybe<FilterString>;
  event?: InputMaybe<issue__NestedFilterBenefitsSummaryGeneratedEvent>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<plan__FilterBenefitsSummaryResult>;
  or?: InputMaybe<Array<plan__FilterBenefitsSummaryResult>>;
  owner?: InputMaybe<NestedFilterUser>;
  plan?: InputMaybe<plan__NestedFilterPlan>;
  schemaVersion?: InputMaybe<FilterInt>;
  summary?: InputMaybe<FilterJSON>;
  updatedAt?: InputMaybe<FilterString>;
};

export type plan__FilterPlan = {
  activeCoverages?: InputMaybe<fhirext__NestedFilterCoverageVersion>;
  and?: InputMaybe<Array<plan__FilterPlan>>;
  benefitsSummaryResults?: InputMaybe<plan__NestedFilterBenefitsSummaryResult>;
  coc?: InputMaybe<document__NestedFilterDocument>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<plan__FilterPlan>;
  or?: InputMaybe<Array<plan__FilterPlan>>;
  owner?: InputMaybe<NestedFilterUser>;
  planLabel?: InputMaybe<FilterString>;
  planType?: InputMaybe<Filterplan__PlanType>;
  sbc?: InputMaybe<document__NestedFilterDocument>;
  sob?: InputMaybe<document__NestedFilterDocument>;
  spd?: InputMaybe<document__NestedFilterDocument>;
  status?: InputMaybe<Filterplan__PlanStatus>;
};

export type plan__NestedFilterBenefitsSummaryResult = {
  createdAt?: InputMaybe<FilterString>;
  event?: InputMaybe<issue__NestedFilterBenefitsSummaryGeneratedEvent>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  plan?: InputMaybe<plan__NestedFilterPlan>;
  schemaVersion?: InputMaybe<FilterInt>;
  summary?: InputMaybe<FilterJSON>;
  updatedAt?: InputMaybe<FilterString>;
};

export type plan__NestedFilterPlan = {
  activeCoverages?: InputMaybe<fhirext__NestedFilterCoverageVersion>;
  benefitsSummaryResults?: InputMaybe<plan__NestedFilterBenefitsSummaryResult>;
  coc?: InputMaybe<document__NestedFilterDocument>;
  coverageType?: InputMaybe<Filterfhir__CoverageType>;
  createdAt?: InputMaybe<FilterString>;
  document?: InputMaybe<document__NestedFilterDocument>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  owner?: InputMaybe<NestedFilterUser>;
  planLabel?: InputMaybe<FilterString>;
  planType?: InputMaybe<Filterplan__PlanType>;
  sbc?: InputMaybe<document__NestedFilterDocument>;
  sob?: InputMaybe<document__NestedFilterDocument>;
  spd?: InputMaybe<document__NestedFilterDocument>;
  status?: InputMaybe<Filterplan__PlanStatus>;
};

export type plan__OrderBenefitsSummaryResult = {
  createdAt?: InputMaybe<Ordering>;
  event?: InputMaybe<issue__OrderBenefitsSummaryGeneratedEvent>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  plan?: InputMaybe<plan__OrderPlan>;
  schemaVersion?: InputMaybe<Ordering>;
  summary?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type plan__OrderPlan = {
  coc?: InputMaybe<document__OrderDocument>;
  coverageType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  document?: InputMaybe<document__OrderDocument>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  link?: InputMaybe<webAgent__OrderLink>;
  owner?: InputMaybe<OrderUser>;
  planLabel?: InputMaybe<Ordering>;
  planType?: InputMaybe<Ordering>;
  sbc?: InputMaybe<document__OrderDocument>;
  sob?: InputMaybe<document__OrderDocument>;
  spd?: InputMaybe<document__OrderDocument>;
  status?: InputMaybe<Ordering>;
};

export type plan__Plan = {
  activeCoverages?: Maybe<Array<fhirext__CoverageVersion>>;
  benefitsSummaryResults?: Maybe<Array<plan__BenefitsSummaryResult>>;
  coc?: Maybe<document__Document>;
  coveragePeriod?: Maybe<Scalars['JSON']['output']>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  document?: Maybe<document__Document>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<webAgent__Link>;
  owner: User;
  planLabel?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<plan__PlanType>;
  sbc?: Maybe<document__Document>;
  sob?: Maybe<document__Document>;
  spd?: Maybe<document__Document>;
  status?: Maybe<plan__PlanStatus>;
};


export type plan__PlanactiveCoveragesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverageVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverageVersion>;
};


export type plan__PlanbenefitsSummaryResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterBenefitsSummaryResult>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderBenefitsSummaryResult>;
};


export type plan__PlancocArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__PlandocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__PlanlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type plan__PlanownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type plan__PlansbcArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__PlansobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__PlanspdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

/** Status of the plan: ACTIVE, CANCELLED, PENDING. */
export enum plan__PlanStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING'
}

/** Type of health insurance plan. */
export enum plan__PlanType {
  Catastrophic = 'Catastrophic',
  DEPO = 'DEPO',
  DHMO = 'DHMO',
  DISP = 'DISP',
  DPOS = 'DPOS',
  DPPO = 'DPPO',
  EHB = 'EHB',
  EPO = 'EPO',
  FFS = 'FFS',
  HDHP = 'HDHP',
  HMO = 'HMO',
  Indemnity = 'Indemnity',
  MAPD = 'MAPD',
  MA_PD = 'MA_PD',
  MTM = 'MTM',
  OTC = 'OTC',
  PBM = 'PBM',
  PDP = 'PDP',
  POS = 'POS',
  PPO = 'PPO',
  Rx = 'Rx',
  VFFS = 'VFFS',
  VHMO = 'VHMO',
  VPOS = 'VPOS',
  VPPO = 'VPPO',
  VSP = 'VSP'
}

export type plan__Plan_Type = BaseObject & Object & Owned & plan__Plan & {
  __typename: 'plan__Plan_Type';
  activeCoverages?: Maybe<Array<fhirext__CoverageVersion>>;
  benefitsSummaryResults?: Maybe<Array<plan__BenefitsSummaryResult>>;
  coc?: Maybe<document__Document>;
  coveragePeriod?: Maybe<Scalars['JSON']['output']>;
  coverageType?: Maybe<fhir__CoverageType>;
  createdAt: Scalars['String']['output'];
  document?: Maybe<document__Document>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<webAgent__Link>;
  owner: User;
  planLabel?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<plan__PlanType>;
  sbc?: Maybe<document__Document>;
  sob?: Maybe<document__Document>;
  spd?: Maybe<document__Document>;
  status?: Maybe<plan__PlanStatus>;
};


export type plan__Plan_TypeactiveCoveragesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterCoverageVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderCoverageVersion>;
};


export type plan__Plan_TypebenefitsSummaryResultsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterBenefitsSummaryResult>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderBenefitsSummaryResult>;
};


export type plan__Plan_TypecocArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__Plan_TypedocumentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__Plan_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type plan__Plan_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type plan__Plan_TypesbcArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__Plan_TypesobArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type plan__Plan_TypespdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};

export enum projection__BenefitPositionKind {
  DEDUCTIBLE_FAMILY = 'DEDUCTIBLE_FAMILY',
  DEDUCTIBLE_INDIVIDUAL = 'DEDUCTIBLE_INDIVIDUAL',
  OOP_FAMILY = 'OOP_FAMILY',
  OOP_INDIVIDUAL = 'OOP_INDIVIDUAL'
}

export enum projection__BenefitPositionNetwork {
  IN_NETWORK = 'IN_NETWORK',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK',
  UNKNOWN = 'UNKNOWN'
}

export enum projection__BenefitPositionObservation {
  BASELINE = 'BASELINE',
  ENDED = 'ENDED',
  MOVED = 'MOVED',
  RUNG_SWITCH = 'RUNG_SWITCH',
  UNCHANGED = 'UNCHANGED'
}

export type projection__BenefitPositionObservationView = {
  checkId: Scalars['String']['output'];
  delta?: Maybe<Scalars['Float']['output']>;
  eventId: Scalars['String']['output'];
  forced: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: projection__BenefitPositionKind;
  lead: Scalars['Boolean']['output'];
  limitAmount?: Maybe<Scalars['Float']['output']>;
  materializationKey: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  metAmount?: Maybe<Scalars['Float']['output']>;
  network?: Maybe<projection__BenefitPositionNetwork>;
  observation: projection__BenefitPositionObservation;
  observedAt: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  planYearEnd?: Maybe<Scalars['String']['output']>;
  planYearStart?: Maybe<Scalars['String']['output']>;
  previousMetAmount?: Maybe<Scalars['Float']['output']>;
  remainingAmount?: Maybe<Scalars['Float']['output']>;
  scope: projection__BenefitPositionScope;
  source?: Maybe<Scalars['String']['output']>;
  user: User;
};


export type projection__BenefitPositionObservationViewuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__BenefitPositionObservationView_Type = BaseObject & Object & projection__BenefitPositionObservationView & {
  __typename: 'projection__BenefitPositionObservationView_Type';
  checkId: Scalars['String']['output'];
  delta?: Maybe<Scalars['Float']['output']>;
  eventId: Scalars['String']['output'];
  forced: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  kind: projection__BenefitPositionKind;
  lead: Scalars['Boolean']['output'];
  limitAmount?: Maybe<Scalars['Float']['output']>;
  materializationKey: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  metAmount?: Maybe<Scalars['Float']['output']>;
  network?: Maybe<projection__BenefitPositionNetwork>;
  observation: projection__BenefitPositionObservation;
  observedAt: Scalars['String']['output'];
  payerName: Scalars['String']['output'];
  planYearEnd?: Maybe<Scalars['String']['output']>;
  planYearStart?: Maybe<Scalars['String']['output']>;
  previousMetAmount?: Maybe<Scalars['Float']['output']>;
  remainingAmount?: Maybe<Scalars['Float']['output']>;
  scope: projection__BenefitPositionScope;
  source?: Maybe<Scalars['String']['output']>;
  user: User;
};


export type projection__BenefitPositionObservationView_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum projection__BenefitPositionScope {
  IN_NETWORK = 'IN_NETWORK',
  OUT_OF_NETWORK = 'OUT_OF_NETWORK'
}

export type projection__CaseAskView = {
  askId: Scalars['String']['output'];
  askedAt?: Maybe<Scalars['String']['output']>;
  caseView: projection__CaseView;
  detail: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  kind: projection__RequirementKind;
  satisfiedAt?: Maybe<Scalars['String']['output']>;
  targetOrganizationId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<projection__RequirementTargetType>;
};


export type projection__CaseAskViewcaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export type projection__CaseAskView_Type = BaseObject & Object & projection__CaseAskView & {
  __typename: 'projection__CaseAskView_Type';
  askId: Scalars['String']['output'];
  askedAt?: Maybe<Scalars['String']['output']>;
  caseView: projection__CaseView;
  detail: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  kind: projection__RequirementKind;
  satisfiedAt?: Maybe<Scalars['String']['output']>;
  targetOrganizationId?: Maybe<Scalars['String']['output']>;
  targetType?: Maybe<projection__RequirementTargetType>;
};


export type projection__CaseAskView_TypecaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export type projection__CaseBillAmountView = {
  amount: Scalars['Decimal']['output'];
  caseView: projection__CaseView;
  discrepancy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  observationId?: Maybe<Scalars['String']['output']>;
  recordedAt?: Maybe<Scalars['String']['output']>;
  resolvedFrom?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};


export type projection__CaseBillAmountViewcaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export type projection__CaseBillAmountView_Type = BaseObject & Object & projection__CaseBillAmountView & {
  __typename: 'projection__CaseBillAmountView_Type';
  amount: Scalars['Decimal']['output'];
  caseView: projection__CaseView;
  discrepancy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  observationId?: Maybe<Scalars['String']['output']>;
  recordedAt?: Maybe<Scalars['String']['output']>;
  resolvedFrom?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
};


export type projection__CaseBillAmountView_TypecaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export type projection__CaseFlowView = {
  answers: Scalars['JSON']['output'];
  caseView: projection__CaseView;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  flowId: Scalars['String']['output'];
  flowType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  specVersion?: Maybe<Scalars['Int64']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
};


export type projection__CaseFlowViewcaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export type projection__CaseFlowView_Type = BaseObject & Object & projection__CaseFlowView & {
  __typename: 'projection__CaseFlowView_Type';
  answers: Scalars['JSON']['output'];
  caseView: projection__CaseView;
  completed: Scalars['Boolean']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  flowId: Scalars['String']['output'];
  flowType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  specVersion?: Maybe<Scalars['Int64']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
};


export type projection__CaseFlowView_TypecaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export enum projection__CaseLifecycle {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN'
}

export type projection__CasePriorPaymentView = {
  amountPaid?: Maybe<Scalars['Decimal']['output']>;
  caseView: projection__CaseView;
  discrepancy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recordedAt?: Maybe<Scalars['String']['output']>;
  resolvedFrom?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};


export type projection__CasePriorPaymentViewcaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export type projection__CasePriorPaymentView_Type = BaseObject & Object & projection__CasePriorPaymentView & {
  __typename: 'projection__CasePriorPaymentView_Type';
  amountPaid?: Maybe<Scalars['Decimal']['output']>;
  caseView: projection__CaseView;
  discrepancy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recordedAt?: Maybe<Scalars['String']['output']>;
  resolvedFrom?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  status: Scalars['String']['output'];
};


export type projection__CasePriorPaymentView_TypecaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export type projection__CaseProviderView = {
  caseView: projection__CaseView;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  setBy: projection__ProviderSetBy;
  source: Scalars['String']['output'];
};


export type projection__CaseProviderViewcaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export type projection__CaseProviderView_Type = BaseObject & Object & projection__CaseProviderView & {
  __typename: 'projection__CaseProviderView_Type';
  caseView: projection__CaseView;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  setBy: projection__ProviderSetBy;
  source: Scalars['String']['output'];
};


export type projection__CaseProviderView_TypecaseViewArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseView>;
};

export type projection__CaseReengagementFeed = {
  bill_upload_requested_ask_id?: Maybe<Scalars['String']['output']>;
  bill_upload_requested_at?: Maybe<Scalars['String']['output']>;
  bill_uploaded_ask_id?: Maybe<Scalars['String']['output']>;
  bill_uploaded_at?: Maybe<Scalars['String']['output']>;
  coverage_card_received_at?: Maybe<Scalars['String']['output']>;
  coverage_insured_declared_at?: Maybe<Scalars['String']['output']>;
  coverage_requested_at?: Maybe<Scalars['String']['output']>;
  coverage_uninsured_declared_at?: Maybe<Scalars['String']['output']>;
  hipaa_requested_at?: Maybe<Scalars['String']['output']>;
  hipaa_requested_authorization_ids: Array<Scalars['String']['output']>;
  hipaa_signed_at?: Maybe<Scalars['String']['output']>;
  hipaa_signed_authorization_ids: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  last_outreach_at?: Maybe<Scalars['String']['output']>;
  latest_ha_message_id?: Maybe<Scalars['String']['output']>;
  latest_ha_message_seen_at?: Maybe<Scalars['String']['output']>;
  latest_ha_message_sent_at?: Maybe<Scalars['String']['output']>;
  latest_member_message_id?: Maybe<Scalars['String']['output']>;
  latest_member_message_sent_at?: Maybe<Scalars['String']['output']>;
  latest_seen_ha_message_id?: Maybe<Scalars['String']['output']>;
  latest_seen_ha_message_seen_at?: Maybe<Scalars['String']['output']>;
  latest_seen_ha_message_sent_at?: Maybe<Scalars['String']['output']>;
  payment_cancelled_at?: Maybe<Scalars['String']['output']>;
  payment_charge_failed_at?: Maybe<Scalars['String']['output']>;
  payment_charge_resolved_at?: Maybe<Scalars['String']['output']>;
  payment_confirmed_at?: Maybe<Scalars['String']['output']>;
  payment_declined_at?: Maybe<Scalars['String']['output']>;
  payment_requested_at?: Maybe<Scalars['String']['output']>;
  status: projection__CaseLifecycle;
  top_user_ask?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  waiting_on?: Maybe<projection__CaseWaitingActor>;
};


export type projection__CaseReengagementFeedissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type projection__CaseReengagementFeed_Type = BaseObject & Object & projection__CaseReengagementFeed & {
  __typename: 'projection__CaseReengagementFeed_Type';
  bill_upload_requested_ask_id?: Maybe<Scalars['String']['output']>;
  bill_upload_requested_at?: Maybe<Scalars['String']['output']>;
  bill_uploaded_ask_id?: Maybe<Scalars['String']['output']>;
  bill_uploaded_at?: Maybe<Scalars['String']['output']>;
  coverage_card_received_at?: Maybe<Scalars['String']['output']>;
  coverage_insured_declared_at?: Maybe<Scalars['String']['output']>;
  coverage_requested_at?: Maybe<Scalars['String']['output']>;
  coverage_uninsured_declared_at?: Maybe<Scalars['String']['output']>;
  hipaa_requested_at?: Maybe<Scalars['String']['output']>;
  hipaa_requested_authorization_ids: Array<Scalars['String']['output']>;
  hipaa_signed_at?: Maybe<Scalars['String']['output']>;
  hipaa_signed_authorization_ids: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  last_outreach_at?: Maybe<Scalars['String']['output']>;
  latest_ha_message_id?: Maybe<Scalars['String']['output']>;
  latest_ha_message_seen_at?: Maybe<Scalars['String']['output']>;
  latest_ha_message_sent_at?: Maybe<Scalars['String']['output']>;
  latest_member_message_id?: Maybe<Scalars['String']['output']>;
  latest_member_message_sent_at?: Maybe<Scalars['String']['output']>;
  latest_seen_ha_message_id?: Maybe<Scalars['String']['output']>;
  latest_seen_ha_message_seen_at?: Maybe<Scalars['String']['output']>;
  latest_seen_ha_message_sent_at?: Maybe<Scalars['String']['output']>;
  payment_cancelled_at?: Maybe<Scalars['String']['output']>;
  payment_charge_failed_at?: Maybe<Scalars['String']['output']>;
  payment_charge_resolved_at?: Maybe<Scalars['String']['output']>;
  payment_confirmed_at?: Maybe<Scalars['String']['output']>;
  payment_declined_at?: Maybe<Scalars['String']['output']>;
  payment_requested_at?: Maybe<Scalars['String']['output']>;
  status: projection__CaseLifecycle;
  top_user_ask?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['String']['output'];
  user_id: Scalars['String']['output'];
  waiting_on?: Maybe<projection__CaseWaitingActor>;
};


export type projection__CaseReengagementFeed_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type projection__CaseView = {
  asks?: Maybe<Array<projection__CaseAskView>>;
  billAmount?: Maybe<projection__CaseBillAmountView>;
  caseType?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  escalatedAt?: Maybe<Scalars['String']['output']>;
  facts?: Maybe<Scalars['JSON']['output']>;
  flows?: Maybe<Array<projection__CaseFlowView>>;
  id: Scalars['ID']['output'];
  identityObservations: Scalars['JSON']['output'];
  info?: Maybe<Scalars['JSON']['output']>;
  isEscalated: Scalars['Boolean']['output'];
  issue: issue__Issue;
  lifecycle: projection__CaseLifecycle;
  milestones?: Maybe<Scalars['JSON']['output']>;
  priorPayment?: Maybe<projection__CasePriorPaymentView>;
  provider?: Maybe<projection__CaseProviderView>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};


export type projection__CaseViewasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseAskView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseAskView>;
};


export type projection__CaseViewbillAmountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseBillAmountView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseBillAmountView>;
};


export type projection__CaseViewflowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseFlowView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseFlowView>;
};


export type projection__CaseViewissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type projection__CaseViewpriorPaymentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCasePriorPaymentView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCasePriorPaymentView>;
};


export type projection__CaseViewproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseProviderView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseProviderView>;
};

export type projection__CaseView_Type = BaseObject & Object & projection__CaseView & {
  __typename: 'projection__CaseView_Type';
  asks?: Maybe<Array<projection__CaseAskView>>;
  billAmount?: Maybe<projection__CaseBillAmountView>;
  caseType?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  escalatedAt?: Maybe<Scalars['String']['output']>;
  facts?: Maybe<Scalars['JSON']['output']>;
  flows?: Maybe<Array<projection__CaseFlowView>>;
  id: Scalars['ID']['output'];
  identityObservations: Scalars['JSON']['output'];
  info?: Maybe<Scalars['JSON']['output']>;
  isEscalated: Scalars['Boolean']['output'];
  issue: issue__Issue;
  lifecycle: projection__CaseLifecycle;
  milestones?: Maybe<Scalars['JSON']['output']>;
  priorPayment?: Maybe<projection__CasePriorPaymentView>;
  provider?: Maybe<projection__CaseProviderView>;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};


export type projection__CaseView_TypeasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseAskView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseAskView>;
};


export type projection__CaseView_TypebillAmountArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseBillAmountView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseBillAmountView>;
};


export type projection__CaseView_TypeflowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseFlowView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseFlowView>;
};


export type projection__CaseView_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type projection__CaseView_TypepriorPaymentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCasePriorPaymentView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCasePriorPaymentView>;
};


export type projection__CaseView_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterCaseProviderView>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderCaseProviderView>;
};

export enum projection__CaseWaitingActor {
  GRANTED_HEALTH = 'GRANTED_HEALTH',
  INSURER = 'INSURER',
  PROVIDER = 'PROVIDER',
  USER = 'USER'
}

export enum projection__CdpProvider {
  BRIGHTDATA = 'BRIGHTDATA',
  BROWSERBASE = 'BROWSERBASE',
  BROWSERLESS = 'BROWSERLESS',
  BROWSER_USE = 'BROWSER_USE',
  LOCAL = 'LOCAL',
  STEEL = 'STEEL',
  UNDETECT = 'UNDETECT'
}

export type projection__EligibilityCheckAttemptView = {
  attemptedAt: Scalars['String']['output'];
  checkId?: Maybe<Scalars['String']['output']>;
  confirmedMemberId?: Maybe<Scalars['String']['output']>;
  coverageType?: Maybe<Scalars['String']['output']>;
  dispatchReason?: Maybe<projection__EligibilityCheckDispatchReason>;
  dispatched: Scalars['Boolean']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorSubCode?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  materializationKey: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  membershipSource?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  npiSource?: Maybe<Scalars['String']['output']>;
  outcome: projection__EligibilityCheckOutcome;
  payerId?: Maybe<Scalars['String']['output']>;
  payerName: Scalars['String']['output'];
  payerSource?: Maybe<Scalars['String']['output']>;
  rawResponse?: Maybe<Scalars['JSON']['output']>;
  subscriberDobSource?: Maybe<Scalars['String']['output']>;
  subscriberFirstNameSource?: Maybe<Scalars['String']['output']>;
  subscriberLastNameSource?: Maybe<Scalars['String']['output']>;
  suppressedSignature?: Maybe<Scalars['String']['output']>;
  suppressionRetryAt?: Maybe<Scalars['String']['output']>;
  user: User;
  vendorResponseId?: Maybe<Scalars['String']['output']>;
};


export type projection__EligibilityCheckAttemptViewuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__EligibilityCheckAttemptView_Type = BaseObject & Object & projection__EligibilityCheckAttemptView & {
  __typename: 'projection__EligibilityCheckAttemptView_Type';
  attemptedAt: Scalars['String']['output'];
  checkId?: Maybe<Scalars['String']['output']>;
  confirmedMemberId?: Maybe<Scalars['String']['output']>;
  coverageType?: Maybe<Scalars['String']['output']>;
  dispatchReason?: Maybe<projection__EligibilityCheckDispatchReason>;
  dispatched: Scalars['Boolean']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorSubCode?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  materializationKey: Scalars['String']['output'];
  memberId: Scalars['String']['output'];
  membershipSource?: Maybe<Scalars['String']['output']>;
  npi?: Maybe<Scalars['String']['output']>;
  npiSource?: Maybe<Scalars['String']['output']>;
  outcome: projection__EligibilityCheckOutcome;
  payerId?: Maybe<Scalars['String']['output']>;
  payerName: Scalars['String']['output'];
  payerSource?: Maybe<Scalars['String']['output']>;
  rawResponse?: Maybe<Scalars['JSON']['output']>;
  subscriberDobSource?: Maybe<Scalars['String']['output']>;
  subscriberFirstNameSource?: Maybe<Scalars['String']['output']>;
  subscriberLastNameSource?: Maybe<Scalars['String']['output']>;
  suppressedSignature?: Maybe<Scalars['String']['output']>;
  suppressionRetryAt?: Maybe<Scalars['String']['output']>;
  user: User;
  vendorResponseId?: Maybe<Scalars['String']['output']>;
};


export type projection__EligibilityCheckAttemptView_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum projection__EligibilityCheckDispatchReason {
  BASELINE = 'BASELINE',
  CHANGED = 'CHANGED',
  DRY_RUN = 'DRY_RUN',
  EMPTY_SNAPSHOT = 'EMPTY_SNAPSHOT',
  FORCED = 'FORCED',
  UNCHANGED = 'UNCHANGED'
}

export enum projection__EligibilityCheckOutcome {
  CHECKED = 'CHECKED',
  FAILED = 'FAILED',
  SKIPPED = 'SKIPPED'
}

export enum projection__EnrichmentConfidence {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export enum projection__EnrichmentPriceRating {
  GOOD_VALUE = 'GOOD_VALUE',
  HIGH = 'HIGH',
  LOW = 'LOW',
  TYPICAL = 'TYPICAL',
  UNKNOWN = 'UNKNOWN'
}

export type projection__FilterBenefitPositionObservationView = {
  and?: InputMaybe<Array<projection__FilterBenefitPositionObservationView>>;
  checkId?: InputMaybe<FilterString>;
  delta?: InputMaybe<FilterFloat>;
  eventId?: InputMaybe<FilterString>;
  forced?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprojection__BenefitPositionKind>;
  lead?: InputMaybe<FilterBoolean>;
  limitAmount?: InputMaybe<FilterFloat>;
  materializationKey?: InputMaybe<FilterString>;
  memberId?: InputMaybe<FilterString>;
  metAmount?: InputMaybe<FilterFloat>;
  network?: InputMaybe<Filterprojection__BenefitPositionNetwork>;
  not?: InputMaybe<projection__FilterBenefitPositionObservationView>;
  observation?: InputMaybe<Filterprojection__BenefitPositionObservation>;
  observedAt?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<projection__FilterBenefitPositionObservationView>>;
  payerName?: InputMaybe<FilterString>;
  planYearEnd?: InputMaybe<FilterString>;
  planYearStart?: InputMaybe<FilterString>;
  previousMetAmount?: InputMaybe<FilterFloat>;
  remainingAmount?: InputMaybe<FilterFloat>;
  scope?: InputMaybe<Filterprojection__BenefitPositionScope>;
  source?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type projection__FilterCaseAskView = {
  and?: InputMaybe<Array<projection__FilterCaseAskView>>;
  askId?: InputMaybe<FilterString>;
  askedAt?: InputMaybe<FilterString>;
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  detail?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprojection__RequirementKind>;
  not?: InputMaybe<projection__FilterCaseAskView>;
  or?: InputMaybe<Array<projection__FilterCaseAskView>>;
  satisfiedAt?: InputMaybe<FilterString>;
  targetOrganizationId?: InputMaybe<FilterString>;
  targetType?: InputMaybe<Filterprojection__RequirementTargetType>;
};

export type projection__FilterCaseBillAmountView = {
  amount?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<projection__FilterCaseBillAmountView>>;
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  discrepancy?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterCaseBillAmountView>;
  observationId?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<projection__FilterCaseBillAmountView>>;
  recordedAt?: InputMaybe<FilterString>;
  resolvedFrom?: InputMaybe<FilterString>;
  source?: InputMaybe<FilterString>;
};

export type projection__FilterCaseFlowView = {
  and?: InputMaybe<Array<projection__FilterCaseFlowView>>;
  answers?: InputMaybe<FilterJSON>;
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  completed?: InputMaybe<FilterBoolean>;
  completedAt?: InputMaybe<FilterString>;
  flowId?: InputMaybe<FilterString>;
  flowType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterCaseFlowView>;
  or?: InputMaybe<Array<projection__FilterCaseFlowView>>;
  specVersion?: InputMaybe<FilterInt64>;
  startedAt?: InputMaybe<FilterString>;
};

export type projection__FilterCasePriorPaymentView = {
  amountPaid?: InputMaybe<FilterDecimal>;
  and?: InputMaybe<Array<projection__FilterCasePriorPaymentView>>;
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  discrepancy?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterCasePriorPaymentView>;
  or?: InputMaybe<Array<projection__FilterCasePriorPaymentView>>;
  recordedAt?: InputMaybe<FilterString>;
  resolvedFrom?: InputMaybe<FilterString>;
  source?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterString>;
};

export type projection__FilterCaseProviderView = {
  and?: InputMaybe<Array<projection__FilterCaseProviderView>>;
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterCaseProviderView>;
  or?: InputMaybe<Array<projection__FilterCaseProviderView>>;
  providerId?: InputMaybe<FilterString>;
  setBy?: InputMaybe<Filterprojection__ProviderSetBy>;
  source?: InputMaybe<FilterString>;
};

export type projection__FilterCaseReengagementFeed = {
  and?: InputMaybe<Array<projection__FilterCaseReengagementFeed>>;
  bill_upload_requested_ask_id?: InputMaybe<FilterString>;
  bill_upload_requested_at?: InputMaybe<FilterString>;
  bill_uploaded_ask_id?: InputMaybe<FilterString>;
  bill_uploaded_at?: InputMaybe<FilterString>;
  coverage_card_received_at?: InputMaybe<FilterString>;
  coverage_insured_declared_at?: InputMaybe<FilterString>;
  coverage_requested_at?: InputMaybe<FilterString>;
  coverage_uninsured_declared_at?: InputMaybe<FilterString>;
  hipaa_requested_at?: InputMaybe<FilterString>;
  hipaa_signed_at?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  last_outreach_at?: InputMaybe<FilterString>;
  latest_ha_message_id?: InputMaybe<FilterString>;
  latest_ha_message_seen_at?: InputMaybe<FilterString>;
  latest_ha_message_sent_at?: InputMaybe<FilterString>;
  latest_member_message_id?: InputMaybe<FilterString>;
  latest_member_message_sent_at?: InputMaybe<FilterString>;
  latest_seen_ha_message_id?: InputMaybe<FilterString>;
  latest_seen_ha_message_seen_at?: InputMaybe<FilterString>;
  latest_seen_ha_message_sent_at?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterCaseReengagementFeed>;
  or?: InputMaybe<Array<projection__FilterCaseReengagementFeed>>;
  payment_cancelled_at?: InputMaybe<FilterString>;
  payment_charge_failed_at?: InputMaybe<FilterString>;
  payment_charge_resolved_at?: InputMaybe<FilterString>;
  payment_confirmed_at?: InputMaybe<FilterString>;
  payment_declined_at?: InputMaybe<FilterString>;
  payment_requested_at?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterprojection__CaseLifecycle>;
  top_user_ask?: InputMaybe<FilterString>;
  updated_at?: InputMaybe<FilterString>;
  user_id?: InputMaybe<FilterString>;
  waiting_on?: InputMaybe<Filterprojection__CaseWaitingActor>;
};

export type projection__FilterCaseView = {
  and?: InputMaybe<Array<projection__FilterCaseView>>;
  asks?: InputMaybe<projection__NestedFilterCaseAskView>;
  billAmount?: InputMaybe<projection__NestedFilterCaseBillAmountView>;
  caseType?: InputMaybe<FilterString>;
  closedAt?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  escalatedAt?: InputMaybe<FilterString>;
  facts?: InputMaybe<FilterJSON>;
  flows?: InputMaybe<projection__NestedFilterCaseFlowView>;
  id?: InputMaybe<FilterID>;
  identityObservations?: InputMaybe<FilterJSON>;
  info?: InputMaybe<FilterJSON>;
  isEscalated?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  lifecycle?: InputMaybe<Filterprojection__CaseLifecycle>;
  milestones?: InputMaybe<FilterJSON>;
  not?: InputMaybe<projection__FilterCaseView>;
  or?: InputMaybe<Array<projection__FilterCaseView>>;
  priorPayment?: InputMaybe<projection__NestedFilterCasePriorPaymentView>;
  provider?: InputMaybe<projection__NestedFilterCaseProviderView>;
  updatedAt?: InputMaybe<FilterString>;
  userId?: InputMaybe<FilterString>;
};

export type projection__FilterEligibilityCheckAttemptView = {
  and?: InputMaybe<Array<projection__FilterEligibilityCheckAttemptView>>;
  attemptedAt?: InputMaybe<FilterString>;
  checkId?: InputMaybe<FilterString>;
  confirmedMemberId?: InputMaybe<FilterString>;
  coverageType?: InputMaybe<FilterString>;
  dispatchReason?: InputMaybe<Filterprojection__EligibilityCheckDispatchReason>;
  dispatched?: InputMaybe<FilterBoolean>;
  errorCode?: InputMaybe<FilterString>;
  errorSubCode?: InputMaybe<FilterString>;
  eventId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  materializationKey?: InputMaybe<FilterString>;
  memberId?: InputMaybe<FilterString>;
  membershipSource?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterEligibilityCheckAttemptView>;
  npi?: InputMaybe<FilterString>;
  npiSource?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<projection__FilterEligibilityCheckAttemptView>>;
  outcome?: InputMaybe<Filterprojection__EligibilityCheckOutcome>;
  payerId?: InputMaybe<FilterString>;
  payerName?: InputMaybe<FilterString>;
  payerSource?: InputMaybe<FilterString>;
  rawResponse?: InputMaybe<FilterJSON>;
  subscriberDobSource?: InputMaybe<FilterString>;
  subscriberFirstNameSource?: InputMaybe<FilterString>;
  subscriberLastNameSource?: InputMaybe<FilterString>;
  suppressedSignature?: InputMaybe<FilterString>;
  suppressionRetryAt?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
  vendorResponseId?: InputMaybe<FilterString>;
};

export type projection__FilterInsuranceDiscoveryAttemptView = {
  activeCoveragesFound?: InputMaybe<FilterInt64>;
  and?: InputMaybe<Array<projection__FilterInsuranceDiscoveryAttemptView>>;
  attemptedAt?: InputMaybe<FilterString>;
  confidenceLevel?: InputMaybe<FilterString>;
  coveragesFound?: InputMaybe<FilterInt64>;
  discoveryId?: InputMaybe<FilterString>;
  errorCode?: InputMaybe<FilterString>;
  errorSubCode?: InputMaybe<FilterString>;
  eventId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterInsuranceDiscoveryAttemptView>;
  npi?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<projection__FilterInsuranceDiscoveryAttemptView>>;
  outcome?: InputMaybe<Filterprojection__InsuranceDiscoveryOutcome>;
  rawResponse?: InputMaybe<FilterJSON>;
  searchedDateOfBirth?: InputMaybe<FilterString>;
  searchedFirstName?: InputMaybe<FilterString>;
  searchedLastName?: InputMaybe<FilterString>;
  searchedState?: InputMaybe<FilterString>;
  trigger?: InputMaybe<Filterprojection__InsuranceDiscoveryTrigger>;
  user?: InputMaybe<NestedFilterUser>;
  vendorDurationMs?: InputMaybe<FilterInt64>;
  vendorPollCount?: InputMaybe<FilterInt64>;
};

export type projection__FilterRpaBrowserFingerprint = {
  and?: InputMaybe<Array<projection__FilterRpaBrowserFingerprint>>;
  botdIsBot?: InputMaybe<FilterBoolean>;
  botdVerdict?: InputMaybe<FilterString>;
  canvasHash?: InputMaybe<FilterString>;
  canvasTag?: InputMaybe<FilterString>;
  connectionId?: InputMaybe<FilterString>;
  creepjsHeadless?: InputMaybe<FilterFloat>;
  creepjsLikeHeadless?: InputMaybe<FilterFloat>;
  creepjsReason?: InputMaybe<FilterString>;
  creepjsStealth?: InputMaybe<FilterFloat>;
  creepjsTag?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  deviceMemoryGb?: InputMaybe<FilterFloat>;
  fingerprintProbeFailedReason?: InputMaybe<FilterString>;
  fingerprintTag?: InputMaybe<FilterString>;
  hardwareConcurrency?: InputMaybe<FilterFloat>;
  http2Fingerprint?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  ja4?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterRpaBrowserFingerprint>;
  or?: InputMaybe<Array<projection__FilterRpaBrowserFingerprint>>;
  osMismatch?: InputMaybe<FilterBoolean>;
  platform?: InputMaybe<FilterString>;
  pluginCount?: InputMaybe<FilterFloat>;
  rbDummyFn?: InputMaybe<FilterString>;
  rbExposeFunctionLeak?: InputMaybe<FilterString>;
  rbMainWorldExecution?: InputMaybe<FilterString>;
  rbRuntimeEnableLeak?: InputMaybe<FilterString>;
  rbSourceUrlLeak?: InputMaybe<FilterString>;
  rebrowserReason?: InputMaybe<FilterString>;
  rebrowserTag?: InputMaybe<FilterString>;
  runtimeEnableTag?: InputMaybe<FilterString>;
  schemaVersion?: InputMaybe<FilterInt64>;
  sessionId?: InputMaybe<FilterString>;
  timezone?: InputMaybe<FilterString>;
  tzOffsetMinutes?: InputMaybe<FilterFloat>;
  updatedAt?: InputMaybe<FilterString>;
  userAgent?: InputMaybe<FilterString>;
  webdriverFlag?: InputMaybe<FilterBoolean>;
  webdriverTag?: InputMaybe<FilterString>;
  webglRenderer?: InputMaybe<FilterString>;
  webglTag?: InputMaybe<FilterString>;
  webglUnmaskedRenderer?: InputMaybe<FilterString>;
  wireReason?: InputMaybe<FilterString>;
  wireTag?: InputMaybe<FilterString>;
};

export type projection__FilterRpaConnection = {
  and?: InputMaybe<Array<projection__FilterRpaConnection>>;
  connectionId?: InputMaybe<FilterString>;
  connectionStatus?: InputMaybe<Filterprojection__RpaConnectionStatus>;
  id?: InputMaybe<FilterID>;
  inspectUrl?: InputMaybe<FilterString>;
  lostReason?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterRpaConnection>;
  or?: InputMaybe<Array<projection__FilterRpaConnection>>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
  startedAt?: InputMaybe<FilterString>;
  tasks?: InputMaybe<projection__NestedFilterRpaTask>;
};

export type projection__FilterRpaEgressIp = {
  and?: InputMaybe<Array<projection__FilterRpaEgressIp>>;
  connectionId?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaEgressIp>;
  or?: InputMaybe<Array<projection__FilterRpaEgressIp>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  sessionId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
};

export type projection__FilterRpaExperimentView = {
  and?: InputMaybe<Array<projection__FilterRpaExperimentView>>;
  data?: InputMaybe<FilterJSON>;
  experimentId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaExperimentView>;
  or?: InputMaybe<Array<projection__FilterRpaExperimentView>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterString>;
  stoppedAt?: InputMaybe<FilterString>;
};

export type projection__FilterRpaLinkView = {
  and?: InputMaybe<Array<projection__FilterRpaLinkView>>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  linkId?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterRpaLinkView>;
  or?: InputMaybe<Array<projection__FilterRpaLinkView>>;
  schemaVersion?: InputMaybe<FilterInt64>;
};

export type projection__FilterRpaProviderAttempt = {
  and?: InputMaybe<Array<projection__FilterRpaProviderAttempt>>;
  errorMessage?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaProviderAttempt>;
  occurredAt?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<projection__FilterRpaProviderAttempt>>;
  provider?: InputMaybe<Filterprojection__CdpProvider>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
  success?: InputMaybe<FilterBoolean>;
};

export type projection__FilterRpaSession = {
  and?: InputMaybe<Array<projection__FilterRpaSession>>;
  cancelledAt?: InputMaybe<FilterString>;
  cdpProviderSessionId?: InputMaybe<FilterString>;
  connections?: InputMaybe<projection__NestedFilterRpaConnection>;
  endpointId?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  linkId?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterRpaSession>;
  or?: InputMaybe<Array<projection__FilterRpaSession>>;
  provider?: InputMaybe<Filterprojection__CdpProvider>;
  providerAttempts?: InputMaybe<projection__NestedFilterRpaProviderAttempt>;
  proxyGeoCity?: InputMaybe<FilterString>;
  proxyGeoCountry?: InputMaybe<FilterString>;
  proxyGeoSubdivision?: InputMaybe<FilterString>;
  proxyOrigin?: InputMaybe<Filterprojection__ProxyOrigin>;
  proxyStickyLabel?: InputMaybe<FilterString>;
  proxyStickyTtlMinutes?: InputMaybe<FilterInt64>;
  proxyStrategy?: InputMaybe<Filterprojection__ProxyStrategy>;
  sessionId?: InputMaybe<FilterString>;
  sessionStatus?: InputMaybe<Filterprojection__RpaSessionStatus>;
  startedAt?: InputMaybe<FilterString>;
  stealthStrategy?: InputMaybe<Filterprojection__StealthStrategy>;
  timeline?: InputMaybe<projection__NestedFilterRpaTimelineEntry>;
  userId?: InputMaybe<FilterString>;
};

export type projection__FilterRpaSessionSummary = {
  and?: InputMaybe<Array<projection__FilterRpaSessionSummary>>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  linkId?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterRpaSessionSummary>;
  or?: InputMaybe<Array<projection__FilterRpaSessionSummary>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  sessionId?: InputMaybe<FilterString>;
  startedAt?: InputMaybe<FilterString>;
};

export type projection__FilterRpaSessionTimeline = {
  and?: InputMaybe<Array<projection__FilterRpaSessionTimeline>>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaSessionTimeline>;
  or?: InputMaybe<Array<projection__FilterRpaSessionTimeline>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  sessionId?: InputMaybe<FilterString>;
};

export type projection__FilterRpaTask = {
  and?: InputMaybe<Array<projection__FilterRpaTask>>;
  classifyActionTaken?: InputMaybe<FilterBoolean>;
  classifyClassification?: InputMaybe<FilterString>;
  connection?: InputMaybe<projection__NestedFilterRpaConnection>;
  failureReason?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprojection__RpaTaskKind>;
  not?: InputMaybe<projection__FilterRpaTask>;
  or?: InputMaybe<Array<projection__FilterRpaTask>>;
  signInPhase?: InputMaybe<FilterString>;
  signInPhaseDetail?: InputMaybe<FilterJSON>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterprojection__RpaTaskStatus>;
  taskId?: InputMaybe<FilterString>;
};

export type projection__FilterRpaTimelineEntry = {
  and?: InputMaybe<Array<projection__FilterRpaTimelineEntry>>;
  eventDetail?: InputMaybe<FilterJSON>;
  eventTag?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterRpaTimelineEntry>;
  occurredAt?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<projection__FilterRpaTimelineEntry>>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
};

export type projection__FilterUserDataView = {
  and?: InputMaybe<Array<projection__FilterUserDataView>>;
  createdAt?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  kind?: InputMaybe<FilterString>;
  metadata?: InputMaybe<FilterJSON>;
  not?: InputMaybe<projection__FilterUserDataView>;
  or?: InputMaybe<Array<projection__FilterUserDataView>>;
  schemaVersion?: InputMaybe<FilterInt64>;
  updatedAt?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type projection__FilterUserEligibilityView = {
  and?: InputMaybe<Array<projection__FilterUserEligibilityView>>;
  createdAt?: InputMaybe<FilterString>;
  enrolledAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  lastCheckDispatchReason?: InputMaybe<Filterprojection__EligibilityCheckDispatchReason>;
  lastCheckOutcome?: InputMaybe<Filterprojection__EligibilityCheckOutcome>;
  lastCheckVendorResponseId?: InputMaybe<FilterString>;
  lastCheckedAt?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterUserEligibilityView>;
  or?: InputMaybe<Array<projection__FilterUserEligibilityView>>;
  updatedAt?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type projection__FilterUserEnrichmentData = {
  and?: InputMaybe<Array<projection__FilterUserEnrichmentData>>;
  confidence?: InputMaybe<Filterprojection__EnrichmentConfidence>;
  createdAt?: InputMaybe<FilterString>;
  enrichments?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  kind?: InputMaybe<FilterString>;
  not?: InputMaybe<projection__FilterUserEnrichmentData>;
  or?: InputMaybe<Array<projection__FilterUserEnrichmentData>>;
  overallPriceRating?: InputMaybe<Filterprojection__EnrichmentPriceRating>;
  schemaVersion?: InputMaybe<FilterInt64>;
  title?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type projection__FilterUserMemory = {
  and?: InputMaybe<Array<projection__FilterUserMemory>>;
  createdAt?: InputMaybe<FilterString>;
  entries?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<projection__FilterUserMemory>;
  or?: InputMaybe<Array<projection__FilterUserMemory>>;
  updatedAt?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type projection__InsuranceDiscoveryAttemptView = {
  activeCoveragesFound: Scalars['Int64']['output'];
  attemptedAt: Scalars['String']['output'];
  confidenceLevel?: Maybe<Scalars['String']['output']>;
  coveragesFound: Scalars['Int64']['output'];
  discoveryId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorSubCode?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  npi?: Maybe<Scalars['String']['output']>;
  outcome: projection__InsuranceDiscoveryOutcome;
  proposedMembershipKeys?: Maybe<Array<Scalars['String']['output']>>;
  rawResponse?: Maybe<Scalars['JSON']['output']>;
  searchedDateOfBirth?: Maybe<Scalars['String']['output']>;
  searchedFirstName: Scalars['String']['output'];
  searchedLastName: Scalars['String']['output'];
  searchedState?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<projection__InsuranceDiscoveryTrigger>;
  user: User;
  vendorDurationMs?: Maybe<Scalars['Int64']['output']>;
  vendorPollCount?: Maybe<Scalars['Int64']['output']>;
};


export type projection__InsuranceDiscoveryAttemptViewuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__InsuranceDiscoveryAttemptView_Type = BaseObject & Object & projection__InsuranceDiscoveryAttemptView & {
  __typename: 'projection__InsuranceDiscoveryAttemptView_Type';
  activeCoveragesFound: Scalars['Int64']['output'];
  attemptedAt: Scalars['String']['output'];
  confidenceLevel?: Maybe<Scalars['String']['output']>;
  coveragesFound: Scalars['Int64']['output'];
  discoveryId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorSubCode?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  npi?: Maybe<Scalars['String']['output']>;
  outcome: projection__InsuranceDiscoveryOutcome;
  proposedMembershipKeys?: Maybe<Array<Scalars['String']['output']>>;
  rawResponse?: Maybe<Scalars['JSON']['output']>;
  searchedDateOfBirth?: Maybe<Scalars['String']['output']>;
  searchedFirstName: Scalars['String']['output'];
  searchedLastName: Scalars['String']['output'];
  searchedState?: Maybe<Scalars['String']['output']>;
  trigger?: Maybe<projection__InsuranceDiscoveryTrigger>;
  user: User;
  vendorDurationMs?: Maybe<Scalars['Int64']['output']>;
  vendorPollCount?: Maybe<Scalars['Int64']['output']>;
};


export type projection__InsuranceDiscoveryAttemptView_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum projection__InsuranceDiscoveryOutcome {
  FAILED = 'FAILED',
  FOUND = 'FOUND',
  NOT_FOUND = 'NOT_FOUND'
}

export enum projection__InsuranceDiscoveryTrigger {
  ONBOARDING_FALLBACK = 'ONBOARDING_FALLBACK',
  OPERATOR = 'OPERATOR'
}

export type projection__NestedFilterCaseAskView = {
  askId?: InputMaybe<FilterString>;
  askedAt?: InputMaybe<FilterString>;
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  detail?: InputMaybe<FilterJSON>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprojection__RequirementKind>;
  satisfiedAt?: InputMaybe<FilterString>;
  targetOrganizationId?: InputMaybe<FilterString>;
  targetType?: InputMaybe<Filterprojection__RequirementTargetType>;
};

export type projection__NestedFilterCaseBillAmountView = {
  amount?: InputMaybe<FilterDecimal>;
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  discrepancy?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  observationId?: InputMaybe<FilterString>;
  recordedAt?: InputMaybe<FilterString>;
  resolvedFrom?: InputMaybe<FilterString>;
  source?: InputMaybe<FilterString>;
};

export type projection__NestedFilterCaseFlowView = {
  answers?: InputMaybe<FilterJSON>;
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  completed?: InputMaybe<FilterBoolean>;
  completedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  flowId?: InputMaybe<FilterString>;
  flowType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  specVersion?: InputMaybe<FilterInt64>;
  startedAt?: InputMaybe<FilterString>;
};

export type projection__NestedFilterCasePriorPaymentView = {
  amountPaid?: InputMaybe<FilterDecimal>;
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  discrepancy?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  recordedAt?: InputMaybe<FilterString>;
  resolvedFrom?: InputMaybe<FilterString>;
  source?: InputMaybe<FilterString>;
  status?: InputMaybe<FilterString>;
};

export type projection__NestedFilterCaseProviderView = {
  caseView?: InputMaybe<projection__NestedFilterCaseView>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  providerId?: InputMaybe<FilterString>;
  setBy?: InputMaybe<Filterprojection__ProviderSetBy>;
  source?: InputMaybe<FilterString>;
};

export type projection__NestedFilterCaseView = {
  asks?: InputMaybe<projection__NestedFilterCaseAskView>;
  billAmount?: InputMaybe<projection__NestedFilterCaseBillAmountView>;
  caseType?: InputMaybe<FilterString>;
  closedAt?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  escalatedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  facts?: InputMaybe<FilterJSON>;
  flows?: InputMaybe<projection__NestedFilterCaseFlowView>;
  id?: InputMaybe<FilterID>;
  identityObservations?: InputMaybe<FilterJSON>;
  info?: InputMaybe<FilterJSON>;
  isEscalated?: InputMaybe<FilterBoolean>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  lifecycle?: InputMaybe<Filterprojection__CaseLifecycle>;
  milestones?: InputMaybe<FilterJSON>;
  priorPayment?: InputMaybe<projection__NestedFilterCasePriorPaymentView>;
  provider?: InputMaybe<projection__NestedFilterCaseProviderView>;
  updatedAt?: InputMaybe<FilterString>;
  userId?: InputMaybe<FilterString>;
};

export type projection__NestedFilterRpaConnection = {
  connectionId?: InputMaybe<FilterString>;
  connectionStatus?: InputMaybe<Filterprojection__RpaConnectionStatus>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  inspectUrl?: InputMaybe<FilterString>;
  lostReason?: InputMaybe<FilterString>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
  startedAt?: InputMaybe<FilterString>;
  tasks?: InputMaybe<projection__NestedFilterRpaTask>;
};

export type projection__NestedFilterRpaProviderAttempt = {
  errorMessage?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  occurredAt?: InputMaybe<FilterString>;
  provider?: InputMaybe<Filterprojection__CdpProvider>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
  success?: InputMaybe<FilterBoolean>;
};

export type projection__NestedFilterRpaSession = {
  cancelledAt?: InputMaybe<FilterString>;
  cdpProviderSessionId?: InputMaybe<FilterString>;
  connections?: InputMaybe<projection__NestedFilterRpaConnection>;
  endpointId?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  linkId?: InputMaybe<FilterString>;
  provider?: InputMaybe<Filterprojection__CdpProvider>;
  providerAttempts?: InputMaybe<projection__NestedFilterRpaProviderAttempt>;
  proxyGeoCity?: InputMaybe<FilterString>;
  proxyGeoCountry?: InputMaybe<FilterString>;
  proxyGeoSubdivision?: InputMaybe<FilterString>;
  proxyOrigin?: InputMaybe<Filterprojection__ProxyOrigin>;
  proxyStickyLabel?: InputMaybe<FilterString>;
  proxyStickyTtlMinutes?: InputMaybe<FilterInt64>;
  proxyStrategy?: InputMaybe<Filterprojection__ProxyStrategy>;
  sessionId?: InputMaybe<FilterString>;
  sessionStatus?: InputMaybe<Filterprojection__RpaSessionStatus>;
  startedAt?: InputMaybe<FilterString>;
  stealthStrategy?: InputMaybe<Filterprojection__StealthStrategy>;
  timeline?: InputMaybe<projection__NestedFilterRpaTimelineEntry>;
  userId?: InputMaybe<FilterString>;
};

export type projection__NestedFilterRpaTask = {
  classifyActionTaken?: InputMaybe<FilterBoolean>;
  classifyClassification?: InputMaybe<FilterString>;
  connection?: InputMaybe<projection__NestedFilterRpaConnection>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  failureReason?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprojection__RpaTaskKind>;
  signInPhase?: InputMaybe<FilterString>;
  signInPhaseDetail?: InputMaybe<FilterJSON>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterprojection__RpaTaskStatus>;
  taskId?: InputMaybe<FilterString>;
};

export type projection__NestedFilterRpaTimelineEntry = {
  eventDetail?: InputMaybe<FilterJSON>;
  eventTag?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  occurredAt?: InputMaybe<FilterString>;
  session?: InputMaybe<projection__NestedFilterRpaSession>;
};

export type projection__OrderBenefitPositionObservationView = {
  checkId?: InputMaybe<Ordering>;
  delta?: InputMaybe<Ordering>;
  eventId?: InputMaybe<Ordering>;
  forced?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  lead?: InputMaybe<Ordering>;
  limitAmount?: InputMaybe<Ordering>;
  materializationKey?: InputMaybe<Ordering>;
  memberId?: InputMaybe<Ordering>;
  metAmount?: InputMaybe<Ordering>;
  network?: InputMaybe<Ordering>;
  observation?: InputMaybe<Ordering>;
  observedAt?: InputMaybe<Ordering>;
  payerName?: InputMaybe<Ordering>;
  planYearEnd?: InputMaybe<Ordering>;
  planYearStart?: InputMaybe<Ordering>;
  previousMetAmount?: InputMaybe<Ordering>;
  remainingAmount?: InputMaybe<Ordering>;
  scope?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type projection__OrderCaseAskView = {
  askId?: InputMaybe<Ordering>;
  askedAt?: InputMaybe<Ordering>;
  caseView?: InputMaybe<projection__OrderCaseView>;
  detail?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  satisfiedAt?: InputMaybe<Ordering>;
  targetOrganizationId?: InputMaybe<Ordering>;
  targetType?: InputMaybe<Ordering>;
};

export type projection__OrderCaseBillAmountView = {
  amount?: InputMaybe<Ordering>;
  caseView?: InputMaybe<projection__OrderCaseView>;
  discrepancy?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  observationId?: InputMaybe<Ordering>;
  recordedAt?: InputMaybe<Ordering>;
  resolvedFrom?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
};

export type projection__OrderCaseFlowView = {
  answers?: InputMaybe<Ordering>;
  caseView?: InputMaybe<projection__OrderCaseView>;
  completed?: InputMaybe<Ordering>;
  completedAt?: InputMaybe<Ordering>;
  flowId?: InputMaybe<Ordering>;
  flowType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  specVersion?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
};

export type projection__OrderCasePriorPaymentView = {
  amountPaid?: InputMaybe<Ordering>;
  caseView?: InputMaybe<projection__OrderCaseView>;
  discrepancy?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  recordedAt?: InputMaybe<Ordering>;
  resolvedFrom?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
};

export type projection__OrderCaseProviderView = {
  caseView?: InputMaybe<projection__OrderCaseView>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  providerId?: InputMaybe<Ordering>;
  setBy?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
};

export type projection__OrderCaseReengagementFeed = {
  bill_upload_requested_ask_id?: InputMaybe<Ordering>;
  bill_upload_requested_at?: InputMaybe<Ordering>;
  bill_uploaded_ask_id?: InputMaybe<Ordering>;
  bill_uploaded_at?: InputMaybe<Ordering>;
  coverage_card_received_at?: InputMaybe<Ordering>;
  coverage_insured_declared_at?: InputMaybe<Ordering>;
  coverage_requested_at?: InputMaybe<Ordering>;
  coverage_uninsured_declared_at?: InputMaybe<Ordering>;
  hipaa_requested_at?: InputMaybe<Ordering>;
  hipaa_signed_at?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  last_outreach_at?: InputMaybe<Ordering>;
  latest_ha_message_id?: InputMaybe<Ordering>;
  latest_ha_message_seen_at?: InputMaybe<Ordering>;
  latest_ha_message_sent_at?: InputMaybe<Ordering>;
  latest_member_message_id?: InputMaybe<Ordering>;
  latest_member_message_sent_at?: InputMaybe<Ordering>;
  latest_seen_ha_message_id?: InputMaybe<Ordering>;
  latest_seen_ha_message_seen_at?: InputMaybe<Ordering>;
  latest_seen_ha_message_sent_at?: InputMaybe<Ordering>;
  payment_cancelled_at?: InputMaybe<Ordering>;
  payment_charge_failed_at?: InputMaybe<Ordering>;
  payment_charge_resolved_at?: InputMaybe<Ordering>;
  payment_confirmed_at?: InputMaybe<Ordering>;
  payment_declined_at?: InputMaybe<Ordering>;
  payment_requested_at?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  top_user_ask?: InputMaybe<Ordering>;
  updated_at?: InputMaybe<Ordering>;
  user_id?: InputMaybe<Ordering>;
  waiting_on?: InputMaybe<Ordering>;
};

export type projection__OrderCaseView = {
  billAmount?: InputMaybe<projection__OrderCaseBillAmountView>;
  caseType?: InputMaybe<Ordering>;
  closedAt?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  escalatedAt?: InputMaybe<Ordering>;
  facts?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  identityObservations?: InputMaybe<Ordering>;
  info?: InputMaybe<Ordering>;
  isEscalated?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  lifecycle?: InputMaybe<Ordering>;
  milestones?: InputMaybe<Ordering>;
  priorPayment?: InputMaybe<projection__OrderCasePriorPaymentView>;
  provider?: InputMaybe<projection__OrderCaseProviderView>;
  updatedAt?: InputMaybe<Ordering>;
  userId?: InputMaybe<Ordering>;
};

export type projection__OrderEligibilityCheckAttemptView = {
  attemptedAt?: InputMaybe<Ordering>;
  checkId?: InputMaybe<Ordering>;
  confirmedMemberId?: InputMaybe<Ordering>;
  coverageType?: InputMaybe<Ordering>;
  dispatchReason?: InputMaybe<Ordering>;
  dispatched?: InputMaybe<Ordering>;
  errorCode?: InputMaybe<Ordering>;
  errorSubCode?: InputMaybe<Ordering>;
  eventId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  materializationKey?: InputMaybe<Ordering>;
  memberId?: InputMaybe<Ordering>;
  membershipSource?: InputMaybe<Ordering>;
  npi?: InputMaybe<Ordering>;
  npiSource?: InputMaybe<Ordering>;
  outcome?: InputMaybe<Ordering>;
  payerId?: InputMaybe<Ordering>;
  payerName?: InputMaybe<Ordering>;
  payerSource?: InputMaybe<Ordering>;
  rawResponse?: InputMaybe<Ordering>;
  subscriberDobSource?: InputMaybe<Ordering>;
  subscriberFirstNameSource?: InputMaybe<Ordering>;
  subscriberLastNameSource?: InputMaybe<Ordering>;
  suppressedSignature?: InputMaybe<Ordering>;
  suppressionRetryAt?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
  vendorResponseId?: InputMaybe<Ordering>;
};

export type projection__OrderInsuranceDiscoveryAttemptView = {
  activeCoveragesFound?: InputMaybe<Ordering>;
  attemptedAt?: InputMaybe<Ordering>;
  confidenceLevel?: InputMaybe<Ordering>;
  coveragesFound?: InputMaybe<Ordering>;
  discoveryId?: InputMaybe<Ordering>;
  errorCode?: InputMaybe<Ordering>;
  errorSubCode?: InputMaybe<Ordering>;
  eventId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  npi?: InputMaybe<Ordering>;
  outcome?: InputMaybe<Ordering>;
  rawResponse?: InputMaybe<Ordering>;
  searchedDateOfBirth?: InputMaybe<Ordering>;
  searchedFirstName?: InputMaybe<Ordering>;
  searchedLastName?: InputMaybe<Ordering>;
  searchedState?: InputMaybe<Ordering>;
  trigger?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
  vendorDurationMs?: InputMaybe<Ordering>;
  vendorPollCount?: InputMaybe<Ordering>;
};

export type projection__OrderRpaBrowserFingerprint = {
  botdIsBot?: InputMaybe<Ordering>;
  botdVerdict?: InputMaybe<Ordering>;
  canvasHash?: InputMaybe<Ordering>;
  canvasTag?: InputMaybe<Ordering>;
  connectionId?: InputMaybe<Ordering>;
  creepjsHeadless?: InputMaybe<Ordering>;
  creepjsLikeHeadless?: InputMaybe<Ordering>;
  creepjsReason?: InputMaybe<Ordering>;
  creepjsStealth?: InputMaybe<Ordering>;
  creepjsTag?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  deviceMemoryGb?: InputMaybe<Ordering>;
  fingerprintProbeFailedReason?: InputMaybe<Ordering>;
  fingerprintTag?: InputMaybe<Ordering>;
  hardwareConcurrency?: InputMaybe<Ordering>;
  http2Fingerprint?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  ja4?: InputMaybe<Ordering>;
  osMismatch?: InputMaybe<Ordering>;
  platform?: InputMaybe<Ordering>;
  pluginCount?: InputMaybe<Ordering>;
  rbDummyFn?: InputMaybe<Ordering>;
  rbExposeFunctionLeak?: InputMaybe<Ordering>;
  rbMainWorldExecution?: InputMaybe<Ordering>;
  rbRuntimeEnableLeak?: InputMaybe<Ordering>;
  rbSourceUrlLeak?: InputMaybe<Ordering>;
  rebrowserReason?: InputMaybe<Ordering>;
  rebrowserTag?: InputMaybe<Ordering>;
  runtimeEnableTag?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  sessionId?: InputMaybe<Ordering>;
  timezone?: InputMaybe<Ordering>;
  tzOffsetMinutes?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  userAgent?: InputMaybe<Ordering>;
  webdriverFlag?: InputMaybe<Ordering>;
  webdriverTag?: InputMaybe<Ordering>;
  webglRenderer?: InputMaybe<Ordering>;
  webglTag?: InputMaybe<Ordering>;
  webglUnmaskedRenderer?: InputMaybe<Ordering>;
  wireReason?: InputMaybe<Ordering>;
  wireTag?: InputMaybe<Ordering>;
};

export type projection__OrderRpaConnection = {
  connectionId?: InputMaybe<Ordering>;
  connectionStatus?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  inspectUrl?: InputMaybe<Ordering>;
  lostReason?: InputMaybe<Ordering>;
  session?: InputMaybe<projection__OrderRpaSession>;
  startedAt?: InputMaybe<Ordering>;
};

export type projection__OrderRpaEgressIp = {
  connectionId?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  sessionId?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type projection__OrderRpaExperimentView = {
  data?: InputMaybe<Ordering>;
  experimentId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  stoppedAt?: InputMaybe<Ordering>;
};

export type projection__OrderRpaLinkView = {
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  linkId?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
};

export type projection__OrderRpaProviderAttempt = {
  errorMessage?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  occurredAt?: InputMaybe<Ordering>;
  provider?: InputMaybe<Ordering>;
  session?: InputMaybe<projection__OrderRpaSession>;
  success?: InputMaybe<Ordering>;
};

export type projection__OrderRpaSession = {
  cancelledAt?: InputMaybe<Ordering>;
  cdpProviderSessionId?: InputMaybe<Ordering>;
  endpointId?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  linkId?: InputMaybe<Ordering>;
  provider?: InputMaybe<Ordering>;
  proxyGeoCity?: InputMaybe<Ordering>;
  proxyGeoCountry?: InputMaybe<Ordering>;
  proxyGeoSubdivision?: InputMaybe<Ordering>;
  proxyOrigin?: InputMaybe<Ordering>;
  proxyStickyLabel?: InputMaybe<Ordering>;
  proxyStickyTtlMinutes?: InputMaybe<Ordering>;
  proxyStrategy?: InputMaybe<Ordering>;
  sessionId?: InputMaybe<Ordering>;
  sessionStatus?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  stealthStrategy?: InputMaybe<Ordering>;
  userId?: InputMaybe<Ordering>;
};

export type projection__OrderRpaSessionSummary = {
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  linkId?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  sessionId?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
};

export type projection__OrderRpaSessionTimeline = {
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  sessionId?: InputMaybe<Ordering>;
};

export type projection__OrderRpaTask = {
  classifyActionTaken?: InputMaybe<Ordering>;
  classifyClassification?: InputMaybe<Ordering>;
  connection?: InputMaybe<projection__OrderRpaConnection>;
  failureReason?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  signInPhase?: InputMaybe<Ordering>;
  signInPhaseDetail?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  taskId?: InputMaybe<Ordering>;
};

export type projection__OrderRpaTimelineEntry = {
  eventDetail?: InputMaybe<Ordering>;
  eventTag?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  occurredAt?: InputMaybe<Ordering>;
  session?: InputMaybe<projection__OrderRpaSession>;
};

export type projection__OrderUserDataView = {
  createdAt?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  key?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  metadata?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type projection__OrderUserEligibilityView = {
  createdAt?: InputMaybe<Ordering>;
  enrolledAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastCheckDispatchReason?: InputMaybe<Ordering>;
  lastCheckOutcome?: InputMaybe<Ordering>;
  lastCheckVendorResponseId?: InputMaybe<Ordering>;
  lastCheckedAt?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type projection__OrderUserEnrichmentData = {
  confidence?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  enrichments?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  key?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  overallPriceRating?: InputMaybe<Ordering>;
  schemaVersion?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type projection__OrderUserMemory = {
  createdAt?: InputMaybe<Ordering>;
  entries?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export enum projection__ProviderSetBy {
  AUTOMATED = 'AUTOMATED',
  CLEARED = 'CLEARED',
  MEMBER_CONFIRMED = 'MEMBER_CONFIRMED',
  MEMBER_CORRECTED = 'MEMBER_CORRECTED',
  MEMBER_ENTERED = 'MEMBER_ENTERED',
  STAFF_ENTERED = 'STAFF_ENTERED'
}

export enum projection__ProxyOrigin {
  BUILTIN = 'BUILTIN',
  DECODO = 'DECODO',
  DIRECT = 'DIRECT',
  MASSIVE = 'MASSIVE',
  NIMBLE = 'NIMBLE',
  OXYLABS = 'OXYLABS'
}

export enum projection__ProxyStrategy {
  DEFAULT = 'DEFAULT',
  PROXY_LOCATION = 'PROXY_LOCATION',
  USER_IP = 'USER_IP'
}

export enum projection__RequirementKind {
  BILL_UPLOAD = 'BILL_UPLOAD',
  COVERAGE_INFORMATION = 'COVERAGE_INFORMATION',
  HIPAA_AUTHORIZATION = 'HIPAA_AUTHORIZATION',
  PAYMENT_PREFERENCES = 'PAYMENT_PREFERENCES'
}

export enum projection__RequirementTargetType {
  GRANTED_HEALTH = 'GRANTED_HEALTH',
  INSURER = 'INSURER',
  PROVIDER = 'PROVIDER',
  UNSPECIFIED = 'UNSPECIFIED'
}

export type projection__RpaBrowserFingerprint = {
  botdDetectorsFired?: Maybe<Array<Scalars['String']['output']>>;
  botdIsBot?: Maybe<Scalars['Boolean']['output']>;
  botdVerdict?: Maybe<Scalars['String']['output']>;
  canvasHash?: Maybe<Scalars['String']['output']>;
  canvasTag?: Maybe<Scalars['String']['output']>;
  connectionId: Scalars['String']['output'];
  creepjsHeadless?: Maybe<Scalars['Float']['output']>;
  creepjsLikeHeadless?: Maybe<Scalars['Float']['output']>;
  creepjsReason?: Maybe<Scalars['String']['output']>;
  creepjsStealth?: Maybe<Scalars['Float']['output']>;
  creepjsTag: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  deviceMemoryGb?: Maybe<Scalars['Float']['output']>;
  fingerprintProbeFailedReason?: Maybe<Scalars['String']['output']>;
  fingerprintTag: Scalars['String']['output'];
  hardwareConcurrency?: Maybe<Scalars['Float']['output']>;
  http2Fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ja4?: Maybe<Scalars['String']['output']>;
  osMismatch?: Maybe<Scalars['Boolean']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  pluginCount?: Maybe<Scalars['Float']['output']>;
  rbDummyFn?: Maybe<Scalars['String']['output']>;
  rbExposeFunctionLeak?: Maybe<Scalars['String']['output']>;
  rbMainWorldExecution?: Maybe<Scalars['String']['output']>;
  rbRuntimeEnableLeak?: Maybe<Scalars['String']['output']>;
  rbSourceUrlLeak?: Maybe<Scalars['String']['output']>;
  rebrowserReason?: Maybe<Scalars['String']['output']>;
  rebrowserTag: Scalars['String']['output'];
  runtimeEnableTag?: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  tzOffsetMinutes?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  webdriverFlag?: Maybe<Scalars['Boolean']['output']>;
  webdriverTag?: Maybe<Scalars['String']['output']>;
  webglRenderer?: Maybe<Scalars['String']['output']>;
  webglTag?: Maybe<Scalars['String']['output']>;
  webglUnmaskedRenderer?: Maybe<Scalars['String']['output']>;
  wireReason?: Maybe<Scalars['String']['output']>;
  wireTag: Scalars['String']['output'];
};

export type projection__RpaBrowserFingerprint_Type = BaseObject & Object & projection__RpaBrowserFingerprint & {
  __typename: 'projection__RpaBrowserFingerprint_Type';
  botdDetectorsFired?: Maybe<Array<Scalars['String']['output']>>;
  botdIsBot?: Maybe<Scalars['Boolean']['output']>;
  botdVerdict?: Maybe<Scalars['String']['output']>;
  canvasHash?: Maybe<Scalars['String']['output']>;
  canvasTag?: Maybe<Scalars['String']['output']>;
  connectionId: Scalars['String']['output'];
  creepjsHeadless?: Maybe<Scalars['Float']['output']>;
  creepjsLikeHeadless?: Maybe<Scalars['Float']['output']>;
  creepjsReason?: Maybe<Scalars['String']['output']>;
  creepjsStealth?: Maybe<Scalars['Float']['output']>;
  creepjsTag: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  deviceMemoryGb?: Maybe<Scalars['Float']['output']>;
  fingerprintProbeFailedReason?: Maybe<Scalars['String']['output']>;
  fingerprintTag: Scalars['String']['output'];
  hardwareConcurrency?: Maybe<Scalars['Float']['output']>;
  http2Fingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ja4?: Maybe<Scalars['String']['output']>;
  osMismatch?: Maybe<Scalars['Boolean']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  pluginCount?: Maybe<Scalars['Float']['output']>;
  rbDummyFn?: Maybe<Scalars['String']['output']>;
  rbExposeFunctionLeak?: Maybe<Scalars['String']['output']>;
  rbMainWorldExecution?: Maybe<Scalars['String']['output']>;
  rbRuntimeEnableLeak?: Maybe<Scalars['String']['output']>;
  rbSourceUrlLeak?: Maybe<Scalars['String']['output']>;
  rebrowserReason?: Maybe<Scalars['String']['output']>;
  rebrowserTag: Scalars['String']['output'];
  runtimeEnableTag?: Maybe<Scalars['String']['output']>;
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  tzOffsetMinutes?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['String']['output'];
  userAgent?: Maybe<Scalars['String']['output']>;
  webdriverFlag?: Maybe<Scalars['Boolean']['output']>;
  webdriverTag?: Maybe<Scalars['String']['output']>;
  webglRenderer?: Maybe<Scalars['String']['output']>;
  webglTag?: Maybe<Scalars['String']['output']>;
  webglUnmaskedRenderer?: Maybe<Scalars['String']['output']>;
  wireReason?: Maybe<Scalars['String']['output']>;
  wireTag: Scalars['String']['output'];
};

export type projection__RpaConnection = {
  connectionId: Scalars['String']['output'];
  connectionStatus?: Maybe<projection__RpaConnectionStatus>;
  id: Scalars['ID']['output'];
  inspectUrl?: Maybe<Scalars['String']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  session?: Maybe<projection__RpaSession>;
  startedAt: Scalars['String']['output'];
  tasks?: Maybe<Array<projection__RpaTask>>;
};


export type projection__RpaConnectionsessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};


export type projection__RpaConnectiontasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTask>;
};

export enum projection__RpaConnectionStatus {
  CONNECTED = 'CONNECTED',
  DISCONNECTED = 'DISCONNECTED',
  LOST = 'LOST'
}

export type projection__RpaConnection_Type = BaseObject & Object & projection__RpaConnection & {
  __typename: 'projection__RpaConnection_Type';
  connectionId: Scalars['String']['output'];
  connectionStatus?: Maybe<projection__RpaConnectionStatus>;
  id: Scalars['ID']['output'];
  inspectUrl?: Maybe<Scalars['String']['output']>;
  lostReason?: Maybe<Scalars['String']['output']>;
  session?: Maybe<projection__RpaSession>;
  startedAt: Scalars['String']['output'];
  tasks?: Maybe<Array<projection__RpaTask>>;
};


export type projection__RpaConnection_TypesessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};


export type projection__RpaConnection_TypetasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTask>;
};

export type projection__RpaEgressIp = {
  connectionId: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type projection__RpaEgressIp_Type = BaseObject & Object & projection__RpaEgressIp & {
  __typename: 'projection__RpaEgressIp_Type';
  connectionId: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type projection__RpaExperimentView = {
  data: Scalars['JSON']['output'];
  experimentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  startedAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stoppedAt?: Maybe<Scalars['String']['output']>;
};

export type projection__RpaExperimentView_Type = BaseObject & Object & projection__RpaExperimentView & {
  __typename: 'projection__RpaExperimentView_Type';
  data: Scalars['JSON']['output'];
  experimentId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  startedAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  stoppedAt?: Maybe<Scalars['String']['output']>;
};

export type projection__RpaLinkView = {
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  linkId: Scalars['String']['output'];
  schemaVersion: Scalars['Int64']['output'];
};

export type projection__RpaLinkView_Type = BaseObject & Object & projection__RpaLinkView & {
  __typename: 'projection__RpaLinkView_Type';
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  linkId: Scalars['String']['output'];
  schemaVersion: Scalars['Int64']['output'];
};

export type projection__RpaProviderAttempt = {
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  provider: projection__CdpProvider;
  session: projection__RpaSession;
  success: Scalars['Boolean']['output'];
};


export type projection__RpaProviderAttemptsessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};

export type projection__RpaProviderAttempt_Type = BaseObject & Object & projection__RpaProviderAttempt & {
  __typename: 'projection__RpaProviderAttempt_Type';
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  provider: projection__CdpProvider;
  session: projection__RpaSession;
  success: Scalars['Boolean']['output'];
};


export type projection__RpaProviderAttempt_TypesessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};

export type projection__RpaSession = {
  cancelledAt?: Maybe<Scalars['String']['output']>;
  cdpProviderSessionId?: Maybe<Scalars['String']['output']>;
  connections?: Maybe<Array<projection__RpaConnection>>;
  endpointId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<projection__CdpProvider>;
  providerAttempts?: Maybe<Array<projection__RpaProviderAttempt>>;
  proxyGeoCity?: Maybe<Scalars['String']['output']>;
  proxyGeoCountry?: Maybe<Scalars['String']['output']>;
  proxyGeoSubdivision?: Maybe<Scalars['String']['output']>;
  proxyOrigin?: Maybe<projection__ProxyOrigin>;
  proxyStickyLabel?: Maybe<Scalars['String']['output']>;
  proxyStickyTtlMinutes?: Maybe<Scalars['Int64']['output']>;
  proxyStrategy?: Maybe<projection__ProxyStrategy>;
  sessionId: Scalars['String']['output'];
  sessionStatus?: Maybe<projection__RpaSessionStatus>;
  startedAt: Scalars['String']['output'];
  stealthStrategy?: Maybe<projection__StealthStrategy>;
  timeline?: Maybe<Array<projection__RpaTimelineEntry>>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type projection__RpaSessionconnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};


export type projection__RpaSessionproviderAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaProviderAttempt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaProviderAttempt>;
};


export type projection__RpaSessiontimelineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTimelineEntry>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTimelineEntry>;
};

export enum projection__RpaSessionStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED',
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  SUCCEEDED = 'SUCCEEDED'
}

export type projection__RpaSessionSummary = {
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  linkId: Scalars['String']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};

export type projection__RpaSessionSummary_Type = BaseObject & Object & projection__RpaSessionSummary & {
  __typename: 'projection__RpaSessionSummary_Type';
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  linkId: Scalars['String']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};

export type projection__RpaSessionTimeline = {
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
};

export type projection__RpaSessionTimeline_Type = BaseObject & Object & projection__RpaSessionTimeline & {
  __typename: 'projection__RpaSessionTimeline_Type';
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  schemaVersion: Scalars['Int64']['output'];
  sessionId: Scalars['String']['output'];
};

export type projection__RpaSession_Type = BaseObject & Object & projection__RpaSession & {
  __typename: 'projection__RpaSession_Type';
  cancelledAt?: Maybe<Scalars['String']['output']>;
  cdpProviderSessionId?: Maybe<Scalars['String']['output']>;
  connections?: Maybe<Array<projection__RpaConnection>>;
  endpointId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  linkId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<projection__CdpProvider>;
  providerAttempts?: Maybe<Array<projection__RpaProviderAttempt>>;
  proxyGeoCity?: Maybe<Scalars['String']['output']>;
  proxyGeoCountry?: Maybe<Scalars['String']['output']>;
  proxyGeoSubdivision?: Maybe<Scalars['String']['output']>;
  proxyOrigin?: Maybe<projection__ProxyOrigin>;
  proxyStickyLabel?: Maybe<Scalars['String']['output']>;
  proxyStickyTtlMinutes?: Maybe<Scalars['Int64']['output']>;
  proxyStrategy?: Maybe<projection__ProxyStrategy>;
  sessionId: Scalars['String']['output'];
  sessionStatus?: Maybe<projection__RpaSessionStatus>;
  startedAt: Scalars['String']['output'];
  stealthStrategy?: Maybe<projection__StealthStrategy>;
  timeline?: Maybe<Array<projection__RpaTimelineEntry>>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type projection__RpaSession_TypeconnectionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};


export type projection__RpaSession_TypeproviderAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaProviderAttempt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaProviderAttempt>;
};


export type projection__RpaSession_TypetimelineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaTimelineEntry>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaTimelineEntry>;
};

export type projection__RpaTask = {
  classifyActionTaken?: Maybe<Scalars['Boolean']['output']>;
  classifyClassification?: Maybe<Scalars['String']['output']>;
  connection?: Maybe<projection__RpaConnection>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<projection__RpaTaskKind>;
  signInPhase?: Maybe<Scalars['String']['output']>;
  signInPhaseDetail?: Maybe<Scalars['JSON']['output']>;
  startedAt: Scalars['String']['output'];
  status?: Maybe<projection__RpaTaskStatus>;
  taskId: Scalars['String']['output'];
};


export type projection__RpaTaskconnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};

export enum projection__RpaTaskKind {
  CLASSIFY = 'CLASSIFY',
  CRAWL = 'CRAWL',
  SIGN_IN = 'SIGN_IN',
  TAILGATE = 'TAILGATE'
}

export enum projection__RpaTaskStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCEEDED = 'SUCCEEDED'
}

export type projection__RpaTask_Type = BaseObject & Object & projection__RpaTask & {
  __typename: 'projection__RpaTask_Type';
  classifyActionTaken?: Maybe<Scalars['Boolean']['output']>;
  classifyClassification?: Maybe<Scalars['String']['output']>;
  connection?: Maybe<projection__RpaConnection>;
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  kind?: Maybe<projection__RpaTaskKind>;
  signInPhase?: Maybe<Scalars['String']['output']>;
  signInPhaseDetail?: Maybe<Scalars['JSON']['output']>;
  startedAt: Scalars['String']['output'];
  status?: Maybe<projection__RpaTaskStatus>;
  taskId: Scalars['String']['output'];
};


export type projection__RpaTask_TypeconnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaConnection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaConnection>;
};

export type projection__RpaTimelineEntry = {
  eventDetail?: Maybe<Scalars['JSON']['output']>;
  eventTag: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  session?: Maybe<projection__RpaSession>;
};


export type projection__RpaTimelineEntrysessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};

export type projection__RpaTimelineEntry_Type = BaseObject & Object & projection__RpaTimelineEntry & {
  __typename: 'projection__RpaTimelineEntry_Type';
  eventDetail?: Maybe<Scalars['JSON']['output']>;
  eventTag: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['String']['output'];
  session?: Maybe<projection__RpaSession>;
};


export type projection__RpaTimelineEntry_TypesessionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<projection__FilterRpaSession>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<projection__OrderRpaSession>;
};

export enum projection__StealthStrategy {
  ADVANCED_STEALTH = 'ADVANCED_STEALTH',
  BASIC_STEALTH = 'BASIC_STEALTH',
  DEFAULT = 'DEFAULT'
}

export type projection__UserDataView = {
  createdAt: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Int64']['output'];
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserDataViewuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserDataView_Type = BaseObject & Object & projection__UserDataView & {
  __typename: 'projection__UserDataView_Type';
  createdAt: Scalars['String']['output'];
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  schemaVersion: Scalars['Int64']['output'];
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserDataView_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserEligibilityView = {
  createdAt: Scalars['String']['output'];
  enrolledAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastCheckDispatchReason?: Maybe<projection__EligibilityCheckDispatchReason>;
  lastCheckOutcome?: Maybe<projection__EligibilityCheckOutcome>;
  lastCheckVendorResponseId?: Maybe<Scalars['String']['output']>;
  lastCheckedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserEligibilityViewuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserEligibilityView_Type = BaseObject & Object & projection__UserEligibilityView & {
  __typename: 'projection__UserEligibilityView_Type';
  createdAt: Scalars['String']['output'];
  enrolledAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastCheckDispatchReason?: Maybe<projection__EligibilityCheckDispatchReason>;
  lastCheckOutcome?: Maybe<projection__EligibilityCheckOutcome>;
  lastCheckVendorResponseId?: Maybe<Scalars['String']['output']>;
  lastCheckedAt?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserEligibilityView_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserEnrichmentData = {
  confidence?: Maybe<projection__EnrichmentConfidence>;
  createdAt: Scalars['String']['output'];
  enrichments?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  overallPriceRating?: Maybe<projection__EnrichmentPriceRating>;
  schemaVersion: Scalars['Int64']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserEnrichmentDatauserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserEnrichmentData_Type = BaseObject & Object & projection__UserEnrichmentData & {
  __typename: 'projection__UserEnrichmentData_Type';
  confidence?: Maybe<projection__EnrichmentConfidence>;
  createdAt: Scalars['String']['output'];
  enrichments?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  overallPriceRating?: Maybe<projection__EnrichmentPriceRating>;
  schemaVersion: Scalars['Int64']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserEnrichmentData_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserMemory = {
  createdAt: Scalars['String']['output'];
  entries: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserMemoryuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type projection__UserMemory_Type = BaseObject & Object & projection__UserMemory & {
  __typename: 'projection__UserMemory_Type';
  createdAt: Scalars['String']['output'];
  entries: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['String']['output'];
  user: User;
};


export type projection__UserMemory_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum provider__ContactKind {
  Email = 'Email',
  Fax = 'Fax',
  Mail = 'Mail',
  Phone = 'Phone',
  Portal = 'Portal',
  Website = 'Website'
}

export type provider__ContactPoint = {
  id: Scalars['ID']['output'];
  kind: provider__ContactKind;
  lastVerified?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  purpose: provider__ContactPurpose;
  source?: Maybe<provider__Source>;
  value: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__ContactPointverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type provider__ContactPoint_Type = BaseObject & Object & Verifiable & provider__ContactPoint & {
  __typename: 'provider__ContactPoint_Type';
  id: Scalars['ID']['output'];
  kind: provider__ContactKind;
  lastVerified?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  purpose: provider__ContactPurpose;
  source?: Maybe<provider__Source>;
  value: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__ContactPoint_TypeverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum provider__ContactPurpose {
  Billing = 'Billing',
  FinancialAssistance = 'FinancialAssistance',
  General = 'General',
  MedicalRecords = 'MedicalRecords',
  Other = 'Other'
}

export type provider__FilterContactPoint = {
  and?: InputMaybe<Array<provider__FilterContactPoint>>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprovider__ContactKind>;
  lastVerified?: InputMaybe<FilterString>;
  not?: InputMaybe<provider__FilterContactPoint>;
  notes?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<provider__FilterContactPoint>>;
  purpose?: InputMaybe<Filterprovider__ContactPurpose>;
  source?: InputMaybe<Filterprovider__Source>;
  value?: InputMaybe<FilterString>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__FilterNegotiationProfile = {
  and?: InputMaybe<Array<provider__FilterNegotiationProfile>>;
  discountPctMax?: InputMaybe<FilterInt>;
  discountPctMin?: InputMaybe<FilterInt>;
  hipaaTurnaroundDays?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterID>;
  insuredStance?: InputMaybe<Filterprovider__NegotiationStance>;
  lastVerified?: InputMaybe<FilterString>;
  not?: InputMaybe<provider__FilterNegotiationProfile>;
  offersPaymentPlans?: InputMaybe<FilterBoolean>;
  or?: InputMaybe<Array<provider__FilterNegotiationProfile>>;
  paymentPlanMaxMonths?: InputMaybe<FilterInt>;
  pricingVsMarket?: InputMaybe<FilterFloat>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__FilterProvider = {
  addressLine1?: InputMaybe<FilterString>;
  addressLine2?: InputMaybe<FilterString>;
  aliases?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<provider__FilterProvider>>;
  ccn?: InputMaybe<FilterString>;
  city?: InputMaybe<FilterString>;
  contactPoints?: InputMaybe<provider__NestedFilterContactPoint>;
  county?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  faPolicy?: InputMaybe<FilterJSON>;
  faPolicyUrl?: InputMaybe<FilterString>;
  facilities?: InputMaybe<provider__NestedFilterProvider>;
  forms?: InputMaybe<provider__NestedFilterProviderForm>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  isNonprofit?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterprovider__ProviderKind>;
  lastSyncedAt?: InputMaybe<FilterString>;
  lastVerified?: InputMaybe<FilterString>;
  negotiation?: InputMaybe<provider__NestedFilterNegotiationProfile>;
  not?: InputMaybe<provider__FilterProvider>;
  npi?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<provider__FilterProvider>>;
  ownership?: InputMaybe<Filterprovider__Ownership>;
  ownershipRaw?: InputMaybe<FilterString>;
  partOf?: InputMaybe<provider__NestedFilterProvider>;
  postalCode?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  source?: InputMaybe<Filterprovider__Source>;
  state?: InputMaybe<FilterString>;
  systemName?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__FilterProviderForm = {
  and?: InputMaybe<Array<provider__FilterProviderForm>>;
  calibratedAt?: InputMaybe<FilterString>;
  calibratedBy?: InputMaybe<NestedFilterUser>;
  contentHash?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  detectedAt?: InputMaybe<FilterString>;
  detectionFailedAt?: InputMaybe<FilterString>;
  fields?: InputMaybe<FilterJSON>;
  formType?: InputMaybe<Filterprovider__FormType>;
  formUrl?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  internalTemplate?: InputMaybe<FilterJSON>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<provider__FilterProviderForm>;
  or?: InputMaybe<Array<provider__FilterProviderForm>>;
  provider?: InputMaybe<provider__NestedFilterProvider>;
  revision?: InputMaybe<FilterInt>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  submissionChannel?: InputMaybe<Filterprovider__SubmissionChannel>;
  submitTo?: InputMaybe<provider__NestedFilterContactPoint>;
  updatedAt?: InputMaybe<FilterString>;
};

export type provider__FilterResearchRun = {
  and?: InputMaybe<Array<provider__FilterResearchRun>>;
  claimsDropped?: InputMaybe<FilterInt>;
  claimsKept?: InputMaybe<FilterInt>;
  contactsKept?: InputMaybe<FilterInt>;
  costUsd?: InputMaybe<FilterFloat>;
  durationMs?: InputMaybe<FilterInt>;
  engine?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  finishedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isOpen?: InputMaybe<FilterBoolean>;
  model?: InputMaybe<FilterString>;
  not?: InputMaybe<provider__FilterResearchRun>;
  notesWritten?: InputMaybe<FilterBoolean>;
  or?: InputMaybe<Array<provider__FilterResearchRun>>;
  proposal?: InputMaybe<FilterJSON>;
  provider?: InputMaybe<provider__NestedFilterProvider>;
  requestedAt?: InputMaybe<FilterString>;
  requestedBy?: InputMaybe<NestedFilterUser>;
  skillVersion?: InputMaybe<FilterString>;
  startedAt?: InputMaybe<FilterString>;
  status?: InputMaybe<Filterprovider__ResearchRunStatus>;
  turns?: InputMaybe<FilterInt>;
  workflowId?: InputMaybe<FilterString>;
};

export enum provider__FormType {
  Appeal = 'Appeal',
  Catastrophic = 'Catastrophic',
  FaApplication = 'FaApplication',
  Other = 'Other'
}

export type provider__NegotiationProfile = {
  discountPctMax?: Maybe<Scalars['Int']['output']>;
  discountPctMin?: Maybe<Scalars['Int']['output']>;
  hipaaTurnaroundDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  insuredStance?: Maybe<provider__NegotiationStance>;
  lastVerified?: Maybe<Scalars['String']['output']>;
  offersPaymentPlans?: Maybe<Scalars['Boolean']['output']>;
  paymentPlanMaxMonths?: Maybe<Scalars['Int']['output']>;
  pricingVsMarket?: Maybe<Scalars['Float']['output']>;
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__NegotiationProfileverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type provider__NegotiationProfile_Type = BaseObject & Object & Verifiable & provider__NegotiationProfile & {
  __typename: 'provider__NegotiationProfile_Type';
  discountPctMax?: Maybe<Scalars['Int']['output']>;
  discountPctMin?: Maybe<Scalars['Int']['output']>;
  hipaaTurnaroundDays?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  insuredStance?: Maybe<provider__NegotiationStance>;
  lastVerified?: Maybe<Scalars['String']['output']>;
  offersPaymentPlans?: Maybe<Scalars['Boolean']['output']>;
  paymentPlanMaxMonths?: Maybe<Scalars['Int']['output']>;
  pricingVsMarket?: Maybe<Scalars['Float']['output']>;
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__NegotiationProfile_TypeverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum provider__NegotiationStance {
  DoesNotNegotiate = 'DoesNotNegotiate',
  NegotiatesAll = 'NegotiatesAll',
  Restricted = 'Restricted',
  SelfPayOnly = 'SelfPayOnly'
}

export type provider__NestedFilterContactPoint = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  kind?: InputMaybe<Filterprovider__ContactKind>;
  lastVerified?: InputMaybe<FilterString>;
  notes?: InputMaybe<FilterString>;
  purpose?: InputMaybe<Filterprovider__ContactPurpose>;
  source?: InputMaybe<Filterprovider__Source>;
  value?: InputMaybe<FilterString>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__NestedFilterNegotiationProfile = {
  discountPctMax?: InputMaybe<FilterInt>;
  discountPctMin?: InputMaybe<FilterInt>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hipaaTurnaroundDays?: InputMaybe<FilterInt>;
  id?: InputMaybe<FilterID>;
  insuredStance?: InputMaybe<Filterprovider__NegotiationStance>;
  lastVerified?: InputMaybe<FilterString>;
  offersPaymentPlans?: InputMaybe<FilterBoolean>;
  paymentPlanMaxMonths?: InputMaybe<FilterInt>;
  pricingVsMarket?: InputMaybe<FilterFloat>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__NestedFilterProvider = {
  addressLine1?: InputMaybe<FilterString>;
  addressLine2?: InputMaybe<FilterString>;
  aliases?: InputMaybe<FilterString>;
  ccn?: InputMaybe<FilterString>;
  city?: InputMaybe<FilterString>;
  contactPoints?: InputMaybe<provider__NestedFilterContactPoint>;
  county?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  faPolicy?: InputMaybe<FilterJSON>;
  faPolicyUrl?: InputMaybe<FilterString>;
  facilities?: InputMaybe<provider__NestedFilterProvider>;
  forms?: InputMaybe<provider__NestedFilterProviderForm>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  isNonprofit?: InputMaybe<FilterBoolean>;
  kind?: InputMaybe<Filterprovider__ProviderKind>;
  lastSyncedAt?: InputMaybe<FilterString>;
  lastVerified?: InputMaybe<FilterString>;
  negotiation?: InputMaybe<provider__NestedFilterNegotiationProfile>;
  npi?: InputMaybe<FilterString>;
  ownership?: InputMaybe<Filterprovider__Ownership>;
  ownershipRaw?: InputMaybe<FilterString>;
  partOf?: InputMaybe<provider__NestedFilterProvider>;
  postalCode?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  source?: InputMaybe<Filterprovider__Source>;
  state?: InputMaybe<FilterString>;
  systemName?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
  verified?: InputMaybe<FilterBoolean>;
  verifiedBy?: InputMaybe<NestedFilterUser>;
};

export type provider__NestedFilterProviderForm = {
  calibratedAt?: InputMaybe<FilterString>;
  calibratedBy?: InputMaybe<NestedFilterUser>;
  contentHash?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  detectedAt?: InputMaybe<FilterString>;
  detectionFailedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<FilterJSON>;
  formType?: InputMaybe<Filterprovider__FormType>;
  formUrl?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  internalTemplate?: InputMaybe<FilterJSON>;
  name?: InputMaybe<FilterString>;
  provider?: InputMaybe<provider__NestedFilterProvider>;
  revision?: InputMaybe<FilterInt>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
  submissionChannel?: InputMaybe<Filterprovider__SubmissionChannel>;
  submitTo?: InputMaybe<provider__NestedFilterContactPoint>;
  updatedAt?: InputMaybe<FilterString>;
};

export type provider__OrderContactPoint = {
  id?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  lastVerified?: InputMaybe<Ordering>;
  notes?: InputMaybe<Ordering>;
  purpose?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
  value?: InputMaybe<Ordering>;
  verified?: InputMaybe<Ordering>;
  verifiedBy?: InputMaybe<OrderUser>;
};

export type provider__OrderNegotiationProfile = {
  discountPctMax?: InputMaybe<Ordering>;
  discountPctMin?: InputMaybe<Ordering>;
  hipaaTurnaroundDays?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  insuredStance?: InputMaybe<Ordering>;
  lastVerified?: InputMaybe<Ordering>;
  offersPaymentPlans?: InputMaybe<Ordering>;
  paymentPlanMaxMonths?: InputMaybe<Ordering>;
  pricingVsMarket?: InputMaybe<Ordering>;
  verified?: InputMaybe<Ordering>;
  verifiedBy?: InputMaybe<OrderUser>;
};

export type provider__OrderProvider = {
  addressLine1?: InputMaybe<Ordering>;
  addressLine2?: InputMaybe<Ordering>;
  ccn?: InputMaybe<Ordering>;
  city?: InputMaybe<Ordering>;
  county?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  displayName?: InputMaybe<Ordering>;
  faPolicy?: InputMaybe<Ordering>;
  faPolicyUrl?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  isNonprofit?: InputMaybe<Ordering>;
  kind?: InputMaybe<Ordering>;
  lastSyncedAt?: InputMaybe<Ordering>;
  lastVerified?: InputMaybe<Ordering>;
  negotiation?: InputMaybe<provider__OrderNegotiationProfile>;
  npi?: InputMaybe<Ordering>;
  ownership?: InputMaybe<Ordering>;
  ownershipRaw?: InputMaybe<Ordering>;
  partOf?: InputMaybe<provider__OrderProvider>;
  postalCode?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
  source?: InputMaybe<Ordering>;
  state?: InputMaybe<Ordering>;
  systemName?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  verified?: InputMaybe<Ordering>;
  verifiedBy?: InputMaybe<OrderUser>;
};

export type provider__OrderProviderForm = {
  calibratedAt?: InputMaybe<Ordering>;
  calibratedBy?: InputMaybe<OrderUser>;
  contentHash?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  detectedAt?: InputMaybe<Ordering>;
  detectionFailedAt?: InputMaybe<Ordering>;
  fields?: InputMaybe<Ordering>;
  formType?: InputMaybe<Ordering>;
  formUrl?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  internalTemplate?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  provider?: InputMaybe<provider__OrderProvider>;
  revision?: InputMaybe<Ordering>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
  submissionChannel?: InputMaybe<Ordering>;
  submitTo?: InputMaybe<provider__OrderContactPoint>;
  updatedAt?: InputMaybe<Ordering>;
};

export type provider__OrderResearchRun = {
  claimsDropped?: InputMaybe<Ordering>;
  claimsKept?: InputMaybe<Ordering>;
  contactsKept?: InputMaybe<Ordering>;
  costUsd?: InputMaybe<Ordering>;
  durationMs?: InputMaybe<Ordering>;
  engine?: InputMaybe<Ordering>;
  error?: InputMaybe<Ordering>;
  finishedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isOpen?: InputMaybe<Ordering>;
  model?: InputMaybe<Ordering>;
  notesWritten?: InputMaybe<Ordering>;
  proposal?: InputMaybe<Ordering>;
  provider?: InputMaybe<provider__OrderProvider>;
  requestedAt?: InputMaybe<Ordering>;
  requestedBy?: InputMaybe<OrderUser>;
  skillVersion?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  turns?: InputMaybe<Ordering>;
  workflowId?: InputMaybe<Ordering>;
};

export enum provider__Ownership {
  ForProfit = 'ForProfit',
  Government = 'Government',
  Nonprofit = 'Nonprofit'
}

export type provider__Provider = {
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  ccn?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactPoints?: Maybe<Array<provider__ContactPoint>>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  faPolicy?: Maybe<Scalars['JSON']['output']>;
  faPolicyUrl?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<provider__Provider>>;
  forms?: Maybe<Array<provider__ProviderForm>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isNonprofit: Scalars['Boolean']['output'];
  kind: provider__ProviderKind;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  lastVerified?: Maybe<Scalars['String']['output']>;
  negotiation?: Maybe<provider__NegotiationProfile>;
  notes?: Maybe<Array<Scalars['String']['output']>>;
  npi?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<provider__Ownership>;
  ownershipRaw?: Maybe<Scalars['String']['output']>;
  partOf?: Maybe<provider__Provider>;
  postalCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<provider__Source>;
  state?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__ProvidercontactPointsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};


export type provider__ProviderfacilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__ProviderformsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProviderForm>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProviderForm>;
};


export type provider__ProvidernegotiationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterNegotiationProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderNegotiationProfile>;
};


export type provider__ProviderpartOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__ProviderverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type provider__ProviderForm = {
  calibratedAt?: Maybe<Scalars['String']['output']>;
  calibratedBy?: Maybe<User>;
  contentHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  detectedAt?: Maybe<Scalars['String']['output']>;
  detectionFailedAt?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['JSON']['output']>;
  formType: provider__FormType;
  formUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalTemplate?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  provider: provider__Provider;
  revision: Scalars['Int']['output'];
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  submissionChannel?: Maybe<provider__SubmissionChannel>;
  submitTo?: Maybe<provider__ContactPoint>;
  updatedAt: Scalars['String']['output'];
};


export type provider__ProviderFormcalibratedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type provider__ProviderFormproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__ProviderFormsubmitToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};

export type provider__ProviderForm_Type = BaseObject & Object & provider__ProviderForm & {
  __typename: 'provider__ProviderForm_Type';
  calibratedAt?: Maybe<Scalars['String']['output']>;
  calibratedBy?: Maybe<User>;
  contentHash?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  detectedAt?: Maybe<Scalars['String']['output']>;
  detectionFailedAt?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Scalars['JSON']['output']>;
  formType: provider__FormType;
  formUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalTemplate?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  provider: provider__Provider;
  revision: Scalars['Int']['output'];
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  submissionChannel?: Maybe<provider__SubmissionChannel>;
  submitTo?: Maybe<provider__ContactPoint>;
  updatedAt: Scalars['String']['output'];
};


export type provider__ProviderForm_TypecalibratedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type provider__ProviderForm_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__ProviderForm_TypesubmitToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};

export enum provider__ProviderKind {
  HealthSystem = 'HealthSystem',
  Hospital = 'Hospital',
  ImagingCenter = 'ImagingCenter',
  Lab = 'Lab',
  Other = 'Other',
  Pharmacy = 'Pharmacy',
  PhysicianGroup = 'PhysicianGroup'
}

export type provider__Provider_Type = BaseObject & Object & Slugged & Verifiable & provider__Provider & {
  __typename: 'provider__Provider_Type';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  ccn?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactPoints?: Maybe<Array<provider__ContactPoint>>;
  county?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  faPolicy?: Maybe<Scalars['JSON']['output']>;
  faPolicyUrl?: Maybe<Scalars['String']['output']>;
  facilities?: Maybe<Array<provider__Provider>>;
  forms?: Maybe<Array<provider__ProviderForm>>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isNonprofit: Scalars['Boolean']['output'];
  kind: provider__ProviderKind;
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  lastVerified?: Maybe<Scalars['String']['output']>;
  negotiation?: Maybe<provider__NegotiationProfile>;
  notes?: Maybe<Array<Scalars['String']['output']>>;
  npi?: Maybe<Scalars['String']['output']>;
  ownership?: Maybe<provider__Ownership>;
  ownershipRaw?: Maybe<Scalars['String']['output']>;
  partOf?: Maybe<provider__Provider>;
  postalCode?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<provider__Source>;
  state?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
  verifiedBy?: Maybe<User>;
};


export type provider__Provider_TypecontactPointsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterContactPoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderContactPoint>;
};


export type provider__Provider_TypefacilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__Provider_TypeformsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProviderForm>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProviderForm>;
};


export type provider__Provider_TypenegotiationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterNegotiationProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderNegotiationProfile>;
};


export type provider__Provider_TypepartOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__Provider_TypeverifiedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type provider__ResearchRun = {
  claimsDropped?: Maybe<Scalars['Int']['output']>;
  claimsKept?: Maybe<Scalars['Int']['output']>;
  contactsKept?: Maybe<Scalars['Int']['output']>;
  costUsd?: Maybe<Scalars['Float']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOpen: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
  notesWritten?: Maybe<Scalars['Boolean']['output']>;
  proposal?: Maybe<Scalars['JSON']['output']>;
  provider: provider__Provider;
  requestedAt: Scalars['String']['output'];
  requestedBy?: Maybe<User>;
  skillVersion?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: provider__ResearchRunStatus;
  turns?: Maybe<Scalars['Int']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};


export type provider__ResearchRunproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__ResearchRunrequestedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum provider__ResearchRunStatus {
  Failed = 'Failed',
  Requested = 'Requested',
  Running = 'Running',
  Succeeded = 'Succeeded'
}

export type provider__ResearchRun_Type = BaseObject & Object & provider__ResearchRun & {
  __typename: 'provider__ResearchRun_Type';
  claimsDropped?: Maybe<Scalars['Int']['output']>;
  claimsKept?: Maybe<Scalars['Int']['output']>;
  contactsKept?: Maybe<Scalars['Int']['output']>;
  costUsd?: Maybe<Scalars['Float']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  engine?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOpen: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
  notesWritten?: Maybe<Scalars['Boolean']['output']>;
  proposal?: Maybe<Scalars['JSON']['output']>;
  provider: provider__Provider;
  requestedAt: Scalars['String']['output'];
  requestedBy?: Maybe<User>;
  skillVersion?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: provider__ResearchRunStatus;
  turns?: Maybe<Scalars['Int']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
};


export type provider__ResearchRun_TypeproviderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<provider__FilterProvider>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<provider__OrderProvider>;
};


export type provider__ResearchRun_TyperequestedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum provider__Source {
  ahrq = 'ahrq',
  cms = 'cms',
  ha = 'ha',
  imported = 'imported',
  notion = 'notion',
  research = 'research'
}

export enum provider__SubmissionChannel {
  Email = 'Email',
  Fax = 'Fax',
  InPerson = 'InPerson',
  Mail = 'Mail',
  Phone = 'Phone',
  PortalStructured = 'PortalStructured',
  PortalUpload = 'PortalUpload'
}

export type segment__FilterPartnerSegment = {
  and?: InputMaybe<Array<segment__FilterPartnerSegment>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<segment__FilterPartnerSegment>;
  or?: InputMaybe<Array<segment__FilterPartnerSegment>>;
  partnerSlug?: InputMaybe<FilterString>;
  segment?: InputMaybe<segment__NestedFilterSegment>;
  updatedAt?: InputMaybe<FilterString>;
};

export type segment__FilterSegment = {
  and?: InputMaybe<Array<segment__FilterSegment>>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  not?: InputMaybe<segment__FilterSegment>;
  or?: InputMaybe<Array<segment__FilterSegment>>;
  owningTeam?: InputMaybe<FilterString>;
  status?: InputMaybe<Filtersegment__SegmentStatus>;
  updatedAt?: InputMaybe<FilterString>;
};

export type segment__FilterUserSegment = {
  and?: InputMaybe<Array<segment__FilterUserSegment>>;
  assignedBy?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  effectiveFrom?: InputMaybe<FilterString>;
  effectiveTo?: InputMaybe<FilterString>;
  evidence?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<segment__FilterUserSegment>;
  or?: InputMaybe<Array<segment__FilterUserSegment>>;
  reason?: InputMaybe<FilterString>;
  segment?: InputMaybe<segment__NestedFilterSegment>;
  source?: InputMaybe<Filtersegment__SegmentSource>;
  user?: InputMaybe<NestedFilterUser>;
};

export type segment__FilterUtmSegment = {
  and?: InputMaybe<Array<segment__FilterUtmSegment>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<segment__FilterUtmSegment>;
  or?: InputMaybe<Array<segment__FilterUtmSegment>>;
  segment?: InputMaybe<segment__NestedFilterSegment>;
  updatedAt?: InputMaybe<FilterString>;
  utmCampaign?: InputMaybe<FilterString>;
};

export type segment__NestedFilterSegment = {
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  owningTeam?: InputMaybe<FilterString>;
  status?: InputMaybe<Filtersegment__SegmentStatus>;
  updatedAt?: InputMaybe<FilterString>;
};

export type segment__NestedFilterUserSegment = {
  assignedBy?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  effectiveFrom?: InputMaybe<FilterString>;
  effectiveTo?: InputMaybe<FilterString>;
  evidence?: InputMaybe<FilterJSON>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  reason?: InputMaybe<FilterString>;
  segment?: InputMaybe<segment__NestedFilterSegment>;
  source?: InputMaybe<Filtersegment__SegmentSource>;
  user?: InputMaybe<NestedFilterUser>;
};

export type segment__OrderPartnerSegment = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  partnerSlug?: InputMaybe<Ordering>;
  segment?: InputMaybe<segment__OrderSegment>;
  updatedAt?: InputMaybe<Ordering>;
};

export type segment__OrderSegment = {
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  displayName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  key?: InputMaybe<Ordering>;
  owningTeam?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type segment__OrderUserSegment = {
  assignedBy?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  effectiveFrom?: InputMaybe<Ordering>;
  effectiveTo?: InputMaybe<Ordering>;
  evidence?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  reason?: InputMaybe<Ordering>;
  segment?: InputMaybe<segment__OrderSegment>;
  source?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type segment__OrderUtmSegment = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  segment?: InputMaybe<segment__OrderSegment>;
  updatedAt?: InputMaybe<Ordering>;
  utmCampaign?: InputMaybe<Ordering>;
};

/** Maps a partner slug to the single segment its users belong to. Rows are created manually (one-off production queries) and matched by slug string; no dependency on partner::Partner. Exactly one segment per slug (partnerSlug is exclusive); remove a mapping by deleting the row. */
export type segment__PartnerSegment = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  partnerSlug: Scalars['String']['output'];
  segment: segment__Segment;
  updatedAt: Scalars['String']['output'];
};


/** Maps a partner slug to the single segment its users belong to. Rows are created manually (one-off production queries) and matched by slug string; no dependency on partner::Partner. Exactly one segment per slug (partnerSlug is exclusive); remove a mapping by deleting the row. */
export type segment__PartnerSegmentsegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};

/** Maps a partner slug to the single segment its users belong to. Rows are created manually (one-off production queries) and matched by slug string; no dependency on partner::Partner. Exactly one segment per slug (partnerSlug is exclusive); remove a mapping by deleting the row. */
export type segment__PartnerSegment_Type = BaseObject & Object & segment__PartnerSegment & {
  __typename: 'segment__PartnerSegment_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  partnerSlug: Scalars['String']['output'];
  segment: segment__Segment;
  updatedAt: Scalars['String']['output'];
};


/** Maps a partner slug to the single segment its users belong to. Rows are created manually (one-off production queries) and matched by slug string; no dependency on partner::Partner. Exactly one segment per slug (partnerSlug is exclusive); remove a mapping by deleting the row. */
export type segment__PartnerSegment_TypesegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};

/** Canonical governed list of named segments (e.g. touchcare_partner, pregnancy_icp). Managed by admins; serves as the source of truth for valid segment keys. */
export type segment__Segment = {
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  owningTeam: Scalars['String']['output'];
  status: segment__SegmentStatus;
  updatedAt: Scalars['String']['output'];
};

export enum segment__SegmentSource {
  EXTERNAL_ENRICHMENT = 'EXTERNAL_ENRICHMENT',
  MANUAL_OVERRIDE = 'MANUAL_OVERRIDE',
  PARTNER = 'PARTNER',
  UTM_SIGNUP = 'UTM_SIGNUP'
}

export enum segment__SegmentStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  DEPRECATED = 'DEPRECATED'
}

/** Canonical governed list of named segments (e.g. touchcare_partner, pregnancy_icp). Managed by admins; serves as the source of truth for valid segment keys. */
export type segment__Segment_Type = BaseObject & Object & segment__Segment & {
  __typename: 'segment__Segment_Type';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  owningTeam: Scalars['String']['output'];
  status: segment__SegmentStatus;
  updatedAt: Scalars['String']['output'];
};

/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegment = {
  assignedBy: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  effectiveFrom: Scalars['String']['output'];
  effectiveTo?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  segment: segment__Segment;
  source: segment__SegmentSource;
  user: User;
};


/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegmentsegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};


/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegmentuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegment_Type = BaseObject & Object & segment__UserSegment & {
  __typename: 'segment__UserSegment_Type';
  assignedBy: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  effectiveFrom: Scalars['String']['output'];
  effectiveTo?: Maybe<Scalars['String']['output']>;
  evidence?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  segment: segment__Segment;
  source: segment__SegmentSource;
  user: User;
};


/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegment_TypesegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};


/** Junction between users and segments. Soft-deleted via isActive / effectiveTo rather than hard-deletes. Deduplicated on (user, segment, source) — upsert semantics for cron jobs. */
export type segment__UserSegment_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** Maps a utm_campaign value to the single segment its signups belong to. Rows are created manually (one-off production queries) and matched by lowercased campaign string. Exactly one segment per campaign (utmCampaign is exclusive); deleting the row removes the mapping and makes any value still stashed on a client no-op. */
export type segment__UtmSegment = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  segment: segment__Segment;
  updatedAt: Scalars['String']['output'];
  utmCampaign: Scalars['String']['output'];
};


/** Maps a utm_campaign value to the single segment its signups belong to. Rows are created manually (one-off production queries) and matched by lowercased campaign string. Exactly one segment per campaign (utmCampaign is exclusive); deleting the row removes the mapping and makes any value still stashed on a client no-op. */
export type segment__UtmSegmentsegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};

/** Maps a utm_campaign value to the single segment its signups belong to. Rows are created manually (one-off production queries) and matched by lowercased campaign string. Exactly one segment per campaign (utmCampaign is exclusive); deleting the row removes the mapping and makes any value still stashed on a client no-op. */
export type segment__UtmSegment_Type = BaseObject & Object & segment__UtmSegment & {
  __typename: 'segment__UtmSegment_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  segment: segment__Segment;
  updatedAt: Scalars['String']['output'];
  utmCampaign: Scalars['String']['output'];
};


/** Maps a utm_campaign value to the single segment its signups belong to. Rows are created manually (one-off production queries) and matched by lowercased campaign string. Exactly one segment per campaign (utmCampaign is exclusive); deleting the row removes the mapping and makes any value still stashed on a client no-op. */
export type segment__UtmSegment_TypesegmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<segment__FilterSegment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<segment__OrderSegment>;
};

export type suggestion__FilterSuggestedAction = {
  actionPayload?: InputMaybe<FilterJSON>;
  and?: InputMaybe<Array<suggestion__FilterSuggestedAction>>;
  comment?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  executedAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  not?: InputMaybe<suggestion__FilterSuggestedAction>;
  or?: InputMaybe<Array<suggestion__FilterSuggestedAction>>;
  rejectReasonCode?: InputMaybe<FilterString>;
  respondedAt?: InputMaybe<FilterString>;
  reviewTask?: InputMaybe<taskManagement__NestedFilterIssueTask>;
  reviewer?: InputMaybe<NestedFilterUser>;
  sentEvent?: InputMaybe<issue__NestedFilterEvent>;
  status?: InputMaybe<Filtersuggestion__SuggestedActionStatus>;
  triggerEvent?: InputMaybe<issue__NestedFilterEvent>;
  type?: InputMaybe<FilterString>;
};

export type suggestion__NestedFilterSuggestedAction = {
  actionPayload?: InputMaybe<FilterJSON>;
  comment?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  executedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  rejectReasonCode?: InputMaybe<FilterString>;
  respondedAt?: InputMaybe<FilterString>;
  reviewTask?: InputMaybe<taskManagement__NestedFilterIssueTask>;
  reviewer?: InputMaybe<NestedFilterUser>;
  sentEvent?: InputMaybe<issue__NestedFilterEvent>;
  status?: InputMaybe<Filtersuggestion__SuggestedActionStatus>;
  triggerEvent?: InputMaybe<issue__NestedFilterEvent>;
  type?: InputMaybe<FilterString>;
};

export type suggestion__OrderSuggestedAction = {
  actionPayload?: InputMaybe<Ordering>;
  comment?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  executedAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  rejectReasonCode?: InputMaybe<Ordering>;
  respondedAt?: InputMaybe<Ordering>;
  reviewTask?: InputMaybe<taskManagement__OrderIssueTask>;
  reviewer?: InputMaybe<OrderUser>;
  sentEvent?: InputMaybe<issue__OrderEvent>;
  status?: InputMaybe<Ordering>;
  triggerEvent?: InputMaybe<issue__OrderEvent>;
  type?: InputMaybe<Ordering>;
};

export type suggestion__SuggestedAction = {
  actionPayload: Scalars['JSON']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  rejectReasonCode?: Maybe<Scalars['String']['output']>;
  respondedAt?: Maybe<Scalars['String']['output']>;
  reviewTask?: Maybe<taskManagement__IssueTask>;
  reviewer?: Maybe<User>;
  sentEvent?: Maybe<issue__Event>;
  status: suggestion__SuggestedActionStatus;
  triggerEvent?: Maybe<issue__Event>;
  type: Scalars['String']['output'];
};


export type suggestion__SuggestedActionissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type suggestion__SuggestedActionreviewTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};


export type suggestion__SuggestedActionreviewerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type suggestion__SuggestedActionsentEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type suggestion__SuggestedActiontriggerEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};

/** Status of a suggested action */
export enum suggestion__SuggestedActionStatus {
  ACCEPTED = 'ACCEPTED',
  MODIFIED = 'MODIFIED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
  SUPERSEDED = 'SUPERSEDED'
}

export type suggestion__SuggestedAction_Type = BaseObject & Object & suggestion__SuggestedAction & {
  __typename: 'suggestion__SuggestedAction_Type';
  actionPayload: Scalars['JSON']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  executedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  rejectReasonCode?: Maybe<Scalars['String']['output']>;
  respondedAt?: Maybe<Scalars['String']['output']>;
  reviewTask?: Maybe<taskManagement__IssueTask>;
  reviewer?: Maybe<User>;
  sentEvent?: Maybe<issue__Event>;
  status: suggestion__SuggestedActionStatus;
  triggerEvent?: Maybe<issue__Event>;
  type: Scalars['String']['output'];
};


export type suggestion__SuggestedAction_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type suggestion__SuggestedAction_TypereviewTaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterIssueTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderIssueTask>;
};


export type suggestion__SuggestedAction_TypereviewerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type suggestion__SuggestedAction_TypesentEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};


export type suggestion__SuggestedAction_TypetriggerEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderEvent>;
};

export type taskManagement__DataQualityFlagTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  createdBy: User;
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  resource: fhirext__ResourceVersion;
  sourceName: Scalars['String']['output'];
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__DataQualityFlagTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__DataQualityFlagTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__DataQualityFlagTaskcreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__DataQualityFlagTaskresourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};

export type taskManagement__DataQualityFlagTask_Type = BaseObject & Object & taskManagement__DataQualityFlagTask & taskManagement__Task & {
  __typename: 'taskManagement__DataQualityFlagTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  createdBy: User;
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  resource: fhirext__ResourceVersion;
  sourceName: Scalars['String']['output'];
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__DataQualityFlagTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__DataQualityFlagTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__DataQualityFlagTask_TypecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__DataQualityFlagTask_TyperesourceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterResourceVersion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderResourceVersion>;
};

export type taskManagement__FilterDataQualityFlagTask = {
  and?: InputMaybe<Array<taskManagement__FilterDataQualityFlagTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterDataQualityFlagTask>;
  or?: InputMaybe<Array<taskManagement__FilterDataQualityFlagTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  resource?: InputMaybe<fhirext__NestedFilterResourceVersion>;
  sourceName?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterFollowUpClosurePendingIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterFollowUpClosurePendingIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterFollowUpClosurePendingIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterFollowUpClosurePendingIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterFollowUpUserUnresponsiveIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterFollowUpUserUnresponsiveIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterFollowUpUserUnresponsiveIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterFollowUpUserUnresponsiveIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterGeneralIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterGeneralIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterGeneralIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterGeneralIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterIssueResearchTask = {
  and?: InputMaybe<Array<taskManagement__FilterIssueResearchTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterIssueResearchTask>;
  or?: InputMaybe<Array<taskManagement__FilterIssueResearchTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterIssueUserMessagingTask = {
  and?: InputMaybe<Array<taskManagement__FilterIssueUserMessagingTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterIssueUserMessagingTask>;
  or?: InputMaybe<Array<taskManagement__FilterIssueUserMessagingTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterPhoneCall = {
  aircallId?: InputMaybe<FilterString>;
  aircallSessionId?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<taskManagement__FilterPhoneCall>>;
  callDate?: InputMaybe<FilterString>;
  callType?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  duration?: InputMaybe<FilterFloat>;
  duration_minutes?: InputMaybe<FilterFloat>;
  hasVoicemail?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  isInbound?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<taskManagement__FilterPhoneCall>;
  or?: InputMaybe<Array<taskManagement__FilterPhoneCall>>;
  owner?: InputMaybe<NestedFilterUser>;
  resolved?: InputMaybe<FilterBoolean>;
  task?: InputMaybe<taskManagement__NestedFilterTask>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterPhoneCallIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterPhoneCallIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterPhoneCallIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterPhoneCallIssueTask>>;
  phoneCall?: InputMaybe<taskManagement__NestedFilterPhoneCall>;
  phoneCallEvent?: InputMaybe<issue__NestedFilterPhoneCallEvent>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterProcessCustomerBillPaymentIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterProcessCustomerBillPaymentIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterProcessCustomerBillPaymentIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterProcessCustomerBillPaymentIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterRetryChargeIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterRetryChargeIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterRetryChargeIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterRetryChargeIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewCaseIntakeIssueTask = {
  additionalDetailsRequested?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<taskManagement__FilterReviewCaseIntakeIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  hasAllInformation?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewCaseIntakeIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewCaseIntakeIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewEscalatedCaseTask = {
  additionalDetailsRequested?: InputMaybe<FilterString>;
  and?: InputMaybe<Array<taskManagement__FilterReviewEscalatedCaseTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  hasAllInformation?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewEscalatedCaseTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewEscalatedCaseTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewFindingTask = {
  and?: InputMaybe<Array<taskManagement__FilterReviewFindingTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  finding?: InputMaybe<fhirext__NestedFilterFinding>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewFindingTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewFindingTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewIssueChatTask = {
  and?: InputMaybe<Array<taskManagement__FilterReviewIssueChatTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewIssueChatTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewIssueChatTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewPaymentAcceptanceIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterReviewPaymentAcceptanceIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewPaymentAcceptanceIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewPaymentAcceptanceIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterReviewSuggestionTask = {
  and?: InputMaybe<Array<taskManagement__FilterReviewSuggestionTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterReviewSuggestionTask>;
  or?: InputMaybe<Array<taskManagement__FilterReviewSuggestionTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  suggestedAction?: InputMaybe<suggestion__NestedFilterSuggestedAction>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterSendFormIssueTask = {
  and?: InputMaybe<Array<taskManagement__FilterSendFormIssueTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  formSender?: InputMaybe<FilterString>;
  formType?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterSendFormIssueTask>;
  or?: InputMaybe<Array<taskManagement__FilterSendFormIssueTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  sendingMethod?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterTask = {
  and?: InputMaybe<Array<taskManagement__FilterTask>>;
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  not?: InputMaybe<taskManagement__FilterTask>;
  or?: InputMaybe<Array<taskManagement__FilterTask>>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FilterTaskComment = {
  and?: InputMaybe<Array<taskManagement__FilterTaskComment>>;
  canEdit?: InputMaybe<FilterBoolean>;
  comment?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<taskManagement__FilterTaskComment>;
  or?: InputMaybe<Array<taskManagement__FilterTaskComment>>;
  pinned?: InputMaybe<FilterBoolean>;
  task?: InputMaybe<taskManagement__NestedFilterTask>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__FollowUpClosurePendingIssueTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__FollowUpClosurePendingIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__FollowUpClosurePendingIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__FollowUpClosurePendingIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__FollowUpClosurePendingIssueTask_Type = BaseObject & Object & taskManagement__FollowUpClosurePendingIssueTask & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__FollowUpClosurePendingIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__FollowUpClosurePendingIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__FollowUpClosurePendingIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__FollowUpUserUnresponsiveIssueTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__FollowUpUserUnresponsiveIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__FollowUpUserUnresponsiveIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__FollowUpUserUnresponsiveIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__FollowUpUserUnresponsiveIssueTask_Type = BaseObject & Object & taskManagement__FollowUpUserUnresponsiveIssueTask & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__FollowUpUserUnresponsiveIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__FollowUpUserUnresponsiveIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__FollowUpUserUnresponsiveIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__GeneralIssueTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__GeneralIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__GeneralIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__GeneralIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__GeneralIssueTask_Type = BaseObject & Object & taskManagement__GeneralIssueTask & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__GeneralIssueTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__GeneralIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__GeneralIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__GeneralIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueResearchTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueResearchTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueResearchTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueResearchTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueResearchTask_Type = BaseObject & Object & taskManagement__IssueResearchTask & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__IssueResearchTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueResearchTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueResearchTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueResearchTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__Task & {
  __typename: 'taskManagement__IssueTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueUserMessagingTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueUserMessagingTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueUserMessagingTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueUserMessagingTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__IssueUserMessagingTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__IssueUserMessagingTask & taskManagement__Task & {
  __typename: 'taskManagement__IssueUserMessagingTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__IssueUserMessagingTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__IssueUserMessagingTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__IssueUserMessagingTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__NestedFilterIssueTask = {
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  caseRef?: InputMaybe<FilterString>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  issue?: InputMaybe<issue__NestedFilterIssue>;
  minutesSpent?: InputMaybe<FilterInt>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__NestedFilterPhoneCall = {
  aircallId?: InputMaybe<FilterString>;
  aircallSessionId?: InputMaybe<FilterString>;
  callDate?: InputMaybe<FilterString>;
  callType?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  duration?: InputMaybe<FilterFloat>;
  duration_minutes?: InputMaybe<FilterFloat>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasVoicemail?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  isInbound?: InputMaybe<FilterBoolean>;
  owner?: InputMaybe<NestedFilterUser>;
  resolved?: InputMaybe<FilterBoolean>;
  task?: InputMaybe<taskManagement__NestedFilterTask>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__NestedFilterTask = {
  assignee?: InputMaybe<NestedFilterUser>;
  caseHasReengagementReason?: InputMaybe<FilterBoolean>;
  comments?: InputMaybe<taskManagement__NestedFilterTaskComment>;
  createdAt?: InputMaybe<FilterString>;
  dedupeKey?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  dueDate?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  minutesSpent?: InputMaybe<FilterInt>;
  priority?: InputMaybe<FilterInt>;
  researchNotes?: InputMaybe<FilterString>;
  status?: InputMaybe<FiltertaskManagement__TaskStatus>;
  timeSpent?: InputMaybe<FilterString>;
  title?: InputMaybe<FilterString>;
  type?: InputMaybe<FiltertaskManagement__TaskType>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__NestedFilterTaskComment = {
  canEdit?: InputMaybe<FilterBoolean>;
  comment?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  createdBy?: InputMaybe<NestedFilterUser>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  pinned?: InputMaybe<FilterBoolean>;
  task?: InputMaybe<taskManagement__NestedFilterTask>;
  updatedAt?: InputMaybe<FilterString>;
};

export type taskManagement__OrderDataQualityFlagTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  resource?: InputMaybe<fhirext__OrderResourceVersion>;
  sourceName?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderFollowUpClosurePendingIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderFollowUpUserUnresponsiveIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderGeneralIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderIssueResearchTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderIssueUserMessagingTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderPhoneCall = {
  aircallId?: InputMaybe<Ordering>;
  aircallSessionId?: InputMaybe<Ordering>;
  callDate?: InputMaybe<Ordering>;
  callType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  duration?: InputMaybe<Ordering>;
  duration_minutes?: InputMaybe<Ordering>;
  hasVoicemail?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isInbound?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  resolved?: InputMaybe<Ordering>;
  task?: InputMaybe<taskManagement__OrderTask>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderPhoneCallIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  phoneCall?: InputMaybe<taskManagement__OrderPhoneCall>;
  phoneCallEvent?: InputMaybe<issue__OrderPhoneCallEvent>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderProcessCustomerBillPaymentIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderRetryChargeIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewCaseIntakeIssueTask = {
  additionalDetailsRequested?: InputMaybe<Ordering>;
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  hasAllInformation?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewEscalatedCaseTask = {
  additionalDetailsRequested?: InputMaybe<Ordering>;
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  hasAllInformation?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewFindingTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  finding?: InputMaybe<fhirext__OrderFinding>;
  id?: InputMaybe<Ordering>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewIssueChatTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewPaymentAcceptanceIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderReviewSuggestionTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  suggestedAction?: InputMaybe<suggestion__OrderSuggestedAction>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderSendFormIssueTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  caseRef?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  formSender?: InputMaybe<Ordering>;
  formType?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  issue?: InputMaybe<issue__OrderIssue>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  sendingMethod?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderTask = {
  assignee?: InputMaybe<OrderUser>;
  caseHasReengagementReason?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  dedupeKey?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  dueDate?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  minutesSpent?: InputMaybe<Ordering>;
  priority?: InputMaybe<Ordering>;
  researchNotes?: InputMaybe<Ordering>;
  status?: InputMaybe<Ordering>;
  timeSpent?: InputMaybe<Ordering>;
  title?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
};

export type taskManagement__OrderTaskComment = {
  canEdit?: InputMaybe<Ordering>;
  comment?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  createdBy?: InputMaybe<OrderUser>;
  id?: InputMaybe<Ordering>;
  pinned?: InputMaybe<Ordering>;
  task?: InputMaybe<taskManagement__OrderTask>;
  updatedAt?: InputMaybe<Ordering>;
};

/** Represents a phone call associated with a task */
export type taskManagement__PhoneCall = {
  aircallId: Scalars['String']['output'];
  aircallSessionId?: Maybe<Scalars['String']['output']>;
  callDate: Scalars['String']['output'];
  callType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  hasVoicemail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInbound: Scalars['Boolean']['output'];
  owner: User;
  resolved: Scalars['Boolean']['output'];
  task: taskManagement__Task;
  updatedAt: Scalars['String']['output'];
};


/** Represents a phone call associated with a task */
export type taskManagement__PhoneCallownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Represents a phone call associated with a task */
export type taskManagement__PhoneCalltaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};

export type taskManagement__PhoneCallIssueTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  phoneCall?: Maybe<taskManagement__PhoneCall>;
  phoneCallEvent?: Maybe<issue__PhoneCallEvent>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__PhoneCallIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__PhoneCallIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__PhoneCallIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type taskManagement__PhoneCallIssueTaskphoneCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterPhoneCall>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderPhoneCall>;
};


export type taskManagement__PhoneCallIssueTaskphoneCallEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPhoneCallEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPhoneCallEvent>;
};

export type taskManagement__PhoneCallIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__PhoneCallIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__PhoneCallIssueTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  phoneCall?: Maybe<taskManagement__PhoneCall>;
  phoneCallEvent?: Maybe<issue__PhoneCallEvent>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__PhoneCallIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__PhoneCallIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__PhoneCallIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type taskManagement__PhoneCallIssueTask_TypephoneCallArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterPhoneCall>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderPhoneCall>;
};


export type taskManagement__PhoneCallIssueTask_TypephoneCallEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterPhoneCallEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderPhoneCallEvent>;
};

/** Represents a phone call associated with a task */
export type taskManagement__PhoneCall_Type = BaseObject & Object & Owned & taskManagement__PhoneCall & {
  __typename: 'taskManagement__PhoneCall_Type';
  aircallId: Scalars['String']['output'];
  aircallSessionId?: Maybe<Scalars['String']['output']>;
  callDate: Scalars['String']['output'];
  callType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  duration: Scalars['Float']['output'];
  duration_minutes?: Maybe<Scalars['Float']['output']>;
  hasVoicemail: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isInbound: Scalars['Boolean']['output'];
  owner: User;
  resolved: Scalars['Boolean']['output'];
  task: taskManagement__Task;
  updatedAt: Scalars['String']['output'];
};


/** Represents a phone call associated with a task */
export type taskManagement__PhoneCall_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


/** Represents a phone call associated with a task */
export type taskManagement__PhoneCall_TypetaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};

export type taskManagement__ProcessCustomerBillPaymentIssueTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ProcessCustomerBillPaymentIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ProcessCustomerBillPaymentIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ProcessCustomerBillPaymentIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ProcessCustomerBillPaymentIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ProcessCustomerBillPaymentIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ProcessCustomerBillPaymentIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ProcessCustomerBillPaymentIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ProcessCustomerBillPaymentIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__RetryChargeIssueTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__RetryChargeIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__RetryChargeIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__RetryChargeIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__RetryChargeIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__RetryChargeIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__RetryChargeIssueTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__RetryChargeIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__RetryChargeIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__RetryChargeIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewCaseIntakeIssueTask = {
  additionalDetailsRequested?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hasAllInformation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewCaseIntakeIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewCaseIntakeIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewCaseIntakeIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewCaseIntakeIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewCaseIntakeIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type';
  additionalDetailsRequested?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hasAllInformation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewCaseIntakeIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewCaseIntakeIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewCaseIntakeIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewEscalatedCaseTask = {
  additionalDetailsRequested?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hasAllInformation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewEscalatedCaseTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewEscalatedCaseTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewEscalatedCaseTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewEscalatedCaseTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewEscalatedCaseTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewEscalatedCaseTask_Type';
  additionalDetailsRequested?: Maybe<Scalars['String']['output']>;
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  hasAllInformation?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewEscalatedCaseTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewEscalatedCaseTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewEscalatedCaseTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewFindingTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  finding: fhirext__Finding;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewFindingTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewFindingTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewFindingTaskfindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};

export type taskManagement__ReviewFindingTask_Type = BaseObject & Object & taskManagement__ReviewFindingTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewFindingTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  finding: fhirext__Finding;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewFindingTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewFindingTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewFindingTask_TypefindingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<fhirext__FilterFinding>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<fhirext__OrderFinding>;
};

export type taskManagement__ReviewIssueChatTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewIssueChatTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewIssueChatTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewIssueChatTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewIssueChatTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewIssueChatTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewIssueChatTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewIssueChatTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewIssueChatTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewIssueChatTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewPaymentAcceptanceIssueTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewPaymentAcceptanceIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewPaymentAcceptanceIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewPaymentAcceptanceIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewPaymentAcceptanceIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewPaymentAcceptanceIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewPaymentAcceptanceIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewPaymentAcceptanceIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewPaymentAcceptanceIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__ReviewSuggestionTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  suggestedAction: suggestion__SuggestedAction;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewSuggestionTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewSuggestionTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewSuggestionTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type taskManagement__ReviewSuggestionTasksuggestedActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<suggestion__FilterSuggestedAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<suggestion__OrderSuggestedAction>;
};

export type taskManagement__ReviewSuggestionTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__ReviewSuggestionTask & taskManagement__Task & {
  __typename: 'taskManagement__ReviewSuggestionTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  suggestedAction: suggestion__SuggestedAction;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__ReviewSuggestionTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__ReviewSuggestionTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__ReviewSuggestionTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};


export type taskManagement__ReviewSuggestionTask_TypesuggestedActionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<suggestion__FilterSuggestedAction>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<suggestion__OrderSuggestedAction>;
};

export type taskManagement__SendFormIssueTask = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  formSender: Scalars['String']['output'];
  formType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  sendingMethod: Scalars['String']['output'];
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__SendFormIssueTaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__SendFormIssueTaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__SendFormIssueTaskissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__SendFormIssueTask_Type = BaseObject & Object & taskManagement__IssueTask & taskManagement__SendFormIssueTask & taskManagement__Task & {
  __typename: 'taskManagement__SendFormIssueTask_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  caseRef: Scalars['String']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  formSender: Scalars['String']['output'];
  formType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  issue: issue__Issue;
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  sendingMethod: Scalars['String']['output'];
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__SendFormIssueTask_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__SendFormIssueTask_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};


export type taskManagement__SendFormIssueTask_TypeissueArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<issue__FilterIssue>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<issue__OrderIssue>;
};

export type taskManagement__Task = {
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__TaskassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__TaskcommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};

export type taskManagement__TaskComment = {
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  pinned: Scalars['Boolean']['output'];
  task: taskManagement__Task;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__TaskCommentcreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__TaskCommenttaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};

export type taskManagement__TaskComment_Type = BaseObject & Object & taskManagement__TaskComment & {
  __typename: 'taskManagement__TaskComment_Type';
  canEdit?: Maybe<Scalars['Boolean']['output']>;
  comment: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['ID']['output'];
  pinned: Scalars['Boolean']['output'];
  task: taskManagement__Task;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__TaskComment_TypecreatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__TaskComment_TypetaskArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTask>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTask>;
};

export enum taskManagement__TaskStatus {
  CANCELED = 'CANCELED',
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED'
}

export enum taskManagement__TaskType {
  DATA_QUALITY_FLAG = 'DATA_QUALITY_FLAG',
  DATA_QUALITY_TASK = 'DATA_QUALITY_TASK',
  FOLLOW_UP_CLOSURE_PENDING = 'FOLLOW_UP_CLOSURE_PENDING',
  FOLLOW_UP_USER_UNRESPONSIVE = 'FOLLOW_UP_USER_UNRESPONSIVE',
  GENERAL = 'GENERAL',
  ISSUE = 'ISSUE',
  ISSUE_RESEARCH = 'ISSUE_RESEARCH',
  ISSUE_USER_MESSAGING = 'ISSUE_USER_MESSAGING',
  OTHER = 'OTHER',
  PHONE_CALL = 'PHONE_CALL',
  PROCESS_CUSTOMER_BILL_PAYMENT = 'PROCESS_CUSTOMER_BILL_PAYMENT',
  RESEARCH = 'RESEARCH',
  RETRY_CHARGE = 'RETRY_CHARGE',
  REVIEW_CASE_INTAKE = 'REVIEW_CASE_INTAKE',
  REVIEW_ESCALATED_CASE = 'REVIEW_ESCALATED_CASE',
  REVIEW_FINDING_TASK = 'REVIEW_FINDING_TASK',
  REVIEW_ISSUE_CHAT = 'REVIEW_ISSUE_CHAT',
  REVIEW_PAYMENT_ACCEPTANCE = 'REVIEW_PAYMENT_ACCEPTANCE',
  REVIEW_SUGGESTED_ACTION = 'REVIEW_SUGGESTED_ACTION',
  SEND_FORM = 'SEND_FORM',
  USER_MESSAGING = 'USER_MESSAGING'
}

export type taskManagement__Task_Type = BaseObject & Object & taskManagement__Task & {
  __typename: 'taskManagement__Task_Type';
  assignee?: Maybe<User>;
  caseHasReengagementReason: Scalars['Boolean']['output'];
  comments?: Maybe<Array<taskManagement__TaskComment>>;
  createdAt: Scalars['String']['output'];
  dedupeKey?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  minutesSpent?: Maybe<Scalars['Int']['output']>;
  priority: Scalars['Int']['output'];
  researchNotes?: Maybe<Scalars['String']['output']>;
  status: taskManagement__TaskStatus;
  timeSpent?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: taskManagement__TaskType;
  updatedAt: Scalars['String']['output'];
};


export type taskManagement__Task_TypeassigneeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type taskManagement__Task_TypecommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<taskManagement__FilterTaskComment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<taskManagement__OrderTaskComment>;
};

export type user__Email = {
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stytchId?: Maybe<Scalars['String']['output']>;
  user: User;
};


export type user__EmailuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type user__Email_Type = BaseObject & Object & user__Email & {
  __typename: 'user__Email_Type';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  stytchId?: Maybe<Scalars['String']['output']>;
  user: User;
};


export type user__Email_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type user__FilterEmail = {
  and?: InputMaybe<Array<user__FilterEmail>>;
  email?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<user__FilterEmail>;
  or?: InputMaybe<Array<user__FilterEmail>>;
  stytchId?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type user__FilterProfile = {
  and?: InputMaybe<Array<user__FilterProfile>>;
  fullName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<user__FilterProfile>;
  or?: InputMaybe<Array<user__FilterProfile>>;
  storedFullName?: InputMaybe<FilterString>;
  storedName?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type user__FilterSegmentationData = {
  and?: InputMaybe<Array<user__FilterSegmentationData>>;
  createdAt?: InputMaybe<FilterString>;
  hasInsurance?: InputMaybe<FilterBoolean>;
  heardAboutUsFrom?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<user__FilterSegmentationData>;
  or?: InputMaybe<Array<user__FilterSegmentationData>>;
  owner?: InputMaybe<NestedFilterUser>;
  updatedAt?: InputMaybe<FilterString>;
  usageScope?: InputMaybe<FilterString>;
};

export type user__NestedFilterEmail = {
  email?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  stytchId?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type user__NestedFilterProfile = {
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  storedFullName?: InputMaybe<FilterString>;
  storedName?: InputMaybe<FilterString>;
  user?: InputMaybe<NestedFilterUser>;
};

export type user__NestedFilterSegmentationData = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasInsurance?: InputMaybe<FilterBoolean>;
  heardAboutUsFrom?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  updatedAt?: InputMaybe<FilterString>;
  usageScope?: InputMaybe<FilterString>;
};

export type user__OrderEmail = {
  email?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  stytchId?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type user__OrderProfile = {
  fullName?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  storedFullName?: InputMaybe<Ordering>;
  storedName?: InputMaybe<Ordering>;
  user?: InputMaybe<OrderUser>;
};

export type user__OrderSegmentationData = {
  createdAt?: InputMaybe<Ordering>;
  hasInsurance?: InputMaybe<Ordering>;
  heardAboutUsFrom?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  updatedAt?: InputMaybe<Ordering>;
  usageScope?: InputMaybe<Ordering>;
};

/** A user's profile, intended to contain less-sensitive information that may be shared with other users. */
export type user__Profile = {
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  storedFullName?: Maybe<Scalars['String']['output']>;
  storedName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};


/** A user's profile, intended to contain less-sensitive information that may be shared with other users. */
export type user__ProfileuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

/** A user's profile, intended to contain less-sensitive information that may be shared with other users. */
export type user__Profile_Type = BaseObject & Object & user__Profile & {
  __typename: 'user__Profile_Type';
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  storedFullName?: Maybe<Scalars['String']['output']>;
  storedName?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};


/** A user's profile, intended to contain less-sensitive information that may be shared with other users. */
export type user__Profile_TypeuserArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type user__SegmentationData = {
  createdAt: Scalars['String']['output'];
  features?: Maybe<Array<Scalars['String']['output']>>;
  hasInsurance?: Maybe<Scalars['Boolean']['output']>;
  heardAboutUsFrom?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  updatedAt: Scalars['String']['output'];
  usageScope?: Maybe<Scalars['String']['output']>;
  usageScopes?: Maybe<Array<Scalars['String']['output']>>;
  useCases?: Maybe<Array<Scalars['String']['output']>>;
};


export type user__SegmentationDataownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type user__SegmentationData_Type = BaseObject & Object & Owned & user__SegmentationData & {
  __typename: 'user__SegmentationData_Type';
  createdAt: Scalars['String']['output'];
  features?: Maybe<Array<Scalars['String']['output']>>;
  hasInsurance?: Maybe<Scalars['Boolean']['output']>;
  heardAboutUsFrom?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  owner: User;
  updatedAt: Scalars['String']['output'];
  usageScope?: Maybe<Scalars['String']['output']>;
  usageScopes?: Maybe<Array<Scalars['String']['output']>>;
  useCases?: Maybe<Array<Scalars['String']['output']>>;
};


export type user__SegmentationData_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__AiConversationLogArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};


export type webAgent__AiConversationLogArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__AiConversationLogArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__AiConversationLogArtifact_Type = BaseObject & Object & Owned & webAgent__AiConversationLogArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__AiConversationLogArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
};


export type webAgent__AiConversationLogArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__AiConversationLogArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__AiDiscoveryCrawl = {
  categorization?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objectives?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  owner: User;
  status: webAgent__AiDiscoveryCrawlStatus;
  successfulExtractions: Scalars['Int64']['output'];
  successfulObjectives?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  successfulObjectivesCount: Scalars['Int64']['output'];
  successfulProbes: Scalars['Int64']['output'];
  totalObjectivesCount: Scalars['Int64']['output'];
};


export type webAgent__AiDiscoveryCrawlexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__AiDiscoveryCrawlobjectivesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type webAgent__AiDiscoveryCrawlownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__AiDiscoveryCrawlsuccessfulObjectivesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};

export type webAgent__AiDiscoveryCrawlObjective = {
  abortReasons?: Maybe<Array<Scalars['JSON']['output']>>;
  agentLogArtifact?: Maybe<webAgent__WebAgentArtifact>;
  categorization?: Maybe<Scalars['String']['output']>;
  crawl: webAgent__AiDiscoveryCrawl;
  createdAt: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  dataSlug?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<document__Document>>;
  endedAt?: Maybe<Scalars['String']['output']>;
  failureCause?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objectiveType: webAgent__AiDiscoveryCrawlObjectiveType;
  owner: User;
  parentObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  status?: Maybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  traceArtifact?: Maybe<webAgent__PlaywrightTraceArtifact>;
};


export type webAgent__AiDiscoveryCrawlObjectiveagentLogArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentArtifact>;
};


export type webAgent__AiDiscoveryCrawlObjectivecrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__AiDiscoveryCrawlObjectivedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type webAgent__AiDiscoveryCrawlObjectiveownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__AiDiscoveryCrawlObjectiveparentObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type webAgent__AiDiscoveryCrawlObjectivetraceArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightTraceArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightTraceArtifact>;
};

export enum webAgent__AiDiscoveryCrawlObjectiveResult {
  ABORTED = 'ABORTED',
  DIED = 'DIED',
  DISABLED = 'DISABLED',
  FAILED = 'FAILED',
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS'
}

export enum webAgent__AiDiscoveryCrawlObjectiveType {
  AI = 'AI',
  CLASSIC = 'CLASSIC',
  PROBE = 'PROBE'
}

export type webAgent__AiDiscoveryCrawlObjective_Type = BaseObject & Object & Owned & webAgent__AiDiscoveryCrawlObjective & {
  __typename: 'webAgent__AiDiscoveryCrawlObjective_Type';
  abortReasons?: Maybe<Array<Scalars['JSON']['output']>>;
  agentLogArtifact?: Maybe<webAgent__WebAgentArtifact>;
  categorization?: Maybe<Scalars['String']['output']>;
  crawl: webAgent__AiDiscoveryCrawl;
  createdAt: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  dataSlug?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<document__Document>>;
  endedAt?: Maybe<Scalars['String']['output']>;
  failureCause?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objectiveType: webAgent__AiDiscoveryCrawlObjectiveType;
  owner: User;
  parentObjective?: Maybe<webAgent__AiDiscoveryCrawlObjective>;
  status?: Maybe<webAgent__AiDiscoveryCrawlObjectiveResult>;
  traceArtifact?: Maybe<webAgent__PlaywrightTraceArtifact>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypeagentLogArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentArtifact>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypecrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypeparentObjectiveArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type webAgent__AiDiscoveryCrawlObjective_TypetraceArtifactArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterPlaywrightTraceArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderPlaywrightTraceArtifact>;
};

export enum webAgent__AiDiscoveryCrawlStatus {
  COMPLETED = 'COMPLETED',
  CRASHED = 'CRASHED',
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  PARTIAL = 'PARTIAL'
}

export type webAgent__AiDiscoveryCrawl_Type = BaseObject & Object & Owned & webAgent__AiDiscoveryCrawl & {
  __typename: 'webAgent__AiDiscoveryCrawl_Type';
  categorization?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  endedAt?: Maybe<Scalars['String']['output']>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  objectives?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  owner: User;
  status: webAgent__AiDiscoveryCrawlStatus;
  successfulExtractions: Scalars['Int64']['output'];
  successfulObjectives?: Maybe<Array<webAgent__AiDiscoveryCrawlObjective>>;
  successfulObjectivesCount: Scalars['Int64']['output'];
  successfulProbes: Scalars['Int64']['output'];
  totalObjectivesCount: Scalars['Int64']['output'];
};


export type webAgent__AiDiscoveryCrawl_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__AiDiscoveryCrawl_TypeobjectivesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};


export type webAgent__AiDiscoveryCrawl_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__AiDiscoveryCrawl_TypesuccessfulObjectivesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
};

/** The stealth strategy to use for Browserbase. */
export enum webAgent__BrowserbaseStealthStrategy {
  ADVANCED_STEALTH = 'ADVANCED_STEALTH',
  BASIC_STEALTH = 'BASIC_STEALTH',
  DEFAULT = 'DEFAULT'
}

export enum webAgent__CDPProvider {
  BRIGHTDATA = 'BRIGHTDATA',
  BROWSERBASE = 'BROWSERBASE',
  BROWSERLESS = 'BROWSERLESS',
  BROWSER_USE = 'BROWSER_USE',
  LOCAL = 'LOCAL',
  STEEL = 'STEEL',
  UNDETECT = 'UNDETECT'
}

export type webAgent__CrawlDataSummaryArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  crawlType: webAgent__CrawlType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  summary: Scalars['JSON']['output'];
};


export type webAgent__CrawlDataSummaryArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__CrawlDataSummaryArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__CrawlDataSummaryArtifact_Type = BaseObject & Object & Owned & webAgent__CrawlDataSummaryArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__CrawlDataSummaryArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  crawlType: webAgent__CrawlType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  summary: Scalars['JSON']['output'];
};


export type webAgent__CrawlDataSummaryArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__CrawlDataSummaryArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__CrawlType {
  AI = 'AI',
  CLASSIC = 'CLASSIC'
}

/**
 * Tombstone enum for Expo OTAs that still select `planDocumentsDataLatency`
 * after INT-944 / #7650 dropped the Gel scalar. Remove once production
 * clients no longer select the field.
 */
export enum webAgent__DataLatency {
  DEFERRED = 'DEFERRED',
  IMMEDIATE = 'IMMEDIATE'
}

/**
 * Temporary compatibility fields for deployed Expo OTAs that still select
 * endpoint flags removed in INT-944 / #7650. Values are unused by current
 * clients (over-fetched only). Remove after a production OTA ships without
 * these selections.
 */
export type webAgent__Endpoint = {
  cdpProvider: webAgent__CDPProvider;
  currentSupportLevel?: Maybe<webAgent__EndpointSupportLevelHistory>;
  dashboardUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayUrl: Scalars['String']['output'];
  externalIds: Array<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAuthenticationRequired: Scalars['Boolean']['output'];
  isIngestionSupported: Scalars['Boolean']['output'];
  isPasswordRequired: Scalars['Boolean']['output'];
  loginUrl: Scalars['String']['output'];
  managedMfaConfiguration?: Maybe<webAgent__ManagedMfaConfiguration>;
  metadata: Array<Scalars['JSON']['output']>;
  organization?: Maybe<integration__Organization>;
  planDocumentsDataLatency: webAgent__DataLatency;
  planDocumentsSupported: Scalars['Boolean']['output'];
  portalGuideUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  supportLevelHistory?: Maybe<Array<webAgent__EndpointSupportLevelHistory>>;
  type: webAgent__EndpointType;
};


/**
 * Temporary compatibility fields for deployed Expo OTAs that still select
 * endpoint flags removed in INT-944 / #7650. Values are unused by current
 * clients (over-fetched only). Remove after a production OTA ships without
 * these selections.
 */
export type webAgent__EndpointcurrentSupportLevelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};


/**
 * Temporary compatibility fields for deployed Expo OTAs that still select
 * endpoint flags removed in INT-944 / #7650. Values are unused by current
 * clients (over-fetched only). Remove after a production OTA ships without
 * these selections.
 */
export type webAgent__EndpointmanagedMfaConfigurationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaConfiguration>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaConfiguration>;
};


/**
 * Temporary compatibility fields for deployed Expo OTAs that still select
 * endpoint flags removed in INT-944 / #7650. Values are unused by current
 * clients (over-fetched only). Remove after a production OTA ships without
 * these selections.
 */
export type webAgent__EndpointorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};


/**
 * Temporary compatibility fields for deployed Expo OTAs that still select
 * endpoint flags removed in INT-944 / #7650. Values are unused by current
 * clients (over-fetched only). Remove after a production OTA ships without
 * these selections.
 */
export type webAgent__EndpointsupportLevelHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};

export enum webAgent__EndpointSupportLevel {
  P0 = 'P0',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3'
}

export type webAgent__EndpointSupportLevelHistory = {
  createdAt: Scalars['String']['output'];
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  supportLevel: webAgent__EndpointSupportLevel;
  updatedBy: User;
};


export type webAgent__EndpointSupportLevelHistoryendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type webAgent__EndpointSupportLevelHistoryupdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__EndpointSupportLevelHistory_Type = BaseObject & Object & webAgent__EndpointSupportLevelHistory & {
  __typename: 'webAgent__EndpointSupportLevelHistory_Type';
  createdAt: Scalars['String']['output'];
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  supportLevel: webAgent__EndpointSupportLevel;
  updatedBy: User;
};


export type webAgent__EndpointSupportLevelHistory_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type webAgent__EndpointSupportLevelHistory_TypeupdatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__EndpointType {
  EHR = 'EHR',
  INSURANCE = 'INSURANCE'
}

export type webAgent__Endpoint_Type = BaseObject & Object & integration__BaseEndpoint & webAgent__Endpoint & {
  __typename: 'webAgent__Endpoint_Type';
  cdpProvider: webAgent__CDPProvider;
  currentSupportLevel?: Maybe<webAgent__EndpointSupportLevelHistory>;
  dashboardUrl?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  displayUrl: Scalars['String']['output'];
  externalIds: Array<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isAuthenticationRequired: Scalars['Boolean']['output'];
  isIngestionSupported: Scalars['Boolean']['output'];
  isPasswordRequired: Scalars['Boolean']['output'];
  loginUrl: Scalars['String']['output'];
  managedMfaConfiguration?: Maybe<webAgent__ManagedMfaConfiguration>;
  metadata: Array<Scalars['JSON']['output']>;
  organization?: Maybe<integration__Organization>;
  planDocumentsDataLatency: webAgent__DataLatency;
  planDocumentsSupported: Scalars['Boolean']['output'];
  portalGuideUrl?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  supportLevelHistory?: Maybe<Array<webAgent__EndpointSupportLevelHistory>>;
  type: webAgent__EndpointType;
};


export type webAgent__Endpoint_TypecurrentSupportLevelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};


export type webAgent__Endpoint_TypemanagedMfaConfigurationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaConfiguration>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaConfiguration>;
};


export type webAgent__Endpoint_TypeorganizationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterOrganization>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderOrganization>;
};


export type webAgent__Endpoint_TypesupportLevelHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
};

export type webAgent__ExecutionClassification = {
  cause: Scalars['String']['output'];
  classifierVersion: Scalars['String']['output'];
  confidence: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  evidence?: Maybe<Scalars['JSON']['output']>;
  execution: webAgent__WebAgentExecution;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type webAgent__ExecutionClassificationexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__ExecutionClassification_Type = BaseObject & Object & webAgent__ExecutionClassification & {
  __typename: 'webAgent__ExecutionClassification_Type';
  cause: Scalars['String']['output'];
  classifierVersion: Scalars['String']['output'];
  confidence: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  evidence?: Maybe<Scalars['JSON']['output']>;
  execution: webAgent__WebAgentExecution;
  explanation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type webAgent__ExecutionClassification_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export enum webAgent__ExecutionOrigin {
  USER_LINK = 'USER_LINK',
  USER_RELINK = 'USER_RELINK'
}

export enum webAgent__ExecutionProxyOrigin {
  BUILTIN = 'BUILTIN',
  DECODO = 'DECODO',
  DIRECT = 'DIRECT',
  MASSIVE = 'MASSIVE',
  NIMBLE = 'NIMBLE',
  OXYLABS = 'OXYLABS'
}

export type webAgent__FilterAiConversationLogArtifact = {
  and?: InputMaybe<Array<webAgent__FilterAiConversationLogArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterAiConversationLogArtifact>;
  or?: InputMaybe<Array<webAgent__FilterAiConversationLogArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterAiDiscoveryCrawl = {
  and?: InputMaybe<Array<webAgent__FilterAiDiscoveryCrawl>>;
  categorization?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  notes?: InputMaybe<FilterString>;
  objectives?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  or?: InputMaybe<Array<webAgent__FilterAiDiscoveryCrawl>>;
  owner?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlStatus>;
  successfulExtractions?: InputMaybe<FilterInt64>;
  successfulObjectives?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  successfulObjectivesCount?: InputMaybe<FilterInt64>;
  successfulProbes?: InputMaybe<FilterInt64>;
  totalObjectivesCount?: InputMaybe<FilterInt64>;
};

export type webAgent__FilterAiDiscoveryCrawlObjective = {
  agentLogArtifact?: InputMaybe<webAgent__NestedFilterWebAgentArtifact>;
  and?: InputMaybe<Array<webAgent__FilterAiDiscoveryCrawlObjective>>;
  categorization?: InputMaybe<FilterString>;
  crawl?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  createdAt?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  dataSlug?: InputMaybe<FilterString>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  endedAt?: InputMaybe<FilterString>;
  failureCause?: InputMaybe<FilterString>;
  failureReason?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterAiDiscoveryCrawlObjective>;
  notes?: InputMaybe<FilterString>;
  objectiveType?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlObjectiveType>;
  or?: InputMaybe<Array<webAgent__FilterAiDiscoveryCrawlObjective>>;
  owner?: InputMaybe<NestedFilterUser>;
  parentObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  status?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlObjectiveResult>;
  traceArtifact?: InputMaybe<webAgent__NestedFilterPlaywrightTraceArtifact>;
};

export type webAgent__FilterCrawlDataSummaryArtifact = {
  and?: InputMaybe<Array<webAgent__FilterCrawlDataSummaryArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  crawlType?: InputMaybe<FilterwebAgent__CrawlType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterCrawlDataSummaryArtifact>;
  or?: InputMaybe<Array<webAgent__FilterCrawlDataSummaryArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  summary?: InputMaybe<FilterJSON>;
};

export type webAgent__FilterEndpoint = {
  and?: InputMaybe<Array<webAgent__FilterEndpoint>>;
  cdpProvider?: InputMaybe<FilterwebAgent__CDPProvider>;
  currentSupportLevel?: InputMaybe<webAgent__NestedFilterEndpointSupportLevelHistory>;
  dashboardUrl?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  displayUrl?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  isAuthenticationRequired?: InputMaybe<FilterBoolean>;
  isPasswordRequired?: InputMaybe<FilterBoolean>;
  loginUrl?: InputMaybe<FilterString>;
  managedMfaConfiguration?: InputMaybe<webAgent__NestedFilterManagedMfaConfiguration>;
  not?: InputMaybe<webAgent__FilterEndpoint>;
  or?: InputMaybe<Array<webAgent__FilterEndpoint>>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  portalGuideUrl?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  supportLevelHistory?: InputMaybe<webAgent__NestedFilterEndpointSupportLevelHistory>;
  type?: InputMaybe<FilterwebAgent__EndpointType>;
};

export type webAgent__FilterEndpointSupportLevelHistory = {
  and?: InputMaybe<Array<webAgent__FilterEndpointSupportLevelHistory>>;
  createdAt?: InputMaybe<FilterString>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterEndpointSupportLevelHistory>;
  or?: InputMaybe<Array<webAgent__FilterEndpointSupportLevelHistory>>;
  supportLevel?: InputMaybe<FilterwebAgent__EndpointSupportLevel>;
  updatedBy?: InputMaybe<NestedFilterUser>;
};

export type webAgent__FilterExecutionClassification = {
  and?: InputMaybe<Array<webAgent__FilterExecutionClassification>>;
  cause?: InputMaybe<FilterString>;
  classifierVersion?: InputMaybe<FilterString>;
  confidence?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  evidence?: InputMaybe<FilterJSON>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  explanation?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterExecutionClassification>;
  or?: InputMaybe<Array<webAgent__FilterExecutionClassification>>;
};

export type webAgent__FilterInitialPageLoadSpan = {
  and?: InputMaybe<Array<webAgent__FilterInitialPageLoadSpan>>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterInitialPageLoadSpan>;
  or?: InputMaybe<Array<webAgent__FilterInitialPageLoadSpan>>;
  startedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterLink = {
  active?: InputMaybe<FilterBoolean>;
  and?: InputMaybe<Array<webAgent__FilterLink>>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  deactivatedReason?: InputMaybe<FilterwebAgent__LinkDeactivatedReason>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  executions?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  hasManagedMfa?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  lastSyncedAt?: InputMaybe<FilterString>;
  latestExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  mfaReceiver?: InputMaybe<webAgent__NestedFilterMfaReceiver>;
  not?: InputMaybe<webAgent__FilterLink>;
  or?: InputMaybe<Array<webAgent__FilterLink>>;
  owner?: InputMaybe<NestedFilterUser>;
  patientDOB?: InputMaybe<FilterString>;
  patientId?: InputMaybe<FilterString>;
  patientName?: InputMaybe<FilterString>;
  plans?: InputMaybe<plan__NestedFilterPlan>;
  providerProfiles?: InputMaybe<webAgent__NestedFilterLinkProviderProfile>;
  secrets?: InputMaybe<webAgent__NestedFilterLinkSecret>;
  userId?: InputMaybe<FilterString>;
};

export type webAgent__FilterLinkProviderProfile = {
  and?: InputMaybe<Array<webAgent__FilterLinkProviderProfile>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterLinkProviderProfile>;
  or?: InputMaybe<Array<webAgent__FilterLinkProviderProfile>>;
  owner?: InputMaybe<NestedFilterUser>;
  profileId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
  vendor?: InputMaybe<FilterwebAgent__CDPProvider>;
};

export type webAgent__FilterLinkSecret = {
  and?: InputMaybe<Array<webAgent__FilterLinkSecret>>;
  createdAt?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterLinkSecret>;
  or?: InputMaybe<Array<webAgent__FilterLinkSecret>>;
  owner?: InputMaybe<NestedFilterUser>;
  value?: InputMaybe<FilterJSON>;
};

export type webAgent__FilterManagedMfaConfiguration = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaConfiguration>>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  isSupported?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<webAgent__FilterManagedMfaConfiguration>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaConfiguration>>;
};

export type webAgent__FilterManagedMfaConfigured = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaConfigured>>;
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  configuredMethod?: InputMaybe<FilterwebAgent__MfaMethod>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterManagedMfaConfigured>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaConfigured>>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__FilterManagedMfaFailed = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaFailed>>;
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  error?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterManagedMfaFailed>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaFailed>>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__FilterManagedMfaOutcome = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaOutcome>>;
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaOutcome>>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__FilterManagedMfaRejected = {
  and?: InputMaybe<Array<webAgent__FilterManagedMfaRejected>>;
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterManagedMfaRejected>;
  or?: InputMaybe<Array<webAgent__FilterManagedMfaRejected>>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__FilterMfaCodeRequest = {
  and?: InputMaybe<Array<webAgent__FilterMfaCodeRequest>>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  isValid?: InputMaybe<FilterBoolean>;
  mfaReceiver?: InputMaybe<webAgent__NestedFilterMfaReceiver>;
  not?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  or?: InputMaybe<Array<webAgent__FilterMfaCodeRequest>>;
  usedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterMfaConfigurationSummaryArtifact = {
  and?: InputMaybe<Array<webAgent__FilterMfaConfigurationSummaryArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  authenticatorAppSupport?: InputMaybe<FilterwebAgent__MfaSupportLevel>;
  createdAt?: InputMaybe<FilterString>;
  description?: InputMaybe<FilterString>;
  emailSupport?: InputMaybe<FilterwebAgent__MfaSupportLevel>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  isMfaRequired?: InputMaybe<FilterwebAgent__MfaRequirement>;
  not?: InputMaybe<webAgent__FilterMfaConfigurationSummaryArtifact>;
  or?: InputMaybe<Array<webAgent__FilterMfaConfigurationSummaryArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  phoneSupport?: InputMaybe<FilterwebAgent__MfaSupportLevel>;
  smsSupport?: InputMaybe<FilterwebAgent__MfaSupportLevel>;
  success?: InputMaybe<FilterBoolean>;
  wasPromptedForMfa?: InputMaybe<FilterBoolean>;
};

export type webAgent__FilterMfaEmail = {
  and?: InputMaybe<Array<webAgent__FilterMfaEmail>>;
  codeRequests?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  email?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  latestCodeRequest?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterMfaEmail>;
  or?: InputMaybe<Array<webAgent__FilterMfaEmail>>;
};

export type webAgent__FilterMfaNumber = {
  and?: InputMaybe<Array<webAgent__FilterMfaNumber>>;
  backupNumber?: InputMaybe<FilterString>;
  codeRequests?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  isStopped?: InputMaybe<FilterBoolean>;
  latestCodeRequest?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterMfaNumber>;
  number?: InputMaybe<FilterString>;
  or?: InputMaybe<Array<webAgent__FilterMfaNumber>>;
  stopRequestedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterMfaReceiver = {
  and?: InputMaybe<Array<webAgent__FilterMfaReceiver>>;
  codeRequests?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  latestCodeRequest?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  not?: InputMaybe<webAgent__FilterMfaReceiver>;
  or?: InputMaybe<Array<webAgent__FilterMfaReceiver>>;
};

export type webAgent__FilterNavigatorSpecialistInstructions = {
  and?: InputMaybe<Array<webAgent__FilterNavigatorSpecialistInstructions>>;
  createdAt?: InputMaybe<FilterString>;
  dataSlug?: InputMaybe<FilterString>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  instructions?: InputMaybe<FilterString>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<webAgent__FilterNavigatorSpecialistInstructions>;
  or?: InputMaybe<Array<webAgent__FilterNavigatorSpecialistInstructions>>;
};

export type webAgent__FilterNavigatorSpecialistPageDiscovery = {
  and?: InputMaybe<Array<webAgent__FilterNavigatorSpecialistPageDiscovery>>;
  createdAt?: InputMaybe<FilterString>;
  dataSlug?: InputMaybe<FilterString>;
  discovery?: InputMaybe<FilterJSON>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  not?: InputMaybe<webAgent__FilterNavigatorSpecialistPageDiscovery>;
  or?: InputMaybe<Array<webAgent__FilterNavigatorSpecialistPageDiscovery>>;
};

export type webAgent__FilterPlaywrightHarArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightHarArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterPlaywrightHarArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightHarArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterPlaywrightInterceptedResponsesArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightInterceptedResponsesArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterPlaywrightInterceptedResponsesArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightInterceptedResponsesArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterPlaywrightPageSourceArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightPageSourceArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  llmSummary?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterPlaywrightPageSourceArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightPageSourceArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterPlaywrightScreenshotArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightScreenshotArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterPlaywrightScreenshotArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightScreenshotArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterPlaywrightTraceArtifact = {
  and?: InputMaybe<Array<webAgent__FilterPlaywrightTraceArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterPlaywrightTraceArtifact>;
  or?: InputMaybe<Array<webAgent__FilterPlaywrightTraceArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterRecipeFinishedEvent = {
  and?: InputMaybe<Array<webAgent__FilterRecipeFinishedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterRecipeFinishedEvent>;
  or?: InputMaybe<Array<webAgent__FilterRecipeFinishedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  playwrightTraceS3bucket?: InputMaybe<FilterString>;
  playwrightTraceS3key?: InputMaybe<FilterString>;
  recipeDuration?: InputMaybe<FilterString>;
  result?: InputMaybe<FilterJSON>;
  screenshotS3bucket?: InputMaybe<FilterString>;
  screenshotS3key?: InputMaybe<FilterString>;
  startEvent?: InputMaybe<webAgent__NestedFilterRecipeStartedEvent>;
};

export type webAgent__FilterRecipeStartedEvent = {
  and?: InputMaybe<Array<webAgent__FilterRecipeStartedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterRecipeStartedEvent>;
  or?: InputMaybe<Array<webAgent__FilterRecipeStartedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  recipeName?: InputMaybe<FilterString>;
};

export type webAgent__FilterRequestResponseSpan = {
  and?: InputMaybe<Array<webAgent__FilterRequestResponseSpan>>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterRequestResponseSpan>;
  or?: InputMaybe<Array<webAgent__FilterRequestResponseSpan>>;
  requestType?: InputMaybe<FilterString>;
  responseType?: InputMaybe<FilterString>;
  startedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterRobotFinishedEvent = {
  and?: InputMaybe<Array<webAgent__FilterRobotFinishedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterRobotFinishedEvent>;
  or?: InputMaybe<Array<webAgent__FilterRobotFinishedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  result?: InputMaybe<FilterJSON>;
  robotDuration?: InputMaybe<FilterString>;
  startEvent?: InputMaybe<webAgent__NestedFilterRobotStartedEvent>;
};

export type webAgent__FilterRobotStartedEvent = {
  and?: InputMaybe<Array<webAgent__FilterRobotStartedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterRobotStartedEvent>;
  or?: InputMaybe<Array<webAgent__FilterRobotStartedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  robotName?: InputMaybe<FilterString>;
};

export type webAgent__FilterSignInRobotResultArtifact = {
  and?: InputMaybe<Array<webAgent__FilterSignInRobotResultArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterSignInRobotResultArtifact>;
  or?: InputMaybe<Array<webAgent__FilterSignInRobotResultArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  recipeResults?: InputMaybe<FilterJSON>;
  result?: InputMaybe<FilterJSON>;
  success?: InputMaybe<FilterBoolean>;
};

export type webAgent__FilterSpan = {
  and?: InputMaybe<Array<webAgent__FilterSpan>>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  not?: InputMaybe<webAgent__FilterSpan>;
  or?: InputMaybe<Array<webAgent__FilterSpan>>;
  startedAt?: InputMaybe<FilterString>;
};

export type webAgent__FilterUrlOpenedEvent = {
  and?: InputMaybe<Array<webAgent__FilterUrlOpenedEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterUrlOpenedEvent>;
  or?: InputMaybe<Array<webAgent__FilterUrlOpenedEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
  url?: InputMaybe<FilterString>;
};

export type webAgent__FilterUserExitInsuranceLinkFeedback = {
  and?: InputMaybe<Array<webAgent__FilterUserExitInsuranceLinkFeedback>>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  feedback?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterUserExitInsuranceLinkFeedback>;
  or?: InputMaybe<Array<webAgent__FilterUserExitInsuranceLinkFeedback>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__FilterWebAgentArtifact = {
  and?: InputMaybe<Array<webAgent__FilterWebAgentArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  category?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterWebAgentArtifact>;
  or?: InputMaybe<Array<webAgent__FilterWebAgentArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__FilterWebAgentExecution = {
  and?: InputMaybe<Array<webAgent__FilterWebAgentExecution>>;
  artifacts?: InputMaybe<webAgent__NestedFilterWebAgentExecutionArtifact>;
  audioTokenCount?: InputMaybe<FilterInt64>;
  browserbaseStealthStrategy?: InputMaybe<FilterwebAgent__BrowserbaseStealthStrategy>;
  cachedTokenCount?: InputMaybe<FilterInt64>;
  cdpInspectUrl?: InputMaybe<FilterString>;
  cdpProvider?: InputMaybe<FilterwebAgent__CDPProvider>;
  cdpProviderProfileId?: InputMaybe<FilterString>;
  cdpProviderSessionId?: InputMaybe<FilterString>;
  classification?: InputMaybe<webAgent__NestedFilterExecutionClassification>;
  createdAt?: InputMaybe<FilterString>;
  discoveryCrawls?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  endpoint?: InputMaybe<integration__NestedFilterBaseEndpoint>;
  endpointSupportLevel?: InputMaybe<FilterwebAgent__EndpointSupportLevel>;
  events?: InputMaybe<webAgent__NestedFilterWebAgentExecutionEvent>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  initiatedBy?: InputMaybe<NestedFilterUser>;
  initiatorRole?: InputMaybe<FilterParticipant>;
  inputTokenCount?: InputMaybe<FilterInt64>;
  isFailedProviderAttempt?: InputMaybe<FilterBoolean>;
  lastUserMfaMethods?: InputMaybe<FilterwebAgent__MfaMethod>;
  latestDiscoveryCrawl?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  latestManagedMfaOutcome?: InputMaybe<webAgent__NestedFilterManagedMfaOutcome>;
  latestStatus?: InputMaybe<FilterwebAgent__WebExecutionStatus>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  managedMfaOutcomes?: InputMaybe<webAgent__NestedFilterManagedMfaOutcome>;
  millisBlockedOnUser?: InputMaybe<FilterInt>;
  not?: InputMaybe<webAgent__FilterWebAgentExecution>;
  or?: InputMaybe<Array<webAgent__FilterWebAgentExecution>>;
  origin?: InputMaybe<FilterwebAgent__ExecutionOrigin>;
  originalExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  otelTraceId?: InputMaybe<FilterString>;
  outputTokenCount?: InputMaybe<FilterInt64>;
  owner?: InputMaybe<NestedFilterUser>;
  proxyOrigin?: InputMaybe<FilterwebAgent__ExecutionProxyOrigin>;
  signInActivityTimedOutAt?: InputMaybe<FilterString>;
  signInClientTimedOutAt?: InputMaybe<FilterString>;
  signInErroredAt?: InputMaybe<FilterString>;
  signInPhaseAtFailure?: InputMaybe<FilterString>;
  signInRobotType?: InputMaybe<FilterwebAgent__SignInRobotType>;
  signInSucceededAt?: InputMaybe<FilterString>;
  type?: InputMaybe<FilterwebAgent__WebExecutionType>;
};

export type webAgent__FilterWebAgentExecutionArtifact = {
  and?: InputMaybe<Array<webAgent__FilterWebAgentExecutionArtifact>>;
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterWebAgentExecutionArtifact>;
  or?: InputMaybe<Array<webAgent__FilterWebAgentExecutionArtifact>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__FilterWebAgentExecutionEvent = {
  and?: InputMaybe<Array<webAgent__FilterWebAgentExecutionEvent>>;
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  id?: InputMaybe<FilterID>;
  not?: InputMaybe<webAgent__FilterWebAgentExecutionEvent>;
  or?: InputMaybe<Array<webAgent__FilterWebAgentExecutionEvent>>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__InitialPageLoadSpan = {
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__InitialPageLoadSpanexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__InitialPageLoadSpan_Type = BaseObject & Object & webAgent__InitialPageLoadSpan & webAgent__Span & {
  __typename: 'webAgent__InitialPageLoadSpan_Type';
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__InitialPageLoadSpan_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__Link = {
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  deactivatedReason?: Maybe<webAgent__LinkDeactivatedReason>;
  endpoint: webAgent__Endpoint;
  executions?: Maybe<Array<webAgent__WebAgentExecution>>;
  hasManagedMfa: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  latestExecution?: Maybe<webAgent__WebAgentExecution>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  mfaReceiver?: Maybe<webAgent__MfaReceiver>;
  owner: User;
  patientDOB?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<plan__Plan>>;
  providerProfiles?: Maybe<Array<webAgent__LinkProviderProfile>>;
  secrets?: Maybe<Array<webAgent__LinkSecret>>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type webAgent__LinkendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type webAgent__LinkexecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__LinklatestExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__LinklatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__LinkmfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};


export type webAgent__LinkownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__LinkplansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type webAgent__LinkproviderProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkProviderProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkProviderProfile>;
};


export type webAgent__LinksecretsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkSecret>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkSecret>;
};

export enum webAgent__LinkDeactivatedReason {
  FORCED_BY_ADMIN = 'FORCED_BY_ADMIN',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  MFA_REQUIRED = 'MFA_REQUIRED'
}

export type webAgent__LinkProviderProfile = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  link: webAgent__Link;
  owner: User;
  profileId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vendor: webAgent__CDPProvider;
};


export type webAgent__LinkProviderProfilelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__LinkProviderProfileownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__LinkProviderProfile_Type = BaseObject & Object & Owned & webAgent__LinkProviderProfile & {
  __typename: 'webAgent__LinkProviderProfile_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  link: webAgent__Link;
  owner: User;
  profileId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  vendor: webAgent__CDPProvider;
};


export type webAgent__LinkProviderProfile_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__LinkProviderProfile_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__LinkSecret = {
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  link: webAgent__Link;
  owner: User;
  value: Scalars['JSON']['output'];
};


export type webAgent__LinkSecretlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__LinkSecretownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__LinkSecret_Type = BaseObject & Object & Owned & webAgent__LinkSecret & {
  __typename: 'webAgent__LinkSecret_Type';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  link: webAgent__Link;
  owner: User;
  value: Scalars['JSON']['output'];
};


export type webAgent__LinkSecret_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__LinkSecret_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__Link_Type = BaseObject & Object & Owned & integration__BaseLink & webAgent__Link & {
  __typename: 'webAgent__Link_Type';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  deactivatedReason?: Maybe<webAgent__LinkDeactivatedReason>;
  endpoint: webAgent__Endpoint;
  executions?: Maybe<Array<webAgent__WebAgentExecution>>;
  hasManagedMfa: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['String']['output']>;
  latestExecution?: Maybe<webAgent__WebAgentExecution>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  mfaReceiver?: Maybe<webAgent__MfaReceiver>;
  owner: User;
  patientDOB?: Maybe<Scalars['String']['output']>;
  patientId?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<plan__Plan>>;
  providerProfiles?: Maybe<Array<webAgent__LinkProviderProfile>>;
  secrets?: Maybe<Array<webAgent__LinkSecret>>;
  userId?: Maybe<Scalars['String']['output']>;
};


export type webAgent__Link_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};


export type webAgent__Link_TypeexecutionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__Link_TypelatestExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__Link_TypelatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__Link_TypemfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};


export type webAgent__Link_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__Link_TypeplansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<plan__FilterPlan>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<plan__OrderPlan>;
};


export type webAgent__Link_TypeproviderProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkProviderProfile>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkProviderProfile>;
};


export type webAgent__Link_TypesecretsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLinkSecret>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLinkSecret>;
};

export type webAgent__ManagedMfaConfiguration = {
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isSupported: Scalars['Boolean']['output'];
  supportedMethods?: Maybe<Array<webAgent__MfaMethod>>;
};


export type webAgent__ManagedMfaConfigurationendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__ManagedMfaConfiguration_Type = BaseObject & Object & webAgent__ManagedMfaConfiguration & {
  __typename: 'webAgent__ManagedMfaConfiguration_Type';
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isSupported: Scalars['Boolean']['output'];
  supportedMethods?: Maybe<Array<webAgent__MfaMethod>>;
};


export type webAgent__ManagedMfaConfiguration_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__ManagedMfaConfigured = {
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  configuredMethod?: Maybe<webAgent__MfaMethod>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaConfiguredexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaConfiguredownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaConfigured_Type = BaseObject & Object & Owned & webAgent__ManagedMfaConfigured & webAgent__ManagedMfaOutcome & {
  __typename: 'webAgent__ManagedMfaConfigured_Type';
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  configuredMethod?: Maybe<webAgent__MfaMethod>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaConfigured_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaConfigured_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaFailed = {
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaFailedexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaFailedownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaFailed_Type = BaseObject & Object & Owned & webAgent__ManagedMfaFailed & webAgent__ManagedMfaOutcome & {
  __typename: 'webAgent__ManagedMfaFailed_Type';
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaFailed_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaFailed_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaOutcome = {
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaOutcomeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaOutcomeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__ManagedMfaOutcomeType {
  CONFIGURED = 'CONFIGURED',
  FAILED = 'FAILED',
  REJECTED = 'REJECTED'
}

export type webAgent__ManagedMfaRejected = {
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaRejectedexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaRejectedownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__ManagedMfaRejected_Type = BaseObject & Object & Owned & webAgent__ManagedMfaOutcome & webAgent__ManagedMfaRejected & {
  __typename: 'webAgent__ManagedMfaRejected_Type';
  configurationEndedAt: Scalars['String']['output'];
  configurationStartedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  type: webAgent__ManagedMfaOutcomeType;
};


export type webAgent__ManagedMfaRejected_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__ManagedMfaRejected_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__MfaCodeRequest = {
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  mfaReceiver: webAgent__MfaReceiver;
  usedAt?: Maybe<Scalars['String']['output']>;
};


export type webAgent__MfaCodeRequestexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__MfaCodeRequestmfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};

export type webAgent__MfaCodeRequest_Type = BaseObject & Object & webAgent__MfaCodeRequest & {
  __typename: 'webAgent__MfaCodeRequest_Type';
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  mfaReceiver: webAgent__MfaReceiver;
  usedAt?: Maybe<Scalars['String']['output']>;
};


export type webAgent__MfaCodeRequest_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__MfaCodeRequest_TypemfaReceiverArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaReceiver>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaReceiver>;
};

export type webAgent__MfaConfigurationSummaryArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  authenticatorAppSupport?: Maybe<webAgent__MfaSupportLevel>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  emailSupport?: Maybe<webAgent__MfaSupportLevel>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  isMfaRequired?: Maybe<webAgent__MfaRequirement>;
  owner: User;
  phoneSupport?: Maybe<webAgent__MfaSupportLevel>;
  smsSupport?: Maybe<webAgent__MfaSupportLevel>;
  success: Scalars['Boolean']['output'];
  wasPromptedForMfa?: Maybe<Scalars['Boolean']['output']>;
};


export type webAgent__MfaConfigurationSummaryArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__MfaConfigurationSummaryArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__MfaConfigurationSummaryArtifact_Type = BaseObject & Object & Owned & webAgent__MfaConfigurationSummaryArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__MfaConfigurationSummaryArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  authenticatorAppSupport?: Maybe<webAgent__MfaSupportLevel>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  emailSupport?: Maybe<webAgent__MfaSupportLevel>;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  isMfaRequired?: Maybe<webAgent__MfaRequirement>;
  owner: User;
  phoneSupport?: Maybe<webAgent__MfaSupportLevel>;
  smsSupport?: Maybe<webAgent__MfaSupportLevel>;
  success: Scalars['Boolean']['output'];
  wasPromptedForMfa?: Maybe<Scalars['Boolean']['output']>;
};


export type webAgent__MfaConfigurationSummaryArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__MfaConfigurationSummaryArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__MfaEmail = {
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
};


export type webAgent__MfaEmailcodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaEmaillatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaEmaillinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__MfaEmail_Type = BaseObject & Object & webAgent__MfaEmail & webAgent__MfaReceiver & {
  __typename: 'webAgent__MfaEmail_Type';
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
};


export type webAgent__MfaEmail_TypecodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaEmail_TypelatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaEmail_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export enum webAgent__MfaMethod {
  AUTHENTICATOR = 'AUTHENTICATOR',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SMS = 'SMS'
}

export type webAgent__MfaNumber = {
  backupNumber?: Maybe<Scalars['String']['output']>;
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isStopped: Scalars['Boolean']['output'];
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
  number: Scalars['String']['output'];
  stopRequestedAt?: Maybe<Scalars['String']['output']>;
};


export type webAgent__MfaNumbercodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaNumberlatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaNumberlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__MfaNumber_Type = BaseObject & Object & webAgent__MfaNumber & webAgent__MfaReceiver & {
  __typename: 'webAgent__MfaNumber_Type';
  backupNumber?: Maybe<Scalars['String']['output']>;
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isStopped: Scalars['Boolean']['output'];
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
  number: Scalars['String']['output'];
  stopRequestedAt?: Maybe<Scalars['String']['output']>;
};


export type webAgent__MfaNumber_TypecodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaNumber_TypelatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaNumber_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__MfaReceiver = {
  codeRequests?: Maybe<Array<webAgent__MfaCodeRequest>>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  latestCodeRequest?: Maybe<webAgent__MfaCodeRequest>;
  link?: Maybe<webAgent__Link>;
};


export type webAgent__MfaReceivercodeRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaReceiverlatestCodeRequestArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterMfaCodeRequest>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderMfaCodeRequest>;
};


export type webAgent__MfaReceiverlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};

export enum webAgent__MfaRequirement {
  OPTIONAL = 'OPTIONAL',
  REQUIRED = 'REQUIRED',
  UNKNOWN = 'UNKNOWN'
}

export enum webAgent__MfaSupportLevel {
  MULTIPLE = 'MULTIPLE',
  SINGLE = 'SINGLE',
  UNKNOWN = 'UNKNOWN',
  UNSUPPORTED = 'UNSUPPORTED'
}

export type webAgent__NavigatorSpecialistInstructions = {
  createdAt: Scalars['String']['output'];
  dataSlug?: Maybe<Scalars['String']['output']>;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type webAgent__NavigatorSpecialistInstructionsendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__NavigatorSpecialistInstructions_Type = BaseObject & Object & webAgent__NavigatorSpecialistInstructions & {
  __typename: 'webAgent__NavigatorSpecialistInstructions_Type';
  createdAt: Scalars['String']['output'];
  dataSlug?: Maybe<Scalars['String']['output']>;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  instructions: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type webAgent__NavigatorSpecialistInstructions_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__NavigatorSpecialistPageDiscovery = {
  createdAt: Scalars['String']['output'];
  dataSlug: Scalars['String']['output'];
  discovery?: Maybe<Scalars['JSON']['output']>;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type webAgent__NavigatorSpecialistPageDiscoveryendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__NavigatorSpecialistPageDiscovery_Type = BaseObject & Object & webAgent__NavigatorSpecialistPageDiscovery & {
  __typename: 'webAgent__NavigatorSpecialistPageDiscovery_Type';
  createdAt: Scalars['String']['output'];
  dataSlug: Scalars['String']['output'];
  discovery?: Maybe<Scalars['JSON']['output']>;
  endpoint: webAgent__Endpoint;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
};


export type webAgent__NavigatorSpecialistPageDiscovery_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderEndpoint>;
};

export type webAgent__NestedFilterAiDiscoveryCrawl = {
  categorization?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  endedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  notes?: InputMaybe<FilterString>;
  objectives?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  owner?: InputMaybe<NestedFilterUser>;
  status?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlStatus>;
  successfulExtractions?: InputMaybe<FilterInt64>;
  successfulObjectives?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  successfulObjectivesCount?: InputMaybe<FilterInt64>;
  successfulProbes?: InputMaybe<FilterInt64>;
  totalObjectivesCount?: InputMaybe<FilterInt64>;
};

export type webAgent__NestedFilterAiDiscoveryCrawlObjective = {
  agentLogArtifact?: InputMaybe<webAgent__NestedFilterWebAgentArtifact>;
  categorization?: InputMaybe<FilterString>;
  crawl?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  createdAt?: InputMaybe<FilterString>;
  data?: InputMaybe<FilterJSON>;
  dataSlug?: InputMaybe<FilterString>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  endedAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  failureCause?: InputMaybe<FilterString>;
  failureReason?: InputMaybe<FilterJSON>;
  id?: InputMaybe<FilterID>;
  name?: InputMaybe<FilterString>;
  notes?: InputMaybe<FilterString>;
  objectiveType?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlObjectiveType>;
  owner?: InputMaybe<NestedFilterUser>;
  parentObjective?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawlObjective>;
  status?: InputMaybe<FilterwebAgent__AiDiscoveryCrawlObjectiveResult>;
  traceArtifact?: InputMaybe<webAgent__NestedFilterPlaywrightTraceArtifact>;
};

export type webAgent__NestedFilterEndpoint = {
  cdpProvider?: InputMaybe<FilterwebAgent__CDPProvider>;
  currentSupportLevel?: InputMaybe<webAgent__NestedFilterEndpointSupportLevelHistory>;
  dashboardUrl?: InputMaybe<FilterString>;
  displayName?: InputMaybe<FilterString>;
  displayUrl?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  isAuthenticationRequired?: InputMaybe<FilterBoolean>;
  isPasswordRequired?: InputMaybe<FilterBoolean>;
  loginUrl?: InputMaybe<FilterString>;
  managedMfaConfiguration?: InputMaybe<webAgent__NestedFilterManagedMfaConfiguration>;
  organization?: InputMaybe<integration__NestedFilterOrganization>;
  portalGuideUrl?: InputMaybe<FilterString>;
  slug?: InputMaybe<FilterString>;
  supportLevelHistory?: InputMaybe<webAgent__NestedFilterEndpointSupportLevelHistory>;
  type?: InputMaybe<FilterwebAgent__EndpointType>;
};

export type webAgent__NestedFilterEndpointSupportLevelHistory = {
  createdAt?: InputMaybe<FilterString>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  supportLevel?: InputMaybe<FilterwebAgent__EndpointSupportLevel>;
  updatedBy?: InputMaybe<NestedFilterUser>;
};

export type webAgent__NestedFilterExecutionClassification = {
  cause?: InputMaybe<FilterString>;
  classifierVersion?: InputMaybe<FilterString>;
  confidence?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  evidence?: InputMaybe<FilterJSON>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  explanation?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
};

export type webAgent__NestedFilterLink = {
  active?: InputMaybe<FilterBoolean>;
  createdAt?: InputMaybe<FilterString>;
  deactivatedAt?: InputMaybe<FilterString>;
  deactivatedReason?: InputMaybe<FilterwebAgent__LinkDeactivatedReason>;
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  executions?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  hasManagedMfa?: InputMaybe<FilterBoolean>;
  id?: InputMaybe<FilterID>;
  lastSyncedAt?: InputMaybe<FilterString>;
  latestExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  mfaReceiver?: InputMaybe<webAgent__NestedFilterMfaReceiver>;
  owner?: InputMaybe<NestedFilterUser>;
  patientDOB?: InputMaybe<FilterString>;
  patientId?: InputMaybe<FilterString>;
  patientName?: InputMaybe<FilterString>;
  plans?: InputMaybe<plan__NestedFilterPlan>;
  providerProfiles?: InputMaybe<webAgent__NestedFilterLinkProviderProfile>;
  secrets?: InputMaybe<webAgent__NestedFilterLinkSecret>;
  userId?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterLinkProviderProfile = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  owner?: InputMaybe<NestedFilterUser>;
  profileId?: InputMaybe<FilterString>;
  updatedAt?: InputMaybe<FilterString>;
  vendor?: InputMaybe<FilterwebAgent__CDPProvider>;
};

export type webAgent__NestedFilterLinkSecret = {
  createdAt?: InputMaybe<FilterString>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  key?: InputMaybe<FilterString>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  owner?: InputMaybe<NestedFilterUser>;
  value?: InputMaybe<FilterJSON>;
};

export type webAgent__NestedFilterManagedMfaConfiguration = {
  endpoint?: InputMaybe<webAgent__NestedFilterEndpoint>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isSupported?: InputMaybe<FilterBoolean>;
};

export type webAgent__NestedFilterManagedMfaOutcome = {
  configurationEndedAt?: InputMaybe<FilterString>;
  configurationStartedAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  type?: InputMaybe<FilterwebAgent__ManagedMfaOutcomeType>;
};

export type webAgent__NestedFilterMfaCodeRequest = {
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isValid?: InputMaybe<FilterBoolean>;
  mfaReceiver?: InputMaybe<webAgent__NestedFilterMfaReceiver>;
  usedAt?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterMfaReceiver = {
  codeRequests?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  isActive?: InputMaybe<FilterBoolean>;
  latestCodeRequest?: InputMaybe<webAgent__NestedFilterMfaCodeRequest>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
};

export type webAgent__NestedFilterPlaywrightTraceArtifact = {
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterRecipeStartedEvent = {
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  recipeName?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterRobotStartedEvent = {
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  robotName?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterUserExitInsuranceLinkFeedback = {
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  feedback?: InputMaybe<FilterString>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__NestedFilterWebAgentArtifact = {
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  category?: InputMaybe<FilterString>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
  s3Bucket?: InputMaybe<FilterString>;
  s3Key?: InputMaybe<FilterString>;
};

export type webAgent__NestedFilterWebAgentExecution = {
  artifacts?: InputMaybe<webAgent__NestedFilterWebAgentExecutionArtifact>;
  audioTokenCount?: InputMaybe<FilterInt64>;
  browserbaseStealthStrategy?: InputMaybe<FilterwebAgent__BrowserbaseStealthStrategy>;
  cachedTokenCount?: InputMaybe<FilterInt64>;
  cdpInspectUrl?: InputMaybe<FilterString>;
  cdpProvider?: InputMaybe<FilterwebAgent__CDPProvider>;
  cdpProviderProfileId?: InputMaybe<FilterString>;
  cdpProviderSessionId?: InputMaybe<FilterString>;
  classification?: InputMaybe<webAgent__NestedFilterExecutionClassification>;
  createdAt?: InputMaybe<FilterString>;
  discoveryCrawls?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  documents?: InputMaybe<document__NestedFilterDocument>;
  endpoint?: InputMaybe<integration__NestedFilterBaseEndpoint>;
  endpointSupportLevel?: InputMaybe<FilterwebAgent__EndpointSupportLevel>;
  events?: InputMaybe<webAgent__NestedFilterWebAgentExecutionEvent>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  ingestions?: InputMaybe<ingestion__NestedFilterIngestion>;
  initiatedBy?: InputMaybe<NestedFilterUser>;
  initiatorRole?: InputMaybe<FilterParticipant>;
  inputTokenCount?: InputMaybe<FilterInt64>;
  isFailedProviderAttempt?: InputMaybe<FilterBoolean>;
  lastUserMfaMethods?: InputMaybe<FilterwebAgent__MfaMethod>;
  latestDiscoveryCrawl?: InputMaybe<webAgent__NestedFilterAiDiscoveryCrawl>;
  latestIngestion?: InputMaybe<ingestion__NestedFilterIngestion>;
  latestManagedMfaOutcome?: InputMaybe<webAgent__NestedFilterManagedMfaOutcome>;
  latestStatus?: InputMaybe<FilterwebAgent__WebExecutionStatus>;
  link?: InputMaybe<webAgent__NestedFilterLink>;
  managedMfaOutcomes?: InputMaybe<webAgent__NestedFilterManagedMfaOutcome>;
  millisBlockedOnUser?: InputMaybe<FilterInt>;
  origin?: InputMaybe<FilterwebAgent__ExecutionOrigin>;
  originalExecution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  otelTraceId?: InputMaybe<FilterString>;
  outputTokenCount?: InputMaybe<FilterInt64>;
  owner?: InputMaybe<NestedFilterUser>;
  proxyOrigin?: InputMaybe<FilterwebAgent__ExecutionProxyOrigin>;
  signInActivityTimedOutAt?: InputMaybe<FilterString>;
  signInClientTimedOutAt?: InputMaybe<FilterString>;
  signInErroredAt?: InputMaybe<FilterString>;
  signInPhaseAtFailure?: InputMaybe<FilterString>;
  signInRobotType?: InputMaybe<FilterwebAgent__SignInRobotType>;
  signInSucceededAt?: InputMaybe<FilterString>;
  type?: InputMaybe<FilterwebAgent__WebExecutionType>;
};

export type webAgent__NestedFilterWebAgentExecutionArtifact = {
  artifactType?: InputMaybe<FilterwebAgent__WebAgentExecutionArtifactType>;
  createdAt?: InputMaybe<FilterString>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__NestedFilterWebAgentExecutionEvent = {
  createdAt?: InputMaybe<FilterString>;
  eventType?: InputMaybe<FilterwebAgent__WebAgentExecutionEventType>;
  execution?: InputMaybe<webAgent__NestedFilterWebAgentExecution>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<FilterID>;
  owner?: InputMaybe<NestedFilterUser>;
};

export type webAgent__OrderAiConversationLogArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderAiDiscoveryCrawl = {
  categorization?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  endedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  notes?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  status?: InputMaybe<Ordering>;
  successfulExtractions?: InputMaybe<Ordering>;
  successfulObjectivesCount?: InputMaybe<Ordering>;
  successfulProbes?: InputMaybe<Ordering>;
  totalObjectivesCount?: InputMaybe<Ordering>;
};

export type webAgent__OrderAiDiscoveryCrawlObjective = {
  agentLogArtifact?: InputMaybe<webAgent__OrderWebAgentArtifact>;
  categorization?: InputMaybe<Ordering>;
  crawl?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
  createdAt?: InputMaybe<Ordering>;
  data?: InputMaybe<Ordering>;
  dataSlug?: InputMaybe<Ordering>;
  endedAt?: InputMaybe<Ordering>;
  failureCause?: InputMaybe<Ordering>;
  failureReason?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  notes?: InputMaybe<Ordering>;
  objectiveType?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  parentObjective?: InputMaybe<webAgent__OrderAiDiscoveryCrawlObjective>;
  status?: InputMaybe<Ordering>;
  traceArtifact?: InputMaybe<webAgent__OrderPlaywrightTraceArtifact>;
};

export type webAgent__OrderCrawlDataSummaryArtifact = {
  artifactType?: InputMaybe<Ordering>;
  crawlType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  summary?: InputMaybe<Ordering>;
};

export type webAgent__OrderEndpoint = {
  cdpProvider?: InputMaybe<Ordering>;
  currentSupportLevel?: InputMaybe<webAgent__OrderEndpointSupportLevelHistory>;
  dashboardUrl?: InputMaybe<Ordering>;
  displayName?: InputMaybe<Ordering>;
  displayUrl?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  isAuthenticationRequired?: InputMaybe<Ordering>;
  isPasswordRequired?: InputMaybe<Ordering>;
  loginUrl?: InputMaybe<Ordering>;
  managedMfaConfiguration?: InputMaybe<webAgent__OrderManagedMfaConfiguration>;
  organization?: InputMaybe<integration__OrderOrganization>;
  portalGuideUrl?: InputMaybe<Ordering>;
  slug?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderEndpointSupportLevelHistory = {
  createdAt?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  supportLevel?: InputMaybe<Ordering>;
  updatedBy?: InputMaybe<OrderUser>;
};

export type webAgent__OrderExecutionClassification = {
  cause?: InputMaybe<Ordering>;
  classifierVersion?: InputMaybe<Ordering>;
  confidence?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  evidence?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  explanation?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
};

export type webAgent__OrderInitialPageLoadSpan = {
  endedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderLink = {
  active?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  deactivatedAt?: InputMaybe<Ordering>;
  deactivatedReason?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  hasManagedMfa?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  lastSyncedAt?: InputMaybe<Ordering>;
  latestExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  latestIngestion?: InputMaybe<ingestion__OrderIngestion>;
  mfaReceiver?: InputMaybe<webAgent__OrderMfaReceiver>;
  owner?: InputMaybe<OrderUser>;
  patientDOB?: InputMaybe<Ordering>;
  patientId?: InputMaybe<Ordering>;
  patientName?: InputMaybe<Ordering>;
  userId?: InputMaybe<Ordering>;
};

export type webAgent__OrderLinkProviderProfile = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  link?: InputMaybe<webAgent__OrderLink>;
  owner?: InputMaybe<OrderUser>;
  profileId?: InputMaybe<Ordering>;
  updatedAt?: InputMaybe<Ordering>;
  vendor?: InputMaybe<Ordering>;
};

export type webAgent__OrderLinkSecret = {
  createdAt?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  key?: InputMaybe<Ordering>;
  link?: InputMaybe<webAgent__OrderLink>;
  owner?: InputMaybe<OrderUser>;
  value?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaConfiguration = {
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  isSupported?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaConfigured = {
  configurationEndedAt?: InputMaybe<Ordering>;
  configurationStartedAt?: InputMaybe<Ordering>;
  configuredMethod?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaFailed = {
  configurationEndedAt?: InputMaybe<Ordering>;
  configurationStartedAt?: InputMaybe<Ordering>;
  error?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaOutcome = {
  configurationEndedAt?: InputMaybe<Ordering>;
  configurationStartedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderManagedMfaRejected = {
  configurationEndedAt?: InputMaybe<Ordering>;
  configurationStartedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderMfaCodeRequest = {
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  isValid?: InputMaybe<Ordering>;
  mfaReceiver?: InputMaybe<webAgent__OrderMfaReceiver>;
  usedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderMfaConfigurationSummaryArtifact = {
  artifactType?: InputMaybe<Ordering>;
  authenticatorAppSupport?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  description?: InputMaybe<Ordering>;
  emailSupport?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  isMfaRequired?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  phoneSupport?: InputMaybe<Ordering>;
  smsSupport?: InputMaybe<Ordering>;
  success?: InputMaybe<Ordering>;
  wasPromptedForMfa?: InputMaybe<Ordering>;
};

export type webAgent__OrderMfaEmail = {
  email?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  latestCodeRequest?: InputMaybe<webAgent__OrderMfaCodeRequest>;
  link?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__OrderMfaNumber = {
  backupNumber?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  isStopped?: InputMaybe<Ordering>;
  latestCodeRequest?: InputMaybe<webAgent__OrderMfaCodeRequest>;
  link?: InputMaybe<webAgent__OrderLink>;
  number?: InputMaybe<Ordering>;
  stopRequestedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderMfaReceiver = {
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
  latestCodeRequest?: InputMaybe<webAgent__OrderMfaCodeRequest>;
  link?: InputMaybe<webAgent__OrderLink>;
};

export type webAgent__OrderNavigatorSpecialistInstructions = {
  createdAt?: InputMaybe<Ordering>;
  dataSlug?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  instructions?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
};

export type webAgent__OrderNavigatorSpecialistPageDiscovery = {
  createdAt?: InputMaybe<Ordering>;
  dataSlug?: InputMaybe<Ordering>;
  discovery?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<webAgent__OrderEndpoint>;
  id?: InputMaybe<Ordering>;
  isActive?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightHarArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightInterceptedResponsesArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightPageSourceArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  llmSummary?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightScreenshotArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderPlaywrightTraceArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderRecipeFinishedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  playwrightTraceS3bucket?: InputMaybe<Ordering>;
  playwrightTraceS3key?: InputMaybe<Ordering>;
  recipeDuration?: InputMaybe<Ordering>;
  result?: InputMaybe<Ordering>;
  screenshotS3bucket?: InputMaybe<Ordering>;
  screenshotS3key?: InputMaybe<Ordering>;
  startEvent?: InputMaybe<webAgent__OrderRecipeStartedEvent>;
};

export type webAgent__OrderRecipeStartedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  recipeName?: InputMaybe<Ordering>;
};

export type webAgent__OrderRequestResponseSpan = {
  endedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  requestType?: InputMaybe<Ordering>;
  responseType?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderRobotFinishedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  result?: InputMaybe<Ordering>;
  robotDuration?: InputMaybe<Ordering>;
  startEvent?: InputMaybe<webAgent__OrderRobotStartedEvent>;
};

export type webAgent__OrderRobotStartedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  robotName?: InputMaybe<Ordering>;
};

export type webAgent__OrderSignInRobotResultArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  recipeResults?: InputMaybe<Ordering>;
  result?: InputMaybe<Ordering>;
  success?: InputMaybe<Ordering>;
};

export type webAgent__OrderSpan = {
  endedAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  name?: InputMaybe<Ordering>;
  startedAt?: InputMaybe<Ordering>;
};

export type webAgent__OrderUrlOpenedEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  url?: InputMaybe<Ordering>;
};

export type webAgent__OrderUserExitInsuranceLinkFeedback = {
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  feedback?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type webAgent__OrderWebAgentArtifact = {
  artifactType?: InputMaybe<Ordering>;
  category?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  s3Bucket?: InputMaybe<Ordering>;
  s3Key?: InputMaybe<Ordering>;
};

export type webAgent__OrderWebAgentExecution = {
  audioTokenCount?: InputMaybe<Ordering>;
  browserbaseStealthStrategy?: InputMaybe<Ordering>;
  cachedTokenCount?: InputMaybe<Ordering>;
  cdpInspectUrl?: InputMaybe<Ordering>;
  cdpProvider?: InputMaybe<Ordering>;
  cdpProviderProfileId?: InputMaybe<Ordering>;
  cdpProviderSessionId?: InputMaybe<Ordering>;
  classification?: InputMaybe<webAgent__OrderExecutionClassification>;
  createdAt?: InputMaybe<Ordering>;
  endpoint?: InputMaybe<integration__OrderBaseEndpoint>;
  endpointSupportLevel?: InputMaybe<Ordering>;
  id?: InputMaybe<Ordering>;
  initiatedBy?: InputMaybe<OrderUser>;
  initiatorRole?: InputMaybe<Ordering>;
  inputTokenCount?: InputMaybe<Ordering>;
  isFailedProviderAttempt?: InputMaybe<Ordering>;
  latestIngestion?: InputMaybe<ingestion__OrderIngestion>;
  latestManagedMfaOutcome?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
  latestStatus?: InputMaybe<Ordering>;
  link?: InputMaybe<webAgent__OrderLink>;
  millisBlockedOnUser?: InputMaybe<Ordering>;
  origin?: InputMaybe<Ordering>;
  originalExecution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  otelTraceId?: InputMaybe<Ordering>;
  outputTokenCount?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
  proxyOrigin?: InputMaybe<Ordering>;
  signInActivityTimedOutAt?: InputMaybe<Ordering>;
  signInClientTimedOutAt?: InputMaybe<Ordering>;
  signInErroredAt?: InputMaybe<Ordering>;
  signInPhaseAtFailure?: InputMaybe<Ordering>;
  signInRobotType?: InputMaybe<Ordering>;
  signInSucceededAt?: InputMaybe<Ordering>;
  type?: InputMaybe<Ordering>;
};

export type webAgent__OrderWebAgentExecutionArtifact = {
  artifactType?: InputMaybe<Ordering>;
  createdAt?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type webAgent__OrderWebAgentExecutionEvent = {
  createdAt?: InputMaybe<Ordering>;
  eventType?: InputMaybe<Ordering>;
  execution?: InputMaybe<webAgent__OrderWebAgentExecution>;
  id?: InputMaybe<Ordering>;
  owner?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightHarArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightHarArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightHarArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightHarArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightHarArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightHarArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightHarArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightHarArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightInterceptedResponsesArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightInterceptedResponsesArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightInterceptedResponsesArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightInterceptedResponsesArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightInterceptedResponsesArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightInterceptedResponsesArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightInterceptedResponsesArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightInterceptedResponsesArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightPageSourceArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  llmSummary?: Maybe<Scalars['String']['output']>;
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightPageSourceArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightPageSourceArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightPageSourceArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightPageSourceArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightPageSourceArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  llmSummary?: Maybe<Scalars['String']['output']>;
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightPageSourceArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightPageSourceArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightScreenshotArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightScreenshotArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightScreenshotArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightScreenshotArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightScreenshotArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightScreenshotArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightScreenshotArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightScreenshotArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightTraceArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightTraceArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightTraceArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__PlaywrightTraceArtifact_Type = BaseObject & Object & Owned & webAgent__PlaywrightTraceArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__PlaywrightTraceArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__PlaywrightTraceArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__PlaywrightTraceArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__ProxyDevice {
  COMMON = 'COMMON',
  MOBILE = 'MOBILE',
  TV = 'TV'
}

export enum webAgent__ProxyOrigin {
  BUILTIN = 'BUILTIN',
  DECODO = 'DECODO',
  DIRECT = 'DIRECT',
  MASSIVE = 'MASSIVE',
  NIMBLE = 'NIMBLE',
  OXYLABS = 'OXYLABS'
}

export type webAgent__RecipeFinishedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  playwrightTraceS3bucket?: Maybe<Scalars['String']['output']>;
  playwrightTraceS3key?: Maybe<Scalars['String']['output']>;
  recipeDuration: Scalars['String']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  screenshotS3bucket?: Maybe<Scalars['String']['output']>;
  screenshotS3key?: Maybe<Scalars['String']['output']>;
  startEvent: webAgent__RecipeStartedEvent;
};


export type webAgent__RecipeFinishedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RecipeFinishedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__RecipeFinishedEventstartEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRecipeStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRecipeStartedEvent>;
};

export type webAgent__RecipeFinishedEvent_Type = BaseObject & Object & Owned & webAgent__RecipeFinishedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__RecipeFinishedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  playwrightTraceS3bucket?: Maybe<Scalars['String']['output']>;
  playwrightTraceS3key?: Maybe<Scalars['String']['output']>;
  recipeDuration: Scalars['String']['output'];
  result?: Maybe<Scalars['JSON']['output']>;
  screenshotS3bucket?: Maybe<Scalars['String']['output']>;
  screenshotS3key?: Maybe<Scalars['String']['output']>;
  startEvent: webAgent__RecipeStartedEvent;
};


export type webAgent__RecipeFinishedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RecipeFinishedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__RecipeFinishedEvent_TypestartEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRecipeStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRecipeStartedEvent>;
};

export type webAgent__RecipeStartedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  recipeName: Scalars['String']['output'];
};


export type webAgent__RecipeStartedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RecipeStartedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__RecipeStartedEvent_Type = BaseObject & Object & Owned & webAgent__RecipeStartedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__RecipeStartedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  recipeName: Scalars['String']['output'];
};


export type webAgent__RecipeStartedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RecipeStartedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__RequestResponseSpan = {
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  responseType: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__RequestResponseSpanexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__RequestResponseSpan_Type = BaseObject & Object & webAgent__RequestResponseSpan & webAgent__Span & {
  __typename: 'webAgent__RequestResponseSpan_Type';
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  requestType: Scalars['String']['output'];
  responseType: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__RequestResponseSpan_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export type webAgent__RobotFinishedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  result?: Maybe<Scalars['JSON']['output']>;
  robotDuration: Scalars['String']['output'];
  startEvent: webAgent__RobotStartedEvent;
};


export type webAgent__RobotFinishedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RobotFinishedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__RobotFinishedEventstartEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRobotStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRobotStartedEvent>;
};

export type webAgent__RobotFinishedEvent_Type = BaseObject & Object & Owned & webAgent__RobotFinishedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__RobotFinishedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  result?: Maybe<Scalars['JSON']['output']>;
  robotDuration: Scalars['String']['output'];
  startEvent: webAgent__RobotStartedEvent;
};


export type webAgent__RobotFinishedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RobotFinishedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__RobotFinishedEvent_TypestartEventArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterRobotStartedEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderRobotStartedEvent>;
};

export type webAgent__RobotStartedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  robotName: Scalars['String']['output'];
};


export type webAgent__RobotStartedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RobotStartedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__RobotStartedEvent_Type = BaseObject & Object & Owned & webAgent__RobotStartedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__RobotStartedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  robotName: Scalars['String']['output'];
};


export type webAgent__RobotStartedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__RobotStartedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__SignInRobotResultArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  recipeResults?: Maybe<Scalars['JSON']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};


export type webAgent__SignInRobotResultArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__SignInRobotResultArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__SignInRobotResultArtifact_Type = BaseObject & Object & Owned & webAgent__SignInRobotResultArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__SignInRobotResultArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  recipeResults?: Maybe<Scalars['JSON']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};


export type webAgent__SignInRobotResultArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__SignInRobotResultArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__SignInRobotType {
  AI = 'AI',
  ASTRA = 'ASTRA',
  CLASSIC = 'CLASSIC',
  MOCK = 'MOCK',
  NEOCLASSICAL = 'NEOCLASSICAL',
  NO_AUTH = 'NO_AUTH'
}

export type webAgent__Span = {
  endedAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startedAt: Scalars['String']['output'];
};


export type webAgent__SpanexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};

export enum webAgent__StickinessMode {
  ROTATING = 'ROTATING',
  STICKY_ESTABLISH = 'STICKY_ESTABLISH',
  STICKY_RESUME = 'STICKY_RESUME'
}

export type webAgent__UrlOpenedEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  url: Scalars['String']['output'];
};


export type webAgent__UrlOpenedEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__UrlOpenedEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__UrlOpenedEvent_Type = BaseObject & Object & Owned & webAgent__UrlOpenedEvent & webAgent__WebAgentExecutionEvent & {
  __typename: 'webAgent__UrlOpenedEvent_Type';
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  url: Scalars['String']['output'];
};


export type webAgent__UrlOpenedEvent_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__UrlOpenedEvent_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__UserExitInsuranceLinkFeedback = {
  createdAt: Scalars['String']['output'];
  execution?: Maybe<webAgent__WebAgentExecution>;
  feedback: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
};


export type webAgent__UserExitInsuranceLinkFeedbackexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__UserExitInsuranceLinkFeedbackownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__UserExitInsuranceLinkFeedback_Type = BaseObject & Object & Owned & webAgent__UserExitInsuranceLinkFeedback & {
  __typename: 'webAgent__UserExitInsuranceLinkFeedback_Type';
  createdAt: Scalars['String']['output'];
  execution?: Maybe<webAgent__WebAgentExecution>;
  feedback: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner: User;
};


export type webAgent__UserExitInsuranceLinkFeedback_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__UserExitInsuranceLinkFeedback_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__WebAgentArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__WebAgentArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__WebAgentArtifact_Type = BaseObject & Object & Owned & webAgent__WebAgentArtifact & webAgent__WebAgentExecutionArtifact & {
  __typename: 'webAgent__WebAgentArtifact_Type';
  artifactType: webAgent__WebAgentExecutionArtifactType;
  category: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
};


export type webAgent__WebAgentArtifact_TypeexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentArtifact_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__WebAgentExecution = {
  artifacts?: Maybe<Array<webAgent__WebAgentExecutionArtifact>>;
  audioTokenCount?: Maybe<Scalars['Int64']['output']>;
  browserbaseStealthStrategy?: Maybe<webAgent__BrowserbaseStealthStrategy>;
  cachedTokenCount?: Maybe<Scalars['Int64']['output']>;
  cdpInspectUrl?: Maybe<Scalars['String']['output']>;
  cdpProvider?: Maybe<webAgent__CDPProvider>;
  cdpProviderProfileId?: Maybe<Scalars['String']['output']>;
  cdpProviderSessionId?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<webAgent__ExecutionClassification>;
  /**
   * The robot crawl's progress after a `sign_in@1` sign-in. Null for a legacy
   * attempt, or while the attempt runs until its crawl starts. Once the attempt
   * closes it reads as ended, whether or not a crawl ran. Owner or admin only.
   */
  crawlProgress?: Maybe<CrawlProgress>;
  createdAt: Scalars['String']['output'];
  discoveryCrawls?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  documents?: Maybe<Array<document__Document>>;
  endpoint?: Maybe<integration__BaseEndpoint>;
  endpointSupportLevel?: Maybe<webAgent__EndpointSupportLevel>;
  events?: Maybe<Array<webAgent__WebAgentExecutionEvent>>;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  initiatedBy?: Maybe<User>;
  initiatorRole?: Maybe<Participant>;
  inputTokenCount?: Maybe<Scalars['Int64']['output']>;
  isFailedProviderAttempt: Scalars['Boolean']['output'];
  lastUserMfaMethods?: Maybe<Array<webAgent__MfaMethod>>;
  latestDiscoveryCrawl?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  latestManagedMfaOutcome?: Maybe<webAgent__ManagedMfaOutcome>;
  latestStatus?: Maybe<webAgent__WebExecutionStatus>;
  link?: Maybe<webAgent__Link>;
  managedMfaOutcomes?: Maybe<Array<webAgent__ManagedMfaOutcome>>;
  millisBlockedOnUser?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<webAgent__ExecutionOrigin>;
  originalExecution?: Maybe<webAgent__WebAgentExecution>;
  otelTraceId?: Maybe<Scalars['String']['output']>;
  outputTokenCount?: Maybe<Scalars['Int64']['output']>;
  owner: User;
  proxyOrigin?: Maybe<webAgent__ExecutionProxyOrigin>;
  signInActivityTimedOutAt?: Maybe<Scalars['String']['output']>;
  signInClientTimedOutAt?: Maybe<Scalars['String']['output']>;
  signInErroredAt?: Maybe<Scalars['String']['output']>;
  signInPhaseAtFailure?: Maybe<Scalars['String']['output']>;
  signInRobotType?: Maybe<webAgent__SignInRobotType>;
  signInSucceededAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<webAgent__WebExecutionType>;
  unrecoverableErrorReports?: Maybe<Array<Scalars['JSON']['output']>>;
};


export type webAgent__WebAgentExecutionartifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionArtifact>;
};


export type webAgent__WebAgentExecutionclassificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterExecutionClassification>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderExecutionClassification>;
};


export type webAgent__WebAgentExecutiondiscoveryCrawlsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__WebAgentExecutiondocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type webAgent__WebAgentExecutionendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type webAgent__WebAgentExecutioneventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionEvent>;
};


export type webAgent__WebAgentExecutioningestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__WebAgentExecutioninitiatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__WebAgentExecutionlatestDiscoveryCrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__WebAgentExecutionlatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__WebAgentExecutionlatestManagedMfaOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type webAgent__WebAgentExecutionlinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__WebAgentExecutionmanagedMfaOutcomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type webAgent__WebAgentExecutionoriginalExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentExecutionownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export type webAgent__WebAgentExecutionArtifact = {
  artifactType: webAgent__WebAgentExecutionArtifactType;
  createdAt: Scalars['String']['output'];
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
};


export type webAgent__WebAgentExecutionArtifactexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentExecutionArtifactownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__WebAgentExecutionArtifactType {
  AI_CONVERSATION_LOG = 'AI_CONVERSATION_LOG',
  CRAWL_DATA_SUMMARY = 'CRAWL_DATA_SUMMARY',
  MFA_CONFIGURATION_SUMMARY = 'MFA_CONFIGURATION_SUMMARY',
  PLAYWRIGHT_HAR = 'PLAYWRIGHT_HAR',
  PLAYWRIGHT_INTERCEPTED_RESPONSES = 'PLAYWRIGHT_INTERCEPTED_RESPONSES',
  PLAYWRIGHT_PAGE_SOURCE = 'PLAYWRIGHT_PAGE_SOURCE',
  PLAYWRIGHT_SCREENSHOT = 'PLAYWRIGHT_SCREENSHOT',
  PLAYWRIGHT_TRACE = 'PLAYWRIGHT_TRACE',
  SIGN_IN_ROBOT_RESULT = 'SIGN_IN_ROBOT_RESULT',
  WEB_AGENT_ARTIFACT = 'WEB_AGENT_ARTIFACT'
}

export type webAgent__WebAgentExecutionEvent = {
  createdAt: Scalars['String']['output'];
  eventType: webAgent__WebAgentExecutionEventType;
  execution: webAgent__WebAgentExecution;
  id: Scalars['ID']['output'];
  owner: User;
};


export type webAgent__WebAgentExecutionEventexecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentExecutionEventownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__WebAgentExecutionEventType {
  RECIPE_FINISHED = 'RECIPE_FINISHED',
  RECIPE_STARTED = 'RECIPE_STARTED',
  ROBOT_FINISHED = 'ROBOT_FINISHED',
  ROBOT_STARTED = 'ROBOT_STARTED',
  URL_OPENED = 'URL_OPENED'
}

export type webAgent__WebAgentExecution_Type = BaseObject & Object & Owned & webAgent__WebAgentExecution & {
  __typename: 'webAgent__WebAgentExecution_Type';
  artifacts?: Maybe<Array<webAgent__WebAgentExecutionArtifact>>;
  audioTokenCount?: Maybe<Scalars['Int64']['output']>;
  browserbaseStealthStrategy?: Maybe<webAgent__BrowserbaseStealthStrategy>;
  cachedTokenCount?: Maybe<Scalars['Int64']['output']>;
  cdpInspectUrl?: Maybe<Scalars['String']['output']>;
  cdpProvider?: Maybe<webAgent__CDPProvider>;
  cdpProviderProfileId?: Maybe<Scalars['String']['output']>;
  cdpProviderSessionId?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<webAgent__ExecutionClassification>;
  crawlProgress?: Maybe<CrawlProgress>;
  createdAt: Scalars['String']['output'];
  discoveryCrawls?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  documents?: Maybe<Array<document__Document>>;
  endpoint?: Maybe<integration__BaseEndpoint>;
  endpointSupportLevel?: Maybe<webAgent__EndpointSupportLevel>;
  events?: Maybe<Array<webAgent__WebAgentExecutionEvent>>;
  id: Scalars['ID']['output'];
  ingestions?: Maybe<Array<ingestion__Ingestion>>;
  initiatedBy?: Maybe<User>;
  initiatorRole?: Maybe<Participant>;
  inputTokenCount?: Maybe<Scalars['Int64']['output']>;
  isFailedProviderAttempt: Scalars['Boolean']['output'];
  lastUserMfaMethods?: Maybe<Array<webAgent__MfaMethod>>;
  latestDiscoveryCrawl?: Maybe<Array<webAgent__AiDiscoveryCrawl>>;
  latestIngestion?: Maybe<ingestion__Ingestion>;
  latestManagedMfaOutcome?: Maybe<webAgent__ManagedMfaOutcome>;
  latestStatus?: Maybe<webAgent__WebExecutionStatus>;
  link?: Maybe<webAgent__Link>;
  managedMfaOutcomes?: Maybe<Array<webAgent__ManagedMfaOutcome>>;
  millisBlockedOnUser?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<webAgent__ExecutionOrigin>;
  originalExecution?: Maybe<webAgent__WebAgentExecution>;
  otelTraceId?: Maybe<Scalars['String']['output']>;
  outputTokenCount?: Maybe<Scalars['Int64']['output']>;
  owner: User;
  proxyOrigin?: Maybe<webAgent__ExecutionProxyOrigin>;
  signInActivityTimedOutAt?: Maybe<Scalars['String']['output']>;
  signInClientTimedOutAt?: Maybe<Scalars['String']['output']>;
  signInErroredAt?: Maybe<Scalars['String']['output']>;
  signInPhaseAtFailure?: Maybe<Scalars['String']['output']>;
  signInRobotType?: Maybe<webAgent__SignInRobotType>;
  signInSucceededAt?: Maybe<Scalars['String']['output']>;
  type?: Maybe<webAgent__WebExecutionType>;
  unrecoverableErrorReports?: Maybe<Array<Scalars['JSON']['output']>>;
};


export type webAgent__WebAgentExecution_TypeartifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionArtifact>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionArtifact>;
};


export type webAgent__WebAgentExecution_TypeclassificationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterExecutionClassification>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderExecutionClassification>;
};


export type webAgent__WebAgentExecution_TypediscoveryCrawlsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__WebAgentExecution_TypedocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<document__FilterDocument>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<document__OrderDocument>;
};


export type webAgent__WebAgentExecution_TypeendpointArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<integration__FilterBaseEndpoint>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<integration__OrderBaseEndpoint>;
};


export type webAgent__WebAgentExecution_TypeeventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecutionEvent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecutionEvent>;
};


export type webAgent__WebAgentExecution_TypeingestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__WebAgentExecution_TypeinitiatedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};


export type webAgent__WebAgentExecution_TypelatestDiscoveryCrawlArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterAiDiscoveryCrawl>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderAiDiscoveryCrawl>;
};


export type webAgent__WebAgentExecution_TypelatestIngestionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ingestion__FilterIngestion>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<ingestion__OrderIngestion>;
};


export type webAgent__WebAgentExecution_TypelatestManagedMfaOutcomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type webAgent__WebAgentExecution_TypelinkArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterLink>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderLink>;
};


export type webAgent__WebAgentExecution_TypemanagedMfaOutcomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterManagedMfaOutcome>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderManagedMfaOutcome>;
};


export type webAgent__WebAgentExecution_TypeoriginalExecutionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<webAgent__FilterWebAgentExecution>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<webAgent__OrderWebAgentExecution>;
};


export type webAgent__WebAgentExecution_TypeownerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<FilterUser>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<OrderUser>;
};

export enum webAgent__WebExecutionStatus {
  ERRORED = 'ERRORED',
  FAILED_LOGIN_MAX_REACHED = 'FAILED_LOGIN_MAX_REACHED',
  FILLING_CREDENTIALS = 'FILLING_CREDENTIALS',
  FILLING_MFA_CODE = 'FILLING_MFA_CODE',
  FILLING_SECURITY_ANSWER = 'FILLING_SECURITY_ANSWER',
  LOADING_LOGIN_URL = 'LOADING_LOGIN_URL',
  LOGGED_IN = 'LOGGED_IN',
  PROMPTING_CREDENTIALS = 'PROMPTING_CREDENTIALS',
  PROMPTING_MFA_CODE = 'PROMPTING_MFA_CODE',
  PROMPTING_MFA_METHOD = 'PROMPTING_MFA_METHOD',
  PROMPTING_SECURITY_ANSWER = 'PROMPTING_SECURITY_ANSWER',
  REPROMPTING_CREDENTIALS = 'REPROMPTING_CREDENTIALS',
  REPROMPTING_MFA_CODE = 'REPROMPTING_MFA_CODE',
  REPROMPTING_SECURITY_ANSWER = 'REPROMPTING_SECURITY_ANSWER',
  SELECTING_MFA_METHOD = 'SELECTING_MFA_METHOD',
  SUPERSEDED = 'SUPERSEDED',
  USER_TIMEOUT = 'USER_TIMEOUT'
}

export enum webAgent__WebExecutionType {
  HEALTH_CHECK = 'HEALTH_CHECK',
  MANAGED_SIGN_IN_AND_CRAWL = 'MANAGED_SIGN_IN_AND_CRAWL',
  RPA_DEBUG = 'RPA_DEBUG',
  SHADOW_SIGN_IN = 'SHADOW_SIGN_IN',
  SIGN_IN_AND_CRAWL = 'SIGN_IN_AND_CRAWL',
  SIGN_IN_AND_LINK = 'SIGN_IN_AND_LINK',
  SIGN_IN_AND_RESTORE_MFA = 'SIGN_IN_AND_RESTORE_MFA'
}

export type ApiE2eMeQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiE2eMeQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, isAdmin: boolean } | null };

export type ApiE2eOpenNewIssueFromPreviewOutreachMutationVariables = Exact<{
  input: OpenNewIssueFromPreviewInput;
}>;


export type ApiE2eOpenNewIssueFromPreviewOutreachMutation = { __typename: 'Mutation', openNewIssueFromPreview?: { __typename: 'issue__Issue_Type', id: string } | null };

export type ApiE2eCreateTemplateReleaseRequestForOutreachMutationVariables = Exact<{
  input: CreateIssueTemplateReleaseRequestedEventInput;
}>;


export type ApiE2eCreateTemplateReleaseRequestForOutreachMutation = { __typename: 'Mutation', createIssueTemplateReleaseRequestedEvent?: { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | null };

export type ApiE2eOpenNewIssueFromPreviewCaseMutationVariables = Exact<{
  input: OpenNewIssueFromPreviewInput;
}>;


export type ApiE2eOpenNewIssueFromPreviewCaseMutation = { __typename: 'Mutation', openNewIssueFromPreview?: { __typename: 'issue__Issue_Type', id: string, owner: { __typename: 'User_Type', id: string } } | null };

export type ApiE2eUpdateIssueMutationVariables = Exact<{
  input?: InputMaybe<UpdateIssueInput>;
}>;


export type ApiE2eUpdateIssueMutation = { __typename: 'Mutation', updateIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type ApiE2eIssueUnseenStateQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type ApiE2eIssueUnseenStateQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, firstUnseenEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string } | null }> | null };

export type ApiE2eOpenNewIssueFromPreviewEscalationMutationVariables = Exact<{
  input: OpenNewIssueFromPreviewInput;
}>;


export type ApiE2eOpenNewIssueFromPreviewEscalationMutation = { __typename: 'Mutation', openNewIssueFromPreview?: { __typename: 'issue__Issue_Type', id: string } | null };

export type ApiE2eCreateIssueChatEventMutationVariables = Exact<{
  input: CreateIssueChatEventInput;
}>;


export type ApiE2eCreateIssueChatEventMutation = { __typename: 'Mutation', createIssueChatEvent?: { __typename: 'issue__ChatEvent_Type', id: string } | null };

export type ApiE2eHeadlessLoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  passkey: Scalars['String']['input'];
}>;


export type ApiE2eHeadlessLoginMutation = { __typename: 'Mutation', headlessLogin: { __typename: 'AuthenticateError', errorType: AuthenticateResultErrorType } | { __typename: 'AuthenticateSuccess', email?: string | null, user: { __typename: 'AuthUser', id: string, isAdmin: boolean } } };

export type ApiE2eAuthWarmupQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiE2eAuthWarmupQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string } | null };

export type ApiE2eCreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;


export type ApiE2eCreateDocumentMutation = { __typename: 'Mutation', createDocument: { __typename: 'CreateDocumentResult', url: string, s3Key: string, document: { __typename: 'document__Document_Type', id: string } } };

export type ApiE2eFinalizeDocumentMutationVariables = Exact<{
  input: FinalizeDocumentInput;
}>;


export type ApiE2eFinalizeDocumentMutation = { __typename: 'Mutation', finalizeDocument: { __typename: 'FinalizeDocumentResult', document: { __typename: 'document__Document_Type', id: string } } };

export type ApiE2eOpenNewIssueFromPreviewMutationVariables = Exact<{
  input: OpenNewIssueFromPreviewInput;
}>;


export type ApiE2eOpenNewIssueFromPreviewMutation = { __typename: 'Mutation', openNewIssueFromPreview?: { __typename: 'issue__Issue_Type', id: string, title?: string | null, caseType?: string | null, owner: { __typename: 'User_Type', id: string } } | null };

export type ApiE2eProcessDocumentForAnalysisMutationVariables = Exact<{
  input: ProcessDocumentForAnalysisInput;
}>;


export type ApiE2eProcessDocumentForAnalysisMutation = { __typename: 'Mutation', processDocumentForAnalysis: { __typename: 'ProcessDocumentForAnalysisResult', event?: { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, status: issue__DocumentAnalysisStatus } | null } };

export type ApiE2eCaseTimelineQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type ApiE2eCaseTimelineQuery = { __typename: 'Query', issue__Event?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__BillDisputeEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__ChatEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__OutreachEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__PhoneCallEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actionRequired: boolean }> | null };

export type ApiE2eCreateTemplateReleaseRequestMutationVariables = Exact<{
  input: CreateIssueTemplateReleaseRequestedEventInput;
}>;


export type ApiE2eCreateTemplateReleaseRequestMutation = { __typename: 'Mutation', createIssueTemplateReleaseRequestedEvent?: { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | null };

export type ApiE2eOpenNewIssueFromPreviewHipaaMutationVariables = Exact<{
  input: OpenNewIssueFromPreviewInput;
}>;


export type ApiE2eOpenNewIssueFromPreviewHipaaMutation = { __typename: 'Mutation', openNewIssueFromPreview?: { __typename: 'issue__Issue_Type', id: string } | null };

export type ApiE2eCreateSignatureDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;


export type ApiE2eCreateSignatureDocumentMutation = { __typename: 'Mutation', createDocument: { __typename: 'CreateDocumentResult', url: string, document: { __typename: 'document__Document_Type', id: string } } };

export type ApiE2eFinalizeSignatureDocumentMutationVariables = Exact<{
  input: FinalizeDocumentInput;
}>;


export type ApiE2eFinalizeSignatureDocumentMutation = { __typename: 'Mutation', finalizeDocument: { __typename: 'FinalizeDocumentResult', document: { __typename: 'document__Document_Type', id: string } } };

export type ApiE2eSignAndSaveTemplateMutationVariables = Exact<{
  input: SignAndSaveTemplateInput;
}>;


export type ApiE2eSignAndSaveTemplateMutation = { __typename: 'Mutation', signAndSaveTemplate: { __typename: 'SignAndSaveTemplateResult', success: boolean } };

export type ApiE2eOpenNewIssueFromPreviewPaymentMutationVariables = Exact<{
  input: OpenNewIssueFromPreviewInput;
}>;


export type ApiE2eOpenNewIssueFromPreviewPaymentMutation = { __typename: 'Mutation', openNewIssueFromPreview?: { __typename: 'issue__Issue_Type', id: string } | null };

export type ApiE2eCreatePaymentPreferencesRequestMutationVariables = Exact<{
  input: CreatePaymentPreferencesRequestedEventInput;
}>;


export type ApiE2eCreatePaymentPreferencesRequestMutation = { __typename: 'Mutation', createPaymentPreferencesRequestedEvent?: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | null };

export type ApiE2eConfirmPaymentPreferencesMutationVariables = Exact<{
  input: ConfirmPaymentPreferencesInput;
}>;


export type ApiE2eConfirmPaymentPreferencesMutation = { __typename: 'Mutation', confirmPaymentPreferences?: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | null };

export type RecordCalibrationDeltasMutationVariables = Exact<{
  deltas: Array<CalibrationDeltaInput>;
}>;


export type RecordCalibrationDeltasMutation = { __typename: 'Mutation', recordCalibrationDeltas: { __typename: 'CalibrationDeltaAck', accepted: number } };

export type CaseAdvisorChatMutationVariables = Exact<{
  input: CaseAdvisorChatInput;
}>;


export type CaseAdvisorChatMutation = { __typename: 'Mutation', caseAdvisorChat: { __typename: 'CaseAdvisorChatResult', content: string, inputTokens: number, outputTokens: number, toolCalls: Array<{ __typename: 'CaseAdvisorToolCall', toolName: string, uri: string, label: string }> } };

export type GenerateCaseReplyDraftMutationVariables = Exact<{
  input: GenerateCaseReplyDraftInput;
}>;


export type GenerateCaseReplyDraftMutation = { __typename: 'Mutation', generateCaseReplyDraft: { __typename: 'CaseReplyDraftResult', draft: string, rationale?: string | null, sourcesUsed?: Array<string> | null, confidence?: number | null, inputTokens?: number | null, outputTokens?: number | null } };

export type GenerateCaseRecommendationMutationVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type GenerateCaseRecommendationMutation = { __typename: 'Mutation', generateCaseRecommendation: boolean };

export type GetCaseRecommendationQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type GetCaseRecommendationQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, caseRecommendation?: string | null, caseRecommendationGeneratedAt?: string | null }> | null };

export type createRecommendedTaskMutationVariables = Exact<{
  input: CreateIssueTaskInput;
}>;


export type createRecommendedTaskMutation = { __typename: 'Mutation', createIssueTask?: { __typename: 'taskManagement__DataQualityFlagTask_Type', id: string } | { __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type', id: string } | { __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type', id: string } | { __typename: 'taskManagement__GeneralIssueTask_Type', id: string } | { __typename: 'taskManagement__IssueResearchTask_Type', id: string } | { __typename: 'taskManagement__IssueTask_Type', id: string } | { __typename: 'taskManagement__IssueUserMessagingTask_Type', id: string } | { __typename: 'taskManagement__PhoneCallIssueTask_Type', id: string } | { __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type', id: string } | { __typename: 'taskManagement__RetryChargeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewEscalatedCaseTask_Type', id: string } | { __typename: 'taskManagement__ReviewFindingTask_Type', id: string } | { __typename: 'taskManagement__ReviewIssueChatTask_Type', id: string } | { __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewSuggestionTask_Type', id: string } | { __typename: 'taskManagement__SendFormIssueTask_Type', id: string } | { __typename: 'taskManagement__Task_Type', id: string } | null };

export type SubmitRecommendationFeedbackMutationVariables = Exact<{
  input: RecommendationFeedbackInput;
}>;


export type SubmitRecommendationFeedbackMutation = { __typename: 'Mutation', submitRecommendationFeedback: boolean };

export type InternalCaseCardOnFileQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type InternalCaseCardOnFileQuery = { __typename: 'Query', caseCardOnFile: { __typename: 'CaseCardOnFile', ready: boolean, brand?: string | null, last4?: string | null } };

export type RetoolQueryIssueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetoolQueryIssueQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, caseRef: string, title?: string | null, caseType?: string | null, completedPostEscalationActions: Array<issue__PostEscalationActionType>, pendingPostEscalationActions: Array<issue__PostEscalationActionType>, dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, estimatedDollarAmountSaved?: string | null, openedAt: string, closedAt?: string | null, lastSeenAt?: string | null, followUpDate?: string | null, nextSteps?: string | null, caseManagementType?: string | null, caseManagementClosureReason?: string | null, caseManagementRelatedIssueCount?: number | null, coverageType?: string | null, reengagementReason?: issue__ReengagementReason | null, providerName?: string | null, labels?: Array<string> | null, priorityOverride?: issue__PriorityOverride | null, additionalDetails?: string | null, nateraIntake?: string | null, providerDetail?: { __typename: 'provider__Provider_Type', id: string, displayName: string, kind: provider__ProviderKind, contactPoints?: Array<{ __typename: 'provider__ContactPoint_Type', kind: provider__ContactKind, purpose: provider__ContactPurpose, value: string, verified: boolean }> | null } | null, person?: { __typename: 'Person_Type', familyName?: string | null, givenNames?: Array<string> | null, dateOfBirth: string } | null, owner: { __typename: 'User_Type', id: string, primaryPerson?: { __typename: 'Person_Type', givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, phoneNumber?: string | null, addresses?: Array<{ __typename: 'person__Address_Type', street: string, city: string, state: string, zip: string, primary: boolean }> | null } | null, hipaaRelease?: { __typename: 'consent__HipaaRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, templateReleases?: Array<{ __typename: 'consent__TemplateRelease_Type', grantedAt?: string | null, template: { __typename: 'document__Template_Type', id: string } }> | null, emails?: Array<{ __typename: 'user__Email_Type', email: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, staffDisplayProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, resolutionPreferences?: { __typename: 'issue__ResolutionPreferences_Type', savingsPreference: issue__SavingsPreference, minimumDiscountPercent: number, alternativePaymentOptions: Array<issue__AlternativePaymentOption>, successFeePercent: number } | null, paymentPreferences?: { __typename: 'issue__PaymentPreferences_Type', autoPayAuthorized?: boolean | null, acceptAny?: boolean | null, maxSettle?: number | null } | null, lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ChatEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ClosedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__CommentEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__OutreachEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | null, events?: Array<{ __typename: 'issue__AskReraisedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillDisputeEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, invoice?: Array<{ __typename: 'fhirext__InvoiceVersion_Type', id: string }> | null, eob?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string }> | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillPayRequestedEvent_Type', declinedAt?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, billPayAcceptedAt?: string | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillPaySuccessEvent_Type', negotiatedBillAmount: string, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, billPaymentAcceptedAt?: string | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__CardCollectionRequestedEvent_Type', cardSucceededAt?: string | null, cardSupersededAt?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ChatEvent_Type', chatBody: string, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ClosedEvent_Type', userClosureReason?: issue__UserClosureReason | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, feedback?: { __typename: 'feedback__IssueFeedback_Type', id: string, rating: number, review?: string | null, createdAt: string, selectedOptions?: Array<{ __typename: 'feedback__Option_Type', value: string }> | null } | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__CommentEvent_Type', comment: string, pinned: boolean, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', endpointType: webAgent__EndpointType, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, connectAccountChatBody?: string | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', insuranceLinkMessage?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__DocumentUploadedEvent_Type', documentLabel?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, template?: { __typename: 'document__Template_Type', displayName: string } | null, summary?: { __typename: 'document__DocumentSummary_Type', summary: string } | { __typename: 'issue__IssueDocumentSummary_Type', summary: string } | null, files?: Array<{ __typename: 'document__File_Type', name: string, id: string, s3Key?: string | null, s3Bucket: string, sizeBytes?: number | null, contentType?: string | null }> | null }, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, application: { __typename: 'fa__Application_Type', status: fa__ApplicationStatus }, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__HAAssignedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, internalDocument: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, template?: { __typename: 'document__Template_Type', displayName: string } | null, files?: Array<{ __typename: 'document__File_Type', name: string, id: string, s3Key?: string | null, s3Bucket: string, sizeBytes?: number | null, contentType?: string | null }> | null }, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__OutreachEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', userAccepted?: boolean | null, acceptedAt?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', chargeRecoveryReason?: issue__PaymentChargeResolvedReason | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', caseType: issue__PaymentCaseType, resolvedFeeCap: number, feePercentSnapshot: number, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, prefConfirmedAt?: string | null, prefFeeAcknowledgedAt?: string | null, prefDeclinedAt?: string | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', prefsAutoPayBefore: boolean, prefsAutoPayAfter: boolean, prefsMaxChargeBefore?: number | null, prefsMaxChargeAfter?: number | null, prefsMaxSettleBefore?: number | null, prefsMaxSettleAfter?: number | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PhoneCallEvent_Type', isInbound: boolean, phoneNumber?: string | null, durationMinutes?: number | null, callType?: string | null, hasVoicemail: boolean, transcript?: string | null, recordingUrl?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PlanSelectionEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, selectedPlan?: { __typename: 'plan__Plan_Type', id: string } | null, planSelectionOptions?: Array<{ __typename: 'plan__Plan_Type', id: string, planLabel?: string | null }> | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, actions?: Array<{ __typename: 'issue__BillPayPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__CompleteFaApplicationPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__ConnectEhrPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__ConnectInsurancePostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__FaEligibilityInfoPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__PaymentAgreementPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__PaymentPreferencesPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__SignTemplatePostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__UploadBillPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__UploadEobPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__UploadMemberIdPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__UploadProofOfIncomePostEscalationAction_Type', isRequired: boolean }> | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ReopenedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, template: { __typename: 'document__Template_Type', id: string, description: string }, release?: { __typename: 'consent__TemplateRelease_Type', id: string, grantedAt?: string | null } | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ToolExecutionEvent_Type', toolName: string, toolInput: string, toolOutput: string, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__UserInputRequestedEvent_Type', fieldSpec: string, answerValue?: string | null, outcome?: issue__InputOutcome | null, isResolved: boolean, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, userInputMessage?: string | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', message?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, multiSelectionOptions: Array<string>, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', message?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, userSelectionOptions: Array<string>, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null }> | null };

export type RetoolGetIssueCountQueryVariables = Exact<{ [key: string]: never; }>;


export type RetoolGetIssueCountQuery = { __typename: 'Query', issueCount: number };

export type RetoolHeaderMeQueryVariables = Exact<{ [key: string]: never; }>;


export type RetoolHeaderMeQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null };

export type GetPlanSelectionEventsQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type GetPlanSelectionEventsQuery = { __typename: 'Query', events?: Array<{ __typename: 'issue__PlanSelectionEvent_Type', selectedPlan?: { __typename: 'plan__Plan_Type', planLabel?: string | null } | null }> | null };

export type GetIssuePromoCodeUsageQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type GetIssuePromoCodeUsageQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, promoCodeUsages?: Array<{ __typename: 'payment__IssuePromoCodeUsage_Type', id: string, usedAt?: string | null, promoCode: { __typename: 'payment__PromoCode_Type', id: string, code: string, isActive: boolean, createdAt: string, updatedAt: string } }> | null }> | null };

export type InternalSetCaseProviderMutationVariables = Exact<{
  input: SetCaseProviderInput;
}>;


export type InternalSetCaseProviderMutation = { __typename: 'Mutation', setCaseProvider?: { __typename: 'issue__Issue_Type', id: string } | null };

export type ApplyPromoCodeToIssueMutationVariables = Exact<{
  issueId: Scalars['ID']['input'];
  code: Scalars['String']['input'];
}>;


export type ApplyPromoCodeToIssueMutation = { __typename: 'Mutation', applyPromoCodeUsage: { __typename: 'ApplyPromoCodeUsageSuccess', promoCodeUsage: { __typename: 'PromoCodeUsageInfo', id: string, issueId?: string | null, usedAt?: string | null, promoCode: { __typename: 'payment__PromoCode_Type', id: string, code: string, isActive: boolean } } } | { __typename: 'FormError', message?: string | null } };

export type UnapplyPromoCodeFromIssueMutationVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type UnapplyPromoCodeFromIssueMutation = { __typename: 'Mutation', markPromoCodeUsageAsUnused?: { __typename: 'MarkPromoCodeUsageAsUnusedResponse', promoCodeUsage?: { __typename: 'PromoCodeUsageInfo', id: string, issueId?: string | null, usedAt?: string | null, promoCode: { __typename: 'payment__PromoCode_Type', id: string, code: string, isActive: boolean } } | null } | null };

export type RetoolUpdateIssueChatMutationVariables = Exact<{
  input: UpdateIssueInput;
}>;


export type RetoolUpdateIssueChatMutation = { __typename: 'Mutation', updateIssue?: { __typename: 'issue__Issue_Type', id: string, caseManagementClosureReason?: string | null } | null };

export type RetoolCloseIssueMutationVariables = Exact<{
  input: CloseIssueInput;
}>;


export type RetoolCloseIssueMutation = { __typename: 'Mutation', closeIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type RetoolUpdateTaskCommentPinnedMutationVariables = Exact<{
  input: UpdateTaskCommentPinnedInput;
}>;


export type RetoolUpdateTaskCommentPinnedMutation = { __typename: 'Mutation', updateTaskCommentPinned?: { __typename: 'taskManagement__TaskComment_Type', id: string } | null };

export type RetoolUpdateIssueCommentEventPinnedMutationVariables = Exact<{
  input: UpdateIssueCommentEventPinnedInput;
}>;


export type RetoolUpdateIssueCommentEventPinnedMutation = { __typename: 'Mutation', updateIssueCommentEventPinned?: { __typename: 'issue__CommentEvent_Type', id: string } | null };

export type RetoolCreateIssueConnectAccountEventMutationVariables = Exact<{
  input: CreateIssueConnectAccountRequestedEventInput;
}>;


export type RetoolCreateIssueConnectAccountEventMutation = { __typename: 'Mutation', createIssueConnectAccountRequestedEvent?: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | null };

export type InternalStartFaFlowForIssueMutationVariables = Exact<{
  input: StartFaFlowInput;
}>;


export type InternalStartFaFlowForIssueMutation = { __typename: 'Mutation', startFaFlowForIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type InternalResendFaFlowForIssueMutationVariables = Exact<{
  input: ResendFaFlowInput;
}>;


export type InternalResendFaFlowForIssueMutation = { __typename: 'Mutation', resendFaFlowForIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type InternalCaseDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalCaseDocumentsQuery = { __typename: 'Query', document__Document?: Array<{ __typename: 'document__Document_Type', id: string, name: string, userVisible: boolean, dataType?: string | null, sides?: Array<string> | null, createdAt: string, summary?: { __typename: 'document__DocumentSummary_Type', summary: string } | { __typename: 'issue__IssueDocumentSummary_Type', summary: string } | null, issueEvent?: Array<{ __typename: 'issue__DocumentUploadedEvent_Type', id: string }> | null, files?: Array<{ __typename: 'document__File_Type', id: string, name: string, contentType?: string | null }> | null }> | null };

export type CaseIssuedDocumentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CaseIssuedDocumentsQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', documents?: Array<{ __typename: 'document__Document_Type', id: string, name: string, userVisible: boolean, dataType?: string | null, sides?: Array<string> | null, createdAt: string, summary?: { __typename: 'document__DocumentSummary_Type', summary: string } | { __typename: 'issue__IssueDocumentSummary_Type', summary: string } | null, issueEvent?: Array<{ __typename: 'issue__DocumentUploadedEvent_Type', id: string }> | null, files?: Array<{ __typename: 'document__File_Type', id: string, name: string, contentType?: string | null }> | null }> | null }> | null };

export type UserFaPacketDocumentsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  dataTypes: Array<Scalars['String']['input']>;
}>;


export type UserFaPacketDocumentsQuery = { __typename: 'Query', document__Document?: Array<{ __typename: 'document__Document_Type', id: string, name: string, userVisible: boolean, dataType?: string | null, sides?: Array<string> | null, createdAt: string, summary?: { __typename: 'document__DocumentSummary_Type', summary: string } | { __typename: 'issue__IssueDocumentSummary_Type', summary: string } | null, issueEvent?: Array<{ __typename: 'issue__DocumentUploadedEvent_Type', id: string }> | null, files?: Array<{ __typename: 'document__File_Type', id: string, name: string, contentType?: string | null }> | null }> | null };

export type UserMemberCardDocumentsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  dataTypes: Array<Scalars['String']['input']>;
}>;


export type UserMemberCardDocumentsQuery = { __typename: 'Query', document__Document?: Array<{ __typename: 'document__Document_Type', id: string, name: string, userVisible: boolean, dataType?: string | null, sides?: Array<string> | null, createdAt: string, summary?: { __typename: 'document__DocumentSummary_Type', summary: string } | { __typename: 'issue__IssueDocumentSummary_Type', summary: string } | null, issueEvent?: Array<{ __typename: 'issue__DocumentUploadedEvent_Type', id: string }> | null, files?: Array<{ __typename: 'document__File_Type', id: string, name: string, contentType?: string | null }> | null }> | null };

export type CaseHipaaAuthorizationsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type CaseHipaaAuthorizationsQuery = { __typename: 'Query', User?: Array<{ __typename: 'User_Type', id: string, hipaaRelease?: { __typename: 'consent__HipaaRelease_Type', grantedAt?: string | null, name?: string | null, expirationDate?: string | null, signatureDocument?: { __typename: 'document__Document_Type', id: string } | null, person?: { __typename: 'Person_Type', givenNames?: Array<string> | null, familyName?: string | null } | null } | null, templateReleases?: Array<{ __typename: 'consent__TemplateRelease_Type', id: string, grantedAt?: string | null, archivedAt?: string | null, expirationDate?: string | null, document: { __typename: 'document__Document_Type', id: string }, person?: { __typename: 'Person_Type', givenNames?: Array<string> | null, familyName?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, displayName: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, organization?: { __typename: 'integration__Organization_Type', displayName: string } | null } }> | null }> | null };

export type AdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminUsersQuery = { __typename: 'Query', User?: Array<{ __typename: 'User_Type', id: string, primaryEmail?: string | null }> | null };

export type DocumentTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentTemplatesQuery = { __typename: 'Query', document__Template?: Array<{ __typename: 'document__Template_Type', id: string, displayName: string, description: string, templateType: document__TemplateType, default: boolean }> | null };

export type InternalCreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;


export type InternalCreateDocumentMutation = { __typename: 'Mutation', createDocument: { __typename: 'CreateDocumentResult', url: string, document: { __typename: 'document__Document_Type', id: string } } };

export type FinalizeDocumentMutationVariables = Exact<{
  input: FinalizeDocumentInput;
}>;


export type FinalizeDocumentMutation = { __typename: 'Mutation', finalizeDocument: { __typename: 'FinalizeDocumentResult', document: { __typename: 'document__Document_Type', id: string } } };

export type SendDocumentToUserMutationVariables = Exact<{
  input: SendDocumentToUserInput;
}>;


export type SendDocumentToUserMutation = { __typename: 'Mutation', sendDocumentToUser: { __typename: 'SendDocumentToUserResult', document: { __typename: 'document__Document_Type', id: string } } };

export type DeleteUserDocumentMutationVariables = Exact<{
  input: DeleteUserDocumentInput;
}>;


export type DeleteUserDocumentMutation = { __typename: 'Mutation', deleteUserDocument: { __typename: 'DeleteUserDocumentResult', deletedDocumentId: string } };

export type RequestTemplateReleaseMutationVariables = Exact<{
  input?: InputMaybe<CreateIssueTemplateReleaseRequestedEventInput>;
}>;


export type RequestTemplateReleaseMutation = { __typename: 'Mutation', createIssueTemplateReleaseRequestedEvent?: { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | null };

export type InternalCaseIssueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalCaseIssueQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, title?: string | null, caseType?: string | null, dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, estimatedDollarAmountSaved?: string | null, openedAt: string, closedAt?: string | null, lastSeenAt?: string | null, followUpDate?: string | null, nextSteps?: string | null, caseManagementType?: string | null, caseManagementClosureReason?: string | null, caseManagementRelatedIssueCount?: number | null, coverageType?: string | null, labels?: Array<string> | null, additionalDetails?: string | null, person?: { __typename: 'Person_Type', familyName?: string | null, givenNames?: Array<string> | null, dateOfBirth: string } | null, owner: { __typename: 'User_Type', id: string, hipaaRelease?: { __typename: 'consent__HipaaRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, templateReleases?: Array<{ __typename: 'consent__TemplateRelease_Type', template: { __typename: 'document__Template_Type', id: string } }> | null, emails?: Array<{ __typename: 'user__Email_Type', email: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ChatEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ClosedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__CommentEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__OutreachEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, participant: Participant, sentAt: string } | null, events?: Array<{ __typename: 'issue__AskReraisedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillDisputeEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, invoice?: Array<{ __typename: 'fhirext__InvoiceVersion_Type', id: string }> | null, eob?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string }> | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillPayRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, billPayAcceptedAt?: string | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillPaySuccessEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, billPaymentAcceptedAt?: string | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__CardCollectionRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ChatEvent_Type', chatBody: string, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ClosedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, feedback?: { __typename: 'feedback__IssueFeedback_Type', id: string, rating: number, review?: string | null, createdAt: string, selectedOptions?: Array<{ __typename: 'feedback__Option_Type', value: string }> | null } | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__CommentEvent_Type', comment: string, pinned: boolean, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', endpointType: webAgent__EndpointType, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, connectAccountChatBody?: string | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', insuranceLinkMessage?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, userVisible?: boolean | null, eventType: issue__EventType, id: string, participant: Participant, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__DocumentUploadedEvent_Type', documentLabel?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, template?: { __typename: 'document__Template_Type', displayName: string } | null, summary?: { __typename: 'document__DocumentSummary_Type', summary: string } | { __typename: 'issue__IssueDocumentSummary_Type', summary: string } | null, files?: Array<{ __typename: 'document__File_Type', name: string, id: string, s3Key?: string | null, s3Bucket: string, sizeBytes?: number | null, contentType?: string | null }> | null }, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__HAAssignedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, internalDocument: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, template?: { __typename: 'document__Template_Type', displayName: string } | null, files?: Array<{ __typename: 'document__File_Type', name: string, id: string, s3Key?: string | null, s3Bucket: string, sizeBytes?: number | null, contentType?: string | null }> | null }, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__OutreachEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', userAccepted?: boolean | null, acceptedAt?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PhoneCallEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PlanSelectionEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, selectedPlan?: { __typename: 'plan__Plan_Type', id: string } | null, planSelectionOptions?: Array<{ __typename: 'plan__Plan_Type', id: string, planLabel?: string | null }> | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ReopenedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, template: { __typename: 'document__Template_Type', description: string }, release?: { __typename: 'consent__TemplateRelease_Type', grantedAt?: string | null } | null, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__ToolExecutionEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__UserInputRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', message?: string | null, eventType: issue__EventType, id: string, participant: Participant, userVisible?: boolean | null, sentAt: string, seenAt?: string | null, actionRequired: boolean, userSelectionOptions: Array<string>, sentBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null }> | null };

export type InternalUpdateIssueEventMutationVariables = Exact<{
  input?: InputMaybe<UpdateIssueEventInput>;
}>;


export type InternalUpdateIssueEventMutation = { __typename: 'Mutation', updateIssueEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__BillDisputeEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__ChatEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__ClosedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__CommentEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__HAAssignedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__OutreachEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__PhoneCallEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__ReopenedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, actionRequired: boolean } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, actionRequired: boolean } | null };

export type InternalUpdateDocumentNameMutationVariables = Exact<{
  input: UpdateDocumentNameInput;
}>;


export type InternalUpdateDocumentNameMutation = { __typename: 'Mutation', updateDocumentName: { __typename: 'UpdateDocumentNameResult', document: { __typename: 'document__Document_Type', id: string, name: string } } };

export type InternalUpdateFileNameMutationVariables = Exact<{
  input: UpdateFileNameInput;
}>;


export type InternalUpdateFileNameMutation = { __typename: 'Mutation', updateFileName: { __typename: 'UpdateFileNameResult', file: { __typename: 'document__File_Type', id: string, name: string } } };

export type InternalCreateIssueChatEventMutationVariables = Exact<{
  input: CreateIssueChatEventInput;
}>;


export type InternalCreateIssueChatEventMutation = { __typename: 'Mutation', createIssueChatEvent?: { __typename: 'issue__ChatEvent_Type', id: string } | null };

export type InternalCreateIssueCommentEventMutationVariables = Exact<{
  input?: InputMaybe<CreateIssueCommentEventInput>;
}>;


export type InternalCreateIssueCommentEventMutation = { __typename: 'Mutation', createIssueCommentEvent?: { __typename: 'issue__CommentEvent_Type', id: string } | null };

export type InternalNateraCaseIntakeQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type InternalNateraCaseIntakeQuery = { __typename: 'Query', nateraCaseIntake?: string | null };

export type InternalOwnerUserMemoryQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type InternalOwnerUserMemoryQuery = { __typename: 'Query', projection__UserMemory?: Array<{ __typename: 'projection__UserMemory_Type', entries: string }> | null };

export type BillPaymentRequestedEventsQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type BillPaymentRequestedEventsQuery = { __typename: 'Query', events?: Array<{ __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, sentAt: string, acceptedAt?: string | null, billPaid: boolean, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null } }> | null };

export type PaymentAgreementEventsQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type PaymentAgreementEventsQuery = { __typename: 'Query', events?: Array<{ __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, userAccepted?: boolean | null, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null } }> | null };

export type BillPayEventsQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type BillPayEventsQuery = { __typename: 'Query', events?: Array<{ __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, acceptedAt?: string | null, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null } }> | null };

export type UpdateTotalBillDollarAmountMutationVariables = Exact<{
  input: UpdateIssueInput;
}>;


export type UpdateTotalBillDollarAmountMutation = { __typename: 'Mutation', updateIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type CreatePaymentPreferencesRequestedEventMutationVariables = Exact<{
  input: CreatePaymentPreferencesRequestedEventInput;
}>;


export type CreatePaymentPreferencesRequestedEventMutation = { __typename: 'Mutation', createPaymentPreferencesRequestedEvent?: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | null };

export type RequestCardCollectionMutationVariables = Exact<{
  input: RequestCardCollectionInput;
}>;


export type RequestCardCollectionMutation = { __typename: 'Mutation', requestCardCollection?: { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | null };

export type PaymentPreferencesCaptureQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type PaymentPreferencesCaptureQuery = { __typename: 'Query', requests?: Array<{ __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string, confirmedAt?: string | null, declinedAt?: string | null, feeAcknowledgedAt?: string | null }> | null, issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, labels?: Array<string> | null, paymentPreferences?: { __typename: 'issue__PaymentPreferences_Type', id: string, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, acceptAny?: boolean | null, maxSingleCharge?: number | null, maxSettle?: number | null, autoPayAuthorized?: boolean | null, paymentPlanRequested?: boolean | null, paymentPlanMaxMonthly?: number | null, providerRelationship?: issue__ProviderRelationship | null, note?: string | null, resolvedFeeCap: number, successFeePercent: number, createdAt: string, updatedAt: string, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', code: string } | null, requestedEvent: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', confirmedAt?: string | null } } | null }> | null };

export type UpdatePaymentPreferencesMutationVariables = Exact<{
  input: UpdatePaymentPreferencesInput;
}>;


export type UpdatePaymentPreferencesMutation = { __typename: 'Mutation', updatePaymentPreferences?: { __typename: 'issue__PaymentPreferences_Type', id: string, updatedAt: string } | null };

export type ChargeNegotiatedBillMutationVariables = Exact<{
  input: ChargeNegotiatedBillInput;
}>;


export type ChargeNegotiatedBillMutation = { __typename: 'Mutation', chargeNegotiatedBill?: { __typename: 'ChargeNegotiatedBillResponse', totalCharged: string, billAmount: string, successFeeAmount: string } | null };

export type PreviewNegotiatedBillChargeQueryVariables = Exact<{
  input: PreviewNegotiatedBillChargeInput;
}>;


export type PreviewNegotiatedBillChargeQuery = { __typename: 'Query', previewNegotiatedBillCharge?: { __typename: 'NegotiatedBillChargePreviewResult', refusal?: string | null, breakdown?: { __typename: 'NegotiatedBillChargePreview', originalBillCents: number, settledCents: number, savingsCents: number, feePercent: number, feeCapCents: number, feeCapBasis?: NegotiatedBillFeeCapBasis | null, rawFeeCents: number, feeCapped: boolean, feeWaived: boolean, promoCode?: string | null, promoDiscountCents: number, successFeeCents: number, billCents: number, totalCents: number, maxSingleChargeCents?: number | null, maxSettleCents?: number | null, exceedsMaxSingleCharge: boolean, exceedsMaxSettle: boolean } | null } | null };

export type InternalIssuePaymentTransactionsQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type InternalIssuePaymentTransactionsQuery = { __typename: 'Query', payment__PaymentTransaction?: Array<{ __typename: 'payment__PaymentTransaction_Type', id: string, amount: string, currency: string, status: payment__PaymentStatus, transactionType?: payment__PaymentTransactionType | null, createdAt: string, billAmount?: string | null, successFeeAmount?: string | null, failedAt?: string | null, failureCode?: string | null, failureDeclineCode?: string | null, failureMessage?: string | null, stripeReceiptUrl?: string | null }> | null };

export type InternalCasePhoneCallsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalCasePhoneCallsQuery = { __typename: 'Query', issue__PhoneCallEvent?: Array<{ __typename: 'issue__PhoneCallEvent_Type', id: string, aircallId: string, sentAt: string, durationMinutes?: number | null, isInbound: boolean, callType?: string | null, phoneNumber?: string | null, transcript?: string | null, transcriptFetchedAt?: string | null, recordingUrl?: string | null, summary?: string | null, summaryFetchedAt?: string | null }> | null };

export type LogAircallCallMutationVariables = Exact<{
  input: LogAircallCallInput;
}>;


export type LogAircallCallMutation = { __typename: 'Mutation', logAircallCall?: { __typename: 'issue__PhoneCallEvent_Type', id: string } | null };

export type InternalPhoneCallTasksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalPhoneCallTasksQuery = { __typename: 'Query', taskManagement__PhoneCallIssueTask?: Array<{ __typename: 'taskManagement__PhoneCallIssueTask_Type', id: string, title: string, phoneCallEvent?: { __typename: 'issue__PhoneCallEvent_Type', id: string } | null }> | null };

export type FetchPhoneCallTranscriptMutationVariables = Exact<{
  phoneCallEventId: Scalars['ID']['input'];
}>;


export type FetchPhoneCallTranscriptMutation = { __typename: 'Mutation', fetchPhoneCallTranscript?: { __typename: 'issue__PhoneCallEvent_Type', id: string, transcript?: string | null, transcriptFetchedAt?: string | null, recordingUrl?: string | null, summary?: string | null, summaryFetchedAt?: string | null } | null };

export type FetchPhoneCallRecordingUrlMutationVariables = Exact<{
  phoneCallEventId: Scalars['ID']['input'];
}>;


export type FetchPhoneCallRecordingUrlMutation = { __typename: 'Mutation', fetchPhoneCallRecordingUrl: string };

export type HaCaseStateQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type HaCaseStateQuery = { __typename: 'Query', caseState?: { __typename: 'CaseState', summary: CaseStateSummary, waitingOn?: CaseRequirementWaitingOn | null, coverage: Array<{ __typename: 'CaseKindCoverage', kind: CaseRequirementKind, coverage: CaseRequirementCoverage }>, requirements: Array<{ __typename: 'OpenCaseRequirement', key: string, kind: CaseRequirementKind, waitingOn: CaseRequirementWaitingOn, since: Date, askCount: number, target: { __typename: 'CaseRequirementTarget', type: CaseRequirementTargetType, organizationId?: string | null, organizationName?: string | null } } | { __typename: 'SatisfiedCaseRequirement', key: string, kind: CaseRequirementKind, since: Date, askCount: number, target: { __typename: 'CaseRequirementTarget', type: CaseRequirementTargetType, organizationId?: string | null, organizationName?: string | null } } | { __typename: 'UnattestedCaseRequirement', key: string, kind: CaseRequirementKind, authorizationId: string, since: Date }> } | null };

export type InternalCaseTaskDraftQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type InternalCaseTaskDraftQuery = { __typename: 'Query', caseTaskDraft: { __typename: 'CaseTaskDraft', kind: CaseTaskDraftKind, suggestionId?: string | null, draft?: { __typename: 'CaseTaskDraftFields', taskType: string, title: string, dueDate: string, notes: string, reason: string, formType?: string | null, formSender?: string | null, sendingMethod?: string | null } | null } };

export type InternalAcceptTaskDraftMutationVariables = Exact<{
  input: AcceptTaskDraftInput;
}>;


export type InternalAcceptTaskDraftMutation = { __typename: 'Mutation', acceptTaskDraft: boolean };

export type InternalDismissTaskDraftMutationVariables = Exact<{
  input: DismissTaskDraftInput;
}>;


export type InternalDismissTaskDraftMutation = { __typename: 'Mutation', dismissTaskDraft: boolean };

export type InternalCaseIssueTasksQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalCaseIssueTasksQuery = { __typename: 'Query', taskManagement__IssueTask?: Array<{ __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__GeneralIssueTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__IssueResearchTask_Type', researchNotes?: string | null, id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__IssueTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__IssueUserMessagingTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__PhoneCallIssueTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, phoneCallEvent?: { __typename: 'issue__PhoneCallEvent_Type', id: string, aircallId: string, phoneNumber?: string | null, recordingUrl?: string | null } | null, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__RetryChargeIssueTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, hasAllInformation_caseIntake?: boolean | null, additionalDetailsRequested_caseIntake?: string | null, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__ReviewEscalatedCaseTask_Type', hasAllInformation?: boolean | null, additionalDetailsRequested?: string | null, id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__ReviewIssueChatTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__ReviewSuggestionTask_Type', id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, suggestedAction: { __typename: 'suggestion__SuggestedAction_Type', id: string, type: string, actionPayload: string, status: suggestion__SuggestedActionStatus, createdAt: string, respondedAt?: string | null, executedAt?: string | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null } | { __typename: 'taskManagement__SendFormIssueTask_Type', formType: string, formSender: string, sendingMethod: string, id: string, type: taskManagement__TaskType, title: string, description?: string | null, status: taskManagement__TaskStatus, priority: number, dueDate?: string | null, minutesSpent?: number | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string, comment: string, pinned: boolean, createdAt: string, updatedAt: string, canEdit?: boolean | null, createdBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null }> | null }> | null };

export type InternalAdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalAdminUsersQuery = { __typename: 'Query', User?: Array<{ __typename: 'User_Type', id: string, primaryEmail?: string | null }> | null };

export type InternalCreateIssueTaskMutationVariables = Exact<{
  input: CreateIssueTaskInput;
}>;


export type InternalCreateIssueTaskMutation = { __typename: 'Mutation', createIssueTask?: { __typename: 'taskManagement__DataQualityFlagTask_Type', id: string } | { __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type', id: string } | { __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type', id: string } | { __typename: 'taskManagement__GeneralIssueTask_Type', id: string } | { __typename: 'taskManagement__IssueResearchTask_Type', id: string } | { __typename: 'taskManagement__IssueTask_Type', id: string } | { __typename: 'taskManagement__IssueUserMessagingTask_Type', id: string } | { __typename: 'taskManagement__PhoneCallIssueTask_Type', id: string } | { __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type', id: string } | { __typename: 'taskManagement__RetryChargeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewEscalatedCaseTask_Type', id: string } | { __typename: 'taskManagement__ReviewFindingTask_Type', id: string } | { __typename: 'taskManagement__ReviewIssueChatTask_Type', id: string } | { __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewSuggestionTask_Type', id: string } | { __typename: 'taskManagement__SendFormIssueTask_Type', id: string } | { __typename: 'taskManagement__Task_Type', id: string } | null };

export type InternalUpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type InternalUpdateTaskMutation = { __typename: 'Mutation', updateTask?: { __typename: 'taskManagement__DataQualityFlagTask_Type', id: string } | { __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type', id: string } | { __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type', id: string } | { __typename: 'taskManagement__GeneralIssueTask_Type', id: string } | { __typename: 'taskManagement__IssueResearchTask_Type', id: string } | { __typename: 'taskManagement__IssueTask_Type', id: string } | { __typename: 'taskManagement__IssueUserMessagingTask_Type', id: string } | { __typename: 'taskManagement__PhoneCallIssueTask_Type', id: string } | { __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type', id: string } | { __typename: 'taskManagement__RetryChargeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewEscalatedCaseTask_Type', id: string } | { __typename: 'taskManagement__ReviewFindingTask_Type', id: string } | { __typename: 'taskManagement__ReviewIssueChatTask_Type', id: string } | { __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewSuggestionTask_Type', id: string } | { __typename: 'taskManagement__SendFormIssueTask_Type', id: string } | { __typename: 'taskManagement__Task_Type', id: string } | null };

export type InternalCreateTaskCommentMutationVariables = Exact<{
  input: CreateTaskCommentInput;
}>;


export type InternalCreateTaskCommentMutation = { __typename: 'Mutation', createTaskComment?: { __typename: 'taskManagement__TaskComment_Type', id: string } | null };

export type InternalUpdateIssueOnTaskClosureMutationVariables = Exact<{
  input: UpdateIssueInput;
}>;


export type InternalUpdateIssueOnTaskClosureMutation = { __typename: 'Mutation', updateIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type InternalApproveSuggestedActionMutationVariables = Exact<{
  actionId: Scalars['ID']['input'];
}>;


export type InternalApproveSuggestedActionMutation = { __typename: 'Mutation', approveSuggestedAction: { __typename: 'ApproveSuggestedActionResult', success: boolean } };

export type InternalPendingSuggestionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalPendingSuggestionsQuery = { __typename: 'Query', suggestion__SuggestedAction?: Array<{ __typename: 'suggestion__SuggestedAction_Type', id: string, type: string, actionPayload: string, status: suggestion__SuggestedActionStatus, createdAt: string, respondedAt?: string | null, executedAt?: string | null, triggerEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string } | null, reviewTask?: { __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type', id: string } | { __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type', id: string } | { __typename: 'taskManagement__GeneralIssueTask_Type', id: string } | { __typename: 'taskManagement__IssueResearchTask_Type', id: string } | { __typename: 'taskManagement__IssueTask_Type', id: string } | { __typename: 'taskManagement__IssueUserMessagingTask_Type', id: string } | { __typename: 'taskManagement__PhoneCallIssueTask_Type', id: string } | { __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type', id: string } | { __typename: 'taskManagement__RetryChargeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewEscalatedCaseTask_Type', id: string } | { __typename: 'taskManagement__ReviewIssueChatTask_Type', id: string } | { __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewSuggestionTask_Type', id: string } | { __typename: 'taskManagement__SendFormIssueTask_Type', id: string } | null }> | null };

export type InternalRejectSuggestedActionMutationVariables = Exact<{
  actionId: Scalars['ID']['input'];
  reasonCode?: InputMaybe<SuggestionRejectReason>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type InternalRejectSuggestedActionMutation = { __typename: 'Mutation', rejectSuggestedAction: { __typename: 'RejectSuggestedActionResult', success: boolean, outcome: RejectSuggestedActionOutcome } };

export type CaseWorklistPageQueryVariables = Exact<{
  filter: CaseWorklistFilter;
  sort: CaseWorklistSort;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CaseWorklistPageQuery = { __typename: 'Query', caseWorklistPage: { __typename: 'CaseWorklistPage', nextCursor?: string | null, hasMore: boolean, totalCount: number, rows: Array<{ __typename: 'CaseWorklistRow', id: string, title?: string | null, caseRef?: string | null, labels: Array<string>, isEscalated: boolean, priorityOverride?: string | null, priorityOverrideSetByEmail?: string | null, priorityOverrideSetAt?: string | null, ownerId?: string | null, ownerEmail?: string | null, assigneeId?: string | null, assigneeEmail?: string | null, openedAt?: string | null, closedAt?: string | null, caseManagementType?: string | null, providerName?: string | null, totalBillDollarAmount?: number | null, autoPayAuthorized: boolean, nextTaskTitle?: string | null, nextTaskDueDate?: string | null, hasOpenTask: boolean, earliestOpenTaskDueDate?: string | null, hasOpenReviewChatTask: boolean, hasStaffMessage: boolean, lastEventParticipant?: string | null, lastEventSentAt?: string | null, lastMemberMessageAwaitingReplyAt?: string | null, lastMemberActivityAt?: string | null, lastStaffTouchAt?: string | null, ownerSegments: Array<{ __typename: 'CaseWorklistSegment', id: string, key: string, displayName?: string | null, isActive: boolean }> }> } };

export type CaseWorklistSummaryQueryVariables = Exact<{
  filter: CaseWorklistFilter;
}>;


export type CaseWorklistSummaryQuery = { __typename: 'Query', caseWorklistSummary: { __typename: 'CaseWorklistSummary', caseManagementTypes: Array<string>, unanswered: number, overdue: number, noTask: number, byAssignee: Array<{ __typename: 'CaseWorklistAssigneeSla', assigneeId?: string | null, assigneeEmail?: string | null, unanswered: number, overdue: number, noTask: number }> } };

export type HomeIssuesQueryVariables = Exact<{ [key: string]: never; }>;


export type HomeIssuesQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, labels?: Array<string> | null, title?: string | null, caseRef: string, caseManagementType?: string | null, providerName?: string | null, totalBillDollarAmount?: string | null, priorityOverride?: issue__PriorityOverride | null, paymentPreferences?: { __typename: 'issue__PaymentPreferences_Type', autoPayAuthorized?: boolean | null } | null, owner: { __typename: 'User_Type', emails?: Array<{ __typename: 'user__Email_Type', email: string }> | null, segments?: Array<{ __typename: 'segment__UserSegment_Type', isActive: boolean, segment: { __typename: 'segment__Segment_Type', id: string, key: string, displayName: string } }> | null }, openTasks?: Array<{ __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__GeneralIssueTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__IssueResearchTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__IssueTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__IssueUserMessagingTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__PhoneCallIssueTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__RetryChargeIssueTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__ReviewEscalatedCaseTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__ReviewIssueChatTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__ReviewSuggestionTask_Type', dueDate?: string | null } | { __typename: 'taskManagement__SendFormIssueTask_Type', dueDate?: string | null }> | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null, staffTouches?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, reviewChatTasks?: Array<{ __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type', id: string } | { __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type', id: string } | { __typename: 'taskManagement__GeneralIssueTask_Type', id: string } | { __typename: 'taskManagement__IssueResearchTask_Type', id: string } | { __typename: 'taskManagement__IssueTask_Type', id: string } | { __typename: 'taskManagement__IssueUserMessagingTask_Type', id: string } | { __typename: 'taskManagement__PhoneCallIssueTask_Type', id: string } | { __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type', id: string } | { __typename: 'taskManagement__RetryChargeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewEscalatedCaseTask_Type', id: string } | { __typename: 'taskManagement__ReviewIssueChatTask_Type', id: string } | { __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewSuggestionTask_Type', id: string } | { __typename: 'taskManagement__SendFormIssueTask_Type', id: string }> | null, lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__ChatEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__ClosedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__CommentEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__OutreachEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', participant: Participant, sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', participant: Participant, sentAt: string } | null }> | null };

export type RetoolGetAdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type RetoolGetAdminUsersQuery = { __typename: 'Query', User?: Array<{ __typename: 'User_Type', id: string, primaryEmail?: string | null }> | null };

export type RetoolUpdateIssueMutationVariables = Exact<{
  input: UpdateIssueInput;
}>;


export type RetoolUpdateIssueMutation = { __typename: 'Mutation', updateIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type ViewDocumentQueryVariables = Exact<{
  input: ViewDocumentInput;
}>;


export type ViewDocumentQuery = { __typename: 'Query', viewDocument: { __typename: 'ViewDocumentResult', documentUrl: string } };

export type ViewDocumentFileQueryVariables = Exact<{
  input: ViewDocumentFileInput;
}>;


export type ViewDocumentFileQuery = { __typename: 'Query', viewDocumentFile: { __typename: 'ViewDocumentFileResult', fileId: string, fileUrl: string, fileName: string } };

export type InternalFaApplicationViewQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type InternalFaApplicationViewQuery = { __typename: 'Query', faApplicationForIssue?: { __typename: 'FaApplicationView', formSpec: string, formState: string, providerFormId?: string | null, formSpecVersion: number, filedFormSpecVersion?: number | null, submissionSnapshot?: string | null, submittedAt?: string | null, startedAt?: string | null, skippedAt?: string | null } | null };

export type FaApplicationFieldsFragment = { __typename: 'FaApplication', id: string, status: fa__ApplicationStatus, providerId?: string | null, formType?: provider__FormType | null, issuerName?: string | null, formName?: string | null, formState?: string | null, updatedAt: string } & { ' $fragmentName'?: 'FaApplicationFieldsFragment' };

export type InternalFaApplicationQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type InternalFaApplicationQuery = { __typename: 'Query', faApplication?: (
    { __typename: 'FaApplication' }
    & { ' $fragmentRefs'?: { 'FaApplicationFieldsFragment': FaApplicationFieldsFragment } }
  ) | null };

export type InternalUpsertFaApplicationMutationVariables = Exact<{
  input: UpsertFaApplicationInput;
}>;


export type InternalUpsertFaApplicationMutation = { __typename: 'Mutation', upsertFaApplication: (
    { __typename: 'FaApplication' }
    & { ' $fragmentRefs'?: { 'FaApplicationFieldsFragment': FaApplicationFieldsFragment } }
  ) | { __typename: 'FormError', message?: string | null } };

export type InternalComposeFaApplicationMutationVariables = Exact<{
  input: ComposeFaApplicationInput;
}>;


export type InternalComposeFaApplicationMutation = { __typename: 'Mutation', composeFaApplication: (
    { __typename: 'FaApplication' }
    & { ' $fragmentRefs'?: { 'FaApplicationFieldsFragment': FaApplicationFieldsFragment } }
  ) | { __typename: 'FormError', message?: string | null } };

export type InternalFaFlowFormResolutionQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type InternalFaFlowFormResolutionQuery = { __typename: 'Query', faFlowFormPreview?: { __typename: 'FaFlowFormResolution', resolution: FaFlowFormResolutionKind, providerId?: string | null, formId?: string | null, pinnedFormId?: string | null, providerName?: string | null, formName?: string | null, inheritedFrom?: string | null, applicationStatus?: fa__ApplicationStatus | null, pinnedFormProviderName?: string | null, pinnedFormProviderId?: string | null, hasOfferEvent: boolean, carriedOver?: number | null, totalAnswers?: number | null, formSpecVersion?: number | null } | null };

export type InternalPrefillFaApplicationAsStaffMutationVariables = Exact<{
  input: PrefillFaApplicationInput;
}>;


export type InternalPrefillFaApplicationAsStaffMutation = { __typename: 'Mutation', prefillFaApplicationAsStaff: (
    { __typename: 'FaApplication' }
    & { ' $fragmentRefs'?: { 'FaApplicationFieldsFragment': FaApplicationFieldsFragment } }
  ) | { __typename: 'FormError', message?: string | null } };

export type InternalRepinFaApplicationFormMutationVariables = Exact<{
  input: RepinFaApplicationFormInput;
}>;


export type InternalRepinFaApplicationFormMutation = { __typename: 'Mutation', repinFaApplicationForm: { __typename: 'FormError', message?: string | null } | { __typename: 'RepinFaApplicationFormNoop', reason: RepinFaApplicationFormNoopReason, noopMessage: string } | { __typename: 'RepinnedFaApplicationForm', formId: string, formName?: string | null, providerName?: string | null, resolution: FaFlowFormResolutionKind, carriedOver: number, totalAnswers: number } };

export type InternalFaExtractedDocumentsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  kinds: Array<Scalars['String']['input']>;
}>;


export type InternalFaExtractedDocumentsQuery = { __typename: 'Query', projection__UserDataView?: Array<{ __typename: 'projection__UserDataView_Type', key: string, kind: string, data: string, updatedAt: string, metadata?: string | null }> | null };

export type InternalFaStableDocumentsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
  dataTypes: Array<Scalars['String']['input']>;
}>;


export type InternalFaStableDocumentsQuery = { __typename: 'Query', document__Document?: Array<{ __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, createdAt: string, files?: Array<{ __typename: 'document__File_Type', id: string, name: string, contentType?: string | null }> | null }> | null };

export type InternalGenerateFaPacketMutationVariables = Exact<{
  input: GenerateFaPacketInput;
}>;


export type InternalGenerateFaPacketMutation = { __typename: 'Mutation', generateFaPacket: { __typename: 'FaPacket', documentId: string, fillReport: { __typename: 'FaFillReport', filled: number, attempted: number, encodeErrors: number }, verifier: { __typename: 'FaVerifierResult', ok: boolean, checked: number, passed: number, skippedCheckboxes: number, skippedImages: number } } | { __typename: 'FormError', message?: string | null } };

export type InternalFaSupportingDocumentsQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type InternalFaSupportingDocumentsQuery = { __typename: 'Query', faApplicationSupportingDocuments: { __typename: 'FaSupportingDocuments', unresolvedFields: Array<string>, documents: Array<{ __typename: 'FaSupportingDocument', key: string, documentId: string, name: string, fileName?: string | null }> } };

export type SubmitHaFeedbackMutationVariables = Exact<{
  input: HaFeedbackInput;
}>;


export type SubmitHaFeedbackMutation = { __typename: 'Mutation', submitHaFeedback: { __typename: 'HaFeedbackResult', accepted: boolean } };

export type ForecastScenarioFieldsFragment = { __typename: 'ForecastingScenario', id: string, name: string, description?: string | null, updatedAt: string, overrides: Array<{ __typename: 'ForecastingOverride', id: string, variableKey: string, value: number }>, investments: Array<{ __typename: 'ForecastingInvestment', id: string, name: string, effectiveDate: string, targetVariable: string, effectKind: string, effectAmount: number, rampWeeks?: number | null, enabled: boolean }> } & { ' $fragmentName'?: 'ForecastScenarioFieldsFragment' };

export type ForecastOverviewQueryVariables = Exact<{
  scenarioId?: InputMaybe<Scalars['ID']['input']>;
  horizonWeeks?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ForecastOverviewQuery = { __typename: 'Query', forecastingOverview: { __typename: 'ForecastingOverview', horizonWeeks: number, horizonStart: string, scenarioId?: string | null, benchmarkRunId?: string | null, benchmarkComputedAt?: string | null, segmentationVersion: string, usingSeedBenchmarks: boolean, registry: string, projection: string, volumeFallbackWeeks: string, headcountFallbackWeeks: string, leadActuals: string, reconciliationFailures: Array<string> } };

export type ForecastScenariosQueryVariables = Exact<{ [key: string]: never; }>;


export type ForecastScenariosQuery = { __typename: 'Query', forecastingScenarios: Array<(
    { __typename: 'ForecastingScenario' }
    & { ' $fragmentRefs'?: { 'ForecastScenarioFieldsFragment': ForecastScenarioFieldsFragment } }
  )> };

export type SaveForecastScenarioMutationVariables = Exact<{
  input: SaveForecastingScenarioInput;
}>;


export type SaveForecastScenarioMutation = { __typename: 'Mutation', saveForecastingScenario: (
    { __typename: 'ForecastingScenario' }
    & { ' $fragmentRefs'?: { 'ForecastScenarioFieldsFragment': ForecastScenarioFieldsFragment } }
  ) };

export type DeleteForecastScenarioMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteForecastScenarioMutation = { __typename: 'Mutation', deleteForecastingScenario: boolean };

export type SetForecastOverrideMutationVariables = Exact<{
  input: SetForecastingOverrideInput;
}>;


export type SetForecastOverrideMutation = { __typename: 'Mutation', setForecastingOverride: (
    { __typename: 'ForecastingScenario' }
    & { ' $fragmentRefs'?: { 'ForecastScenarioFieldsFragment': ForecastScenarioFieldsFragment } }
  ) };

export type SaveForecastInvestmentMutationVariables = Exact<{
  input: SaveForecastingInvestmentInput;
}>;


export type SaveForecastInvestmentMutation = { __typename: 'Mutation', saveForecastingInvestment: (
    { __typename: 'ForecastingScenario' }
    & { ' $fragmentRefs'?: { 'ForecastScenarioFieldsFragment': ForecastScenarioFieldsFragment } }
  ) };

export type DeleteForecastInvestmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteForecastInvestmentMutation = { __typename: 'Mutation', deleteForecastingInvestment: boolean };

export type SaveForecastInputsMutationVariables = Exact<{
  input: SaveForecastingForecastInputsInput;
}>;


export type SaveForecastInputsMutation = { __typename: 'Mutation', saveForecastingForecastInputs: boolean };

export type InternalGetCalibrationFormFillQueryVariables = Exact<{
  input: GetFormFillInput;
}>;


export type InternalGetCalibrationFormFillQuery = { __typename: 'Query', getFormFill: { __typename: 'FaFormFill', issuerName: string, formName: string, pdfBase64: string, pages: number, proposerFallback: boolean, calibratedAt?: string | null, fields: Array<{ __typename: 'FaFormFillField', id?: string | null, key: string, label: string, description: string, patientLabel: string, patientHelp?: string | null, type: string, signature: boolean, money: boolean, date: boolean, state?: string | null, confidence?: string | null, required?: boolean | null, clusterType?: string | null, clusterLabel?: string | null, markStyle?: string | null, fieldType?: string | null, repeatGroup?: string | null, repeatRow?: number | null, repeatMax?: number | null, repeatItemLabel?: string | null, repeatAddLabel?: string | null, repeatCellKey?: string | null, bbox: { __typename: 'FaFormFillBbox', left: number, top: number, width: number, height: number, page: number } }>, requiredDocs: Array<{ __typename: 'FaFormFillRequiredDoc', type: string, label?: string | null, count?: number | null, period?: number | null, optional?: boolean | null }>, auditFindings: Array<{ __typename: 'FaAuditFinding', class: string, widgetId?: string | null, key?: string | null, message: string, confidence: string }> } | { __typename: 'FormError', message?: string | null } };

export type InternalUserInsuranceQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type InternalUserInsuranceQuery = { __typename: 'Query', userInsurance: { __typename: 'Insurance', checkStatus: { __typename: 'InsuranceCheckStatus', state: InsuranceCheckState, missing: Array<InsuranceCheckRequirement>, lastAttemptAt?: Date | null, lastAnsweredAt?: Date | null, problem?: InsuranceCheckProblem | null }, memberships: Array<{ __typename: 'InsuranceMembership', id: string, status: InsuranceMembershipStatus, coverageType: InsuranceCoverageType, relationship: InsuranceRelationship, memberId?: string | null, subscriberMemberId?: string | null, groupId?: string | null, groupName?: string | null, payerName: string, exclusions: Array<string>, sources: Array<InsuranceSource>, confirmedAt?: Date | null, stale: boolean, figuresFromSubscriber: boolean, checkProblem?: InsuranceCheckProblem | null, accountHolder: boolean, missing: Array<InsuranceCheckRequirement>, person: { __typename: 'InsurancePerson', firstName: string, lastName: string, dateOfBirth?: string | null }, payer?: { __typename: 'Payer', id: string, displayName: string, logoUrl?: string | null } | null, plan: { __typename: 'InsurancePlan', name?: string | null, type?: InsurancePlanType | null, network?: string | null, effectiveDate?: string | null, terminationDate?: string | null }, contacts?: { __typename: 'InsuranceContacts', memberServicesPhone?: string | null, providerServicesPhone?: string | null, preAuthorizationPhone?: string | null, mentalHealthPhone?: string | null, nurseLinePhone?: string | null, pharmacyHelpPhone?: string | null, claimsAddress?: { __typename: 'InsuranceAddress', line1?: string | null, line2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null, pharmacy?: { __typename: 'InsurancePharmacy', rxBin?: string | null, rxPcn?: string | null, rxGroup?: string | null, rxId?: string | null, pbmName?: string | null, pbmPhone?: string | null } | null, positions: Array<{ __typename: 'InsurancePosition', kind: InsurancePositionKind, scope: InsurancePositionScope, service: InsuranceCoverageType, network: InsuranceNetwork, headline: boolean, metAmount: number, limitAmount?: number | null, remainingAmount?: number | null, lastChangedAt?: Date | null, history: Array<{ __typename: 'InsurancePositionReading', observedAt: Date, observation: InsurancePositionReadingKind, network?: InsuranceNetwork | null, metAmount?: number | null, limitAmount?: number | null, delta?: number | null }> }>, costShares: Array<{ __typename: 'InsuranceCostShare', category: InsuranceCareCategory, network: InsuranceNetwork, source: InsuranceCostShareSource, covered?: boolean | null, authRequired?: boolean | null, notes: Array<string>, limit?: { __typename: 'InsuranceCareLimit', unlimited: boolean, quantity?: number | null, unit?: string | null, period?: InsuranceLimitPeriod | null } | null, copays: Array<{ __typename: 'InsuranceCostShareAmount', amount: number, default: boolean, providerTier?: InsuranceProviderTier | null, providerRole?: InsuranceProviderRole | null, billedBy?: InsuranceBilledBy | null, variesByLocation: boolean, deductibleApplies?: boolean | null, notes: Array<string> }>, coinsurances: Array<{ __typename: 'InsuranceCostShareAmount', amount: number, default: boolean, providerTier?: InsuranceProviderTier | null, providerRole?: InsuranceProviderRole | null, billedBy?: InsuranceBilledBy | null, variesByLocation: boolean, deductibleApplies?: boolean | null, notes: Array<string> }> }>, planYear?: { __typename: 'PlanYear', start?: string | null, end?: string | null, status: PlanYearStatus } | null, policyholder: { __typename: 'InsurancePolicyholder', firstName?: string | null, lastName?: string | null, self: boolean } }> } };

export type RetoolGetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RetoolGetUserQuery = { __typename: 'Query', User?: Array<{ __typename: 'User_Type', id: string, isAdmin: boolean, lastAuthenticatedAt?: string | null, notesAsHtml?: string | null, createdAt: string, emails?: Array<{ __typename: 'user__Email_Type', email: string }> | null, issues?: Array<{ __typename: 'issue__Issue_Type', id: string, caseRef: string, isEscalated: boolean, title?: string | null, openedAt: string, closedAt?: string | null, lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ChatEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string } | null, events?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string }> | null }> | null, hipaaRelease?: { __typename: 'consent__HipaaRelease_Type', id: string, grantedAt?: string | null, name?: string | null, dateOfBirth?: string | null, person?: { __typename: 'Person_Type', phoneNumber?: string | null } | null, signatureDocument?: { __typename: 'document__Document_Type', id: string, files?: Array<{ __typename: 'document__File_Type', id: string, s3Key?: string | null }> | null } | null } | null, templateReleases?: Array<{ __typename: 'consent__TemplateRelease_Type', id: string, grantedAt?: string | null, archivedAt?: string | null, documentValues?: string | null, template: { __typename: 'document__Template_Type', description: string }, document: { __typename: 'document__Document_Type', id: string, files?: Array<{ __typename: 'document__File_Type', s3Key?: string | null, s3Bucket: string }> | null } }> | null, webAgentLinks?: Array<{ __typename: 'webAgent__Link_Type', id: string, active: boolean, createdAt: string, lastSyncedAt?: string | null, deactivatedAt?: string | null, deactivatedReason?: webAgent__LinkDeactivatedReason | null, patientId?: string | null, patientDOB?: string | null, patientName?: string | null, latestExecution?: { __typename: 'webAgent__WebAgentExecution_Type', id: string, lastUserMfaMethods?: Array<webAgent__MfaMethod> | null } | null, endpoint: { __typename: 'webAgent__Endpoint_Type', displayName?: string | null, organization?: { __typename: 'integration__Organization_Type', displayName: string } | null } }> | null, persons?: Array<{ __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, primary: boolean, matchKeys: Array<string>, addresses?: Array<{ __typename: 'person__Address_Type', street: string, city: string, state: string, zip: string, primary: boolean }> | null }> | null }> | null, segment__UserSegment?: Array<{ __typename: 'segment__UserSegment_Type', segment: { __typename: 'segment__Segment_Type', id: string, key: string, displayName: string } }> | null };

export type RetoolGetUserPlansQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type RetoolGetUserPlansQuery = { __typename: 'Query', plan__Plan?: Array<{ __typename: 'plan__Plan_Type', id: string, planType?: plan__PlanType | null, planLabel?: string | null, coveragePeriod?: string | null, isActive?: boolean | null, coverageType?: fhir__CoverageType | null, activeCoverages?: Array<{ __typename: 'fhirext__CoverageVersion_Type', id: string, memberId?: string | null, groupId?: string | null, status: fhir__FinancialResourceStatus, relationship?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null, sourceDocument?: { __typename: 'document__Document_Type', source?: { __typename: 'webAgent__WebAgentExecution_Type', endpoint?: { __typename: 'flexpa__Endpoint_Type', slug?: string | null } | { __typename: 'webAgent__Endpoint_Type', slug?: string | null } | null, link?: { __typename: 'webAgent__Link_Type', endpoint: { __typename: 'webAgent__Endpoint_Type', slug?: string | null } } | null } | null } | null }> | null, sbc?: { __typename: 'document__Document_Type', id: string, vellumDocumentId?: string | null } | null, spd?: { __typename: 'document__Document_Type', id: string, vellumDocumentId?: string | null } | null, coc?: { __typename: 'document__Document_Type', id: string, vellumDocumentId?: string | null } | null, sob?: { __typename: 'document__Document_Type', id: string, vellumDocumentId?: string | null } | null, benefitsSummaryResults?: Array<{ __typename: 'plan__BenefitsSummaryResult_Type', summary: string }> | null }> | null };

export type RetoolGetLinkCDPInspectUrlQueryVariables = Exact<{
  linkId: Scalars['ID']['input'];
}>;


export type RetoolGetLinkCDPInspectUrlQuery = { __typename: 'Query', webAgent__WebAgentExecution?: Array<{ __typename: 'webAgent__WebAgentExecution_Type', cdpInspectUrl?: string | null, link?: { __typename: 'webAgent__Link_Type', id: string } | null }> | null };

export type RetoolUserQueryQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type RetoolUserQueryQuery = { __typename: 'Query', queryWebAgentExecutions: Array<{ __typename: 'WebAgentExecutionResult', id: string, type?: webAgent__WebExecutionType | null, cdpProvider?: webAgent__CDPProvider | null, createdAt: Date, lastUserMfaMethods: Array<webAgent__MfaMethod>, endpoint?: { __typename: 'EndpointSlug', slug?: string | null } | null, latestDiscoveryCrawl: Array<{ __typename: 'LatestDiscoveryCrawl', id: string, objectives?: Array<{ __typename: 'LatestDiscoveryCrawlObjective', dataSlug: string, status: webAgent__AiDiscoveryCrawlObjectiveResult }> | null }>, documents: Array<{ __typename: 'ExecutionResultDocument', dataType?: string | null, files: Array<{ __typename: 'ExecutionDocumentType', contentType: string }> }>, latestIngestion?: { __typename: 'LatestIngestion', id: string, status?: ingestion__IngestionStatus | null } | null, artifacts: Array<{ __typename: 'ExecutionResultArtifact', createdAt: Date, artifactType: string, result?: string | null, crawlType?: string | null }> }> };

export type UserDocumentRowFragment = { __typename: 'document__Document_Type', id: string, createdAt: string, dataType?: string | null, name: string, userVisible: boolean, internalIssueEvent?: Array<{ __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, issue: { __typename: 'issue__Issue_Type', id: string } }> | null, ingestions?: Array<{ __typename: 'ingestion__Ingestion_Type', status: ingestion__IngestionStatus }> | null, files?: Array<{ __typename: 'document__File_Type', name: string, id: string, s3Key?: string | null, s3Bucket: string, sizeBytes?: number | null, contentType?: string | null }> | null } & { ' $fragmentName'?: 'UserDocumentRowFragment' };

export type RetoolGetUserEhrDocumentsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type RetoolGetUserEhrDocumentsQuery = { __typename: 'Query', document__Document?: Array<(
    { __typename: 'document__Document_Type' }
    & { ' $fragmentRefs'?: { 'UserDocumentRowFragment': UserDocumentRowFragment } }
  )> | null };

export type RetoolGetUserDocumentsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type RetoolGetUserDocumentsQuery = { __typename: 'Query', document__Document?: Array<(
    { __typename: 'document__Document_Type' }
    & { ' $fragmentRefs'?: { 'UserDocumentRowFragment': UserDocumentRowFragment } }
  )> | null };

export type RetoolGetUserMemberCardDocumentsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type RetoolGetUserMemberCardDocumentsQuery = { __typename: 'Query', document__Document?: Array<(
    { __typename: 'document__Document_Type' }
    & { ' $fragmentRefs'?: { 'UserDocumentRowFragment': UserDocumentRowFragment } }
  )> | null };

export type RetoolUserDocumentsQueryVariables = Exact<{
  userID: Scalars['ID']['input'];
}>;


export type RetoolUserDocumentsQuery = { __typename: 'Query', queryUserUploadedDocuments: Array<{ __typename: 'UserUploadedDocumentsResult', id: string, createdAt: Date, dataType?: string | null, name: string, issueEvent: Array<{ __typename: 'UserDocumentIssueEvent', id: string, issue: { __typename: 'UserDocumentIssue', id: string } }>, latestIngestion?: { __typename: 'UserDocumentIngestion', id: string, status: string } | null, files: Array<{ __typename: 'UserDocumentFile', name: string, id: string }> } | null> };

export type SaveNotesMutationVariables = Exact<{
  input: SaveNotesInput;
}>;


export type SaveNotesMutation = { __typename: 'Mutation', saveNotes: { __typename: 'FormError' } | { __typename: 'SaveNotesSuccess', success: boolean } };

export type RetoolArchiveConsentReleaseMutationVariables = Exact<{
  input: ArchiveConsentReleaseInput;
}>;


export type RetoolArchiveConsentReleaseMutation = { __typename: 'Mutation', archiveConsentRelease: { __typename: 'ArchiveConsentReleaseSuccess', templateReleaseId: string } | { __typename: 'FormError' } };

export type RetoolOpenNewIssueMutationVariables = Exact<{
  input: StaffOpenNewIssueInput;
}>;


export type RetoolOpenNewIssueMutation = { __typename: 'Mutation', staffOpenNewIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type RetoolMergePersonsMutationVariables = Exact<{
  input: MergePersonsInput;
}>;


export type RetoolMergePersonsMutation = { __typename: 'Mutation', mergePersons?: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } | { __typename: 'Person_Type', id: string } | null };

export type RetoolForceDeactiveLinkMutationVariables = Exact<{
  input: ForceDeactivateLinkInput;
}>;


export type RetoolForceDeactiveLinkMutation = { __typename: 'Mutation', forceDeactivateLink?: { __typename: 'BasicSuccessResponse', success: boolean } | null };

export type RetoolStartLinkSignInMutationVariables = Exact<{
  input?: InputMaybe<StartLinkSignInInput>;
}>;


export type RetoolStartLinkSignInMutation = { __typename: 'Mutation', startLinkSignIn?: { __typename: 'StartLinkSignInResponse', success: boolean } | null };

export type RetoolMeEmailQueryVariables = Exact<{ [key: string]: never; }>;


export type RetoolMeEmailQuery = { __typename: 'Query', me?: { __typename: 'User_Type', primaryEmail?: string | null } | null };

export type ProviderHitFieldsFragment = { __typename: 'provider__Provider_Type', id: string, displayName: string, slug?: string | null, kind: provider__ProviderKind, city?: string | null, state?: string | null, source?: provider__Source | null, isActive: boolean, aliases?: Array<string> | null } & { ' $fragmentName'?: 'ProviderHitFieldsFragment' };

export type ProviderRecordFieldsFragment = (
  { __typename: 'provider__Provider_Type', npi?: string | null, ccn?: string | null, systemName?: string | null, addressLine1?: string | null, addressLine2?: string | null, county?: string | null, postalCode?: string | null, faPolicyUrl?: string | null, faPolicy?: string | null, notes?: Array<string> | null, verified: boolean, lastVerified?: string | null, verifiedBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, negotiation?: { __typename: 'provider__NegotiationProfile_Type', id: string, insuredStance?: provider__NegotiationStance | null, discountPctMin?: number | null, discountPctMax?: number | null, offersPaymentPlans?: boolean | null, paymentPlanMaxMonths?: number | null, hipaaTurnaroundDays?: number | null, pricingVsMarket?: number | null, verified: boolean, lastVerified?: string | null, verifiedBy?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null } | null, partOf?: { __typename: 'provider__Provider_Type', id: string, displayName: string } | null, contactPoints?: Array<{ __typename: 'provider__ContactPoint_Type', id: string, kind: provider__ContactKind, purpose: provider__ContactPurpose, value: string, source?: provider__Source | null, verified: boolean, lastVerified?: string | null, notes?: string | null }> | null }
  & { ' $fragmentRefs'?: { 'ProviderHitFieldsFragment': ProviderHitFieldsFragment } }
) & { ' $fragmentName'?: 'ProviderRecordFieldsFragment' };

export type InternalProviderSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type InternalProviderSearchQuery = { __typename: 'Query', searchProviders: Array<{ __typename: 'ProviderSearchResult', id: string, name: string, slug?: string | null, kind?: provider__ProviderKind | null, city?: string | null, state?: string | null, source?: provider__Source | null, isActive?: boolean | null, aliases?: Array<string> | null, phones?: Array<string> | null, matchHint?: { __typename: 'ProviderSearchMatchHint', kind: ProviderSearchMatchKind, text: string } | null }> };

export type InternalSystemSearchQueryVariables = Exact<{
  pattern: Scalars['String']['input'];
}>;


export type InternalSystemSearchQuery = { __typename: 'Query', provider__Provider?: Array<(
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderHitFieldsFragment': ProviderHitFieldsFragment } }
  )> | null };

export type InternalProviderFaPolicyResolutionQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type InternalProviderFaPolicyResolutionQuery = { __typename: 'Query', providerFaPolicyResolution?: { __typename: 'FaPolicyResolution', kind: FaPolicyResolutionKind, policy?: string | null, invalidReasons?: Array<string> | null, inheritedFromProvider?: { __typename: 'FaPolicyInheritanceSource', id: string, displayName: string } | null } | null };

export type InternalProviderByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalProviderByIdQuery = { __typename: 'Query', provider__Provider?: Array<(
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderRecordFieldsFragment': ProviderRecordFieldsFragment } }
  )> | null };

type ProviderResultFields_FormError_Fragment = { __typename: 'FormError', message?: string | null } & { ' $fragmentName'?: 'ProviderResultFields_FormError_Fragment' };

type ProviderResultFields_provider__Provider_Type_Fragment = { __typename: 'provider__Provider_Type', id: string } & { ' $fragmentName'?: 'ProviderResultFields_provider__Provider_Type_Fragment' };

export type ProviderResultFieldsFragment = ProviderResultFields_FormError_Fragment | ProviderResultFields_provider__Provider_Type_Fragment;

export type InternalCalibrationPreviewQueryVariables = Exact<{
  input: CalibrationPreviewInput;
}>;


export type InternalCalibrationPreviewQuery = { __typename: 'Query', calibrationPreview?: { __typename: 'CalibrationPreview', formSpec: string, report: string } | { __typename: 'FormError', message?: string | null } | null };

export type InternalCreateProviderMutationVariables = Exact<{
  input: CreateProviderInput;
}>;


export type InternalCreateProviderMutation = { __typename: 'Mutation', createProvider?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalUpdateProviderMutationVariables = Exact<{
  input: UpdateProviderInput;
}>;


export type InternalUpdateProviderMutation = { __typename: 'Mutation', updateProvider?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalDeleteProviderMutationVariables = Exact<{
  input: DeleteProviderInput;
}>;


export type InternalDeleteProviderMutation = { __typename: 'Mutation', deleteProvider?: { __typename: 'FormError', message?: string | null } | { __typename: 'ProviderDeleted', deletedId: string } | null };

export type InternalVerifyProviderMutationVariables = Exact<{
  input: VerifyProviderInput;
}>;


export type InternalVerifyProviderMutation = { __typename: 'Mutation', verifyProvider?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalVerifyNegotiationMutationVariables = Exact<{
  input: VerifyNegotiationProfileInput;
}>;


export type InternalVerifyNegotiationMutation = { __typename: 'Mutation', verifyNegotiationProfile?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalUpsertNegotiationMutationVariables = Exact<{
  input: UpsertNegotiationProfileInput;
}>;


export type InternalUpsertNegotiationMutation = { __typename: 'Mutation', upsertNegotiationProfile?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalUpsertFaPolicyMutationVariables = Exact<{
  input: UpsertProviderFaPolicyInput;
}>;


export type InternalUpsertFaPolicyMutation = { __typename: 'Mutation', upsertProviderFaPolicy?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalRemoveFaPolicyMutationVariables = Exact<{
  input: RemoveProviderFaPolicyInput;
}>;


export type InternalRemoveFaPolicyMutation = { __typename: 'Mutation', removeProviderFaPolicy?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalRemoveNegotiationMutationVariables = Exact<{
  input: RemoveNegotiationProfileInput;
}>;


export type InternalRemoveNegotiationMutation = { __typename: 'Mutation', removeNegotiationProfile?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalUpsertContactMutationVariables = Exact<{
  input: UpsertProviderContactPointInput;
}>;


export type InternalUpsertContactMutation = { __typename: 'Mutation', upsertProviderContactPoint?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalRemoveContactMutationVariables = Exact<{
  input: RemoveProviderContactPointInput;
}>;


export type InternalRemoveContactMutation = { __typename: 'Mutation', removeProviderContactPoint?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

type ProviderFormUploadResultFields_FormError_Fragment = { __typename: 'FormError', message?: string | null } & { ' $fragmentName'?: 'ProviderFormUploadResultFields_FormError_Fragment' };

type ProviderFormUploadResultFields_ProviderFormUploadTarget_Fragment = { __typename: 'ProviderFormUploadTarget', s3Bucket: string, s3Key: string, s3PutUrl: string } & { ' $fragmentName'?: 'ProviderFormUploadResultFields_ProviderFormUploadTarget_Fragment' };

export type ProviderFormUploadResultFieldsFragment = ProviderFormUploadResultFields_FormError_Fragment | ProviderFormUploadResultFields_ProviderFormUploadTarget_Fragment;

export type InternalPrepareFormUploadMutationVariables = Exact<{
  input: PrepareProviderFormUploadInput;
}>;


export type InternalPrepareFormUploadMutation = { __typename: 'Mutation', prepareProviderFormUpload?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderFormUploadResultFields_FormError_Fragment': ProviderFormUploadResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'ProviderFormUploadTarget' }
    & { ' $fragmentRefs'?: { 'ProviderFormUploadResultFields_ProviderFormUploadTarget_Fragment': ProviderFormUploadResultFields_ProviderFormUploadTarget_Fragment } }
  ) | null };

type ProviderFormResultFields_FormError_Fragment = { __typename: 'FormError', message?: string | null } & { ' $fragmentName'?: 'ProviderFormResultFields_FormError_Fragment' };

type ProviderFormResultFields_provider__ProviderForm_Type_Fragment = { __typename: 'provider__ProviderForm_Type', id: string } & { ' $fragmentName'?: 'ProviderFormResultFields_provider__ProviderForm_Type_Fragment' };

export type ProviderFormResultFieldsFragment = ProviderFormResultFields_FormError_Fragment | ProviderFormResultFields_provider__ProviderForm_Type_Fragment;

export type InternalUpsertProviderFormMutationVariables = Exact<{
  input: UpsertProviderFormInput;
}>;


export type InternalUpsertProviderFormMutation = { __typename: 'Mutation', upsertProviderForm?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderFormResultFields_FormError_Fragment': ProviderFormResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__ProviderForm_Type' }
    & { ' $fragmentRefs'?: { 'ProviderFormResultFields_provider__ProviderForm_Type_Fragment': ProviderFormResultFields_provider__ProviderForm_Type_Fragment } }
  ) | null };

export type InternalCalibrateProviderFormMutationVariables = Exact<{
  input: CalibrateProviderFormInput;
}>;


export type InternalCalibrateProviderFormMutation = { __typename: 'Mutation', calibrateProviderForm?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderFormResultFields_FormError_Fragment': ProviderFormResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__ProviderForm_Type' }
    & { ' $fragmentRefs'?: { 'ProviderFormResultFields_provider__ProviderForm_Type_Fragment': ProviderFormResultFields_provider__ProviderForm_Type_Fragment } }
  ) | null };

export type InternalSetProviderFormShapingMutationVariables = Exact<{
  input: SetProviderFormShapingInput;
}>;


export type InternalSetProviderFormShapingMutation = { __typename: 'Mutation', setProviderFormShaping?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderFormResultFields_FormError_Fragment': ProviderFormResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__ProviderForm_Type' }
    & { ' $fragmentRefs'?: { 'ProviderFormResultFields_provider__ProviderForm_Type_Fragment': ProviderFormResultFields_provider__ProviderForm_Type_Fragment } }
  ) | null };

export type InternalRenameProviderFormMutationVariables = Exact<{
  input: RenameProviderFormInput;
}>;


export type InternalRenameProviderFormMutation = { __typename: 'Mutation', renameProviderForm?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderFormResultFields_FormError_Fragment': ProviderFormResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__ProviderForm_Type' }
    & { ' $fragmentRefs'?: { 'ProviderFormResultFields_provider__ProviderForm_Type_Fragment': ProviderFormResultFields_provider__ProviderForm_Type_Fragment } }
  ) | null };

export type InternalRemoveProviderFormMutationVariables = Exact<{
  input: RemoveProviderFormInput;
}>;


export type InternalRemoveProviderFormMutation = { __typename: 'Mutation', removeProviderForm?: (
    { __typename: 'FormError' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_FormError_Fragment': ProviderResultFields_FormError_Fragment } }
  ) | (
    { __typename: 'provider__Provider_Type' }
    & { ' $fragmentRefs'?: { 'ProviderResultFields_provider__Provider_Type_Fragment': ProviderResultFields_provider__Provider_Type_Fragment } }
  ) | null };

export type InternalStartProviderFormDetectionMutationVariables = Exact<{
  input: StartProviderFormDetectionInput;
}>;


export type InternalStartProviderFormDetectionMutation = { __typename: 'Mutation', startProviderFormDetection: { __typename: 'FormError', message?: string | null } | { __typename: 'ProviderFormDetectionStarted', workflowId: string, priorDetectedAt?: string | null, priorFailedAt?: string | null } };

export type InternalProviderFormDetectionQueryVariables = Exact<{
  input: ProviderFormDetectionInput;
}>;


export type InternalProviderFormDetectionQuery = { __typename: 'Query', providerFormDetection: { __typename: 'ProviderFormDetection', detectedAt?: string | null, detectionFailedAt?: string | null, detectedWidgetCount?: number | null } };

export type ResearchRunFieldsFragment = { __typename: 'ProviderResearchRun', id: string, status: provider__ResearchRunStatus, requestedAt: string, startedAt?: string | null, finishedAt?: string | null, engine?: string | null, skillVersion?: string | null, turns?: number | null, claimsKept?: number | null, contactsKept?: number | null, costUsd?: number | null, notesWritten?: boolean | null, error?: string | null, requestedBy?: { __typename: 'ProviderResearchRequester', primaryEmail?: string | null } | null } & { ' $fragmentName'?: 'ResearchRunFieldsFragment' };

export type InternalProviderResearchRunsQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InternalProviderResearchRunsQuery = { __typename: 'Query', providerResearchRuns: Array<(
    { __typename: 'ProviderResearchRun' }
    & { ' $fragmentRefs'?: { 'ResearchRunFieldsFragment': ResearchRunFieldsFragment } }
  )> };

export type InternalRequestProviderResearchMutationVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type InternalRequestProviderResearchMutation = { __typename: 'Mutation', requestProviderResearch?: (
    { __typename: 'ProviderResearchRun' }
    & { ' $fragmentRefs'?: { 'ResearchRunFieldsFragment': ResearchRunFieldsFragment } }
  ) | null };

export type InternalProviderFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type InternalProviderFormsQuery = { __typename: 'Query', provider__ProviderForm?: Array<{ __typename: 'provider__ProviderForm_Type', id: string, name: string, formType: provider__FormType, formUrl?: string | null, revision: number, detectedAt?: string | null, detectionFailedAt?: string | null, calibratedAt?: string | null, submissionChannel?: provider__SubmissionChannel | null, provider: { __typename: 'provider__Provider_Type', id: string, displayName: string, slug?: string | null, city?: string | null, state?: string | null, faPolicyUrl?: string | null } }> | null };

export type InternalProviderFormsForQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type InternalProviderFormsForQuery = { __typename: 'Query', provider__ProviderForm?: Array<{ __typename: 'provider__ProviderForm_Type', id: string, name: string, formType: provider__FormType, formUrl?: string | null, revision: number, detectedAt?: string | null, detectionFailedAt?: string | null, calibratedAt?: string | null, submissionChannel?: provider__SubmissionChannel | null, provider: { __typename: 'provider__Provider_Type', id: string, displayName: string, slug?: string | null, city?: string | null, state?: string | null, faPolicyUrl?: string | null } }> | null };

export type InternalProviderFormByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalProviderFormByIdQuery = { __typename: 'Query', provider__ProviderForm?: Array<{ __typename: 'provider__ProviderForm_Type', id: string, name: string, formType: provider__FormType, formUrl?: string | null, revision: number, detectedAt?: string | null, detectionFailedAt?: string | null, calibratedAt?: string | null, submissionChannel?: provider__SubmissionChannel | null, provider: { __typename: 'provider__Provider_Type', id: string, displayName: string, slug?: string | null, city?: string | null, state?: string | null, faPolicyUrl?: string | null } }> | null };

export type InternalProviderByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type InternalProviderByNameQuery = { __typename: 'Query', provider__Provider?: Array<{ __typename: 'provider__Provider_Type', id: string, displayName: string, slug?: string | null, city?: string | null, state?: string | null, faPolicyUrl?: string | null, forms?: Array<{ __typename: 'provider__ProviderForm_Type', id: string, name: string, formType: provider__FormType, submissionChannel?: provider__SubmissionChannel | null, formUrl?: string | null, revision: number }> | null }> | null };

export type InternalProviderByAliasQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type InternalProviderByAliasQuery = { __typename: 'Query', provider__Provider?: Array<{ __typename: 'provider__Provider_Type', id: string, displayName: string, slug?: string | null, city?: string | null, state?: string | null, faPolicyUrl?: string | null, forms?: Array<{ __typename: 'provider__ProviderForm_Type', id: string, name: string, formType: provider__FormType, submissionChannel?: provider__SubmissionChannel | null, formUrl?: string | null, revision: number }> | null }> | null };

export type GetHealthSystemLinkedProvidersQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetHealthSystemLinkedProvidersQuery = { __typename: 'Query', provider__Provider?: Array<{ __typename: 'provider__Provider_Type', id: string, displayName: string, kind: provider__ProviderKind, city?: string | null, state?: string | null, npi?: string | null, isActive: boolean }> | null };

export type AssignUserSegmentMutationVariables = Exact<{
  input: AssignUserSegmentInput;
}>;


export type AssignUserSegmentMutation = { __typename: 'Mutation', assignUserSegment: { __typename: 'AssignUserSegmentResult', assignedCount: number } };

export type RemoveUserSegmentMutationVariables = Exact<{
  input: RemoveUserSegmentInput;
}>;


export type RemoveUserSegmentMutation = { __typename: 'Mutation', removeUserSegment: { __typename: 'RemoveUserSegmentResult', removedCount: number } };

export type SegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type SegmentsQuery = { __typename: 'Query', segment__Segment?: Array<{ __typename: 'segment__Segment_Type', id: string, key: string, displayName: string }> | null };

export type UserSegmentKeysQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserSegmentKeysQuery = { __typename: 'Query', segment__UserSegment?: Array<{ __typename: 'segment__UserSegment_Type', segment: { __typename: 'segment__Segment_Type', key: string } }> | null };

export type UsersSegmentsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']>;
}>;


export type UsersSegmentsQuery = { __typename: 'Query', segment__UserSegment?: Array<{ __typename: 'segment__UserSegment_Type', user: { __typename: 'User_Type', id: string }, segment: { __typename: 'segment__Segment_Type', id: string, key: string, displayName: string } }> | null };

export type UserSegmentsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserSegmentsQuery = { __typename: 'Query', segment__UserSegment?: Array<{ __typename: 'segment__UserSegment_Type', isActive: boolean, segment: { __typename: 'segment__Segment_Type', id: string, key: string, displayName: string } }> | null };

export type InternalProviderFormInternalTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type InternalProviderFormInternalTemplateQuery = { __typename: 'Query', provider__ProviderForm?: Array<{ __typename: 'provider__ProviderForm_Type', internalTemplate?: string | null, revision: number }> | null };

export type InternalStaffTailgateViewFragment = { __typename: 'StaffTailgateView', executionId: string, memberUserId: string, linkId: string, portalName: string, phase: StaffTailgatePhase, holdUntil?: Date | null, ask?: { __typename: 'StaffTailgateAsk', askId: string, kind: string, portalMessage?: string | null, expiresAt: Date, form: { __typename: 'StaffTailgateChoose', maxChoices: number, options: Array<{ __typename: 'StaffTailgateChoice', id: string, label: string }> } | { __typename: 'StaffTailgateConfirm', prompt: string } | { __typename: 'StaffTailgateFillIn', fields: Array<{ __typename: 'StaffTailgateField', name: string, label: string, secret: boolean }> }, actions: Array<{ __typename: 'StaffTailgateAction', id: string, label: string }> } | null, browsers: Array<{ __typename: 'StaffTailgateBrowser', sessionId: string, vncUrl: string }>, steps: Array<{ __typename: 'StaffTailgateStep', at: Date, label: string }>, files: Array<{ __typename: 'StaffTailgateFile', documentId: string, name: string, contentType: string, size: number, sha256: string, takenAt: Date, sentToIngestion: boolean }>, ending?: { __typename: 'StaffTailgateEnding', outcome: StaffTailgateOutcome, reason: string } | null } & { ' $fragmentName'?: 'InternalStaffTailgateViewFragment' };

export type InternalStaffTailgateQueryVariables = Exact<{
  executionId: Scalars['String']['input'];
}>;


export type InternalStaffTailgateQuery = { __typename: 'Query', staffTailgate: (
    { __typename: 'StaffTailgateView' }
    & { ' $fragmentRefs'?: { 'InternalStaffTailgateViewFragment': InternalStaffTailgateViewFragment } }
  ) };

export type InternalStartStaffTailgateMutationVariables = Exact<{
  input: StartStaffTailgateInput;
}>;


export type InternalStartStaffTailgateMutation = { __typename: 'Mutation', startStaffTailgate: { __typename: 'StaffTailgateRefused', refusal: StaffTailgateRefusal, message: string } | { __typename: 'StaffTailgateStarted', executionId: string } };

export type InternalAnswerStaffTailgateMutationVariables = Exact<{
  input: AnswerStaffTailgateInput;
}>;


export type InternalAnswerStaffTailgateMutation = { __typename: 'Mutation', answerStaffTailgate: (
    { __typename: 'StaffTailgateView' }
    & { ' $fragmentRefs'?: { 'InternalStaffTailgateViewFragment': InternalStaffTailgateViewFragment } }
  ) };

export type InternalExtendStaffTailgateMutationVariables = Exact<{
  input: StaffTailgateIdInput;
}>;


export type InternalExtendStaffTailgateMutation = { __typename: 'Mutation', extendStaffTailgate: (
    { __typename: 'StaffTailgateView' }
    & { ' $fragmentRefs'?: { 'InternalStaffTailgateViewFragment': InternalStaffTailgateViewFragment } }
  ) };

export type InternalFinishStaffTailgateMutationVariables = Exact<{
  input: StaffTailgateIdInput;
}>;


export type InternalFinishStaffTailgateMutation = { __typename: 'Mutation', finishStaffTailgate: (
    { __typename: 'StaffTailgateView' }
    & { ' $fragmentRefs'?: { 'InternalStaffTailgateViewFragment': InternalStaffTailgateViewFragment } }
  ) };

export type InternalCancelStaffTailgateMutationVariables = Exact<{
  input: StaffTailgateIdInput;
}>;


export type InternalCancelStaffTailgateMutation = { __typename: 'Mutation', cancelStaffTailgate: (
    { __typename: 'StaffTailgateView' }
    & { ' $fragmentRefs'?: { 'InternalStaffTailgateViewFragment': InternalStaffTailgateViewFragment } }
  ) };

export type InternalIngestStaffTailgateFileMutationVariables = Exact<{
  input: IngestStaffTailgateFileInput;
}>;


export type InternalIngestStaffTailgateFileMutation = { __typename: 'Mutation', ingestStaffTailgateFile: { __typename: 'BasicSuccessResponse', success: boolean } };

export type HaMyTasksQueryVariables = Exact<{
  filter: HaMyTasksFilter;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
}>;


export type HaMyTasksQuery = { __typename: 'Query', haMyTasks: Array<{ __typename: 'taskManagement__DataQualityFlagTask_Type', sourceName: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, resource: { __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string } | { __typename: 'fhirext__InvoiceVersion_Type', id: string } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__GeneralIssueTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__IssueResearchTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__IssueTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__IssueUserMessagingTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__PhoneCallIssueTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__RetryChargeIssueTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__ReviewEscalatedCaseTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__ReviewFindingTask_Type', id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, finding: { __typename: 'fhirext__Finding_Type', id: string, resource: { __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string } | { __typename: 'fhirext__InvoiceVersion_Type', id: string } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string } }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__ReviewIssueChatTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__ReviewSuggestionTask_Type', caseRef: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__SendFormIssueTask_Type', caseRef: string, formType: string, formSender: string, sendingMethod: string, id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, memberMessagesAwaitingReply?: Array<{ __typename: 'issue__AskReraisedEvent_Type', sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ChatEvent_Type', sentAt: string } | { __typename: 'issue__ClosedEvent_Type', sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', sentAt: string } | { __typename: 'issue__CommentEvent_Type', sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', sentAt: string } | { __typename: 'issue__OutreachEvent_Type', sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', sentAt: string }> | null }, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null } | { __typename: 'taskManagement__Task_Type', id: string, type: taskManagement__TaskType, priority: number, status: taskManagement__TaskStatus, title: string, dedupeKey?: string | null, description?: string | null, dueDate?: string | null, createdAt: string, updatedAt: string, assignee?: { __typename: 'User_Type', id: string, primaryEmail?: string | null } | null, comments?: Array<{ __typename: 'taskManagement__TaskComment_Type', id: string }> | null }> };

export type HaMyTasksCountQueryVariables = Exact<{
  filter: HaMyTasksFilter;
}>;


export type HaMyTasksCountQuery = { __typename: 'Query', haMyTasksCount: number };

export type RetoolUpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type RetoolUpdateTaskMutation = { __typename: 'Mutation', updateTask?: { __typename: 'taskManagement__DataQualityFlagTask_Type', id: string } | { __typename: 'taskManagement__FollowUpClosurePendingIssueTask_Type', id: string } | { __typename: 'taskManagement__FollowUpUserUnresponsiveIssueTask_Type', id: string } | { __typename: 'taskManagement__GeneralIssueTask_Type', id: string } | { __typename: 'taskManagement__IssueResearchTask_Type', id: string } | { __typename: 'taskManagement__IssueTask_Type', id: string } | { __typename: 'taskManagement__IssueUserMessagingTask_Type', id: string } | { __typename: 'taskManagement__PhoneCallIssueTask_Type', id: string } | { __typename: 'taskManagement__ProcessCustomerBillPaymentIssueTask_Type', id: string } | { __typename: 'taskManagement__RetryChargeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewCaseIntakeIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewEscalatedCaseTask_Type', id: string } | { __typename: 'taskManagement__ReviewFindingTask_Type', id: string } | { __typename: 'taskManagement__ReviewIssueChatTask_Type', id: string } | { __typename: 'taskManagement__ReviewPaymentAcceptanceIssueTask_Type', id: string } | { __typename: 'taskManagement__ReviewSuggestionTask_Type', id: string } | { __typename: 'taskManagement__SendFormIssueTask_Type', id: string } | { __typename: 'taskManagement__Task_Type', id: string } | null };

export type RecordHaEventsMutationVariables = Exact<{
  events: Array<HaEventInput>;
}>;


export type RecordHaEventsMutation = { __typename: 'Mutation', recordHaEvents: { __typename: 'HaEventAck', accepted: number } };

export type HaUserCoverageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HaUserCoverageQuery = { __typename: 'Query', projection__UserDataView?: Array<{ __typename: 'projection__UserDataView_Type', id: string, kind: string, key: string, data: string, metadata?: string | null, createdAt: string }> | null };

export type GenerateMetabaseSignedUrlMutationVariables = Exact<{
  input: MetabaseSignedUrlInput;
}>;


export type GenerateMetabaseSignedUrlMutation = { __typename: 'Mutation', generateMetabaseSignedUrl: { __typename: 'MetabaseSignedUrl', url: string } };

export type InternalStoredCalibrationQueryVariables = Exact<{
  providerId: Scalars['ID']['input'];
}>;


export type InternalStoredCalibrationQuery = { __typename: 'Query', provider__ProviderForm?: Array<{ __typename: 'provider__ProviderForm_Type', id: string, formType: provider__FormType, revision: number, internalTemplate?: string | null }> | null };

export type HaUserRecordsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type HaUserRecordsQuery = { __typename: 'Query', projection__UserDataView?: Array<{ __typename: 'projection__UserDataView_Type', id: string, kind: string, key: string, data: string, metadata?: string | null, createdAt: string }> | null };

export type UserResourcesQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserResourcesQuery = { __typename: 'Query', User?: Array<{ __typename: 'User_Type', id: string, createdAt: string, emails?: Array<{ __typename: 'user__Email_Type', email: string }> | null, primaryPerson?: { __typename: 'Person_Type', givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string } | null }> | null, projection__UserDataView?: Array<{ __typename: 'projection__UserDataView_Type', id: string, kind: string, key: string, data: string, metadata?: string | null, createdAt: string }> | null };

export type UserEnrichmentQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  keys: Array<Scalars['String']['input']>;
}>;


export type UserEnrichmentQuery = { __typename: 'Query', projection__UserEnrichmentData?: Array<{ __typename: 'projection__UserEnrichmentData_Type', kind: string, key: string, title?: string | null, overallPriceRating?: projection__EnrichmentPriceRating | null, confidence?: projection__EnrichmentConfidence | null, enrichments?: string | null }> | null };

export type AccountLinksQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type AccountLinksQuery = { __typename: 'Query', webAgent__Link?: Array<{ __typename: 'webAgent__Link_Type', id: string, active: boolean, createdAt: string, lastSyncedAt?: string | null, deactivatedAt?: string | null, deactivatedReason?: webAgent__LinkDeactivatedReason | null, patientName?: string | null, patientId?: string | null, endpoint: { __typename: 'webAgent__Endpoint_Type', displayName?: string | null, slug?: string | null, displayUrl: string }, latestExecution?: { __typename: 'webAgent__WebAgentExecution_Type', id: string, latestStatus?: webAgent__WebExecutionStatus | null, createdAt: string } | null }> | null };

export type UserDocumentsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserDocumentsQuery = { __typename: 'Query', document__Document?: Array<{ __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, sides?: Array<string> | null, createdAt: string, participant: Participant, userVisible: boolean, summary?: { __typename: 'document__DocumentSummary_Type', summary: string } | { __typename: 'issue__IssueDocumentSummary_Type', summary: string } | null, source?: { __typename: 'webAgent__WebAgentExecution_Type', type?: webAgent__WebExecutionType | null, endpoint?: { __typename: 'flexpa__Endpoint_Type', displayName?: string | null } | { __typename: 'webAgent__Endpoint_Type', displayName?: string | null } | null } | null, files?: Array<{ __typename: 'document__File_Type', s3Bucket: string, s3Key?: string | null, contentType?: string | null, name: string }> | null }> | null };

export type AskGrantedMutationVariables = Exact<{
  input: LlmInput;
}>;


export type AskGrantedMutation = { __typename: 'Mutation', queryOpenai: { __typename: 'LlmResponse', message?: string | null } };

export type PrimaryPersonQueryVariables = Exact<{ [key: string]: never; }>;


export type PrimaryPersonQuery = { __typename: 'Query', me?: { __typename: 'User_Type', primaryPerson?: { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null } | null } | null };

export type AddressAutocompleteQueryVariables = Exact<{
  input: AddressAutocompleteInput;
}>;


export type AddressAutocompleteQuery = { __typename: 'Query', addressAutocomplete?: { __typename: 'AddressAutocompleteResponse', count: number, predictions: Array<{ __typename: 'AddressPrediction', placeId: string, description: string, mainText: string, secondaryText: string, types: Array<string> }> } | null };

export type AddressDetailsQueryVariables = Exact<{
  input: AddressDetailsInput;
}>;


export type AddressDetailsQuery = { __typename: 'Query', addressDetails?: { __typename: 'AddressDetails', placeId: string, formattedAddress: string, street?: string | null, city?: string | null, state?: string | null, zip?: string | null, county?: string | null, country?: string | null, latitude: number, longitude: number } | null };

export type GetPaymentProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentProfileQuery = { __typename: 'Query', getPaymentProfile?: { __typename: 'PaymentProfile', id: string, stripeCustomerId: string, stripePaymentMethodId?: string | null, createdAt: string, updatedAt: string, hasPaymentMethod: boolean, paymentMethodType?: string | null, state?: string | null, zip?: string | null, country?: string | null, cardDetails?: { __typename: 'CardDetails', brand: string, last4: string, walletType?: string | null } | null } | null };

export type UpdatePaymentAgreementEventMutationVariables = Exact<{
  input: UpdatePaymentAgreementEventInput;
}>;


export type UpdatePaymentAgreementEventMutation = { __typename: 'Mutation', updatePaymentAgreementEvent?: { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | null };

export type AcceptBillPayMutationVariables = Exact<{
  input: AcceptBillPayInput;
}>;


export type AcceptBillPayMutation = { __typename: 'Mutation', acceptBillPay?: { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | null };

export type GetActivePromoForIssueQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type GetActivePromoForIssueQuery = { __typename: 'Query', getActivePromoForIssue?: { __typename: 'ActivePromoForIssue', code: string, stripeDiscountPreview?: { __typename: 'StripePromoDiscountPreview', code: string, amountOffCents?: number | null, percentOff?: number | null } | null } | null };

export type ApplyPromoCodeUsageMutationVariables = Exact<{
  input: ApplyPromoCodeUsageInput;
}>;


export type ApplyPromoCodeUsageMutation = { __typename: 'Mutation', applyPromoCodeUsage: { __typename: 'ApplyPromoCodeUsageSuccess', promoCodeUsage: { __typename: 'PromoCodeUsageInfo', id: string, issueId?: string | null, usedAt?: string | null, promoCode: { __typename: 'payment__PromoCode_Type', id: string, code: string, isActive: boolean } }, stripeDiscountPreview?: { __typename: 'StripePromoDiscountPreview', code: string, amountOffCents?: number | null, percentOff?: number | null } | null } | { __typename: 'FormError', message?: string | null } };

export type MarkPromoCodeUsageAsUnusedMutationVariables = Exact<{
  input: MarkPromoCodeUsageAsUnusedInput;
}>;


export type MarkPromoCodeUsageAsUnusedMutation = { __typename: 'Mutation', markPromoCodeUsageAsUnused?: { __typename: 'MarkPromoCodeUsageAsUnusedResponse', promoCodeUsage?: { __typename: 'PromoCodeUsageInfo', id: string, issueId?: string | null, usedAt?: string | null, promoCode: { __typename: 'payment__PromoCode_Type', id: string, code: string, isActive: boolean } } | null } | null };

export type CreateIssueFeedbackMutationVariables = Exact<{
  input: CreateIssueFeedbackInput;
}>;


export type CreateIssueFeedbackMutation = { __typename: 'Mutation', createIssueFeedback: { __typename: 'CreateFeedbackResult', success: boolean } };

export type ReopenIssueMutationVariables = Exact<{
  input: ReopenIssueInput;
}>;


export type ReopenIssueMutation = { __typename: 'Mutation', reopenIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type SendMagicLinkMutationVariables = Exact<{
  input: SendMagicLinkInput;
}>;


export type SendMagicLinkMutation = { __typename: 'Mutation', sendMagicLink: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } | { __typename: 'SendMagicLinkResponse', created: boolean, user: { __typename: 'AuthUser', id: string, isAdmin: boolean, isShadow: boolean, adminUserId?: string | null } } };

export type ResendMagicLinkMutationVariables = Exact<{
  input: ResendMagicLinkInput;
}>;


export type ResendMagicLinkMutation = { __typename: 'Mutation', resendMagicLink: { __typename: 'ResendMagicLinkResult', success: boolean } };

export type AuthenticateMutationVariables = Exact<{
  input: AuthenticateInput;
}>;


export type AuthenticateMutation = { __typename: 'Mutation', authenticate: { __typename: 'AuthenticateError', success: boolean, errorType: AuthenticateResultErrorType } | { __typename: 'AuthenticateSuccess', success: boolean, firstAuthentication: boolean, email?: string | null, hasPendingNateraIntake: boolean, hasNateraCaseAwaitingActivation: boolean, partner?: { __typename: 'InviteTokenPartner', id: string, slug: string, name: string } | null, user: { __typename: 'AuthUser', id: string, isAdmin: boolean, isShadow: boolean, adminUserId?: string | null } } };

export type AuthenticateWithInviteMutationVariables = Exact<{
  input: AuthenticateInput;
  inviteToken: Scalars['String']['input'];
}>;


export type AuthenticateWithInviteMutation = { __typename: 'Mutation', authenticateWithInvite: { __typename: 'AuthenticateError', success: boolean, errorType: AuthenticateResultErrorType } | { __typename: 'AuthenticateWithInviteSuccess', success: boolean, firstAuthentication: boolean, email?: string | null, hasNateraCaseAwaitingActivation: boolean, partner: { __typename: 'InviteTokenPartner', id: string, slug: string, name: string }, user: { __typename: 'AuthUser', id: string, isAdmin: boolean, isShadow: boolean, adminUserId?: string | null } } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename: 'Mutation', logout: boolean };

export type ShadowLoginMutationVariables = Exact<{
  input: ShadowLoginInput;
}>;


export type ShadowLoginMutation = { __typename: 'Mutation', shadowLogin: { __typename: 'AuthUser', id: string, isAdmin: boolean, isShadow: boolean, adminUserId?: string | null } | { __typename: 'FormError', fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, isAdmin: boolean, primaryEmail?: string | null, createdAt: string, lastAuthenticatedAt?: string | null, acceptedTermsAt?: string | null, profile: { __typename: 'user__Profile_Type', name?: string | null }, segmentationData?: { __typename: 'user__SegmentationData_Type', features?: Array<string> | null } | null } | null, viewerPartner?: { __typename: 'InviteTokenPartner', id: string, slug: string, name: string } | null };

export type ClientSupportedVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientSupportedVersionQuery = { __typename: 'Query', clientSupportedVersion: { __typename: 'ClientSupportedVersionResponse', supportedClientVersion: string, supportedClientUpdateId?: string | null, latestClientVersion: string } };

export type InsuranceLinkAttemptMutationVariables = Exact<{
  input: TrackInsuranceLinkAttemptInput;
}>;


export type InsuranceLinkAttemptMutation = { __typename: 'Mutation', trackInsuranceLinkAttempt: { __typename: 'EventTrackingResult', success: boolean } };

export type GetTemplateReleaseQueryVariables = Exact<{
  input: GetTemplateReleaseInput;
}>;


export type GetTemplateReleaseQuery = { __typename: 'Query', getTemplateRelease: { __typename: 'GetTemplateReleaseResult', templateId: string, templateOrgSlug?: string | null, templateOrgDisplayUrl?: string | null, templateOrgLoginUrl?: string | null, templateOrgDisplayName?: string | null, templateName: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, formSpec: string } };

export type CreateDocumentMutationVariables = Exact<{
  input: CreateDocumentInput;
}>;


export type CreateDocumentMutation = { __typename: 'Mutation', createDocument: { __typename: 'CreateDocumentResult', url: string, s3Key: string, document: { __typename: 'document__Document_Type', id: string } } };

export type CreateSetupIntentMutationVariables = Exact<{
  input?: InputMaybe<CreateSetupIntentInput>;
}>;


export type CreateSetupIntentMutation = { __typename: 'Mutation', createSetupIntent: { __typename: 'CreateSetupIntentResponse', clientSecret: string } };

export type CreateMultiFileDocumentMutationVariables = Exact<{
  input: CreateMultiFileDocumentInput;
}>;


export type CreateMultiFileDocumentMutation = { __typename: 'Mutation', createMultiFileDocument: { __typename: 'CreateMultiFileDocumentResult', document: { __typename: 'document__Document_Type', id: string }, files: Array<{ __typename: 'CreateFileResult', s3Key: string, url: string, name: string }> } };

export type GetUnreadIssuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnreadIssuesQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, issues?: Array<{ __typename: 'issue__Issue_Type', id: string, firstUnseenEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string } | null }> | null } | null };

export type DirectLoginToInstitutionMutationVariables = Exact<{
  input: LoginToInstitutionInput;
}>;


export type DirectLoginToInstitutionMutation = { __typename: 'Mutation', directLoginToInstitution: { __typename: 'FailedLoginMaxReached' } | { __typename: 'InvalidCredentials', workflowId: string, success: boolean, error: { __typename: 'FormError', fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } } | { __typename: 'LoginSuccess', success: boolean, workflowId: string, linkId: string } | { __typename: 'MfaRequired', success: boolean, workflowId: string, mfaOptions: Array<{ __typename: 'MfaOption', id: number, method: MfaMethodType, display?: string | null }> } | { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } | { __typename: 'SecurityQuestionRequired', securityQuestions: Array<string>, success: boolean, workflowId: string } | { __typename: 'SelectMfaMethodResponse' } };

export type DirectSubmitMfaCodeMutationVariables = Exact<{
  input: SubmitMfaCodeInput;
}>;


export type DirectSubmitMfaCodeMutation = { __typename: 'Mutation', directSubmitMfaCode: { __typename: 'InvalidCredentials', workflowId: string, success: boolean, error: { __typename: 'FormError', fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } } | { __typename: 'LoginSuccess', success: boolean, workflowId: string, linkId: string } | { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } };

export type DirectRequestNewMfaCodeMutationVariables = Exact<{
  input: RequestNewMfaCodeInput;
}>;


export type DirectRequestNewMfaCodeMutation = { __typename: 'Mutation', directRequestNewMfaCode: { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } | { __typename: 'SelectMfaMethodResponse' } };

export type DirectSelectMfaMethodMutationVariables = Exact<{
  input: SelectMfaMethodInput;
}>;


export type DirectSelectMfaMethodMutation = { __typename: 'Mutation', directSelectMfaMethod: { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } | { __typename: 'SelectMfaMethodResponse', success: boolean } };

export type PlanDocumentsLoadingQueryVariables = Exact<{
  executionId: Scalars['ID']['input'];
}>;


export type PlanDocumentsLoadingQuery = { __typename: 'Query', getAttemptStatus: { __typename: 'AttemptStatus', dataTypes: { __typename: 'DataTypesStatus', planDocuments: { __typename: 'BenefitSummaryCreated', status: DataTypeStatus, caseId: string } | { __typename: 'DataTypeNotSupported', status: DataTypeStatus } | { __typename: 'DataTypeProcessing', status: DataTypeStatus } } } };

export type DirectSubmitSecurityAnswerMutationVariables = Exact<{
  input: SubmitSecurityAnswerInput;
}>;


export type DirectSubmitSecurityAnswerMutation = { __typename: 'Mutation', directSubmitSecurityAnswer: { __typename: 'LoginSuccess', success: boolean, workflowId: string, linkId: string } | { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } | { __typename: 'SecurityQuestionRequired', securityQuestions: Array<string>, success: boolean, workflowId: string } };

export type DirectStartLinkCreationMutationVariables = Exact<{
  input: StartLinkCreationInput;
}>;


export type DirectStartLinkCreationMutation = { __typename: 'Mutation', directStartLinkCreation: { __typename: 'StartLinkCreationResult', workflowId: string } };

export type GetLinkEndpointQueryVariables = Exact<{
  linkId: Scalars['ID']['input'];
}>;


export type GetLinkEndpointQuery = { __typename: 'Query', webAgent__Link?: Array<{ __typename: 'webAgent__Link_Type', endpoint: { __typename: 'webAgent__Endpoint_Type', id: string, displayName?: string | null, displayUrl: string, slug?: string | null, cdpProvider: webAgent__CDPProvider, loginUrl: string, isAuthenticationRequired: boolean, metadata: Array<string>, isActive: boolean, type: webAgent__EndpointType } }> | null };

export type DirectStartRelinkMutationVariables = Exact<{
  input: StartLinkRelinkInput;
}>;


export type DirectStartRelinkMutation = { __typename: 'Mutation', directStartRelink: { __typename: 'DirectStartRelinkResult', workflowId: string } };

export type DirectAwaitLoginResultMutationVariables = Exact<{
  input: DirectAwaitLoginResultInput;
}>;


export type DirectAwaitLoginResultMutation = { __typename: 'Mutation', directAwaitLoginResult: { __typename: 'FailedLoginMaxReached', signInUrl: string } | { __typename: 'InvalidCredentials', workflowId: string, success: boolean, error: { __typename: 'FormError', fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } } | { __typename: 'LoginSuccess', configureManagedMfa?: boolean | null, success: boolean, workflowId: string, linkId: string } | { __typename: 'MfaRequired', success: boolean, workflowId: string, mfaOptions: Array<{ __typename: 'MfaOption', id: number, method: MfaMethodType, display?: string | null }> } | { __typename: 'RpaError', cause: string, errorSignInUrl?: string | null } | { __typename: 'SecurityQuestionRequired', securityQuestions: Array<string>, success: boolean, workflowId: string } | { __typename: 'SelectMfaMethodResponse' } };

export type CheckBenefitsSummaryQueryVariables = Exact<{
  linkId: Scalars['ID']['input'];
}>;


export type CheckBenefitsSummaryQuery = { __typename: 'Query', webAgent__Link?: Array<{ __typename: 'webAgent__Link_Type', id: string, plans?: Array<{ __typename: 'plan__Plan_Type', id: string, benefitsSummaryResults?: Array<{ __typename: 'plan__BenefitsSummaryResult_Type', id: string, schemaVersion: number }> | null }> | null }> | null };

export type GetInsuranceLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsuranceLinksQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, flexpaLinks?: Array<{ __typename: 'flexpa__Link_Type', id: string, active: boolean, createdAt: string, lastSyncedAt?: string | null, patientName?: string | null, patientDOB?: string | null, deactivatedReason?: flexpa__LinkDeactivatedReason | null, endpoint: { __typename: 'flexpa__Endpoint_Type', displayName?: string | null, id: string, slug?: string | null, isActive: boolean, organization?: { __typename: 'integration__Organization_Type', id: string, displayName: string, slug?: string | null } | null } }> | null, webAgentLinks?: Array<{ __typename: 'webAgent__Link_Type', id: string, active: boolean, createdAt: string, lastSyncedAt?: string | null, patientName?: string | null, patientId?: string | null, patientDOB?: string | null, deactivatedAt?: string | null, deactivatedReason?: webAgent__LinkDeactivatedReason | null, latestExecution?: { __typename: 'webAgent__WebAgentExecution_Type', id: string, ingestions?: Array<{ __typename: 'ingestion__Ingestion_Type', id: string, startedAt: string, endedAt?: string | null, status: ingestion__IngestionStatus, resources?: Array<{ __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string } | { __typename: 'fhirext__InvoiceVersion_Type', id: string } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string }> | null }> | null } | null, executions?: Array<{ __typename: 'webAgent__WebAgentExecution_Type', id: string, createdAt: string, ingestions?: Array<{ __typename: 'ingestion__Ingestion_Type', id: string, startedAt: string, endedAt?: string | null, status: ingestion__IngestionStatus }> | null }> | null, endpoint: { __typename: 'webAgent__Endpoint_Type', displayName?: string | null, id: string, slug?: string | null, isActive: boolean, organization?: { __typename: 'integration__Organization_Type', id: string, displayName: string, slug?: string | null } | null } }> | null } | null };

export type GetWebAgentEndpointsP012QueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebAgentEndpointsP012Query = { __typename: 'Query', webAgent__Endpoint?: Array<{ __typename: 'webAgent__Endpoint_Type', isActive: boolean, id: string, type: webAgent__EndpointType, displayName?: string | null, displayUrl: string, slug?: string | null, loginUrl: string, portalGuideUrl?: string | null, metadata: Array<string>, currentSupportLevel?: { __typename: 'webAgent__EndpointSupportLevelHistory_Type', supportLevel: webAgent__EndpointSupportLevel } | null, organization?: { __typename: 'integration__Organization_Type', id: string, displayName: string, slug?: string | null } | null }> | null };

export type GetWebAgentEndpointsAllQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWebAgentEndpointsAllQuery = { __typename: 'Query', webAgent__Endpoint?: Array<{ __typename: 'webAgent__Endpoint_Type', id: string, type: webAgent__EndpointType, isActive: boolean, displayName?: string | null, displayUrl: string, slug?: string | null, loginUrl: string, metadata: Array<string>, portalGuideUrl?: string | null, currentSupportLevel?: { __typename: 'webAgent__EndpointSupportLevelHistory_Type', supportLevel: webAgent__EndpointSupportLevel } | null, organization?: { __typename: 'integration__Organization_Type', id: string, displayName: string, slug?: string | null } | null }> | null };

export type HasAnyCasesQueryVariables = Exact<{ [key: string]: never; }>;


export type HasAnyCasesQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, issues?: Array<{ __typename: 'issue__Issue_Type', id: string }> | null } | null };

export type ResolveInviteTokenQueryVariables = Exact<{
  inviteToken: Scalars['String']['input'];
}>;


export type ResolveInviteTokenQuery = { __typename: 'Query', resolveInviteToken: { __typename: 'AvailableInviteToken', partner: { __typename: 'InviteTokenPartner', name: string, slug: string } } | { __typename: 'RedeemedInviteToken', partner: { __typename: 'InviteTokenPartner', name: string, slug: string } } };

export type GetUserIssuesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserIssuesQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, issues?: Array<{ __typename: 'issue__Issue_Type', id: string }> | null } | null };

export type CheckAllInsuranceLinksMutationVariables = Exact<{ [key: string]: never; }>;


export type CheckAllInsuranceLinksMutation = { __typename: 'Mutation', checkAllInsuranceLinks?: boolean | null };

export type OpenBillDisputeIssueMutationMutationVariables = Exact<{
  input: OpenNewIssueInput;
}>;


export type OpenBillDisputeIssueMutationMutation = { __typename: 'Mutation', openNewIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type GetBillPreviewEobQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  resourceId: Scalars['String']['input'];
}>;


export type GetBillPreviewEobQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, issues?: Array<{ __typename: 'issue__Issue_Type', id: string, eobId?: string | null, title?: string | null, lastSeenAt?: string | null, openedAt: string, closedAt?: string | null, firstUnseenEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string } | null }> | null, explanationOfBenefits?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, title?: string | null, resourceId: string, created?: string | null, status: fhir__ExplanationOfBenefitStatus, billablePeriod?: string | null, serviceDate?: string | null, type?: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', display?: string | null }> | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, network?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, person?: { __typename: 'Person_Type', primaryAddress?: { __typename: 'person__Address_Type', state: string } | null } | null, owner: { __typename: 'User_Type', primaryPerson?: { __typename: 'Person_Type', primaryAddress?: { __typename: 'person__Address_Type', state: string } | null } | null }, item?: Array<{ __typename: 'fhir__ExplanationOfBenefitItem_Type', id: string, productOrService?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null, display?: string | null, system?: string | null }> | null } | null, quantity?: { __typename: 'fhir__Quantity_Type', value?: string | null } | null, adjudication?: Array<{ __typename: 'fhir__ExplanationOfBenefitItemAdjudication_Type', category: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null }, amount?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null }> | null, reviewOutcome?: { __typename: 'fhir__ExplanationOfBenefitItemReviewOutcome_Type', decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, reason?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null } | null }> | null, patient?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, diagnosis?: Array<{ __typename: 'fhir__ExplanationOfBenefitDiagnosis_Type', diagnosisCodeableConcept?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null }> | null, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, totalsByType?: { __typename: 'fhirext__ExplanationOfBenefitTotalsByType_Type', coinsurance?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, copay?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, deductible?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, memberLiability?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, nonCovered?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, benefit?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, discount?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, eligible?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, paidByPatient?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, paidToPatient?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null, submitted?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null } | null, findings?: Array<{ __typename: 'fhirext__Finding_Type', id: string, explanation?: string | null, userDismissed: boolean, type: fhirext__FindingType }> | null, fairMarketValue?: Array<{ __typename: 'FairMarketValueResponse', code: string, percentile50: { __typename: 'SimpleMoney', value: string, currency: string } }> | null }> | null } | null };

export type GetFlaggedEobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFlaggedEobsQuery = { __typename: 'Query', queryFlaggedExplanationOfBenefits: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, title?: string | null, status: fhir__ExplanationOfBenefitStatus, created?: string | null, resourceId: string, billablePeriod?: string | null, serviceDate?: string | null, totalsByType?: { __typename: 'fhirext__ExplanationOfBenefitTotalsByType_Type', memberLiability?: { __typename: 'fhir__Money_Type', value?: string | null, currency?: string | null } | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null, item?: Array<{ __typename: 'fhir__ExplanationOfBenefitItem_Type', id: string, productOrService?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null, coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null, display?: string | null }> | null } | null, reviewOutcome?: { __typename: 'fhir__ExplanationOfBenefitItemReviewOutcome_Type', decision?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null, reason?: { __typename: 'fhir__CodeableConcept_Type', text?: string | null } | null } | null }> | null, total?: Array<{ __typename: 'fhir__ExplanationOfBenefitTotal_Type', category: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null }, amount: { __typename: 'fhir__Money_Type', currency?: string | null, value?: string | null } }> | null, patient?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, findings?: Array<{ __typename: 'fhirext__Finding_Type', id: string, explanation?: string | null, userDismissed: boolean, lastReviewStatus?: fhirext__ReviewStatus | null, type: fhirext__FindingType, note?: string | null }> | null }> };

export type GetFlaggedEobsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFlaggedEobsCountQuery = { __typename: 'Query', countFlaggedExplanationOfBenefits: number };

export type GetInsuranceLinkStatusQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsuranceLinkStatusQueryQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, flexpaLinks?: Array<{ __typename: 'flexpa__Link_Type', id: string, active: boolean, lastSyncedAt?: string | null, createdAt: string, endpoint: { __typename: 'flexpa__Endpoint_Type', displayName?: string | null, slug?: string | null }, imports?: Array<{ __typename: 'flexpa__FlexpaImport_Type', id: string, status: flexpa__FlexpaImportStatus }> | null }> | null, webAgentLinks?: Array<{ __typename: 'webAgent__Link_Type', id: string, active: boolean, createdAt: string, endpoint: { __typename: 'webAgent__Endpoint_Type', type: webAgent__EndpointType, displayName?: string | null, slug?: string | null }, latestExecution?: { __typename: 'webAgent__WebAgentExecution_Type', ingestions?: Array<{ __typename: 'ingestion__Ingestion_Type', status: ingestion__IngestionStatus }> | null } | null }> | null, explanationOfBenefits?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string }> | null } | null };

export type GetUserEobsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserEobsQuery = { __typename: 'Query', queryUserEobs: Array<{ __typename: 'UserHealthRecord', key: string, kind: string, data: string, enrichment?: string | null, updatedAt: Date }> };

export type GetUserInvoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInvoicesQuery = { __typename: 'Query', queryUserInvoices: Array<{ __typename: 'UserHealthRecord', key: string, kind: string, data: string, enrichment?: string | null, updatedAt: Date }> };

export type GetUserEobQueryVariables = Exact<{
  key: Scalars['ID']['input'];
}>;


export type GetUserEobQuery = { __typename: 'Query', queryUserEob?: { __typename: 'UserHealthRecord', key: string, kind: string, data: string, enrichment?: string | null, updatedAt: Date } | null };

export type GetUserInvoiceQueryVariables = Exact<{
  key: Scalars['ID']['input'];
}>;


export type GetUserInvoiceQuery = { __typename: 'Query', queryUserInvoice?: { __typename: 'UserHealthRecord', key: string, kind: string, data: string, enrichment?: string | null, updatedAt: Date } | null };

export type GetDocumentAnalysisEventStatusQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetDocumentAnalysisEventStatusQuery = { __typename: 'Query', issue__Event?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, id: string, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null } } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string }> | null };

export type RetryDocumentAnalysisForEventMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type RetryDocumentAnalysisForEventMutation = { __typename: 'Mutation', processDocumentForAnalysis: { __typename: 'ProcessDocumentForAnalysisResult', success: boolean, event?: { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null } } | null } };

export type RetryDocumentAnalysisForDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  issueId: Scalars['ID']['input'];
}>;


export type RetryDocumentAnalysisForDocumentMutation = { __typename: 'Mutation', processDocumentForAnalysis: { __typename: 'ProcessDocumentForAnalysisResult', success: boolean, workflowId: string } };

export type StartManualIntakeMutationVariables = Exact<{
  input: StartManualIntakeInput;
}>;


export type StartManualIntakeMutation = { __typename: 'Mutation', startManualIntake: { __typename: 'StartManualIntakeResult', started: boolean } };

export type GetCompletedPostEscalationActionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetCompletedPostEscalationActionsQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, completedPostEscalationActions: Array<issue__PostEscalationActionType>, pendingPostEscalationActions: Array<issue__PostEscalationActionType> }> | null };

export type StartPostEscalationQuestionMutationVariables = Exact<{
  input: StartPostEscalationQuestionInput;
}>;


export type StartPostEscalationQuestionMutation = { __typename: 'Mutation', startPostEscalationQuestion?: { __typename: 'issue__Issue_Type', id: string } | null };

export type RecordInsuranceStatusFromCaseMutationVariables = Exact<{
  input: RecordInsuranceStatusInput;
}>;


export type RecordInsuranceStatusFromCaseMutation = { __typename: 'Mutation', recordInsuranceStatus: { __typename: 'OnboardingAck', ok: boolean } };

export type DeclareNoIncomeDocumentsMutationVariables = Exact<{
  input: DeclareNoIncomeDocumentsInput;
}>;


export type DeclareNoIncomeDocumentsMutation = { __typename: 'Mutation', declareNoIncomeDocuments: boolean };

export type CloseCaseMutationVariables = Exact<{
  input: CloseCaseInput;
}>;


export type CloseCaseMutation = { __typename: 'Mutation', closeCase?: { __typename: 'issue__Issue_Type', id: string } | null };

export type GetIssueDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetIssueDetailsQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, additionalDetails?: string | null, caseType?: string | null, benefitsQuestionType?: string | null, billDisputeType?: string | null, benefitsInclude?: Array<string> | null, benefitsPrice?: string | null, benefitsCoverage?: string | null, userVisibleEvents?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', healthRecordKind?: string | null, healthRecordKey?: string | null, id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string }> | null, person?: { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string } | null, documents?: Array<{ __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, createdAt: string, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null }> | null, benefitsContext?: { __typename: 'issue__BenefitsContext_Type', id: string, selectedPlan?: { __typename: 'plan__Plan_Type', id: string, planLabel?: string | null, planType?: plan__PlanType | null, isActive?: boolean | null, sbc?: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null } | null, coc?: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null } | null, spd?: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null } | null } | null } | null }> | null };

export type GetIssueIdByCaseRefQueryVariables = Exact<{
  caseRef: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetIssueIdByCaseRefQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string }> | null };

export type GetCaseActivationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetCaseActivationQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, nateraIntake?: string | null, isEscalated: boolean, labels?: Array<string> | null, userVisibleEvents?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string }> | null }> | null };

export type GetCaseDocumentStagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetCaseDocumentStagesQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, userVisibleEvents?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, document: { __typename: 'document__Document_Type', id: string }, documentStage?: { __typename: 'DocumentStageState', attemptId: string, attemptStartedAt: string, stage: DocumentStage, detail?: string | null, sender?: string | null, at: string } | null } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string }> | null }> | null };

export type CaseChatEventFieldsFragment = { __typename: 'issue__ChatEvent_Type', chatBody: string } & { ' $fragmentName'?: 'CaseChatEventFieldsFragment' };

export type CaseDocumentClassificationFailedEventFieldsFragment = { __typename: 'issue__DocumentClassificationFailedEvent_Type', classificationStatus?: issue__DocumentClassificationStatus | null, classificationResolvedAt?: string | null } & { ' $fragmentName'?: 'CaseDocumentClassificationFailedEventFieldsFragment' };

export type CaseHaAssignedEventFieldsFragment = { __typename: 'issue__HAAssignedEvent_Type', assigneeAverageCaseRating?: number | null, assigneeProfile: { __typename: 'user__Profile_Type', name?: string | null } } & { ' $fragmentName'?: 'CaseHaAssignedEventFieldsFragment' };

export type CaseTemplateReleaseRequestedEventFieldsFragment = { __typename: 'issue__TemplateReleaseRequestedEvent_Type', releaseRequestKey?: string | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null } } & { ' $fragmentName'?: 'CaseTemplateReleaseRequestedEventFieldsFragment' };

export type CasePlanSelectionEventFieldsFragment = { __typename: 'issue__PlanSelectionEvent_Type', id: string, selectedPlan?: { __typename: 'plan__Plan_Type', id: string } | null, options?: Array<{ __typename: 'plan__Plan_Type', id: string, planLabel?: string | null }> | null } & { ' $fragmentName'?: 'CasePlanSelectionEventFieldsFragment' };

export type CaseUserSelectionRequestedEventFieldsFragment = { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, stringMessage?: string | null, stringOptions: Array<string> } & { ' $fragmentName'?: 'CaseUserSelectionRequestedEventFieldsFragment' };

export type CaseUserMultiSelectionRequestedEventFieldsFragment = { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, multiMessage?: string | null, multiOptions: Array<string> } & { ' $fragmentName'?: 'CaseUserMultiSelectionRequestedEventFieldsFragment' };

export type CaseUserInputRequestedEventFieldsFragment = { __typename: 'issue__UserInputRequestedEvent_Type', id: string, fieldSpec: string, answerValue?: string | null, skippable?: boolean | null, freeTextAllowed?: boolean | null, outcome?: issue__InputOutcome | null, isResolved: boolean, inputMessage?: string | null } & { ' $fragmentName'?: 'CaseUserInputRequestedEventFieldsFragment' };

export type CaseConnectAccountRequestedEventFieldsFragment = { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, endpointType: webAgent__EndpointType, buttonText: string, showSkipButton?: boolean | null, connectAccountMessage?: string | null } & { ' $fragmentName'?: 'CaseConnectAccountRequestedEventFieldsFragment' };

export type CasePaymentPreferencesRequestedEventFieldsFragment = { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', feeAcknowledgedAt?: string | null, cancelledAt?: string | null, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, resolvedFeeCap: number, feePercentSnapshot: number, seenAt?: string | null, paymentRequestKey?: string | null, paymentPrefsConfirmedAt?: string | null, paymentPrefsDeclinedAt?: string | null, paymentPrefsPreAuthStatus?: issue__PreAuthStatus | null, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', code: string } | null } & { ' $fragmentName'?: 'CasePaymentPreferencesRequestedEventFieldsFragment' };

export type CaseIssueFieldsFragment = { __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, caseType?: string | null, benefitsQuestionType?: string | null, billDisputeType?: string | null, additionalDetails?: string | null, benefitsInclude?: Array<string> | null, benefitsPrice?: string | null, isEscalated: boolean, completedPostEscalationActions: Array<issue__PostEscalationActionType>, pendingPostEscalationActions: Array<issue__PostEscalationActionType>, hasStaffParticipant: boolean, benefitsCoverage?: string | null, totalBillDollarAmount?: string | null, providerName?: string | null, labels?: Array<string> | null, nateraIntake?: string | null, providerDetail?: { __typename: 'provider__Provider_Type', kind: provider__ProviderKind } | null } & { ' $fragmentName'?: 'CaseIssueFieldsFragment' };

export type CaseIssueLatestEventsFragment = { __typename: 'issue__Issue_Type', lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, id: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null, firstUnseenEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null } & { ' $fragmentName'?: 'CaseIssueLatestEventsFragment' };

export type CaseDocumentUploadedEventFieldsFragment = { __typename: 'issue__DocumentUploadedEvent_Type', uploading?: boolean | null, uploadFailed?: boolean | null, previewPromptMessage?: string | null, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, createdAt: string, latestIngestion?: { __typename: 'ingestion__Ingestion_Type', resources?: Array<{ __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, eobTitle?: string | null } | { __typename: 'fhirext__InvoiceVersion_Type', id: string, invoiceTitle?: string | null } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string }> | null } | null, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null } } & { ' $fragmentName'?: 'CaseDocumentUploadedEventFieldsFragment' };

export type CaseHipaaReleaseRequestedEventFieldsFragment = { __typename: 'issue__HipaaReleaseRequestedEvent_Type', hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, grantedAt?: string | null } } & { ' $fragmentName'?: 'CaseHipaaReleaseRequestedEventFieldsFragment' };

export type CaseBillDisputeEventFieldsFragment = { __typename: 'issue__BillDisputeEvent_Type', eobId?: string | null, healthRecordKey?: string | null, eob?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, resourceId: string, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null }> | null } & { ' $fragmentName'?: 'CaseBillDisputeEventFieldsFragment' };

export type CaseClosedEventFieldsFragment = { __typename: 'issue__ClosedEvent_Type', userClosureReason?: issue__UserClosureReason | null, feedback?: { __typename: 'feedback__IssueFeedback_Type', id: string, rating: number, review?: string | null } | null } & { ' $fragmentName'?: 'CaseClosedEventFieldsFragment' };

export type CasePaymentAgreementRequestedEventFieldsFragment = { __typename: 'issue__PaymentAgreementRequestedEvent_Type', userAccepted?: boolean | null } & { ' $fragmentName'?: 'CasePaymentAgreementRequestedEventFieldsFragment' };

export type CaseClosurePaymentRequestedEventFieldsFragment = { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, chargeDate?: string | null } & { ' $fragmentName'?: 'CaseClosurePaymentRequestedEventFieldsFragment' };

export type CaseBenefitsSummaryGeneratedEventFieldsFragment = { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, plan: { __typename: 'plan__Plan_Type', id: string, planLabel?: string | null, link?: { __typename: 'webAgent__Link_Type', id: string, endpoint: { __typename: 'webAgent__Endpoint_Type', id: string, slug?: string | null } } | null, benefitsSummaryResults?: Array<{ __typename: 'plan__BenefitsSummaryResult_Type', id: string, summary: string }> | null } } & { ' $fragmentName'?: 'CaseBenefitsSummaryGeneratedEventFieldsFragment' };

export type CaseConnectInsuranceRequestedEventFieldsFragment = { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, insuranceLinkMessage?: string | null } & { ' $fragmentName'?: 'CaseConnectInsuranceRequestedEventFieldsFragment' };

export type CaseBillPayRequestedEventFieldsFragment = { __typename: 'issue__BillPayRequestedEvent_Type', declinedAt?: string | null, availableMinimumDiscountOptions: Array<number>, billPayAcceptedAt?: string | null, billPayPreAuthStatus?: issue__PreAuthStatus | null } & { ' $fragmentName'?: 'CaseBillPayRequestedEventFieldsFragment' };

export type CaseBillPaySuccessEventFieldsFragment = { __typename: 'issue__BillPaySuccessEvent_Type', negotiatedBillAmount: string, originalBillAmount: string, successFeeAmount: string, successFeePercent: number } & { ' $fragmentName'?: 'CaseBillPaySuccessEventFieldsFragment' };

export type CaseCardCollectionRequestedEventFieldsFragment = { __typename: 'issue__CardCollectionRequestedEvent_Type', cardSucceededAt?: string | null, cardSupersededAt?: string | null, seenAt?: string | null, cardActionRequired: boolean } & { ' $fragmentName'?: 'CaseCardCollectionRequestedEventFieldsFragment' };

export type CaseOutreachEventFieldsFragment = { __typename: 'issue__OutreachEvent_Type', outreachBody: string, ask: { __typename: 'issue__AskReraisedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillDisputeEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CardCollectionRequestedEvent_Type', cardSucceededAt?: string | null, cardSupersededAt?: string | null, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ChatEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, grantedAt?: string | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__OutreachEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', feeAcknowledgedAt?: string | null, cancelledAt?: string | null, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, resolvedFeeCap: number, feePercentSnapshot: number, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, paymentRequestKey?: string | null, paymentPrefsConfirmedAt?: string | null, paymentPrefsDeclinedAt?: string | null, paymentPrefsPreAuthStatus?: issue__PreAuthStatus | null, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', code: string } | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PhoneCallEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserInputRequestedEvent_Type', fieldSpec: string, answerValue?: string | null, skippable?: boolean | null, freeTextAllowed?: boolean | null, outcome?: issue__InputOutcome | null, isResolved: boolean, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, inputMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } } & { ' $fragmentName'?: 'CaseOutreachEventFieldsFragment' };

export type CaseAskReraisedEventFieldsFragment = { __typename: 'issue__AskReraisedEvent_Type', reraisedAsk: { __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string } } & { ' $fragmentName'?: 'CaseAskReraisedEventFieldsFragment' };

export type CaseBillPaymentRequestedEventFieldsFragment = { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, billPaymentAcceptedAt?: string | null } & { ' $fragmentName'?: 'CaseBillPaymentRequestedEventFieldsFragment' };

export type CaseBillPaymentSuccessEventFieldsFragment = { __typename: 'issue__BillPaymentSuccessEvent_Type' } & { ' $fragmentName'?: 'CaseBillPaymentSuccessEventFieldsFragment' };

export type CasePaymentChargeFailedEventFieldsFragment = { __typename: 'issue__PaymentChargeFailedEvent_Type', paymentResolvedAt?: string | null, paymentResolvedReason?: issue__PaymentChargeResolvedReason | null } & { ' $fragmentName'?: 'CasePaymentChargeFailedEventFieldsFragment' };

export type CaseDocumentAnalysisEventFieldsFragment = { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null } & { ' $fragmentName'?: 'CaseDocumentAnalysisEventFieldsFragment' };

export type CasePostEscalationActionsEventFieldsFragment = { __typename: 'issue__PostEscalationActionsEvent_Type', actions?: Array<{ __typename: 'issue__BillPayPostEscalationAction_Type', isRequired: boolean, billPayLinkedEvent: { __typename: 'issue__BillPayRequestedEvent_Type', id: string, availableMinimumDiscountOptions: Array<number> } } | { __typename: 'issue__CompleteFaApplicationPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__ConnectEhrPostEscalationAction_Type', isRequired: boolean, ehrLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__ConnectInsurancePostEscalationAction_Type', isRequired: boolean, insLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__FaEligibilityInfoPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__PaymentAgreementPostEscalationAction_Type', isRequired: boolean, payLinkedEvent: { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } } | { __typename: 'issue__PaymentPreferencesPostEscalationAction_Type', isRequired: boolean, paymentPrefsLinkedEvent: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, requestKey?: string | null, resolvedFeeCap: number, feePercentSnapshot: number, cancelledAt?: string | null } } | { __typename: 'issue__SignTemplatePostEscalationAction_Type', isRequired: boolean, signLinkedEvent: { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, release?: { __typename: 'consent__TemplateRelease_Type', id: string } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType } } } | { __typename: 'issue__UploadBillPostEscalationAction_Type', isRequired: boolean, uploadBillLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadEobPostEscalationAction_Type', isRequired: boolean, uploadEobLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadMemberIdPostEscalationAction_Type', isRequired: boolean, uploadMemberIdLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadProofOfIncomePostEscalationAction_Type', isRequired: boolean, uploadProofOfIncomeLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null }> | null } & { ' $fragmentName'?: 'CasePostEscalationActionsEventFieldsFragment' };

export type GetIssueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  benefitsSummarySchemaVersion: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetIssueQuery = { __typename: 'Query', issue__Issue?: Array<{ __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, caseType?: string | null, benefitsQuestionType?: string | null, billDisputeType?: string | null, additionalDetails?: string | null, benefitsInclude?: Array<string> | null, benefitsPrice?: string | null, isEscalated: boolean, completedPostEscalationActions: Array<issue__PostEscalationActionType>, pendingPostEscalationActions: Array<issue__PostEscalationActionType>, hasStaffParticipant: boolean, benefitsCoverage?: string | null, totalBillDollarAmount?: string | null, providerName?: string | null, labels?: Array<string> | null, nateraIntake?: string | null, providerDetail?: { __typename: 'provider__Provider_Type', kind: provider__ProviderKind } | null, userVisibleEvents?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, reraisedAsk: { __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, plan: { __typename: 'plan__Plan_Type', id: string, planLabel?: string | null, link?: { __typename: 'webAgent__Link_Type', id: string, endpoint: { __typename: 'webAgent__Endpoint_Type', id: string, slug?: string | null } } | null, benefitsSummaryResults?: Array<{ __typename: 'plan__BenefitsSummaryResult_Type', id: string, summary: string }> | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillDisputeEvent_Type', eobId?: string | null, healthRecordKey?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, eob?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, resourceId: string, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null }> | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', declinedAt?: string | null, availableMinimumDiscountOptions: Array<number>, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPayAcceptedAt?: string | null, billPayPreAuthStatus?: issue__PreAuthStatus | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaySuccessEvent_Type', negotiatedBillAmount: string, originalBillAmount: string, successFeeAmount: string, successFeePercent: number, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPaymentAcceptedAt?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CardCollectionRequestedEvent_Type', cardSucceededAt?: string | null, cardSupersededAt?: string | null, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, cardActionRequired: boolean, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosedEvent_Type', userClosureReason?: issue__UserClosureReason | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, feedback?: { __typename: 'feedback__IssueFeedback_Type', id: string, rating: number, review?: string | null } | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, chargeDate?: string | null, id: string, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, endpointType: webAgent__EndpointType, buttonText: string, showSkipButton?: boolean | null, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, connectAccountMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, insuranceLinkMessage?: string | null, eventType: issue__EventType, participant: Participant, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', classificationStatus?: issue__DocumentClassificationStatus | null, classificationResolvedAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentUploadedEvent_Type', uploading?: boolean | null, uploadFailed?: boolean | null, previewPromptMessage?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, createdAt: string, latestIngestion?: { __typename: 'ingestion__Ingestion_Type', resources?: Array<{ __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, eobTitle?: string | null } | { __typename: 'fhirext__InvoiceVersion_Type', id: string, invoiceTitle?: string | null } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string }> | null } | null, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HAAssignedEvent_Type', assigneeAverageCaseRating?: number | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, assigneeProfile: { __typename: 'user__Profile_Type', name?: string | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, grantedAt?: string | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__OutreachEvent_Type', outreachBody: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, ask: { __typename: 'issue__AskReraisedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillDisputeEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CardCollectionRequestedEvent_Type', cardSucceededAt?: string | null, cardSupersededAt?: string | null, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ChatEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, grantedAt?: string | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__OutreachEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', feeAcknowledgedAt?: string | null, cancelledAt?: string | null, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, resolvedFeeCap: number, feePercentSnapshot: number, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, paymentRequestKey?: string | null, paymentPrefsConfirmedAt?: string | null, paymentPrefsDeclinedAt?: string | null, paymentPrefsPreAuthStatus?: issue__PreAuthStatus | null, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', code: string } | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PhoneCallEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserInputRequestedEvent_Type', fieldSpec: string, answerValue?: string | null, skippable?: boolean | null, freeTextAllowed?: boolean | null, outcome?: issue__InputOutcome | null, isResolved: boolean, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, inputMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', userAccepted?: boolean | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', paymentResolvedAt?: string | null, paymentResolvedReason?: issue__PaymentChargeResolvedReason | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', feeAcknowledgedAt?: string | null, cancelledAt?: string | null, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, resolvedFeeCap: number, feePercentSnapshot: number, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, paymentRequestKey?: string | null, paymentPrefsConfirmedAt?: string | null, paymentPrefsDeclinedAt?: string | null, paymentPrefsPreAuthStatus?: issue__PreAuthStatus | null, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', code: string } | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PhoneCallEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, selectedPlan?: { __typename: 'plan__Plan_Type', id: string } | null, options?: Array<{ __typename: 'plan__Plan_Type', id: string, planLabel?: string | null }> | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, actions?: Array<{ __typename: 'issue__BillPayPostEscalationAction_Type', isRequired: boolean, billPayLinkedEvent: { __typename: 'issue__BillPayRequestedEvent_Type', id: string, availableMinimumDiscountOptions: Array<number> } } | { __typename: 'issue__CompleteFaApplicationPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__ConnectEhrPostEscalationAction_Type', isRequired: boolean, ehrLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__ConnectInsurancePostEscalationAction_Type', isRequired: boolean, insLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__FaEligibilityInfoPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__PaymentAgreementPostEscalationAction_Type', isRequired: boolean, payLinkedEvent: { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } } | { __typename: 'issue__PaymentPreferencesPostEscalationAction_Type', isRequired: boolean, paymentPrefsLinkedEvent: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, requestKey?: string | null, resolvedFeeCap: number, feePercentSnapshot: number, cancelledAt?: string | null } } | { __typename: 'issue__SignTemplatePostEscalationAction_Type', isRequired: boolean, signLinkedEvent: { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, release?: { __typename: 'consent__TemplateRelease_Type', id: string } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType } } } | { __typename: 'issue__UploadBillPostEscalationAction_Type', isRequired: boolean, uploadBillLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadEobPostEscalationAction_Type', isRequired: boolean, uploadEobLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadMemberIdPostEscalationAction_Type', isRequired: boolean, uploadMemberIdLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadProofOfIncomePostEscalationAction_Type', isRequired: boolean, uploadProofOfIncomeLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null }> | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, releaseRequestKey?: string | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, fieldSpec: string, answerValue?: string | null, skippable?: boolean | null, freeTextAllowed?: boolean | null, outcome?: issue__InputOutcome | null, isResolved: boolean, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, inputMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, multiMessage?: string | null, multiOptions: Array<string>, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, stringMessage?: string | null, stringOptions: Array<string>, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null }> | null, lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, id: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null, firstUnseenEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null }> | null, me?: { __typename: 'User_Type', id: string, webAgentLinks?: Array<{ __typename: 'webAgent__Link_Type', id: string, endpoint: { __typename: 'webAgent__Endpoint_Type', type: webAgent__EndpointType }, executions?: Array<{ __typename: 'webAgent__WebAgentExecution_Type', id: string, createdAt: string, signInSucceededAt?: string | null, latestStatus?: webAgent__WebExecutionStatus | null, endpoint?: { __typename: 'flexpa__Endpoint_Type' } | { __typename: 'webAgent__Endpoint_Type', type: webAgent__EndpointType } | null }> | null }> | null } | null };

export type GetCaseRowsByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  eventIds: Array<Scalars['ID']['input']>;
  benefitsSummarySchemaVersion: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetCaseRowsByIdQuery = { __typename: 'Query', caseRowsById?: { __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, caseType?: string | null, benefitsQuestionType?: string | null, billDisputeType?: string | null, additionalDetails?: string | null, benefitsInclude?: Array<string> | null, benefitsPrice?: string | null, isEscalated: boolean, completedPostEscalationActions: Array<issue__PostEscalationActionType>, pendingPostEscalationActions: Array<issue__PostEscalationActionType>, hasStaffParticipant: boolean, benefitsCoverage?: string | null, totalBillDollarAmount?: string | null, providerName?: string | null, labels?: Array<string> | null, nateraIntake?: string | null, userVisibleEvents?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, reraisedAsk: { __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string } } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, plan: { __typename: 'plan__Plan_Type', id: string, planLabel?: string | null, link?: { __typename: 'webAgent__Link_Type', id: string, endpoint: { __typename: 'webAgent__Endpoint_Type', id: string, slug?: string | null } } | null, benefitsSummaryResults?: Array<{ __typename: 'plan__BenefitsSummaryResult_Type', id: string, summary: string }> | null } } | { __typename: 'issue__BillDisputeEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, eobId?: string | null, healthRecordKey?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, eob?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, resourceId: string, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, declinedAt?: string | null, availableMinimumDiscountOptions: Array<number>, billPayAcceptedAt?: string | null, billPayPreAuthStatus?: issue__PreAuthStatus | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, negotiatedBillAmount: string, originalBillAmount: string, successFeeAmount: string, successFeePercent: number, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPaid: boolean, billPaymentAcceptedAt?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, cardSucceededAt?: string | null, cardSupersededAt?: string | null, seenAt?: string | null, cardActionRequired: boolean, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ChatEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, chatBody: string, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, userClosureReason?: issue__UserClosureReason | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, feedback?: { __typename: 'feedback__IssueFeedback_Type', id: string, rating: number, review?: string | null } | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, chargeDate?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, endpointType: webAgent__EndpointType, buttonText: string, showSkipButton?: boolean | null, connectAccountMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, insuranceLinkMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, classificationStatus?: issue__DocumentClassificationStatus | null, classificationResolvedAt?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, uploading?: boolean | null, uploadFailed?: boolean | null, previewPromptMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, createdAt: string, latestIngestion?: { __typename: 'ingestion__Ingestion_Type', resources?: Array<{ __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, eobTitle?: string | null } | { __typename: 'fhirext__InvoiceVersion_Type', id: string, invoiceTitle?: string | null } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string }> | null } | null, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null } } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, assigneeAverageCaseRating?: number | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, assigneeProfile: { __typename: 'user__Profile_Type', name?: string | null } } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, grantedAt?: string | null } } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__OutreachEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, outreachBody: string, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, ask: { __typename: 'issue__AskReraisedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillDisputeEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CardCollectionRequestedEvent_Type', cardSucceededAt?: string | null, cardSupersededAt?: string | null, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ChatEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, grantedAt?: string | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__OutreachEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', feeAcknowledgedAt?: string | null, cancelledAt?: string | null, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, resolvedFeeCap: number, feePercentSnapshot: number, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, paymentRequestKey?: string | null, paymentPrefsConfirmedAt?: string | null, paymentPrefsDeclinedAt?: string | null, paymentPrefsPreAuthStatus?: issue__PreAuthStatus | null, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', code: string } | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PhoneCallEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserInputRequestedEvent_Type', fieldSpec: string, answerValue?: string | null, skippable?: boolean | null, freeTextAllowed?: boolean | null, outcome?: issue__InputOutcome | null, isResolved: boolean, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, inputMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, userAccepted?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, paymentResolvedAt?: string | null, paymentResolvedReason?: issue__PaymentChargeResolvedReason | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, feeAcknowledgedAt?: string | null, cancelledAt?: string | null, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, resolvedFeeCap: number, feePercentSnapshot: number, seenAt?: string | null, paymentRequestKey?: string | null, paymentPrefsConfirmedAt?: string | null, paymentPrefsDeclinedAt?: string | null, paymentPrefsPreAuthStatus?: issue__PreAuthStatus | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', code: string } | null } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PhoneCallEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, selectedPlan?: { __typename: 'plan__Plan_Type', id: string } | null, options?: Array<{ __typename: 'plan__Plan_Type', id: string, planLabel?: string | null }> | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, actions?: Array<{ __typename: 'issue__BillPayPostEscalationAction_Type', isRequired: boolean, billPayLinkedEvent: { __typename: 'issue__BillPayRequestedEvent_Type', id: string, availableMinimumDiscountOptions: Array<number> } } | { __typename: 'issue__CompleteFaApplicationPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__ConnectEhrPostEscalationAction_Type', isRequired: boolean, ehrLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__ConnectInsurancePostEscalationAction_Type', isRequired: boolean, insLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__FaEligibilityInfoPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__PaymentAgreementPostEscalationAction_Type', isRequired: boolean, payLinkedEvent: { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } } | { __typename: 'issue__PaymentPreferencesPostEscalationAction_Type', isRequired: boolean, paymentPrefsLinkedEvent: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, requestKey?: string | null, resolvedFeeCap: number, feePercentSnapshot: number, cancelledAt?: string | null } } | { __typename: 'issue__SignTemplatePostEscalationAction_Type', isRequired: boolean, signLinkedEvent: { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, release?: { __typename: 'consent__TemplateRelease_Type', id: string } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType } } } | { __typename: 'issue__UploadBillPostEscalationAction_Type', isRequired: boolean, uploadBillLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadEobPostEscalationAction_Type', isRequired: boolean, uploadEobLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadMemberIdPostEscalationAction_Type', isRequired: boolean, uploadMemberIdLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadProofOfIncomePostEscalationAction_Type', isRequired: boolean, uploadProofOfIncomeLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null }> | null } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, releaseRequestKey?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, fieldSpec: string, answerValue?: string | null, skippable?: boolean | null, freeTextAllowed?: boolean | null, outcome?: issue__InputOutcome | null, isResolved: boolean, inputMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, multiMessage?: string | null, multiOptions: Array<string>, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, stringMessage?: string | null, stringOptions: Array<string>, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null }> | null, providerDetail?: { __typename: 'provider__Provider_Type', kind: provider__ProviderKind } | null, lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, id: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null, firstUnseenEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null } | null };

export type GetCaseRowsSinceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after: Scalars['String']['input'];
  benefitsSummarySchemaVersion: Scalars['Int']['input'];
  userId: Scalars['ID']['input'];
}>;


export type GetCaseRowsSinceQuery = { __typename: 'Query', caseRowsSince?: { __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, caseType?: string | null, benefitsQuestionType?: string | null, billDisputeType?: string | null, additionalDetails?: string | null, benefitsInclude?: Array<string> | null, benefitsPrice?: string | null, isEscalated: boolean, completedPostEscalationActions: Array<issue__PostEscalationActionType>, pendingPostEscalationActions: Array<issue__PostEscalationActionType>, hasStaffParticipant: boolean, benefitsCoverage?: string | null, totalBillDollarAmount?: string | null, providerName?: string | null, labels?: Array<string> | null, nateraIntake?: string | null, userVisibleEvents?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, reraisedAsk: { __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string } } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, plan: { __typename: 'plan__Plan_Type', id: string, planLabel?: string | null, link?: { __typename: 'webAgent__Link_Type', id: string, endpoint: { __typename: 'webAgent__Endpoint_Type', id: string, slug?: string | null } } | null, benefitsSummaryResults?: Array<{ __typename: 'plan__BenefitsSummaryResult_Type', id: string, summary: string }> | null } } | { __typename: 'issue__BillDisputeEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, eobId?: string | null, healthRecordKey?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, eob?: Array<{ __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, resourceId: string, provider?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, facility?: { __typename: 'fhir__Reference_Type', display?: string | null } | null, decision?: { __typename: 'fhir__CodeableConcept_Type', coding?: Array<{ __typename: 'fhir__Coding_Type', code?: string | null }> | null } | null }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, declinedAt?: string | null, availableMinimumDiscountOptions: Array<number>, billPayAcceptedAt?: string | null, billPayPreAuthStatus?: issue__PreAuthStatus | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, negotiatedBillAmount: string, originalBillAmount: string, successFeeAmount: string, successFeePercent: number, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, billPaid: boolean, billPaymentAcceptedAt?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, cardSucceededAt?: string | null, cardSupersededAt?: string | null, seenAt?: string | null, cardActionRequired: boolean, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ChatEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, chatBody: string, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, userClosureReason?: issue__UserClosureReason | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, feedback?: { __typename: 'feedback__IssueFeedback_Type', id: string, rating: number, review?: string | null } | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, chargeDate?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, endpointType: webAgent__EndpointType, buttonText: string, showSkipButton?: boolean | null, connectAccountMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, insuranceLinkMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, status: issue__DocumentAnalysisStatus, errorMessage?: string | null, errorIsRetriable?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, classificationStatus?: issue__DocumentClassificationStatus | null, classificationResolvedAt?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, uploading?: boolean | null, uploadFailed?: boolean | null, previewPromptMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, document: { __typename: 'document__Document_Type', id: string, name: string, dataType?: string | null, createdAt: string, latestIngestion?: { __typename: 'ingestion__Ingestion_Type', resources?: Array<{ __typename: 'fhirext__AccountVersion_Type', id: string } | { __typename: 'fhirext__CoverageVersion_Type', id: string } | { __typename: 'fhirext__EncounterVersion_Type', id: string } | { __typename: 'fhirext__ExplanationOfBenefitVersion_Type', id: string, eobTitle?: string | null } | { __typename: 'fhirext__InvoiceVersion_Type', id: string, invoiceTitle?: string | null } | { __typename: 'fhirext__PatientVersion_Type', id: string } | { __typename: 'fhirext__PractitionerVersion_Type', id: string }> | null } | null, files?: Array<{ __typename: 'document__File_Type', id: string, sizeBytes?: number | null, contentType?: string | null }> | null } } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, assigneeAverageCaseRating?: number | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, assigneeProfile: { __typename: 'user__Profile_Type', name?: string | null } } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, grantedAt?: string | null } } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__OutreachEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, outreachBody: string, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, ask: { __typename: 'issue__AskReraisedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillDisputeEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CardCollectionRequestedEvent_Type', cardSucceededAt?: string | null, cardSupersededAt?: string | null, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ChatEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, hipaaRelease: { __typename: 'consent__HipaaRelease_Type', id: string, grantedAt?: string | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__OutreachEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', feeAcknowledgedAt?: string | null, cancelledAt?: string | null, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, resolvedFeeCap: number, feePercentSnapshot: number, seenAt?: string | null, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, paymentRequestKey?: string | null, paymentPrefsConfirmedAt?: string | null, paymentPrefsDeclinedAt?: string | null, paymentPrefsPreAuthStatus?: issue__PreAuthStatus | null, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', code: string } | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PhoneCallEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null }, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserInputRequestedEvent_Type', fieldSpec: string, answerValue?: string | null, skippable?: boolean | null, freeTextAllowed?: boolean | null, outcome?: issue__InputOutcome | null, isResolved: boolean, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, inputMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, userAccepted?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, paymentResolvedAt?: string | null, paymentResolvedReason?: issue__PaymentChargeResolvedReason | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, feeAcknowledgedAt?: string | null, cancelledAt?: string | null, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, resolvedFeeCap: number, feePercentSnapshot: number, seenAt?: string | null, paymentRequestKey?: string | null, paymentPrefsConfirmedAt?: string | null, paymentPrefsDeclinedAt?: string | null, paymentPrefsPreAuthStatus?: issue__PreAuthStatus | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', code: string } | null } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PhoneCallEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, selectedPlan?: { __typename: 'plan__Plan_Type', id: string } | null, options?: Array<{ __typename: 'plan__Plan_Type', id: string, planLabel?: string | null }> | null } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, actions?: Array<{ __typename: 'issue__BillPayPostEscalationAction_Type', isRequired: boolean, billPayLinkedEvent: { __typename: 'issue__BillPayRequestedEvent_Type', id: string, availableMinimumDiscountOptions: Array<number> } } | { __typename: 'issue__CompleteFaApplicationPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__ConnectEhrPostEscalationAction_Type', isRequired: boolean, ehrLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__ConnectInsurancePostEscalationAction_Type', isRequired: boolean, insLinkedEvent: { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, endpointType: webAgent__EndpointType } } | { __typename: 'issue__FaEligibilityInfoPostEscalationAction_Type', isRequired: boolean } | { __typename: 'issue__PaymentAgreementPostEscalationAction_Type', isRequired: boolean, payLinkedEvent: { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } } | { __typename: 'issue__PaymentPreferencesPostEscalationAction_Type', isRequired: boolean, paymentPrefsLinkedEvent: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, requestKey?: string | null, resolvedFeeCap: number, feePercentSnapshot: number, cancelledAt?: string | null } } | { __typename: 'issue__SignTemplatePostEscalationAction_Type', isRequired: boolean, signLinkedEvent: { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, release?: { __typename: 'consent__TemplateRelease_Type', id: string } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType } } } | { __typename: 'issue__UploadBillPostEscalationAction_Type', isRequired: boolean, uploadBillLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadEobPostEscalationAction_Type', isRequired: boolean, uploadEobLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadMemberIdPostEscalationAction_Type', isRequired: boolean, uploadMemberIdLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null } | { __typename: 'issue__UploadProofOfIncomePostEscalationAction_Type', isRequired: boolean, uploadProofOfIncomeLinkedEvent?: { __typename: 'issue__DocumentUploadedEvent_Type', document: { __typename: 'document__Document_Type', id: string, name: string, files?: Array<{ __typename: 'document__File_Type', id: string, contentType?: string | null }> | null } } | null }> | null } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, releaseRequestKey?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null, release?: { __typename: 'consent__TemplateRelease_Type', id: string, createdAt: string, grantedAt?: string | null } | null, template: { __typename: 'document__Template_Type', id: string, templateType: document__TemplateType, displayName: string, description: string, templateCounterpartyType?: document__TemplateCounterpartyType | null, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, fieldSpec: string, answerValue?: string | null, skippable?: boolean | null, freeTextAllowed?: boolean | null, outcome?: issue__InputOutcome | null, isResolved: boolean, inputMessage?: string | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, multiMessage?: string | null, multiOptions: Array<string>, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, stringMessage?: string | null, stringOptions: Array<string>, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null }> | null, providerDetail?: { __typename: 'provider__Provider_Type', kind: provider__ProviderKind } | null, lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', dollarAmountSaved?: string | null, totalBillDollarAmount?: string | null, successFee?: string | null, chargeDelayDays?: number | null, sentAt: string, id: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', status: issue__DocumentAnalysisStatus, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null, firstUnseenEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | null } | null };

export type SendMessageMutationVariables = Exact<{
  input: CreateIssueChatEventInput;
  userId: Scalars['ID']['input'];
}>;


export type SendMessageMutation = { __typename: 'Mutation', createIssueChatEvent?: { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, eventType: issue__EventType, participant: Participant, sentAt: string, userVisible?: boolean | null, sentByProfile?: { __typename: 'user__Profile_Type', name?: string | null } | null, eventFeedbacks?: Array<{ __typename: 'feedback__IssueEventFeedback_Type', id: string, rating: number }> | null } | null };

export type MarkIssueAsSeenMutationVariables = Exact<{
  input: UpdateIssueInput;
}>;


export type MarkIssueAsSeenMutation = { __typename: 'Mutation', updateIssue?: { __typename: 'issue__Issue_Type', id: string } | null };

export type selectPlanForEventMutationVariables = Exact<{
  input: SelectPlanForEventInput;
}>;


export type selectPlanForEventMutation = { __typename: 'Mutation', selectPlanForEvent?: { __typename: 'issue__PlanSelectionEvent_Type', id: string } | null };

export type chargeRetryReadyMutationVariables = Exact<{
  input: ChargeRetryReadyInput;
}>;


export type chargeRetryReadyMutation = { __typename: 'Mutation', chargeRetryReady?: { __typename: 'issue__Issue_Type', id: string, userVisibleEvents?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string } | { __typename: 'issue__ChatEvent_Type', id: string } | { __typename: 'issue__ClosedEvent_Type', id: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string } | { __typename: 'issue__CommentEvent_Type', id: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string } | { __typename: 'issue__OutreachEvent_Type', id: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', paymentResolvedAt?: string | null, paymentResolvedReason?: issue__PaymentChargeResolvedReason | null, id: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string } | { __typename: 'issue__ReopenedEvent_Type', id: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string }> | null } | null };

export type provideUserInputAnswerMutationVariables = Exact<{
  input: ProvideUserInputAnswerInput;
}>;


export type provideUserInputAnswerMutation = { __typename: 'Mutation', provideUserInputAnswer?: { __typename: 'issue__UserInputRequestedEvent_Type', id: string } | null };

export type RecordIssueChatEventFeedbackMutationVariables = Exact<{
  input: RecordIssueEventFeedbackInput;
}>;


export type RecordIssueChatEventFeedbackMutation = { __typename: 'Mutation', recordIssueEventFeedback: { __typename: 'CreateFeedbackResult', success: boolean } };

export type ConversationEventsSubscriptionVariables = Exact<{
  issueId: Scalars['String']['input'];
}>;


export type ConversationEventsSubscription = { __typename: 'Subscription', conversationEvents: { __typename: 'ConversationSubscriptionEvent', type: ConversationEventType, turnId: string, token?: string | null, error?: string | null, toolName?: string | null, documentId?: string | null, stage?: DocumentStage | null, attemptId?: string | null, attemptStartedAt?: string | null, at?: string | null, detail?: string | null, sender?: string | null, waitingOn?: string | null, waitingOnKind?: WaitReason | null, waitingOnDocumentId?: string | null, seq?: number | null, fromSeq?: number | null, toSeq?: number | null } };

export type ConversationEventsV2SubscriptionVariables = Exact<{
  issueId: Scalars['String']['input'];
}>;


export type ConversationEventsV2Subscription = { __typename: 'Subscription', conversationEvents: { __typename: 'ConversationSubscriptionEvent', type: ConversationEventType, turnId: string, token?: string | null, error?: string | null, toolName?: string | null, documentId?: string | null, stage?: DocumentStage | null, attemptId?: string | null, attemptStartedAt?: string | null, at?: string | null, detail?: string | null, sender?: string | null, waitingOn?: string | null, waitingOnKind?: WaitReason | null, waitingOnDocumentId?: string | null, seq?: number | null, fromSeq?: number | null, toSeq?: number | null, eventId?: string | null, eventIds?: Array<string> | null, blockId?: string | null, blockRow?: number | null } };

export type LegacyConversationEventsSubscriptionVariables = Exact<{
  issueId: Scalars['String']['input'];
}>;


export type LegacyConversationEventsSubscription = { __typename: 'Subscription', conversationEvents: { __typename: 'ConversationSubscriptionEvent', type: ConversationEventType, turnId: string, token?: string | null, error?: string | null, toolName?: string | null } };

export type GetChatEventFeedbackOptionsQueryVariables = Exact<{
  area: feedback__AreaType;
}>;


export type GetChatEventFeedbackOptionsQuery = { __typename: 'Query', feedback__Option?: Array<{ __typename: 'feedback__Option_Type', id: string, value: string, sentiment: feedback__SentimentType }> | null };

export type SearchProvidersQueryVariables = Exact<{
  query: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchProvidersQuery = { __typename: 'Query', searchProviders: Array<{ __typename: 'ProviderSearchResult', id: string, name: string, city?: string | null, state?: string | null }> };

export type ProviderDisplayNameQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProviderDisplayNameQuery = { __typename: 'Query', provider__Provider?: Array<{ __typename: 'provider__Provider_Type', id: string, displayName: string }> | null };

export type QueryIssuesV2QueryVariables = Exact<{
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  open?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Int']['input']>;
}>;


export type QueryIssuesV2Query = { __typename: 'Query', queryIssuesV2?: Array<{ __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, closedAt?: string | null, lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', insuranceLinkMessage?: string | null, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, multiMessage?: string | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, stringMessage?: string | null } | null, firstUnseenEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__BillPaymentRequestedEvent_Type', billPaid: boolean, id: string, sentAt: string, eventType: issue__EventType, participant: Participant, billPaymentAcceptedAt?: string | null } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ChatEvent_Type', chatBody: string, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', insuranceLinkMessage?: string | null, id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, template: { __typename: 'document__Template_Type', description: string } } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, multiMessage?: string | null } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string, eventType: issue__EventType, participant: Participant, stringMessage?: string | null } | null }> | null };

export type OpenNewIssueFromPreviewMutationVariables = Exact<{
  input: OpenNewIssueFromPreviewInput;
}>;


export type OpenNewIssueFromPreviewMutation = { __typename: 'Mutation', openNewIssueFromPreview?: { __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string } | null };

export type GetFileIdsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFileIdsQuery = { __typename: 'Query', document__Document?: Array<{ __typename: 'document__Document_Type', id: string, files?: Array<{ __typename: 'document__File_Type', id: string, name: string, contentType?: string | null }> | null }> | null };

export type FaApplicationForIssueQueryVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;


export type FaApplicationForIssueQuery = { __typename: 'Query', faApplicationForIssue?: { __typename: 'FaApplicationView', formSpec: string, formState: string, submittedAt?: string | null, reopenedAt?: string | null, startedAt?: string | null, skippedAt?: string | null } | null };

export type SaveFaApplicationDraftMutationVariables = Exact<{
  input: SaveFaApplicationDraftInput;
}>;


export type SaveFaApplicationDraftMutation = { __typename: 'Mutation', saveFaApplicationDraft: { __typename: 'FaApplicationView', formSpec: string, formState: string, submittedAt?: string | null, reopenedAt?: string | null, startedAt?: string | null, skippedAt?: string | null } };

export type SubmitFaApplicationMutationVariables = Exact<{
  input: SubmitFaApplicationInput;
}>;


export type SubmitFaApplicationMutation = { __typename: 'Mutation', submitFaApplication: { __typename: 'FaApplicationView', formSpec: string, formState: string, submittedAt?: string | null, reopenedAt?: string | null, startedAt?: string | null, skippedAt?: string | null } | { __typename: 'FaFormChangedError' } | { __typename: 'FaSubmitValidationError', formMessage?: string | null, fieldErrors: Array<{ __typename: 'FaFieldError', key: string, code: FaFieldErrorCode, message?: string | null }> } };

export type SkipFaApplicationForIssueMutationVariables = Exact<{
  input: SkipFaApplicationInput;
}>;


export type SkipFaApplicationForIssueMutation = { __typename: 'Mutation', skipFaApplicationForIssue: { __typename: 'FaApplicationView', formSpec: string, formState: string, submittedAt?: string | null, reopenedAt?: string | null, startedAt?: string | null, skippedAt?: string | null } | { __typename: 'FormError', message?: string | null } };

export type StartFaApplicationForIssueMutationVariables = Exact<{
  input: StartFaApplicationInput;
}>;


export type StartFaApplicationForIssueMutation = { __typename: 'Mutation', startFaApplicationForIssue: { __typename: 'FaApplicationView', formSpec: string, formState: string, submittedAt?: string | null, reopenedAt?: string | null, startedAt?: string | null, skippedAt?: string | null } | { __typename: 'FormError', message?: string | null } };

export type GetYourCasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetYourCasesQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, issues?: Array<{ __typename: 'issue__Issue_Type', id: string, title?: string | null, openedAt: string, nateraIntake?: string | null, isEscalated: boolean, labels?: Array<string> | null, lastEvent?: { __typename: 'issue__AskReraisedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ChatEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ClosedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__CommentEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__OutreachEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, sentAt: string } | null, actions?: Array<{ __typename: 'issue__AskReraisedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__BenefitsSummaryGeneratedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__BillDisputeEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__BillPayRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__BillPaySuccessEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__BillPaymentRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__BillPaymentSuccessEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__ChatEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__ClosedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__ClosurePaymentRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__CommentEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__ConnectAccountRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__ConnectInsuranceRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__DocumentAnalysisEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__DocumentClassificationFailedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__DocumentUploadedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__FinancialAssistanceFlowEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__HAAssignedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__HipaaReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__InternalDocumentUploadedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__OutreachEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__PaymentAgreementRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__PaymentChargeFailedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__PaymentChargeResolvedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__PaymentPreferencesUpdatedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__PhoneCallEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__PlanSelectionEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__PostEscalationActionsEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__ReopenedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__TemplateReleaseRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__ToolExecutionEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__UserInputRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__UserMultiSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string } | { __typename: 'issue__UserSelectionRequestedEvent_Type', id: string, eventType: issue__EventType, actionRequired: boolean, sentAt: string }> | null }> | null } | null };

export type GetClosedWinsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetClosedWinsQuery = { __typename: 'Query', issue__ClosedEvent?: Array<{ __typename: 'issue__ClosedEvent_Type', id: string, userClosureReason?: issue__UserClosureReason | null, sentAt: string, issue: { __typename: 'issue__Issue_Type', id: string, title?: string | null, caseType?: string | null, closedAt?: string | null, lastSeenAt?: string | null, caseManagementClosureReason?: string | null, dollarAmountSaved?: string | null, providerName?: string | null } }> | null };

export type CheckInsuranceLinksQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckInsuranceLinksQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, flexpaLinks?: Array<{ __typename: 'flexpa__Link_Type', id: string, active: boolean }> | null, webAgentLinks?: Array<{ __typename: 'webAgent__Link_Type', id: string, active: boolean }> | null } | null };

export type GetPersonalizedPromptsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonalizedPromptsQuery = { __typename: 'Query', getPersonalizedPrompts: { __typename: 'GetPersonalizedPromptsResponse', prompts: Array<{ __typename: 'PersonalizedPrompt', id: string, text: string, response: string, caseType: CaseType, icon: PromptIcon }> } };

export type PendingNateraIntakeQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingNateraIntakeQuery = { __typename: 'Query', hasPendingNateraIntake: boolean };

export type NateraIntakeResumeQueryVariables = Exact<{ [key: string]: never; }>;


export type NateraIntakeResumeQuery = { __typename: 'Query', nateraIntakeResumeDestination: NateraIntakeResumeDestination };

export type NateraIntakeIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type NateraIntakeIdentityQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, persons?: Array<{ __typename: 'Person_Type', id: string, primary: boolean }> | null } | null };

export type PendingNateraIntakeAnswersQueryVariables = Exact<{ [key: string]: never; }>;


export type PendingNateraIntakeAnswersQuery = { __typename: 'Query', pendingNateraIntakeAnswers?: { __typename: 'PendingNateraIntakeAnswers', expressArm?: string | null, billCount: number, billRangeFloorCents?: number | null, billRangeCeilingCents?: number | null, householdSize?: number | null, annualHouseholdIncomeCents?: number | null, incomeDeclined?: boolean | null, incomeRangeFloorCents?: number | null, incomeRangeCeilingCents?: number | null, faRead?: NateraIntakeFaRead | null, insuranceCarrier?: string | null } | null };

export type NateraQuoteInsuranceQueryVariables = Exact<{ [key: string]: never; }>;


export type NateraQuoteInsuranceQuery = { __typename: 'Query', myInsurance: { __typename: 'Insurance', checkStatus: { __typename: 'InsuranceCheckStatus', state: InsuranceCheckState }, memberships: Array<{ __typename: 'InsuranceMembership', id: string, status: InsuranceMembershipStatus, accountHolder: boolean, coverageType: InsuranceCoverageType, payerName: string, groupName?: string | null, stale: boolean, payer?: { __typename: 'Payer', logoUrl?: string | null } | null, person: { __typename: 'InsurancePerson', firstName: string, lastName: string }, plan: { __typename: 'InsurancePlan', name?: string | null }, planYear?: { __typename: 'PlanYear', start?: string | null, status: PlanYearStatus } | null, positions: Array<{ __typename: 'InsurancePosition', kind: InsurancePositionKind, scope: InsurancePositionScope, service: InsuranceCoverageType, metAmount: number, limitAmount?: number | null }> }> } };

export type RecordNateraIntakeAnswersMutationVariables = Exact<{
  input: RecordNateraIntakeAnswersInput;
}>;


export type RecordNateraIntakeAnswersMutation = { __typename: 'Mutation', recordNateraIntakeAnswers: boolean };

export type RecordPhoneForNateraIntakeMutationVariables = Exact<{
  input: RecordPhoneInput;
}>;


export type RecordPhoneForNateraIntakeMutation = { __typename: 'Mutation', recordPhone: { __typename: 'OnboardingAck', ok: boolean } };

export type CreateNateraIntakeCaseMutationVariables = Exact<{
  input?: InputMaybe<CreateNateraIntakeCaseInput>;
}>;


export type CreateNateraIntakeCaseMutation = { __typename: 'Mutation', createNateraIntakeCase: { __typename: 'NateraIntakeCase', issueId: string, paymentPreferencesRequestId?: string | null, mode: NateraIntakeMode, created: boolean } };

export type CompleteNateraIntakeActivationMutationVariables = Exact<{
  input: CompleteNateraIntakeActivationInput;
}>;


export type CompleteNateraIntakeActivationMutation = { __typename: 'Mutation', completeNateraIntakeActivation: { __typename: 'NateraIntakeActivation', issueId: string, escalated: boolean, required: Array<NateraIntakeActivationItem>, missing: Array<NateraIntakeActivationItem>, hipaaTemplateId?: string | null, uninsuredDeclared: boolean, insuranceVerified: boolean, reminderAt?: Date | null, uploadCounts: Array<{ __typename: 'NateraIntakeActivationUploadCount', item: NateraIntakeActivationItem, count: number }> } };

export type RequestNateraIntakeReminderMutationVariables = Exact<{
  input: RequestNateraIntakeReminderInput;
}>;


export type RequestNateraIntakeReminderMutation = { __typename: 'Mutation', requestNateraIntakeReminder: { __typename: 'NateraIntakeActivation', issueId: string, escalated: boolean, required: Array<NateraIntakeActivationItem>, missing: Array<NateraIntakeActivationItem>, hipaaTemplateId?: string | null, uninsuredDeclared: boolean, insuranceVerified: boolean, reminderAt?: Date | null, uploadCounts: Array<{ __typename: 'NateraIntakeActivationUploadCount', item: NateraIntakeActivationItem, count: number }> } };

export type RecordInsuranceStatusFromNateraIntakeMutationVariables = Exact<{
  input: RecordInsuranceStatusInput;
}>;


export type RecordInsuranceStatusFromNateraIntakeMutation = { __typename: 'Mutation', recordInsuranceStatus: { __typename: 'OnboardingAck', ok: boolean } };

export type NateraIntakeAgreementQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type NateraIntakeAgreementQuery = { __typename: 'Query', issue__PaymentPreferencesRequestedEvent?: Array<{ __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, caseType: issue__PaymentCaseType, contract: issue__PaymentAgreementContract, requestKey?: string | null, resolvedFeeCap: number, feePercentSnapshot: number, feeAcknowledgedAt?: string | null, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', id: string, code: string } | null, issue: { __typename: 'issue__Issue_Type', id: string, labels?: Array<string> | null, totalBillDollarAmount?: string | null, nateraIntake?: string | null } }> | null };

export type AcknowledgePaymentFeeMutationVariables = Exact<{
  input: AcknowledgePaymentFeeInput;
}>;


export type AcknowledgePaymentFeeMutation = { __typename: 'Mutation', acknowledgePaymentFee?: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, contract: issue__PaymentAgreementContract, feeAcknowledgedAt?: string | null, feePercentSnapshot: number, resolvedFeeCap: number, appliedPromoCode?: { __typename: 'payment__PromoCode_Type', id: string, code: string } | null } | null };

export type CheckFaEligibilityMutationVariables = Exact<{
  input: CheckFaEligibilityInput;
}>;


export type CheckFaEligibilityMutation = { __typename: 'Mutation', checkFaEligibility: { __typename: 'FaEligibilityResult', outcome: FaEligibilityOutcome } };

export type AcceptTermsMutationVariables = Exact<{
  input: AcceptTermsInput;
}>;


export type AcceptTermsMutation = { __typename: 'Mutation', acceptTerms: { __typename: 'OnboardingAck', ok: boolean } };

export type RecordIdentityMutationVariables = Exact<{
  input: RecordIdentityInput;
}>;


export type RecordIdentityMutation = { __typename: 'Mutation', recordIdentity: { __typename: 'OnboardingAck', ok: boolean } };

export type RecordPhoneMutationVariables = Exact<{
  input: RecordPhoneInput;
}>;


export type RecordPhoneMutation = { __typename: 'Mutation', recordPhone: { __typename: 'OnboardingAck', ok: boolean } };

export type RecordInsuranceMutationVariables = Exact<{
  input: RecordInsuranceInput;
}>;


export type RecordInsuranceMutation = { __typename: 'Mutation', recordInsurance: { __typename: 'OnboardingAck', ok: boolean } };

export type OnboardingSearchPayersQueryVariables = Exact<{
  input: SearchPayersInput;
}>;


export type OnboardingSearchPayersQuery = { __typename: 'Query', searchPayers: Array<{ __typename: 'Payer', id: string, primaryPayerId: string, displayName: string, logoUrl?: string | null, memberIdRequired: boolean }> };

export type OnboardingPopularPayersQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingPopularPayersQuery = { __typename: 'Query', popularPayers: Array<{ __typename: 'Payer', id: string, primaryPayerId: string, displayName: string, logoUrl?: string | null, memberIdRequired: boolean }> };

export type RecordInsuranceStatusMutationVariables = Exact<{
  input: RecordInsuranceStatusInput;
}>;


export type RecordInsuranceStatusMutation = { __typename: 'Mutation', recordInsuranceStatus: { __typename: 'OnboardingAck', ok: boolean } };

export type OnboardingDerivedStateQueryVariables = Exact<{ [key: string]: never; }>;


export type OnboardingDerivedStateQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, acceptedTermsAt?: string | null, persons?: Array<{ __typename: 'Person_Type', id: string, primary: boolean, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string }> | null, segmentationData?: { __typename: 'user__SegmentationData_Type', id: string, hasInsurance?: boolean | null, features?: Array<string> | null } | null } | null, projection__UserMemory?: Array<{ __typename: 'projection__UserMemory_Type', id: string, entries: string }> | null, viewerPartner?: { __typename: 'InviteTokenPartner', id: string, slug: string, name: string } | null };

export type UpsertOnboardingIntentMutationVariables = Exact<{
  input: UpsertUserSegmentationDataInput;
}>;


export type UpsertOnboardingIntentMutation = { __typename: 'Mutation', upsertUserSegmentationData: { __typename: 'user__SegmentationData_Type', id: string } };

export type PreAuthorizePaymentPreferencesMutationVariables = Exact<{
  input: PreAuthorizePaymentPreferencesInput;
}>;


export type PreAuthorizePaymentPreferencesMutation = { __typename: 'Mutation', preAuthorizePaymentPreferences?: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string } | null };

export type ConfirmPaymentPreferencesMutationVariables = Exact<{
  input: ConfirmPaymentPreferencesInput;
}>;


export type ConfirmPaymentPreferencesMutation = { __typename: 'Mutation', confirmPaymentPreferences?: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, confirmedAt?: string | null } | null };

export type ConfirmSimplifiedPaymentAgreementMutationVariables = Exact<{
  input: ConfirmSimplifiedPaymentAgreementInput;
}>;


export type ConfirmSimplifiedPaymentAgreementMutation = { __typename: 'Mutation', confirmSimplifiedPaymentAgreement?: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, confirmedAt?: string | null } | null };

export type DeclinePaymentPreferencesMutationVariables = Exact<{
  input: DeclinePaymentPreferencesInput;
}>;


export type DeclinePaymentPreferencesMutation = { __typename: 'Mutation', declinePaymentPreferences?: { __typename: 'issue__PaymentPreferencesRequestedEvent_Type', id: string, declinedAt?: string | null } | null };

export type CaptureCardCollectionMutationVariables = Exact<{
  input: CaptureCardCollectionInput;
}>;


export type CaptureCardCollectionMutation = { __typename: 'Mutation', captureCardCollection?: { __typename: 'issue__CardCollectionRequestedEvent_Type', id: string, cardSucceededAt?: string | null } | null };

export type MergePersonsMutationVariables = Exact<{
  input: MergePersonsInput;
}>;


export type MergePersonsMutation = { __typename: 'Mutation', mergePersons?: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', path: string, message: string }> | null } | { __typename: 'Person_Type', id: string } | null };

export type CreatePersonMutationVariables = Exact<{
  input: CreatePersonInput;
}>;


export type CreatePersonMutation = { __typename: 'Mutation', createPerson?: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', message: string, path: string }> | null } | { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, primary: boolean } | null };

export type UpdatePersonFormMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdatePersonFormMutation = { __typename: 'Mutation', updatePerson?: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', message: string, path: string }> | null } | { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, primary: boolean } | null };

export type CheckPersonMatchMutationVariables = Exact<{
  input: CheckPersonMatchInput;
}>;


export type CheckPersonMatchMutation = { __typename: 'Mutation', checkPersonMatch?: { __typename: 'FormError', message?: string | null, fields?: Array<{ __typename: 'FieldError', message: string, path: string }> | null } | { __typename: 'NoMatchingPerson' } | { __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, primary: boolean, phoneNumber?: string | null, emailAddress?: string | null, addresses?: Array<{ __typename: 'person__Address_Type', id: string, street: string, city: string, state: string, zip: string, primary: boolean }> | null } | null };

export type GetPersonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPersonsQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, persons?: Array<{ __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, primary: boolean, phoneNumber?: string | null, emailAddress?: string | null, addresses?: Array<{ __typename: 'person__Address_Type', id: string, street: string, street2?: string | null, city: string, state: string, zip: string, primary: boolean }> | null }> | null } | null };

export type GetPersonQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPersonQuery = { __typename: 'Query', Person?: Array<{ __typename: 'Person_Type', id: string, givenNames?: Array<string> | null, familyName?: string | null, dateOfBirth: string, phoneNumber?: string | null, emailAddress?: string | null, primary: boolean, addresses?: Array<{ __typename: 'person__Address_Type', id: string, street: string, city: string, state: string, zip: string, primary: boolean }> | null }> | null };

export type TemplateFileQueryVariables = Exact<{
  input: TemplateFileInput;
}>;


export type TemplateFileQuery = { __typename: 'Query', templateFile: { __typename: 'FormError', message?: string | null } | { __typename: 'TemplateFile', fileBase64: string } };

export type SignAndSaveTemplateValuesV3MutationVariables = Exact<{
  input: SignAndSaveTemplateValuesInput;
}>;


export type SignAndSaveTemplateValuesV3Mutation = { __typename: 'Mutation', signAndSaveTemplateValues: { __typename: 'SignAndSaveTemplateSuccess', success: boolean } | { __typename: 'TemplateSubmitValidationError', formMessage?: string | null, fieldErrors: Array<{ __typename: 'TemplateSubmitFieldError', key: string, code: TemplateSubmitFieldErrorCode }> } };

export type ValidateTemplateValuesV3MutationVariables = Exact<{
  input: ValidateTemplateValuesInput;
}>;


export type ValidateTemplateValuesV3Mutation = { __typename: 'Mutation', validateTemplateValues: { __typename: 'SignAndSaveTemplateSuccess', success: boolean } | { __typename: 'TemplateSubmitValidationError', formMessage?: string | null, fieldErrors: Array<{ __typename: 'TemplateSubmitFieldError', key: string, code: TemplateSubmitFieldErrorCode }> } };

export type GetSignedHipaaReleaseQueryVariables = Exact<{
  templateReleaseId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSignedHipaaReleaseQuery = { __typename: 'Query', me?: { __typename: 'User_Type', id: string, templateReleases?: Array<{ __typename: 'consent__TemplateRelease_Type', id: string, grantedAt?: string | null, document: { __typename: 'document__Document_Type', id: string, template?: { __typename: 'document__Template_Type', id: string, displayName: string, default: boolean, organization?: { __typename: 'integration__Organization_Type', slug?: string | null } | null } | null } }> | null } | null };

export type ViewReleaseDocumentQueryVariables = Exact<{
  input: ViewDocumentInput;
}>;


export type ViewReleaseDocumentQuery = { __typename: 'Query', viewDocument: { __typename: 'ViewDocumentResult', documentId: string, documentUrl: string } };

export type InitiateAccountDeletionV2MutationVariables = Exact<{ [key: string]: never; }>;


export type InitiateAccountDeletionV2Mutation = { __typename: 'Mutation', initiateAccountDeletionV2: { __typename: 'AccountDeletionFailure', error: AccountDeletionError } | { __typename: 'AccountDeletionSuccess', userId: string } };

export type GetUserPaymentsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type GetUserPaymentsQuery = { __typename: 'Query', payment__PaymentTransaction?: Array<{ __typename: 'payment__PaymentTransaction_Type', id: string, amount: string, currency: string, stripePaymentIntentId?: string | null, stripeReceiptUrl?: string | null, status: payment__PaymentStatus, createdAt: string, issue?: { __typename: 'issue__Issue_Type', id: string, title?: string | null } | null }> | null, getPaymentProfile?: { __typename: 'PaymentProfile', id: string, hasPaymentMethod: boolean } | null };

export type GetReleasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReleasesQuery = { __typename: 'Query', me?: { __typename: 'User_Type', templateReleases?: Array<{ __typename: 'consent__TemplateRelease_Type', id: string, grantedAt?: string | null, template: { __typename: 'document__Template_Type', id: string, displayName: string, default: boolean, organization?: { __typename: 'integration__Organization_Type', id: string, slug?: string | null } | null } }> | null } | null, document__Template?: Array<{ __typename: 'document__Template_Type', id: string, displayName: string }> | null };

export const FaApplicationFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FaApplicationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"formName"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<FaApplicationFieldsFragment, unknown>;
export const ForecastScenarioFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ForecastScenarioFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForecastingScenario"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variableKey"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"investments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"targetVariable"}},{"kind":"Field","name":{"kind":"Name","value":"effectKind"}},{"kind":"Field","name":{"kind":"Name","value":"effectAmount"}},{"kind":"Field","name":{"kind":"Name","value":"rampWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<ForecastScenarioFieldsFragment, unknown>;
export const UserDocumentRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDocumentRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document__Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"internalIssueEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]} as unknown as DocumentNode<UserDocumentRowFragment, unknown>;
export const ProviderHitFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderHitFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"aliases"}}]}}]} as unknown as DocumentNode<ProviderHitFieldsFragment, unknown>;
export const ProviderRecordFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderRecordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderHitFields"}},{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","name":{"kind":"Name","value":"ccn"}},{"kind":"Field","name":{"kind":"Name","value":"systemName"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"faPolicyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"faPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"lastVerified"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"insuredStance"}},{"kind":"Field","name":{"kind":"Name","value":"discountPctMin"}},{"kind":"Field","name":{"kind":"Name","value":"discountPctMax"}},{"kind":"Field","name":{"kind":"Name","value":"offersPaymentPlans"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPlanMaxMonths"}},{"kind":"Field","name":{"kind":"Name","value":"hipaaTurnaroundDays"}},{"kind":"Field","name":{"kind":"Name","value":"pricingVsMarket"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"lastVerified"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"partOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"lastVerified"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderHitFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"aliases"}}]}}]} as unknown as DocumentNode<ProviderRecordFieldsFragment, unknown>;
export const ProviderResultFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ProviderResultFieldsFragment, unknown>;
export const ProviderFormUploadResultFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderFormUploadResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormUploadResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormUploadTarget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3PutUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ProviderFormUploadResultFieldsFragment, unknown>;
export const ProviderFormResultFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderFormResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__ProviderForm_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<ProviderFormResultFieldsFragment, unknown>;
export const ResearchRunFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResearchRunFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResearchRun"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"engine"}},{"kind":"Field","name":{"kind":"Name","value":"skillVersion"}},{"kind":"Field","name":{"kind":"Name","value":"turns"}},{"kind":"Field","name":{"kind":"Name","value":"claimsKept"}},{"kind":"Field","name":{"kind":"Name","value":"contactsKept"}},{"kind":"Field","name":{"kind":"Name","value":"costUsd"}},{"kind":"Field","name":{"kind":"Name","value":"notesWritten"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}}]} as unknown as DocumentNode<ResearchRunFieldsFragment, unknown>;
export const InternalStaffTailgateViewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalStaffTailgateView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"memberUserId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}},{"kind":"Field","name":{"kind":"Name","value":"portalName"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"portalMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateChoose"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxChoices"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateFillIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateConfirm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"browsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"vncUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdUntil"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"sha256"}},{"kind":"Field","name":{"kind":"Name","value":"takenAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentToIngestion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<InternalStaffTailgateViewFragment, unknown>;
export const CaseChatEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseChatEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}}]} as unknown as DocumentNode<CaseChatEventFieldsFragment, unknown>;
export const CaseDocumentClassificationFailedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseDocumentClassificationFailedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentClassificationFailedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"classificationResolvedAt"}}]}}]} as unknown as DocumentNode<CaseDocumentClassificationFailedEventFieldsFragment, unknown>;
export const CaseHaAssignedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseHaAssignedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HAAssignedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assigneeProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assigneeAverageCaseRating"}}]}}]} as unknown as DocumentNode<CaseHaAssignedEventFieldsFragment, unknown>;
export const CaseTemplateReleaseRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseTemplateReleaseRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"releaseRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<CaseTemplateReleaseRequestedEventFieldsFragment, unknown>;
export const CasePlanSelectionEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePlanSelectionEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PlanSelectionEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}}]}}]}}]} as unknown as DocumentNode<CasePlanSelectionEventFieldsFragment, unknown>;
export const CaseUserSelectionRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseUserSelectionRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"stringMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"stringOptions"},"name":{"kind":"Name","value":"options"}}]}}]} as unknown as DocumentNode<CaseUserSelectionRequestedEventFieldsFragment, unknown>;
export const CaseUserMultiSelectionRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseUserMultiSelectionRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"multiMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"multiOptions"},"name":{"kind":"Name","value":"options"}}]}}]} as unknown as DocumentNode<CaseUserMultiSelectionRequestedEventFieldsFragment, unknown>;
export const CaseUserInputRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseUserInputRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserInputRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"inputMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSpec"}},{"kind":"Field","name":{"kind":"Name","value":"answerValue"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"isResolved"}}]}}]} as unknown as DocumentNode<CaseUserInputRequestedEventFieldsFragment, unknown>;
export const CaseConnectAccountRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseConnectAccountRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectAccountRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","alias":{"kind":"Name","value":"connectAccountMessage"},"name":{"kind":"Name","value":"chatBody"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"showSkipButton"}}]}}]} as unknown as DocumentNode<CaseConnectAccountRequestedEventFieldsFragment, unknown>;
export const CasePaymentPreferencesRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePaymentPreferencesRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsConfirmedAt"},"name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsDeclinedAt"},"name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}}]} as unknown as DocumentNode<CasePaymentPreferencesRequestedEventFieldsFragment, unknown>;
export const CaseIssueFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseIssueFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__Issue_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"providerDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"billDisputeType"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsInclude"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"completedPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"hasStaffParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"nateraIntake"}}]}}]} as unknown as DocumentNode<CaseIssueFieldsFragment, unknown>;
export const CaseIssueLatestEventsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseIssueLatestEvents"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__Issue_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}}]}}]}}]} as unknown as DocumentNode<CaseIssueLatestEventsFragment, unknown>;
export const CaseDocumentUploadedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseDocumentUploadedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentUploadedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploading"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"uploadFailed"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"previewPromptMessage"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestIngestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isLatest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__InvoiceVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"invoiceTitle"},"name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__ExplanationOfBenefitVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"eobTitle"},"name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<CaseDocumentUploadedEventFieldsFragment, unknown>;
export const CaseHipaaReleaseRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseHipaaReleaseRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}}]} as unknown as DocumentNode<CaseHipaaReleaseRequestedEventFieldsFragment, unknown>;
export const CaseBillDisputeEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillDisputeEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eobId"}},{"kind":"Field","name":{"kind":"Name","value":"healthRecordKey"}},{"kind":"Field","name":{"kind":"Name","value":"eob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CaseBillDisputeEventFieldsFragment, unknown>;
export const CaseClosedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseClosedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userClosureReason"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review"}}]}}]}}]} as unknown as DocumentNode<CaseClosedEventFieldsFragment, unknown>;
export const CasePaymentAgreementRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePaymentAgreementRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}}]}}]} as unknown as DocumentNode<CasePaymentAgreementRequestedEventFieldsFragment, unknown>;
export const CaseClosurePaymentRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseClosurePaymentRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDate"}}]}}]} as unknown as DocumentNode<CaseClosurePaymentRequestedEventFieldsFragment, unknown>;
export const CaseBenefitsSummaryGeneratedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBenefitsSummaryGeneratedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BenefitsSummaryGeneratedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsSummaryResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaVersion"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}}]} as unknown as DocumentNode<CaseBenefitsSummaryGeneratedEventFieldsFragment, unknown>;
export const CaseConnectInsuranceRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseConnectInsuranceRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}}]} as unknown as DocumentNode<CaseConnectInsuranceRequestedEventFieldsFragment, unknown>;
export const CaseBillPayRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPayRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"billPayPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}}]} as unknown as DocumentNode<CaseBillPayRequestedEventFieldsFragment, unknown>;
export const CaseBillPaySuccessEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPaySuccessEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaySuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiatedBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"originalBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeePercent"}}]}}]} as unknown as DocumentNode<CaseBillPaySuccessEventFieldsFragment, unknown>;
export const CaseCardCollectionRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseCardCollectionRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CardCollectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardSupersededAt"}},{"kind":"Field","alias":{"kind":"Name","value":"cardActionRequired"},"name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}}]} as unknown as DocumentNode<CaseCardCollectionRequestedEventFieldsFragment, unknown>;
export const CaseOutreachEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseOutreachEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__OutreachEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachBody"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsConfirmedAt"},"name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsDeclinedAt"},"name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CardCollectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardSupersededAt"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserInputRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"inputMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSpec"}},{"kind":"Field","name":{"kind":"Name","value":"answerValue"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"isResolved"}}]}}]}}]}}]} as unknown as DocumentNode<CaseOutreachEventFieldsFragment, unknown>;
export const CaseAskReraisedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseAskReraisedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__AskReraisedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reraisedAsk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CaseAskReraisedEventFieldsFragment, unknown>;
export const CaseBillPaymentRequestedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPaymentRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}}]} as unknown as DocumentNode<CaseBillPaymentRequestedEventFieldsFragment, unknown>;
export const CaseBillPaymentSuccessEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPaymentSuccessEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentSuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]} as unknown as DocumentNode<CaseBillPaymentSuccessEventFieldsFragment, unknown>;
export const CasePaymentChargeFailedEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePaymentChargeFailedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentChargeFailedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedReason"}}]}}]} as unknown as DocumentNode<CasePaymentChargeFailedEventFieldsFragment, unknown>;
export const CaseDocumentAnalysisEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseDocumentAnalysisEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}}]}}]} as unknown as DocumentNode<CaseDocumentAnalysisEventFieldsFragment, unknown>;
export const CasePostEscalationActionsEventFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePostEscalationActionsEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PostEscalationActionsEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadBillPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadBillLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadEobPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadEobLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadMemberIdPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadMemberIdLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadProofOfIncomePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadProofOfIncomeLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__SignTemplatePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"signLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"payLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsurancePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"insLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectEhrPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ehrLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CasePostEscalationActionsEventFieldsFragment, unknown>;
export const ApiE2eMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApiE2eMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}}]}}]} as unknown as DocumentNode<ApiE2eMeQuery, ApiE2eMeQueryVariables>;
export const ApiE2eOpenNewIssueFromPreviewOutreachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eOpenNewIssueFromPreviewOutreach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueFromPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssueFromPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eOpenNewIssueFromPreviewOutreachMutation, ApiE2eOpenNewIssueFromPreviewOutreachMutationVariables>;
export const ApiE2eCreateTemplateReleaseRequestForOutreachDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eCreateTemplateReleaseRequestForOutreach"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueTemplateReleaseRequestedEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueTemplateReleaseRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eCreateTemplateReleaseRequestForOutreachMutation, ApiE2eCreateTemplateReleaseRequestForOutreachMutationVariables>;
export const ApiE2eOpenNewIssueFromPreviewCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eOpenNewIssueFromPreviewCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueFromPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssueFromPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApiE2eOpenNewIssueFromPreviewCaseMutation, ApiE2eOpenNewIssueFromPreviewCaseMutationVariables>;
export const ApiE2eUpdateIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eUpdateIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eUpdateIssueMutation, ApiE2eUpdateIssueMutationVariables>;
export const ApiE2eIssueUnseenStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApiE2eIssueUnseenState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApiE2eIssueUnseenStateQuery, ApiE2eIssueUnseenStateQueryVariables>;
export const ApiE2eOpenNewIssueFromPreviewEscalationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eOpenNewIssueFromPreviewEscalation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueFromPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssueFromPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eOpenNewIssueFromPreviewEscalationMutation, ApiE2eOpenNewIssueFromPreviewEscalationMutationVariables>;
export const ApiE2eCreateIssueChatEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eCreateIssueChatEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueChatEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueChatEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eCreateIssueChatEventMutation, ApiE2eCreateIssueChatEventMutationVariables>;
export const ApiE2eHeadlessLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eHeadlessLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"passkey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"headlessLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"passkey"},"value":{"kind":"Variable","name":{"kind":"Name","value":"passkey"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errorType"}}]}}]}}]}}]} as unknown as DocumentNode<ApiE2eHeadlessLoginMutation, ApiE2eHeadlessLoginMutationVariables>;
export const ApiE2eAuthWarmupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApiE2eAuthWarmup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eAuthWarmupQuery, ApiE2eAuthWarmupQueryVariables>;
export const ApiE2eCreateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eCreateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApiE2eCreateDocumentMutation, ApiE2eCreateDocumentMutationVariables>;
export const ApiE2eFinalizeDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eFinalizeDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApiE2eFinalizeDocumentMutation, ApiE2eFinalizeDocumentMutationVariables>;
export const ApiE2eOpenNewIssueFromPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eOpenNewIssueFromPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueFromPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssueFromPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApiE2eOpenNewIssueFromPreviewMutation, ApiE2eOpenNewIssueFromPreviewMutationVariables>;
export const ApiE2eProcessDocumentForAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eProcessDocumentForAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProcessDocumentForAnalysisInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processDocumentForAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<ApiE2eProcessDocumentForAnalysisMutation, ApiE2eProcessDocumentForAnalysisMutationVariables>;
export const ApiE2eCaseTimelineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ApiE2eCaseTimeline"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<ApiE2eCaseTimelineQuery, ApiE2eCaseTimelineQueryVariables>;
export const ApiE2eCreateTemplateReleaseRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eCreateTemplateReleaseRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueTemplateReleaseRequestedEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueTemplateReleaseRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eCreateTemplateReleaseRequestMutation, ApiE2eCreateTemplateReleaseRequestMutationVariables>;
export const ApiE2eOpenNewIssueFromPreviewHipaaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eOpenNewIssueFromPreviewHipaa"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueFromPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssueFromPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eOpenNewIssueFromPreviewHipaaMutation, ApiE2eOpenNewIssueFromPreviewHipaaMutationVariables>;
export const ApiE2eCreateSignatureDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eCreateSignatureDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApiE2eCreateSignatureDocumentMutation, ApiE2eCreateSignatureDocumentMutationVariables>;
export const ApiE2eFinalizeSignatureDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eFinalizeSignatureDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<ApiE2eFinalizeSignatureDocumentMutation, ApiE2eFinalizeSignatureDocumentMutationVariables>;
export const ApiE2eSignAndSaveTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eSignAndSaveTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignAndSaveTemplateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signAndSaveTemplate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ApiE2eSignAndSaveTemplateMutation, ApiE2eSignAndSaveTemplateMutationVariables>;
export const ApiE2eOpenNewIssueFromPreviewPaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eOpenNewIssueFromPreviewPayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueFromPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssueFromPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eOpenNewIssueFromPreviewPaymentMutation, ApiE2eOpenNewIssueFromPreviewPaymentMutationVariables>;
export const ApiE2eCreatePaymentPreferencesRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eCreatePaymentPreferencesRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePaymentPreferencesRequestedEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPaymentPreferencesRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eCreatePaymentPreferencesRequestMutation, ApiE2eCreatePaymentPreferencesRequestMutationVariables>;
export const ApiE2eConfirmPaymentPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApiE2eConfirmPaymentPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmPaymentPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmPaymentPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ApiE2eConfirmPaymentPreferencesMutation, ApiE2eConfirmPaymentPreferencesMutationVariables>;
export const RecordCalibrationDeltasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordCalibrationDeltas"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deltas"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalibrationDeltaInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordCalibrationDeltas"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"deltas"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deltas"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accepted"}}]}}]}}]} as unknown as DocumentNode<RecordCalibrationDeltasMutation, RecordCalibrationDeltasMutationVariables>;
export const CaseAdvisorChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CaseAdvisorChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseAdvisorChatInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseAdvisorChat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}},{"kind":"Field","name":{"kind":"Name","value":"toolCalls"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toolName"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}}]}}]}}]} as unknown as DocumentNode<CaseAdvisorChatMutation, CaseAdvisorChatMutationVariables>;
export const GenerateCaseReplyDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateCaseReplyDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateCaseReplyDraftInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateCaseReplyDraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"draft"}},{"kind":"Field","name":{"kind":"Name","value":"rationale"}},{"kind":"Field","name":{"kind":"Name","value":"sourcesUsed"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"inputTokens"}},{"kind":"Field","name":{"kind":"Name","value":"outputTokens"}}]}}]}}]} as unknown as DocumentNode<GenerateCaseReplyDraftMutation, GenerateCaseReplyDraftMutationVariables>;
export const GenerateCaseRecommendationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateCaseRecommendation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateCaseRecommendation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}]}}]} as unknown as DocumentNode<GenerateCaseRecommendationMutation, GenerateCaseRecommendationMutationVariables>;
export const GetCaseRecommendationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaseRecommendation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseRecommendation"}},{"kind":"Field","name":{"kind":"Name","value":"caseRecommendationGeneratedAt"}}]}}]}}]} as unknown as DocumentNode<GetCaseRecommendationQuery, GetCaseRecommendationQueryVariables>;
export const createRecommendedTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createRecommendedTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<createRecommendedTaskMutation, createRecommendedTaskMutationVariables>;
export const SubmitRecommendationFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitRecommendationFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecommendationFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitRecommendationFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SubmitRecommendationFeedbackMutation, SubmitRecommendationFeedbackMutationVariables>;
export const InternalCaseCardOnFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalCaseCardOnFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseCardOnFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ready"}},{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}}]}}]}}]} as unknown as DocumentNode<InternalCaseCardOnFileQuery, InternalCaseCardOnFileQueryVariables>;
export const RetoolQueryIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolQueryIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseRef"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"completedPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"followUpDate"}},{"kind":"Field","name":{"kind":"Name","value":"nextSteps"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementType"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementClosureReason"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementRelatedIssueCount"}},{"kind":"Field","name":{"kind":"Name","value":"coverageType"}},{"kind":"Field","name":{"kind":"Name","value":"reengagementReason"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"providerDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"contactPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"priorityOverride"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"staffDisplayProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resolutionPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savingsPreference"}},{"kind":"Field","name":{"kind":"Name","value":"minimumDiscountPercent"}},{"kind":"Field","name":{"kind":"Name","value":"alternativePaymentOptions"}},{"kind":"Field","name":{"kind":"Name","value":"successFeePercent"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoPayAuthorized"}},{"kind":"Field","name":{"kind":"Name","value":"acceptAny"}},{"kind":"Field","name":{"kind":"Name","value":"maxSettle"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nateraIntake"}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sentBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentUploadedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentLabel"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__InternalDocumentUploadedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userClosureReason"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CommentEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PhoneCallEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isInbound"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"callType"}},{"kind":"Field","name":{"kind":"Name","value":"hasVoicemail"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"userSelectionOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserInputRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"userInputMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSpec"}},{"kind":"Field","name":{"kind":"Name","value":"answerValue"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"isResolved"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"multiSelectionOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PlanSelectionEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"planSelectionOptions"},"name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectAccountRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endpointType"}},{"kind":"Field","alias":{"kind":"Name","value":"connectAccountChatBody"},"name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaySuccessEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiatedBillAmount"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"prefConfirmedAt"},"name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"prefFeeAcknowledgedAt"},"name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"prefDeclinedAt"},"name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CardCollectionRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardSupersededAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentChargeResolvedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeRecoveryReason"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesUpdatedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefsAutoPayBefore"}},{"kind":"Field","name":{"kind":"Name","value":"prefsAutoPayAfter"}},{"kind":"Field","name":{"kind":"Name","value":"prefsMaxChargeBefore"}},{"kind":"Field","name":{"kind":"Name","value":"prefsMaxChargeAfter"}},{"kind":"Field","name":{"kind":"Name","value":"prefsMaxSettleBefore"}},{"kind":"Field","name":{"kind":"Name","value":"prefsMaxSettleAfter"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PostEscalationActionsEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ToolExecutionEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toolName"}},{"kind":"Field","name":{"kind":"Name","value":"toolInput"}},{"kind":"Field","name":{"kind":"Name","value":"toolOutput"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__FinancialAssistanceFlowEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"application"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetoolQueryIssueQuery, RetoolQueryIssueQueryVariables>;
export const RetoolGetIssueCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolGetIssueCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueCount"}}]}}]} as unknown as DocumentNode<RetoolGetIssueCountQuery, RetoolGetIssueCountQueryVariables>;
export const RetoolHeaderMeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolHeaderMe"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}}]} as unknown as DocumentNode<RetoolHeaderMeQuery, RetoolHeaderMeQueryVariables>;
export const GetPlanSelectionEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlanSelectionEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"issue__PlanSelectionEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planLabel"}}]}}]}}]}}]} as unknown as DocumentNode<GetPlanSelectionEventsQuery, GetPlanSelectionEventsQueryVariables>;
export const GetIssuePromoCodeUsageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIssuePromoCodeUsage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promoCodeUsages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}}]}}]}}]}}]} as unknown as DocumentNode<GetIssuePromoCodeUsageQuery, GetIssuePromoCodeUsageQueryVariables>;
export const InternalSetCaseProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalSetCaseProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetCaseProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setCaseProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InternalSetCaseProviderMutation, InternalSetCaseProviderMutationVariables>;
export const ApplyPromoCodeToIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyPromoCodeToIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyPromoCodeUsage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyPromoCodeUsageSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCodeUsage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ApplyPromoCodeToIssueMutation, ApplyPromoCodeToIssueMutationVariables>;
export const UnapplyPromoCodeFromIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UnapplyPromoCodeFromIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markPromoCodeUsageAsUnused"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCodeUsage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}}]}}]}}]}}]} as unknown as DocumentNode<UnapplyPromoCodeFromIssueMutation, UnapplyPromoCodeFromIssueMutationVariables>;
export const RetoolUpdateIssueChatDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolUpdateIssueChat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementClosureReason"}}]}}]}}]} as unknown as DocumentNode<RetoolUpdateIssueChatMutation, RetoolUpdateIssueChatMutationVariables>;
export const RetoolCloseIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolCloseIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CloseIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closeIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RetoolCloseIssueMutation, RetoolCloseIssueMutationVariables>;
export const RetoolUpdateTaskCommentPinnedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolUpdateTaskCommentPinned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskCommentPinnedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTaskCommentPinned"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RetoolUpdateTaskCommentPinnedMutation, RetoolUpdateTaskCommentPinnedMutationVariables>;
export const RetoolUpdateIssueCommentEventPinnedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolUpdateIssueCommentEventPinned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueCommentEventPinnedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssueCommentEventPinned"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RetoolUpdateIssueCommentEventPinnedMutation, RetoolUpdateIssueCommentEventPinnedMutationVariables>;
export const RetoolCreateIssueConnectAccountEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolCreateIssueConnectAccountEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueConnectAccountRequestedEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueConnectAccountRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RetoolCreateIssueConnectAccountEventMutation, RetoolCreateIssueConnectAccountEventMutationVariables>;
export const InternalStartFaFlowForIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalStartFaFlowForIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartFaFlowInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startFaFlowForIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InternalStartFaFlowForIssueMutation, InternalStartFaFlowForIssueMutationVariables>;
export const InternalResendFaFlowForIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalResendFaFlowForIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendFaFlowInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendFaFlowForIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InternalResendFaFlowForIssueMutation, InternalResendFaFlowForIssueMutationVariables>;
export const InternalCaseDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalCaseDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"internalIssueEvent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"sides"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<InternalCaseDocumentsQuery, InternalCaseDocumentsQueryVariables>;
export const CaseIssuedDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CaseIssuedDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"sides"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CaseIssuedDocumentsQuery, CaseIssuedDocumentsQueryVariables>;
export const UserFaPacketDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserFaPacketDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataTypes"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"sides"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<UserFaPacketDocumentsQuery, UserFaPacketDocumentsQueryVariables>;
export const UserMemberCardDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserMemberCardDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataTypes"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"sides"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<UserMemberCardDocumentsQuery, UserMemberCardDocumentsQueryVariables>;
export const CaseHipaaAuthorizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CaseHipaaAuthorizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"signatureDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"expirationDate"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<CaseHipaaAuthorizationsQuery, CaseHipaaAuthorizationsQueryVariables>;
export const AdminUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isAdmin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primaryEmail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}}]} as unknown as DocumentNode<AdminUsersQuery, AdminUsersQueryVariables>;
export const DocumentTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DocumentTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"default"}}]}}]}}]} as unknown as DocumentNode<DocumentTemplatesQuery, DocumentTemplatesQueryVariables>;
export const InternalCreateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalCreateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InternalCreateDocumentMutation, InternalCreateDocumentMutationVariables>;
export const FinalizeDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FinalizeDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinalizeDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finalizeDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<FinalizeDocumentMutation, FinalizeDocumentMutationVariables>;
export const SendDocumentToUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendDocumentToUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendDocumentToUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendDocumentToUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SendDocumentToUserMutation, SendDocumentToUserMutationVariables>;
export const DeleteUserDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUserDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUserDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUserDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedDocumentId"}}]}}]}}]} as unknown as DocumentNode<DeleteUserDocumentMutation, DeleteUserDocumentMutationVariables>;
export const RequestTemplateReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestTemplateRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueTemplateReleaseRequestedEventInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueTemplateReleaseRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RequestTemplateReleaseMutation, RequestTemplateReleaseMutationVariables>;
export const InternalCaseIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalCaseIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"estimatedDollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"followUpDate"}},{"kind":"Field","name":{"kind":"Name","value":"nextSteps"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementType"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementClosureReason"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementRelatedIssueCount"}},{"kind":"Field","name":{"kind":"Name","value":"coverageType"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sentBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentUploadedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentLabel"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__InternalDocumentUploadedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"selectedOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CommentEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"userSelectionOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PlanSelectionEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"planSelectionOptions"},"name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectAccountRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"connectAccountChatBody"},"name":{"kind":"Name","value":"chatBody"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayRequestedEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InternalCaseIssueQuery, InternalCaseIssueQueryVariables>;
export const InternalUpdateIssueEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpdateIssueEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueEventInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssueEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}}]}}]}}]} as unknown as DocumentNode<InternalUpdateIssueEventMutation, InternalUpdateIssueEventMutationVariables>;
export const InternalUpdateDocumentNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpdateDocumentName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateDocumentNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDocumentName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<InternalUpdateDocumentNameMutation, InternalUpdateDocumentNameMutationVariables>;
export const InternalUpdateFileNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpdateFileName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateFileNameInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFileName"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<InternalUpdateFileNameMutation, InternalUpdateFileNameMutationVariables>;
export const InternalCreateIssueChatEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalCreateIssueChatEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueChatEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueChatEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InternalCreateIssueChatEventMutation, InternalCreateIssueChatEventMutationVariables>;
export const InternalCreateIssueCommentEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalCreateIssueCommentEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueCommentEventInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueCommentEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InternalCreateIssueCommentEventMutation, InternalCreateIssueCommentEventMutationVariables>;
export const InternalNateraCaseIntakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalNateraCaseIntake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nateraCaseIntake"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}]}}]} as unknown as DocumentNode<InternalNateraCaseIntakeQuery, InternalNateraCaseIntakeQueryVariables>;
export const InternalOwnerUserMemoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalOwnerUserMemory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projection__UserMemory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"}}]}}]}}]} as unknown as DocumentNode<InternalOwnerUserMemoryQuery, InternalOwnerUserMemoryQueryVariables>;
export const BillPaymentRequestedEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillPaymentRequestedEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<BillPaymentRequestedEventsQuery, BillPaymentRequestedEventsQueryVariables>;
export const PaymentAgreementEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentAgreementEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"issue__PaymentAgreementRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<PaymentAgreementEventsQuery, PaymentAgreementEventsQueryVariables>;
export const BillPayEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillPayEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"issue__BillPayRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<BillPayEventsQuery, BillPayEventsQueryVariables>;
export const UpdateTotalBillDollarAmountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTotalBillDollarAmount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateTotalBillDollarAmountMutation, UpdateTotalBillDollarAmountMutationVariables>;
export const CreatePaymentPreferencesRequestedEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePaymentPreferencesRequestedEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePaymentPreferencesRequestedEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPaymentPreferencesRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreatePaymentPreferencesRequestedEventMutation, CreatePaymentPreferencesRequestedEventMutationVariables>;
export const RequestCardCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestCardCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestCardCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestCardCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RequestCardCollectionMutation, RequestCardCollectionMutationVariables>;
export const PaymentPreferencesCaptureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentPreferencesCapture"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"requests"},"name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"acceptAny"}},{"kind":"Field","name":{"kind":"Name","value":"maxSingleCharge"}},{"kind":"Field","name":{"kind":"Name","value":"maxSettle"}},{"kind":"Field","name":{"kind":"Name","value":"autoPayAuthorized"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPlanRequested"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPlanMaxMonthly"}},{"kind":"Field","name":{"kind":"Name","value":"providerRelationship"}},{"kind":"Field","name":{"kind":"Name","value":"note"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"successFeePercent"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<PaymentPreferencesCaptureQuery, PaymentPreferencesCaptureQueryVariables>;
export const UpdatePaymentPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePaymentPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePaymentPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePaymentPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentPreferencesMutation, UpdatePaymentPreferencesMutationVariables>;
export const ChargeNegotiatedBillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChargeNegotiatedBill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChargeNegotiatedBillInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeNegotiatedBill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCharged"}},{"kind":"Field","name":{"kind":"Name","value":"billAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeeAmount"}}]}}]}}]} as unknown as DocumentNode<ChargeNegotiatedBillMutation, ChargeNegotiatedBillMutationVariables>;
export const PreviewNegotiatedBillChargeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PreviewNegotiatedBillCharge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreviewNegotiatedBillChargeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewNegotiatedBillCharge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refusal"}},{"kind":"Field","name":{"kind":"Name","value":"breakdown"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"originalBillCents"}},{"kind":"Field","name":{"kind":"Name","value":"settledCents"}},{"kind":"Field","name":{"kind":"Name","value":"savingsCents"}},{"kind":"Field","name":{"kind":"Name","value":"feePercent"}},{"kind":"Field","name":{"kind":"Name","value":"feeCapCents"}},{"kind":"Field","name":{"kind":"Name","value":"feeCapBasis"}},{"kind":"Field","name":{"kind":"Name","value":"rawFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"feeCapped"}},{"kind":"Field","name":{"kind":"Name","value":"feeWaived"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"}},{"kind":"Field","name":{"kind":"Name","value":"promoDiscountCents"}},{"kind":"Field","name":{"kind":"Name","value":"successFeeCents"}},{"kind":"Field","name":{"kind":"Name","value":"billCents"}},{"kind":"Field","name":{"kind":"Name","value":"totalCents"}},{"kind":"Field","name":{"kind":"Name","value":"maxSingleChargeCents"}},{"kind":"Field","name":{"kind":"Name","value":"maxSettleCents"}},{"kind":"Field","name":{"kind":"Name","value":"exceedsMaxSingleCharge"}},{"kind":"Field","name":{"kind":"Name","value":"exceedsMaxSettle"}}]}}]}}]}}]} as unknown as DocumentNode<PreviewNegotiatedBillChargeQuery, PreviewNegotiatedBillChargeQueryVariables>;
export const InternalIssuePaymentTransactionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalIssuePaymentTransactions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment__PaymentTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"transactionType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"billAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"failedAt"}},{"kind":"Field","name":{"kind":"Name","value":"failureCode"}},{"kind":"Field","name":{"kind":"Name","value":"failureDeclineCode"}},{"kind":"Field","name":{"kind":"Name","value":"failureMessage"}},{"kind":"Field","name":{"kind":"Name","value":"stripeReceiptUrl"}}]}}]}}]} as unknown as DocumentNode<InternalIssuePaymentTransactionsQuery, InternalIssuePaymentTransactionsQueryVariables>;
export const InternalCasePhoneCallsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalCasePhoneCalls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__PhoneCallEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aircallId"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"isInbound"}},{"kind":"Field","name":{"kind":"Name","value":"callType"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptFetchedAt"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryFetchedAt"}}]}}]}}]} as unknown as DocumentNode<InternalCasePhoneCallsQuery, InternalCasePhoneCallsQueryVariables>;
export const LogAircallCallDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LogAircallCall"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogAircallCallInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logAircallCall"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<LogAircallCallMutation, LogAircallCallMutationVariables>;
export const InternalPhoneCallTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalPhoneCallTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskManagement__PhoneCallIssueTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dueDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCallEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InternalPhoneCallTasksQuery, InternalPhoneCallTasksQueryVariables>;
export const FetchPhoneCallTranscriptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FetchPhoneCallTranscript"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneCallEventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPhoneCallTranscript"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneCallEventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneCallEventId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"transcript"}},{"kind":"Field","name":{"kind":"Name","value":"transcriptFetchedAt"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"summaryFetchedAt"}}]}}]}}]} as unknown as DocumentNode<FetchPhoneCallTranscriptMutation, FetchPhoneCallTranscriptMutationVariables>;
export const FetchPhoneCallRecordingUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FetchPhoneCallRecordingUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"phoneCallEventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchPhoneCallRecordingUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"phoneCallEventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"phoneCallEventId"}}}]}]}}]} as unknown as DocumentNode<FetchPhoneCallRecordingUrlMutation, FetchPhoneCallRecordingUrlMutationVariables>;
export const HaCaseStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HaCaseState"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseState"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"waitingOn"}},{"kind":"Field","name":{"kind":"Name","value":"coverage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"coverage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"OpenCaseRequirement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"waitingOn"}},{"kind":"Field","name":{"kind":"Name","value":"since"}},{"kind":"Field","name":{"kind":"Name","value":"askCount"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SatisfiedCaseRequirement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"since"}},{"kind":"Field","name":{"kind":"Name","value":"askCount"}},{"kind":"Field","name":{"kind":"Name","value":"target"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"organizationName"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnattestedCaseRequirement"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"authorizationId"}},{"kind":"Field","name":{"kind":"Name","value":"since"}}]}}]}}]}}]}}]} as unknown as DocumentNode<HaCaseStateQuery, HaCaseStateQueryVariables>;
export const InternalCaseTaskDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalCaseTaskDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseTaskDraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"suggestionId"}},{"kind":"Field","name":{"kind":"Name","value":"draft"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskType"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"formSender"}},{"kind":"Field","name":{"kind":"Name","value":"sendingMethod"}}]}}]}}]}}]} as unknown as DocumentNode<InternalCaseTaskDraftQuery, InternalCaseTaskDraftQueryVariables>;
export const InternalAcceptTaskDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAcceptTaskDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptTaskDraftInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptTaskDraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<InternalAcceptTaskDraftMutation, InternalAcceptTaskDraftMutationVariables>;
export const InternalDismissTaskDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalDismissTaskDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DismissTaskDraftInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dismissTaskDraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<InternalDismissTaskDraftMutation, InternalDismissTaskDraftMutationVariables>;
export const InternalCaseIssueTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalCaseIssueTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"taskManagement__IssueTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dueDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"minutesSpent"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__SendFormIssueTask_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"formSender"}},{"kind":"Field","name":{"kind":"Name","value":"sendingMethod"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__ReviewCaseIntakeIssueTask_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"hasAllInformation_caseIntake"},"name":{"kind":"Name","value":"hasAllInformation"}},{"kind":"Field","alias":{"kind":"Name","value":"additionalDetailsRequested_caseIntake"},"name":{"kind":"Name","value":"additionalDetailsRequested"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__ReviewEscalatedCaseTask_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasAllInformation"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetailsRequested"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__ReviewSuggestionTask_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestedAction"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"actionPayload"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"respondedAt"}},{"kind":"Field","name":{"kind":"Name","value":"executedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__IssueResearchTask_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"researchNotes"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__PhoneCallIssueTask_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneCallEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aircallId"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"recordingUrl"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"pinned"}},{"kind":"Field","name":{"kind":"Name","value":"createdBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"canEdit"}}]}}]}}]}}]} as unknown as DocumentNode<InternalCaseIssueTasksQuery, InternalCaseIssueTasksQueryVariables>;
export const InternalAdminUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalAdminUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isAdmin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primaryEmail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}}]} as unknown as DocumentNode<InternalAdminUsersQuery, InternalAdminUsersQueryVariables>;
export const InternalCreateIssueTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalCreateIssueTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InternalCreateIssueTaskMutation, InternalCreateIssueTaskMutationVariables>;
export const InternalUpdateTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpdateTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InternalUpdateTaskMutation, InternalUpdateTaskMutationVariables>;
export const InternalCreateTaskCommentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalCreateTaskComment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTaskCommentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTaskComment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InternalCreateTaskCommentMutation, InternalCreateTaskCommentMutationVariables>;
export const InternalUpdateIssueOnTaskClosureDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpdateIssueOnTaskClosure"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InternalUpdateIssueOnTaskClosureMutation, InternalUpdateIssueOnTaskClosureMutationVariables>;
export const InternalApproveSuggestedActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalApproveSuggestedAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"approveSuggestedAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<InternalApproveSuggestedActionMutation, InternalApproveSuggestedActionMutationVariables>;
export const InternalPendingSuggestionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalPendingSuggestions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suggestion__SuggestedAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"actionPayload"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"respondedAt"}},{"kind":"Field","name":{"kind":"Name","value":"executedAt"}},{"kind":"Field","name":{"kind":"Name","value":"triggerEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewTask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<InternalPendingSuggestionsQuery, InternalPendingSuggestionsQueryVariables>;
export const InternalRejectSuggestedActionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalRejectSuggestedAction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reasonCode"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SuggestionRejectReason"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rejectSuggestedAction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"actionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"reasonCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reasonCode"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}}]}}]}}]} as unknown as DocumentNode<InternalRejectSuggestedActionMutation, InternalRejectSuggestedActionMutationVariables>;
export const CaseWorklistPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CaseWorklistPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseWorklistFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sort"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseWorklistSort"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseWorklistPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"sort"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sort"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caseRef"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"priorityOverride"}},{"kind":"Field","name":{"kind":"Name","value":"priorityOverrideSetByEmail"}},{"kind":"Field","name":{"kind":"Name","value":"priorityOverrideSetAt"}},{"kind":"Field","name":{"kind":"Name","value":"ownerId"}},{"kind":"Field","name":{"kind":"Name","value":"ownerEmail"}},{"kind":"Field","name":{"kind":"Name","value":"ownerSegments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assigneeId"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementType"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"autoPayAuthorized"}},{"kind":"Field","name":{"kind":"Name","value":"nextTaskTitle"}},{"kind":"Field","name":{"kind":"Name","value":"nextTaskDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasOpenTask"}},{"kind":"Field","name":{"kind":"Name","value":"earliestOpenTaskDueDate"}},{"kind":"Field","name":{"kind":"Name","value":"hasOpenReviewChatTask"}},{"kind":"Field","name":{"kind":"Name","value":"hasStaffMessage"}},{"kind":"Field","name":{"kind":"Name","value":"lastEventParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"lastEventSentAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastMemberMessageAwaitingReplyAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastMemberActivityAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastStaffTouchAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nextCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasMore"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CaseWorklistPageQuery, CaseWorklistPageQueryVariables>;
export const CaseWorklistSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CaseWorklistSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaseWorklistFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseWorklistSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseManagementTypes"}},{"kind":"Field","name":{"kind":"Name","value":"unanswered"}},{"kind":"Field","name":{"kind":"Name","value":"overdue"}},{"kind":"Field","name":{"kind":"Name","value":"noTask"}},{"kind":"Field","name":{"kind":"Name","value":"byAssignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assigneeId"}},{"kind":"Field","name":{"kind":"Name","value":"assigneeEmail"}},{"kind":"Field","name":{"kind":"Name","value":"unanswered"}},{"kind":"Field","name":{"kind":"Name","value":"overdue"}},{"kind":"Field","name":{"kind":"Name","value":"noTask"}}]}}]}}]}}]} as unknown as DocumentNode<CaseWorklistSummaryQuery, CaseWorklistSummaryQueryVariables>;
export const HomeIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HomeIssues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isEscalated"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"closedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastEvent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caseRef"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementType"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"priorityOverride"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreferences"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoPayAuthorized"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"segment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"openTasks"},"name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPLETED"},{"kind":"EnumValue","value":"CANCELED"}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dueDate"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}},{"kind":"ObjectField","name":{"kind":"Name","value":"nulls"},"value":{"kind":"EnumValue","value":"BIGGEST"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dueDate"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"memberMessagesAwaitingReply"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"USER"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"CHAT"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"staffTouches"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"STAFF"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userVisible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"CHAT"},{"kind":"EnumValue","value":"PHONE_CALL"}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"reviewChatTasks"},"name":{"kind":"Name","value":"tasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"REVIEW_ISSUE_CHAT"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPLETED"},{"kind":"EnumValue","value":"CANCELED"}]}}]}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}}]}}]}}]} as unknown as DocumentNode<HomeIssuesQuery, HomeIssuesQueryVariables>;
export const RetoolGetAdminUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolGetAdminUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isAdmin"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primaryEmail"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}}]} as unknown as DocumentNode<RetoolGetAdminUsersQuery, RetoolGetAdminUsersQueryVariables>;
export const RetoolUpdateIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolUpdateIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RetoolUpdateIssueMutation, RetoolUpdateIssueMutationVariables>;
export const ViewDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}}]}}]}}]} as unknown as DocumentNode<ViewDocumentQuery, ViewDocumentQueryVariables>;
export const ViewDocumentFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewDocumentFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewDocumentFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewDocumentFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileId"}},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}}]}}]} as unknown as DocumentNode<ViewDocumentFileQuery, ViewDocumentFileQueryVariables>;
export const InternalFaApplicationViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalFaApplicationView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faApplicationForIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formSpec"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"providerFormId"}},{"kind":"Field","name":{"kind":"Name","value":"formSpecVersion"}},{"kind":"Field","name":{"kind":"Name","value":"filedFormSpecVersion"}},{"kind":"Field","name":{"kind":"Name","value":"submissionSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"skippedAt"}}]}}]}}]} as unknown as DocumentNode<InternalFaApplicationViewQuery, InternalFaApplicationViewQueryVariables>;
export const InternalFaApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalFaApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FaApplicationFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FaApplicationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"formName"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<InternalFaApplicationQuery, InternalFaApplicationQueryVariables>;
export const InternalUpsertFaApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpsertFaApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertFaApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertFaApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FaApplicationFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FaApplicationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"formName"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<InternalUpsertFaApplicationMutation, InternalUpsertFaApplicationMutationVariables>;
export const InternalComposeFaApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalComposeFaApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeFaApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"composeFaApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FaApplicationFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FaApplicationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"formName"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<InternalComposeFaApplicationMutation, InternalComposeFaApplicationMutationVariables>;
export const InternalFaFlowFormResolutionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalFaFlowFormResolution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faFlowFormPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolution"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"pinnedFormId"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"formName"}},{"kind":"Field","name":{"kind":"Name","value":"inheritedFrom"}},{"kind":"Field","name":{"kind":"Name","value":"applicationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"pinnedFormProviderName"}},{"kind":"Field","name":{"kind":"Name","value":"pinnedFormProviderId"}},{"kind":"Field","name":{"kind":"Name","value":"hasOfferEvent"}},{"kind":"Field","name":{"kind":"Name","value":"carriedOver"}},{"kind":"Field","name":{"kind":"Name","value":"totalAnswers"}},{"kind":"Field","name":{"kind":"Name","value":"formSpecVersion"}}]}}]}}]} as unknown as DocumentNode<InternalFaFlowFormResolutionQuery, InternalFaFlowFormResolutionQueryVariables>;
export const InternalPrefillFaApplicationAsStaffDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalPrefillFaApplicationAsStaff"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrefillFaApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prefillFaApplicationAsStaff"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FaApplicationFields"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FaApplicationFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplication"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"providerId"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"formName"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]} as unknown as DocumentNode<InternalPrefillFaApplicationAsStaffMutation, InternalPrefillFaApplicationAsStaffMutationVariables>;
export const InternalRepinFaApplicationFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalRepinFaApplicationForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RepinFaApplicationFormInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"repinFaApplicationForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RepinnedFaApplicationForm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formId"}},{"kind":"Field","name":{"kind":"Name","value":"formName"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"resolution"}},{"kind":"Field","name":{"kind":"Name","value":"carriedOver"}},{"kind":"Field","name":{"kind":"Name","value":"totalAnswers"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RepinFaApplicationFormNoop"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","alias":{"kind":"Name","value":"noopMessage"},"name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<InternalRepinFaApplicationFormMutation, InternalRepinFaApplicationFormMutationVariables>;
export const InternalFaExtractedDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalFaExtractedDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kinds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projection__UserDataView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"kind"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kinds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<InternalFaExtractedDocumentsQuery, InternalFaExtractedDocumentsQueryVariables>;
export const InternalFaStableDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalFaStableDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dataTypes"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dataTypes"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<InternalFaStableDocumentsQuery, InternalFaStableDocumentsQueryVariables>;
export const InternalGenerateFaPacketDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalGenerateFaPacket"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateFaPacketInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateFaPacket"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaPacket"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"fillReport"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filled"}},{"kind":"Field","name":{"kind":"Name","value":"attempted"}},{"kind":"Field","name":{"kind":"Name","value":"encodeErrors"}}]}},{"kind":"Field","name":{"kind":"Name","value":"verifier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}},{"kind":"Field","name":{"kind":"Name","value":"checked"}},{"kind":"Field","name":{"kind":"Name","value":"passed"}},{"kind":"Field","name":{"kind":"Name","value":"skippedCheckboxes"}},{"kind":"Field","name":{"kind":"Name","value":"skippedImages"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<InternalGenerateFaPacketMutation, InternalGenerateFaPacketMutationVariables>;
export const InternalFaSupportingDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalFaSupportingDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faApplicationSupportingDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"fileName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unresolvedFields"}}]}}]}}]} as unknown as DocumentNode<InternalFaSupportingDocumentsQuery, InternalFaSupportingDocumentsQueryVariables>;
export const SubmitHaFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitHaFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HaFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitHaFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accepted"}}]}}]}}]} as unknown as DocumentNode<SubmitHaFeedbackMutation, SubmitHaFeedbackMutationVariables>;
export const ForecastOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ForecastOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"horizonWeeks"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forecastingOverview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scenarioId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scenarioId"}}},{"kind":"Argument","name":{"kind":"Name","value":"horizonWeeks"},"value":{"kind":"Variable","name":{"kind":"Name","value":"horizonWeeks"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"horizonWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"horizonStart"}},{"kind":"Field","name":{"kind":"Name","value":"scenarioId"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkRunId"}},{"kind":"Field","name":{"kind":"Name","value":"benchmarkComputedAt"}},{"kind":"Field","name":{"kind":"Name","value":"segmentationVersion"}},{"kind":"Field","name":{"kind":"Name","value":"usingSeedBenchmarks"}},{"kind":"Field","name":{"kind":"Name","value":"registry"}},{"kind":"Field","name":{"kind":"Name","value":"projection"}},{"kind":"Field","name":{"kind":"Name","value":"volumeFallbackWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"headcountFallbackWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"leadActuals"}},{"kind":"Field","name":{"kind":"Name","value":"reconciliationFailures"}}]}}]}}]} as unknown as DocumentNode<ForecastOverviewQuery, ForecastOverviewQueryVariables>;
export const ForecastScenariosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ForecastScenarios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forecastingScenarios"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ForecastScenarioFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ForecastScenarioFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForecastingScenario"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variableKey"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"investments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"targetVariable"}},{"kind":"Field","name":{"kind":"Name","value":"effectKind"}},{"kind":"Field","name":{"kind":"Name","value":"effectAmount"}},{"kind":"Field","name":{"kind":"Name","value":"rampWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<ForecastScenariosQuery, ForecastScenariosQueryVariables>;
export const SaveForecastScenarioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveForecastScenario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveForecastingScenarioInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveForecastingScenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ForecastScenarioFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ForecastScenarioFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForecastingScenario"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variableKey"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"investments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"targetVariable"}},{"kind":"Field","name":{"kind":"Name","value":"effectKind"}},{"kind":"Field","name":{"kind":"Name","value":"effectAmount"}},{"kind":"Field","name":{"kind":"Name","value":"rampWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<SaveForecastScenarioMutation, SaveForecastScenarioMutationVariables>;
export const DeleteForecastScenarioDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteForecastScenario"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteForecastingScenario"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteForecastScenarioMutation, DeleteForecastScenarioMutationVariables>;
export const SetForecastOverrideDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetForecastOverride"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetForecastingOverrideInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setForecastingOverride"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ForecastScenarioFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ForecastScenarioFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForecastingScenario"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variableKey"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"investments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"targetVariable"}},{"kind":"Field","name":{"kind":"Name","value":"effectKind"}},{"kind":"Field","name":{"kind":"Name","value":"effectAmount"}},{"kind":"Field","name":{"kind":"Name","value":"rampWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<SetForecastOverrideMutation, SetForecastOverrideMutationVariables>;
export const SaveForecastInvestmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveForecastInvestment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveForecastingInvestmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveForecastingInvestment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ForecastScenarioFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ForecastScenarioFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ForecastingScenario"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"variableKey"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"investments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"targetVariable"}},{"kind":"Field","name":{"kind":"Name","value":"effectKind"}},{"kind":"Field","name":{"kind":"Name","value":"effectAmount"}},{"kind":"Field","name":{"kind":"Name","value":"rampWeeks"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]} as unknown as DocumentNode<SaveForecastInvestmentMutation, SaveForecastInvestmentMutationVariables>;
export const DeleteForecastInvestmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteForecastInvestment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteForecastingInvestment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}}]} as unknown as DocumentNode<DeleteForecastInvestmentMutation, DeleteForecastInvestmentMutationVariables>;
export const SaveForecastInputsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveForecastInputs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveForecastingForecastInputsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveForecastingForecastInputs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<SaveForecastInputsMutation, SaveForecastInputsMutationVariables>;
export const InternalGetCalibrationFormFillDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalGetCalibrationFormFill"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetFormFillInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getFormFill"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaFormFill"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuerName"}},{"kind":"Field","name":{"kind":"Name","value":"formName"}},{"kind":"Field","name":{"kind":"Name","value":"pdfBase64"}},{"kind":"Field","name":{"kind":"Name","value":"pages"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"patientLabel"}},{"kind":"Field","name":{"kind":"Name","value":"patientHelp"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"signature"}},{"kind":"Field","name":{"kind":"Name","value":"money"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"clusterType"}},{"kind":"Field","name":{"kind":"Name","value":"clusterLabel"}},{"kind":"Field","name":{"kind":"Name","value":"markStyle"}},{"kind":"Field","name":{"kind":"Name","value":"fieldType"}},{"kind":"Field","name":{"kind":"Name","value":"repeatGroup"}},{"kind":"Field","name":{"kind":"Name","value":"repeatRow"}},{"kind":"Field","name":{"kind":"Name","value":"repeatMax"}},{"kind":"Field","name":{"kind":"Name","value":"repeatItemLabel"}},{"kind":"Field","name":{"kind":"Name","value":"repeatAddLabel"}},{"kind":"Field","name":{"kind":"Name","value":"repeatCellKey"}},{"kind":"Field","name":{"kind":"Name","value":"bbox"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"left"}},{"kind":"Field","name":{"kind":"Name","value":"top"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"page"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"requiredDocs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"count"}},{"kind":"Field","name":{"kind":"Name","value":"period"}},{"kind":"Field","name":{"kind":"Name","value":"optional"}}]}},{"kind":"Field","name":{"kind":"Name","value":"auditFindings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"class"}},{"kind":"Field","name":{"kind":"Name","value":"widgetId"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"proposerFallback"}},{"kind":"Field","name":{"kind":"Name","value":"calibratedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<InternalGetCalibrationFormFillQuery, InternalGetCalibrationFormFillQueryVariables>;
export const InternalUserInsuranceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalUserInsurance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userInsurance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"missing"}},{"kind":"Field","name":{"kind":"Name","value":"lastAttemptAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastAnsweredAt"}},{"kind":"Field","name":{"kind":"Name","value":"problem"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"coverageType"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"relationship"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"subscriberMemberId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"payerName"}},{"kind":"Field","name":{"kind":"Name","value":"payer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveDate"}},{"kind":"Field","name":{"kind":"Name","value":"terminationDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberServicesPhone"}},{"kind":"Field","name":{"kind":"Name","value":"providerServicesPhone"}},{"kind":"Field","name":{"kind":"Name","value":"preAuthorizationPhone"}},{"kind":"Field","name":{"kind":"Name","value":"mentalHealthPhone"}},{"kind":"Field","name":{"kind":"Name","value":"nurseLinePhone"}},{"kind":"Field","name":{"kind":"Name","value":"pharmacyHelpPhone"}},{"kind":"Field","name":{"kind":"Name","value":"claimsAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"line1"}},{"kind":"Field","name":{"kind":"Name","value":"line2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pharmacy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rxBin"}},{"kind":"Field","name":{"kind":"Name","value":"rxPcn"}},{"kind":"Field","name":{"kind":"Name","value":"rxGroup"}},{"kind":"Field","name":{"kind":"Name","value":"rxId"}},{"kind":"Field","name":{"kind":"Name","value":"pbmName"}},{"kind":"Field","name":{"kind":"Name","value":"pbmPhone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"headline"}},{"kind":"Field","name":{"kind":"Name","value":"metAmount"}},{"kind":"Field","name":{"kind":"Name","value":"limitAmount"}},{"kind":"Field","name":{"kind":"Name","value":"remainingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"lastChangedAt"}},{"kind":"Field","name":{"kind":"Name","value":"history"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"observedAt"}},{"kind":"Field","name":{"kind":"Name","value":"observation"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"metAmount"}},{"kind":"Field","name":{"kind":"Name","value":"limitAmount"}},{"kind":"Field","name":{"kind":"Name","value":"delta"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"costShares"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"}},{"kind":"Field","name":{"kind":"Name","value":"network"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"covered"}},{"kind":"Field","name":{"kind":"Name","value":"limit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unlimited"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"period"}}]}},{"kind":"Field","name":{"kind":"Name","value":"authRequired"}},{"kind":"Field","name":{"kind":"Name","value":"copays"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"providerTier"}},{"kind":"Field","name":{"kind":"Name","value":"providerRole"}},{"kind":"Field","name":{"kind":"Name","value":"billedBy"}},{"kind":"Field","name":{"kind":"Name","value":"variesByLocation"}},{"kind":"Field","name":{"kind":"Name","value":"deductibleApplies"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coinsurances"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"providerTier"}},{"kind":"Field","name":{"kind":"Name","value":"providerRole"}},{"kind":"Field","name":{"kind":"Name","value":"billedBy"}},{"kind":"Field","name":{"kind":"Name","value":"variesByLocation"}},{"kind":"Field","name":{"kind":"Name","value":"deductibleApplies"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"exclusions"}},{"kind":"Field","name":{"kind":"Name","value":"sources"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"stale"}},{"kind":"Field","name":{"kind":"Name","value":"planYear"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"end"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"figuresFromSubscriber"}},{"kind":"Field","name":{"kind":"Name","value":"checkProblem"}},{"kind":"Field","name":{"kind":"Name","value":"accountHolder"}},{"kind":"Field","name":{"kind":"Name","value":"missing"}},{"kind":"Field","name":{"kind":"Name","value":"policyholder"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"self"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InternalUserInsuranceQuery, InternalUserInsuranceQueryVariables>;
export const RetoolGetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolGetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"lastAuthenticatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"notesAsHtml"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lastEvent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseRef"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"signatureDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"templateReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}},{"kind":"Field","name":{"kind":"Name","value":"archivedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentValues"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"webAgentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedReason"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientDOB"}},{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"latestExecution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastUserMfaMethods"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"matchKeys"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"segment__UserSegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<RetoolGetUserQuery, RetoolGetUserQueryVariables>;
export const RetoolGetUserPlansDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolGetUserPlans"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"plan__Plan"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planType"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}},{"kind":"Field","name":{"kind":"Name","value":"coveragePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"coverageType"}},{"kind":"Field","name":{"kind":"Name","value":"activeCoverages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memberId"}},{"kind":"Field","name":{"kind":"Name","value":"groupId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"relationship"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceDocument"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sbc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vellumDocumentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"spd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vellumDocumentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"coc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vellumDocumentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vellumDocumentId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsSummaryResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}}]} as unknown as DocumentNode<RetoolGetUserPlansQuery, RetoolGetUserPlansQueryVariables>;
export const RetoolGetLinkCDPInspectUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolGetLinkCDPInspectUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__WebAgentExecution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"link"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cdpInspectUrl"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RetoolGetLinkCDPInspectUrlQuery, RetoolGetLinkCDPInspectUrlQueryVariables>;
export const RetoolUserQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolUserQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryWebAgentExecutions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"cdpProvider"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestDiscoveryCrawl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"objectives"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataSlug"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestIngestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastUserMfaMethods"}},{"kind":"Field","name":{"kind":"Name","value":"artifacts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"artifactType"}},{"kind":"Field","name":{"kind":"Name","value":"result"}},{"kind":"Field","name":{"kind":"Name","value":"crawlType"}}]}}]}}]}}]} as unknown as DocumentNode<RetoolUserQueryQuery, RetoolUserQueryQueryVariables>;
export const RetoolGetUserEhrDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolGetUserEhrDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ilike"},"value":{"kind":"StringValue","value":"ehr-%","block":false}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ilike"},"value":{"kind":"StringValue","value":"ccda-%","block":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDocumentRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDocumentRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document__Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"internalIssueEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]} as unknown as DocumentNode<RetoolGetUserEhrDocumentsQuery, RetoolGetUserEhrDocumentsQueryVariables>;
export const RetoolGetUserDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolGetUserDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"internalIssueEvent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userVisible"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDocumentRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDocumentRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document__Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"internalIssueEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]} as unknown as DocumentNode<RetoolGetUserDocumentsQuery, RetoolGetUserDocumentsQueryVariables>;
export const RetoolGetUserMemberCardDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolGetUserMemberCardDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"dataType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"memberCard","block":false},{"kind":"StringValue","value":"member-card-data","block":false},{"kind":"StringValue","value":"member-id-cards-page-screenshot","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserDocumentRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserDocumentRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"document__Document"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"internalIssueEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"endedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]} as unknown as DocumentNode<RetoolGetUserMemberCardDocumentsQuery, RetoolGetUserMemberCardDocumentsQueryVariables>;
export const RetoolUserDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolUserDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryUserUploadedDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userID"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"issueEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestIngestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RetoolUserDocumentsQuery, RetoolUserDocumentsQueryVariables>;
export const SaveNotesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveNotes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveNotesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveNotes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SaveNotesSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<SaveNotesMutation, SaveNotesMutationVariables>;
export const RetoolArchiveConsentReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolArchiveConsentRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ArchiveConsentReleaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveConsentRelease"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArchiveConsentReleaseSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateReleaseId"}}]}}]}}]}}]} as unknown as DocumentNode<RetoolArchiveConsentReleaseMutation, RetoolArchiveConsentReleaseMutationVariables>;
export const RetoolOpenNewIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolOpenNewIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StaffOpenNewIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffOpenNewIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RetoolOpenNewIssueMutation, RetoolOpenNewIssueMutationVariables>;
export const RetoolMergePersonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolMergePersons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MergePersonsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mergePersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetoolMergePersonsMutation, RetoolMergePersonsMutationVariables>;
export const RetoolForceDeactiveLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolForceDeactiveLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ForceDeactivateLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"forceDeactivateLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RetoolForceDeactiveLinkMutation, RetoolForceDeactiveLinkMutationVariables>;
export const RetoolStartLinkSignInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolStartLinkSignIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"StartLinkSignInInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startLinkSignIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RetoolStartLinkSignInMutation, RetoolStartLinkSignInMutationVariables>;
export const RetoolMeEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RetoolMeEmail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}}]} as unknown as DocumentNode<RetoolMeEmailQuery, RetoolMeEmailQueryVariables>;
export const InternalProviderSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"25"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"aliases"}},{"kind":"Field","name":{"kind":"Name","value":"phones"}},{"kind":"Field","name":{"kind":"Name","value":"matchHint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}}]} as unknown as DocumentNode<InternalProviderSearchQuery, InternalProviderSearchQueryVariables>;
export const InternalSystemSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalSystemSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pattern"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__Provider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"kind"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"HealthSystem"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pattern"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderHitFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderHitFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"aliases"}}]}}]} as unknown as DocumentNode<InternalSystemSearchQuery, InternalSystemSearchQueryVariables>;
export const InternalProviderFaPolicyResolutionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderFaPolicyResolution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerFaPolicyResolution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"inheritedFromProvider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"policy"}},{"kind":"Field","name":{"kind":"Name","value":"invalidReasons"}}]}}]}}]} as unknown as DocumentNode<InternalProviderFaPolicyResolutionQuery, InternalProviderFaPolicyResolutionQueryVariables>;
export const InternalProviderByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__Provider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderRecordFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderHitFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"aliases"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderRecordFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderHitFields"}},{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","name":{"kind":"Name","value":"ccn"}},{"kind":"Field","name":{"kind":"Name","value":"systemName"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine1"}},{"kind":"Field","name":{"kind":"Name","value":"addressLine2"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"faPolicyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"faPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"lastVerified"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"negotiation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"insuredStance"}},{"kind":"Field","name":{"kind":"Name","value":"discountPctMin"}},{"kind":"Field","name":{"kind":"Name","value":"discountPctMax"}},{"kind":"Field","name":{"kind":"Name","value":"offersPaymentPlans"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPlanMaxMonths"}},{"kind":"Field","name":{"kind":"Name","value":"hipaaTurnaroundDays"}},{"kind":"Field","name":{"kind":"Name","value":"pricingVsMarket"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"lastVerified"}},{"kind":"Field","name":{"kind":"Name","value":"verifiedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"partOf"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"contactPoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"purpose"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"source"}},{"kind":"Field","name":{"kind":"Name","value":"verified"}},{"kind":"Field","name":{"kind":"Name","value":"lastVerified"}},{"kind":"Field","name":{"kind":"Name","value":"notes"}}]}}]}}]} as unknown as DocumentNode<InternalProviderByIdQuery, InternalProviderByIdQueryVariables>;
export const InternalCalibrationPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalCalibrationPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalibrationPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calibrationPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CalibrationPreview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formSpec"}},{"kind":"Field","name":{"kind":"Name","value":"report"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<InternalCalibrationPreviewQuery, InternalCalibrationPreviewQueryVariables>;
export const InternalCreateProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalCreateProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalCreateProviderMutation, InternalCreateProviderMutationVariables>;
export const InternalUpdateProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpdateProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalUpdateProviderMutation, InternalUpdateProviderMutationVariables>;
export const InternalDeleteProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalDeleteProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderDeleted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletedId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<InternalDeleteProviderMutation, InternalDeleteProviderMutationVariables>;
export const InternalVerifyProviderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalVerifyProvider"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyProviderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyProvider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalVerifyProviderMutation, InternalVerifyProviderMutationVariables>;
export const InternalVerifyNegotiationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalVerifyNegotiation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VerifyNegotiationProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"verifyNegotiationProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalVerifyNegotiationMutation, InternalVerifyNegotiationMutationVariables>;
export const InternalUpsertNegotiationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpsertNegotiation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertNegotiationProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertNegotiationProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalUpsertNegotiationMutation, InternalUpsertNegotiationMutationVariables>;
export const InternalUpsertFaPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpsertFaPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertProviderFaPolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertProviderFaPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalUpsertFaPolicyMutation, InternalUpsertFaPolicyMutationVariables>;
export const InternalRemoveFaPolicyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalRemoveFaPolicy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveProviderFaPolicyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProviderFaPolicy"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalRemoveFaPolicyMutation, InternalRemoveFaPolicyMutationVariables>;
export const InternalRemoveNegotiationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalRemoveNegotiation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveNegotiationProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeNegotiationProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalRemoveNegotiationMutation, InternalRemoveNegotiationMutationVariables>;
export const InternalUpsertContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpsertContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertProviderContactPointInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertProviderContactPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalUpsertContactMutation, InternalUpsertContactMutationVariables>;
export const InternalRemoveContactDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalRemoveContact"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveProviderContactPointInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProviderContactPoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalRemoveContactMutation, InternalRemoveContactMutationVariables>;
export const InternalPrepareFormUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalPrepareFormUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PrepareProviderFormUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareProviderFormUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderFormUploadResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderFormUploadResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormUploadResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormUploadTarget"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"s3PutUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalPrepareFormUploadMutation, InternalPrepareFormUploadMutationVariables>;
export const InternalUpsertProviderFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalUpsertProviderForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertProviderFormInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertProviderForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderFormResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderFormResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__ProviderForm_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalUpsertProviderFormMutation, InternalUpsertProviderFormMutationVariables>;
export const InternalCalibrateProviderFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalCalibrateProviderForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CalibrateProviderFormInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"calibrateProviderForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderFormResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderFormResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__ProviderForm_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalCalibrateProviderFormMutation, InternalCalibrateProviderFormMutationVariables>;
export const InternalSetProviderFormShapingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalSetProviderFormShaping"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SetProviderFormShapingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setProviderFormShaping"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderFormResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderFormResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__ProviderForm_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalSetProviderFormShapingMutation, InternalSetProviderFormShapingMutationVariables>;
export const InternalRenameProviderFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalRenameProviderForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RenameProviderFormInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"renameProviderForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderFormResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderFormResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__ProviderForm_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalRenameProviderFormMutation, InternalRenameProviderFormMutationVariables>;
export const InternalRemoveProviderFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalRemoveProviderForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveProviderFormInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeProviderForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProviderResultFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProviderResultFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResult"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"provider__Provider_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<InternalRemoveProviderFormMutation, InternalRemoveProviderFormMutationVariables>;
export const InternalStartProviderFormDetectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalStartProviderFormDetection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartProviderFormDetectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startProviderFormDetection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormDetectionStarted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"priorDetectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"priorFailedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<InternalStartProviderFormDetectionMutation, InternalStartProviderFormDetectionMutationVariables>;
export const InternalProviderFormDetectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderFormDetection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderFormDetectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerFormDetection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"detectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"detectionFailedAt"}},{"kind":"Field","name":{"kind":"Name","value":"detectedWidgetCount"}}]}}]}}]} as unknown as DocumentNode<InternalProviderFormDetectionQuery, InternalProviderFormDetectionQueryVariables>;
export const InternalProviderResearchRunsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderResearchRuns"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerResearchRuns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResearchRunFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResearchRunFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResearchRun"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"engine"}},{"kind":"Field","name":{"kind":"Name","value":"skillVersion"}},{"kind":"Field","name":{"kind":"Name","value":"turns"}},{"kind":"Field","name":{"kind":"Name","value":"claimsKept"}},{"kind":"Field","name":{"kind":"Name","value":"contactsKept"}},{"kind":"Field","name":{"kind":"Name","value":"costUsd"}},{"kind":"Field","name":{"kind":"Name","value":"notesWritten"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}}]} as unknown as DocumentNode<InternalProviderResearchRunsQuery, InternalProviderResearchRunsQueryVariables>;
export const InternalRequestProviderResearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalRequestProviderResearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestProviderResearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"providerId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResearchRunFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResearchRunFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProviderResearchRun"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"requestedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"finishedAt"}},{"kind":"Field","name":{"kind":"Name","value":"engine"}},{"kind":"Field","name":{"kind":"Name","value":"skillVersion"}},{"kind":"Field","name":{"kind":"Name","value":"turns"}},{"kind":"Field","name":{"kind":"Name","value":"claimsKept"}},{"kind":"Field","name":{"kind":"Name","value":"contactsKept"}},{"kind":"Field","name":{"kind":"Name","value":"costUsd"}},{"kind":"Field","name":{"kind":"Name","value":"notesWritten"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBy"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}}]}}]} as unknown as DocumentNode<InternalRequestProviderResearchMutation, InternalRequestProviderResearchMutationVariables>;
export const InternalProviderFormsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderForms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__ProviderForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"formUrl"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}},{"kind":"Field","name":{"kind":"Name","value":"detectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"detectionFailedAt"}},{"kind":"Field","name":{"kind":"Name","value":"calibratedAt"}},{"kind":"Field","name":{"kind":"Name","value":"submissionChannel"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"faPolicyUrl"}}]}}]}}]}}]} as unknown as DocumentNode<InternalProviderFormsQuery, InternalProviderFormsQueryVariables>;
export const InternalProviderFormsForDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderFormsFor"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__ProviderForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"formUrl"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}},{"kind":"Field","name":{"kind":"Name","value":"detectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"detectionFailedAt"}},{"kind":"Field","name":{"kind":"Name","value":"calibratedAt"}},{"kind":"Field","name":{"kind":"Name","value":"submissionChannel"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"faPolicyUrl"}}]}}]}}]}}]} as unknown as DocumentNode<InternalProviderFormsForQuery, InternalProviderFormsForQueryVariables>;
export const InternalProviderFormByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderFormById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__ProviderForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"formUrl"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}},{"kind":"Field","name":{"kind":"Name","value":"detectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"detectionFailedAt"}},{"kind":"Field","name":{"kind":"Name","value":"calibratedAt"}},{"kind":"Field","name":{"kind":"Name","value":"submissionChannel"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"faPolicyUrl"}}]}}]}}]}}]} as unknown as DocumentNode<InternalProviderFormByIdQuery, InternalProviderFormByIdQueryVariables>;
export const InternalProviderByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__Provider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"faPolicyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"forms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"submissionChannel"}},{"kind":"Field","name":{"kind":"Name","value":"formUrl"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}}]}}]}}]}}]} as unknown as DocumentNode<InternalProviderByNameQuery, InternalProviderByNameQueryVariables>;
export const InternalProviderByAliasDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderByAlias"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__Provider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"aliases"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"faPolicyUrl"}},{"kind":"Field","name":{"kind":"Name","value":"forms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"submissionChannel"}},{"kind":"Field","name":{"kind":"Name","value":"formUrl"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}}]}}]}}]}}]} as unknown as DocumentNode<InternalProviderByAliasQuery, InternalProviderByAliasQueryVariables>;
export const GetHealthSystemLinkedProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetHealthSystemLinkedProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__Provider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"partOf"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"npi"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}}]}}]} as unknown as DocumentNode<GetHealthSystemLinkedProvidersQuery, GetHealthSystemLinkedProvidersQueryVariables>;
export const AssignUserSegmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AssignUserSegment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AssignUserSegmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignUserSegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignedCount"}}]}}]}}]} as unknown as DocumentNode<AssignUserSegmentMutation, AssignUserSegmentMutationVariables>;
export const RemoveUserSegmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveUserSegment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveUserSegmentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserSegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removedCount"}}]}}]}}]} as unknown as DocumentNode<RemoveUserSegmentMutation, RemoveUserSegmentMutationVariables>;
export const SegmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Segments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segment__Segment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"ACTIVE"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<SegmentsQuery, SegmentsQueryVariables>;
export const UserSegmentKeysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSegmentKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segment__UserSegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}}]}}]}}]}}]} as unknown as DocumentNode<UserSegmentKeysQuery, UserSegmentKeysQueryVariables>;
export const UsersSegmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersSegments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segment__UserSegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<UsersSegmentsQuery, UsersSegmentsQueryVariables>;
export const UserSegmentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserSegments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"segment__UserSegment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"segment"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]}}]} as unknown as DocumentNode<UserSegmentsQuery, UserSegmentsQueryVariables>;
export const InternalProviderFormInternalTemplateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalProviderFormInternalTemplate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__ProviderForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"internalTemplate"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}}]}}]}}]} as unknown as DocumentNode<InternalProviderFormInternalTemplateQuery, InternalProviderFormInternalTemplateQueryVariables>;
export const InternalStaffTailgateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalStaffTailgate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"staffTailgate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"executionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executionId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalStaffTailgateView"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalStaffTailgateView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"memberUserId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}},{"kind":"Field","name":{"kind":"Name","value":"portalName"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"portalMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateChoose"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxChoices"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateFillIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateConfirm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"browsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"vncUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdUntil"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"sha256"}},{"kind":"Field","name":{"kind":"Name","value":"takenAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentToIngestion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<InternalStaffTailgateQuery, InternalStaffTailgateQueryVariables>;
export const InternalStartStaffTailgateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalStartStaffTailgate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartStaffTailgateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startStaffTailgate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateStarted"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executionId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateRefused"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refusal"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<InternalStartStaffTailgateMutation, InternalStartStaffTailgateMutationVariables>;
export const InternalAnswerStaffTailgateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalAnswerStaffTailgate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnswerStaffTailgateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"answerStaffTailgate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalStaffTailgateView"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalStaffTailgateView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"memberUserId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}},{"kind":"Field","name":{"kind":"Name","value":"portalName"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"portalMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateChoose"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxChoices"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateFillIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateConfirm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"browsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"vncUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdUntil"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"sha256"}},{"kind":"Field","name":{"kind":"Name","value":"takenAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentToIngestion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<InternalAnswerStaffTailgateMutation, InternalAnswerStaffTailgateMutationVariables>;
export const InternalExtendStaffTailgateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalExtendStaffTailgate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extendStaffTailgate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalStaffTailgateView"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalStaffTailgateView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"memberUserId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}},{"kind":"Field","name":{"kind":"Name","value":"portalName"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"portalMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateChoose"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxChoices"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateFillIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateConfirm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"browsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"vncUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdUntil"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"sha256"}},{"kind":"Field","name":{"kind":"Name","value":"takenAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentToIngestion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<InternalExtendStaffTailgateMutation, InternalExtendStaffTailgateMutationVariables>;
export const InternalFinishStaffTailgateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalFinishStaffTailgate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finishStaffTailgate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalStaffTailgateView"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalStaffTailgateView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"memberUserId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}},{"kind":"Field","name":{"kind":"Name","value":"portalName"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"portalMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateChoose"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxChoices"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateFillIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateConfirm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"browsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"vncUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdUntil"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"sha256"}},{"kind":"Field","name":{"kind":"Name","value":"takenAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentToIngestion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<InternalFinishStaffTailgateMutation, InternalFinishStaffTailgateMutationVariables>;
export const InternalCancelStaffTailgateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalCancelStaffTailgate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateIdInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelStaffTailgate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalStaffTailgateView"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalStaffTailgateView"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"executionId"}},{"kind":"Field","name":{"kind":"Name","value":"memberUserId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}},{"kind":"Field","name":{"kind":"Name","value":"portalName"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"askId"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"portalMessage"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateChoose"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"maxChoices"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateFillIn"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"secret"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StaffTailgateConfirm"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"browsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionId"}},{"kind":"Field","name":{"kind":"Name","value":"vncUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"holdUntil"}},{"kind":"Field","name":{"kind":"Name","value":"steps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"size"}},{"kind":"Field","name":{"kind":"Name","value":"sha256"}},{"kind":"Field","name":{"kind":"Name","value":"takenAt"}},{"kind":"Field","name":{"kind":"Name","value":"sentToIngestion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"ending"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]} as unknown as DocumentNode<InternalCancelStaffTailgateMutation, InternalCancelStaffTailgateMutationVariables>;
export const InternalIngestStaffTailgateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InternalIngestStaffTailgateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IngestStaffTailgateFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ingestStaffTailgateFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<InternalIngestStaffTailgateFileMutation, InternalIngestStaffTailgateFileMutationVariables>;
export const HaMyTasksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HaMyTasks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HaMyTasksFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haMyTasks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"dedupeKey"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"dueDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"assignee"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}}]}},{"kind":"Field","name":{"kind":"Name","value":"comments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__IssueTask"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseRef"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__Issue_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","alias":{"kind":"Name","value":"memberMessagesAwaitingReply"},"name":{"kind":"Name","value":"events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"participant"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"USER"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"CHAT"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"actionRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__SendFormIssueTask_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"formSender"}},{"kind":"Field","name":{"kind":"Name","value":"sendingMethod"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__ReviewFindingTask_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"taskManagement__DataQualityFlagTask_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceName"}}]}}]}}]}}]} as unknown as DocumentNode<HaMyTasksQuery, HaMyTasksQueryVariables>;
export const HaMyTasksCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HaMyTasksCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HaMyTasksFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"haMyTasksCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}]}]}}]} as unknown as DocumentNode<HaMyTasksCountQuery, HaMyTasksCountQueryVariables>;
export const RetoolUpdateTaskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetoolUpdateTask"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTaskInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RetoolUpdateTaskMutation, RetoolUpdateTaskMutationVariables>;
export const RecordHaEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordHaEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"events"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"HaEventInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordHaEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"events"},"value":{"kind":"Variable","name":{"kind":"Name","value":"events"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accepted"}}]}}]}}]} as unknown as DocumentNode<RecordHaEventsMutation, RecordHaEventsMutationVariables>;
export const HaUserCoverageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HaUserCoverage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projection__UserDataView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"kind"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"StringValue","value":"coverage","block":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<HaUserCoverageQuery, HaUserCoverageQueryVariables>;
export const GenerateMetabaseSignedUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateMetabaseSignedUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MetabaseSignedUrlInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateMetabaseSignedUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<GenerateMetabaseSignedUrlMutation, GenerateMetabaseSignedUrlMutationVariables>;
export const InternalStoredCalibrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InternalStoredCalibration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__ProviderForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"provider"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"formType"}},{"kind":"Field","name":{"kind":"Name","value":"revision"}},{"kind":"Field","name":{"kind":"Name","value":"internalTemplate"}}]}}]}}]} as unknown as DocumentNode<InternalStoredCalibrationQuery, InternalStoredCalibrationQueryVariables>;
export const HaUserRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HaUserRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projection__UserDataView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"kind"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"claim","block":false},{"kind":"StringValue","value":"invoice","block":false},{"kind":"StringValue","value":"coverage","block":false},{"kind":"StringValue","value":"encounter","block":false}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<HaUserRecordsQuery, HaUserRecordsQueryVariables>;
export const UserResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"User"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projection__UserDataView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"kind"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"person","block":false},{"kind":"StringValue","value":"member","block":false},{"kind":"StringValue","value":"coverage","block":false},{"kind":"StringValue","value":"claim","block":false},{"kind":"StringValue","value":"invoice","block":false},{"kind":"StringValue","value":"encounter","block":false},{"kind":"StringValue","value":"accumulator","block":false}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<UserResourcesQuery, UserResourcesQueryVariables>;
export const UserEnrichmentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserEnrichment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"keys"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projection__UserEnrichmentData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"kind"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"claim","block":false},{"kind":"StringValue","value":"invoice","block":false}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"keys"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"overallPriceRating"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"enrichments"}}]}}]}}]} as unknown as DocumentNode<UserEnrichmentQuery, UserEnrichmentQueryVariables>;
export const AccountLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountLinks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__Link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedReason"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"latestExecution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"latestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<AccountLinksQuery, AccountLinksQueryVariables>;
export const UserDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UserDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"files"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uploaded"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"sides"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}},{"kind":"Field","name":{"kind":"Name","value":"source"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uploaded"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"s3Bucket"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UserDocumentsQuery, UserDocumentsQueryVariables>;
export const AskGrantedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AskGranted"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LlmInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryOpenai"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode<AskGrantedMutation, AskGrantedMutationVariables>;
export const PrimaryPersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PrimaryPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}}]}}]}}]}}]} as unknown as DocumentNode<PrimaryPersonQuery, PrimaryPersonQueryVariables>;
export const AddressAutocompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AddressAutocomplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressAutocompleteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressAutocomplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"predictions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"mainText"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryText"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}}]}}]} as unknown as DocumentNode<AddressAutocompleteQuery, AddressAutocompleteQueryVariables>;
export const AddressDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AddressDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddressDetailsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addressDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeId"}},{"kind":"Field","name":{"kind":"Name","value":"formattedAddress"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"county"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}}]}}]} as unknown as DocumentNode<AddressDetailsQuery, AddressDetailsQueryVariables>;
export const GetPaymentProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPaymentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentMethodId"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasPaymentMethod"}},{"kind":"Field","name":{"kind":"Name","value":"paymentMethodType"}},{"kind":"Field","name":{"kind":"Name","value":"cardDetails"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"}},{"kind":"Field","name":{"kind":"Name","value":"last4"}},{"kind":"Field","name":{"kind":"Name","value":"walletType"}}]}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]} as unknown as DocumentNode<GetPaymentProfileQuery, GetPaymentProfileQueryVariables>;
export const UpdatePaymentAgreementEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePaymentAgreementEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePaymentAgreementEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePaymentAgreementEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdatePaymentAgreementEventMutation, UpdatePaymentAgreementEventMutationVariables>;
export const AcceptBillPayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptBillPay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptBillPayInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptBillPay"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<AcceptBillPayMutation, AcceptBillPayMutationVariables>;
export const GetActivePromoForIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActivePromoForIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getActivePromoForIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"stripeDiscountPreview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amountOffCents"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}}]}}]}}]}}]} as unknown as DocumentNode<GetActivePromoForIssueQuery, GetActivePromoForIssueQueryVariables>;
export const ApplyPromoCodeUsageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ApplyPromoCodeUsage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyPromoCodeUsageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"applyPromoCodeUsage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ApplyPromoCodeUsageSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCodeUsage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stripeDiscountPreview"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"amountOffCents"}},{"kind":"Field","name":{"kind":"Name","value":"percentOff"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<ApplyPromoCodeUsageMutation, ApplyPromoCodeUsageMutationVariables>;
export const MarkPromoCodeUsageAsUnusedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkPromoCodeUsageAsUnused"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarkPromoCodeUsageAsUnusedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markPromoCodeUsageAsUnused"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"promoCodeUsage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"promoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"usedAt"}}]}}]}}]}}]} as unknown as DocumentNode<MarkPromoCodeUsageAsUnusedMutation, MarkPromoCodeUsageAsUnusedMutationVariables>;
export const CreateIssueFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateIssueFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CreateIssueFeedbackMutation, CreateIssueFeedbackMutationVariables>;
export const ReopenIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ReopenIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReopenIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reopenIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReopenIssueMutation, ReopenIssueMutationVariables>;
export const SendMagicLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMagicLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendMagicLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendMagicLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SendMagicLinkResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isShadow"}},{"kind":"Field","name":{"kind":"Name","value":"adminUserId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SendMagicLinkMutation, SendMagicLinkMutationVariables>;
export const ResendMagicLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResendMagicLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResendMagicLinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendMagicLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ResendMagicLinkMutation, ResendMagicLinkMutationVariables>;
export const AuthenticateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Authenticate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"firstAuthentication"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"hasPendingNateraIntake"}},{"kind":"Field","name":{"kind":"Name","value":"hasNateraCaseAwaitingActivation"}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isShadow"}},{"kind":"Field","name":{"kind":"Name","value":"adminUserId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errorType"}}]}}]}}]}}]} as unknown as DocumentNode<AuthenticateMutation, AuthenticateMutationVariables>;
export const AuthenticateWithInviteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AuthenticateWithInvite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticateWithInvite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}},{"kind":"Argument","name":{"kind":"Name","value":"inviteToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateWithInviteSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"firstAuthentication"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"hasNateraCaseAwaitingActivation"}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isShadow"}},{"kind":"Field","name":{"kind":"Name","value":"adminUserId"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthenticateError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errorType"}}]}}]}}]}}]} as unknown as DocumentNode<AuthenticateWithInviteMutation, AuthenticateWithInviteMutationVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const ShadowLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ShadowLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ShadowLoginInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shadowLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthUser"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"isShadow"}},{"kind":"Field","name":{"kind":"Name","value":"adminUserId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ShadowLoginMutation, ShadowLoginMutationVariables>;
export const ProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"primaryEmail"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastAuthenticatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTermsAt"}},{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segmentationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"features"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewerPartner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ProfileQuery, ProfileQueryVariables>;
export const ClientSupportedVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClientSupportedVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSupportedVersion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportedClientVersion"}},{"kind":"Field","name":{"kind":"Name","value":"supportedClientUpdateId"}},{"kind":"Field","name":{"kind":"Name","value":"latestClientVersion"}}]}}]}}]} as unknown as DocumentNode<ClientSupportedVersionQuery, ClientSupportedVersionQueryVariables>;
export const InsuranceLinkAttemptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsuranceLinkAttempt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrackInsuranceLinkAttemptInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackInsuranceLinkAttempt"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<InsuranceLinkAttemptMutation, InsuranceLinkAttemptMutationVariables>;
export const GetTemplateReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTemplateRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GetTemplateReleaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTemplateRelease"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateId"}},{"kind":"Field","name":{"kind":"Name","value":"templateOrgSlug"}},{"kind":"Field","name":{"kind":"Name","value":"templateOrgDisplayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"templateOrgLoginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"templateOrgDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"templateName"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"formSpec"}}]}}]}}]} as unknown as DocumentNode<GetTemplateReleaseQuery, GetTemplateReleaseQueryVariables>;
export const CreateDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateDocumentMutation, CreateDocumentMutationVariables>;
export const CreateSetupIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSetupIntent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateSetupIntentInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSetupIntent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clientSecret"}}]}}]}}]} as unknown as DocumentNode<CreateSetupIntentMutation, CreateSetupIntentMutationVariables>;
export const CreateMultiFileDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateMultiFileDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateMultiFileDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createMultiFileDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"s3Key"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateMultiFileDocumentMutation, CreateMultiFileDocumentMutationVariables>;
export const GetUnreadIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnreadIssues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"firstUnseenEvent"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"closedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetUnreadIssuesQuery, GetUnreadIssuesQueryVariables>;
export const DirectLoginToInstitutionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectLoginToInstitution"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginToInstitutionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directLoginToInstitution"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MfaRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mfaOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityQuestionRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"securityQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectLoginToInstitutionMutation, DirectLoginToInstitutionMutationVariables>;
export const DirectSubmitMfaCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectSubmitMfaCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitMfaCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directSubmitMfaCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectSubmitMfaCodeMutation, DirectSubmitMfaCodeMutationVariables>;
export const DirectRequestNewMfaCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectRequestNewMfaCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestNewMfaCodeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directRequestNewMfaCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectRequestNewMfaCodeMutation, DirectRequestNewMfaCodeMutationVariables>;
export const DirectSelectMfaMethodDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectSelectMfaMethod"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectMfaMethodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directSelectMfaMethod"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SelectMfaMethodResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectSelectMfaMethodMutation, DirectSelectMfaMethodMutationVariables>;
export const PlanDocumentsLoadingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlanDocumentsLoading"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"executionId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAttemptStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"executionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"executionId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dataTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"planDocuments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataTypeProcessing"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DataTypeNotSupported"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BenefitSummaryCreated"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"caseId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<PlanDocumentsLoadingQuery, PlanDocumentsLoadingQueryVariables>;
export const DirectSubmitSecurityAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectSubmitSecurityAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitSecurityAnswerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directSubmitSecurityAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityQuestionRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"securityQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectSubmitSecurityAnswerMutation, DirectSubmitSecurityAnswerMutationVariables>;
export const DirectStartLinkCreationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectStartLinkCreation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartLinkCreationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directStartLinkCreation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}}]}}]} as unknown as DocumentNode<DirectStartLinkCreationMutation, DirectStartLinkCreationMutationVariables>;
export const GetLinkEndpointDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLinkEndpoint"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__Link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"webAgent__Endpoint_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"cdpProvider"}},{"kind":"Field","name":{"kind":"Name","value":"loginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isAuthenticationRequired"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLinkEndpointQuery, GetLinkEndpointQueryVariables>;
export const DirectStartRelinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectStartRelink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartLinkRelinkInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directStartRelink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}}]}}]} as unknown as DocumentNode<DirectStartRelinkMutation, DirectStartRelinkMutationVariables>;
export const DirectAwaitLoginResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DirectAwaitLoginResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DirectAwaitLoginResultInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"directAwaitLoginResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"configureManagedMfa"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"linkId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InvalidCredentials"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflowId"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MfaRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mfaOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"method"}},{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SecurityQuestionRequired"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"securityQuestions"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedLoginMaxReached"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signInUrl"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RpaError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cause"}},{"kind":"Field","alias":{"kind":"Name","value":"errorSignInUrl"},"name":{"kind":"Name","value":"signInUrl"}}]}}]}}]}}]} as unknown as DocumentNode<DirectAwaitLoginResultMutation, DirectAwaitLoginResultMutationVariables>;
export const CheckBenefitsSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckBenefitsSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__Link"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"linkId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"plans"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsSummaryResults"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schemaVersion"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CheckBenefitsSummaryQuery, CheckBenefitsSummaryQueryVariables>;
export const GetInsuranceLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInsuranceLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexpaLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"patientDOB"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedReason"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"webAgentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"patientName"}},{"kind":"Field","name":{"kind":"Name","value":"patientId"}},{"kind":"Field","name":{"kind":"Name","value":"patientDOB"}},{"kind":"Field","name":{"kind":"Name","value":"latestExecution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"executions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"COMPLETED"},{"kind":"EnumValue","value":"PARTIAL"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"endedAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"deactivatedReason"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetInsuranceLinksQuery, GetInsuranceLinksQueryVariables>;
export const GetWebAgentEndpointsP012Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWebAgentEndpointsP012"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__Endpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"currentSupportLevel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"supportLevel"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"P0"},{"kind":"EnumValue","value":"P1"},{"kind":"EnumValue","value":"P2"}]}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"loginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"portalGuideUrl"}},{"kind":"Field","name":{"kind":"Name","value":"currentSupportLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetWebAgentEndpointsP012Query, GetWebAgentEndpointsP012QueryVariables>;
export const GetWebAgentEndpointsAllDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWebAgentEndpointsAll"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"webAgent__Endpoint"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isActive"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"displayUrl"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"loginUrl"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"portalGuideUrl"}},{"kind":"Field","name":{"kind":"Name","value":"currentSupportLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supportLevel"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]} as unknown as DocumentNode<GetWebAgentEndpointsAllQuery, GetWebAgentEndpointsAllQueryVariables>;
export const HasAnyCasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HasAnyCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<HasAnyCasesQuery, HasAnyCasesQueryVariables>;
export const ResolveInviteTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResolveInviteToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inviteToken"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveInviteToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inviteToken"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inviteToken"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AvailableInviteToken"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RedeemedInviteToken"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"partner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ResolveInviteTokenQuery, ResolveInviteTokenQueryVariables>;
export const GetUserIssuesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserIssues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserIssuesQuery, GetUserIssuesQueryVariables>;
export const CheckAllInsuranceLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckAllInsuranceLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkAllInsuranceLinks"}}]}}]} as unknown as DocumentNode<CheckAllInsuranceLinksMutation, CheckAllInsuranceLinksMutationVariables>;
export const OpenBillDisputeIssueMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OpenBillDisputeIssueMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<OpenBillDisputeIssueMutationMutation, OpenBillDisputeIssueMutationMutationVariables>;
export const GetBillPreviewEobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBillPreviewEob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eobId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resourceId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eobId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"explanationOfBenefits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resourceId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"type"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"network"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryPerson"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"primaryAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productOrService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"display"}},{"kind":"Field","name":{"kind":"Name","value":"system"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quantity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"adjudication"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewOutcome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"diagnosis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"diagnosisCodeableConcept"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billablePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"serviceDate"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalsByType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coinsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"copay"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"deductible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberLiability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nonCovered"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"discount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eligible"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paidByPatient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"paidToPatient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}},{"kind":"Field","name":{"kind":"Name","value":"submitted"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"explanation"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"lastReviewStatus"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"ACCEPTED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userDismissed"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"userDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fairMarketValue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"percentile50"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBillPreviewEobQuery, GetBillPreviewEobQueryVariables>;
export const GetFlaggedEobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlaggedEobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryFlaggedExplanationOfBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"totalsByType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"memberLiability"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"productOrService"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"display"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviewOutcome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"amount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"patient"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billablePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceDate"}},{"kind":"Field","name":{"kind":"Name","value":"findings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"explanation"}},{"kind":"Field","name":{"kind":"Name","value":"userDismissed"}},{"kind":"Field","name":{"kind":"Name","value":"lastReviewStatus"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"note"}}]}}]}}]}}]} as unknown as DocumentNode<GetFlaggedEobsQuery, GetFlaggedEobsQueryVariables>;
export const GetFlaggedEobsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFlaggedEobsCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"countFlaggedExplanationOfBenefits"}}]}}]} as unknown as DocumentNode<GetFlaggedEobsCountQuery, GetFlaggedEobsCountQueryVariables>;
export const GetInsuranceLinkStatusQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInsuranceLinkStatusQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexpaLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"lastSyncedAt"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"webAgentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"latestExecution"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ingestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"explanationOfBenefits"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetInsuranceLinkStatusQueryQuery, GetInsuranceLinkStatusQueryQueryVariables>;
export const GetUserEobsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserEobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryUserEobs"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUserEobsQuery, GetUserEobsQueryVariables>;
export const GetUserInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryUserInvoices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUserInvoicesQuery, GetUserInvoicesQueryVariables>;
export const GetUserEobDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserEob"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryUserEob"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUserEobQuery, GetUserEobQueryVariables>;
export const GetUserInvoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserInvoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryUserInvoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"enrichment"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetUserInvoiceQuery, GetUserInvoiceQueryVariables>;
export const GetDocumentAnalysisEventStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDocumentAnalysisEventStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Event"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDocumentAnalysisEventStatusQuery, GetDocumentAnalysisEventStatusQueryVariables>;
export const RetryDocumentAnalysisForEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetryDocumentAnalysisForEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processDocumentForAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isRetry"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"event"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<RetryDocumentAnalysisForEventMutation, RetryDocumentAnalysisForEventMutationVariables>;
export const RetryDocumentAnalysisForDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RetryDocumentAnalysisForDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"processDocumentForAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"documentId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"documentId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"isRetry"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"workflowId"}}]}}]}}]} as unknown as DocumentNode<RetryDocumentAnalysisForDocumentMutation, RetryDocumentAnalysisForDocumentMutationVariables>;
export const StartManualIntakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartManualIntake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartManualIntakeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startManualIntake"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"started"}}]}}]}}]} as unknown as DocumentNode<StartManualIntakeMutation, StartManualIntakeMutationVariables>;
export const GetCompletedPostEscalationActionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCompletedPostEscalationActions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"completedPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPostEscalationActions"}}]}}]}}]} as unknown as DocumentNode<GetCompletedPostEscalationActionsQuery, GetCompletedPostEscalationActionsQueryVariables>;
export const StartPostEscalationQuestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartPostEscalationQuestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartPostEscalationQuestionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startPostEscalationQuestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<StartPostEscalationQuestionMutation, StartPostEscalationQuestionMutationVariables>;
export const RecordInsuranceStatusFromCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordInsuranceStatusFromCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordInsuranceStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordInsuranceStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RecordInsuranceStatusFromCaseMutation, RecordInsuranceStatusFromCaseMutationVariables>;
export const DeclareNoIncomeDocumentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeclareNoIncomeDocuments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeclareNoIncomeDocumentsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"declareNoIncomeDocuments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeclareNoIncomeDocumentsMutation, DeclareNoIncomeDocumentsMutationVariables>;
export const CloseCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CloseCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CloseCaseInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"closeCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CloseCaseMutation, CloseCaseMutationVariables>;
export const GetIssueDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIssueDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"billDisputeType"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsInclude"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsPrice"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"BILL_DISPUTE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"healthRecordKind"}},{"kind":"Field","name":{"kind":"Name","value":"healthRecordKey"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsContext"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}},{"kind":"Field","name":{"kind":"Name","value":"planType"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"sbc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"coc"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"spd"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetIssueDetailsQuery, GetIssueDetailsQueryVariables>;
export const GetIssueIdByCaseRefDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIssueIdByCaseRef"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"caseRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"caseRef"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"caseRef"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetIssueIdByCaseRefQuery, GetIssueIdByCaseRefQueryVariables>;
export const GetCaseActivationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaseActivation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nateraIntake"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"PAYMENT_PREFERENCES_REQUESTED"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCaseActivationQuery, GetCaseActivationQueryVariables>;
export const GetCaseDocumentStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaseDocumentStages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eventType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"DOCUMENT_UPLOADED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentUploadedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"documentStage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"attemptStartedAt"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"sender"}},{"kind":"Field","name":{"kind":"Name","value":"at"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCaseDocumentStagesQuery, GetCaseDocumentStagesQueryVariables>;
export const GetIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__Issue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"providerDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"billDisputeType"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsInclude"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"completedPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"hasStaffParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"nateraIntake"}},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentUploadedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploading"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"uploadFailed"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"previewPromptMessage"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestIngestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isLatest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__InvoiceVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"invoiceTitle"},"name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__ExplanationOfBenefitVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"eobTitle"},"name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentClassificationFailedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"classificationResolvedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eobId"}},{"kind":"Field","name":{"kind":"Name","value":"healthRecordKey"}},{"kind":"Field","name":{"kind":"Name","value":"eob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"releaseRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userClosureReason"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDate"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BenefitsSummaryGeneratedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsSummaryResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaVersion"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PlanSelectionEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"stringMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"stringOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"multiMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"multiOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserInputRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"inputMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSpec"}},{"kind":"Field","name":{"kind":"Name","value":"answerValue"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"isResolved"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectAccountRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","alias":{"kind":"Name","value":"connectAccountMessage"},"name":{"kind":"Name","value":"chatBody"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"showSkipButton"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"billPayPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaySuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiatedBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"originalBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeePercent"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsConfirmedAt"},"name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsDeclinedAt"},"name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CardCollectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardSupersededAt"}},{"kind":"Field","alias":{"kind":"Name","value":"cardActionRequired"},"name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__OutreachEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachBody"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsConfirmedAt"},"name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsDeclinedAt"},"name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CardCollectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardSupersededAt"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserInputRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"inputMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSpec"}},{"kind":"Field","name":{"kind":"Name","value":"answerValue"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"isResolved"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__AskReraisedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reraisedAsk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentSuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentChargeFailedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedReason"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HAAssignedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assigneeProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assigneeAverageCaseRating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PostEscalationActionsEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadBillPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadBillLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadEobPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadEobLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadMemberIdPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadMemberIdLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadProofOfIncomePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadProofOfIncomeLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__SignTemplatePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"signLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"payLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsurancePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"insLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectEhrPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ehrLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"webAgentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"webAgent__Endpoint_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"executions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"signInSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestStatus"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"webAgent__Endpoint_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetIssueQuery, GetIssueQueryVariables>;
export const GetCaseRowsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaseRowsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseRowsById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventIds"}}},{"kind":"Argument","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseIssueFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseIssueLatestEvents"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseDocumentUploadedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseDocumentClassificationFailedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseChatEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseHipaaReleaseRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillDisputeEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseTemplateReleaseRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseClosedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePaymentAgreementRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseClosurePaymentRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBenefitsSummaryGeneratedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePlanSelectionEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseUserSelectionRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseUserMultiSelectionRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseUserInputRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseConnectInsuranceRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseConnectAccountRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillPayRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillPaySuccessEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePaymentPreferencesRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseCardCollectionRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseOutreachEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseAskReraisedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillPaymentRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillPaymentSuccessEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePaymentChargeFailedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseDocumentAnalysisEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseHaAssignedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePostEscalationActionsEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseIssueFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__Issue_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"providerDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"billDisputeType"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsInclude"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"completedPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"hasStaffParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"nateraIntake"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseIssueLatestEvents"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__Issue_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseDocumentUploadedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentUploadedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploading"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"uploadFailed"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"previewPromptMessage"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestIngestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isLatest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__InvoiceVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"invoiceTitle"},"name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__ExplanationOfBenefitVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"eobTitle"},"name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseDocumentClassificationFailedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentClassificationFailedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"classificationResolvedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseChatEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseHipaaReleaseRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillDisputeEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eobId"}},{"kind":"Field","name":{"kind":"Name","value":"healthRecordKey"}},{"kind":"Field","name":{"kind":"Name","value":"eob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseTemplateReleaseRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"releaseRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseClosedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userClosureReason"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePaymentAgreementRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseClosurePaymentRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBenefitsSummaryGeneratedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BenefitsSummaryGeneratedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsSummaryResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaVersion"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePlanSelectionEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PlanSelectionEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseUserSelectionRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"stringMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"stringOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseUserMultiSelectionRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"multiMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"multiOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseUserInputRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserInputRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"inputMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSpec"}},{"kind":"Field","name":{"kind":"Name","value":"answerValue"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"isResolved"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseConnectInsuranceRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseConnectAccountRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectAccountRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","alias":{"kind":"Name","value":"connectAccountMessage"},"name":{"kind":"Name","value":"chatBody"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"showSkipButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPayRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"billPayPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPaySuccessEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaySuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiatedBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"originalBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeePercent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePaymentPreferencesRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsConfirmedAt"},"name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsDeclinedAt"},"name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseCardCollectionRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CardCollectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardSupersededAt"}},{"kind":"Field","alias":{"kind":"Name","value":"cardActionRequired"},"name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseOutreachEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__OutreachEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachBody"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsConfirmedAt"},"name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsDeclinedAt"},"name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CardCollectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardSupersededAt"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserInputRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"inputMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSpec"}},{"kind":"Field","name":{"kind":"Name","value":"answerValue"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"isResolved"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseAskReraisedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__AskReraisedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reraisedAsk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPaymentRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPaymentSuccessEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentSuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePaymentChargeFailedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentChargeFailedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedReason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseDocumentAnalysisEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseHaAssignedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HAAssignedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assigneeProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assigneeAverageCaseRating"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePostEscalationActionsEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PostEscalationActionsEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadBillPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadBillLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadEobPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadEobLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadMemberIdPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadMemberIdLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadProofOfIncomePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadProofOfIncomeLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__SignTemplatePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"signLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"payLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsurancePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"insLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectEhrPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ehrLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCaseRowsByIdQuery, GetCaseRowsByIdQueryVariables>;
export const GetCaseRowsSinceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCaseRowsSince"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"caseRowsSince"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseIssueFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseIssueLatestEvents"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseDocumentUploadedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseDocumentClassificationFailedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseChatEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseHipaaReleaseRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillDisputeEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseTemplateReleaseRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseClosedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePaymentAgreementRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseClosurePaymentRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBenefitsSummaryGeneratedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePlanSelectionEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseUserSelectionRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseUserMultiSelectionRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseUserInputRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseConnectInsuranceRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseConnectAccountRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillPayRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillPaySuccessEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePaymentPreferencesRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseCardCollectionRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseOutreachEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseAskReraisedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillPaymentRequestedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseBillPaymentSuccessEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePaymentChargeFailedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseDocumentAnalysisEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CaseHaAssignedEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CasePostEscalationActionsEventFields"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"}}]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseIssueFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__Issue_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"providerDetail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsQuestionType"}},{"kind":"Field","name":{"kind":"Name","value":"billDisputeType"}},{"kind":"Field","name":{"kind":"Name","value":"additionalDetails"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsInclude"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsPrice"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"completedPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"pendingPostEscalationActions"}},{"kind":"Field","name":{"kind":"Name","value":"hasStaffParticipant"}},{"kind":"Field","name":{"kind":"Name","value":"benefitsCoverage"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"nateraIntake"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseIssueLatestEvents"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__Issue_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseDocumentUploadedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentUploadedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploading"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"uploadFailed"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"previewPromptMessage"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dataType"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"latestIngestion"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isLatest"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__InvoiceVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"invoiceTitle"},"name":{"kind":"Name","value":"title"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"fhirext__ExplanationOfBenefitVersion_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"eobTitle"},"name":{"kind":"Name","value":"title"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sizeBytes"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseDocumentClassificationFailedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentClassificationFailedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classificationStatus"}},{"kind":"Field","name":{"kind":"Name","value":"classificationResolvedAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseChatEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseHipaaReleaseRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillDisputeEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillDisputeEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eobId"}},{"kind":"Field","name":{"kind":"Name","value":"healthRecordKey"}},{"kind":"Field","name":{"kind":"Name","value":"eob"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"provider"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"facility"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"display"}}]}},{"kind":"Field","name":{"kind":"Name","value":"decision"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coding"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseTemplateReleaseRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"releaseRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseClosedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userClosureReason"}},{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"review"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePaymentAgreementRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userAccepted"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseClosurePaymentRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ClosurePaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFee"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDelayDays"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"chargeDate"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBenefitsSummaryGeneratedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BenefitsSummaryGeneratedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}},{"kind":"Field","name":{"kind":"Name","value":"link"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpoint"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"benefitsSummaryResults"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"schemaVersion"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"benefitsSummarySchemaVersion"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePlanSelectionEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PlanSelectionEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"selectedPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"planLabel"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseUserSelectionRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"stringMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"stringOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseUserMultiSelectionRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"multiMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","alias":{"kind":"Name","value":"multiOptions"},"name":{"kind":"Name","value":"options"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseUserInputRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserInputRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"inputMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSpec"}},{"kind":"Field","name":{"kind":"Name","value":"answerValue"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"isResolved"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseConnectInsuranceRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseConnectAccountRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectAccountRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","alias":{"kind":"Name","value":"connectAccountMessage"},"name":{"kind":"Name","value":"chatBody"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}},{"kind":"Field","name":{"kind":"Name","value":"buttonText"}},{"kind":"Field","name":{"kind":"Name","value":"showSkipButton"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPayRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"billPayPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPaySuccessEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaySuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"negotiatedBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"originalBillAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeeAmount"}},{"kind":"Field","name":{"kind":"Name","value":"successFeePercent"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePaymentPreferencesRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsConfirmedAt"},"name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsDeclinedAt"},"name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseCardCollectionRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CardCollectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardSupersededAt"}},{"kind":"Field","alias":{"kind":"Name","value":"cardActionRequired"},"name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseOutreachEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__OutreachEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outreachBody"}},{"kind":"Field","name":{"kind":"Name","value":"ask"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HipaaReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hipaaRelease"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"templateCounterpartyType"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentRequestKey"},"name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsConfirmedAt"},"name":{"kind":"Name","value":"confirmedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsDeclinedAt"},"name":{"kind":"Name","value":"declinedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsPreAuthStatus"},"name":{"kind":"Name","value":"preAuthStatus"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__CardCollectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}},{"kind":"Field","name":{"kind":"Name","value":"cardSupersededAt"}},{"kind":"Field","name":{"kind":"Name","value":"seenAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserInputRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"inputMessage"},"name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fieldSpec"}},{"kind":"Field","name":{"kind":"Name","value":"answerValue"}},{"kind":"Field","name":{"kind":"Name","value":"skippable"}},{"kind":"Field","name":{"kind":"Name","value":"freeTextAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"outcome"}},{"kind":"Field","name":{"kind":"Name","value":"isResolved"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseAskReraisedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__AskReraisedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reraisedAsk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPaymentRequestedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseBillPaymentSuccessEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentSuccessEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePaymentChargeFailedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentChargeFailedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedReason"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseDocumentAnalysisEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__DocumentAnalysisEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"errorIsRetriable"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CaseHaAssignedEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__HAAssignedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assigneeProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assigneeAverageCaseRating"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CasePostEscalationActionsEventFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PostEscalationActionsEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isRequired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"isRequired"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadBillPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadBillLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadEobPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadEobLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadMemberIdPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadMemberIdLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UploadProofOfIncomePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"uploadProofOfIncomeLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__SignTemplatePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"signLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"release"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateType"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentAgreementPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"payLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPayPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPayLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"availableMinimumDiscountOptions"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsurancePostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"insLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectEhrPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"ehrLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endpointType"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentPreferencesPostEscalationAction_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"paymentPrefsLinkedEvent"},"name":{"kind":"Name","value":"linkedEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetCaseRowsSinceQuery, GetCaseRowsSinceQueryVariables>;
export const SendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateIssueChatEventInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createIssueChatEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"userVisible"}},{"kind":"Field","name":{"kind":"Name","value":"sentByProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"eventFeedbacks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}}]}}]}}]} as unknown as DocumentNode<SendMessageMutation, SendMessageMutationVariables>;
export const MarkIssueAsSeenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkIssueAsSeen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateIssueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MarkIssueAsSeenMutation, MarkIssueAsSeenMutationVariables>;
export const selectPlanForEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"selectPlanForEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SelectPlanForEventInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"selectPlanForEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<selectPlanForEventMutation, selectPlanForEventMutationVariables>;
export const chargeRetryReadyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"chargeRetryReady"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChargeRetryReadyInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chargeRetryReady"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userVisibleEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__PaymentChargeFailedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedAt"}},{"kind":"Field","name":{"kind":"Name","value":"paymentResolvedReason"}}]}}]}}]}}]}}]} as unknown as DocumentNode<chargeRetryReadyMutation, chargeRetryReadyMutationVariables>;
export const provideUserInputAnswerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"provideUserInputAnswer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProvideUserInputAnswerInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provideUserInputAnswer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<provideUserInputAnswerMutation, provideUserInputAnswerMutationVariables>;
export const RecordIssueChatEventFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordIssueChatEventFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordIssueEventFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordIssueEventFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RecordIssueChatEventFeedbackMutation, RecordIssueChatEventFeedbackMutationVariables>;
export const ConversationEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ConversationEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"turnId"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"toolName"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"attemptStartedAt"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"sender"}},{"kind":"Field","name":{"kind":"Name","value":"waitingOn"}},{"kind":"Field","name":{"kind":"Name","value":"waitingOnKind"}},{"kind":"Field","name":{"kind":"Name","value":"waitingOnDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"fromSeq"}},{"kind":"Field","name":{"kind":"Name","value":"toSeq"}}]}}]}}]} as unknown as DocumentNode<ConversationEventsSubscription, ConversationEventsSubscriptionVariables>;
export const ConversationEventsV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ConversationEventsV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"turnId"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"toolName"}},{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"stage"}},{"kind":"Field","name":{"kind":"Name","value":"attemptId"}},{"kind":"Field","name":{"kind":"Name","value":"attemptStartedAt"}},{"kind":"Field","name":{"kind":"Name","value":"at"}},{"kind":"Field","name":{"kind":"Name","value":"detail"}},{"kind":"Field","name":{"kind":"Name","value":"sender"}},{"kind":"Field","name":{"kind":"Name","value":"waitingOn"}},{"kind":"Field","name":{"kind":"Name","value":"waitingOnKind"}},{"kind":"Field","name":{"kind":"Name","value":"waitingOnDocumentId"}},{"kind":"Field","name":{"kind":"Name","value":"seq"}},{"kind":"Field","name":{"kind":"Name","value":"fromSeq"}},{"kind":"Field","name":{"kind":"Name","value":"toSeq"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"eventIds"}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","name":{"kind":"Name","value":"blockRow"}}]}}]}}]} as unknown as DocumentNode<ConversationEventsV2Subscription, ConversationEventsV2SubscriptionVariables>;
export const LegacyConversationEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"LegacyConversationEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"conversationEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"turnId"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"toolName"}}]}}]}}]} as unknown as DocumentNode<LegacyConversationEventsSubscription, LegacyConversationEventsSubscriptionVariables>;
export const GetChatEventFeedbackOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChatEventFeedbackOptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"area"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"feedback__AreaType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback__Option"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"area"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"area"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"archived"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}}]}}]}}]} as unknown as DocumentNode<GetChatEventFeedbackOptionsQuery, GetChatEventFeedbackOptionsQueryVariables>;
export const SearchProvidersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchProviders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchProviders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<SearchProvidersQuery, SearchProvidersQueryVariables>;
export const ProviderDisplayNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProviderDisplayName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"provider__Provider"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<ProviderDisplayNameQuery, ProviderDisplayNameQueryVariables>;
export const QueryIssuesV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"QueryIssuesV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"closed"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unread"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"read"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"open"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryIssuesV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"closed"},"value":{"kind":"Variable","name":{"kind":"Name","value":"closed"}}},{"kind":"Argument","name":{"kind":"Name","value":"unread"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unread"}}},{"kind":"Argument","name":{"kind":"Name","value":"read"},"value":{"kind":"Variable","name":{"kind":"Name","value":"read"}}},{"kind":"Argument","name":{"kind":"Name","value":"open"},"value":{"kind":"Variable","name":{"kind":"Name","value":"open"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stringMessage"},"name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiMessage"},"name":{"kind":"Name","value":"message"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"firstUnseenEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"participant"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ChatEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chatBody"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__TemplateReleaseRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__BillPaymentRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"billPaymentAcceptedAt"},"name":{"kind":"Name","value":"acceptedAt"}},{"kind":"Field","name":{"kind":"Name","value":"billPaid"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__ConnectInsuranceRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insuranceLinkMessage"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"stringMessage"},"name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"issue__UserMultiSelectionRequestedEvent_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"multiMessage"},"name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<QueryIssuesV2Query, QueryIssuesV2QueryVariables>;
export const OpenNewIssueFromPreviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OpenNewIssueFromPreview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OpenNewIssueFromPreviewInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openNewIssueFromPreview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}}]}}]}}]} as unknown as DocumentNode<OpenNewIssueFromPreviewMutation, OpenNewIssueFromPreviewMutationVariables>;
export const GetFileIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFileIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"document__Document"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<GetFileIdsQuery, GetFileIdsQueryVariables>;
export const FaApplicationForIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FaApplicationForIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"faApplicationForIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"issueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issueId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formSpec"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reopenedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"skippedAt"}}]}}]}}]} as unknown as DocumentNode<FaApplicationForIssueQuery, FaApplicationForIssueQueryVariables>;
export const SaveFaApplicationDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveFaApplicationDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SaveFaApplicationDraftInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveFaApplicationDraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formSpec"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reopenedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"skippedAt"}}]}}]}}]} as unknown as DocumentNode<SaveFaApplicationDraftMutation, SaveFaApplicationDraftMutationVariables>;
export const SubmitFaApplicationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitFaApplication"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitFaApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitFaApplication"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplicationView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formSpec"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reopenedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"skippedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaSubmitValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formMessage"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SubmitFaApplicationMutation, SubmitFaApplicationMutationVariables>;
export const SkipFaApplicationForIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SkipFaApplicationForIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SkipFaApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skipFaApplicationForIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplicationView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formSpec"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reopenedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"skippedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<SkipFaApplicationForIssueMutation, SkipFaApplicationForIssueMutationVariables>;
export const StartFaApplicationForIssueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"StartFaApplicationForIssue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"StartFaApplicationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startFaApplicationForIssue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FaApplicationView"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formSpec"}},{"kind":"Field","name":{"kind":"Name","value":"formState"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reopenedAt"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"skippedAt"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<StartFaApplicationForIssueMutation, StartFaApplicationForIssueMutationVariables>;
export const GetYourCasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetYourCases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"issues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"closedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"openedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"openedAt"}},{"kind":"Field","name":{"kind":"Name","value":"nateraIntake"}},{"kind":"Field","name":{"kind":"Name","value":"isEscalated"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"lastEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"actionRequired"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetYourCasesQuery, GetYourCasesQueryVariables>;
export const GetClosedWinsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetClosedWins"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__ClosedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"feedback"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"issue"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"closedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"exists"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sentAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"15"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userClosureReason"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"closedAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"caseManagementClosureReason"}},{"kind":"Field","name":{"kind":"Name","value":"dollarAmountSaved"}},{"kind":"Field","name":{"kind":"Name","value":"providerName"}}]}}]}}]}}]} as unknown as DocumentNode<GetClosedWinsQuery, GetClosedWinsQueryVariables>;
export const CheckInsuranceLinksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckInsuranceLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"flexpaLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}},{"kind":"Field","name":{"kind":"Name","value":"webAgentLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}}]} as unknown as DocumentNode<CheckInsuranceLinksQuery, CheckInsuranceLinksQueryVariables>;
export const GetPersonalizedPromptsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPersonalizedPrompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getPersonalizedPrompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prompts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"response"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"icon"}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonalizedPromptsQuery, GetPersonalizedPromptsQueryVariables>;
export const PendingNateraIntakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PendingNateraIntake"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPendingNateraIntake"}}]}}]} as unknown as DocumentNode<PendingNateraIntakeQuery, PendingNateraIntakeQueryVariables>;
export const NateraIntakeResumeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NateraIntakeResume"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nateraIntakeResumeDestination"}}]}}]} as unknown as DocumentNode<NateraIntakeResumeQuery, NateraIntakeResumeQueryVariables>;
export const NateraIntakeIdentityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NateraIntakeIdentity"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}}]} as unknown as DocumentNode<NateraIntakeIdentityQuery, NateraIntakeIdentityQueryVariables>;
export const PendingNateraIntakeAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PendingNateraIntakeAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pendingNateraIntakeAnswers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"expressArm"}},{"kind":"Field","name":{"kind":"Name","value":"billCount"}},{"kind":"Field","name":{"kind":"Name","value":"billRangeFloorCents"}},{"kind":"Field","name":{"kind":"Name","value":"billRangeCeilingCents"}},{"kind":"Field","name":{"kind":"Name","value":"householdSize"}},{"kind":"Field","name":{"kind":"Name","value":"annualHouseholdIncomeCents"}},{"kind":"Field","name":{"kind":"Name","value":"incomeDeclined"}},{"kind":"Field","name":{"kind":"Name","value":"incomeRangeFloorCents"}},{"kind":"Field","name":{"kind":"Name","value":"incomeRangeCeilingCents"}},{"kind":"Field","name":{"kind":"Name","value":"faRead"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceCarrier"}}]}}]}}]} as unknown as DocumentNode<PendingNateraIntakeAnswersQuery, PendingNateraIntakeAnswersQueryVariables>;
export const NateraQuoteInsuranceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NateraQuoteInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"myInsurance"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"state"}}]}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"accountHolder"}},{"kind":"Field","name":{"kind":"Name","value":"coverageType"}},{"kind":"Field","name":{"kind":"Name","value":"payerName"}},{"kind":"Field","name":{"kind":"Name","value":"payer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}}]}},{"kind":"Field","name":{"kind":"Name","value":"person"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"groupName"}},{"kind":"Field","name":{"kind":"Name","value":"stale"}},{"kind":"Field","name":{"kind":"Name","value":"plan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"planYear"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"start"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"positions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kind"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"service"}},{"kind":"Field","name":{"kind":"Name","value":"metAmount"}},{"kind":"Field","name":{"kind":"Name","value":"limitAmount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<NateraQuoteInsuranceQuery, NateraQuoteInsuranceQueryVariables>;
export const RecordNateraIntakeAnswersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordNateraIntakeAnswers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordNateraIntakeAnswersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordNateraIntakeAnswers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<RecordNateraIntakeAnswersMutation, RecordNateraIntakeAnswersMutationVariables>;
export const RecordPhoneForNateraIntakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordPhoneForNateraIntake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordPhoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordPhone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RecordPhoneForNateraIntakeMutation, RecordPhoneForNateraIntakeMutationVariables>;
export const CreateNateraIntakeCaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateNateraIntakeCase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateNateraIntakeCaseInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createNateraIntakeCase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"paymentPreferencesRequestId"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}},{"kind":"Field","name":{"kind":"Name","value":"created"}}]}}]}}]} as unknown as DocumentNode<CreateNateraIntakeCaseMutation, CreateNateraIntakeCaseMutationVariables>;
export const CompleteNateraIntakeActivationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteNateraIntakeActivation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompleteNateraIntakeActivationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"completeNateraIntakeActivation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"escalated"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"missing"}},{"kind":"Field","name":{"kind":"Name","value":"hipaaTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"uninsuredDeclared"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceVerified"}},{"kind":"Field","name":{"kind":"Name","value":"uploadCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reminderAt"}}]}}]}}]} as unknown as DocumentNode<CompleteNateraIntakeActivationMutation, CompleteNateraIntakeActivationMutationVariables>;
export const RequestNateraIntakeReminderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestNateraIntakeReminder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestNateraIntakeReminderInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestNateraIntakeReminder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueId"}},{"kind":"Field","name":{"kind":"Name","value":"escalated"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"missing"}},{"kind":"Field","name":{"kind":"Name","value":"hipaaTemplateId"}},{"kind":"Field","name":{"kind":"Name","value":"uninsuredDeclared"}},{"kind":"Field","name":{"kind":"Name","value":"insuranceVerified"}},{"kind":"Field","name":{"kind":"Name","value":"uploadCounts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"}},{"kind":"Field","name":{"kind":"Name","value":"count"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reminderAt"}}]}}]}}]} as unknown as DocumentNode<RequestNateraIntakeReminderMutation, RequestNateraIntakeReminderMutationVariables>;
export const RecordInsuranceStatusFromNateraIntakeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordInsuranceStatusFromNateraIntake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordInsuranceStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordInsuranceStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RecordInsuranceStatusFromNateraIntakeMutation, RecordInsuranceStatusFromNateraIntakeMutationVariables>;
export const NateraIntakeAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NateraIntakeAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issue__PaymentPreferencesRequestedEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"caseType"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"requestKey"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"labels"}},{"kind":"Field","name":{"kind":"Name","value":"totalBillDollarAmount"}},{"kind":"Field","name":{"kind":"Name","value":"nateraIntake"}}]}}]}}]}}]} as unknown as DocumentNode<NateraIntakeAgreementQuery, NateraIntakeAgreementQueryVariables>;
export const AcknowledgePaymentFeeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcknowledgePaymentFee"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcknowledgePaymentFeeInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acknowledgePaymentFee"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"contract"}},{"kind":"Field","name":{"kind":"Name","value":"feeAcknowledgedAt"}},{"kind":"Field","name":{"kind":"Name","value":"feePercentSnapshot"}},{"kind":"Field","name":{"kind":"Name","value":"resolvedFeeCap"}},{"kind":"Field","name":{"kind":"Name","value":"appliedPromoCode"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<AcknowledgePaymentFeeMutation, AcknowledgePaymentFeeMutationVariables>;
export const CheckFaEligibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckFaEligibility"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckFaEligibilityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkFaEligibility"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outcome"}}]}}]}}]} as unknown as DocumentNode<CheckFaEligibilityMutation, CheckFaEligibilityMutationVariables>;
export const AcceptTermsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptTerms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AcceptTermsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptTerms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const RecordIdentityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordIdentity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordIdentityInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordIdentity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RecordIdentityMutation, RecordIdentityMutationVariables>;
export const RecordPhoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordPhone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordPhoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordPhone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RecordPhoneMutation, RecordPhoneMutationVariables>;
export const RecordInsuranceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordInsurance"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordInsuranceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordInsurance"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RecordInsuranceMutation, RecordInsuranceMutationVariables>;
export const OnboardingSearchPayersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingSearchPayers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SearchPayersInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchPayers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPayerId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"memberIdRequired"}}]}}]}}]} as unknown as DocumentNode<OnboardingSearchPayersQuery, OnboardingSearchPayersQueryVariables>;
export const OnboardingPopularPayersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingPopularPayers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"popularPayers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primaryPayerId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"memberIdRequired"}}]}}]}}]} as unknown as DocumentNode<OnboardingPopularPayersQuery, OnboardingPopularPayersQueryVariables>;
export const RecordInsuranceStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecordInsuranceStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordInsuranceStatusInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordInsuranceStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ok"}}]}}]}}]} as unknown as DocumentNode<RecordInsuranceStatusMutation, RecordInsuranceStatusMutationVariables>;
export const OnboardingDerivedStateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OnboardingDerivedState"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"acceptedTermsAt"}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}}]}},{"kind":"Field","name":{"kind":"Name","value":"segmentationData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasInsurance"}},{"kind":"Field","name":{"kind":"Name","value":"features"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"projection__UserMemory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"entries"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewerPartner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<OnboardingDerivedStateQuery, OnboardingDerivedStateQueryVariables>;
export const UpsertOnboardingIntentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertOnboardingIntent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertUserSegmentationDataInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertUserSegmentationData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpsertOnboardingIntentMutation, UpsertOnboardingIntentMutationVariables>;
export const PreAuthorizePaymentPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PreAuthorizePaymentPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreAuthorizePaymentPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preAuthorizePaymentPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PreAuthorizePaymentPreferencesMutation, PreAuthorizePaymentPreferencesMutationVariables>;
export const ConfirmPaymentPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmPaymentPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmPaymentPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmPaymentPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}}]}}]}}]} as unknown as DocumentNode<ConfirmPaymentPreferencesMutation, ConfirmPaymentPreferencesMutationVariables>;
export const ConfirmSimplifiedPaymentAgreementDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ConfirmSimplifiedPaymentAgreement"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ConfirmSimplifiedPaymentAgreementInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmSimplifiedPaymentAgreement"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmedAt"}}]}}]}}]} as unknown as DocumentNode<ConfirmSimplifiedPaymentAgreementMutation, ConfirmSimplifiedPaymentAgreementMutationVariables>;
export const DeclinePaymentPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeclinePaymentPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeclinePaymentPreferencesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"declinePaymentPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"declinedAt"}}]}}]}}]} as unknown as DocumentNode<DeclinePaymentPreferencesMutation, DeclinePaymentPreferencesMutationVariables>;
export const CaptureCardCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CaptureCardCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CaptureCardCollectionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"captureCardCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardSucceededAt"}}]}}]}}]} as unknown as DocumentNode<CaptureCardCollectionMutation, CaptureCardCollectionMutationVariables>;
export const MergePersonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MergePersons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MergePersonsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"mergePersons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"path"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]}}]} as unknown as DocumentNode<MergePersonsMutation, MergePersonsMutationVariables>;
export const CreatePersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePersonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreatePersonMutation, CreatePersonMutationVariables>;
export const UpdatePersonFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePersonForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePersonInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePerson"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpdatePersonFormMutation, UpdatePersonFormMutationVariables>;
export const CheckPersonMatchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CheckPersonMatch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CheckPersonMatchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkPersonMatch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Person_Type"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"path"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CheckPersonMatchMutation, CheckPersonMatchMutationVariables>;
export const GetPersonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPersons"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"persons"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"primary"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonsQuery, GetPersonsQueryVariables>;
export const GetPersonDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPerson"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Person"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"givenNames"}},{"kind":"Field","name":{"kind":"Name","value":"familyName"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfBirth"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}},{"kind":"Field","name":{"kind":"Name","value":"addresses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"street"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"zip"}},{"kind":"Field","name":{"kind":"Name","value":"primary"}}]}}]}}]}}]} as unknown as DocumentNode<GetPersonQuery, GetPersonQueryVariables>;
export const TemplateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TemplateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateFileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateFile"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileBase64"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TemplateFileQuery, TemplateFileQueryVariables>;
export const SignAndSaveTemplateValuesV3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignAndSaveTemplateValuesV3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SignAndSaveTemplateValuesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signAndSaveTemplateValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SignAndSaveTemplateSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateSubmitValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formMessage"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SignAndSaveTemplateValuesV3Mutation, SignAndSaveTemplateValuesV3MutationVariables>;
export const ValidateTemplateValuesV3Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ValidateTemplateValuesV3"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ValidateTemplateValuesInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validateTemplateValues"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SignAndSaveTemplateSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TemplateSubmitValidationError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formMessage"}},{"kind":"Field","name":{"kind":"Name","value":"fieldErrors"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ValidateTemplateValuesV3Mutation, ValidateTemplateValuesV3MutationVariables>;
export const GetSignedHipaaReleaseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSignedHipaaRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateReleaseId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"templateReleases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateReleaseId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}},{"kind":"Field","name":{"kind":"Name","value":"document"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSignedHipaaReleaseQuery, GetSignedHipaaReleaseQueryVariables>;
export const ViewReleaseDocumentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewReleaseDocument"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ViewDocumentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewDocument"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"documentId"}},{"kind":"Field","name":{"kind":"Name","value":"documentUrl"}}]}}]}}]} as unknown as DocumentNode<ViewReleaseDocumentQuery, ViewReleaseDocumentQueryVariables>;
export const InitiateAccountDeletionV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InitiateAccountDeletionV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"initiateAccountDeletionV2"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountDeletionSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountDeletionFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]}}]} as unknown as DocumentNode<InitiateAccountDeletionV2Mutation, InitiateAccountDeletionV2MutationVariables>;
export const GetUserPaymentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserPayments"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payment__PaymentTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"owner"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"createdAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"DESC"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"stripePaymentIntentId"}},{"kind":"Field","name":{"kind":"Name","value":"stripeReceiptUrl"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"issue"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"getPaymentProfile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hasPaymentMethod"}}]}}]}}]} as unknown as DocumentNode<GetUserPaymentsQuery, GetUserPaymentsQueryVariables>;
export const GetReleasesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReleases"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"templateReleases"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"template"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"displayName"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"dir"},"value":{"kind":"EnumValue","value":"ASC"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"grantedAt"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"default"}},{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"document__Template"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"default"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"BooleanValue","value":true}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"templateType"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"eq"},"value":{"kind":"EnumValue","value":"HIPAA_RELEASE"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}}]} as unknown as DocumentNode<GetReleasesQuery, GetReleasesQueryVariables>;